
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("1JyKZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $lMdlY = parcelRequire("lMdlY");


var $inPa6 = parcelRequire("inPa6");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $gKr8t = parcelRequire("gKr8t");


var $9wGTI = parcelRequire("9wGTI");


var $8a9Dm = parcelRequire("8a9Dm");

var $765515c26d11d063$var$_ContextTokenCache;
class $765515c26d11d063$var$ContextTokenCache {
    static getInstance() {
        if (!$765515c26d11d063$var$ContextTokenCache.instance) $765515c26d11d063$var$ContextTokenCache.instance = new $765515c26d11d063$var$ContextTokenCache();
        return $765515c26d11d063$var$ContextTokenCache.instance;
    }
    get(key) {
        return this.promiseCache.get(key);
    }
    set(key, value) {
        this.promiseCache.set(key, value);
    }
    delete(key) {
        this.promiseCache.delete(key);
    }
    constructor(){
        this.promiseCache = void 0;
        this.promiseCache = new Map();
    }
}
$765515c26d11d063$var$_ContextTokenCache = $765515c26d11d063$var$ContextTokenCache;
$765515c26d11d063$var$ContextTokenCache.instance = void 0;
const $765515c26d11d063$var$EXTRA_BUFFER_MS = 30000; // extra 30 seconds buffer for clock skew
// GraphQL mutation to get context token
const $765515c26d11d063$var$UseGetContextTokenMutation = (0, $eSUdr.gql)`
	mutation useGetContextTokenMutation(
		$cloudId: ID!
		$input: ConfluenceForgeContextTokenRequestInput!
	) {
		confluence_generateForgeContextToken(cloudId: $cloudId, input: $input) {
			success
			errors {
				message
			}
			forgeContextToken {
				jwt
				expiresAt
				extensionId
			}
		}
	}
`;
const $765515c26d11d063$export$42cd66ed92f75ea0 = (extension, extensionData, localId, contextIds)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [runMutation] = (0, $308Wd.useMutationInterop)($765515c26d11d063$var$UseGetContextTokenMutation, {
        client: (0, $gKr8t.getAGGClient)()
    });
    return (0, $42omo.useMemo)(()=>{
        const sendEvent = (action, attributes)=>{
            if (!(0, $9wGTI.fg)('confluence_frontend_forge_context_token_metrics')) return;
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: action,
                    actionSubject: 'forgeContextToken',
                    source: 'useGetContextToken',
                    attributes: {
                        traceId: (0, $lMdlY.getActiveTrace)()?.traceId || 'unknown',
                        ...attributes
                    }
                }
            }).fire();
        };
        const fetchTokenFromServer = async (effectiveContextIds, cache, cacheKey)=>{
            try {
                // Build the input according to the schema
                const input = {
                    contextIds: effectiveContextIds,
                    extensionSpecificContexts: {
                        appVersion: extension.appVersion,
                        context: {
                            appVersion: extension.appVersion,
                            environmentId: extension.environmentId,
                            environmentType: extension.environmentType,
                            siteUrl: window?.location?.origin,
                            extension: {
                                location: undefined,
                                //extensionData?.location
                                content: extensionData?.content ? {
                                    id: extensionData.content.id,
                                    type: extensionData.content.type,
                                    subtype: extensionData.content.subtype
                                } : undefined,
                                space: extensionData?.space ? {
                                    id: extensionData.space.id,
                                    key: extensionData.space.key
                                } : undefined,
                                ...extensionData?.template?.id && {
                                    template: {
                                        id: extensionData.template.id
                                    }
                                },
                                type: extensionData.type,
                                selectedText: extensionData?.selectedText
                            },
                            localId: localId,
                            moduleKey: (0, $8a9Dm.getModuleKey)(extension)
                        },
                        extensionId: extension.id,
                        extensionType: extension.type,
                        installationId: extension.installationId
                    }
                };
                const { data: data } = await runMutation({
                    variables: {
                        cloudId: cloudId,
                        input: input
                    }
                });
                if (!data?.confluence_generateForgeContextToken?.success) {
                    const errors = data?.confluence_generateForgeContextToken?.errors || [];
                    const errorMessage = errors.map((e)=>e.message).join(', ') || 'Unknown error';
                    throw new Error(`Token generation failed: ${errorMessage}`);
                }
                const forgeContextToken = data.confluence_generateForgeContextToken.forgeContextToken;
                if (!forgeContextToken?.jwt) throw new Error('No JWT token received from GraphQL endpoint');
                // Update cache with expiry info if available
                const cachedEntry = cache.get(cacheKey);
                if (cachedEntry && forgeContextToken.expiresAt) cachedEntry.expiresAt = Number(forgeContextToken.expiresAt);
                // Analytics: success (do not include raw JWT)
                sendEvent('succeeded', {
                    extensionId: forgeContextToken.extensionId,
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    hasJwt: Boolean(forgeContextToken.jwt),
                    expiresAt: forgeContextToken.expiresAt
                });
                return forgeContextToken.jwt;
            } catch (error) {
                // Remove from cache on error so next call will retry
                cache.delete(cacheKey);
                // Analytics: failure
                sendEvent('failed', {
                    message: error?.message,
                    extensionId: extension?.id,
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    contextIds: effectiveContextIds
                });
                throw new Error(`Failed to get context token: ${error.message}`);
            }
        };
        return async function getForgeContextToken(contextIdsOverride) {
            if (!cloudId) throw new Error('CloudId is required but not available');
            const effectiveContextIds = contextIdsOverride ?? contextIds;
            const cacheKey = JSON.stringify({
                id: localId || extension.id,
                data: extensionData,
                contextIds: effectiveContextIds
            });
            const cache = $765515c26d11d063$var$ContextTokenCache.getInstance();
            const cached = cache.get(cacheKey);
            // Check if cached promise is still valid
            if (cached) {
                // If no expiresAt provided, assume token is valid and return cached promise
                if (typeof cached.expiresAt !== 'number') return cached.promise;
                if (Date.now() + $765515c26d11d063$var$EXTRA_BUFFER_MS < cached.expiresAt) return cached.promise;
            }
            // Create and cache a new promise
            const issuedAt = Date.now();
            const tokenPromise = fetchTokenFromServer(effectiveContextIds, cache, cacheKey);
            // Cache the promise immediately
            cache.set(cacheKey, {
                promise: tokenPromise,
                expiresAt: undefined,
                issuedAt: // Will be updated when promise resolves
                issuedAt
            });
            return tokenPromise;
        };
    }, [
        extension,
        extensionData,
        localId,
        cloudId,
        runMutation,
        contextIds,
        createAnalyticsEvent
    ]);
};
module.exports["useGetContextToken"] = $765515c26d11d063$export$42cd66ed92f75ea0;

});

parcelRegister("2Fl4v", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $i35rc = parcelRequire("i35rc");


var $5dK2X = parcelRequire("5dK2X");


const $65f5939ddad688eb$var$AKModalDialog = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6ZrcH")));

const $65f5939ddad688eb$var$AKModalTransition = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6ZrcH")).then((module)=>({
            default: module.ModalTransition
        })));

const $65f5939ddad688eb$var$AKModalHeader = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("9ot3w"))));

const $65f5939ddad688eb$var$AKModalTitle = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("d8eRd"))));

const $65f5939ddad688eb$var$AKModalBody = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("1DHa6"))));

const $65f5939ddad688eb$var$AKModalFooter = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("8o1lj"))));

const $65f5939ddad688eb$var$AKButton = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6fHGT")));

const $65f5939ddad688eb$var$SectionMessage = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9uD5t")));
const $65f5939ddad688eb$var$ModalThreeLOPrompt = ({ onClose: onClose = ()=>{}, isBlanketHidden: isBlanketHidden, ...props })=>{
    const { loading: loading, startAuth: startAuth, promptMessage: promptMessage, buttonText: buttonText } = (0, $i35rc.useAuth)(props);
    const { authUrl: authUrl } = props;
    const isAuthUrlEmpty = !authUrl || authUrl === '';
    const intl = (0, $8C5kA.default)();
    const { modalTitle: modalTitle, modalBody: modalBody } = isAuthUrlEmpty ? {
        modalTitle: intl.formatMessage($65f5939ddad688eb$var$messages.modalErrorTitle),
        modalBody: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$SectionMessage, {
            appearance: "error"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $65f5939ddad688eb$var$messages.noAuthURLErrorMessage)))
    } : {
        modalTitle: intl.formatMessage($65f5939ddad688eb$var$messages.modalAccessRequiredTitle),
        modalBody: promptMessage
    };
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalTransition, null, isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalDialog, {
        onClose: ()=>{
            setIsModalOpen(false);
            onClose();
        },
        isBlanketHidden: isBlanketHidden
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalTitle, null, modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalBody, null, modalBody), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKButton, {
        appearance: "subtle",
        onClick: ()=>{
            setIsModalOpen(false);
            onClose();
        }
    }, "Cancel"), !isAuthUrlEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKButton, {
        appearance: "primary",
        autoFocus: true,
        isLoading: loading,
        onClick: startAuth
    }, buttonText))));
};
var $65f5939ddad688eb$export$2e2bcd8739ae039 = $65f5939ddad688eb$var$ModalThreeLOPrompt;
const $65f5939ddad688eb$export$ee02671eeeecd75 = ({ onClose: onClose, appName: appName })=>{
    return function modalThreeLOPrompt({ forgeDoc: { props: props }, dispatch: dispatch }) {
        const { message: message, authUrl: authUrl, promptText: promptText } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$ModalThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            onSuccess: ()=>dispatch({
                    type: 'render',
                    extensionData: {}
                }),
            appName: appName,
            onClose: onClose
        });
    };
};
const $65f5939ddad688eb$export$85a504818a81117d = ({ onClose: onClose, appName: appName, isBlanketHidden: isBlanketHidden = false })=>{
    return (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$ModalThreeLOPrompt, {
            ...props,
            appName: appName,
            onClose: onClose,
            isBlanketHidden: isBlanketHidden
        });
    };
};
const $65f5939ddad688eb$var$messages = (0, $cgtv4.defineMessages)({
    noAuthURLErrorMessage: {
        id: "confluence.threeLOPrompt.modal.no.authURL.error-message",
        defaultMessage: "Consent URL not found. Please refresh the page and try again."
    },
    modalErrorTitle: {
        id: "confluence.threeLOPrompt.modal.error.title",
        defaultMessage: "Error"
    },
    modalAccessRequiredTitle: {
        id: "confluence.threeLOPrompt.modal.access.required.title",
        defaultMessage: "Access required"
    }
});
module.exports["makeModalThreeLOPrompt"] = $65f5939ddad688eb$export$ee02671eeeecd75;
module.exports["makeModalThreeLOPromptForCustomUI"] = $65f5939ddad688eb$export$85a504818a81117d;

});

parcelRegister("6fyld", function(module, exports) {

let $48cec8425f420954$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $48cec8425f420954$var$load("bIwBL").then(()=>parcelRequire('7Cnic'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("6ZrcH", function(module, exports) {

let $516d8ab390ce3105$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $516d8ab390ce3105$var$load("hhss7"),
    $516d8ab390ce3105$var$load("bf0yj")
]).then(()=>parcelRequire('3yfJl'));

});

parcelRegister("6fHGT", function(module, exports) {

let $48d608e2cdc67862$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $48d608e2cdc67862$var$load("eMbal").then(()=>parcelRequire('eAAnv'));

});

parcelRegister("9uD5t", function(module, exports) {

let $6e953c4c6c11d691$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6e953c4c6c11d691$var$load("cjJTJ").then(()=>parcelRequire('iV9t7'));

});

parcelRegister("HEA67", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");


var $45DA9 = parcelRequire("45DA9");


var $7oKJR = parcelRequire("7oKJR");


var $dh538 = parcelRequire("dh538");

const $5a707b7422677cdc$export$5c431bb5ef7d7900 = ({ extensionId: extensionId, localId: localId, children: children })=>{
    (0, $dh538.fg)('forge-ui-new-event-filter') && (0, $7oKJR.setupContextKeysFromSessionStorage)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: {
            forgeUIAttributes: {
                localId: localId,
                ...(0, $45DA9.extensionIdToAnalyticsAttributes)(extensionId)
            }
        }
    }, children);
};
module.exports["ForgeUIExtensionAnalyticsContext"] = $5a707b7422677cdc$export$5c431bb5ef7d7900;

});

parcelRegister("45DA9", function(module, exports) {

var $7MEO5 = parcelRequire("7MEO5");

function $4b306a2ad8292411$export$d4650cd03b563908(extensionId) {
    if (!extensionId) return {};
    try {
        const ari = (0, $7MEO5.parse)(extensionId);
        if (!ari.resourceId) return {};
        const [appId, environmentId, groupId, extensionKey] = ari.resourceId.split('/');
        return {
            appId: appId,
            environmentId: environmentId,
            groupId: groupId,
            extensionKey: extensionKey
        };
    } catch  {
        return {};
    }
}
module.exports["extensionIdToAnalyticsAttributes"] = $4b306a2ad8292411$export$d4650cd03b563908;

});

parcelRegister("fgm2d", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

/* CustomUIRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $3b6c709f803268e6$var$ModalSizes = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    XLARGE: 'xlarge',
    MAX: 'max'
};
const $3b6c709f803268e6$var$modalDimensions = {
    [$3b6c709f803268e6$var$ModalSizes.SMALL]: {
        height: '20vh',
        minHeight: '320px'
    },
    [$3b6c709f803268e6$var$ModalSizes.MEDIUM]: {
        height: '40vh',
        minHeight: '520px'
    },
    [$3b6c709f803268e6$var$ModalSizes.LARGE]: {
        height: '70vh',
        minHeight: '720px'
    },
    [$3b6c709f803268e6$var$ModalSizes.XLARGE]: {
        height: '90vh'
    },
    [$3b6c709f803268e6$var$ModalSizes.MAX]: {
        height: '100%'
    }
};
const $3b6c709f803268e6$export$b3b34c460afe006f = (size)=>{
    if ((0, $dh538.fg)('destructure-getmodaldimensions-with-failsafe')) {
        const safeSize = $3b6c709f803268e6$var$modalDimensions[size] ? size : 'medium';
        return $3b6c709f803268e6$var$modalDimensions[safeSize];
    }
    return $3b6c709f803268e6$var$modalDimensions[size];
};

/* Iframe.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gdv5Z = parcelRequire("gdv5Z");


var $a9dFP = parcelRequire("a9dFP");

var $cOrQJ = parcelRequire("cOrQJ");


var $jIiuI = parcelRequire("jIiuI");





var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $1Igmn = parcelRequire("1Igmn");

const $783b254f80b9fbef$export$fe748943fdfd6c6b = ()=>{
    const query = `
  query forge_ui_getActiveTunnels($appId: ID!, $environmentId: ID!) {
    appActiveTunnels(appId: $appId, environmentId: $environmentId) {
      customUI {
        resourceKey
        tunnelUrl
      }
    }
  }
  `;
    return (0, $eSUdr.default)`${query}`;
};
const $783b254f80b9fbef$export$6702f78eaa0e936a = (client, appId, environmentId, queryOptions)=>{
    return {
        variables: {
            appId: appId,
            environmentId: environmentId
        },
        ...queryOptions,
        query: $783b254f80b9fbef$export$fe748943fdfd6c6b(),
        client: client,
        /**
     * We don't want to set 'ignore' because that discards errors and we need to inspect
     * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
     * https://www.apollographql.com/docs/react/data/error-handling/
     */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
            }
        }
    };
};
const $783b254f80b9fbef$export$f31e7455041d7e13 = ({ loading: loading, data: data })=>{
    if (!loading) return data?.appActiveTunnels?.customUI;
    return undefined;
};
const $783b254f80b9fbef$export$ad717e82ff0f4348 = (options)=>{
    const { appId: appId, environmentType: environmentType, environmentId: environmentId, client: client, queryOptions: queryOptions } = options;
    const shouldQuery = (0, $42omo.useRef)(true);
    if (environmentType !== 'DEVELOPMENT') shouldQuery.current = false;
    const requestOptions = $783b254f80b9fbef$export$6702f78eaa0e936a(client, appId, environmentId, queryOptions);
    const { error: error, loading: loading, data: data } = (0, $xQxzY.useQuery)(requestOptions.query || $783b254f80b9fbef$export$fe748943fdfd6c6b(), {
        ...requestOptions,
        skip: !shouldQuery.current
    });
    const tunnels = $783b254f80b9fbef$export$f31e7455041d7e13({
        loading: loading,
        data: data
    });
    return {
        error: error,
        tunnels: tunnels || [],
        loading: loading
    };
};



var $ijfiP = parcelRequire("ijfiP");




var $a4TK8 = parcelRequire("a4TK8");

const $fbfcc51dc5b115ca$export$cc725e2aa41de44a = (data, equalityCheck = (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))))=>{
    const [memoizedData, setMemoizedData] = (0, $42omo.useState)(data);
    (0, $42omo.useEffect)(()=>{
        if (!equalityCheck(data, memoizedData)) setMemoizedData(data);
    }, [
        data,
        memoizedData,
        equalityCheck
    ]);
    return memoizedData;
};



var $2uzbP = parcelRequire("2uzbP");


var $kaOT1 = parcelRequire("kaOT1");


var $5oEbs = parcelRequire("5oEbs");

var $LiNdD = parcelRequire("LiNdD");




var $4jZsH = parcelRequire("4jZsH");


var $6hkBe = parcelRequire("6hkBe");





var $ge8sG = parcelRequire("ge8sG");


var $UZU5S = parcelRequire("UZU5S");


var $iRhnt = parcelRequire("iRhnt");


var $6baEI = parcelRequire("6baEI");

const $130ab70bfb5bcaa7$export$9b96caef38763092 = ()=>{
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};












/* InnerIframe.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");





var $cUcZ5 = parcelRequire("cUcZ5");

var $39e5966e46da3777$exports = {};
!function(e) {
    var t;
    $39e5966e46da3777$exports = e();
}(function() {
    return (function r(o, i, u) {
        function s(n, e) {
            if (!i[n]) {
                if (!o[n]) {
                    var t = undefined;
                    if (!e && t) return t(n, !0);
                    if (a) return a(n, !0);
                    throw new Error("Cannot find module '" + n + "'");
                }
                e = i[n] = {
                    exports: {}
                };
                o[n][0].call(e.exports, function(e) {
                    var t = o[n][1][e];
                    return s(t || e);
                }, e, e.exports, r, o, i, u);
            }
            return i[n].exports;
        }
        for(var a = undefined, e = 0; e < u.length; e++)s(u[e]);
        return s;
    })({
        1: [
            function(w, b, m) {
                (function(e, n, s, c, d, h, p, g, y) {
                    "use strict";
                    var r = w("crypto");
                    function t(e, t) {
                        t = u(e, t);
                        var n;
                        return void 0 === (n = "passthrough" !== t.algorithm ? r.createHash(t.algorithm) : new l).write && (n.write = n.update, n.end = n.update), f(t, n).dispatch(e), n.update || n.end(""), n.digest ? n.digest("buffer" === t.encoding ? void 0 : t.encoding) : (e = n.read(), "buffer" !== t.encoding ? e.toString(t.encoding) : e);
                    }
                    (m = b.exports = t).sha1 = function(e) {
                        return t(e);
                    }, m.keys = function(e) {
                        return t(e, {
                            excludeValues: !0,
                            algorithm: "sha1",
                            encoding: "hex"
                        });
                    }, m.MD5 = function(e) {
                        return t(e, {
                            algorithm: "md5",
                            encoding: "hex"
                        });
                    }, m.keysMD5 = function(e) {
                        return t(e, {
                            algorithm: "md5",
                            encoding: "hex",
                            excludeValues: !0
                        });
                    };
                    var o = r.getHashes ? r.getHashes().slice() : [
                        "sha1",
                        "md5"
                    ], i = (o.push("passthrough"), [
                        "buffer",
                        "hex",
                        "binary",
                        "base64"
                    ]);
                    function u(e, t) {
                        var n = {};
                        if (n.algorithm = (t = t || {}).algorithm || "sha1", n.encoding = t.encoding || "hex", n.excludeValues = !!t.excludeValues, n.algorithm = n.algorithm.toLowerCase(), n.encoding = n.encoding.toLowerCase(), n.ignoreUnknown = !0 === t.ignoreUnknown, n.respectType = !1 !== t.respectType, n.respectFunctionNames = !1 !== t.respectFunctionNames, n.respectFunctionProperties = !1 !== t.respectFunctionProperties, n.unorderedArrays = !0 === t.unorderedArrays, n.unorderedSets = !1 !== t.unorderedSets, n.unorderedObjects = !1 !== t.unorderedObjects, n.replacer = t.replacer || void 0, n.excludeKeys = t.excludeKeys || void 0, void 0 === e) throw new Error("Object argument required.");
                        for(var r = 0; r < o.length; ++r)o[r].toLowerCase() === n.algorithm.toLowerCase() && (n.algorithm = o[r]);
                        if (-1 === o.indexOf(n.algorithm)) throw new Error('Algorithm "' + n.algorithm + '"  not supported. supported values: ' + o.join(", "));
                        if (-1 === i.indexOf(n.encoding) && "passthrough" !== n.algorithm) throw new Error('Encoding "' + n.encoding + '"  not supported. supported values: ' + i.join(", "));
                        return n;
                    }
                    function a(e) {
                        if ("function" == typeof e) return null != /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(e));
                    }
                    function f(o, t, i) {
                        i = i || [];
                        function u(e) {
                            return t.update ? t.update(e, "utf8") : t.write(e, "utf8");
                        }
                        return {
                            dispatch: function(e) {
                                return this["_" + (null === (e = o.replacer ? o.replacer(e) : e) ? "null" : typeof e)](e);
                            },
                            _object: function(t) {
                                var n, e = Object.prototype.toString.call(t), r = /\[object (.*)\]/i.exec(e);
                                r = (r = r ? r[1] : "unknown:[" + e + "]").toLowerCase();
                                if (0 <= (e = i.indexOf(t))) return this.dispatch("[CIRCULAR:" + e + "]");
                                if (i.push(t), void 0 !== s && s.isBuffer && s.isBuffer(t)) return u("buffer:"), u(t);
                                if ("object" === r || "function" === r || "asyncfunction" === r) return e = Object.keys(t), o.unorderedObjects && (e = e.sort()), !1 === o.respectType || a(t) || e.splice(0, 0, "prototype", "__proto__", "constructor"), o.excludeKeys && (e = e.filter(function(e) {
                                    return !o.excludeKeys(e);
                                })), u("object:" + e.length + ":"), n = this, e.forEach(function(e) {
                                    n.dispatch(e), u(":"), o.excludeValues || n.dispatch(t[e]), u(",");
                                });
                                if (!this["_" + r]) {
                                    if (o.ignoreUnknown) return u("[" + r + "]");
                                    throw new Error('Unknown object type "' + r + '"');
                                }
                                this["_" + r](t);
                            },
                            _array: function(e, t) {
                                t = void 0 !== t ? t : !1 !== o.unorderedArrays;
                                var n = this;
                                if (u("array:" + e.length + ":"), !t || e.length <= 1) return e.forEach(function(e) {
                                    return n.dispatch(e);
                                });
                                var r = [], t = e.map(function(e) {
                                    var t = new l, n = i.slice();
                                    return f(o, t, n).dispatch(e), r = r.concat(n.slice(i.length)), t.read().toString();
                                });
                                return i = i.concat(r), t.sort(), this._array(t, !1);
                            },
                            _date: function(e) {
                                return u("date:" + e.toJSON());
                            },
                            _symbol: function(e) {
                                return u("symbol:" + e.toString());
                            },
                            _error: function(e) {
                                return u("error:" + e.toString());
                            },
                            _boolean: function(e) {
                                return u("bool:" + e.toString());
                            },
                            _string: function(e) {
                                u("string:" + e.length + ":"), u(e.toString());
                            },
                            _function: function(e) {
                                u("fn:"), a(e) ? this.dispatch("[native]") : this.dispatch(e.toString()), !1 !== o.respectFunctionNames && this.dispatch("function-name:" + String(e.name)), o.respectFunctionProperties && this._object(e);
                            },
                            _number: function(e) {
                                return u("number:" + e.toString());
                            },
                            _xml: function(e) {
                                return u("xml:" + e.toString());
                            },
                            _null: function() {
                                return u("Null");
                            },
                            _undefined: function() {
                                return u("Undefined");
                            },
                            _regexp: function(e) {
                                return u("regex:" + e.toString());
                            },
                            _uint8array: function(e) {
                                return u("uint8array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint8clampedarray: function(e) {
                                return u("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int8array: function(e) {
                                return u("int8array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint16array: function(e) {
                                return u("uint16array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int16array: function(e) {
                                return u("int16array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint32array: function(e) {
                                return u("uint32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int32array: function(e) {
                                return u("int32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _float32array: function(e) {
                                return u("float32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _float64array: function(e) {
                                return u("float64array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _arraybuffer: function(e) {
                                return u("arraybuffer:"), this.dispatch(new Uint8Array(e));
                            },
                            _url: function(e) {
                                return u("url:" + e.toString());
                            },
                            _map: function(e) {
                                u("map:");
                                e = Array.from(e);
                                return this._array(e, !1 !== o.unorderedSets);
                            },
                            _set: function(e) {
                                u("set:");
                                e = Array.from(e);
                                return this._array(e, !1 !== o.unorderedSets);
                            },
                            _file: function(e) {
                                return u("file:"), this.dispatch([
                                    e.name,
                                    e.size,
                                    e.type,
                                    e.lastModfied
                                ]);
                            },
                            _blob: function() {
                                if (o.ignoreUnknown) return u("[blob]");
                                throw Error('Hashing Blob objects is currently not supported\n(see https://github.com/puleos/object-hash/issues/26)\nUse "options.replacer" or "options.ignoreUnknown"\n');
                            },
                            _domwindow: function() {
                                return u("domwindow");
                            },
                            _bigint: function(e) {
                                return u("bigint:" + e.toString());
                            },
                            _process: function() {
                                return u("process");
                            },
                            _timer: function() {
                                return u("timer");
                            },
                            _pipe: function() {
                                return u("pipe");
                            },
                            _tcp: function() {
                                return u("tcp");
                            },
                            _udp: function() {
                                return u("udp");
                            },
                            _tty: function() {
                                return u("tty");
                            },
                            _statwatcher: function() {
                                return u("statwatcher");
                            },
                            _securecontext: function() {
                                return u("securecontext");
                            },
                            _connection: function() {
                                return u("connection");
                            },
                            _zlib: function() {
                                return u("zlib");
                            },
                            _context: function() {
                                return u("context");
                            },
                            _nodescript: function() {
                                return u("nodescript");
                            },
                            _httpparser: function() {
                                return u("httpparser");
                            },
                            _dataview: function() {
                                return u("dataview");
                            },
                            _signal: function() {
                                return u("signal");
                            },
                            _fsevent: function() {
                                return u("fsevent");
                            },
                            _tlswrap: function() {
                                return u("tlswrap");
                            }
                        };
                    }
                    function l() {
                        return {
                            buf: "",
                            write: function(e) {
                                this.buf += e;
                            },
                            end: function(e) {
                                this.buf += e;
                            },
                            read: function() {
                                return this.buf;
                            }
                        };
                    }
                    m.writeToStream = function(e, t, n) {
                        return void 0 === n && (n = t, t = {}), f(t = u(e, t), n).dispatch(e);
                    };
                }).call(this, w("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, w("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
            },
            {
                buffer: 3,
                crypto: 5,
                lYpoI2: 11
            }
        ],
        2: [
            function(e, t, f) {
                (function(e, t, n, r, o, i, u, s, a) {
                    !function(e) {
                        "use strict";
                        var a = "undefined" != typeof Uint8Array ? Uint8Array : Array, t = "+".charCodeAt(0), n = "/".charCodeAt(0), r = "0".charCodeAt(0), o = "a".charCodeAt(0), i = "A".charCodeAt(0), u = "-".charCodeAt(0), s = "_".charCodeAt(0);
                        function f(e) {
                            e = e.charCodeAt(0);
                            return e === t || e === u ? 62 : e === n || e === s ? 63 : e < r ? -1 : e < r + 10 ? e - r + 26 + 26 : e < i + 26 ? e - i : e < o + 26 ? e - o + 26 : void 0;
                        }
                        e.toByteArray = function(e) {
                            var t, n;
                            if (0 < e.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
                            var r = e.length, r = "=" === e.charAt(r - 2) ? 2 : "=" === e.charAt(r - 1) ? 1 : 0, o = new a(3 * e.length / 4 - r), i = 0 < r ? e.length - 4 : e.length, u = 0;
                            function s(e) {
                                o[u++] = e;
                            }
                            for(t = 0; t < i; t += 4)s((16711680 & (n = f(e.charAt(t)) << 18 | f(e.charAt(t + 1)) << 12 | f(e.charAt(t + 2)) << 6 | f(e.charAt(t + 3)))) >> 16), s((65280 & n) >> 8), s(255 & n);
                            return 2 == r ? s(255 & (n = f(e.charAt(t)) << 2 | f(e.charAt(t + 1)) >> 4)) : 1 == r && (s((n = f(e.charAt(t)) << 10 | f(e.charAt(t + 1)) << 4 | f(e.charAt(t + 2)) >> 2) >> 8 & 255), s(255 & n)), o;
                        }, e.fromByteArray = function(e) {
                            var t, n, r, o, i = e.length % 3, u = "";
                            function s(e) {
                                return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(e);
                            }
                            for(t = 0, r = e.length - i; t < r; t += 3)n = (e[t] << 16) + (e[t + 1] << 8) + e[t + 2], u += s((o = n) >> 18 & 63) + s(o >> 12 & 63) + s(o >> 6 & 63) + s(63 & o);
                            switch(i){
                                case 1:
                                    u = (u += s((n = e[e.length - 1]) >> 2)) + s(n << 4 & 63) + "==";
                                    break;
                                case 2:
                                    u = (u = (u += s((n = (e[e.length - 2] << 8) + e[e.length - 1]) >> 10)) + s(n >> 4 & 63)) + s(n << 2 & 63) + "=";
                            }
                            return u;
                        };
                    }(void 0 === f ? this.base64js = {} : f);
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        3: [
            function(O, e, H) {
                (function(e, n, f, r, h, p, g, y, w) {
                    var a = O("base64-js"), i = O("ieee754");
                    function f(e, t, n) {
                        if (!(this instanceof f)) return new f(e, t, n);
                        var r, o, i, u, s = typeof e;
                        if ("base64" === t && "string" == s) for(e = (u = e).trim ? u.trim() : u.replace(/^\s+|\s+$/g, ""); e.length % 4 != 0;)e += "=";
                        if ("number" == s) r = j(e);
                        else if ("string" == s) r = f.byteLength(e, t);
                        else {
                            if ("object" != s) throw new Error("First argument needs to be a number, array or string.");
                            r = j(e.length);
                        }
                        if (f._useTypedArrays ? o = f._augment(new Uint8Array(r)) : ((o = this).length = r, o._isBuffer = !0), f._useTypedArrays && "number" == typeof e.byteLength) o._set(e);
                        else if (C(u = e) || f.isBuffer(u) || u && "object" == typeof u && "number" == typeof u.length) for(i = 0; i < r; i++)f.isBuffer(e) ? o[i] = e.readUInt8(i) : o[i] = e[i];
                        else if ("string" == s) o.write(e, 0, t);
                        else if ("number" == s && !f._useTypedArrays && !n) for(i = 0; i < r; i++)o[i] = 0;
                        return o;
                    }
                    function b(e, t, n, r) {
                        return f._charsWritten = c(function(e) {
                            for(var t = [], n = 0; n < e.length; n++)t.push(255 & e.charCodeAt(n));
                            return t;
                        }(t), e, n, r);
                    }
                    function m(e, t, n, r) {
                        return f._charsWritten = c(function(e) {
                            for(var t, n, r = [], o = 0; o < e.length; o++)n = e.charCodeAt(o), t = n >> 8, n = n % 256, r.push(n), r.push(t);
                            return r;
                        }(t), e, n, r);
                    }
                    function v(e, t, n) {
                        var r = "";
                        n = Math.min(e.length, n);
                        for(var o = t; o < n; o++)r += String.fromCharCode(e[o]);
                        return r;
                    }
                    function o(e, t, n, r) {
                        r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 1 < e.length, "Trying to read beyond buffer length"));
                        var o, r = e.length;
                        if (!(r <= t)) return n ? (o = e[t], t + 1 < r && (o |= e[t + 1] << 8)) : (o = e[t] << 8, t + 1 < r && (o |= e[t + 1])), o;
                    }
                    function u(e, t, n, r) {
                        r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 3 < e.length, "Trying to read beyond buffer length"));
                        var o, r = e.length;
                        if (!(r <= t)) return n ? (t + 2 < r && (o = e[t + 2] << 16), t + 1 < r && (o |= e[t + 1] << 8), o |= e[t], t + 3 < r && (o += e[t + 3] << 24 >>> 0)) : (t + 1 < r && (o = e[t + 1] << 16), t + 2 < r && (o |= e[t + 2] << 8), t + 3 < r && (o |= e[t + 3]), o += e[t] << 24 >>> 0), o;
                    }
                    function _(e, t, n, r) {
                        if (r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 1 < e.length, "Trying to read beyond buffer length")), !(e.length <= t)) return r = o(e, t, n, !0), 32768 & r ? -1 * (65535 - r + 1) : r;
                    }
                    function E(e, t, n, r) {
                        if (r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 3 < e.length, "Trying to read beyond buffer length")), !(e.length <= t)) return r = u(e, t, n, !0), 2147483648 & r ? -1 * (4294967295 - r + 1) : r;
                    }
                    function I(e, t, n, r) {
                        return r || (d("boolean" == typeof n, "missing or invalid endian"), d(t + 3 < e.length, "Trying to read beyond buffer length")), i.read(e, t, n, 23, 4);
                    }
                    function A(e, t, n, r) {
                        return r || (d("boolean" == typeof n, "missing or invalid endian"), d(t + 7 < e.length, "Trying to read beyond buffer length")), i.read(e, t, n, 52, 8);
                    }
                    function s(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 1 < e.length, "trying to write beyond buffer length"), Y(t, 65535));
                        o = e.length;
                        if (!(o <= n)) for(var i = 0, u = Math.min(o - n, 2); i < u; i++)e[n + i] = (t & 255 << 8 * (r ? i : 1 - i)) >>> 8 * (r ? i : 1 - i);
                    }
                    function l(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "trying to write beyond buffer length"), Y(t, 4294967295));
                        o = e.length;
                        if (!(o <= n)) for(var i = 0, u = Math.min(o - n, 4); i < u; i++)e[n + i] = t >>> 8 * (r ? i : 3 - i) & 255;
                    }
                    function B(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 1 < e.length, "Trying to write beyond buffer length"), F(t, 32767, -32768)), e.length <= n || s(e, 0 <= t ? t : 65535 + t + 1, n, r, o);
                    }
                    function L(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "Trying to write beyond buffer length"), F(t, 2147483647, -2147483648)), e.length <= n || l(e, 0 <= t ? t : 4294967295 + t + 1, n, r, o);
                    }
                    function U(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "Trying to write beyond buffer length"), D(t, 34028234663852886e22, -340282346638528860000000000000000000000)), e.length <= n || i.write(e, t, n, r, 23, 4);
                    }
                    function x(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 7 < e.length, "Trying to write beyond buffer length"), D(t, 17976931348623157e292, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000)), e.length <= n || i.write(e, t, n, r, 52, 8);
                    }
                    H.Buffer = f, H.SlowBuffer = f, H.INSPECT_MAX_BYTES = 50, f.poolSize = 8192, f._useTypedArrays = function() {
                        try {
                            var e = new ArrayBuffer(0), t = new Uint8Array(e);
                            return t.foo = function() {
                                return 42;
                            }, 42 === t.foo() && "function" == typeof t.subarray;
                        } catch (e) {
                            return !1;
                        }
                    }(), f.isEncoding = function(e) {
                        switch(String(e).toLowerCase()){
                            case "hex":
                            case "utf8":
                            case "utf-8":
                            case "ascii":
                            case "binary":
                            case "base64":
                            case "raw":
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                return !0;
                            default:
                                return !1;
                        }
                    }, f.isBuffer = function(e) {
                        return !(null == e || !e._isBuffer);
                    }, f.byteLength = function(e, t) {
                        var n;
                        switch(e += "", t || "utf8"){
                            case "hex":
                                n = e.length / 2;
                                break;
                            case "utf8":
                            case "utf-8":
                                n = T(e).length;
                                break;
                            case "ascii":
                            case "binary":
                            case "raw":
                                n = e.length;
                                break;
                            case "base64":
                                n = M(e).length;
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                n = 2 * e.length;
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return n;
                    }, f.concat = function(e, t) {
                        if (d(C(e), "Usage: Buffer.concat(list, [totalLength])\nlist should be an Array."), 0 === e.length) return new f(0);
                        if (1 === e.length) return e[0];
                        if ("number" != typeof t) for(o = t = 0; o < e.length; o++)t += e[o].length;
                        for(var n = new f(t), r = 0, o = 0; o < e.length; o++){
                            var i = e[o];
                            i.copy(n, r), r += i.length;
                        }
                        return n;
                    }, f.prototype.write = function(e, t, n, r) {
                        isFinite(t) ? isFinite(n) || (r = n, n = void 0) : (a = r, r = t, t = n, n = a), t = Number(t) || 0;
                        var o, i, u, s, a = this.length - t;
                        switch((!n || a < (n = Number(n))) && (n = a), r = String(r || "utf8").toLowerCase()){
                            case "hex":
                                o = function(e, t, n, r) {
                                    n = Number(n) || 0;
                                    var o = e.length - n;
                                    (!r || o < (r = Number(r))) && (r = o), d((o = t.length) % 2 == 0, "Invalid hex string"), o / 2 < r && (r = o / 2);
                                    for(var i = 0; i < r; i++){
                                        var u = parseInt(t.substr(2 * i, 2), 16);
                                        d(!isNaN(u), "Invalid hex string"), e[n + i] = u;
                                    }
                                    return f._charsWritten = 2 * i, i;
                                }(this, e, t, n);
                                break;
                            case "utf8":
                            case "utf-8":
                                i = this, u = t, s = n, o = f._charsWritten = c(T(e), i, u, s);
                                break;
                            case "ascii":
                            case "binary":
                                o = b(this, e, t, n);
                                break;
                            case "base64":
                                i = this, u = t, s = n, o = f._charsWritten = c(M(e), i, u, s);
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                o = m(this, e, t, n);
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return o;
                    }, f.prototype.toString = function(e, t, n) {
                        var r, o, i, u, s = this;
                        if (e = String(e || "utf8").toLowerCase(), t = Number(t) || 0, (n = void 0 !== n ? Number(n) : s.length) === t) return "";
                        switch(e){
                            case "hex":
                                r = function(e, t, n) {
                                    var r = e.length;
                                    (!t || t < 0) && (t = 0);
                                    (!n || n < 0 || r < n) && (n = r);
                                    for(var o = "", i = t; i < n; i++)o += k(e[i]);
                                    return o;
                                }(s, t, n);
                                break;
                            case "utf8":
                            case "utf-8":
                                r = function(e, t, n) {
                                    var r = "", o = "";
                                    n = Math.min(e.length, n);
                                    for(var i = t; i < n; i++)e[i] <= 127 ? (r += N(o) + String.fromCharCode(e[i]), o = "") : o += "%" + e[i].toString(16);
                                    return r + N(o);
                                }(s, t, n);
                                break;
                            case "ascii":
                            case "binary":
                                r = v(s, t, n);
                                break;
                            case "base64":
                                o = s, u = n, r = 0 === (i = t) && u === o.length ? a.fromByteArray(o) : a.fromByteArray(o.slice(i, u));
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                r = function(e, t, n) {
                                    for(var r = e.slice(t, n), o = "", i = 0; i < r.length; i += 2)o += String.fromCharCode(r[i] + 256 * r[i + 1]);
                                    return o;
                                }(s, t, n);
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return r;
                    }, f.prototype.toJSON = function() {
                        return {
                            type: "Buffer",
                            data: Array.prototype.slice.call(this._arr || this, 0)
                        };
                    }, f.prototype.copy = function(e, t, n, r) {
                        if (t = t || 0, (r = r || 0 === r ? r : this.length) !== (n = n || 0) && 0 !== e.length && 0 !== this.length) {
                            d(n <= r, "sourceEnd < sourceStart"), d(0 <= t && t < e.length, "targetStart out of bounds"), d(0 <= n && n < this.length, "sourceStart out of bounds"), d(0 <= r && r <= this.length, "sourceEnd out of bounds"), r > this.length && (r = this.length);
                            var o = (r = e.length - t < r - n ? e.length - t + n : r) - n;
                            if (o < 100 || !f._useTypedArrays) for(var i = 0; i < o; i++)e[i + t] = this[i + n];
                            else e._set(this.subarray(n, n + o), t);
                        }
                    }, f.prototype.slice = function(e, t) {
                        var n = this.length;
                        if (e = S(e, n, 0), t = S(t, n, n), f._useTypedArrays) return f._augment(this.subarray(e, t));
                        for(var r = t - e, o = new f(r, void 0, !0), i = 0; i < r; i++)o[i] = this[i + e];
                        return o;
                    }, f.prototype.get = function(e) {
                        return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(e);
                    }, f.prototype.set = function(e, t) {
                        return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(e, t);
                    }, f.prototype.readUInt8 = function(e, t) {
                        if (t || (d(null != e, "missing offset"), d(e < this.length, "Trying to read beyond buffer length")), !(e >= this.length)) return this[e];
                    }, f.prototype.readUInt16LE = function(e, t) {
                        return o(this, e, !0, t);
                    }, f.prototype.readUInt16BE = function(e, t) {
                        return o(this, e, !1, t);
                    }, f.prototype.readUInt32LE = function(e, t) {
                        return u(this, e, !0, t);
                    }, f.prototype.readUInt32BE = function(e, t) {
                        return u(this, e, !1, t);
                    }, f.prototype.readInt8 = function(e, t) {
                        if (t || (d(null != e, "missing offset"), d(e < this.length, "Trying to read beyond buffer length")), !(e >= this.length)) return 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
                    }, f.prototype.readInt16LE = function(e, t) {
                        return _(this, e, !0, t);
                    }, f.prototype.readInt16BE = function(e, t) {
                        return _(this, e, !1, t);
                    }, f.prototype.readInt32LE = function(e, t) {
                        return E(this, e, !0, t);
                    }, f.prototype.readInt32BE = function(e, t) {
                        return E(this, e, !1, t);
                    }, f.prototype.readFloatLE = function(e, t) {
                        return I(this, e, !0, t);
                    }, f.prototype.readFloatBE = function(e, t) {
                        return I(this, e, !1, t);
                    }, f.prototype.readDoubleLE = function(e, t) {
                        return A(this, e, !0, t);
                    }, f.prototype.readDoubleBE = function(e, t) {
                        return A(this, e, !1, t);
                    }, f.prototype.writeUInt8 = function(e, t, n) {
                        n || (d(null != e, "missing value"), d(null != t, "missing offset"), d(t < this.length, "trying to write beyond buffer length"), Y(e, 255)), t >= this.length || (this[t] = e);
                    }, f.prototype.writeUInt16LE = function(e, t, n) {
                        s(this, e, t, !0, n);
                    }, f.prototype.writeUInt16BE = function(e, t, n) {
                        s(this, e, t, !1, n);
                    }, f.prototype.writeUInt32LE = function(e, t, n) {
                        l(this, e, t, !0, n);
                    }, f.prototype.writeUInt32BE = function(e, t, n) {
                        l(this, e, t, !1, n);
                    }, f.prototype.writeInt8 = function(e, t, n) {
                        n || (d(null != e, "missing value"), d(null != t, "missing offset"), d(t < this.length, "Trying to write beyond buffer length"), F(e, 127, -128)), t >= this.length || (0 <= e ? this.writeUInt8(e, t, n) : this.writeUInt8(255 + e + 1, t, n));
                    }, f.prototype.writeInt16LE = function(e, t, n) {
                        B(this, e, t, !0, n);
                    }, f.prototype.writeInt16BE = function(e, t, n) {
                        B(this, e, t, !1, n);
                    }, f.prototype.writeInt32LE = function(e, t, n) {
                        L(this, e, t, !0, n);
                    }, f.prototype.writeInt32BE = function(e, t, n) {
                        L(this, e, t, !1, n);
                    }, f.prototype.writeFloatLE = function(e, t, n) {
                        U(this, e, t, !0, n);
                    }, f.prototype.writeFloatBE = function(e, t, n) {
                        U(this, e, t, !1, n);
                    }, f.prototype.writeDoubleLE = function(e, t, n) {
                        x(this, e, t, !0, n);
                    }, f.prototype.writeDoubleBE = function(e, t, n) {
                        x(this, e, t, !1, n);
                    }, f.prototype.fill = function(e, t, n) {
                        if (t = t || 0, n = n || this.length, d("number" == typeof (e = "string" == typeof (e = e || 0) ? e.charCodeAt(0) : e) && !isNaN(e), "value is not a number"), d(t <= n, "end < start"), n !== t && 0 !== this.length) {
                            d(0 <= t && t < this.length, "start out of bounds"), d(0 <= n && n <= this.length, "end out of bounds");
                            for(var r = t; r < n; r++)this[r] = e;
                        }
                    }, f.prototype.inspect = function() {
                        for(var e = [], t = this.length, n = 0; n < t; n++)if (e[n] = k(this[n]), n === H.INSPECT_MAX_BYTES) {
                            e[n + 1] = "...";
                            break;
                        }
                        return "<Buffer " + e.join(" ") + ">";
                    }, f.prototype.toArrayBuffer = function() {
                        if ("undefined" == typeof Uint8Array) throw new Error("Buffer.toArrayBuffer not supported in this browser");
                        if (f._useTypedArrays) return new f(this).buffer;
                        for(var e = new Uint8Array(this.length), t = 0, n = e.length; t < n; t += 1)e[t] = this[t];
                        return e.buffer;
                    };
                    var t = f.prototype;
                    function S(e, t, n) {
                        return "number" != typeof e ? n : t <= (e = ~~e) ? t : 0 <= e || 0 <= (e += t) ? e : 0;
                    }
                    function j(e) {
                        return (e = ~~Math.ceil(+e)) < 0 ? 0 : e;
                    }
                    function C(e) {
                        return (Array.isArray || function(e) {
                            return "[object Array]" === Object.prototype.toString.call(e);
                        })(e);
                    }
                    function k(e) {
                        return e < 16 ? "0" + e.toString(16) : e.toString(16);
                    }
                    function T(e) {
                        for(var t = [], n = 0; n < e.length; n++){
                            var r = e.charCodeAt(n);
                            if (r <= 127) t.push(e.charCodeAt(n));
                            else for(var o = n, i = (55296 <= r && r <= 57343 && n++, encodeURIComponent(e.slice(o, n + 1)).substr(1).split("%")), u = 0; u < i.length; u++)t.push(parseInt(i[u], 16));
                        }
                        return t;
                    }
                    function M(e) {
                        return a.toByteArray(e);
                    }
                    function c(e, t, n, r) {
                        for(var o = 0; o < r && !(o + n >= t.length || o >= e.length); o++)t[o + n] = e[o];
                        return o;
                    }
                    function N(e) {
                        try {
                            return decodeURIComponent(e);
                        } catch (e) {
                            return String.fromCharCode(65533);
                        }
                    }
                    function Y(e, t) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(0 <= e, "specified a negative value for writing an unsigned value"), d(e <= t, "value is larger than maximum value for type"), d(Math.floor(e) === e, "value has a fractional component");
                    }
                    function F(e, t, n) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(e <= t, "value larger than maximum allowed value"), d(n <= e, "value smaller than minimum allowed value"), d(Math.floor(e) === e, "value has a fractional component");
                    }
                    function D(e, t, n) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(e <= t, "value larger than maximum allowed value"), d(n <= e, "value smaller than minimum allowed value");
                    }
                    function d(e, t) {
                        if (!e) throw new Error(t || "Failed assertion");
                    }
                    f._augment = function(e) {
                        return e._isBuffer = !0, e._get = e.get, e._set = e.set, e.get = t.get, e.set = t.set, e.write = t.write, e.toString = t.toString, e.toLocaleString = t.toString, e.toJSON = t.toJSON, e.copy = t.copy, e.slice = t.slice, e.readUInt8 = t.readUInt8, e.readUInt16LE = t.readUInt16LE, e.readUInt16BE = t.readUInt16BE, e.readUInt32LE = t.readUInt32LE, e.readUInt32BE = t.readUInt32BE, e.readInt8 = t.readInt8, e.readInt16LE = t.readInt16LE, e.readInt16BE = t.readInt16BE, e.readInt32LE = t.readInt32LE, e.readInt32BE = t.readInt32BE, e.readFloatLE = t.readFloatLE, e.readFloatBE = t.readFloatBE, e.readDoubleLE = t.readDoubleLE, e.readDoubleBE = t.readDoubleBE, e.writeUInt8 = t.writeUInt8, e.writeUInt16LE = t.writeUInt16LE, e.writeUInt16BE = t.writeUInt16BE, e.writeUInt32LE = t.writeUInt32LE, e.writeUInt32BE = t.writeUInt32BE, e.writeInt8 = t.writeInt8, e.writeInt16LE = t.writeInt16LE, e.writeInt16BE = t.writeInt16BE, e.writeInt32LE = t.writeInt32LE, e.writeInt32BE = t.writeInt32BE, e.writeFloatLE = t.writeFloatLE, e.writeFloatBE = t.writeFloatBE, e.writeDoubleLE = t.writeDoubleLE, e.writeDoubleBE = t.writeDoubleBE, e.fill = t.fill, e.inspect = t.inspect, e.toArrayBuffer = t.toArrayBuffer, e;
                    };
                }).call(this, O("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, O("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
            },
            {
                "base64-js": 2,
                buffer: 3,
                ieee754: 10,
                lYpoI2: 11
            }
        ],
        4: [
            function(c, d, e) {
                (function(e, t, a, n, r, o, i, u, s) {
                    var a = c("buffer").Buffer, f = 4, l = new a(f);
                    l.fill(0);
                    d.exports = {
                        hash: function(e, t, n, r) {
                            for(var o = t(function(e, t) {
                                e.length % f != 0 && (n = e.length + (f - e.length % f), e = a.concat([
                                    e,
                                    l
                                ], n));
                                for(var n, r = [], o = t ? e.readInt32BE : e.readInt32LE, i = 0; i < e.length; i += f)r.push(o.call(e, i));
                                return r;
                            }(e = a.isBuffer(e) ? e : new a(e), r), 8 * e.length), t = r, i = new a(n), u = t ? i.writeInt32BE : i.writeInt32LE, s = 0; s < o.length; s++)u.call(i, o[s], 4 * s, !0);
                            return i;
                        }
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        5: [
            function(v, e, _) {
                (function(l, c, u, d, h, p, g, y, w) {
                    var u = v("buffer").Buffer, e = v("./sha"), t = v("./sha256"), n = v("./rng"), b = {
                        sha1: e,
                        sha256: t,
                        md5: v("./md5")
                    }, s = 64, a = new u(s);
                    function r(e, n) {
                        var r = b[e = e || "sha1"], o = [];
                        return r || i("algorithm:", e, "is not yet supported"), {
                            update: function(e) {
                                return u.isBuffer(e) || (e = new u(e)), o.push(e), e.length, this;
                            },
                            digest: function(e) {
                                var t = u.concat(o), t = n ? function(e, t, n) {
                                    u.isBuffer(t) || (t = new u(t)), u.isBuffer(n) || (n = new u(n)), t.length > s ? t = e(t) : t.length < s && (t = u.concat([
                                        t,
                                        a
                                    ], s));
                                    for(var r = new u(s), o = new u(s), i = 0; i < s; i++)r[i] = 54 ^ t[i], o[i] = 92 ^ t[i];
                                    return n = e(u.concat([
                                        r,
                                        n
                                    ])), e(u.concat([
                                        o,
                                        n
                                    ]));
                                }(r, n, t) : r(t);
                                return o = null, e ? t.toString(e) : t;
                            }
                        };
                    }
                    function i() {
                        var e = [].slice.call(arguments).join(" ");
                        throw new Error([
                            e,
                            "we accept pull requests",
                            "http://github.com/dominictarr/crypto-browserify"
                        ].join("\n"));
                    }
                    a.fill(0), _.createHash = function(e) {
                        return r(e);
                    }, _.createHmac = r, _.randomBytes = function(e, t) {
                        if (!t || !t.call) return new u(n(e));
                        try {
                            t.call(this, void 0, new u(n(e)));
                        } catch (e) {
                            t(e);
                        }
                    };
                    var o, f = [
                        "createCredentials",
                        "createCipher",
                        "createCipheriv",
                        "createDecipher",
                        "createDecipheriv",
                        "createSign",
                        "createVerify",
                        "createDiffieHellman",
                        "pbkdf2"
                    ], m = function(e) {
                        _[e] = function() {
                            i("sorry,", e, "is not implemented yet");
                        };
                    };
                    for(o in f)m(f[o], o);
                }).call(this, v("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, v("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./md5": 6,
                "./rng": 7,
                "./sha": 8,
                "./sha256": 9,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        6: [
            function(w, b, e) {
                (function(e, r, o, i, u, a, f, l, y) {
                    var t = w("./helpers");
                    function n(e, t) {
                        e[t >> 5] |= 128 << t % 32, e[14 + (t + 64 >>> 9 << 4)] = t;
                        for(var n = 1732584193, r = -271733879, o = -1732584194, i = 271733878, u = 0; u < e.length; u += 16){
                            var s = n, a = r, f = o, l = i, n = c(n, r, o, i, e[u + 0], 7, -680876936), i = c(i, n, r, o, e[u + 1], 12, -389564586), o = c(o, i, n, r, e[u + 2], 17, 606105819), r = c(r, o, i, n, e[u + 3], 22, -1044525330);
                            n = c(n, r, o, i, e[u + 4], 7, -176418897), i = c(i, n, r, o, e[u + 5], 12, 1200080426), o = c(o, i, n, r, e[u + 6], 17, -1473231341), r = c(r, o, i, n, e[u + 7], 22, -45705983), n = c(n, r, o, i, e[u + 8], 7, 1770035416), i = c(i, n, r, o, e[u + 9], 12, -1958414417), o = c(o, i, n, r, e[u + 10], 17, -42063), r = c(r, o, i, n, e[u + 11], 22, -1990404162), n = c(n, r, o, i, e[u + 12], 7, 1804603682), i = c(i, n, r, o, e[u + 13], 12, -40341101), o = c(o, i, n, r, e[u + 14], 17, -1502002290), n = d(n, r = c(r, o, i, n, e[u + 15], 22, 1236535329), o, i, e[u + 1], 5, -165796510), i = d(i, n, r, o, e[u + 6], 9, -1069501632), o = d(o, i, n, r, e[u + 11], 14, 643717713), r = d(r, o, i, n, e[u + 0], 20, -373897302), n = d(n, r, o, i, e[u + 5], 5, -701558691), i = d(i, n, r, o, e[u + 10], 9, 38016083), o = d(o, i, n, r, e[u + 15], 14, -660478335), r = d(r, o, i, n, e[u + 4], 20, -405537848), n = d(n, r, o, i, e[u + 9], 5, 568446438), i = d(i, n, r, o, e[u + 14], 9, -1019803690), o = d(o, i, n, r, e[u + 3], 14, -187363961), r = d(r, o, i, n, e[u + 8], 20, 1163531501), n = d(n, r, o, i, e[u + 13], 5, -1444681467), i = d(i, n, r, o, e[u + 2], 9, -51403784), o = d(o, i, n, r, e[u + 7], 14, 1735328473), n = h(n, r = d(r, o, i, n, e[u + 12], 20, -1926607734), o, i, e[u + 5], 4, -378558), i = h(i, n, r, o, e[u + 8], 11, -2022574463), o = h(o, i, n, r, e[u + 11], 16, 1839030562), r = h(r, o, i, n, e[u + 14], 23, -35309556), n = h(n, r, o, i, e[u + 1], 4, -1530992060), i = h(i, n, r, o, e[u + 4], 11, 1272893353), o = h(o, i, n, r, e[u + 7], 16, -155497632), r = h(r, o, i, n, e[u + 10], 23, -1094730640), n = h(n, r, o, i, e[u + 13], 4, 681279174), i = h(i, n, r, o, e[u + 0], 11, -358537222), o = h(o, i, n, r, e[u + 3], 16, -722521979), r = h(r, o, i, n, e[u + 6], 23, 76029189), n = h(n, r, o, i, e[u + 9], 4, -640364487), i = h(i, n, r, o, e[u + 12], 11, -421815835), o = h(o, i, n, r, e[u + 15], 16, 530742520), n = p(n, r = h(r, o, i, n, e[u + 2], 23, -995338651), o, i, e[u + 0], 6, -198630844), i = p(i, n, r, o, e[u + 7], 10, 1126891415), o = p(o, i, n, r, e[u + 14], 15, -1416354905), r = p(r, o, i, n, e[u + 5], 21, -57434055), n = p(n, r, o, i, e[u + 12], 6, 1700485571), i = p(i, n, r, o, e[u + 3], 10, -1894986606), o = p(o, i, n, r, e[u + 10], 15, -1051523), r = p(r, o, i, n, e[u + 1], 21, -2054922799), n = p(n, r, o, i, e[u + 8], 6, 1873313359), i = p(i, n, r, o, e[u + 15], 10, -30611744), o = p(o, i, n, r, e[u + 6], 15, -1560198380), r = p(r, o, i, n, e[u + 13], 21, 1309151649), n = p(n, r, o, i, e[u + 4], 6, -145523070), i = p(i, n, r, o, e[u + 11], 10, -1120210379), o = p(o, i, n, r, e[u + 2], 15, 718787259), r = p(r, o, i, n, e[u + 9], 21, -343485551), n = g(n, s), r = g(r, a), o = g(o, f), i = g(i, l);
                        }
                        return Array(n, r, o, i);
                    }
                    function s(e, t, n, r, o, i) {
                        return g((t = g(g(t, e), g(r, i))) << o | t >>> 32 - o, n);
                    }
                    function c(e, t, n, r, o, i, u) {
                        return s(t & n | ~t & r, e, t, o, i, u);
                    }
                    function d(e, t, n, r, o, i, u) {
                        return s(t & r | n & ~r, e, t, o, i, u);
                    }
                    function h(e, t, n, r, o, i, u) {
                        return s(t ^ n ^ r, e, t, o, i, u);
                    }
                    function p(e, t, n, r, o, i, u) {
                        return s(n ^ (t | ~r), e, t, o, i, u);
                    }
                    function g(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    b.exports = function(e) {
                        return t.hash(e, n, 16);
                    };
                }).call(this, w("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, w("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        7: [
            function(e, l, t) {
                (function(e, t, n, r, o, i, u, s, f) {
                    var a;
                    l.exports = a || function(e) {
                        for(var t, n = new Array(e), r = 0; r < e; r++)0 == (3 & r) && (t = 4294967296 * Math.random()), n[r] = t >>> ((3 & r) << 3) & 255;
                        return n;
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        8: [
            function(c, d, e) {
                (function(e, t, n, r, o, s, a, f, l) {
                    var i = c("./helpers");
                    function u(l, c) {
                        l[c >> 5] |= 128 << 24 - c % 32, l[15 + (c + 64 >> 9 << 4)] = c;
                        for(var e, t, n, r = Array(80), o = 1732584193, i = -271733879, u = -1732584194, s = 271733878, d = -1009589776, h = 0; h < l.length; h += 16){
                            for(var p = o, g = i, y = u, w = s, b = d, a = 0; a < 80; a++){
                                r[a] = a < 16 ? l[h + a] : v(r[a - 3] ^ r[a - 8] ^ r[a - 14] ^ r[a - 16], 1);
                                var f = m(m(v(o, 5), (f = i, t = u, n = s, (e = a) < 20 ? f & t | ~f & n : !(e < 40) && e < 60 ? f & t | f & n | t & n : f ^ t ^ n)), m(m(d, r[a]), (e = a) < 20 ? 1518500249 : e < 40 ? 1859775393 : e < 60 ? -1894007588 : -899497514)), d = s, s = u, u = v(i, 30), i = o, o = f;
                            }
                            o = m(o, p), i = m(i, g), u = m(u, y), s = m(s, w), d = m(d, b);
                        }
                        return Array(o, i, u, s, d);
                    }
                    function m(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    function v(e, t) {
                        return e << t | e >>> 32 - t;
                    }
                    d.exports = function(e) {
                        return i.hash(e, u, 20, !0);
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        9: [
            function(c, d, e) {
                (function(e, t, n, r, u, s, a, f, l) {
                    function b(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    function o(e, l) {
                        var c, d = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), t = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), n = new Array(64);
                        e[l >> 5] |= 128 << 24 - l % 32, e[15 + (l + 64 >> 9 << 4)] = l;
                        for(var r, o, h = 0; h < e.length; h += 16){
                            for(var i = t[0], u = t[1], s = t[2], p = t[3], a = t[4], g = t[5], y = t[6], w = t[7], f = 0; f < 64; f++)n[f] = f < 16 ? e[f + h] : b(b(b((o = n[f - 2], m(o, 17) ^ m(o, 19) ^ v(o, 10)), n[f - 7]), (o = n[f - 15], m(o, 7) ^ m(o, 18) ^ v(o, 3))), n[f - 16]), c = b(b(b(b(w, m(o = a, 6) ^ m(o, 11) ^ m(o, 25)), a & g ^ ~a & y), d[f]), n[f]), r = b(m(r = i, 2) ^ m(r, 13) ^ m(r, 22), i & u ^ i & s ^ u & s), w = y, y = g, g = a, a = b(p, c), p = s, s = u, u = i, i = b(c, r);
                            t[0] = b(i, t[0]), t[1] = b(u, t[1]), t[2] = b(s, t[2]), t[3] = b(p, t[3]), t[4] = b(a, t[4]), t[5] = b(g, t[5]), t[6] = b(y, t[6]), t[7] = b(w, t[7]);
                        }
                        return t;
                    }
                    var i = c("./helpers"), m = function(e, t) {
                        return e >>> t | e << 32 - t;
                    }, v = function(e, t) {
                        return e >>> t;
                    };
                    d.exports = function(e) {
                        return i.hash(e, o, 32, !0);
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        10: [
            function(e, t, f) {
                (function(e, t, n, r, o, i, u, s, a) {
                    f.read = function(e, t, n, r, o) {
                        var i, u, l = 8 * o - r - 1, c = (1 << l) - 1, d = c >> 1, s = -7, a = n ? o - 1 : 0, f = n ? -1 : 1, o = e[t + a];
                        for(a += f, i = o & (1 << -s) - 1, o >>= -s, s += l; 0 < s; i = 256 * i + e[t + a], a += f, s -= 8);
                        for(u = i & (1 << -s) - 1, i >>= -s, s += r; 0 < s; u = 256 * u + e[t + a], a += f, s -= 8);
                        if (0 === i) i = 1 - d;
                        else {
                            if (i === c) return u ? NaN : 1 / 0 * (o ? -1 : 1);
                            u += Math.pow(2, r), i -= d;
                        }
                        return (o ? -1 : 1) * u * Math.pow(2, i - r);
                    }, f.write = function(e, t, l, n, r, c) {
                        var o, i, u = 8 * c - r - 1, s = (1 << u) - 1, a = s >> 1, d = 23 === r ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = n ? 0 : c - 1, h = n ? 1 : -1, c = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                        for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (i = isNaN(t) ? 1 : 0, o = s) : (o = Math.floor(Math.log(t) / Math.LN2), t * (n = Math.pow(2, -o)) < 1 && (o--, n *= 2), 2 <= (t += 1 <= o + a ? d / n : d * Math.pow(2, 1 - a)) * n && (o++, n /= 2), s <= o + a ? (i = 0, o = s) : 1 <= o + a ? (i = (t * n - 1) * Math.pow(2, r), o += a) : (i = t * Math.pow(2, a - 1) * Math.pow(2, r), o = 0)); 8 <= r; e[l + f] = 255 & i, f += h, i /= 256, r -= 8);
                        for(o = o << r | i, u += r; 0 < u; e[l + f] = 255 & o, f += h, o /= 256, u -= 8);
                        e[l + f - h] |= 128 * c;
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        11: [
            function(e, h, t) {
                (function(e, t, n, r, o, f, l, c, d) {
                    var i, u, s;
                    function a() {}
                    (e = h.exports = {}).nextTick = (u = "undefined" != typeof window && window.setImmediate, s = "undefined" != typeof window && window.postMessage && window.addEventListener, u ? function(e) {
                        return window.setImmediate(e);
                    } : s ? (i = [], window.addEventListener("message", function(e) {
                        var t = e.source;
                        t !== window && null !== t || "process-tick" !== e.data || (e.stopPropagation(), 0 < i.length && i.shift()());
                    }, !0), function(e) {
                        i.push(e), window.postMessage("process-tick", "*");
                    }) : function(e) {
                        setTimeout(e, 0);
                    }), e.title = "browser", e.browser = !0, e.env = {}, e.argv = [], e.on = a, e.addListener = a, e.once = a, e.off = a, e.removeListener = a, e.removeAllListeners = a, e.emit = a, e.binding = function(e) {
                        throw new Error("process.binding is not supported");
                    }, e.cwd = function() {
                        return "/";
                    }, e.chdir = function(e) {
                        throw new Error("process.chdir is not supported");
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ]
    }, {}, [
        1
    ])(1);
});






var $iP9n7 = parcelRequire("iP9n7");








var $dj2Gr = parcelRequire("dj2Gr");




var $1KmJq = parcelRequire("1KmJq");




const $e9c93549781f9d57$export$50666a6a6eccdc2e = (0, $eSUdr.default)`mutation publishRealtimeChannel($installationId:ID!$name:String!$payload:String!$context:String$isGlobal:Boolean$token:String){ecosystem{publishRealtimeChannel(installationId:$installationId name:$name payload:$payload context:$context isGlobal:$isGlobal token:$token){eventId eventTimestamp}}}`;
const $e9c93549781f9d57$export$df7d62be1d7f5fc9 = (installationId, context, options)=>{
    const [mutationFunction] = (0, $1KmJq.useMutation)($e9c93549781f9d57$export$50666a6a6eccdc2e, options);
    return async (payload, contextToken)=>{
        const { channelName: channelName, isGlobal: isGlobal, options: options } = payload.data;
        const { token: token, contextOverrides: contextOverrides } = options || {};
        const eventPayload = JSON.stringify(payload.data.eventPayload);
        const channelContext = contextOverrides ? JSON.stringify({
            context: context,
            contextOverrides: contextOverrides
        }) : context;
        const { data: data } = await mutationFunction({
            variables: {
                installationId: installationId,
                name: channelName,
                context: channelContext,
                payload: eventPayload,
                isGlobal: isGlobal ?? false,
                token: token
            },
            context: {
                headers: {
                    'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(),
                    ...contextToken ? {
                        'x-forge-context-token': contextToken
                    } : {}
                }
            }
        });
        if (data?.ecosystem.publishRealtimeChannel) {
            const { eventId: eventId, eventTimestamp: eventTimestamp } = data.ecosystem.publishRealtimeChannel;
            return {
                eventId: eventId,
                eventTimestamp: eventTimestamp
            };
        }
    };
};





var $lB1H3 = parcelRequire("lB1H3");








var $lrJXD = parcelRequire("lrJXD");

const $b7f5501d28b11a4d$var$getAGGWebsocketURI = ()=>{
    return `wss://${window.location.host}/gateway/api/graphql/subscriptions`;
};
const $b7f5501d28b11a4d$var$createAGGSubscriptionClient = ()=>{
    return (0, $lrJXD.createClient)({
        url: $b7f5501d28b11a4d$var$getAGGWebsocketURI(),
        retryAttempts: 2,
        lazy: true
    });
};
const $b7f5501d28b11a4d$var$getAGGSubscriptionClient = ()=>{
    let client = window.__FORGE_AGG_SUBSCRIPTION_CLIENT__;
    if (!client) {
        client = $b7f5501d28b11a4d$var$createAGGSubscriptionClient();
        window.__FORGE_AGG_SUBSCRIPTION_CLIENT__ = client;
    }
    return client;
};
class $b7f5501d28b11a4d$var$BasicSubscription {
    get subscriptionCallbacks() {
        return this._subscriptionCallbacks;
    }
    set subscriptionCallbacks(callbacks) {
        this._subscriptionCallbacks = callbacks;
    }
    unsubscribe() {
        if (!this.closed) {
            this.baseUnsubscribe();
            this.closed = true;
            this._subscriptionCallbacks = [];
        }
    }
    addCallback(callback) {
        this._subscriptionCallbacks.push(callback);
    }
    removeCallback(callback) {
        const index = this._subscriptionCallbacks.indexOf(callback);
        if (index !== -1) this._subscriptionCallbacks.splice(index, 1);
    }
    onNext(event) {
        const payload = this.parsePayload(event);
        this._subscriptionCallbacks.forEach((callback)=>{
            try {
                callback(payload);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('[forge-realtime] Error in subscription callback: ', error);
            }
        });
    }
    onError(error) {
        this._subscriptionCallbacks.forEach((callback)=>{
            try {
                callback(null, error);
            } catch (callbackError) {
                // eslint-disable-next-line no-console
                console.error('[forge-realtime] Error in subscription callback:', callbackError);
            }
        });
    }
    parsePayload(payload) {
        try {
            return JSON.parse(payload);
        // eslint-disable-next-line no-unused-vars
        } catch (err) {
            return payload;
        }
    }
    constructor(baseUnsubscribe, callback){
        this.closed = void 0;
        this.baseUnsubscribe = void 0;
        this._subscriptionCallbacks = void 0;
        this.closed = false;
        this.baseUnsubscribe = baseUnsubscribe;
        this._subscriptionCallbacks = [
            callback
        ];
    }
}
const $b7f5501d28b11a4d$export$ec068583843480e7 = (payload, sink, subscriptionCallback, client)=>{
    if (!client) client = $b7f5501d28b11a4d$var$getAGGSubscriptionClient();
    const unsubscribe = client.subscribe(payload, sink);
    return new $b7f5501d28b11a4d$var$BasicSubscription(unsubscribe, subscriptionCallback);
};


const $364771c9cefa2143$var$realtimeChannel = (0, $eSUdr.default)`subscription realtimeChannel($installationId:ID!$name:String!$context:String$isGlobal:Boolean$token:String){ecosystem{realtimeChannel(installationId:$installationId name:$name context:$context isGlobal:$isGlobal token:$token){payload}}}`;
const $364771c9cefa2143$var$globalRealtimeChannelQuery = (0, $eSUdr.default)`subscription globalRealtimeChannel($installationId:ID!$name:String!$token:String){ecosystem{globalRealtimeChannel(installationId:$installationId name:$name token:$token){payload}}}`;
const $364771c9cefa2143$var$getChannelKey = (context)=>{
    return Object.entries(context).sort((a, b)=>a[0].localeCompare(b[0])).toString();
};
const $364771c9cefa2143$export$905d34fe81a9cf60 = ({ isOauthScopedEndpoint: isOauthScopedEndpoint = false, payload: payload, context: context, installationId: installationId, contextToken: contextToken })=>{
    const query = isOauthScopedEndpoint ? {
        operationName: 'globalRealtimeChannel',
        query: (0, $lB1H3.print)($364771c9cefa2143$var$globalRealtimeChannelQuery)
    } : {
        operationName: 'realtimeChannel',
        query: (0, $lB1H3.print)($364771c9cefa2143$var$realtimeChannel)
    };
    return {
        ...query,
        variables: {
            installationId: installationId,
            name: payload.data.channelName,
            ...!isOauthScopedEndpoint && {
                context: context,
                isGlobal: payload.data.isGlobal ?? false
            },
            token: payload.data.options?.token
        },
        extensions: {
            'x-forge-context-token': contextToken,
            ...payload.data.options?.replaySeconds && {
                command: {
                    type: 'replay',
                    data: {
                        // Timestamp in seconds of when to replay messages from. Valid for up to 7 days in the past.
                        sequenceNumber: Date.now() / 1000 - payload.data.options.replaySeconds
                    }
                }
            }
        }
    };
};
const $364771c9cefa2143$var$unsubscribeAllSubscriptions = (activeSubscriptions)=>{
    activeSubscriptions.forEach((subscription)=>{
        if (!subscription.closed) subscription.unsubscribe();
    });
    activeSubscriptions.clear();
};
const $364771c9cefa2143$export$21407f03011cb801 = (installationId, context, getContextToken)=>{
    const activeSubscriptions = (0, $42omo.useRef)(new Map());
    (0, $42omo.useEffect)(()=>{
        const currentSubscriptions = activeSubscriptions.current;
        return ()=>{
            $364771c9cefa2143$var$unsubscribeAllSubscriptions(currentSubscriptions);
        };
    }, []);
    // this is the bridge method that will be called from the extension
    return async (payload)=>{
        const { onEvent: onEvent } = payload.data;
        const channelContext = payload.data.options?.contextOverrides ? JSON.stringify({
            context: context,
            contextOverrides: payload.data.options?.contextOverrides
        }) : context;
        const channelKey = $364771c9cefa2143$var$getChannelKey({
            channelName: payload.data.channelName,
            isGlobal: payload.data.isGlobal,
            channelContext: channelContext
        });
        const existingSubscription = activeSubscriptions.current.get(channelKey);
        const isGqlCallToOauthScopedEndpoint = (0, $dh538.fg)('forge_realtime_uses_new_oauth_scoped_endpoint') && !!payload.data.isGlobal;
        if (existingSubscription) {
            // if subscription already exists
            existingSubscription.addCallback(onEvent);
            onEvent('SUBSCRIPTION_STARTED');
        } else if ((0, $dh538.fg)('platform_forge_realtime_retry_on_expired_token')) {
            // helper to create a subscription and handle token refresh
            const createSubscription = async ()=>{
                const subscriptionPayload = $364771c9cefa2143$export$905d34fe81a9cf60({
                    payload: payload,
                    context: channelContext,
                    installationId: installationId,
                    contextToken: await getContextToken?.()
                });
                const subscription = (0, $b7f5501d28b11a4d$export$ec068583843480e7)(subscriptionPayload, {
                    next: (result)=>{
                        subscription.onNext(result.data.ecosystem?.realtimeChannel?.payload);
                    },
                    error: async (err)=>{
                        const error = Array.isArray(err) ? err[0] : err;
                        if (getContextToken && error?.message === 'Unauthorized request') try {
                            const newSubscription = await createSubscription();
                            newSubscription.subscriptionCallbacks = [
                                ...subscription.subscriptionCallbacks
                            ];
                            activeSubscriptions.current.set(channelKey, newSubscription);
                            subscription.unsubscribe();
                            return;
                        } catch (err) {
                            subscription.onError(err);
                            activeSubscriptions.current.delete(channelKey);
                            return;
                        }
                        subscription.onError(err);
                        activeSubscriptions.current.delete(channelKey);
                    },
                    complete: ()=>{
                        activeSubscriptions.current.delete(channelKey);
                    }
                }, onEvent);
                activeSubscriptions.current.set(channelKey, subscription);
                return subscription;
            };
            createSubscription();
        } else {
            const subscription = (0, $b7f5501d28b11a4d$export$ec068583843480e7)($364771c9cefa2143$export$905d34fe81a9cf60({
                isOauthScopedEndpoint: isGqlCallToOauthScopedEndpoint,
                payload: payload,
                context: channelContext,
                installationId: installationId,
                contextToken: await getContextToken?.()
            }), {
                next: (result)=>{
                    subscription.onNext(isGqlCallToOauthScopedEndpoint ? result.data.ecosystem?.globalRealtimeChannel?.payload : result.data.ecosystem?.realtimeChannel?.payload);
                },
                error: (err)=>{
                    subscription.onError(err);
                    activeSubscriptions.current.delete(channelKey);
                },
                complete: ()=>{
                    activeSubscriptions.current.delete(channelKey);
                }
            }, onEvent);
            activeSubscriptions.current.set(channelKey, subscription);
        }
        return {
            unsubscribe: ()=>{
                const subscription = activeSubscriptions.current.get(channelKey);
                if (subscription) {
                    // remove one subscription
                    subscription.removeCallback(onEvent);
                    // if no more subscriptions remove the channelKey and unsubscribe
                    if (subscription.subscriptionCallbacks.length === 0) {
                        activeSubscriptions.current.delete(channelKey);
                        if (!subscription.closed) subscription.unsubscribe();
                    }
                }
            }
        };
    };
};



var $4ZTaE = parcelRequire("4ZTaE");


var $4LgCj = parcelRequire("4LgCj");

var $9XihO = parcelRequire("9XihO");

var $kxKUs = parcelRequire("kxKUs");

var $kZjf5 = parcelRequire("kZjf5");

var $buzAL = parcelRequire("buzAL");

var $i25hX = parcelRequire("i25hX");




const $87edcca4ef2d73a1$export$eb5f18ff99769aac = (extensionType)=>{
    const [product, moduleName] = extensionType.split(':');
    const SUPPORTED_PRODUCTS = [
        'jira',
        'confluence'
    ];
    // For xen:macro
    if (product === 'xen') return 'confluence';
    // Resolve non-portal JSM modules to Jira
    if (product === 'jiraServiceManagement') {
        if (moduleName && !moduleName.includes('portal')) return 'jira';
    }
    if (!SUPPORTED_PRODUCTS.includes(product)) return null;
    return product;
};





const $8b4a60e16bea70d5$export$6e6c2af98f57fa9d = 'ai_mate_agent';
const $8b4a60e16bea70d5$export$b573cc53e8beacd0 = (0, $eSUdr.default)`query agentStudioGetAgents($cloudId:String!$input:AgentStudioAgentQueryInput$product:String){agentStudio_getAgents(cloudId:$cloudId input:$input product:$product)@optIn(to:"AgentStudio"){edges{node{id name externalConfigReference}}}}`;
// From https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/06c1faa9feb39485f12c6528f9baf9bb1c653451/platform/packages/ai-mate/conversation-assistant-agent/src/services/paginated-agents/utils.tsx
const $8b4a60e16bea70d5$var$getAgentIdFromAri = (ari)=>{
    // Pattern: ari:cloud:rovo::agent/activation/{uuid}/{uuid}
    const ariPattern = /^ari:cloud:rovo::agent\/activation\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/([^/]+)$/;
    const match = ari.match(ariPattern);
    if (!match) return null;
    // Return the second UUID (agent ID)
    return match[1];
};
const $8b4a60e16bea70d5$var$getIdFromAgent = (agent)=>{
    const id = agent?.node?.id;
    if (!id) return null;
    return $8b4a60e16bea70d5$var$getAgentIdFromAri(agent?.node?.id);
};
const $8b4a60e16bea70d5$var$getAgentIdFromResponse = (agentsList, agentKey, agentAppId)=>{
    // No agents found from given name so fallback to default agent
    if (agentsList.length === 0) return null;
    // OOTB agents can't have the same name,
    // but it can have the same name as a custom agent or a forge agent
    if (!agentKey || !agentAppId) {
        // Custom agents don't have externalConfigReference
        const agent = agentsList.find((agent)=>agent?.node?.externalConfigReference != null && !agent?.node?.externalConfigReference.includes('ari:cloud:ecosystem::extension'));
        return $8b4a60e16bea70d5$var$getIdFromAgent(agent);
    }
    // Forge agents can have the same name so we have to filter further by key and appId
    // Their external config reference follows the pattern:
    // `${installationId}_ari:cloud:ecosystem::extension/${appId}/${environmentId}/static/${moduleKey}`;
    const forgeAgentRegex = new RegExp(`${agentAppId}/[^/]+/static/${agentKey}`);
    const agent = agentsList.find((agent)=>agent?.node?.externalConfigReference && forgeAgentRegex.test(agent?.node?.externalConfigReference));
    return $8b4a60e16bea70d5$var$getIdFromAgent(agent);
};
const $8b4a60e16bea70d5$export$de10b7621d6ba909 = async ({ client: client, cloudId: cloudId, product: product, input: input, agentKey: agentKey, agentAppId: agentAppId })=>{
    const variables = {
        cloudId: cloudId,
        product: product,
        input: input
    };
    try {
        const response = await client.query({
            query: $8b4a60e16bea70d5$export$b573cc53e8beacd0,
            variables: variables,
            fetchPolicy: 'cache-first'
        });
        const agentsList = response.data?.agentStudio_getAgents?.edges ?? [];
        const agentId = $8b4a60e16bea70d5$var$getAgentIdFromResponse(agentsList, agentKey, agentAppId) ?? $8b4a60e16bea70d5$export$6e6c2af98f57fa9d;
        return agentId;
    } catch (err) {
        return $8b4a60e16bea70d5$export$6e6c2af98f57fa9d;
    }
};


const $a6f437d394af1fd4$var$ROVO_TOPIC = 'ai-mate';
const $a6f437d394af1fd4$var$FORGE_SOURCE = 'forge-bridge-open-rovo';
const $a6f437d394af1fd4$var$ROVO_EVENT_TYPE = 'chat-new';
const $a6f437d394af1fd4$var$makeForgeAgentExternalConfigReference = (appId, installationId, environmentId, agentKey)=>{
    return `${installationId}_ari:cloud:ecosystem::extension/${appId}/${environmentId}/static/${agentKey}`;
};
function $a6f437d394af1fd4$export$1b9e058b7e689de(extensionType, appId, cloudId, apolloClient, installationId, environmentId) {
    const publish = (0, $i25hX.usePublish)($a6f437d394af1fd4$var$ROVO_TOPIC);
    return {
        openRovo: async ({ agentKey: agentKey, agentName: agentName, prompt: prompt, sourceAppId: sourceAppId, sourceInstallationId: sourceInstallationId, sourceEnvironmentId: sourceEnvironmentId })=>{
            const product = (0, $87edcca4ef2d73a1$export$eb5f18ff99769aac)(extensionType);
            if (!cloudId || !product) return false;
            // Use sourceAppId if provided (from embedded macro forwarding), otherwise use the captured appId
            const effectiveAppId = sourceAppId || appId;
            const effectiveInstallationId = sourceInstallationId || installationId;
            const effectiveEnvironmentId = sourceEnvironmentId || environmentId;
            const isForgeAgent = agentName && agentKey;
            const publishEventDetails = {
                type: $a6f437d394af1fd4$var$ROVO_EVENT_TYPE,
                product: product,
                source: $a6f437d394af1fd4$var$FORGE_SOURCE
            };
            let agentIdConfig;
            if (isForgeAgent && (0, $dh538.fg)('platform_forge_ui_rovo_bridge_use_externalconfig')) agentIdConfig = {
                agentExternalConfigReference: $a6f437d394af1fd4$var$makeForgeAgentExternalConfigReference(effectiveAppId, effectiveInstallationId, effectiveEnvironmentId, agentKey)
            };
            else {
                // If agent name is not provided use default rovo chat agent
                const agentId = agentName && !agentKey ? await (0, $8b4a60e16bea70d5$export$de10b7621d6ba909)({
                    client: apolloClient,
                    agentAppId: effectiveAppId,
                    cloudId: cloudId,
                    input: {
                        name: agentName
                    },
                    product: product,
                    agentKey: agentKey
                }) : (0, $8b4a60e16bea70d5$export$6e6c2af98f57fa9d);
                agentIdConfig = {
                    agentId: agentId
                };
            }
            publish({
                ...publishEventDetails,
                data: {
                    dialogues: [],
                    ...agentIdConfig,
                    ...prompt ? {
                        prompt: prompt
                    } : {}
                }
            });
        }
    };
}






var $inPa6 = parcelRequire("inPa6");










const $dd25f80afb746bb3$export$c58c2ef6cd7b14a1 = (appId, accountId)=>!!window['__consentedApps']?.[`${appId}:${accountId}`];
const $dd25f80afb746bb3$export$8d4e05c53de89926 = (appId, accountId)=>{
    window.__consentedApps = window.__consentedApps || {};
    window.__consentedApps[`${appId}:${accountId}`] = true;
};






var $CMcde = parcelRequire("CMcde");

const $13104cd2bb06c6a7$export$aee5524fcec014ce = (loadingComponent)=>{
    if (loadingComponent) return typeof loadingComponent === 'function' ? loadingComponent() : loadingComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $CMcde.Loader), null);
};



var $eahkE = parcelRequire("eahkE");





var $1uzCd = parcelRequire("1uzCd");




const $5ba58c31384319a3$var$LIMIT_UNIQUE_RESIZE_OBSERVATIONS = 15;
const $5ba58c31384319a3$export$9de303ca9515c607 = ()=>{
    const containerRef = (0, $42omo.useRef)(null);
    const [height, setHeight] = (0, $42omo.useState)(null);
    const [observationInvalidatedReason, setObservationInvalidatedReason] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        if (!containerRef.current) return;
        let uniqueSizeObservations = 0;
        // Also handles initial height in case ref->element attachment is delayed.
        const observer = new ResizeObserver(([entry])=>{
            setHeight((prevHeight)=>{
                const height = Math.trunc(entry.contentRect.height);
                if (prevHeight !== height) uniqueSizeObservations++;
                return height;
            });
            // Break after too many unique changes.
            if (uniqueSizeObservations >= $5ba58c31384319a3$var$LIMIT_UNIQUE_RESIZE_OBSERVATIONS) {
                observer.disconnect();
                setObservationInvalidatedReason(`Stopped counting after ${$5ba58c31384319a3$var$LIMIT_UNIQUE_RESIZE_OBSERVATIONS} unique resize events`);
            }
        });
        observer.observe(containerRef.current);
        return ()=>observer.disconnect();
    }, []);
    return {
        containerRef: containerRef,
        height: height,
        observationInvalidatedReason: observationInvalidatedReason
    };
};



var $iUjrf = parcelRequire("iUjrf");


var $eI4ye = parcelRequire("eI4ye");

const $4db8dff54302fa45$export$1b708c663f12db29 = ({ isEnabled: isEnabled, viewportDimensions: viewportDimensions })=>{
    const { captureEvent: captureEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    const { containerRef: containerRef, height: height } = (0, $5ba58c31384319a3$export$9de303ca9515c607)();
    const isTracking = (0, $42omo.useRef)(true);
    (0, $42omo.useEffect)(()=>{
        // Stop tracking after 10 seconds
        const timeoutId = setTimeout(()=>{
            isTracking.current = false;
        }, (0, $eI4ye.PERFORMANCE_ANALYTICS_INTERVAL));
        return ()=>clearTimeout(timeoutId);
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (height !== null && isEnabled && isTracking.current) {
            isTracking.current = true;
            captureEvent({
                type: 'resized',
                height: height,
                measuredHeight: viewportDimensions?.measuredHeight,
                viewportHeight: viewportDimensions?.viewportHeight,
                elapsed: (0, $1uzCd.getPerformanceMark)()
            });
        }
    }, [
        height,
        isEnabled,
        captureEvent,
        viewportDimensions
    ]);
    return {
        containerRef: containerRef
    };
};



var $iqcSr = parcelRequire("iqcSr");


var $lMJg3 = parcelRequire("lMJg3");




var $b7qxC = parcelRequire("b7qxC");

const $9c850cca6011a656$var$globalEdgeUrlMap = {
    dev: 'dev.services.atlassian.com',
    stg: 'stg.services.atlassian.com',
    prod: 'services.atlassian.com'
};
const $9c850cca6011a656$var$getBaseUrl = (environment)=>{
    const baseUrl = $9c850cca6011a656$var$globalEdgeUrlMap[environment];
    if (!baseUrl) throw new Error(`Invalid environment: ${environment}`);
    const service = 'forge-outbound-proxy';
    const url = `https://${service}.${baseUrl}`;
    return url;
};
const $9c850cca6011a656$export$e02fc95a45760598 = async (appId, user, environment, contextToken)=>{
    const init = {
        method: 'POST',
        headers: {
            'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(),
            'Content-Type': 'application/json',
            Authentication: `Bearer ${contextToken}`
        },
        body: JSON.stringify({
            user: user,
            appId: appId
        })
    };
    const url = $9c850cca6011a656$var$getBaseUrl((0, $b7qxC.getCDNEnvironment)(environment)) + '/client/feature-flags';
    const response = await fetch(url, init);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
};












var $JsJ4Y = parcelRequire("JsJ4Y");

// FIT tokens are valid for 1 hour, but to include some buffer, we'll use 30 minutes.
const $f0e8edd6ba016f56$var$FIT_TOKEN_EXPIRY_MS = 1800000;
const $f0e8edd6ba016f56$export$b0dbbdaccd254bb8 = (0, $eSUdr.gql)`mutation signInvocationTokenForUI($input:SignInvocationTokenForUIInput!){signInvocationTokenForUI(input:$input){success errors{extensions{statusCode errorType}message}forgeInvocationToken{jwt}metadata{baseUrl}}}`;
function $f0e8edd6ba016f56$export$a30e8bad2b49cec5(options) {
    const [signInvocationTokenForUIMutation] = (0, $1KmJq.useMutation)($f0e8edd6ba016f56$export$b0dbbdaccd254bb8, options);
    // Cache the FIT tokens against remoteKey to avoid excessively minting new FIT tokens.
    const cachedFitTokenMapRef = (0, $42omo.useRef)(new Map());
    return async (remoteKey, init, isMultipartFormData, restPath, contextToken)=>{
        if (!contextToken) throw new Error('Context token is required');
        const { fitToken: fitToken, remoteBaseUrl: remoteBaseUrl } = await $f0e8edd6ba016f56$var$getCachedFitToken(remoteKey, contextToken, cachedFitTokenMapRef, signInvocationTokenForUIMutation);
        // Call the remote with the FIT token as the authorization header
        const targetUrl = restPath ? new URL(restPath, remoteBaseUrl) : remoteBaseUrl;
        const headers = new Headers(init.headers);
        headers.set('Authorization', `Bearer ${fitToken}`);
        // handle multipart form data
        const body = isMultipartFormData ? $f0e8edd6ba016f56$var$parseFormData(JSON.parse(init.body)) : init.body;
        if (isMultipartFormData) // let the fetch api correctly set the multipart/form-data content-type
        // https://github.com/github/fetch/issues/505#issuecomment-293064470
        headers.delete('content-type');
        const response = await fetch(targetUrl, {
            ...init,
            headers: headers,
            body: body
        });
        // Handle binary response types
        const isAttachment = $f0e8edd6ba016f56$var$isBinaryContentType(response.headers.get('content-type'));
        if (response.ok && response.body !== null && response.status !== 204 && isAttachment) {
            const b64Content = await (0, $JsJ4Y.blobToBase64)(await response.blob());
            return new Response(b64Content, {
                status: response.status,
                statusText: response.statusText,
                headers: response.headers
            });
        }
        return response;
    };
}
async function $f0e8edd6ba016f56$var$getCachedFitToken(remoteKey, contextToken, cachedFitTokenMapRef, signInvocationTokenForUIMutation) {
    let fitToken;
    let remoteBaseUrl;
    const cachedFitToken = cachedFitTokenMapRef.current.get(remoteKey);
    // Attempt to use the cached FIT token if it is in the map and is valid
    if (cachedFitToken && $f0e8edd6ba016f56$var$isFitValid(cachedFitToken)) {
        fitToken = cachedFitToken.fitToken;
        remoteBaseUrl = cachedFitToken.remoteBaseUrl;
    } else {
        const fitExchangeResponse = await $f0e8edd6ba016f56$var$exchangeFCTForFIT(contextToken, remoteKey, signInvocationTokenForUIMutation);
        const { fitToken: newFitToken, remoteBaseUrl: newRemoteBaseUrl } = fitExchangeResponse;
        cachedFitTokenMapRef.current.set(remoteKey, {
            fitToken: newFitToken,
            remoteBaseUrl: newRemoteBaseUrl,
            fitTokenExpiresAt: Date.now() + $f0e8edd6ba016f56$var$FIT_TOKEN_EXPIRY_MS
        });
        fitToken = newFitToken;
        remoteBaseUrl = newRemoteBaseUrl;
    }
    if (!remoteBaseUrl) throw new Error('Remote base URL is not available for the given remote key');
    if (!fitToken) throw new Error('FIT token is not available for the given remote key');
    return {
        fitToken: fitToken,
        remoteBaseUrl: remoteBaseUrl
    };
}
async function $f0e8edd6ba016f56$var$exchangeFCTForFIT(contextToken, remoteKey, signInvocationTokenForUIMutation) {
    const { data: data, errors: errors } = await signInvocationTokenForUIMutation({
        variables: {
            input: {
                forgeContextToken: contextToken,
                remoteKey: remoteKey
            }
        }
    });
    if (errors || !data?.signInvocationTokenForUI || data.signInvocationTokenForUI.errors) throw new Error(`Failed to generate FIT token`);
    return {
        fitToken: data.signInvocationTokenForUI.forgeInvocationToken.jwt,
        remoteBaseUrl: data.signInvocationTokenForUI.metadata.baseUrl
    };
}
function $f0e8edd6ba016f56$var$isFitValid(cachedFitToken) {
    return cachedFitToken.fitTokenExpiresAt > Date.now();
}
function $f0e8edd6ba016f56$var$parseFormData(formLike) {
    const form = new FormData();
    for (const [key, value] of Object.entries(formLike))if (key.startsWith('file')) {
        const encodedFileNameKey = `__${key}Name`;
        const encodedMimeTypeKey = `__${key}Type`;
        const fileName = formLike[encodedFileNameKey];
        const mimeType = formLike[encodedMimeTypeKey];
        // convert back from base64 to File (Blob)
        const blob = (0, $JsJ4Y.base64ToBlob)(value, mimeType);
        const file = new File([
            blob
        ], fileName, {
            type: mimeType
        });
        form.append(key, file);
    } else form.append(key, value);
    // remove request metadata properties
    form.delete('__fileName');
    form.delete('__fileType');
    return form;
}
function $f0e8edd6ba016f56$var$isBinaryContentType(contentType) {
    return Boolean(contentType && !contentType.includes('application/json') && contentType.search(/text\//) === -1);
}





const $ab5a832ac7acfeff$var$styles = {
    threeLOInfo: "_1bsb1osq _4t3i1osq",
    box: "_kqswh2mm"
}; // TODO: no styles defined for resizable modals yet.
// Only Jira enables resizing on modals at the moment.
const $ab5a832ac7acfeff$var$modalIframeStyles = null;
const $ab5a832ac7acfeff$var$iframeStyles = null;
const $ab5a832ac7acfeff$var$hiddenIframeStyles = null;
const $ab5a832ac7acfeff$var$nonResizeableIframeStyles = null;
const $ab5a832ac7acfeff$var$defaultComponents = {
    ThreeLOPrompt: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4ZTaE.default), props)
}; /**
    * Hook for determining default IFrame React ref, using parent ref when provided
    *
    * @param parentIframeRef parent IFrame React ref
    * @returns default IFrame React ref
    */ 
function $ab5a832ac7acfeff$var$useDefaultIframeRef(parentIframeRef) {
    const localIframeRef = (0, $42omo.useRef)(null);
    const mergedRef = (0, $iP9n7.useMergeRefs)([
        parentIframeRef,
        localIframeRef
    ]);
    return mergedRef;
}
const $ab5a832ac7acfeff$export$3c4d31cb85fd39c5 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ accountId: accountId, extension: extension, contextIds: contextIds, apolloClient: apolloClient, components: components, coreData: coreData, extensionData: extensionData, extensionViewData: extensionViewData, loadingComponent: loadingComponent, onLoad: onLoad, height: height = '100%', width: width = '100%', src: src, bridge: bridge, customBridgeMethods: customBridgeMethods, isResizable: isResizable, getContextToken: getContextToken, timezone: timezone, locale: locale, setIsThreeLOPromptVisible: setIsThreeLOPromptVisible, setShouldShowRenderer: setShouldShowRenderer, extensionPayload: extensionPayload, isHidden: isHidden, theme: theme, surfaceColor: surfaceColor, appId: appId, isInModal: isInModal, setIsLoading: setIsLoading, onError: onError, entryPoint: entryPoint, isEmbeddedMacro: isEmbeddedMacro, embeddedParentLocalId: embeddedParentLocalId }, parentIframeRef)=>{
    const { ThreeLOPrompt: ThreeLOPrompt } = components ? components($ab5a832ac7acfeff$var$defaultComponents) : $ab5a832ac7acfeff$var$defaultComponents;
    const appIsAuthenticated = (0, $dd25f80afb746bb3$export$c58c2ef6cd7b14a1)(appId, accountId);
    const { appVersion: appVersion, consentUrl: consentUrl, currentUserConsent: currentUserConsent, requiresUserConsent: requiresUserConsent, properties: { frameId: frameId } } = extension;
    const [userConsentRequired, setUserConsentRequired] = (0, $42omo.useState)(consentUrl && !currentUserConsent && requiresUserConsent && !appIsAuthenticated);
    const productContext = (0, $42omo.useMemo)(()=>{
        const resolverContext = (0, $ge8sG.getResolverContext)({
            ...coreData,
            appVersion: appVersion
        }, extensionData);
        const viewContext = (0, $UZU5S.getViewContext)({
            resolverContext: resolverContext,
            accountId: accountId,
            extension: extension,
            timezone: timezone ?? (0, $130ab70bfb5bcaa7$export$9b96caef38763092)(),
            locale: locale ?? (0, $LiNdD.getBrowserLocale)(),
            extensionPayload: extensionPayload,
            extensionViewData: extensionViewData,
            theme: theme,
            surfaceColor: surfaceColor,
            location: window.location.toString()
        });
        return {
            resolverContext: resolverContext,
            viewContext: viewContext
        };
    }, [
        appVersion,
        coreData,
        extensionData,
        extensionViewData,
        accountId,
        extension,
        timezone,
        locale,
        extensionPayload,
        theme,
        surfaceColor
    ]);
    const tracing = (0, $kaOT1.useTracingContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const contextTokenRef = (0, $42omo.useRef)(undefined);
    const [threeLOInfo, setThreeLOInfo] = (0, $42omo.useState)(null);
    const invokeRetriesRef = (0, $42omo.useRef)([]);
    const iframeRef = $ab5a832ac7acfeff$var$useDefaultIframeRef(parentIframeRef);
    (0, $42omo.useEffect)(()=>{
        const clearThreeLOInfo = async ()=>setThreeLOInfo(null);
        if (userConsentRequired) {
            tracing?.recordConsentFlow('consent flow - start');
            setThreeLOInfo({
                authUrl: consentUrl,
                onSuccess: async ()=>{
                    tracing?.recordConsentFlow('consent flow - end', 'success');
                    setUserConsentRequired(false);
                    setIsThreeLOPromptVisible(false);
                    (0, $dd25f80afb746bb3$export$8d4e05c53de89926)(appId, accountId);
                    return clearThreeLOInfo();
                },
                onReject: ()=>{
                    tracing?.recordConsentFlow('consent flow - end', 'rejected');
                    return clearThreeLOInfo();
                }
            });
            setIsThreeLOPromptVisible(true);
            setShouldShowRenderer?.(false);
            if (onLoad) onLoad();
        }
    }, [
        onLoad,
        setIsThreeLOPromptVisible,
        setShouldShowRenderer,
        tracing,
        appId,
        accountId,
        consentUrl,
        userConsentRequired
    ]);
    const navigation = (0, $kZjf5.useNavigation)({
        extension: extension,
        push: bridge?.spaPush
    });
    const invoker = (0, $dj2Gr.useInvokeExtension)(contextIds, extension.id, {
        client: apolloClient
    }); // The hash generated here should match the one created in the Realtime service when it hashes extension.context
    // in the FCT.
    // If this is flaky because of differences between extensionData and the FCT's extension.context, then
    // use the decoded FCT context directly here as well.
    const extensionContext = (()=>{
        try {
            const { modal: // eslint-disable-next-line no-unused-vars
            modal, ...productExtensionData } = extensionData;
            return (0, (/*@__PURE__*/$parcel$interopDefault($39e5966e46da3777$exports)))(productExtensionData || {}); // eslint-disable-next-line no-unused-vars
        } catch (_) {
            // eslint-disable-next-line no-console
            console.error('Product context is not a serializable object.');
            return '';
        }
    })(); // the realtime hooks below have no side effect (i.e. does not actively trigger any network calls or actively makes any subscription).
    // It is because everything inside this hook is lazily initialized.
    // Importantly:
    // - SubscribeRealtimeChannel is called by the client (i.e. @forge/bridge)
    const subscribeRealtimeChannel = (0, $364771c9cefa2143$export$21407f03011cb801)(extension.installationId, extensionContext, getContextToken);
    const publishRealtimeChannel = (0, $e9c93549781f9d57$export$df7d62be1d7f5fc9)(extension.installationId, extensionContext, {
        client: apolloClient
    });
    const renderThreeLOPrompt = (retry)=>{
        return new Promise((resolve, reject)=>{
            const authUrl = threeLOInfo?.authUrl || consentUrl;
            if (authUrl) {
                invokeRetriesRef.current.push(retry);
                tracing?.recordConsentFlow('consent flow - start');
                setThreeLOInfo({
                    authUrl: authUrl,
                    onSuccess: ()=>{
                        tracing?.recordConsentFlow('consent flow - end', 'success');
                        resolve();
                        setThreeLOInfo(null);
                        setIsThreeLOPromptVisible(false);
                        setShouldShowRenderer?.(true);
                        return Promise.all(invokeRetriesRef.current.map((retry)=>retry())).then(()=>{
                            invokeRetriesRef.current = [];
                        });
                    },
                    onReject: ()=>{
                        tracing?.recordConsentFlow('consent flow - end', 'rejected');
                        return reject();
                    }
                });
                setIsThreeLOPromptVisible(true);
                setShouldShowRenderer?.(false);
            }
        });
    };
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const rovoChat = (0, $a6f437d394af1fd4$export$1b9e058b7e689de)(extension.type, appId, cloudId, apolloClient, extension.installationId, extension.environmentId);
    const productFetchClient = (0, $9XihO.useProductFetchClient)({
        appId: appId,
        environment: environment,
        contextIds: contextIds,
        cloudId: cloudId,
        workspaceId: workspaceId,
        extensionId: extension.id,
        options: {
            client: apolloClient
        },
        renderThreeLOPrompt: renderThreeLOPrompt
    });
    const permissions = (0, $buzAL.usePermission)({
        appId: appId,
        installationId: extension.installationId,
        contextIds: contextIds,
        extensionId: extension.id,
        options: {
            client: apolloClient
        },
        renderThreeLOPrompt: renderThreeLOPrompt
    });
    const fetchRemoteClient = (0, $f0e8edd6ba016f56$export$a30e8bad2b49cec5)({
        client: apolloClient
    });
    const permissionFunctions = Object.fromEntries((0, $buzAL.permissionMethods).map((method)=>[
            `${(0, $buzAL.PERMISSION_METHOD_PREFIX)}${method}`,
            permissions[method]
        ]));
    const { loading: loading, iframeProps: { onLoad: onLoadIframeFromProps } } = (0, $kxKUs.useBridge)({
        cloudId: cloudId,
        theme: theme,
        surfaceColor: surfaceColor,
        origin: new URL(src).origin,
        api: {
            ...(0, $4LgCj.createBridgeApi)(bridge, {
                userConsentRequired: !!userConsentRequired
            }),
            ...(0, $dh538.fg)('platform_forge_ui_open_rovo_bridge') ? {
                openRovo: rovoChat.openRovo
            } : {},
            onInvoke: async (payload)=>{
                const newContextToken = getContextToken ? await getContextToken(contextIds) : contextTokenRef.current?.jwt;
                tracing?.recordGqlCall('invokeExtension - start');
                const { data: data } = await invoker({
                    call: payload,
                    context: {
                        ...productContext.resolverContext
                    },
                    extensionPayload: extensionPayload,
                    contextToken: newContextToken
                }); // Default to using the regular invocation response
                var resp = data?.invokeExtension; // If the comparison feature flag is enabled, perform a shadow invocation to compare responses
                if ((0, $dh538.fg)('forge_ui_use_get_context_token_compare')) {
                    // Get shadow context token from cached token (when getContextToken is defined, it's already used above)
                    const shadowContextToken = contextTokenRef.current?.jwt; // Perform shadow invocation with the shadow token
                    const { data: shadowData } = await invoker({
                        call: payload,
                        context: {
                            ...productContext.resolverContext
                        },
                        extensionPayload: extensionPayload,
                        contextToken: shadowContextToken
                    }); // Compare responses and select the optimal one based on token context differences
                    const selectedResponse = (0, $iRhnt.selectOptimalInvocationResponse)(data?.invokeExtension, shadowData?.invokeExtension, createAnalyticsEvent);
                    if (selectedResponse) resp = selectedResponse;
                }
                if (!resp?.success) {
                    const error = resp?.errors?.[0];
                    if (error?.extensions.errorType === 'USER_CONSENT_REQUIRED') return {
                        type: '3lo',
                        authUrl: error?.extensions.fields?.authInfoUrl
                    };
                    if (error?.extensions.errorType === (0, $eahkE.SANDBOX_DEPRECATION_ERROR) && onError && (0, $dh538.fg)('platform_render_sandbox_runtime_error_panel')) onError(error?.extensions.errorType);
                    return {
                        type: 'err',
                        message: error?.message ?? 'An error occurred while trying to invoke.'
                    };
                }
                tracing?.recordGqlCall('invokeExtension - end');
                contextTokenRef.current = resp?.contextToken;
                return {
                    type: 'ok',
                    response: resp?.response?.body
                };
            },
            onInitFeatureFlags: async (data)=>{
                const newContextToken = getContextToken ? await getContextToken() : contextTokenRef.current?.jwt;
                tracing?.recordBridgeCall('getFeatureFlags - start');
                try {
                    const resp = await (0, $9c850cca6011a656$export$e02fc95a45760598)(appId, data.user, environment, newContextToken);
                    tracing?.recordBridgeCall('getFeatureFlags - end');
                    return {
                        type: 'ok',
                        response: resp
                    };
                } catch (err) {
                    tracing?.recordBridgeCall('getFeatureFlags - end'); // eslint-disable-next-line no-console
                    console.error('There were errors while initialising feature flags client ', err);
                    return {
                        type: 'err',
                        message: 'An error occurred while trying to initialise feature flags client.'
                    };
                }
            },
            onNavigate: navigation.onNavigate,
            onThreeLO: async (authUrl, retry)=>{
                return new Promise((resolve, reject)=>{
                    invokeRetriesRef.current.push(retry);
                    tracing?.recordConsentFlow('consent flow - start');
                    setThreeLOInfo({
                        authUrl: authUrl,
                        onSuccess: ()=>{
                            tracing?.recordConsentFlow('consent flow - end', 'success');
                            resolve();
                            setThreeLOInfo(null);
                            setIsThreeLOPromptVisible(false);
                            setShouldShowRenderer?.(true);
                            return Promise.all(invokeRetriesRef.current.map((retry)=>retry())).then(()=>{
                                invokeRetriesRef.current = [];
                            });
                        },
                        onReject: ()=>{
                            tracing?.recordConsentFlow('consent flow - end', 'rejected');
                            return reject();
                        }
                    });
                    setIsThreeLOPromptVisible(true);
                    setShouldShowRenderer?.(false);
                });
            },
            getContext: async ()=>({
                    ...productContext.viewContext
                }),
            fetchProduct: async ({ restPath: restPath, product: product, fetchRequestInit: fetchRequestInit, isMultipartFormData: isMultipartFormData })=>{
                const response = await productFetchClient(restPath, product, fetchRequestInit, isMultipartFormData);
                const { status: status, statusText: statusText } = response;
                const headers = Object.fromEntries(response.headers.entries());
                const isAttachment = (0, $9XihO.isBinaryContentType)(response.headers.get('content-type'));
                const body = response.body ? await response.text() : undefined;
                return {
                    headers: headers,
                    status: status,
                    statusText: statusText,
                    body: body,
                    isAttachment: isAttachment
                };
            },
            fetchRemote: async ({ remoteKey: remoteKey, fetchRequestInit: fetchRequestInit, isMultipartFormData: isMultipartFormData })=>{
                const { path: path, ...init } = fetchRequestInit;
                const contextToken = getContextToken ? await getContextToken() : contextTokenRef.current?.jwt;
                const response = await fetchRemoteClient(remoteKey, init, isMultipartFormData, path, contextToken);
                const { status: status, statusText: statusText } = response;
                const headers = Object.fromEntries(response.headers.entries());
                const isAttachment = (0, $9XihO.isBinaryContentType)(response.headers.get('content-type'));
                const body = response.body ? await response.text() : undefined;
                return {
                    headers: headers,
                    status: status,
                    statusText: statusText,
                    body: body,
                    isAttachment: isAttachment
                };
            },
            getFrameId: ()=>frameId ?? null,
            subscribeRealtimeChannel: async (payload)=>{
                return subscribeRealtimeChannel(payload);
            },
            publishRealtimeChannel: async (payload)=>{
                const contextToken = getContextToken ? await getContextToken() : contextTokenRef.current?.jwt;
                return publishRealtimeChannel(payload, contextToken);
            },
            ...permissionFunctions
        },
        customBridgeMethods: customBridgeMethods,
        onLoad: onLoad,
        isResizable: isResizable,
        height: height,
        environment: environment,
        extension: extension,
        iframeRef: iframeRef,
        client: apolloClient,
        contextIds: contextIds,
        isInModal: isInModal,
        localId: coreData.localId,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedParentLocalId: embeddedParentLocalId
    });
    (0, $42omo.useEffect)(()=>{
        setIsLoading?.(loading);
    }, [
        loading,
        setIsLoading
    ]);
    const { containerRef: containerRef } = (0, $4db8dff54302fa45$export$1b708c663f12db29)({
        // need to check if the extension is custom UI as well since this component is used in WebRuntime for UI Kit
        isEnabled: (0, $iqcSr.isCustomUI)(extension, entryPoint) && (0, $dh538.fg)('forge-ui-performance-analytics-provider')
    });
    const sandboxAttributeRules = [
        'allow-downloads',
        'allow-forms',
        'allow-modals',
        'allow-pointer-lock',
        'allow-same-origin',
        'allow-scripts'
    ];
    try {
        const egressService = (0, $lMJg3.egressPermissionService)('FETCH_CLIENT_SIDE', extension.egress);
        const containsWildCardEgress = egressService.containsWildCardEgress();
        if (containsWildCardEgress) sandboxAttributeRules.push('allow-popups', 'allow-popups-to-escape-sandbox');
         // eslint-disable-next-line no-unused-vars
    } catch (_) {}
    let framePermissionsPolicy = 'camera; clipboard-write; display-capture; fullscreen; microphone';
    if ((0, $dh538.fg)('platform_forge-ui_frame-allow-local-network-access')) framePermissionsPolicy += '; local-network-access';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ref: containerRef,
        xcss: $ab5a832ac7acfeff$var$styles.box,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: isResizable || threeLOInfo ? undefined : height,
            width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width
        }
    }, navigation.getModalJsx(), permissions.getModalJsx(), (loading || threeLOInfo) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ab5a832ac7acfeff$var$styles.threeLOInfo
    }, loading && !threeLOInfo && !isHidden && (0, $13104cd2bb06c6a7$export$aee5524fcec014ce)(loadingComponent), threeLOInfo && ThreeLOPrompt({
        authUrl: threeLOInfo.authUrl,
        onSuccess: threeLOInfo.onSuccess,
        metadata: {
            moduleType: extension.type
        }
    })), !userConsentRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("iframe", {
        "data-testid": "hosted-resources-iframe",
        "data-forge-iframe": true,
        sandbox: sandboxAttributeRules.join(' '),
        allow: framePermissionsPolicy,
        src: src,
        ref: iframeRef,
        onLoad: onLoadIframeFromProps,
        title: `Iframe ${frameId ?? (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))()} from ${appId}`,
        className: (0, $gMc0m.default)([
            "_19itglyw _1e0c1ule _1bsb1osq",
            (loading || threeLOInfo || isHidden) && "_1e0cglyw",
            isInModal && "_2rkofajl _4t3i1osq",
            !isResizable && "_4t3i1osq"
        ])
    })));
});




var $6oQb1 = parcelRequire("6oQb1");


var $jc2GP = parcelRequire("jc2GP");








var $luNHV = parcelRequire("luNHV");





var $hQK66 = parcelRequire("hQK66");




const $81f81791d185e0cc$export$5585193a0b9bb43d = ({ context: context, children: children, getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion })=>{
    const forgeReactMajorVersion = (0, $42omo.useRef)(null);
    const initialConfigKey = (0, $42omo.useRef)(null);
    const { config: config, ...extensionWithoutConfig } = context.extension ?? {};
    const currentConfigKey = (0, (/*@__PURE__*/$parcel$interopDefault($2uzbP)))(config);
    const baseContextKey = (0, (/*@__PURE__*/$parcel$interopDefault($2uzbP)))({
        ...context,
        extension: extensionWithoutConfig
    });
    const trackWrappedComponentMounted = $81f81791d185e0cc$var$useWrappedComponentMountTracker();
    (0, $42omo.useEffect)(()=>{
        (0, $luNHV.emit)('FORGE_CORE_MACRO_CONFIG_CHANGED', {
            config: config
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentConfigKey
    ]);
    if (forgeReactMajorVersion.current === null) forgeReactMajorVersion.current = getCurrentForgeReactMajorVersion();
    if (initialConfigKey.current === null) initialConfigKey.current = currentConfigKey;
    // for existing apps we need to ensure backwards compatibility
    const shouldContextKeyChangeOnConfigChange = forgeReactMajorVersion.current === null || forgeReactMajorVersion.current < 11;
    // if the app is using the new version of Forge react, we always uses the initial config key
    const key = baseContextKey + (shouldContextKeyChangeOnConfigChange ? currentConfigKey : initialConfigKey.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($81f81791d185e0cc$var$WrappedComponent, {
        key: key,
        onMounted: trackWrappedComponentMounted
    }, children);
};
const $81f81791d185e0cc$var$useWrappedComponentMountTracker = ()=>{
    const { trackExtensionRemounted: trackExtensionRemounted } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    const mountedCount = (0, $42omo.useRef)(0);
    const trackWrappedComponentMounted = (0, $hQK66.useCallbackOne)(()=>{
        mountedCount.current += 1;
        if (mountedCount.current > 1) trackExtensionRemounted({
            mountCount: mountedCount.current
        });
    }, [
        mountedCount,
        trackExtensionRemounted
    ]);
    return trackWrappedComponentMounted;
};
const $81f81791d185e0cc$var$WrappedComponent = ({ children: children, onMounted: onMounted })=>{
    (0, $42omo.useEffect)(()=>{
        onMounted();
    }, [
        onMounted
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};



var $cqiXo = parcelRequire("cqiXo");




const $f2c0519b4a165d40$var$styles = {
    hostedResourcesIframeContainer: "_kqswh2mm",
    box: "_1bsb1osq _4t3i1osq"
};
const $f2c0519b4a165d40$var$ReloadOnContextChangeWrapper = ({ context: context, children: children, getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion })=>{
    if (getCurrentForgeReactMajorVersion) return /*#__PURE__*/ $42omo.createElement((0, $81f81791d185e0cc$export$5585193a0b9bb43d), {
        context: context,
        getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion
    }, children);
    return /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), {
        key: (0, (/*@__PURE__*/$parcel$interopDefault($2uzbP)))(context)
    }, children);
};
const $f2c0519b4a165d40$export$5137ec99f248330b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ accountId: accountId, extension: extension, contextIds: contextIds, apolloClient: apolloClient, components: components, coreData: coreData, extensionData: extensionData, extensionViewData: extensionViewData, loadingComponent: loadingComponent, onLoad: onLoad, height: height = '100%', width: width = '100%', bridge: bridge, customBridgeMethods: customBridgeMethods, isResizable: isResizable = true, entryPoint: entryPoint, extensionPayload: extensionPayload, getContextToken: getContextToken, timezone: timezone, locale: locale, isHidden: isHidden = false, isInModal: isInModal = false, setShouldShowRenderer: setShouldShowRenderer, setIsLoading: setIsLoading, getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion, onError: onError, isEmbeddedMacro: isEmbeddedMacro = false, embeddedParentLocalId: embeddedParentLocalId }, iframeRef)=>{
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext)); // ARKEN-856: useThemeObserver() is a bit noisy, it returns copies of the same theme which breaks useBridge() dependencies
    // We use useMemoizedStateObject() to properly memoize its output doing a deep-equality check
    const theme = (0, $fbfcc51dc5b115ca$export$cc725e2aa41de44a)((0, $cOrQJ.default)());
    const iframeWrapperRef = (0, $42omo.useRef)(null);
    const [surfaceColor, setSurfaceColor] = (0, $42omo.useState)(null);
    const { trackExtensionLoaded: trackExtensionLoaded } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    (0, $42omo.useEffect)(()=>{
        if (!iframeWrapperRef.current) return;
        const nextSurfaceColor = getComputedStyle(iframeWrapperRef.current).getPropertyValue((0, $a9dFP.CURRENT_SURFACE_CSS_VAR));
        setSurfaceColor(nextSurfaceColor);
    }, [
        theme
    ]);
    const { appId: appId, moduleKey: moduleKey } = (0, $ijfiP.parseExtensionId)(extension.id);
    const { environmentId: environmentId, environmentType: environmentType } = extension;
    const extensionEntryPoint = (0, $6hkBe.getExtensionEntryPoint)(extension, entryPoint);
    const urlSafeContext = (0, $5oEbs.urlSafeB64)((0, $cqiXo.getEncodedAppContext)(extension));
    const defaultSrc = (0, $42omo.useMemo)(()=>(0, $5oEbs.createSrcFromExtension)(appId, extension, environment, extensionEntryPoint), [
        appId,
        extension,
        environment,
        extensionEntryPoint
    ]);
    const { tunnels: tunnels, loading: isTunnelsLoading } = (0, $783b254f80b9fbef$export$ad717e82ff0f4348)({
        client: apolloClient,
        appId: appId,
        environmentId: environmentId,
        environmentType: environmentType
    });
    const isSignedCookieLoading = (0, $6baEI.useCDNAuthSignedCookie)();
    const loading = isTunnelsLoading || (0, $6baEI.shouldUseCDNAuth)() && isSignedCookieLoading;
    (0, $42omo.useEffect)(()=>{
        const renderType = extension?.properties?.render === 'native' ? 'UIKit' : 'CustomUI';
        const extensionType = (0, $jc2GP.getExtensionType)(extension);
        trackExtensionLoaded({
            forgeEnvironment: extension?.environmentType,
            renderType: renderType,
            extensionType: extensionType
        }); // This should run for each new unique appId/moduleKey combination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        appId,
        moduleKey
    ]);
    const [isThreeLOPromptVisible, setIsThreeLOPromptVisible] = (0, $42omo.useState)(false);
    const coreDataInner = {
        ...coreData,
        environmentId: environmentId,
        environmentType: environmentType,
        moduleKey: moduleKey,
        siteUrl: window.location.origin
    };
    const resizingEnabled = isResizable && !extension.properties.viewportSize;
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        ref: iframeWrapperRef,
        testId: "hosted-resources-iframe-container",
        xcss: $f2c0519b4a165d40$var$styles.hostedResourcesIframeContainer,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: isThreeLOPromptVisible || isHidden || isEmbeddedMacro && (0, $dh538.fg)('platform_forge_ui_min_height_embedded_macro') ? undefined : height,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: resizingEnabled || isThreeLOPromptVisible || isHidden ? undefined : height,
            width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width
        }
    }, loading && /*#__PURE__*/ $42omo.createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $f2c0519b4a165d40$var$styles.box
    }, loading && !isHidden && (0, $13104cd2bb06c6a7$export$aee5524fcec014ce)(loadingComponent))), !loading && /*#__PURE__*/ $42omo.createElement((0, $kaOT1.TracingProvider), null, /*#__PURE__*/ $42omo.createElement($f2c0519b4a165d40$var$ReloadOnContextChangeWrapper, {
        getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
        context: (0, $UZU5S.getViewContext)({
            resolverContext: (0, $ge8sG.getResolverContext)(coreDataInner, extensionData),
            accountId: accountId,
            extension: extension,
            timezone: timezone ?? (0, $130ab70bfb5bcaa7$export$9b96caef38763092)(),
            locale: locale ?? (0, $LiNdD.getBrowserLocale)(),
            extensionViewData: extensionViewData,
            extensionPayload: (0, $dh538.fg)('only-include-macro-config-from-payload-in-reload') ? {
                config: extensionPayload?.config,
                macro: extensionPayload?.macro,
                isEditing: extensionPayload?.isEditing
            } : (0, $dh538.fg)('platform_move_dynamic_macro_context') ? extensionPayload : undefined
        })
    }, /*#__PURE__*/ $42omo.createElement((0, $ab5a832ac7acfeff$export$3c4d31cb85fd39c5), {
        accountId: accountId,
        extension: extension,
        contextIds: contextIds,
        apolloClient: apolloClient,
        components: components,
        coreData: coreDataInner,
        extensionData: extensionData,
        extensionViewData: extensionViewData,
        loadingComponent: loadingComponent,
        onLoad: onLoad,
        height: height,
        width: width,
        src: (0, $4jZsH.getSrcUrl)(tunnels, extensionEntryPoint, defaultSrc, urlSafeContext),
        bridge: bridge,
        customBridgeMethods: customBridgeMethods,
        isResizable: resizingEnabled,
        getContextToken: getContextToken,
        timezone: timezone,
        locale: locale,
        setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
        setShouldShowRenderer: setShouldShowRenderer,
        extensionPayload: extensionPayload,
        isHidden: isHidden,
        theme: theme,
        surfaceColor: surfaceColor,
        appId: appId,
        ref: iframeRef,
        isInModal: isInModal,
        setIsLoading: setIsLoading,
        onError: onError,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedParentLocalId: embeddedParentLocalId
    }))));
});



var $gj7hi = parcelRequire("gj7hi");


var $8CZUH = parcelRequire("8CZUH");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $hnPaP = parcelRequire("hnPaP");


var $7hpmn = parcelRequire("7hpmn");







var $u9agA = parcelRequire("u9agA");


var $1c598 = parcelRequire("1c598");

/* custom-ui-modal-utils.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $1DHa6 = parcelRequire("1DHa6");

const $dc67d857f203b917$var$smallModalStyles = null;
const $dc67d857f203b917$var$mediumModalStyles = null;
const $dc67d857f203b917$var$largeModalStyles = null;
const $dc67d857f203b917$var$xlargeModalStyles = null;
const $dc67d857f203b917$var$maxModalStyles = null;
const $dc67d857f203b917$var$resizableModalStyles = null; // TODO: Fix below styles once we move to compiled/react
const $dc67d857f203b917$export$a6d6b74199964ee4 = ({ children: children, size: size, styles: styles, isResizable: isResizable })=>{
    switch(size){
        case 'small':
            return /*#__PURE__*/ $42omo.createElement("div", {
                style: styles,
                className: (0, $gMc0m.default)([
                    "_2rkofajl _4t3i1tmh _1tkenklw _bfhk1bhr",
                    isResizable && "_1reo1wug _18m91wug _4t3i1wug"
                ])
            }, children);
        case 'medium':
            return /*#__PURE__*/ $42omo.createElement("div", {
                style: styles,
                className: (0, $gMc0m.default)([
                    "_2rkofajl _4t3ivzbd _1tke1lk4 _bfhk1bhr",
                    isResizable && "_1reo1wug _18m91wug _4t3i1wug"
                ])
            }, children);
        case 'large':
            return /*#__PURE__*/ $42omo.createElement("div", {
                style: styles,
                className: (0, $gMc0m.default)([
                    "_2rkofajl _4t3i1rxh _1tke1yw0 _bfhk1bhr",
                    isResizable && "_1reo1wug _18m91wug _4t3i1wug"
                ])
            }, children);
        case 'xlarge':
            return /*#__PURE__*/ $42omo.createElement("div", {
                style: styles,
                className: (0, $gMc0m.default)([
                    "_2rkofajl _4t3i10fc _1tkezwhf _bfhk1bhr",
                    isResizable && "_1reo1wug _18m91wug _4t3i1wug"
                ])
            }, children);
        case 'max':
            return /*#__PURE__*/ $42omo.createElement("div", {
                style: styles,
                className: (0, $gMc0m.default)([
                    "_2rkofajl _4t3i1osq _bfhk1bhr"
                ])
            }, children);
        default:
            return /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, children);
    }
};
const $dc67d857f203b917$export$ca177c112881662a = (modalSize)=>{
    if (modalSize === 'xlarge') return 'x-large';
    if (modalSize === 'max') return '100%';
    return modalSize;
};



var $amyZ5 = parcelRequire("amyZ5");





var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $jdPfT = parcelRequire("jdPfT");

const $8537409554582c9d$var$getExtensionIcon = (extension)=>{
    return extension?.properties?.config?.icon ?? extension?.properties?.icon;
};
const $8537409554582c9d$var$styles = {
    modalDeprecationMessage: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $8537409554582c9d$export$17d9f1e4832027c9 = ({ accountId: accountId, bridge: bridge, client: client, contextIds: contextIds, coreData: coreData, customBridgeMethods: customBridgeMethods, dialogs: dialogs, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, getThreeLOPrompt: getThreeLOPrompt, height: height, width: width, isIframeHidden: isIframeHidden, isIframeResizable: isIframeResizable, iframeRef: iframeRef, isInModal: isInModal, loadingComponent: loadingComponent, locale: locale, localId: localId, modalStyles: modalStyles, modalProvider: modalProvider, onIframeLoad: onIframeLoad, onModalCustomUIRendererClose: onModalCustomUIRendererClose, product: product, timezone: timezone, getModalWidth: getModalWidth, setIsLoading: setIsLoading, isEmbeddedMacro: isEmbeddedMacro, embeddedParentLocalId: embeddedParentLocalId })=>{
    const [error, setError] = (0, $42omo.useState)(null);
    // modalOptions is null when no modal is open is non null when opened
    // Uses InternalModalState to allow extension property from FAUS forwarding
    const [modalOptions, setModalOptions] = (0, $42omo.useState)(null);
    const [viewOnClose, setViewOnClose] = (0, $42omo.useState)();
    const onCloseFromModalClass = modalOptions?.onClose;
    const iframeProps = {
        accountId: accountId,
        apolloClient: client,
        contextIds: contextIds,
        components: getThreeLOPrompt,
        coreData: coreData,
        customBridgeMethods: customBridgeMethods,
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        isHidden: isIframeHidden,
        isResizable: isIframeResizable,
        locale: locale,
        timezone: timezone,
        loadingComponent: loadingComponent,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedParentLocalId: embeddedParentLocalId
    };
    const platformAddBridgeMessageForwardingFromFaus = (0, $dh538.fg)('platform_add_bridge_message_forwarding_from_faus');
    const extensionInModal = (0, $42omo.useMemo)(()=>{
        if (platformAddBridgeMessageForwardingFromFaus) {
            // Use the embedded macro's extension if provided (for modals opened from embedded macros)
            const baseExtension = modalOptions?.extension || extension;
            return {
                ...baseExtension,
                // Pass a type that is not included in the dimensions presets so that it falls back to default
                type: `${baseExtension.type}::dynamic-modal`,
                properties: {
                    ...baseExtension.properties,
                    resource: modalOptions?.resource ?? baseExtension.properties.resource
                }
            };
        }
        return {
            ...extension,
            // Pass a type that is not included in the dimensions presets so that it falls back to default
            type: `${extension.type}::dynamic-modal`,
            properties: {
                ...extension.properties,
                resource: modalOptions?.resource ?? extension.properties.resource
            }
        };
    }, [
        extension,
        modalOptions?.resource,
        modalOptions?.extension,
        platformAddBridgeMessageForwardingFromFaus
    ]);
    const onError = (error)=>{
        error && setError(error);
    };
    const extensionDataInModal = (0, $42omo.useMemo)(()=>({
            ...extensionData,
            ...modalOptions?.context ? {
                modal: modalOptions?.context
            } : {},
            // This is to handle an incompatibility issue with Compass and JSM where they are incorrectly currently spreading the context object on the top level instead of in the `modal` object.
            // Remove once Compass apps have been updated https://softwareteams.atlassian.net/browse/COMPASS-22051 and a notice to app developers have been sent out
            ...(product === 'compass' || extension.type.startsWith('jiraServiceManagement')) && modalOptions?.context ? {
                ...modalOptions?.context
            } : {}
        }), [
        extension.type,
        extensionData,
        modalOptions?.context,
        product
    ]);
    const handleModalTearDown = (0, $42omo.useCallback)(()=>{
        setModalOptions(null);
    }, [
        setModalOptions
    ]);
    const isReducedMotion = (0, $7hpmn.useIsReducedMotion)();
    const handleModalClose = (0, $42omo.useCallback)(()=>{
        onCloseFromModalClass?.();
        // if reduced motion is enabled, we need to call handleModalTearDown here as it no longer calls `onCloseComplete` in `ModalCustomUIRenderer`
        if (isReducedMotion) handleModalTearDown();
    }, [
        isReducedMotion,
        onCloseFromModalClass,
        handleModalTearDown
    ]);
    // Confluence specific feature
    // Needed to show Forge modals in live pages. dialogs won't be passed in if the page isn't live.
    (0, $42omo.useEffect)(()=>{
        if (product !== 'confluence') return;
        if (dialogs && modalOptions) dialogs.showDialog($8537409554582c9d$export$5d28a207fd7621f6, {
            extension: extensionInModal,
            extensionData: extensionDataInModal,
            localId: localId,
            onTearDown: handleModalTearDown,
            bridge: bridge,
            size: modalOptions.size,
            closeOnEscape: modalOptions.closeOnEscape,
            closeOnOverlayClick: modalOptions.closeOnOverlayClick
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        modalOptions,
        dialogs
    ]);
    if (error) {
        // Sandbox deprecation error
        if (error === (0, $eahkE.SANDBOX_DEPRECATION_ERROR)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eahkE.ForgeDeprecationMessage), {
            extension: extension,
            client: client,
            error: error
        });
    // Currently no other error types are handled
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f2c0519b4a165d40$export$5137ec99f248330b), {
        ...iframeProps,
        entryPoint: entryPoint,
        isResizable: isIframeResizable,
        bridge: {
            ...bridge,
            openModal: (opts)=>{
                setModalOptions(opts.data);
                return true;
            },
            ...onModalCustomUIRendererClose ? {
                close: (payload)=>{
                    if ((0, $dh538.fg)('forge-ui-on-close-bridge-method')) onModalCustomUIRendererClose().then(()=>{
                        bridge?.close?.(payload);
                    }).finally(()=>{
                        return true;
                    });
                    else {
                        // This bridge.close reference is defined below in ModalCustomUIRenderer.
                        onModalCustomUIRendererClose();
                        bridge?.close?.(payload);
                        return true;
                    }
                }
            } : {}
        },
        height: height,
        width: width,
        isInModal: isInModal,
        ref: iframeRef,
        onLoad: onIframeLoad,
        setIsLoading: setIsLoading,
        onError: onError
    }), modalOptions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8537409554582c9d$export$5d28a207fd7621f6, {
        ...iframeProps,
        product: product,
        getThreeLOPrompt: getThreeLOPrompt,
        dialogs: dialogs,
        client: client,
        extension: extensionInModal,
        extensionData: extensionDataInModal,
        localId: localId,
        onTearDown: handleModalTearDown,
        bridge: {
            ...bridge,
            onClose: (callback)=>{
                setViewOnClose(()=>callback.data);
                // stores the callback for when modal is closed
                return true;
            },
            close: (payload)=>{
                onCloseFromModalClass?.(payload.data);
                return true;
            }
        },
        modalOnClose: handleModalClose,
        size: modalOptions.size,
        closeOnEscape: modalOptions.closeOnEscape,
        closeOnOverlayClick: modalOptions.closeOnOverlayClick,
        modalStyles: modalStyles,
        modalProvider: modalProvider,
        getModalWidth: getModalWidth,
        isIframeResizable: isIframeResizable,
        viewOnClose: viewOnClose
    }) : null);
};
const $8537409554582c9d$export$5d28a207fd7621f6 = ({ accountId: accountId, bridge: bridge, coreData: coreData, client: client, closeOnEscape: closeOnEscape, closeOnOverlayClick: closeOnOverlayClick, consentMessage: consentMessage, contextIds: contextIds, customBridgeMethods: customBridgeMethods, dialogs: dialogs, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, getThreeLOPrompt: getThreeLOPrompt, isIframeHidden: isIframeHidden = false, isIframeResizable: isIframeResizable = false, loadingComponent: loadingComponent, locale: locale, localId: localId, mentionProvider: mentionProvider, modalExtension: modalExtension, modalStyles: modalStyles, modalProvider: ModalProvider, onConsentModalClose: onConsentModalClose, onConsentSuccess: onConsentSuccess, onError: onError, onForgeDocUpdated: onForgeDocUpdated, onIframeLoad: onIframeLoad, onTearDown: onTearDown, product: product, size: size, timezone: timezone, getModalWidth: getModalWidth, modalOnClose: // onClose from `Modal`
modalOnClose, viewOnClose: // onClose from `view`
viewOnClose })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(true);
    // This is for preventing inline dialog apps from being closed by an esc key press when a
    // modal is open until https://product-fabric.atlassian.net/browse/DSP-3552 is resolved.
    (0, $42omo.useEffect)(()=>{
        if (product !== 'confluence' || modalExtension?.type === 'macroConfig' || product === 'confluence' && modalExtension?.type === 'bylineItem') return;
        function dismissEscape(e) {
            if (e.key === 'Escape') {
                e.stopPropagation();
                if (closeOnEscape) {
                    modalOnClose?.();
                    setIsOpen(false);
                }
            }
        }
        if (isOpen) document.addEventListener('keydown', dismissEscape, {
            capture: true
        });
        return ()=>document.removeEventListener('keydown', dismissEscape, {
                capture: true
            });
    }, [
        isOpen,
        closeOnEscape,
        product,
        modalOnClose,
        modalExtension?.type
    ]);
    const modalWidthForMacroCustomConfig = extension.type === (0, $1c598.ConfluenceExtension).MACRO && (0, $dh538.fg)('forge_enable_fullscreen_viewport_for_custom_config') ? modalExtension?.modalWidth : undefined;
    const modalSize = modalWidthForMacroCustomConfig ?? size ?? extension.properties.viewportSize ?? 'medium';
    const modalWidth = getModalWidth ? getModalWidth(size) : (0, $dc67d857f203b917$export$ca177c112881662a)(modalSize);
    // If size is defined, iframe modal should not be resizable.
    // In JSM ONLY, iframe modal should ALWAYS be resizable.
    // Iframe should scale to 100% of the modal so that Select drop downs are not cut off
    const isJsmModule = extension.type.startsWith('jiraServiceManagement');
    const isModalResizable = isJsmModule || (size !== undefined ? false : isIframeResizable);
    const shouldShowFCFModalDeprecationMessage = (extension.type === (0, $1c598.JiraExtension).CUSTOM_FIELD || extension.type === (0, $1c598.JiraExtension).CUSTOM_FIELD_TYPE) && !(0, $dh538.fg)('forge_disable_fcf_modal_experience_on_issue_view');
    const renderModal = ()=>{
        const closeProps = {
            onClose: async ()=>{
                if ((0, $dh538.fg)('forge-ui-on-close-bridge-method')) try {
                    await viewOnClose?.();
                } finally{
                    modalOnClose?.();
                    setIsOpen(false);
                }
                else {
                    modalOnClose?.();
                    setIsOpen(false);
                }
            },
            onCloseComplete: onTearDown
        };
        const modalContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldShowFCFModalDeprecationMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $8537409554582c9d$var$styles.modalDeprecationMessage
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $amyZ5.ForgeModalDeprecationMessage), {
            client: client,
            extension: extension
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dc67d857f203b917$export$a6d6b74199964ee4), {
            size: modalSize,
            styles: modalStyles,
            isResizable: isIframeResizable
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8537409554582c9d$export$17d9f1e4832027c9, {
            product: product,
            coreData: coreData,
            getThreeLOPrompt: getThreeLOPrompt,
            dialogs: dialogs,
            accountId: accountId,
            client: client,
            contextIds: contextIds,
            extension: extension,
            extensionData: extensionData,
            extensionViewData: extensionViewData,
            bridge: bridge,
            customBridgeMethods: customBridgeMethods,
            consentMessage: consentMessage,
            entryPoint: entryPoint,
            getContextToken: getContextToken,
            height: "100%",
            isIframeHidden: isIframeHidden,
            isIframeResizable: isModalResizable,
            locale: locale,
            localId: localId,
            mentionProvider: mentionProvider,
            modalExtension: modalExtension,
            onConsentSuccess: onConsentSuccess,
            onForgeDocUpdated: onForgeDocUpdated,
            timezone: timezone,
            onConsentModalClose: onConsentModalClose,
            onError: onError,
            onIframeLoad: onIframeLoad,
            loadingComponent: loadingComponent,
            extensionPayload: extensionPayload,
            modalStyles: modalStyles,
            // This is called when `view.close` is called
            onModalCustomUIRendererClose: async ()=>{
                if (viewOnClose && (0, $dh538.fg)('forge-ui-on-close-bridge-method')) try {
                    await viewOnClose?.();
                } finally{
                    setIsOpen(false);
                    // If is a modal extension point, call modalOnClose to reset state from product
                    // This is required to reset the state of the modal in the product when view.close is called
                    modalExtension && modalOnClose?.();
                }
                else {
                    setIsOpen(false);
                    // if is a modal extension point, call modalOnClose to reset state from product
                    // This is required to reset the state of the modal in the product when view.close is called
                    modalExtension && modalOnClose?.();
                }
            },
            isInModal: true
        })));
        const isMacroExtension = extension.type === (0, $1c598.ConfluenceExtension).MACRO;
        const extensionIcon = isMacroExtension ? $8537409554582c9d$var$getExtensionIcon(extension) : undefined;
        if (modalSize === 'fullscreen' && ((0, $dh538.fg)('platform_add_modal_support_to_bylineitem_extension') || (0, $dh538.fg)('forge_enable_fullscreen_viewport_for_custom_config'))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnPaP.FullScreenModalDialog), {
            ...closeProps,
            testId: "custom-ui-fullscreen-modal-dialog",
            shouldCloseOnEscapePress: closeOnEscape
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, isMacroExtension && (0, $dh538.fg)('forge_enable_fullscreen_viewport_for_custom_config') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.100",
            alignBlock: "center"
        }, extensionIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: extensionIcon,
            alt: "Macro custom config icon",
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
            label: "",
            color: "var(--ds-icon-accent-gray, #7D818A)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, modalExtension?.title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, modalExtension?.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
            label: "Close Modal",
            onClick: modalExtension?.closeModalExtension
        })), modalContent);
        else {
            const { height: modalHeight } = (0, $3b6c709f803268e6$export$b3b34c460afe006f)(modalSize ?? 'medium');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
                ...closeProps,
                width: modalWidth,
                height: modalSize === 'max' ? modalHeight : undefined,
                testId: "custom-ui-modal-dialog",
                shouldCloseOnOverlayClick: closeOnOverlayClick,
                shouldCloseOnEscapePress: closeOnEscape
            }, modalContent);
        }
    };
    if (ModalProvider) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ModalProvider, null, renderModal()));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isOpen && renderModal());
};









var $jed12 = parcelRequire("jed12");


var $hEvav = parcelRequire("hEvav");




var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $6vnrx = parcelRequire("6vnrx");


var $9UyM5 = parcelRequire("9UyM5");


const $ac41127a79653400$var$AKAvatarGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("aX7Hk")));

const $ac41127a79653400$var$AKBadge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("6OBBH")));
function $ac41127a79653400$export$a2cdaa6af5c46e54(users, accountIds, intl) {
    // order should match accountIds
    return accountIds.map((key)=>{
        const { name: name = intl.formatMessage($ac41127a79653400$var$messages.unknownUserMessage), picture: picture = '' } = users[key] || {};
        return {
            key: key,
            name: name,
            src: picture
        };
    });
}
function $ac41127a79653400$export$7962e827ea8ac95f({ data: data }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac41127a79653400$var$AKAvatarGroup, {
        appearance: "stack",
        data: data
    });
}
function $ac41127a79653400$var$More({ data: data }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac41127a79653400$var$AKBadge, null, `+${data.length}`);
}
function $ac41127a79653400$export$82c3b28526691c79({ data: data }) {
    const end = Math.max(Math.min(8, data.length), 0); // 4 would be the same as AvatarStack
    const shown = data.slice(0, end);
    const more = data.slice(end);
    const hasMore = more.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, shown.map(({ name: name }, i)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac41127a79653400$var$AKBadge, {
            appearance: "primary"
        }, name), hasMore || i !== end - 1 ? ' ' : null);
    }), hasMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac41127a79653400$var$More, {
        data: more
    }) : null);
}
// @ts-ignore setting z index to 0 so that the avatars do not overlap other components
const $ac41127a79653400$var$avatarStackWrapper = (0, $ecnYn.xcss)({
    zIndex: 0,
    position: 'relative'
});
function $ac41127a79653400$export$2e2bcd8739ae039({ accountIds: accountIds, client: client }) {
    const users = (0, $6vnrx.useUsers)(accountIds, client);
    const intl = (0, $8C5kA.default)();
    const data = $ac41127a79653400$export$a2cdaa6af5c46e54(users, accountIds, intl);
    const { inline: inline } = (0, $9UyM5.useInlineContext)();
    if (inline) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac41127a79653400$export$82c3b28526691c79, {
        data: data
    });
    return(// Each avatar in an avatar stack has a z index value applied.
    // Setting a container with a z index here to 0 so that the avatars do no overlap other components such as the Select menu
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ac41127a79653400$var$avatarStackWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac41127a79653400$export$7962e827ea8ac95f, {
        data: data
    })));
}
function $ac41127a79653400$export$63abfa3ed5832db7({ children: children }) {
    const accountIds = children.map((child)=>{
        if (child.type !== 'User' && child.type !== 'Avatar') return '';
        const { props: props } = child;
        const { accountId: accountId } = props;
        return accountId;
    }).filter((x)=>x);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac41127a79653400$export$2e2bcd8739ae039, {
        accountIds: accountIds,
        client: undefined
    });
}
function $ac41127a79653400$export$30420ba0b3cd13e0({ client: client }) {
    return function avatarStackNext({ forgeDoc: { children: children } }) {
        const accountIds = children.map((child)=>{
            if (child.type !== 'User' && child.type !== 'Avatar') return '';
            const { props: props } = child;
            const { accountId: accountId } = props;
            return accountId;
        }).filter((x)=>x);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac41127a79653400$export$2e2bcd8739ae039, {
            accountIds: accountIds,
            client: client
        });
    };
}
const $ac41127a79653400$var$messages = (0, $cgtv4.defineMessages)({
    unknownUserMessage: {
        id: "confluence.user.group.unknown.user.message",
        defaultMessage: "Unknown User"
    }
});


var $durRy = parcelRequire("durRy");


var $dx0OV = parcelRequire("dx0OV");








const $6f2f66284b5f7b02$export$c9565324b088e0b8 = ({ setForgeDoc: setForgeDoc, setError: setError, accountId: accountId, apolloClient: apolloClient, contextIds: contextIds, extension: extension, components: components, coreData: coreData, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, timezone: timezone, locale: locale, bridge: bridge, ...restProps })=>{
    const forgeReactMajorVersion = (0, $42omo.useRef)(null);
    const combinedBridge = {
        onError: ({ error: error })=>{
            if (setError) setError(error);
        },
        ...bridge,
        reconcile: ({ forgeDoc: forgeDoc })=>{
            Object.freeze(forgeDoc);
            setForgeDoc(forgeDoc);
            if (forgeReactMajorVersion.current === null && forgeDoc.forgeReactMajorVersion) forgeReactMajorVersion.current = forgeDoc.forgeReactMajorVersion;
        }
    };
    const getCurrentForgeReactMajorVersion = (0, $hQK66.useCallbackOne)(()=>{
        return forgeReactMajorVersion.current;
    }, [
        forgeReactMajorVersion
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f2c0519b4a165d40$export$5137ec99f248330b), {
        accountId: accountId,
        apolloClient: apolloClient,
        contextIds: contextIds,
        extension: extension,
        coreData: coreData,
        components: components,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        timezone: timezone,
        locale: locale,
        bridge: combinedBridge,
        isHidden: true,
        getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
        ...restProps,
        onError: (err)=>setError && setError(new Error(err))
    });
};


const $388fc69d2d887761$var$uuidRe = new RegExp('^{([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})}$');
const $388fc69d2d887761$export$3a1a8bfb58a690be = (uuid)=>{
    const match = $388fc69d2d887761$var$uuidRe.exec(uuid);
    if (!match) return '';
    return match[1];
};



const $e892f186f061f3fc$var$HeightAnalyticsWrapper = ({ children: children, viewportDimensions: viewportDimensions })=>{
    const isEnabled = (0, $dh538.fg)('forge-ui-performance-analytics-provider');
    const { containerRef: containerRef } = (0, $4db8dff54302fa45$export$1b708c663f12db29)({
        isEnabled: isEnabled,
        viewportDimensions: viewportDimensions
    });
    if (isEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: containerRef,
        id: "forge-ui-height-observer-wrapper"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $e892f186f061f3fc$export$9ca39743052e068e = (props)=>{
    const { accountId: accountId, bridge: bridge, client: client, components: components, coreData: coreData, contextIds: contextIds, staticForgeDoc: staticForgeDoc, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionViewData: extensionViewData, getContextToken: getContextToken, mentionProvider: mentionProvider, product: product, locale: locale, modalExtension: modalExtension, onForgeDocUpdated: onForgeDocUpdated, getThreeLOPrompt: getThreeLOPrompt, customBridgeMethods: customBridgeMethods, loadingComponent: loadingComponent, onError: onError, extensionPayload: extensionPayload, onSuccess: onSuccess, onAppError: onAppError, viewportDimensions: viewportDimensions, isEmbeddedMacro: isEmbeddedMacro, embeddedParentLocalId: embeddedParentLocalId } = props;
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const [forgeDoc, setForgeDoc] = (0, $42omo.useState)(staticForgeDoc ?? undefined);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const [shouldShowRenderer, setShouldShowRenderer] = (0, $42omo.useState)(true);
    const isMacro = extension.type === 'xen:macro';
    const injectedComponentsWithKey = (0, $42omo.useMemo)(()=>{
        return components ? Object.keys(components).reduce((acc, key)=>{
            const Component = components[key];
            return {
                ...acc,
                // A key is required to ensure React creates new component instances when forgeDoc.key changes.
                // Without this key, React reuses the same component instance across different forgeDoc updates,
                // causing hook call order violations when the component structure changes between renders.
                [key]: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                        ...args,
                        key: args.forgeDoc.key
                    })
            };
        }, {}) : {};
    }, [
        components
    ]);
    const wiredComponents = (0, $42omo.useMemo)(()=>({
            Avatar: (0, $hEvav.makeUser)({
                client: client
            }),
            AvatarStack: (0, $ac41127a79653400$export$30420ba0b3cd13e0)({
                client: client
            }),
            UserPicker: (0, $durRy.makeNativeUserPicker)({
                client: client,
                mentionProvider: mentionProvider,
                accountId: accountId,
                ...workspaceId ? {
                    cloudId: 'bitbucket'
                } : {
                    cloudId: cloudId
                },
                productAttributes: workspaceId ? {
                    workspaceIds: [
                        (0, $388fc69d2d887761$export$3a1a8bfb58a690be)(workspaceId)
                    ]
                } : undefined,
                productKey: product
            }),
            ...(0, $dh538.fg)('platform_add_embedded_macro_support_to_ui_kit') ? {
                AdfRenderer: (0, $dx0OV.makeADFRenderer)({
                    bridge: bridge,
                    client: client
                })
            } : {}
        }), [
        accountId,
        client,
        cloudId,
        mentionProvider,
        product,
        workspaceId,
        bridge
    ]);
    const getComponents = (0, $42omo.useCallback)((defaults)=>({
            ...defaults,
            ...wiredComponents,
            ...(0, $dh538.fg)('forge-ui-kit-editor') ? injectedComponentsWithKey : components
        }), [
        components,
        injectedComponentsWithKey,
        wiredComponents
    ]);
    const handleError = (0, $42omo.useCallback)((error)=>{
        if (onError) onError(error.message);
        if (onAppError) onAppError(error.message);
    }, [
        onError,
        onAppError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (onError && error) onError(error.message);
        if (onAppError && error) onAppError(error.message);
    }, [
        error,
        onError,
        onAppError
    ]);
    const isUiKit1 = !(extension.properties.resource || entryPoint && extension.properties[entryPoint].resource);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e892f186f061f3fc$var$HeightAnalyticsWrapper, {
        viewportDimensions: isMacro ? viewportDimensions : undefined
    }, shouldShowRenderer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jed12.default), {
        isNative: !isUiKit1,
        forgeDoc: forgeDoc,
        extension: extension,
        error: error?.message,
        components: getComponents,
        modalExtension: modalExtension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionType: extensionData.type,
        loading: true,
        loadingComponent: loadingComponent,
        onError: handleError,
        client: client,
        onSuccess: onSuccess
    }), staticForgeDoc || isUiKit1 ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f2f66284b5f7b02$export$c9565324b088e0b8), {
        accountId: accountId,
        setForgeDoc: (forgeDoc)=>{
            if (forgeDoc.type !== 'MacroConfig') setForgeDoc(forgeDoc);
            onForgeDocUpdated?.(forgeDoc);
        },
        setError: setError,
        apolloClient: client,
        components: getThreeLOPrompt,
        contextIds: contextIds,
        extension: extension,
        coreData: coreData,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        locale: locale,
        bridge: bridge,
        getContextToken: getContextToken,
        entryPoint: entryPoint,
        customBridgeMethods: customBridgeMethods,
        setShouldShowRenderer: setShouldShowRenderer,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedParentLocalId: embeddedParentLocalId
    }));
};






var $69400 = parcelRequire("69400");


var $g7rOD = parcelRequire("g7rOD");

const $acc8ad845a033cd1$var$Frame = ({ forgeDoc: forgeDoc, IframeRenderer: IframeRenderer })=>{
    const { setFrameCount: setFrameCount } = (0, $42omo.useContext)((0, $69400.FrameCount));
    (0, $42omo.useEffect)(()=>{
        setFrameCount((prevCount)=>prevCount + 1);
        return ()=>setFrameCount((prevCount)=>prevCount - 1);
    }, [
        setFrameCount
    ]);
    const { resource: resource, frameId: frameId } = forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IframeRenderer, {
        resource: resource,
        frameId: frameId
    });
};
const $acc8ad845a033cd1$var$FrameMemo = /*#__PURE__*/ (0, $42omo.memo)($acc8ad845a033cd1$var$Frame, (0, $g7rOD.forgePropsAreEqual));
const $acc8ad845a033cd1$export$1f1ebfe6da5b177c = (IframeRenderer)=>{
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($acc8ad845a033cd1$var$FrameMemo, {
            ...props,
            IframeRenderer: IframeRenderer
        });
};


var $2Fl4v = parcelRequire("2Fl4v");




var $HEA67 = parcelRequire("HEA67");











var $bedQP = parcelRequire("bedQP");


var $iRRvH = parcelRequire("iRRvH");

const $3e3bb681d9ba953d$var$UFOSegmentForgeUnifiedWebRenderer = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
        name: "forge-ui-app-content-root"
    }, children);
const $3e3bb681d9ba953d$export$31f657a5c2c592d6 = (0, $bedQP.componentWithFG)('forge-ui-performance-analytics-provider', $3e3bb681d9ba953d$var$UFOSegmentForgeUnifiedWebRenderer, (0, $42omo.Fragment));


















var $fwDOR = parcelRequire("fwDOR");

// Maximum time we would expect an app initialization to take.
const $f6ee5ed4b27f8132$var$HOLD_MS_APP_INIT_TIMEOUT = 6000;
const $f6ee5ed4b27f8132$var$HOLD_MS_FRAME_INITIALISED = 2000;
const $f6ee5ed4b27f8132$var$HOLD_MS_RESOURCE_REQUEST_TIMEOUT = 5000;
const $f6ee5ed4b27f8132$var$HOLD_MS_CATCH_LATENT_REQUESTS = 350;
const $f6ee5ed4b27f8132$var$holdResourceStartEvents = new Set([
    'product-api-request-initiated',
    'resolver-invoke-initiated'
]);
const $f6ee5ed4b27f8132$var$holdResourceEndEvents = new Set([
    'product-api-requested',
    'resolver-invoked'
]);
const $f6ee5ed4b27f8132$var$holdAffectingEvents = new Set([
    ...$f6ee5ed4b27f8132$var$holdResourceStartEvents,
    ...$f6ee5ed4b27f8132$var$holdResourceEndEvents,
    'navigation-timing',
    'user-interacted'
]);
const $f6ee5ed4b27f8132$export$e286348a1f2b0a60 = ({ children: children })=>{
    const timelineRef = (0, $42omo.useContext)((0, $eI4ye.PerformanceAnalyticsContext));
    const { captureEvent: captureEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    const appRuntimeInitiated = (0, $42omo.useRef)(false);
    const [holdState, setHoldState] = (0, $42omo.useState)('holding');
    const releaseTimeoutRef = (0, $42omo.useRef)();
    const holdResourcesStartedCountRef = (0, $42omo.useRef)(0);
    const holdResourcesFinishedCountRef = (0, $42omo.useRef)(0);
    const releaseHold = (0, $42omo.useCallback)(()=>{
        clearTimeout(releaseTimeoutRef.current);
        setHoldState('released');
    }, [
        setHoldState
    ]);
    const retainHoldFor = (0, $42omo.useCallback)((holdFor)=>{
        clearTimeout(releaseTimeoutRef.current);
        releaseTimeoutRef.current = setTimeout(releaseHold, holdFor);
    }, [
        releaseHold
    ]);
    const handleEvent = (0, $42omo.useCallback)((event)=>{
        if (!$f6ee5ed4b27f8132$var$holdAffectingEvents.has(event.type)) return;
        // Drop holds on user interaction (timeline invalidated).
        if (event.type === 'user-interacted') {
            releaseHold();
            return;
        }
        // Keep track of requests starting and finished, don't consider in holding
        // logic until the app has initialised.
        const resourceHoldStarted = $f6ee5ed4b27f8132$var$holdResourceStartEvents.has(event.type);
        const resourceHoldFinished = $f6ee5ed4b27f8132$var$holdResourceEndEvents.has(event.type);
        if (resourceHoldStarted) holdResourcesStartedCountRef.current += 1;
        else if (resourceHoldFinished) holdResourcesFinishedCountRef.current += 1;
        const activeResourceRequests = holdResourcesStartedCountRef.current - holdResourcesFinishedCountRef.current;
        // Retain unconditional hold until 'navigation-timing' is received to indicate
        // that the frame runtime has initialised correctly.
        if (!appRuntimeInitiated.current) {
            if (event.type === 'navigation-timing') {
                appRuntimeInitiated.current = true;
                retainHoldFor(activeResourceRequests > 0 ? $f6ee5ed4b27f8132$var$HOLD_MS_RESOURCE_REQUEST_TIMEOUT : $f6ee5ed4b27f8132$var$HOLD_MS_FRAME_INITIALISED);
            }
            return;
        }
        // On new resource holds, reset to default resource request timeout.
        if (resourceHoldStarted) retainHoldFor($f6ee5ed4b27f8132$var$HOLD_MS_RESOURCE_REQUEST_TIMEOUT);
        // Retain hold until all active requests are finished.
        if (activeResourceRequests > 0) return;
        // No active resource requests, wait a moment to catch any new resource
        // requests initiated by the app runtime.
        retainHoldFor($f6ee5ed4b27f8132$var$HOLD_MS_CATCH_LATENT_REQUESTS);
    }, [
        releaseHold,
        retainHoldFor
    ]);
    // Event listener management.
    (0, $42omo.useEffect)(()=>{
        // Default timeout for app init, so we don't indefinitely on e.g. for
        // unhandled app errors.
        retainHoldFor($f6ee5ed4b27f8132$var$HOLD_MS_APP_INIT_TIMEOUT);
        const { listeners: listeners } = timelineRef.current;
        listeners.add(handleEvent);
        return ()=>{
            clearTimeout(releaseTimeoutRef.current);
            listeners.delete(handleEvent);
        };
    }, [
        timelineRef,
        handleEvent,
        retainHoldFor
    ]);
    (0, $42omo.useEffect)(()=>{
        // On hold state change or component dismount: flag release in timeline.
        return ()=>{
            if (holdState === 'holding') captureEvent({
                type: 'page-hold-released',
                elapsed: (0, $1uzCd.getPerformanceMark)()
            });
        };
    }, [
        holdState,
        captureEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "forge-ui-app-content-ttai-wait-v2",
        hold: holdState === 'holding'
    }), children);
};
const $f6ee5ed4b27f8132$export$4304f91d6e983d05 = (0, $bedQP.componentWithFG)('forge-ui-performance-analytics-provider', $f6ee5ed4b27f8132$export$e286348a1f2b0a60, (0, $42omo.Fragment));



var $bsX2q = parcelRequire("bsX2q");


var $grQpA = parcelRequire("grQpA");




const $e2fd6b5eb27bb420$var$getLoadingComponent = (loadingComponent)=>{
    if (loadingComponent) // Wrapping loadingComponent in a valid react element (fragment)
    // ReactNode type is not necessarily a valid React element, unable to change this type as different extension points pass in various loadingComponent types
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, loadingComponent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $CMcde.Loader), null);
};
const $e2fd6b5eb27bb420$export$b89b612df1c715da = (props)=>{
    const { accountId: accountId, bridge: bridge, client: client, components: components, consentMessage: consentMessage, contextIds: contextIds, customBridgeMethods: customBridgeMethods, staticForgeDoc: staticForgeDoc, dialogs: dialogs, entryPoint: entryPoint, extension: providedExtension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, hasModalConsentPrompt: hasModalConsentPrompt, height: height, width: width, isIframeHidden: isIframeHidden, isIframeResizable: isIframeResizable, getContextToken: getContextToken, loadingComponent: loadingComponent, locale: locale, localId: localId, mentionProvider: mentionProvider, modalExtension: modalExtension, modalStyles: modalStyles, modalProvider: modalProvider, onConsentModalClose: onConsentModalClose, onConsentSuccess: onConsentSuccess, onConsentInitialization: onConsentInitialization, onError: onError, onForgeDocUpdated: onForgeDocUpdated, onIframeLoad: onIframeLoad, onInitialRender: onInitialRender, product: product, timezone: timezone, getModalWidth: getModalWidth, onModalExtensionClose: onModalExtensionClose, onSuccess: onSuccess, onAppError: onAppError, viewportDimensions: viewportDimensions, isEmbeddedMacro: isEmbeddedMacro, embeddedParentLocalId: embeddedParentLocalId } = props;
    let cloudId;
    let workspaceId;
    if ('cloudId' in props) cloudId = props.cloudId;
    else if ('workspaceId' in props) workspaceId = props.workspaceId;
    const cloudOrWorkspaceId = cloudId ? {
        cloudId: cloudId
    } : {
        workspaceId: workspaceId
    };
    // For embedded macros, fetch fresh extension data from XLS instead of using
    // the potentially stale version stored in the ADF. This ensures embedded macros
    // always use the latest deployed version in view mode.
    const shouldRefetchExtension = isEmbeddedMacro && (0, $dh538.fg)('platform_refetch_embedded_macro_extension');
    const extensionType = providedExtension.type;
    const { extensions: freshExtensions, loading: extensionsLoading } = (0, $bsX2q.useExtensionList)({
        client: client,
        contextIds: contextIds,
        ...shouldRefetchExtension && extensionType ? {
            filter: [
                {
                    type: (0, $grQpA.GQLExtensionContextsFilterType).ExtensionType,
                    value: [
                        extensionType
                    ]
                }
            ]
        } : {},
        queryOptions: {
            skip: !shouldRefetchExtension
        }
    });
    // Use fresh extension if available for embedded macros, otherwise use the prop
    const freshExtension = shouldRefetchExtension ? freshExtensions?.find((ext)=>ext.id === providedExtension.id) : undefined;
    const extension = freshExtension ?? providedExtension;
    const { id: extensionId, environmentId: environmentId, environmentType: environmentType } = extension;
    (0, $42omo.useEffect)(()=>{
        onInitialRender?.();
    }, [
        onInitialRender
    ]);
    const coreData = (0, $42omo.useMemo)(()=>({
            workspaceId: workspaceId,
            cloudId: cloudId,
            localId: localId || extensionId,
            environmentId: environmentId,
            environmentType: environmentType
        }), [
        cloudId,
        environmentId,
        environmentType,
        extensionId,
        localId,
        workspaceId
    ]);
    const getThreeLOPrompt = (0, $42omo.useCallback)(()=>({
            ThreeLOPrompt: modalExtension || hasModalConsentPrompt ? (0, $2Fl4v.makeModalThreeLOPromptForCustomUI)({
                appName: extension.properties.title,
                isBlanketHidden: true,
                onClose: onConsentModalClose
            }) : (0, $4ZTaE.makeThreeLOPromptForCustomUI)({
                appName: extension.properties.title,
                onSuccess: onConsentSuccess,
                message: consentMessage,
                onInitialization: onConsentInitialization
            })
        }), [
        extension.properties.title,
        consentMessage,
        hasModalConsentPrompt,
        modalExtension,
        onConsentSuccess,
        onConsentModalClose,
        onConsentInitialization
    ]);
    const customUIProps = {
        accountId: accountId,
        bridge: bridge,
        client: client,
        consentMessage: consentMessage,
        contextIds: contextIds,
        coreData: coreData,
        customBridgeMethods: customBridgeMethods,
        dialogs: dialogs,
        entryPoint: entryPoint,
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        getThreeLOPrompt: getThreeLOPrompt,
        height: height,
        loadingComponent: loadingComponent,
        locale: locale,
        localId: localId,
        mentionProvider: mentionProvider,
        modalExtension: modalExtension,
        modalStyles: modalStyles,
        modalProvider: modalProvider,
        onConsentModalClose: onConsentModalClose,
        onConsentSuccess: onConsentSuccess,
        onError: onError,
        onForgeDocUpdated: onForgeDocUpdated,
        onIframeLoad: onIframeLoad,
        product: product,
        timezone: timezone,
        isIframeHidden: isIframeHidden,
        isIframeResizable: isIframeResizable,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedParentLocalId: embeddedParentLocalId
    };
    const uiKitEmbeddedMacroProps = {
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedParentLocalId: embeddedParentLocalId
    };
    const [viewOnClose, setViewOnClose] = (0, $42omo.useState)();
    // Show nothing while loading fresh extension data for embedded macros
    if (shouldRefetchExtension && extensionsLoading) return $e2fd6b5eb27bb420$var$getLoadingComponent(loadingComponent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $HEA67.ForgeUIExtensionAnalyticsContext), {
        extensionId: props.extension.id,
        localId: props.localId || props.extension.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3e3bb681d9ba953d$export$31f657a5c2c592d6), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eI4ye.PerformanceAnalyticsProviderRollout), {
        profileKey: `${props.extension.id}-${props.extension.key}-${props.entryPoint}`,
        appType: (0, $iqcSr.isCustomUI)(props.extension, props.entryPoint) ? 'CustomUI' : 'UIKit',
        forgeEnvironment: props.extension.environmentType,
        extensionType: props.extension.type
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f6ee5ed4b27f8132$export$4304f91d6e983d05), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        hidden: true,
        id: "forge-ui-renderer"
    }), !(0, $iqcSr.isCustomUI)(extension, entryPoint) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e892f186f061f3fc$export$9ca39743052e068e), {
        staticForgeDoc: staticForgeDoc,
        coreData: coreData,
        getThreeLOPrompt: getThreeLOPrompt,
        accountId: accountId,
        client: client,
        contextIds: contextIds,
        extension: extension,
        extensionData: extensionData,
        extensionViewData: extensionViewData,
        product: product,
        bridge: bridge,
        customBridgeMethods: customBridgeMethods,
        components: {
            Frame: (0, $acc8ad845a033cd1$export$1f1ebfe6da5b177c)((inputProps)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8537409554582c9d$export$17d9f1e4832027c9), {
                    ...customUIProps,
                    extension: {
                        ...extension,
                        properties: {
                            ...extension.properties,
                            ...inputProps
                        }
                    },
                    // Ensure extensions that are rendered as entryPoints aren't passing through the very same entryPoint to the Frame
                    entryPoint: undefined,
                    // Ensures Frame is always resized to the full height of the content
                    // Required because Jira leaves isIframeResizable as false
                    isIframeResizable: true
                });
            }),
            ...components
        },
        consentMessage: consentMessage,
        entryPoint: entryPoint,
        getContextToken: getContextToken,
        locale: locale,
        localId: localId,
        mentionProvider: mentionProvider,
        modalExtension: modalExtension,
        onConsentSuccess: onConsentSuccess,
        onForgeDocUpdated: onForgeDocUpdated,
        timezone: timezone,
        onConsentModalClose: onConsentModalClose,
        onError: onError,
        loadingComponent: loadingComponent,
        extensionPayload: extensionPayload,
        onSuccess: onSuccess,
        ...cloudOrWorkspaceId,
        onAppError: onAppError,
        viewportDimensions: viewportDimensions,
        ...(0, $dh538.fg)('platform_add_bridge_message_forwarding_from_faus') ? uiKitEmbeddedMacroProps : {}
    }) : modalExtension ? // getModalWidth not applied here since all modal extensions are defaulted to medium width
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8537409554582c9d$export$5d28a207fd7621f6), {
        ...customUIProps,
        bridge: {
            onClose: (callback)=>{
                setViewOnClose(()=>callback.data);
                // stores the callback for when modal is closed
                return true;
            },
            // spread down here so product can override the default onClose
            ...customUIProps.bridge
        },
        modalOnClose: onModalExtensionClose,
        closeOnEscape: modalExtension?.shouldCloseOnEscapePress ?? true,
        closeOnOverlayClick: modalExtension?.shouldCloseOnOverlayClick ?? true,
        viewOnClose: viewOnClose
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8537409554582c9d$export$17d9f1e4832027c9), {
        ...customUIProps,
        getModalWidth: getModalWidth,
        width: width
    })))));
};
module.exports["ForgeUIRenderer"] = $e2fd6b5eb27bb420$export$b89b612df1c715da;

});

parcelRegister("dj2Gr", function(module, exports) {

var $hQK66 = parcelRequire("hQK66");


var $eSUdr = parcelRequire("eSUdr");


var $1KmJq = parcelRequire("1KmJq");


var $1Igmn = parcelRequire("1Igmn");

const $7569106fed376473$export$46af696e5313090f = (0, $eSUdr.default)`mutation forge_ui_invokeExtension($input:InvokeExtensionInput!){invokeExtension(input:$input){success response{body}contextToken{jwt expiresAt}errors{message extensions{errorType statusCode ...on InvokeExtensionPayloadErrorExtension{fields{authInfoUrl}}}}}}`;
const $7569106fed376473$export$19d283d2f5a7d3c = (contextIds, extensionId, options)=>{
    const [mutationFunction] = (0, $1KmJq.useMutation)($7569106fed376473$export$46af696e5313090f, options);
    return (0, $hQK66.useCallbackOne)((payload, entryPoint = 'resolver')=>mutationFunction({
            variables: {
                input: {
                    contextIds: contextIds,
                    extensionId: extensionId,
                    payload: payload,
                    entryPoint: entryPoint
                }
            },
            context: {
                headers: {
                    'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
                }
            }
        }), [
        contextIds,
        extensionId,
        mutationFunction
    ]);
};
module.exports["useInvokeExtension"] = $7569106fed376473$export$19d283d2f5a7d3c;

});

parcelRegister("1BqC1", function(module, exports) {
$parcel$export(module.exports, "iframeResize", () => $12ade3c53ffa5233$export$e284ab1b3bcdabe6, (v) => $12ade3c53ffa5233$export$e284ab1b3bcdabe6 = v);
$parcel$export(module.exports, "iframeResizer", () => $12ade3c53ffa5233$export$b6962bfb5a91d43, (v) => $12ade3c53ffa5233$export$b6962bfb5a91d43 = v);
$parcel$export(module.exports, "iframeResizerContentWindow", () => $12ade3c53ffa5233$export$1aafc108bc1f168c, (v) => $12ade3c53ffa5233$export$1aafc108bc1f168c = v);
var $12ade3c53ffa5233$export$e284ab1b3bcdabe6;
var $12ade3c53ffa5233$export$b6962bfb5a91d43// Backwards compatability
;
var $12ade3c53ffa5233$export$1aafc108bc1f168c;

var $9wL22 = parcelRequire("9wL22");

$12ade3c53ffa5233$export$e284ab1b3bcdabe6 = $9wL22;
$12ade3c53ffa5233$export$b6962bfb5a91d43 = $9wL22;

$12ade3c53ffa5233$export$1aafc108bc1f168c = (parcelRequire("hAXmP"));

});

parcelRegister("hAXmP", function(module, exports) {
/*
 * File: iframeResizer.contentWindow.js
 * Desc: Include this file in any page being loaded into an iframe
 *       to force the iframe to resize to the content size.
 * Requires: iframeResizer.js on host page.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 *
 */ // eslint-disable-next-line sonarjs/cognitive-complexity, no-shadow-restricted-names
(function(undefined) {
    if (typeof window === 'undefined') return; // don't run for server side render
    var autoResize = true, base = 10, bodyBackground = '', bodyMargin = 0, bodyMarginStr = '', bodyObserver = null, bodyPadding = '', calculateWidth = false, doubleEventList = {
        resize: 1,
        click: 1
    }, eventCancelTimer = 128, firstRun = true, height = 1, heightCalcModeDefault = 'bodyOffset', heightCalcMode = heightCalcModeDefault, initLock = true, initMsg = '', inPageLinks = {}, interval = 32, intervalTimer = null, logging = false, mouseEvents = false, msgID = '[iFrameSizer]', msgIdLen = msgID.length, myID = '', resetRequiredMethods = {
        max: 1,
        min: 1,
        bodyScroll: 1,
        documentElementScroll: 1
    }, resizeFrom = 'child', sendPermit = true, target = window.parent, targetOriginDefault = '*', tolerance = 0, triggerLocked = false, triggerLockedTimer = null, throttledTimer = 16, width = 1, widthCalcModeDefault = 'scroll', widthCalcMode = widthCalcModeDefault, win = window, onMessage = function() {
        warn('onMessage function not defined');
    }, onReady = function() {}, onPageInfo = function() {}, customCalcMethods = {
        height: function() {
            warn('Custom height calculation function not defined');
            return document.documentElement.offsetHeight;
        },
        width: function() {
            warn('Custom width calculation function not defined');
            return document.body.scrollWidth;
        }
    }, eventHandlersByName = {}, passiveSupported = false;
    function noop() {}
    try {
        var options = Object.create({}, {
            passive: {
                get: function() {
                    passiveSupported = true;
                }
            }
        });
        window.addEventListener('test', noop, options);
        window.removeEventListener('test', noop, options);
    } catch (error) {
    /* */ }
    function addEventListener(el, evt, func, options) {
        el.addEventListener(evt, func, passiveSupported ? options || {} : false);
    }
    function removeEventListener(el, evt, func) {
        el.removeEventListener(evt, func, false);
    }
    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    // Based on underscore.js
    function throttle(func) {
        var context, args, result, timeout = null, previous = 0, later = function() {
            previous = Date.now();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) // eslint-disable-next-line no-multi-assign
            context = args = null;
        };
        return function() {
            var now = Date.now();
            if (!previous) previous = now;
            var remaining = throttledTimer - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > throttledTimer) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) // eslint-disable-next-line no-multi-assign
                context = args = null;
            } else if (!timeout) timeout = setTimeout(later, remaining);
            return result;
        };
    }
    function formatLogMsg(msg) {
        return msgID + '[' + myID + '] ' + msg;
    }
    function log(msg) {
        if (logging && 'object' === typeof window.console) // eslint-disable-next-line no-console
        console.log(formatLogMsg(msg));
    }
    function warn(msg) {
        if ('object' === typeof window.console) // eslint-disable-next-line no-console
        console.warn(formatLogMsg(msg));
    }
    function init() {
        readDataFromParent();
        log('Initialising iFrame (' + window.location.href + ')');
        readDataFromPage();
        setMargin();
        setBodyStyle('background', bodyBackground);
        setBodyStyle('padding', bodyPadding);
        injectClearFixIntoBodyElement();
        checkHeightMode();
        checkWidthMode();
        stopInfiniteResizingOfIFrame();
        setupPublicMethods();
        setupMouseEvents();
        startEventListeners();
        inPageLinks = setupInPageLinks();
        sendSize('init', 'Init message from host page');
        onReady();
    }
    function readDataFromParent() {
        function strBool(str) {
            return 'true' === str;
        }
        var data = initMsg.substr(msgIdLen).split(':');
        myID = data[0];
        bodyMargin = undefined !== data[1] ? Number(data[1]) : bodyMargin // For V1 compatibility
        ;
        calculateWidth = undefined !== data[2] ? strBool(data[2]) : calculateWidth;
        logging = undefined !== data[3] ? strBool(data[3]) : logging;
        interval = undefined !== data[4] ? Number(data[4]) : interval;
        autoResize = undefined !== data[6] ? strBool(data[6]) : autoResize;
        bodyMarginStr = data[7];
        heightCalcMode = undefined !== data[8] ? data[8] : heightCalcMode;
        bodyBackground = data[9];
        bodyPadding = data[10];
        tolerance = undefined !== data[11] ? Number(data[11]) : tolerance;
        inPageLinks.enable = undefined !== data[12] ? strBool(data[12]) : false;
        resizeFrom = undefined !== data[13] ? data[13] : resizeFrom;
        widthCalcMode = undefined !== data[14] ? data[14] : widthCalcMode;
        mouseEvents = undefined !== data[15] ? Boolean(data[15]) : mouseEvents;
    }
    function depricate(key) {
        var splitName = key.split('Callback');
        if (splitName.length === 2) {
            var name = 'on' + splitName[0].charAt(0).toUpperCase() + splitName[0].slice(1);
            this[name] = this[key];
            delete this[key];
            warn("Deprecated: '" + key + "' has been renamed '" + name + "'. The old method will be removed in the next major version.");
        }
    }
    function readDataFromPage() {
        function readData() {
            var data = window.iFrameResizer;
            log('Reading data from page: ' + JSON.stringify(data));
            Object.keys(data).forEach(depricate, data);
            onMessage = 'onMessage' in data ? data.onMessage : onMessage;
            onReady = 'onReady' in data ? data.onReady : onReady;
            targetOriginDefault = 'targetOrigin' in data ? data.targetOrigin : targetOriginDefault;
            heightCalcMode = 'heightCalculationMethod' in data ? data.heightCalculationMethod : heightCalcMode;
            widthCalcMode = 'widthCalculationMethod' in data ? data.widthCalculationMethod : widthCalcMode;
        }
        function setupCustomCalcMethods(calcMode, calcFunc) {
            if ('function' === typeof calcMode) {
                log('Setup custom ' + calcFunc + 'CalcMethod');
                customCalcMethods[calcFunc] = calcMode;
                calcMode = 'custom';
            }
            return calcMode;
        }
        if ('iFrameResizer' in window && Object === window.iFrameResizer.constructor) {
            readData();
            heightCalcMode = setupCustomCalcMethods(heightCalcMode, 'height');
            widthCalcMode = setupCustomCalcMethods(widthCalcMode, 'width');
        }
        log('TargetOrigin for parent set to: ' + targetOriginDefault);
    }
    function chkCSS(attr, value) {
        if (-1 !== value.indexOf('-')) {
            warn('Negative CSS value ignored for ' + attr);
            value = '';
        }
        return value;
    }
    function setBodyStyle(attr, value) {
        if (undefined !== value && '' !== value && 'null' !== value) {
            document.body.style[attr] = value;
            log('Body ' + attr + ' set to "' + value + '"');
        }
    }
    function setMargin() {
        // If called via V1 script, convert bodyMargin from int to str
        if (undefined === bodyMarginStr) bodyMarginStr = bodyMargin + 'px';
        setBodyStyle('margin', chkCSS('margin', bodyMarginStr));
    }
    function stopInfiniteResizingOfIFrame() {
        document.documentElement.style.height = '';
        document.body.style.height = '';
        log('HTML & body height set to "auto"');
    }
    function manageTriggerEvent(options) {
        var listener = {
            add: function(eventName) {
                function handleEvent() {
                    sendSize(options.eventName, options.eventType);
                }
                eventHandlersByName[eventName] = handleEvent;
                addEventListener(window, eventName, handleEvent, {
                    passive: true
                });
            },
            remove: function(eventName) {
                var handleEvent = eventHandlersByName[eventName];
                delete eventHandlersByName[eventName];
                removeEventListener(window, eventName, handleEvent);
            }
        };
        if (options.eventNames && Array.prototype.map) {
            options.eventName = options.eventNames[0];
            options.eventNames.map(listener[options.method]);
        } else listener[options.method](options.eventName);
        log(capitalizeFirstLetter(options.method) + ' event listener: ' + options.eventType);
    }
    function manageEventListeners(method) {
        manageTriggerEvent({
            method: method,
            eventType: 'Animation Start',
            eventNames: [
                'animationstart',
                'webkitAnimationStart'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Animation Iteration',
            eventNames: [
                'animationiteration',
                'webkitAnimationIteration'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Animation End',
            eventNames: [
                'animationend',
                'webkitAnimationEnd'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Input',
            eventName: 'input'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Mouse Up',
            eventName: 'mouseup'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Mouse Down',
            eventName: 'mousedown'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Orientation Change',
            eventName: 'orientationchange'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Print',
            eventName: [
                'afterprint',
                'beforeprint'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Ready State Change',
            eventName: 'readystatechange'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch Start',
            eventName: 'touchstart'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch End',
            eventName: 'touchend'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch Cancel',
            eventName: 'touchcancel'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition Start',
            eventNames: [
                'transitionstart',
                'webkitTransitionStart',
                'MSTransitionStart',
                'oTransitionStart',
                'otransitionstart'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition Iteration',
            eventNames: [
                'transitioniteration',
                'webkitTransitionIteration',
                'MSTransitionIteration',
                'oTransitionIteration',
                'otransitioniteration'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition End',
            eventNames: [
                'transitionend',
                'webkitTransitionEnd',
                'MSTransitionEnd',
                'oTransitionEnd',
                'otransitionend'
            ]
        });
        if ('child' === resizeFrom) manageTriggerEvent({
            method: method,
            eventType: 'IFrame Resized',
            eventName: 'resize'
        });
    }
    function checkCalcMode(calcMode, calcModeDefault, modes, type) {
        if (calcModeDefault !== calcMode) {
            if (!(calcMode in modes)) {
                warn(calcMode + ' is not a valid option for ' + type + 'CalculationMethod.');
                calcMode = calcModeDefault;
            }
            log(type + ' calculation method set to "' + calcMode + '"');
        }
        return calcMode;
    }
    function checkHeightMode() {
        heightCalcMode = checkCalcMode(heightCalcMode, heightCalcModeDefault, getHeight, 'height');
    }
    function checkWidthMode() {
        widthCalcMode = checkCalcMode(widthCalcMode, widthCalcModeDefault, getWidth, 'width');
    }
    function startEventListeners() {
        if (true === autoResize) {
            manageEventListeners('add');
            setupMutationObserver();
        } else log('Auto Resize disabled');
    }
    //   function stopMsgsToParent() {
    //     log('Disable outgoing messages')
    //     sendPermit = false
    //   }
    //   function removeMsgListener() {
    //     log('Remove event listener: Message')
    //     removeEventListener(window, 'message', receiver)
    //   }
    function disconnectMutationObserver() {
        if (null !== bodyObserver) /* istanbul ignore next */ // Not testable in PhantonJS
        bodyObserver.disconnect();
    }
    function stopEventListeners() {
        manageEventListeners('remove');
        disconnectMutationObserver();
        clearInterval(intervalTimer);
    }
    //   function teardown() {
    //     stopMsgsToParent()
    //     removeMsgListener()
    //     if (true === autoResize) stopEventListeners()
    //   }
    function injectClearFixIntoBodyElement() {
        var clearFix = document.createElement('div');
        clearFix.style.clear = 'both';
        // Guard against the following having been globally redefined in CSS.
        clearFix.style.display = 'block';
        clearFix.style.height = '0';
        document.body.appendChild(clearFix);
    }
    function setupInPageLinks() {
        function getPagePosition() {
            return {
                x: window.pageXOffset !== undefined ? window.pageXOffset : document.documentElement.scrollLeft,
                y: window.pageYOffset !== undefined ? window.pageYOffset : document.documentElement.scrollTop
            };
        }
        function getElementPosition(el) {
            var elPosition = el.getBoundingClientRect(), pagePosition = getPagePosition();
            return {
                x: parseInt(elPosition.left, 10) + parseInt(pagePosition.x, 10),
                y: parseInt(elPosition.top, 10) + parseInt(pagePosition.y, 10)
            };
        }
        function findTarget(location) {
            function jumpToTarget(target) {
                var jumpPosition = getElementPosition(target);
                log('Moving to in page link (#' + hash + ') at x: ' + jumpPosition.x + ' y: ' + jumpPosition.y);
                sendMsg(jumpPosition.y, jumpPosition.x, 'scrollToOffset') // X&Y reversed at sendMsg uses height/width
                ;
            }
            var hash = location.split('#')[1] || location, hashData = decodeURIComponent(hash), target = document.getElementById(hashData) || document.getElementsByName(hashData)[0];
            if (undefined !== target) jumpToTarget(target);
            else {
                log('In page link (#' + hash + ') not found in iFrame, so sending to parent');
                sendMsg(0, 0, 'inPageLink', '#' + hash);
            }
        }
        function checkLocationHash() {
            var hash = window.location.hash;
            var href = window.location.href;
            if ('' !== hash && '#' !== hash) findTarget(href);
        }
        function bindAnchors() {
            function setupLink(el) {
                function linkClicked(e) {
                    e.preventDefault();
                    /* jshint validthis:true */ findTarget(this.getAttribute('href'));
                }
                if ('#' !== el.getAttribute('href')) addEventListener(el, 'click', linkClicked);
            }
            Array.prototype.forEach.call(document.querySelectorAll('a[href^="#"]'), setupLink);
        }
        function bindLocationHash() {
            addEventListener(window, 'hashchange', checkLocationHash);
        }
        function initCheck() {
            // Check if page loaded with location hash after init resize
            setTimeout(checkLocationHash, eventCancelTimer);
        }
        function enableInPageLinks() {
            /* istanbul ignore else */ // Not testable in phantonJS
            if (Array.prototype.forEach && document.querySelectorAll) {
                log('Setting up location.hash handlers');
                bindAnchors();
                bindLocationHash();
                initCheck();
            } else warn('In page linking not fully supported in this browser! (See README.md for IE8 workaround)');
        }
        if (inPageLinks.enable) enableInPageLinks();
        else log('In page linking not enabled');
        return {
            findTarget: findTarget
        };
    }
    function setupMouseEvents() {
        if (mouseEvents !== true) return;
        function sendMouse(e) {
            sendMsg(0, 0, e.type, e.screenY + ':' + e.screenX);
        }
        function addMouseListener(evt, name) {
            log('Add event listener: ' + name);
            addEventListener(window.document, evt, sendMouse);
        }
        addMouseListener('mouseenter', 'Mouse Enter');
        addMouseListener('mouseleave', 'Mouse Leave');
    }
    function setupPublicMethods() {
        log('Enable public methods');
        win.parentIFrame = {
            autoResize: function autoResizeF(resize) {
                if (true === resize && false === autoResize) {
                    autoResize = true;
                    startEventListeners();
                } else if (false === resize && true === autoResize) {
                    autoResize = false;
                    stopEventListeners();
                }
                sendMsg(0, 0, 'autoResize', JSON.stringify(autoResize));
                return autoResize;
            },
            close: function closeF() {
                sendMsg(0, 0, 'close');
            // teardown()
            },
            getId: function getIdF() {
                return myID;
            },
            getPageInfo: function getPageInfoF(callback) {
                if ('function' === typeof callback) {
                    onPageInfo = callback;
                    sendMsg(0, 0, 'pageInfo');
                } else {
                    onPageInfo = function() {};
                    sendMsg(0, 0, 'pageInfoStop');
                }
            },
            moveToAnchor: function moveToAnchorF(hash) {
                inPageLinks.findTarget(hash);
            },
            reset: function resetF() {
                resetIFrame('parentIFrame.reset');
            },
            scrollTo: function scrollToF(x, y) {
                sendMsg(y, x, 'scrollTo') // X&Y reversed at sendMsg uses height/width
                ;
            },
            scrollToOffset: function scrollToF(x, y) {
                sendMsg(y, x, 'scrollToOffset') // X&Y reversed at sendMsg uses height/width
                ;
            },
            sendMessage: function sendMessageF(msg, targetOrigin) {
                sendMsg(0, 0, 'message', JSON.stringify(msg), targetOrigin);
            },
            setHeightCalculationMethod: function setHeightCalculationMethodF(heightCalculationMethod) {
                heightCalcMode = heightCalculationMethod;
                checkHeightMode();
            },
            setWidthCalculationMethod: function setWidthCalculationMethodF(widthCalculationMethod) {
                widthCalcMode = widthCalculationMethod;
                checkWidthMode();
            },
            setTargetOrigin: function setTargetOriginF(targetOrigin) {
                log('Set targetOrigin: ' + targetOrigin);
                targetOriginDefault = targetOrigin;
            },
            size: function sizeF(customHeight, customWidth) {
                var valString = '' + (customHeight || '') + (customWidth ? ',' + customWidth : '');
                sendSize('size', 'parentIFrame.size(' + valString + ')', customHeight, customWidth);
            }
        };
    }
    function initInterval() {
        if (0 !== interval) {
            log('setInterval: ' + interval + 'ms');
            intervalTimer = setInterval(function() {
                sendSize('interval', 'setInterval: ' + interval);
            }, Math.abs(interval));
        }
    }
    // Not testable in PhantomJS
    /* istanbul ignore next */ function setupBodyMutationObserver() {
        function addImageLoadListners(mutation) {
            function addImageLoadListener(element) {
                if (false === element.complete) {
                    log('Attach listeners to ' + element.src);
                    element.addEventListener('load', imageLoaded, false);
                    element.addEventListener('error', imageError, false);
                    elements.push(element);
                }
            }
            if (mutation.type === 'attributes' && mutation.attributeName === 'src') addImageLoadListener(mutation.target);
            else if (mutation.type === 'childList') Array.prototype.forEach.call(mutation.target.querySelectorAll('img'), addImageLoadListener);
        }
        function removeFromArray(element) {
            elements.splice(elements.indexOf(element), 1);
        }
        function removeImageLoadListener(element) {
            log('Remove listeners from ' + element.src);
            element.removeEventListener('load', imageLoaded, false);
            element.removeEventListener('error', imageError, false);
            removeFromArray(element);
        }
        function imageEventTriggered(event, type, typeDesc) {
            removeImageLoadListener(event.target);
            sendSize(type, typeDesc + ': ' + event.target.src);
        }
        function imageLoaded(event) {
            imageEventTriggered(event, 'imageLoad', 'Image loaded');
        }
        function imageError(event) {
            imageEventTriggered(event, 'imageLoadFailed', 'Image load failed');
        }
        function mutationObserved(mutations) {
            sendSize('mutationObserver', 'mutationObserver: ' + mutations[0].target + ' ' + mutations[0].type);
            // Deal with WebKit / Blink asyncing image loading when tags are injected into the page
            mutations.forEach(addImageLoadListners);
        }
        function createMutationObserver() {
            var target = document.querySelector('body'), config = {
                attributes: true,
                attributeOldValue: false,
                characterData: true,
                characterDataOldValue: false,
                childList: true,
                subtree: true
            };
            observer = new MutationObserver(mutationObserved);
            log('Create body MutationObserver');
            observer.observe(target, config);
            return observer;
        }
        var elements = [], MutationObserver = window.MutationObserver || window.WebKitMutationObserver, observer = createMutationObserver();
        return {
            disconnect: function() {
                if ('disconnect' in observer) {
                    log('Disconnect body MutationObserver');
                    observer.disconnect();
                    elements.forEach(removeImageLoadListener);
                }
            }
        };
    }
    function setupMutationObserver() {
        var forceIntervalTimer = 0 > interval;
        // Not testable in PhantomJS
        /* istanbul ignore if */ if (window.MutationObserver || window.WebKitMutationObserver) {
            if (forceIntervalTimer) initInterval();
            else bodyObserver = setupBodyMutationObserver();
        } else {
            log('MutationObserver not supported in this browser!');
            initInterval();
        }
    }
    // document.documentElement.offsetHeight is not reliable, so
    // we have to jump through hoops to get a better value.
    function getComputedStyle(prop, el) {
        var retVal = 0;
        el = el || document.body // Not testable in phantonJS
        ;
        retVal = document.defaultView.getComputedStyle(el, null);
        retVal = null !== retVal ? retVal[prop] : 0;
        return parseInt(retVal, base);
    }
    function chkEventThottle(timer) {
        if (timer > throttledTimer / 2) {
            throttledTimer = 2 * timer;
            log('Event throttle increased to ' + throttledTimer + 'ms');
        }
    }
    // Idea from https://github.com/guardian/iframe-messenger
    function getMaxElement(side, elements) {
        var elementsLength = elements.length, elVal = 0, maxVal = 0, Side = capitalizeFirstLetter(side), timer = Date.now();
        for(var i = 0; i < elementsLength; i++){
            elVal = elements[i].getBoundingClientRect()[side] + getComputedStyle('margin' + Side, elements[i]);
            if (elVal > maxVal) maxVal = elVal;
        }
        timer = Date.now() - timer;
        log('Parsed ' + elementsLength + ' HTML elements');
        log('Element position calculated in ' + timer + 'ms');
        chkEventThottle(timer);
        return maxVal;
    }
    function getAllMeasurements(dimensions) {
        return [
            dimensions.bodyOffset(),
            dimensions.bodyScroll(),
            dimensions.documentElementOffset(),
            dimensions.documentElementScroll()
        ];
    }
    function getTaggedElements(side, tag) {
        function noTaggedElementsFound() {
            warn('No tagged elements (' + tag + ') found on page');
            return document.querySelectorAll('body *');
        }
        var elements = document.querySelectorAll('[' + tag + ']');
        if (elements.length === 0) noTaggedElementsFound();
        return getMaxElement(side, elements);
    }
    function getAllElements() {
        return document.querySelectorAll('body *');
    }
    var getHeight = {
        bodyOffset: function getBodyOffsetHeight() {
            return document.body.offsetHeight + getComputedStyle('marginTop') + getComputedStyle('marginBottom');
        },
        offset: function() {
            return getHeight.bodyOffset() // Backwards compatability
            ;
        },
        bodyScroll: function getBodyScrollHeight() {
            return document.body.scrollHeight;
        },
        custom: function getCustomWidth() {
            return customCalcMethods.height();
        },
        documentElementOffset: function getDEOffsetHeight() {
            return document.documentElement.offsetHeight;
        },
        documentElementScroll: function getDEScrollHeight() {
            return document.documentElement.scrollHeight;
        },
        max: function getMaxHeight() {
            return Math.max.apply(null, getAllMeasurements(getHeight));
        },
        min: function getMinHeight() {
            return Math.min.apply(null, getAllMeasurements(getHeight));
        },
        grow: function growHeight() {
            return getHeight.max() // Run max without the forced downsizing
            ;
        },
        lowestElement: function getBestHeight() {
            return Math.max(getHeight.bodyOffset() || getHeight.documentElementOffset(), getMaxElement('bottom', getAllElements()));
        },
        taggedElement: function getTaggedElementsHeight() {
            return getTaggedElements('bottom', 'data-iframe-height');
        }
    }, getWidth = {
        bodyScroll: function getBodyScrollWidth() {
            return document.body.scrollWidth;
        },
        bodyOffset: function getBodyOffsetWidth() {
            return document.body.offsetWidth;
        },
        custom: function getCustomWidth() {
            return customCalcMethods.width();
        },
        documentElementScroll: function getDEScrollWidth() {
            return document.documentElement.scrollWidth;
        },
        documentElementOffset: function getDEOffsetWidth() {
            return document.documentElement.offsetWidth;
        },
        scroll: function getMaxWidth() {
            return Math.max(getWidth.bodyScroll(), getWidth.documentElementScroll());
        },
        max: function getMaxWidth() {
            return Math.max.apply(null, getAllMeasurements(getWidth));
        },
        min: function getMinWidth() {
            return Math.min.apply(null, getAllMeasurements(getWidth));
        },
        rightMostElement: function rightMostElement() {
            return getMaxElement('right', getAllElements());
        },
        taggedElement: function getTaggedElementsWidth() {
            return getTaggedElements('right', 'data-iframe-width');
        }
    };
    function sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth) {
        function resizeIFrame() {
            height = currentHeight;
            width = currentWidth;
            sendMsg(height, width, triggerEvent);
        }
        function isSizeChangeDetected() {
            function checkTolarance(a, b) {
                var retVal = Math.abs(a - b) <= tolerance;
                return !retVal;
            }
            currentHeight = undefined !== customHeight ? customHeight : getHeight[heightCalcMode]();
            currentWidth = undefined !== customWidth ? customWidth : getWidth[widthCalcMode]();
            return checkTolarance(height, currentHeight) || calculateWidth && checkTolarance(width, currentWidth);
        }
        function isForceResizableEvent() {
            return !(triggerEvent in {
                init: 1,
                interval: 1,
                size: 1
            });
        }
        function isForceResizableCalcMode() {
            return heightCalcMode in resetRequiredMethods || calculateWidth && widthCalcMode in resetRequiredMethods;
        }
        function logIgnored() {
            log('No change in size detected');
        }
        function checkDownSizing() {
            if (isForceResizableEvent() && isForceResizableCalcMode()) resetIFrame(triggerEventDesc);
            else if (!(triggerEvent in {
                interval: 1
            })) logIgnored();
        }
        var currentHeight, currentWidth;
        if (isSizeChangeDetected() || 'init' === triggerEvent) {
            lockTrigger();
            resizeIFrame();
        } else checkDownSizing();
    }
    var sizeIFrameThrottled = throttle(sizeIFrame);
    function sendSize(triggerEvent, triggerEventDesc, customHeight, customWidth) {
        function recordTrigger() {
            if (!(triggerEvent in {
                reset: 1,
                resetPage: 1,
                init: 1
            })) log('Trigger event: ' + triggerEventDesc);
        }
        function isDoubleFiredEvent() {
            return triggerLocked && triggerEvent in doubleEventList;
        }
        if (!isDoubleFiredEvent()) {
            recordTrigger();
            if (triggerEvent === 'init') sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth);
            else sizeIFrameThrottled(triggerEvent, triggerEventDesc, customHeight, customWidth);
        } else log('Trigger event cancelled: ' + triggerEvent);
    }
    function lockTrigger() {
        if (!triggerLocked) {
            triggerLocked = true;
            log('Trigger event lock on');
        }
        clearTimeout(triggerLockedTimer);
        triggerLockedTimer = setTimeout(function() {
            triggerLocked = false;
            log('Trigger event lock off');
            log('--');
        }, eventCancelTimer);
    }
    function triggerReset(triggerEvent) {
        height = getHeight[heightCalcMode]();
        width = getWidth[widthCalcMode]();
        sendMsg(height, width, triggerEvent);
    }
    function resetIFrame(triggerEventDesc) {
        var hcm = heightCalcMode;
        heightCalcMode = heightCalcModeDefault;
        log('Reset trigger event: ' + triggerEventDesc);
        lockTrigger();
        triggerReset('reset');
        heightCalcMode = hcm;
    }
    function sendMsg(height, width, triggerEvent, msg, targetOrigin) {
        function setTargetOrigin() {
            if (undefined === targetOrigin) targetOrigin = targetOriginDefault;
            else log('Message targetOrigin: ' + targetOrigin);
        }
        function sendToParent() {
            var size = height + ':' + width, message = myID + ':' + size + ':' + triggerEvent + (undefined !== msg ? ':' + msg : '');
            log('Sending message to host page (' + message + ')');
            target.postMessage(msgID + message, targetOrigin);
        }
        if (true === sendPermit) {
            setTargetOrigin();
            sendToParent();
        }
    }
    function receiver(event) {
        var processRequestFromParent = {
            init: function initFromParent() {
                initMsg = event.data;
                target = event.source;
                init();
                firstRun = false;
                setTimeout(function() {
                    initLock = false;
                }, eventCancelTimer);
            },
            reset: function resetFromParent() {
                if (!initLock) {
                    log('Page size reset by host page');
                    triggerReset('resetPage');
                } else log('Page reset ignored by init');
            },
            resize: function resizeFromParent() {
                sendSize('resizeParent', 'Parent window requested size check');
            },
            moveToAnchor: function moveToAnchorF() {
                inPageLinks.findTarget(getData());
            },
            inPageLink: function inPageLinkF() {
                this.moveToAnchor();
            },
            pageInfo: function pageInfoFromParent() {
                var msgBody = getData();
                log('PageInfoFromParent called from parent: ' + msgBody);
                onPageInfo(JSON.parse(msgBody));
                log(' --');
            },
            message: function messageFromParent() {
                var msgBody = getData();
                log('onMessage called from parent: ' + msgBody);
                // eslint-disable-next-line sonarjs/no-extra-arguments
                onMessage(JSON.parse(msgBody));
                log(' --');
            }
        };
        function isMessageForUs() {
            return msgID === ('' + event.data).substr(0, msgIdLen) // ''+ Protects against non-string messages
            ;
        }
        function getMessageType() {
            return event.data.split(']')[1].split(':')[0];
        }
        function getData() {
            return event.data.substr(event.data.indexOf(':') + 1);
        }
        function isMiddleTier() {
            return !(0, module.exports) && 'iFrameResize' in window || 'jQuery' in window && 'iFrameResize' in window.jQuery.prototype;
        }
        function isInitMsg() {
            // Test if this message is from a child below us. This is an ugly test, however, updating
            // the message format would break backwards compatibity.
            return event.data.split(':')[2] in {
                true: 1,
                false: 1
            };
        }
        function callFromParent() {
            var messageType = getMessageType();
            if (messageType in processRequestFromParent) processRequestFromParent[messageType]();
            else if (!isMiddleTier() && !isInitMsg()) warn('Unexpected message (' + event.data + ')');
        }
        function processMessage() {
            if (false === firstRun) callFromParent();
            else if (isInitMsg()) processRequestFromParent.init();
            else log('Ignored message of type "' + getMessageType() + '". Received before initialization.');
        }
        if (isMessageForUs()) processMessage();
    }
    // Normally the parent kicks things off when it detects the iFrame has loaded.
    // If this script is async-loaded, then tell parent page to retry init.
    function chkLateLoaded() {
        if ('loading' !== document.readyState) window.parent.postMessage('[iFrameResizerChild]Ready', '*');
    }
    addEventListener(window, 'message', receiver);
    addEventListener(window, 'readystatechange', chkLateLoaded);
    chkLateLoaded();
})();

});

parcelRegister("7KMPr", function(module, exports) {

var $lzcvT = parcelRequire("lzcvT");


var $ijfiP = parcelRequire("ijfiP");


var $kaOT1 = parcelRequire("kaOT1");

const $9de26c8889125530$var$packageVersion = "0.0.0-use.local";
const $9de26c8889125530$export$bb9823fd3fb51f9c = 'https://1210cfc4338849588134f2c80b99f75c@o55978.ingest.sentry.io/5988824';
const $9de26c8889125530$export$b7f7efe8cd791eed = 'https://a377d38318350e08236b26b7b13c8016@sentry.atlassian-us-gov-mod.com/23';

const $9de26c8889125530$export$faf06bc0661c564c = async ({ error: error, environment: environment, errorExtensionDetails: errorExtensionDetails, page: page, errorInfo: errorInfo, tracing: tracing })=>{
    try {
        const module = await Promise.resolve((parcelRequire("7hGsm")));
        const { BrowserClient: BrowserClient, Hub: Hub } = module;
        // From https://sentry.io/settings/atlassian-2y/projects/forge-ui/keys/ and https://sentry.prod.services.kitt-inf-us-gov-mod.net/settings/sentry/projects/forge-ui/keys
        const dsn = (0, $lzcvT.isFedRamp)() ? $9de26c8889125530$export$b7f7efe8cd791eed : $9de26c8889125530$export$bb9823fd3fb51f9c;
        const client = new BrowserClient({
            environment: environment,
            dsn: dsn,
            release: `forge-ui@${$9de26c8889125530$var$packageVersion}`
        });
        const hub = new Hub(client);
        hub.withScope(async (scope)=>{
            if (tracing) {
                const breadcrumbs = tracing.getBreadcrumbs();
                breadcrumbs.forEach((bc)=>scope.addBreadcrumb(bc, 20));
            }
            if (errorInfo) scope.setExtra('componentTrace', {
                errorInfo: errorInfo,
                componentStack: errorInfo?.componentStack?.substring(0, 1000)
            });
            scope.setTag('extensionPoint', page);
            if (errorExtensionDetails) {
                scope.setExtra('extensionProperties', errorExtensionDetails.properties);
                try {
                    const appIdFromId = (0, $ijfiP.parseExtensionId)(errorExtensionDetails.id ?? '').appId;
                    if (appIdFromId) scope.setTag('appId', appIdFromId);
                } catch (e) {
                // parseExtensionId() uses parse() form @atlassian/cs-ari, which throws an error if the ID is not valid
                }
                if (errorExtensionDetails.environmentType) scope.setTag('forgeEnvironment', errorExtensionDetails.environmentType);
                if (errorExtensionDetails.type) scope.setTag('extensionType', errorExtensionDetails.type);
                if (errorExtensionDetails.appOwnerAccountId) scope.setTag('appOwner', errorExtensionDetails.appOwnerAccountId);
            }
            hub.captureException(error);
        });
        return client.close();
    } catch (e) {
    // Error reporting failed, we don't want to cause a unhandledrejection event
    }
};
module.exports["captureAndReportError"] = $9de26c8889125530$export$faf06bc0661c564c;

});

parcelRegister("luNHV", function(module, exports) {
// This prefix is also used in ConfigPanelFieldsLoader.tsx in the
// @atlaskit/editor-plugin-extension package. The Editor package is public, so it
// cannot import this constant from @atlassian/forge-ui. Do not update this prefix
// without also doing so in the Editor package.
const $6d065658f7ab57e8$var$EVENT_PREFIX = 'forge.bridge.';
function $6d065658f7ab57e8$export$af631764ddc44097(event, callback, extension) {
    const wrappedCallback = (e)=>{
        if (!extension || !e.detail?.extension || extension.id === e.detail?.extension?.id && extension.installationId === e.detail?.extension?.installationId) callback(e.detail?.payload, e.detail?.extension);
    };
    window.document.addEventListener(`${$6d065658f7ab57e8$var$EVENT_PREFIX}${event}`, wrappedCallback);
    return {
        unsubscribe: ()=>window.document.removeEventListener(`${$6d065658f7ab57e8$var$EVENT_PREFIX}${event}`, wrappedCallback)
    };
}
function $6d065658f7ab57e8$export$8f35fbd5db0f3634(event, payload, extension) {
    const newEvent = new CustomEvent(`${$6d065658f7ab57e8$var$EVENT_PREFIX}${event}`, {
        detail: {
            extension: extension,
            payload: payload
        }
    });
    window.document.dispatchEvent(newEvent);
}
module.exports["on"] = $6d065658f7ab57e8$export$af631764ddc44097;
module.exports["emit"] = $6d065658f7ab57e8$export$8f35fbd5db0f3634;

});

parcelRegister("iqcSr", function(module, exports) {
const $017ffa7c15d62dd2$export$4c5241daa4566af8 = (extension, entryPoint)=>{
    const { render: render, resource: resource } = extension.properties;
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = extension.properties[entryPoint];
        return entryPointResource != null && entryPointRender !== 'native';
    }
    return resource != null && render !== 'native';
};
module.exports["isCustomUI"] = $017ffa7c15d62dd2$export$4c5241daa4566af8;

});

parcelRegister("fYGGr", function(module, exports) {

var $bsX2q = parcelRequire("bsX2q");

var $7zIsq = parcelRequire("7zIsq");


var $39Ajm = parcelRequire("39Ajm");

const $cf16612a3c00cd2e$export$f276dc1a7d0b17c5 = async ({ client: client, contextIds: contextIds, moduleType: moduleType, context: context, queryOptions: queryOptions, expandAppOwner: expandAppOwner, extensionsFilter: extensionsFilter, dataClassificationTagIds: dataClassificationTagIds, locale: locale, cloudId: cloudId, includeHidden: includeHidden, bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall = false })=>{
    if (bypassNewForgeExtensionListCall === false) {
        const types = moduleType ? [
            moduleType
        ] : [];
        const requestOptions = (0, $7zIsq.createUsePrefilteredExtensionListQueryOptions)(cloudId ?? contextIds[0], context ?? {}, client, types, locale, includeHidden, queryOptions, contextIds);
        const { fetchPolicy: fetchPolicy, ...rest } = requestOptions;
        const { loading: loading, data: data, errors: errors } = await client.query({
            ...rest,
            query: (0, $39Ajm.FetchPreFilteredForgeAppsQuery),
            fetchPolicy: fetchPolicy === 'cache-and-network' ? 'network-only' : fetchPolicy
        });
        const extensions = (0, $7zIsq.getPrefilteredExtensionsGQLResult)({
            loading: loading,
            data: data
        });
        return {
            extensions: extensions,
            errors: errors
        };
    } else {
        const requestOptions = (0, $bsX2q.createExtensionListQueryOptions)(client, contextIds, queryOptions, expandAppOwner, extensionsFilter, moduleType, dataClassificationTagIds, locale);
        const queryResult = await client.query(requestOptions);
        return {
            extensions: (0, $bsX2q.getExtensionsFromGQLResult)(queryResult),
            errors: queryResult.errors
        };
    }
};
module.exports["getForgeUIExtensionsAsync"] = $cf16612a3c00cd2e$export$f276dc1a7d0b17c5;

});

parcelRegister("kRUUL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hXuPC = parcelRequire("hXuPC");


$hXuPC.__exportStar((parcelRequire("5ExMm")), module.exports);

$hXuPC.__exportStar((parcelRequire("bJnpv")), module.exports);

$hXuPC.__exportStar((parcelRequire("fgfHi")), module.exports);

});

parcelRegister("5ExMm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EgressFilteringService = void 0;

var $bJnpv = parcelRequire("bJnpv");


var $fgfHi = parcelRequire("fgfHi");

class $41dae3f6a51269f4$var$EgressFilteringService {
    parseUrl(url) {
        return (0, $bJnpv.parseUrl)(url);
    }
    containsWildCardEgress() {
        return this.allowsEverything;
    }
    isValidUrl(url) {
        if (this.allowsEverything) return true;
        const parsedUrl = this.parseUrl(url);
        return this.allowedDomainExact(parsedUrl, this.URLs) || this.allowedDomainPattern(parsedUrl, this.wildcardDomains);
    }
    allowedDomainExact(domain, allowList) {
        return allowList.filter((allowed)=>allowed.protocol === domain.protocol).some((url)=>url.hostname === domain.hostname);
    }
    allowedDomainPattern(domain, allowList) {
        return allowList.filter((allowed)=>allowed.protocol === domain.protocol).some((pattern)=>pattern.regex.test(domain.hostname));
    }
    constructor(allowList){
        this.URLs = allowList.filter((domainOrURL)=>!domainOrURL.startsWith('*')).map((url)=>this.parseUrl(url));
        this.wildcardDomains = allowList.filter((domainOrURL)=>domainOrURL !== '*').map((url)=>this.parseUrl(url)).filter((url)=>decodeURIComponent(url.hostname).startsWith('*')).map((url)=>({
                ...url,
                regex: (0, $fgfHi.globToRegex)(decodeURIComponent(url.hostname))
            }));
        this.allowsEverything = allowList.includes('*');
    }
}
module.exports.EgressFilteringService = $41dae3f6a51269f4$var$EgressFilteringService;

});

parcelRegister("bJnpv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseUrl = void 0;
function $88a60e7f5ad1cf39$var$parseUrl(url) {
    var _a, _b;
    const protocol = (_b = (_a = url.match(/^(.*?:)/)) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : 'https:';
    const hostname = url.replace(protocol, '').replace(/^\/*/, '').replace(/^\\*/, '').split(/[\?\/]/)[0];
    return {
        protocol: protocol,
        hostname: hostname
    };
}
module.exports.parseUrl = $88a60e7f5ad1cf39$var$parseUrl;

});

parcelRegister("fgfHi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEgressesBasedOnToggles = module.exports.sortAndGroupEgressPermissionsByDomain = module.exports.EgressCategory = module.exports.EgressType = module.exports.globToRegex = void 0;

var $bJnpv = parcelRequire("bJnpv");

function $b1c486d357da07ae$var$globToRegex(pattern) {
    const escaped = pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&');
    const regexPattern = escaped.replace(/\*/g, '.*');
    return new RegExp(`^${regexPattern}$`);
}
module.exports.globToRegex = $b1c486d357da07ae$var$globToRegex;
const $b1c486d357da07ae$var$sortAndGroupEgressPermissionsByDomain = (egressAddresses)=>{
    if ((egressAddresses === null || egressAddresses === void 0 ? void 0 : egressAddresses.length) === 0) return [];
    const protocolRegex = /^(.*?:\/\/)/;
    const domains = new Set();
    const wildcardDomains = [];
    egressAddresses.forEach((item)=>{
        const itemWithProtocol = protocolRegex.test(item) ? item : `https://${item}`;
        const url = (0, $bJnpv.parseUrl)(itemWithProtocol);
        if (url.hostname.startsWith('*')) {
            domains.add(url.hostname.substring(2));
            wildcardDomains.push($b1c486d357da07ae$var$globToRegex(url.hostname));
        } else domains.add(url.hostname);
    });
    return [
        ...domains
    ].sort().reduce((grouped, domain)=>{
        if (!wildcardDomains.some((pattern)=>pattern.test(domain))) grouped.push(domain);
        return grouped;
    }, []);
};
module.exports.sortAndGroupEgressPermissionsByDomain = $b1c486d357da07ae$var$sortAndGroupEgressPermissionsByDomain;
var $b1c486d357da07ae$var$EgressType;
(function(EgressType) {
    EgressType["FetchBackendSide"] = "FETCH_BACKEND_SIDE";
    EgressType["FetchClientSide"] = "FETCH_CLIENT_SIDE";
    EgressType["Fonts"] = "FONTS";
    EgressType["Frames"] = "FRAMES";
    EgressType["Images"] = "IMAGES";
    EgressType["Media"] = "MEDIA";
    EgressType["Navigation"] = "NAVIGATION";
    EgressType["Scripts"] = "SCRIPTS";
    EgressType["Styles"] = "STYLES";
})($b1c486d357da07ae$var$EgressType = module.exports.EgressType || (module.exports.EgressType = {}));
var $b1c486d357da07ae$var$EgressCategory;
(function(EgressCategory) {
    EgressCategory["ANALYTICS"] = "ANALYTICS";
})($b1c486d357da07ae$var$EgressCategory = module.exports.EgressCategory || (module.exports.EgressCategory = {}));
const $b1c486d357da07ae$var$getEgressesBasedOnToggles = (input)=>{
    const filteredEgresses = input.egress.filter((egress)=>{
        var _a;
        if (((_a = egress.category) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === $b1c486d357da07ae$var$EgressCategory.ANALYTICS) {
            if (input.installationConfig) {
                const analyticsConfig = input.installationConfig.find((config)=>config.key.toUpperCase() === 'ALLOW_EGRESS_ANALYTICS');
                return (analyticsConfig === null || analyticsConfig === void 0 ? void 0 : analyticsConfig.value) !== false;
            } else return input.overrides.ALLOW_EGRESS_ANALYTICS !== false;
        }
        return true;
    });
    const egressByType = new Map();
    for (const egress of filteredEgresses){
        if (!egressByType.has(egress.type)) egressByType.set(egress.type, egress.addresses);
        egressByType.set(egress.type, [
            ...egressByType.get(egress.type),
            ...egress.addresses
        ]);
    }
    return [
        ...egressByType.entries()
    ].map(([type, egresses])=>({
            type: type,
            addresses: [
                ...new Set(egresses)
            ]
        }));
};
module.exports.getEgressesBasedOnToggles = $b1c486d357da07ae$var$getEgressesBasedOnToggles;

});

parcelRegister("CMcde", function(module, exports) {
/* loader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");

const $a7bb558f45760cd7$export$3b0d6d7590275603 = ()=>{
    return /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _y3gn1h6o _ca0qutpp _n3tdutpp _1bsb1osq"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
        testId: "forge-app-loading-spinner",
        size: "large"
    }));
};
module.exports["Loader"] = $a7bb558f45760cd7$export$3b0d6d7590275603;

});

parcelRegister("jc2GP", function(module, exports) {
const $45b69e870d2a465f$export$45b306f42e1402e5 = (extension)=>{
    const { properties: properties } = extension;
    if (properties?.layout === 'bodied') return 'bodiedExtension';
    else if (properties?.layout === 'inline') return 'inlineExtension';
    return 'extension';
};
module.exports["getExtensionType"] = $45b69e870d2a465f$export$45b306f42e1402e5;

});

parcelRegister("hAO4A", function(module, exports) {

let $cceca3ea4ceeeb63$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cceca3ea4ceeeb63$var$load("cjJTJ").then(()=>parcelRequire('hkbHJ'));

});

parcelRegister("2Jivw", function(module, exports) {

var $42omo = parcelRequire("42omo");








const $1dc316a623d24040$var$AKBadge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("6OBBH")));
function $1dc316a623d24040$var$Badge({ appearance: appearance = 'default', text: text }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1dc316a623d24040$var$AKBadge, {
        appearance: appearance
    }, text);
}
var $1dc316a623d24040$export$2e2bcd8739ae039 = $1dc316a623d24040$var$Badge;
function $1dc316a623d24040$export$c07d87ab1594bff4({ props: props }) {
    const { appearance: appearance, text: text } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1dc316a623d24040$var$Badge, {
        appearance: appearance,
        text: text
    });
}





const $708787c55cfee9c5$var$FULL_WIDTH_BUTTONS_BREAKPOINT_PX = 360;
const $708787c55cfee9c5$export$37ca8ef0f54b556e = (width)=>width > 0 && width < $708787c55cfee9c5$var$FULL_WIDTH_BUTTONS_BREAKPOINT_PX;



var $i2hng = parcelRequire("i2hng");




// *** GENERATED FILE - DO NOT EDIT ***
// WARNING: import needs to be statically analysable to not be problematic [at runtime]








































































































































































































































































































































































const $ccc53643ba31c9ca$export$6409a24d2c5a7539 = {
    // @ts-ignore UI Kit 1 is now unsupported
    activity: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hR6PJ"))),
    add: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dC6xb"))),
    'add-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("l1HVn"))),
    'add-item': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dmdbb"))),
    addon: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hqdtj"))),
    'app-access': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hePgN"))),
    'app-switcher': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lM9VV"))),
    archive: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aOJ8u"))),
    'arrow-down': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1z0H8"))),
    'arrow-down-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gOTB4"))),
    'arrow-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("39VYB"))),
    'arrow-left-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("88S5Q"))),
    'arrow-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iTETO"))),
    'arrow-right-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hAPFi"))),
    'arrow-up': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gsmWv"))),
    'arrow-up-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jR3I4"))),
    attachment: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fIlIv"))),
    audio: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4ZwDS"))),
    'audio-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gP79k"))),
    backlog: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1vytV"))),
    // @ts-ignore UI Kit 1 is now unsupported
    billing: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cviev"))),
    'billing-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jMSX1"))),
    'bitbucket-branches': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ebf5H"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'bitbucket-builds': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2OYVW"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'bitbucket-clone': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lfhly"))),
    'bitbucket-commits': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1XK9X"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'bitbucket-compare': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2dBoI"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'bitbucket-forks': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("99CSU"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'bitbucket-output': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("g7Tsp"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'bitbucket-pipelines': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("k12Jn"))),
    'bitbucket-pullrequests': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("b4fvU"))),
    'bitbucket-repos': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("e4CKa"))),
    'bitbucket-snippets': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jzHH4"))),
    'bitbucket-source': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("j9rtJ"))),
    board: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2fxn7"))),
    book: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hODzF"))),
    'bullet-list': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8xSHH"))),
    calendar: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7b9Jb"))),
    'calendar-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4CTwO"))),
    camera: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cIPG7"))),
    'camera-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bbeuj"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'camera-rotate': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hCgUy"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'camera-take-picture': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aFoGZ"))),
    // @ts-ignore UI Kit 1 is now unsupported
    canvas: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("zst8C"))),
    check: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2srJR"))),
    'check-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dwH8A"))),
    'check-circle-outline': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cjTfC"))),
    checkbox: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bMdLQ"))),
    'checkbox-indeterminate': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7j8Tl"))),
    'chevron-down': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dvRoc"))),
    'chevron-down-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2nzoX"))),
    'chevron-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kY2rX"))),
    'chevron-left-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("amqTW"))),
    'chevron-left-large': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aVQLr"))),
    'chevron-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3JA2m"))),
    'chevron-right-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jifNn"))),
    'chevron-right-large': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("964w3"))),
    'chevron-up': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kcDAL"))),
    'chevron-up-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iEWAq"))),
    'child-issues': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("J3tuK"))),
    code: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hq1qR"))),
    comment: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fIqeU"))),
    component: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7QEbW"))),
    copy: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eMYmr"))),
    creditcard: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7tteH"))),
    'creditcard-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bDOuB"))),
    cross: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("38ubZ"))),
    'cross-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("mno1u"))),
    dashboard: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("j1awj"))),
    decision: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kzaD2"))),
    department: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("h9SBZ"))),
    'detail-view': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kA6Oh"))),
    discover: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("73ji6"))),
    'discover-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9espj"))),
    document: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eheOI"))),
    'document-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hRobx"))),
    documents: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4tNhi"))),
    download: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9btog"))),
    'drag-handler': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("a3XEq"))),
    // @ts-ignore UI Kit 1 is now unsupported
    dropbox: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jgcu2"))),
    edit: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("efWml"))),
    'edit-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cGYRn"))),
    'editor-add': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6KbnA"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'editor-addon': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9wNwY"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'editor-advanced': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("a0P6w"))),
    'editor-align-center': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9ycXh"))),
    'editor-align-image-center': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3luMr"))),
    'editor-align-image-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iVyEQ"))),
    'editor-align-image-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5Hc7r"))),
    'editor-align-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jVl3O"))),
    'editor-align-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3pZ62"))),
    'editor-attachment': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gbZIQ"))),
    'editor-background-color': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1qokz"))),
    'editor-bold': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dJxgB"))),
    'editor-bullet-list': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7W0Vz"))),
    'editor-close': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3B5om"))),
    'editor-code': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("c04Yt"))),
    'editor-collapse': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eByCW"))),
    'editor-date': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eCGhk"))),
    'editor-decision': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dWWRT"))),
    'editor-divider': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hSDBt"))),
    'editor-done': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1RnbY"))),
    'editor-edit': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aOrXc"))),
    'editor-emoji': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("45w5X"))),
    'editor-error': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("klhw9"))),
    'editor-expand': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gfKb7"))),
    'editor-feedback': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fpk9k"))),
    'editor-file': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("buqwa"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'editor-file-preview': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("L6p80"))),
    'editor-help': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7ftFc"))),
    'editor-hint': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("a2FUj"))),
    'editor-horizontal-rule': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fQTfl"))),
    'editor-image': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9YoNL"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'editor-image-border': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("05j0s"))),
    'editor-image-resize': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jSdVw"))),
    'editor-indent': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8Cm29"))),
    'editor-info': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("f6kYs"))),
    'editor-italic': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("g47Q7"))),
    'editor-layout-single': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("clMi6"))),
    'editor-layout-three-equal': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ePuor"))),
    'editor-layout-three-with-sidebars': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2pEHb"))),
    'editor-layout-two-equal': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("khqhV"))),
    'editor-layout-two-left-sidebar': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5bLIn"))),
    'editor-layout-two-right-sidebar': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6S4t2"))),
    'editor-link': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aEQsV"))),
    'editor-media-center': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aRaOJ"))),
    'editor-media-full-width': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4pjtl"))),
    'editor-media-wide': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2MjY4"))),
    'editor-media-wrap-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("awNW8"))),
    'editor-media-wrap-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lFoqY"))),
    'editor-mention': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("luSCR"))),
    'editor-more': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iRkfA"))),
    'editor-note': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5fiKg"))),
    'editor-number-list': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("49VGi"))),
    'editor-open': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("Ww4SE"))),
    'editor-outdent': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lHYlB"))),
    'editor-panel': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jE1Ny"))),
    'editor-photo': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gQWHK"))),
    'editor-quote': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("84dCx"))),
    'editor-recent': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lxzyu"))),
    'editor-redo': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3EkzP"))),
    'editor-remove': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jTzoC"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'editor-remove-emoji': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eUTRn"))),
    'editor-search': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("b4jvo"))),
    'editor-settings': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9iUtD"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'editor-strikethrough': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("btq5i"))),
    'editor-success': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dbque"))),
    'editor-table': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aqQGa"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'editor-table-display-options': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iYr5w"))),
    'editor-task': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("k8Qz7"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'editor-text-color': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8e8xH"))),
    'editor-text-style': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2Ua5l"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'editor-underline': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eI4RG"))),
    'editor-undo': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cMHFe"))),
    'editor-unlink': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7V0QM"))),
    'editor-warning': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("apyBI"))),
    email: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eIiHy"))),
    emoji: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("e6UDC"))),
    'emoji-add': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4Sdps"))),
    'emoji-activity': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lrt6E"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'emoji-atlassian': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("51eYZ"))),
    'emoji-custom': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hJZBx"))),
    'emoji-emoji': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3uU0n"))),
    'emoji-flags': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("blLgP"))),
    'emoji-food': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kUFGD"))),
    'emoji-frequent': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2m1kb"))),
    'emoji-keyboard': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("VM0ZU"))),
    'emoji-nature': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bWocZ"))),
    'emoji-objects': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8DUC2"))),
    'emoji-people': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gH7uE"))),
    'emoji-productivity': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iiP0D"))),
    'emoji-symbols': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lo0FS"))),
    'emoji-travel': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("k8GiV"))),
    error: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1ZKpk"))),
    export: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6DU2F"))),
    feedback: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1jMYO"))),
    file: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5Dpm8"))),
    filter: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cvTzJ"))),
    'flag-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6or9j"))),
    folder: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lCkm6"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'folder-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dKKbb"))),
    followers: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gcsah"))),
    // @ts-ignore UI Kit 1 is now unsupported
    following: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9OJ2O"))),
    // @ts-ignore UI Kit 1 is now unsupported
    googledrive: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5ZZrc"))),
    'graph-bar': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bsBpI"))),
    'graph-line': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cBuni"))),
    // @ts-ignore UI Kit 1 is now unsupported
    gsuite: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2J7iA"))),
    // @ts-ignore UI Kit 1 is now unsupported
    highlights: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("77NdO"))),
    'hipchat-audio-only': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bPJCW"))),
    'hipchat-chevron-double-down': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("31uxZ"))),
    'hipchat-chevron-double-up': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4O5jI"))),
    'hipchat-chevron-down': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9TNEo"))),
    'hipchat-chevron-up': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("30QTS"))),
    'hipchat-dial-out': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("d8ht4"))),
    'hipchat-lobby': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bOeBu"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'hipchat-media-attachment-count': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("81y2K"))),
    'hipchat-outgoing-sound': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jQSKc"))),
    'hipchat-sd-video': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("j9lu1"))),
    home: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("39CX7"))),
    'home-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("daSLP"))),
    image: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kj7xK"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'image-border': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2tNba"))),
    'image-resize': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("XPI8H"))),
    info: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gjQhw"))),
    'invite-team': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9khkZ"))),
    issue: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3Wbgn"))),
    'issue-raise': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5yfOO"))),
    issues: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("b6XEm"))),
    'jira-capture': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("KRJU9"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'jira-failed-build-status': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5ufZi"))),
    'jira-labs': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8V5LC"))),
    'jira-test-session': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lqtml"))),
    label: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2Wwhr"))),
    lightbulb: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("e2Q9l"))),
    'lightbulb-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gDpHC"))),
    like: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7go8k"))),
    link: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jIOax"))),
    'link-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kr3bo"))),
    // @ts-ignore UI Kit 1 is now unsupported
    list: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2i5H8"))),
    location: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("79iWF"))),
    lock: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("j8ZNs"))),
    'lock-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bOwxO"))),
    'lock-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3ivMi"))),
    marketplace: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aZaIv"))),
    'media-services-actual-size': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dpVnI"))),
    'media-services-add-comment': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1tZnn"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'media-services-annotate': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9bbst"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'media-services-arrow': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7JjMa"))),
    'media-services-audio': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dcgXf"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'media-services-blur': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("a8uWi"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'media-services-brush': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("h0cX5"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'media-services-button-option': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cPIK5"))),
    'media-services-code': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ixaLP"))),
    'media-services-document': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8yoML"))),
    'media-services-filter': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lYoEY"))),
    'media-services-fit-to-page': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("j5A1r"))),
    'media-services-full-screen': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5MBn9"))),
    'media-services-grid': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cb3Lj"))),
    'media-services-image': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1ubwJ"))),
    'media-services-line': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hOKHE"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'media-services-line-thickness': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gthbx"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'media-services-no-image': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9974f"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'media-services-open-mediaviewer': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1lThz"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'media-services-oval': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cZC9E"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'media-services-pdf': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1mSPh"))),
    'media-services-preselected': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9mUtj"))),
    'media-services-presentation': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("f7ISB"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'media-services-rectangle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("EbKPS"))),
    'media-services-scale-large': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8kOsA"))),
    'media-services-scale-small': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eAyWm"))),
    'media-services-spreadsheet': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("d9nUt"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'media-services-text': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("btFwi"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'media-services-unknown': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4krpA"))),
    'media-services-video': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hZaDl"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'media-services-zip': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1zJUD"))),
    'media-services-zoom-in': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iIMmz"))),
    'media-services-zoom-out': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eMmwT"))),
    // @ts-ignore UI Kit 1 is now unsupported
    mention: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9G3SL"))),
    menu: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8stkn"))),
    'menu-expand': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2m9He"))),
    mobile: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ltxhg"))),
    more: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cOdMJ"))),
    'more-vertical': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4dg2p"))),
    notification: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6J2Sn"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'notification-all': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("YAoD4"))),
    'notification-direct': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("matJm"))),
    'office-building': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hjOwT"))),
    'office-building-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("arLS1"))),
    open: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gFvhr"))),
    overview: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2RcFm"))),
    page: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hYVZR"))),
    'page-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("evwy5"))),
    // @ts-ignore UI Kit 1 is now unsupported
    pdf: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9lXmM"))),
    people: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("etVgP"))),
    'people-group': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ctkLN"))),
    person: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gw31F"))),
    'person-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("35Ray"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'person-with-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lmYEP"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'person-with-cross': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dadmB"))),
    'person-with-tick': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fCb3J"))),
    // @ts-ignore UI Kit 1 is now unsupported
    portfolio: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fXo5h"))),
    preferences: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("schya"))),
    premium: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3nJAu"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'presence-active': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2YYOI"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'presence-busy': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("avHGQ"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'presence-unavailable': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6VxbR"))),
    question: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5PuGi"))),
    'question-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5zfGK"))),
    questions: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cwUD9"))),
    queues: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("k4Sa0"))),
    quote: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hDL78"))),
    radio: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("0tmcS"))),
    recent: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("is8pI"))),
    redo: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gwR2Y"))),
    refresh: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("f7j8T"))),
    retry: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lOjXt"))),
    roadmap: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aPC7f"))),
    'room-menu': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eUzDD"))),
    schedule: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9JZS8"))),
    'schedule-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dZOLy"))),
    screen: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jSIHw"))),
    search: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6e2Bk"))),
    'select-clear': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("f88Ac"))),
    send: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4yCwN"))),
    settings: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("19Gs0"))),
    share: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("YtPOn"))),
    ship: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cpuWo"))),
    shortcut: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jNCHZ"))),
    'sign-in': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5LjxN"))),
    'sign-out': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2wRpI"))),
    sprint: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4nlya"))),
    star: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("khrNE"))),
    'star-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("epS2U"))),
    'star-large': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4pIdf"))),
    // @ts-ignore UI Kit 1 is now unsupported
    status: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lYCLL"))),
    stopwatch: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4xFp0"))),
    subtask: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9akcO"))),
    suitcase: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ibF6V"))),
    switcher: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2qLto"))),
    table: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8c8xN"))),
    task: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9T5Ga"))),
    teams: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7A2yi"))),
    trash: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9nYlG"))),
    tray: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kP3Ak"))),
    undo: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("69CG1"))),
    unlink: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8C8i1"))),
    unlock: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8pv0y"))),
    'unlock-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2FLeD"))),
    'unlock-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jGAhZ"))),
    upload: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("78mD0"))),
    'user-avatar-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4wQ7A"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'vid-audio-muted': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dfqU4"))),
    'vid-audio-on': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eCuOW"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'vid-backward': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kXBau"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'vid-camera-off': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4g2LT"))),
    'vid-camera-on': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iw61s"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'vid-connection-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("epXVg"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'vid-forward': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("l2K9z"))),
    'vid-full-screen-off': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("av9CY"))),
    'vid-full-screen-on': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fw4FO"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'vid-hang-up': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hY1Sf"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'vid-hd-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eqf57"))),
    'vid-pause': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kZddz"))),
    'vid-play': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("i2Pmz"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'vid-raised-hand': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("27sKA"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'vid-share-screen': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aiNXK"))),
    // @ts-ignore UI Kit 1 is now unsupported
    'vid-speaking-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2oPij"))),
    'vid-volume-full': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("PF89G"))),
    'vid-volume-half': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2XqY1"))),
    'vid-volume-muted': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("f7f30"))),
    'video-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9LJJJ"))),
    'video-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hWFXV"))),
    warning: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lkwxc"))),
    watch: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("g0b0z"))),
    'watch-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6e7Vd"))),
    world: /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("28wrY"))),
    'world-small': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("h5Y78")))
};



var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");

const $1b8625d40649a1e3$var$Icon = ({ size: size = 'medium', glyph: glyph })=>{
    const Component = (0, $ccc53643ba31c9ca$export$6409a24d2c5a7539)[glyph];
    const intl = (0, $8C5kA.default)();
    if (!Component) return null;
     // do nothing
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, // @ts-ignore Jira only - TS2322: Type '{ label: string; size: "small" | "medium" | "large"; }' is not assignable to type 'IntrinsicAttributes'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
        label: intl.formatMessage($1b8625d40649a1e3$var$messages.icon),
        size: size
    }));
};
var $1b8625d40649a1e3$export$2e2bcd8739ae039 = $1b8625d40649a1e3$var$Icon;
function $1b8625d40649a1e3$export$af44fe23e87e9bd7({ props: props }) {
    const { glyph: glyph, size: size } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1b8625d40649a1e3$var$Icon, {
        glyph: glyph,
        size: size
    });
}
const $1b8625d40649a1e3$var$messages = (0, $cgtv4.defineMessages)({
    icon: {
        id: "confluence.icon.label",
        defaultMessage: "Icon"
    }
});



const $a42d48f6837420c9$export$8471a7693ebd6f54 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("6fHGT")));
function $a42d48f6837420c9$export$ea18c227d4417cc3({ forgeDoc: forgeDoc, dispatch: dispatch }) {
    const { props: { appearance: appearance = 'default', text: text, disabled: disabled, onClick: onClick, icon: icon, iconPosition: iconPosition = 'before' } = {} } = forgeDoc;
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const handleClick = async ()=>{
        setLoading(true);
        try {
            await dispatch({
                type: 'event',
                handler: onClick,
                args: [],
                extensionData: {}
            });
        } finally{
            setLoading(false);
        }
    };
    let iconDom;
    if (icon) iconDom = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1b8625d40649a1e3$export$2e2bcd8739ae039), {
        size: "medium",
        glyph: icon
    });
    const iconBefore = iconPosition === 'before' ? iconDom : undefined;
    const iconAfter = iconPosition === 'after' ? iconDom : undefined;
    const width = (0, $42omo.useContext)((0, $i2hng.WidthContext));
    let shouldFitContainer = (0, $708787c55cfee9c5$export$37ca8ef0f54b556e)(width);
    return {
        akButtonProps: {
            shouldFitContainer: shouldFitContainer,
            iconBefore: iconBefore,
            iconAfter: iconAfter,
            isLoading: loading,
            isDisabled: disabled,
            appearance: appearance,
            onClick: handleClick,
            children: text
        }
    };
}
function $a42d48f6837420c9$export$353f5b6fc5456de1(props) {
    const { akButtonProps: akButtonProps } = $a42d48f6837420c9$export$ea18c227d4417cc3(props);
    const { shouldFitContainer: shouldFitContainer, iconBefore: iconBefore, iconAfter: iconAfter, isLoading: isLoading, isDisabled: isDisabled, appearance: appearance, onClick: onClick, children: children } = akButtonProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a42d48f6837420c9$export$8471a7693ebd6f54, {
        shouldFitContainer: shouldFitContainer,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isLoading: isLoading,
        isDisabled: isDisabled,
        appearance: appearance,
        onClick: onClick
    }, children);
}
function $a42d48f6837420c9$export$fdac0c774aedd7f7({ forgeDoc: forgeDoc, dispatch: dispatch }) {
    const [loading, setLoading] = (0, $42omo.useState)(forgeDoc.map(()=>false));
    const width = (0, $42omo.useContext)((0, $i2hng.WidthContext));
    const shouldFitContainer = (0, $708787c55cfee9c5$export$37ca8ef0f54b556e)(width);
    const actionButtons = forgeDoc.map((actionButtonForgeDoc, index)=>{
        const { props: { appearance: appearance = 'subtle', text: text, disabled: disabled, onClick: onClick, icon: icon, iconPosition: iconPosition = 'before' } = {} } = actionButtonForgeDoc;
        const handleClick = async ()=>{
            setLoading(loading.map((l, i)=>{
                if (i === index) return true;
                return l;
            }));
            try {
                await dispatch({
                    type: 'event',
                    handler: onClick,
                    args: [],
                    extensionData: {}
                });
            } finally{
                setLoading(loading.map((l, i)=>{
                    if (i === index) return false;
                    return l;
                }));
            }
        };
        let iconDom;
        if (icon) iconDom = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1b8625d40649a1e3$export$2e2bcd8739ae039), {
            size: "medium",
            glyph: icon
        });
        const iconBefore = iconPosition === 'before' ? iconDom : undefined;
        const iconAfter = iconPosition === 'after' ? iconDom : undefined;
        return {
            shouldFitContainer: shouldFitContainer,
            iconBefore: iconBefore,
            iconAfter: iconAfter,
            isLoading: loading[index],
            isDisabled: disabled,
            appearance: appearance,
            onClick: handleClick,
            children: text
        };
    });
    return {
        akActionButtonProps: actionButtons
    };
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

parcelRequire("42omo");

function $5ff27bb82b284c52$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $5ff27bb82b284c52$var$_ref = {
    name: "o9i2zm",
    styles: "display:flex;flex-wrap:wrap;> *{margin-top:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);}margin-top:var(--ds-space-negative-100, -8px);margin-right:var(--ds-space-negative-100, -8px)"
};
const $5ff27bb82b284c52$export$87e672a75327e04b = ({ children: children })=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: $5ff27bb82b284c52$var$_ref
    }, children);
const $5ff27bb82b284c52$export$1ff560ec9540c1a9 = ({ children: children, dispatch: dispatch, Components: Components, render: render, renderChildren: renderChildren })=>/*#__PURE__*/ (0, $9K4OG.jsx)($5ff27bb82b284c52$export$87e672a75327e04b, null, renderChildren({
        children: children,
        dispatch: dispatch,
        Components: Components,
        render: render
    }));


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766















const $8718f926ed0b80e1$var$isOptionData = (value)=>typeof value === 'object' && value.hasOwnProperty('value');
const $8718f926ed0b80e1$var$isUserData = (value)=>typeof value === 'object' && value.hasOwnProperty('id') && value.hasOwnProperty('name') && value.hasOwnProperty('avatarUrl');
const $8718f926ed0b80e1$export$1a3c135ac4585aa9 = (value)=>{
    if ($8718f926ed0b80e1$var$isOptionData(value)) return value.value;
    else if ($8718f926ed0b80e1$var$isUserData(value) && value.type === 'user') return value.id;
    return value;
};
const $8718f926ed0b80e1$export$d1360584b6d92fb7 = (formData)=>Object.entries(formData).reduce((transformedData, [key, value])=>{
        return {
            ...transformedData,
            [key]: Array.isArray(value) ? value.map($8718f926ed0b80e1$export$1a3c135ac4585aa9) : $8718f926ed0b80e1$export$1a3c135ac4585aa9(value)
        };
    }, {});



var $cwXs1 = parcelRequire("cwXs1");

const $0496a86bf4ff1a05$export$6a54433420868a45 = (0, $cwXs1.default)({
    key: 'ui-kit-css'
});



const $051f12b2e6795f2a$export$117438e17b246db9 = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.default
        })));

const $051f12b2e6795f2a$export$bbe730ec239dd31a = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.FormFooter
        })));

const $051f12b2e6795f2a$export$c0511946385c3887 = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.Field
        })));
const $051f12b2e6795f2a$export$2127b0e8511224d0 = (auxElement)=>auxElement.key && auxElement.key.startsWith('actionButton');
function $051f12b2e6795f2a$export$87c0cf8eb5a167e0({ forgeDoc: forgeDoc, dispatch: dispatch, render: render }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { props: { submitButtonText: submitButtonText = formatMessage($051f12b2e6795f2a$export$defe85febe8b728c.forgeFormSubmitButtonText), onSubmit: onSubmit, submitButtonAppearance: submitButtonAppearance = 'default' } = {} } = forgeDoc;
    const [loading, setLoading] = (0, $42omo.useState)(false);
    /**
   * Toggle the Form's React key to remount the component for clearing fields
   * Using the formProps' reset() would trigger our custom form validation for isRequired on some fields
   */ const [formKey, setFormKey] = (0, $42omo.useState)(0);
    const onSubmitHandler = async (formData)=>{
        setLoading(true);
        try {
            await dispatch({
                type: 'event',
                extensionData: {},
                handler: onSubmit,
                args: [
                    (0, $8718f926ed0b80e1$export$d1360584b6d92fb7)(formData)
                ]
            });
            setFormKey(Number(!formKey));
        } finally{
            setLoading(false);
        }
    };
    const akSubmitButtonProps = {
        ...(0, $a42d48f6837420c9$export$ea18c227d4417cc3)({
            forgeDoc: {
                type: 'Button',
                props: {
                    text: submitButtonText,
                    appearance: submitButtonAppearance
                },
                children: []
            },
            dispatch: dispatch,
            render: render
        }).akButtonProps,
        onClick: undefined,
        type: 'submit',
        isLoading: loading
    };
    const children = forgeDoc.children.filter((x)=>!$051f12b2e6795f2a$export$2127b0e8511224d0(x));
    const actions = forgeDoc.children.filter($051f12b2e6795f2a$export$2127b0e8511224d0).map((actionButton)=>({
            ...actionButton,
            props: {
                ...actionButton.props,
                appearance: 'subtle'
            }
        }));
    return {
        akFormProps: {
            key: formKey,
            onSubmit: onSubmitHandler,
            children: ()=>{
                throw Error('@atlassian/forge-ui: Invalid composition of UI Kit useForm and Atlaskit Form');
            }
        },
        akSubmitButtonProps: akSubmitButtonProps,
        htmlFormProps: {
            // @ts-ignore
            'data-testid': 'form',
            className: (0, $0496a86bf4ff1a05$export$6a54433420868a45).css`
        width: 100%;
        margin-top: 0;
        > *:not(footer) {
          margin-top: 0;
        }
        > *:not(:last-child) {
          margin-bottom: ${"var(--ds-space-100, 8px)"};
        }
        ${children.length === 0 ? `
            > footer {
              margin-top: 0;
            }
            ` : ''}
      `
        },
        akFormFooterProps: {
            align: 'start'
        },
        children: children.map(render),
        actions: actions.length > 0 ? actions.map(render) : null
    };
}
const $051f12b2e6795f2a$export$c24727297075ec6a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
const $051f12b2e6795f2a$export$56c425463976216f = ({ name: name, value: value })=>{
    const formContext = (0, $42omo.useContext)($051f12b2e6795f2a$export$c24727297075ec6a);
    (0, $42omo.useEffect)(()=>{
        formContext?.setFormValue(name, value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        name,
        Array.isArray(value) ? value.join() : value
    ]);
    return null;
};
function $051f12b2e6795f2a$export$a7fed597f4b8afd8(props) {
    const { actions: actions, akFormFooterProps: akFormFooterProps, akFormProps: akFormProps, akSubmitButtonProps: akSubmitButtonProps, children: children, htmlFormProps: htmlFormProps } = $051f12b2e6795f2a$export$87c0cf8eb5a167e0(props);
    const { shouldFitContainer: shouldFitContainer, iconBefore: iconBefore, iconAfter: iconAfter, isLoading: loading, isDisabled: disabled, appearance: appearance, onClick: onClick, type: type, children: buttonChildren } = akSubmitButtonProps;
    const { align: align } = akFormFooterProps;
    const { key: key, onSubmit: onSubmit } = akFormProps;
    // @ts-ignore Ignoring the fact that "data-testid" is not part of the declared type
    const { className: className, 'data-testid': dataTestId } = htmlFormProps;
    const [formValues, setFormValues] = (0, $42omo.useState)({});
    const setFormValue = (name, value)=>{
        setFormValues((prevState)=>({
                ...prevState,
                [name]: value
            }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($051f12b2e6795f2a$export$117438e17b246db9, {
        key: key,
        onSubmit: onSubmit
    }, ({ formProps: formProps })=>{
        const { onSubmit: onSubmit, onKeyDown: onKeyDown, ref: ref } = formProps;
        return(// eslint-disable-next-line @atlassian/a11y/no-noninteractive-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("form", {
            onSubmit: onSubmit,
            onKeyDown: onKeyDown,
            ref: ref,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": dataTestId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($051f12b2e6795f2a$export$c24727297075ec6a.Provider, {
            value: {
                formValues: formValues,
                setFormValue: setFormValue
            }
        }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($051f12b2e6795f2a$export$bbe730ec239dd31a, {
            align: align
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5ff27bb82b284c52$export$87e672a75327e04b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a42d48f6837420c9$export$8471a7693ebd6f54), {
            shouldFitContainer: shouldFitContainer,
            iconBefore: iconBefore,
            iconAfter: iconAfter,
            isLoading: loading,
            isDisabled: disabled,
            appearance: appearance,
            onClick: onClick,
            type: type
        }, buttonChildren), actions))));
    });
}
const $051f12b2e6795f2a$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    forgeFormSubmitButtonText: {
        id: "forge-ui.form.submit-button.text",
        defaultMessage: "Submit"
    }
});


function $7d448eb063ac9d6b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7d448eb063ac9d6b$var$styles = {
    name: "1l4ndn6",
    styles: "line-height:20px"
};

const $7d448eb063ac9d6b$var$AKCheckbox = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("iqGOe")).then((module)=>({
            default: module.Checkbox
        })));

const $7d448eb063ac9d6b$var$AKCheckboxField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.CheckboxField
        })));

const $7d448eb063ac9d6b$var$Fieldset = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.Fieldset
        })));

const $7d448eb063ac9d6b$var$AKHelperMessage = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.HelperMessage
        })));
const $7d448eb063ac9d6b$export$4aa08d5625cb8ead = ({ options: options, label: label, name: name, description: description })=>{
    const defaultValues = [];
    options.forEach((option)=>{
        if (option.defaultChecked) defaultValues.push(option.value);
    });
    const [checkboxFieldValues, setCheckboxFieldValues] = (0, $42omo.useState)(defaultValues);
    return /*#__PURE__*/ (0, $9K4OG.jsx)($7d448eb063ac9d6b$var$Fieldset, {
        legend: label
    }, description && /*#__PURE__*/ (0, $9K4OG.jsx)($7d448eb063ac9d6b$var$AKHelperMessage, null, description), options.map((option)=>{
        const { key: key, label: label, value: value, defaultChecked: defaultChecked, isRequired: isRequired } = option;
        return /*#__PURE__*/ (0, $9K4OG.jsx)($7d448eb063ac9d6b$var$AKCheckboxField, {
            key: key,
            value: value,
            defaultIsChecked: defaultChecked,
            name: name
        }, ({ fieldProps: fieldProps })=>{
            const { id: id, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, name: name, 'aria-invalid': ariaInvalid, 'aria-labelledby': ariaLabelledBy, isChecked: isChecked } = fieldProps;
            return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: $7d448eb063ac9d6b$var$styles
            }, /*#__PURE__*/ (0, $9K4OG.jsx)($7d448eb063ac9d6b$var$AKCheckbox, {
                id: id,
                isChecked: isChecked,
                isDisabled: isDisabled,
                isInvalid: isInvalid,
                isRequired: isRequired,
                onBlur: onBlur,
                onFocus: onFocus,
                value: value,
                name: name,
                label: label,
                onChange: (e)=>{
                    if (e.target.checked) setCheckboxFieldValues((prevState)=>[
                            ...prevState,
                            value
                        ]);
                    else setCheckboxFieldValues(checkboxFieldValues.filter((e)=>e !== value));
                    return onChange(e);
                },
                "aria-invalid": ariaInvalid,
                "aria-labelledby": ariaLabelledBy
            }));
        });
    }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $051f12b2e6795f2a$export$56c425463976216f), {
        name: name,
        value: checkboxFieldValues
    }));
};
const $7d448eb063ac9d6b$export$b78851756f45833b = ({ props: propsAny, children: children })=>{
    const { name: name, description: description } = propsAny;
    const props = propsAny;
    // NOTE: legend is deprecated
    const label = 'legend' in props ? props.legend : props.label;
    const options = children.filter(({ type: type })=>type === 'Checkbox').map((child)=>{
        const { key: key, props: props } = child;
        const { label: label, value: value, defaultChecked: defaultChecked, isRequired: isRequired } = props;
        return {
            key: key,
            label: label,
            value: value,
            defaultChecked: defaultChecked,
            isRequired: isRequired
        };
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)($7d448eb063ac9d6b$export$4aa08d5625cb8ead, {
        label: label,
        name: name,
        options: options,
        description: description
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766







var $9UyM5 = parcelRequire("9UyM5");

function $16e3655ad2cab112$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $16e3655ad2cab112$var$styles = {
    name: "h0cvw5",
    styles: "width:'100%'"
};

const $16e3655ad2cab112$var$AKCodeBlock = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("43ZQt")).then((module)=>({
            AkCode: module.Code,
            AkCodeBlock: module.CodeBlock
        })).then((module)=>({
            default: module.AkCodeBlock
        })));

const $16e3655ad2cab112$var$AKCodeInline = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("43ZQt")).then((module)=>({
            AkCode: module.Code,
            AkCodeBlock: module.CodeBlock
        })).then((module)=>({
            default: module.AkCode
        })));
const $16e3655ad2cab112$var$Code = ({ text: text, language: language = 'text', showLineNumbers: showLineNumbers = true })=>{
    const { inline: inline } = (0, $9UyM5.useInlineContext)();
    return inline ? /*#__PURE__*/ (0, $9K4OG.jsx)($16e3655ad2cab112$var$AKCodeInline, null, text) : /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $16e3655ad2cab112$var$styles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($16e3655ad2cab112$var$AKCodeBlock, {
        text: text,
        language: language,
        showLineNumbers: showLineNumbers
    }));
};
var $16e3655ad2cab112$export$2e2bcd8739ae039 = $16e3655ad2cab112$var$Code;
const $16e3655ad2cab112$export$9f067e9ed3ed058 = ({ props: props })=>{
    const { text: text, language: language, showLineNumbers: showLineNumbers } = props;
    return /*#__PURE__*/ (0, $9K4OG.jsx)($16e3655ad2cab112$var$Code, {
        text: text,
        language: language,
        showLineNumbers: showLineNumbers
    });
};






const $b3d700e86f5ab7b3$var$AkDateLozenge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("icwLg")).then((module)=>({
            default: module.Date
        })));
const $b3d700e86f5ab7b3$var$DateLozenge = ({ value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3d700e86f5ab7b3$var$AkDateLozenge, {
        value: value
    });
var $b3d700e86f5ab7b3$export$2e2bcd8739ae039 = $b3d700e86f5ab7b3$var$DateLozenge;
const $b3d700e86f5ab7b3$export$607d2293d1fe73f9 = ({ props: props })=>{
    const { value: value } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3d700e86f5ab7b3$var$DateLozenge, {
        value: value
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766







/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766




var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $3d18012f6ad4f2f5$var$boxStyles = (0, $ecnYn.xcss)({
    maxWidth: '100%',
    width: '320px'
});
const $3d18012f6ad4f2f5$export$b5c4b0e7cd7f148b = (props)=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $3d18012f6ad4f2f5$var$boxStyles
    }, props.children);
};



const $a50e7fe929d36a1e$var$AKDatePicker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("cTiNr")).then((module)=>({
            default: module.DatePicker
        })));

const $a50e7fe929d36a1e$var$AKField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.Field
        })));

const $a50e7fe929d36a1e$var$AKHelperMessage = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.HelperMessage
        })));

const $a50e7fe929d36a1e$var$AKErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.ErrorMessage
        })));
const $a50e7fe929d36a1e$var$validate = (value)=>!value ? 'EMPTY' : undefined;
const $a50e7fe929d36a1e$export$fa96065c64444af6 = (locale)=>{
    const formatObj = new Intl.DateTimeFormat(locale).formatToParts(new Date());
    return formatObj.map((obj)=>{
        switch(obj.type){
            case 'day':
                return 'DD';
            case 'month':
                return 'MM';
            case 'year':
                return 'YYYY';
            default:
                return obj.value;
        }
    }).join('');
};
const $a50e7fe929d36a1e$var$DatePicker = ({ name: name, label: label, description: description, placeholder: placeholder, defaultValue: defaultValue, isRequired: isRequired })=>{
    const [locale, setLocale] = (0, $42omo.useState)('en-US');
    (0, $42omo.useEffect)(()=>{
        if (window.navigator.languages && locale !== window.navigator.languages[0]) setLocale(window.navigator.languages[0]);
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3d18012f6ad4f2f5$export$b5c4b0e7cd7f148b), null, /*#__PURE__*/ (0, $9K4OG.jsx)($a50e7fe929d36a1e$var$AKField, {
        name: name,
        label: label,
        defaultValue: defaultValue,
        isRequired: isRequired,
        validate: isRequired ? $a50e7fe929d36a1e$var$validate : undefined
    }, ({ fieldProps: fieldProps, error: error })=>{
        const { id: id, isDisabled: isDisabled, isInvalid: isInvalid, onBlur: onBlur, onChange: onChange, onFocus: onFocus, 'aria-invalid': ariaInvalid, 'aria-labelledby': ariaLabelledBy } = fieldProps;
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $051f12b2e6795f2a$export$56c425463976216f), {
            name: name,
            value: fieldProps.value
        }), /*#__PURE__*/ (0, $9K4OG.jsx)($a50e7fe929d36a1e$var$AKDatePicker, {
            id: id,
            isDisabled: isDisabled,
            onBlur: onBlur,
            onFocus: onFocus,
            onChange: onChange,
            value: fieldProps.value || '',
            placeholder: placeholder,
            dateFormat: $a50e7fe929d36a1e$export$fa96065c64444af6(locale),
            isInvalid: isInvalid || Boolean(error),
            "aria-invalid": ariaInvalid,
            "aria-labelledby": ariaLabelledBy
        }), error === 'EMPTY' && /*#__PURE__*/ (0, $9K4OG.jsx)($a50e7fe929d36a1e$var$AKErrorMessage, null, "This field is required."), description && /*#__PURE__*/ (0, $9K4OG.jsx)($a50e7fe929d36a1e$var$AKHelperMessage, null, description));
    }));
};
var $a50e7fe929d36a1e$export$2e2bcd8739ae039 = $a50e7fe929d36a1e$var$DatePicker;
const $a50e7fe929d36a1e$export$946840bece97c37 = ({ props: props })=>{
    const { name: name, label: label, defaultValue: defaultValue, description: description, placeholder: placeholder, isRequired: isRequired } = props;
    return /*#__PURE__*/ (0, $9K4OG.jsx)($a50e7fe929d36a1e$var$DatePicker, {
        name: name,
        label: label,
        defaultValue: defaultValue,
        description: description,
        placeholder: placeholder,
        isRequired: isRequired
    });
};



var $gvvHu = parcelRequire("gvvHu");


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 







const $32b8fbcc01788bcc$var$isEqual = (first, second)=>{
    if (first === second) return true;
    if (Array.isArray(first) && Array.isArray(second)) return first.sort().toString() === second.sort().toString();
    return false;
};
const $32b8fbcc01788bcc$var$FormCondition = ({ when: when, is: is, areChildrenPersisted: areChildrenPersisted = false, children: children })=>{
    const formContext = (0, $42omo.useContext)((0, $051f12b2e6795f2a$export$c24727297075ec6a));
    const shouldShowChildren = $32b8fbcc01788bcc$var$isEqual((0, $8718f926ed0b80e1$export$1a3c135ac4585aa9)(formContext?.formValues[when]), is);
    if (areChildrenPersisted) return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $9K4OG.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: shouldShowChildren ? 'block' : 'none'
        })
    }, children);
    else return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, shouldShowChildren ? children : null);
};
var $32b8fbcc01788bcc$export$2e2bcd8739ae039 = $32b8fbcc01788bcc$var$FormCondition;
const $32b8fbcc01788bcc$export$5063d3d804b7f0da = ({ props: props, children: children, Components: Components, dispatch: dispatch, render: render, renderChildren: renderChildren })=>{
    const { when: when, is: is, areChildrenPersisted: areChildrenPersisted } = props;
    return /*#__PURE__*/ (0, $9K4OG.jsx)($32b8fbcc01788bcc$var$FormCondition, {
        when: when,
        is: is,
        areChildrenPersisted: areChildrenPersisted
    }, renderChildren({
        children: children,
        render: render,
        dispatch: dispatch,
        Components: Components
    }));
};






var $er4dw = parcelRequire("er4dw");


var $kS0x0 = parcelRequire("kS0x0");

const $8f85478b37fe897b$export$baab7c95ad93ac5a = {
    xsmall: '25%',
    small: '37.5%',
    medium: '50%',
    large: '75%',
    xlarge: '100%'
};
function $8f85478b37fe897b$export$2e2bcd8739ae039({ src: src, alt: alt, size: size = 'xlarge' }) {
    const maxWidth = $8f85478b37fe897b$export$baab7c95ad93ac5a[size] || '100%';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 'auto',
            maxWidth: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            maxWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textAlign: 'center'
        },
        src: src,
        alt: alt
    });
}
const $8f85478b37fe897b$export$f62f254e0954ca34 = ({ props: props })=>{
    const { src: src, alt: alt, size: size } = props;
    const isValidUrl = (0, $kS0x0.useIsValidImageUrl)(src);
    if (isValidUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8f85478b37fe897b$export$2e2bcd8739ae039, {
        src: src,
        alt: alt,
        size: size
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $er4dw.EgressErrorMessage), {
        url: src
    });
};







function $b7e8ee93f9359bd7$var$Form(props) {
    const { actions: actions, akFormProps: akFormProps, akSubmitButtonProps: akSubmitButtonProps, children: children, htmlFormProps: htmlFormProps } = (0, $051f12b2e6795f2a$export$87c0cf8eb5a167e0)(props);
    const { key: key, onSubmit: onSubmit } = akFormProps;
    const { children: submitButtonChildren, shouldFitContainer: shouldFitContainer, iconBefore: iconBefore, iconAfter: iconAfter, isLoading: loading, isDisabled: disabled, onClick: onClick, type: type } = akSubmitButtonProps;
    // @ts-ignore Ignoring the fact that "data-testid" is not part of the declared type
    const { className: className, 'data-testid': dataTestId } = htmlFormProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $051f12b2e6795f2a$export$117438e17b246db9), {
        key: key,
        onSubmit: onSubmit
    }, ({ formProps: formProps })=>{
        const { onSubmit: onSubmit, onKeyDown: onKeyDown, ref: ref } = formProps;
        return(// eslint-disable-next-line @atlassian/a11y/no-noninteractive-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("form", {
            onSubmit: onSubmit,
            onKeyDown: onKeyDown,
            ref: ref,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": dataTestId
        }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $051f12b2e6795f2a$export$bbe730ec239dd31a), {
            align: "end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5ff27bb82b284c52$export$87e672a75327e04b), null, actions, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a42d48f6837420c9$export$8471a7693ebd6f54), {
            shouldFitContainer: shouldFitContainer,
            iconBefore: iconBefore,
            iconAfter: iconAfter,
            isLoading: loading,
            isDisabled: disabled,
            onClick: onClick,
            type: type,
            appearance: "primary"
        }, submitButtonChildren)))));
    });
}
function $b7e8ee93f9359bd7$export$a06b1ef8e65f6918({ forgeDoc: forgeDoc, dispatch: dispatch, render: render }) {
    if (forgeDoc.children.length === 0) return {
        children: []
    };
    return {
        children: forgeDoc.children[0].type === 'Form' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b7e8ee93f9359bd7$var$Form, {
            forgeDoc: forgeDoc.children[0],
            dispatch: dispatch,
            render: render
        }) : forgeDoc.children.map(render)
    };
}
const $b7e8ee93f9359bd7$export$c7313f750e9cbc9d = (props)=>{
    const { children: children } = $b7e8ee93f9359bd7$export$a06b1ef8e65f6918(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766














const $30d941e03f46872c$export$d84e15b05040c98 = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6ZrcH")));

const $30d941e03f46872c$var$AKModalHeader = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("9ot3w"))));

const $30d941e03f46872c$var$AKModalTitle = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("d8eRd"))));

const $30d941e03f46872c$var$AKModalBody = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("1DHa6"))));

const $30d941e03f46872c$var$AKModalFooter = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("8o1lj"))));

const $30d941e03f46872c$var$AKButton = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6fHGT")));
const $30d941e03f46872c$var$COMPONENT_TOP_MARGIN = "var(--ds-space-150, 12px)";
function $30d941e03f46872c$var$applyTopMargin(element) {
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $9K4OG.css)({
            marginTop: $30d941e03f46872c$var$COMPONENT_TOP_MARGIN
        })
    }, element);
}
function $30d941e03f46872c$export$1e9ab8114847a87d({ forgeDoc: forgeDoc, dispatch: dispatch, render: render }) {
    const intl = (0, $8C5kA.default)();
    const { appearance: appearance, header: header, onClose: onClose, closeButtonText: closeButtonText = intl.formatMessage($30d941e03f46872c$var$messages.closeModalButton), width: width = 'medium' } = forgeDoc.props || {};
    const formForgeDoc = forgeDoc.children.length === 1 && forgeDoc.children[0]?.type === 'Form' ? forgeDoc.children[0] : undefined;
    const [isSubmitting, setIsSubmitting] = (0, $42omo.useState)(false);
    const [isClosing, setIsClosing] = (0, $42omo.useState)(false);
    const [formValues, setFormValues] = (0, $42omo.useState)({});
    const setFormValue = (name, value)=>{
        setFormValues((prevState)=>({
                ...prevState,
                [name]: value
            }));
    };
    const { children: children, akFormProps: akFormProps, htmlFormProps: htmlFormProps, akSubmitButtonProps: akFormSubmitButtonProps } = (0, $051f12b2e6795f2a$export$87c0cf8eb5a167e0)({
        // This is awkward because we only use values if formForgeDoc exists
        // I want to conditionally call this hook but I can't
        forgeDoc: formForgeDoc || {
            type: 'Form',
            children: []
        },
        dispatch: dispatch,
        render: render
    });
    const akFormPropsWithOnSubmit = {
        ...akFormProps,
        onSubmit: async (...args)=>{
            setIsSubmitting(true);
            try {
                await akFormProps.onSubmit(...args);
            } finally{
                setIsSubmitting(false);
            }
        }
    };
    const formId = (0, $42omo.useRef)(`modal-form-id-${Date.now()}`);
    const akSubmitButtonProps = {
        ...akFormSubmitButtonProps,
        appearance: appearance || 'primary',
        isLoading: isSubmitting,
        form: formId.current
    };
    const handleClose = async ()=>{
        setIsClosing(true);
        try {
            await dispatch({
                type: 'event',
                handler: onClose,
                args: [],
                extensionData: {}
            });
        } finally{
            setIsClosing(false);
        }
    };
    const actions = formForgeDoc ? formForgeDoc.children.filter((0, $051f12b2e6795f2a$export$2127b0e8511224d0)) : [];
    const { akActionButtonProps: akActionButtonProps } = (0, $a42d48f6837420c9$export$fdac0c774aedd7f7)({
        forgeDoc: actions,
        dispatch: dispatch,
        render: render
    });
    const { akButtonProps: closeButtonProps } = (0, $a42d48f6837420c9$export$ea18c227d4417cc3)({
        forgeDoc: {
            type: 'Button',
            props: {
                appearance: 'subtle',
                text: closeButtonText,
                onClick: onClose
            },
            children: []
        },
        dispatch: dispatch,
        render: render
    });
    const akCloseButtonProps = {
        ...closeButtonProps,
        isLoading: isClosing || closeButtonProps.isLoading
    };
    return {
        akModalDialogProps: {
            onClose: handleClose,
            width: width
        },
        akModalTitleProps: {
            appearance: appearance,
            children: header
        },
        akModalBodyProps: {
            children: formForgeDoc ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $051f12b2e6795f2a$export$117438e17b246db9), akFormPropsWithOnSubmit, ({ formProps: formProps })=>/*#__PURE__*/ (0, $9K4OG.jsx)("form", {
                    ...formProps,
                    ...htmlFormProps,
                    id: formId.current
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $051f12b2e6795f2a$export$c24727297075ec6a).Provider, {
                    value: {
                        formValues: formValues,
                        setFormValue: setFormValue
                    }
                }, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, (child, index)=>index === 0 ? child : $30d941e03f46872c$var$applyTopMargin(child))))) : (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(forgeDoc.children.map(render), (child, index)=>index === 0 ? child : $30d941e03f46872c$var$applyTopMargin(child))
        },
        actions: formForgeDoc ? [
            ...akActionButtonProps,
            akCloseButtonProps,
            akSubmitButtonProps
        ] : [
            akCloseButtonProps
        ]
    };
}
function $30d941e03f46872c$export$1fa217be60c2f188(props) {
    const { akModalDialogProps: akModalDialogProps, akModalTitleProps: akModalTitleProps, akModalBodyProps: akModalBodyProps, actions: actions } = $30d941e03f46872c$export$1e9ab8114847a87d(props);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($30d941e03f46872c$export$d84e15b05040c98, akModalDialogProps, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($30d941e03f46872c$var$AKModalHeader, null, /*#__PURE__*/ (0, $9K4OG.jsx)($30d941e03f46872c$var$AKModalTitle, akModalTitleProps)), /*#__PURE__*/ (0, $9K4OG.jsx)($30d941e03f46872c$var$AKModalBody, akModalBodyProps), /*#__PURE__*/ (0, $9K4OG.jsx)($30d941e03f46872c$var$AKModalFooter, null, actions.map((akButtonProps, index)=>/*#__PURE__*/ (0, $9K4OG.jsx)($30d941e03f46872c$var$AKButton, {
            ...akButtonProps,
            key: index
        }))))));
}
const $30d941e03f46872c$var$messages = (0, $cgtv4.defineMessages)({
    closeModalButton: {
        id: "confluence.modal.dialog.close.modal.button",
        defaultMessage: "Cancel"
    }
});


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766







function $3dee357baf0d8c03$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3dee357baf0d8c03$var$styles = {
    name: "1l4ndn6",
    styles: "line-height:20px"
};

const $3dee357baf0d8c03$var$Field = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.Field
        })));

const $3dee357baf0d8c03$var$AkRadioGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>Promise.resolve((parcelRequire("lBvGi"))));

const $3dee357baf0d8c03$var$AKHelperMessage = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.HelperMessage
        })));
const $3dee357baf0d8c03$export$a98f0dcb43a68a25 = ({ options: options, defaultValue: defaultValue, isRequired: isRequired, label: label, description: description, name: name })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)($3dee357baf0d8c03$var$Field, {
        defaultValue: defaultValue,
        isRequired: isRequired,
        label: label,
        name: name
    }, ({ fieldProps: fieldProps })=>{
        const { id: id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, value: value, 'aria-labelledby': ariaLabelledBy } = fieldProps;
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $051f12b2e6795f2a$export$56c425463976216f), {
            name: name,
            value: fieldProps.value
        }), description && /*#__PURE__*/ (0, $9K4OG.jsx)($3dee357baf0d8c03$var$AKHelperMessage, null, description), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $3dee357baf0d8c03$var$styles
        }, /*#__PURE__*/ (0, $9K4OG.jsx)($3dee357baf0d8c03$var$AkRadioGroup, {
            "test-id": id,
            isRequired: isRequired,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            onChange: onChange,
            value: value,
            "aria-labelledby": ariaLabelledBy,
            options: options
        })));
    });
};
const $3dee357baf0d8c03$export$306cd3e63a0f2f51 = ({ props: props, children: children })=>{
    const { label: label, name: name, isRequired: isRequired, description: description } = props;
    let defaultValue;
    const options = children.map((child)=>{
        const { props: props, type: type } = child;
        if (type === 'Radio') {
            const { label: label, value: value, defaultChecked: defaultChecked } = props;
            if (defaultChecked) defaultValue = value;
            return {
                name: name,
                label: label,
                value: value
            };
        }
    }).filter((option)=>typeof option !== 'undefined');
    return /*#__PURE__*/ (0, $9K4OG.jsx)($3dee357baf0d8c03$export$a98f0dcb43a68a25, {
        label: label,
        name: name,
        options: options,
        defaultValue: defaultValue,
        description: description,
        isRequired: isRequired
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 








const $a39f1476ebe09a75$var$AKRange = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("7EIk4")));

const $a39f1476ebe09a75$var$AKField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.Field
        })));
const $a39f1476ebe09a75$var$Range = ({ defaultValue: defaultValue, min: min = 0, max: max = 100, step: step = 1, label: label, name: name, testId: testId })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3d18012f6ad4f2f5$export$b5c4b0e7cd7f148b), null, /*#__PURE__*/ (0, $9K4OG.jsx)($a39f1476ebe09a75$var$AKField, {
        name: name,
        label: label,
        defaultValue: defaultValue || min
    }, ({ fieldProps: fieldProps })=>{
        const { isDisabled: isDisabled, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, 'aria-labelledby': ariaLabelledBy } = fieldProps;
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $051f12b2e6795f2a$export$56c425463976216f), {
            name: name,
            value: fieldProps.value
        }), /*#__PURE__*/ (0, $9K4OG.jsx)($a39f1476ebe09a75$var$AKRange, {
            min: min,
            max: max,
            step: step,
            testId: testId,
            isDisabled: isDisabled,
            value: value,
            onChange: onChange,
            onBlur: onBlur,
            onFocus: onFocus,
            "aria-labelledby": ariaLabelledBy
        }));
    }));
};
var $a39f1476ebe09a75$export$2e2bcd8739ae039 = $a39f1476ebe09a75$var$Range;
const $a39f1476ebe09a75$export$da0b73f16fbcfd59 = ({ props: props })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)($a39f1476ebe09a75$var$Range, props);
};






const $c0aa0bb1af76a24d$var$AKSectionMessage = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9uD5t")));
const $c0aa0bb1af76a24d$export$e06a8392284a8d09 = {
    info: 'information',
    confirmation: 'success',
    change: 'discovery',
    warning: 'warning',
    error: 'error'
};
const $c0aa0bb1af76a24d$var$SectionMessage = ({ title: title, appearance: appearance = 'info', children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c0aa0bb1af76a24d$var$AKSectionMessage, {
        title: title,
        //TODO: Remove this mapping once the forge-ui package is updated to accomodate section-message appearance changes
        appearance: $c0aa0bb1af76a24d$export$e06a8392284a8d09[appearance]
    }, children);
};
var $c0aa0bb1af76a24d$export$2e2bcd8739ae039 = $c0aa0bb1af76a24d$var$SectionMessage;
const $c0aa0bb1af76a24d$export$8376ed98c8f93829 = ({ props: props, children: children, Components: Components, render: render, renderChildren: renderChildren, dispatch: dispatch })=>{
    const { title: title, appearance: appearance } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c0aa0bb1af76a24d$var$SectionMessage, {
        title: title,
        appearance: appearance
    }, renderChildren({
        Components: Components,
        children: children,
        render: render,
        dispatch: dispatch
    }));
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766









var $gtD4K = parcelRequire("gtD4K");



var $JmaBh = parcelRequire("JmaBh");



const $22effabcab7a648e$var$AKFormField = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("g4pg0")));

const $22effabcab7a648e$var$AKSelect = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7gfRx")));

const $22effabcab7a648e$var$AKErrorMessage = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.ErrorMessage
        })));

const $22effabcab7a648e$var$AKHelperMessage = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.HelperMessage
        })));
const $22effabcab7a648e$var$validate = (value)=>!value ? 'EMPTY' : undefined;
const $22effabcab7a648e$export$ef9b1a59e592288f = ({ options: options, isMulti: isMulti, defaultValue: defaultValue, label: label, name: name, description: description, isRequired: isRequired, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $JmaBh.PortalConsumer), null, (portal)=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $3d18012f6ad4f2f5$export$b5c4b0e7cd7f148b), null, /*#__PURE__*/ (0, $9K4OG.jsx)($22effabcab7a648e$var$AKFormField, {
            defaultValue: defaultValue,
            label: label,
            name: name,
            isRequired: isRequired,
            validate: isRequired ? $22effabcab7a648e$var$validate : undefined
        }, ({ fieldProps: fieldProps, error: error })=>{
            const { id: id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, 'aria-labelledby': ariaLabelledBy } = fieldProps;
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $051f12b2e6795f2a$export$56c425463976216f), {
                name: name,
                value: fieldProps.value
            }), /*#__PURE__*/ (0, $9K4OG.jsx)($22effabcab7a648e$var$AKSelect, {
                id: id,
                isRequired: isRequired,
                isDisabled: isDisabled,
                isInvalid: isInvalid,
                onChange: onChange,
                onBlur: onBlur,
                onFocus: onFocus,
                value: value,
                "aria-labelledby": ariaLabelledBy,
                isMulti: isMulti,
                menuPortalTarget: portal,
                options: options,
                placeholder: placeholder,
                validationState: error ? 'error' : 'default'
            }), error === 'EMPTY' && /*#__PURE__*/ (0, $9K4OG.jsx)($22effabcab7a648e$var$AKErrorMessage, null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), $22effabcab7a648e$var$messages.requiredFieldMessage)), description && /*#__PURE__*/ (0, $9K4OG.jsx)($22effabcab7a648e$var$AKHelperMessage, null, description));
        })));
};
const $22effabcab7a648e$export$747c8c62a73d26b4 = ({ props: props, children: children })=>{
    const { description: description, label: label, name: name, isMulti: isMulti, placeholder: placeholder, isRequired: isRequired } = props;
    let defaultValue = [];
    const options = children.map((child)=>{
        const { props: props, type: type } = child;
        if (type === 'Option') {
            const { defaultSelected: defaultSelected, label: label, value: value } = props;
            const option = {
                label: label,
                value: value
            };
            if (defaultSelected) {
                if (isMulti) defaultValue.push(option);
                else defaultValue = [
                    option
                ];
            }
            return option;
        }
    }).filter((option)=>typeof option !== 'undefined');
    const formattedDefaultValue = isMulti ? defaultValue : defaultValue[0];
    return /*#__PURE__*/ (0, $9K4OG.jsx)($22effabcab7a648e$export$ef9b1a59e592288f, {
        label: label,
        name: name,
        options: options,
        isMulti: isMulti,
        isRequired: isRequired,
        defaultValue: formattedDefaultValue,
        description: description,
        placeholder: placeholder
    });
};
const $22effabcab7a648e$var$messages = (0, $cgtv4.defineMessages)({
    requiredFieldMessage: {
        id: "confluence.select.required.field.message",
        defaultMessage: "This field is required."
    }
});






const $a9fcfda387e3540d$var$AkStatusLozenge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("cQBlt")));
const $a9fcfda387e3540d$var$StatusLozenge = ({ appearance: appearance, text: text })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a9fcfda387e3540d$var$AkStatusLozenge, {
        appearance: appearance
    }, text);
var $a9fcfda387e3540d$export$2e2bcd8739ae039 = $a9fcfda387e3540d$var$StatusLozenge;
const $a9fcfda387e3540d$export$3cc3ebecc7f239e9 = ({ props: props })=>{
    const { appearance: appearance, text: text } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a9fcfda387e3540d$var$StatusLozenge, {
        appearance: appearance,
        text: text
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766






function $e557af5bc1407d1c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e557af5bc1407d1c$var$styles = {
    name: "6n1ert",
    styles: "width:inherit"
};
const $e557af5bc1407d1c$var$COMPONENT_TOP_MARGIN = "var(--ds-space-150, 12px)";
function $e557af5bc1407d1c$var$applyTopMargin(element) {
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $9K4OG.css)({
            marginTop: $e557af5bc1407d1c$var$COMPONENT_TOP_MARGIN,
            width: 'inherit'
        })
    }, element);
}
var $e557af5bc1407d1c$var$_ref = {
    name: "13i2jrr",
    styles: "display:flex;background:transparent;flex-direction:column;padding:0;position:relative;overflow:hidden;align-items:flex-start;width:100%;> *{margin-bottom:0;}"
};
const $e557af5bc1407d1c$var$View = ({ children: children, nonVisibleChildren: nonVisibleChildren })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: $e557af5bc1407d1c$var$_ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, (child, index)=>index ? $e557af5bc1407d1c$var$applyTopMargin(child) : /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $e557af5bc1407d1c$var$styles
        }, child)), nonVisibleChildren);
};
var $e557af5bc1407d1c$export$2e2bcd8739ae039 = $e557af5bc1407d1c$var$View;
const $e557af5bc1407d1c$export$9dd2b28001e5a44e = ({ children: children, dispatch: dispatch, Components: Components, render: render, renderChildren: renderChildren })=>{
    const isChildVisible = (type)=>![
            'ModalDialog'
        ].includes(type);
    const nonVisibleChildren = children.filter(({ type: type })=>!isChildVisible(type));
    const visibleChildren = children.filter(({ type: type })=>isChildVisible(type));
    return /*#__PURE__*/ (0, $9K4OG.jsx)($e557af5bc1407d1c$var$View, {
        nonVisibleChildren: renderChildren({
            children: nonVisibleChildren,
            dispatch: dispatch,
            Components: Components,
            render: render
        })
    }, renderChildren({
        children: visibleChildren,
        dispatch: dispatch,
        Components: Components,
        render: render
    }));
};






var $j9gwA = parcelRequire("j9gwA");


const $d6f185b59b4c46eb$var$AKTabs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("lebYT")).then((module)=>({
            default: module.default
        })));

const $d6f185b59b4c46eb$var$AKTab = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("lebYT")).then((module)=>({
            default: module.Tab
        })));

const $d6f185b59b4c46eb$var$AKTabList = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("lebYT")).then((module)=>({
            default: module.TabList
        })));

const $d6f185b59b4c46eb$var$AKTabPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("lebYT")).then((module)=>({
            default: module.TabPanel
        })));
// Tabs must be stateful so we don't reset to the first tab on re-renders
const $d6f185b59b4c46eb$var$Tabs = ({ tabs: tabs })=>{
    const [selectedIndex, setSelectedIndex] = (0, $42omo.useState)(0);
    const id = (0, $42omo.useRef)((0, $j9gwA.useUID)());
    return /*#__PURE__*/ (0, $9K4OG.jsx)($d6f185b59b4c46eb$var$AKTabs, {
        selected: selectedIndex,
        onChange: setSelectedIndex,
        id: id.current,
        shouldUnmountTabPanelOnChange: true
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($d6f185b59b4c46eb$var$AKTabList, null, tabs.map((tab, index)=>/*#__PURE__*/ (0, $9K4OG.jsx)($d6f185b59b4c46eb$var$AKTab, {
            key: index
        }, tab.label))), tabs.map((tab, index)=>/*#__PURE__*/ (0, $9K4OG.jsx)($d6f185b59b4c46eb$var$AKTabPanel, {
            key: index
        }, tab.content)));
};
var $d6f185b59b4c46eb$export$2e2bcd8739ae039 = $d6f185b59b4c46eb$var$Tabs;
const $d6f185b59b4c46eb$export$79714c2052a995e9 = ({ children: children, dispatch: dispatch, Components: Components, render: render, renderChildren: renderChildren })=>{
    const tabData = children.map((child)=>{
        const { props: props, type: type } = child;
        if (type === 'Tab') return {
            label: props?.label,
            content: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $e557af5bc1407d1c$export$2e2bcd8739ae039), {
                nonVisibleChildren: null
            }, renderChildren({
                children: child.children,
                dispatch: dispatch,
                Components: Components,
                render: render
            }))
        };
    }).filter((child)=>child != null);
    return /*#__PURE__*/ (0, $9K4OG.jsx)($d6f185b59b4c46eb$var$Tabs, {
        tabs: tabData
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766










const $061808f38ff72f63$var$AKDynamicTable = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("fwIdy")).then((module)=>({
            default: module.DynamicTableStateless
        })));
class $061808f38ff72f63$export$e6dfd72ab29f8598 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    /**
   * There's a bug with Suspense and findDOMNode https://github.com/facebook/react/issues/14188
   * We've opted to catch and ignore the error temporarily while we address the issue in Atlaskit
   * See http:/go/j/FUI-870
   */ componentDidCatch(error) {
        if (error && error.message && (error.message === 'Unable to find node on an unmounted component.' || error.message.startsWith('Minified React error #188;')) && !this.state.retried) this.setState({
            retried: true
        }, ()=>this.setState({
                retried: false
            }));
        else throw error;
    }
    render() {
        const { Component: Component, head: head, isFixedSize: isFixedSize, onSetPage: onSetPage, page: page, rows: rows, rowsPerPage: rowsPerPage } = this.props;
        if (Component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            head: head,
            isFixedSize: isFixedSize,
            onSetPage: onSetPage,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage
        });
        else return null;
    }
    constructor(...args){
        super(...args);
        this.state = {
            retried: false
        };
    }
}
const $061808f38ff72f63$var$LazyLoadedTable = (props)=>{
    const { head: head, isFixedSize: isFixedSize, onSetPage: onSetPage, page: page, rows: rows, rowsPerPage: rowsPerPage } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($061808f38ff72f63$export$e6dfd72ab29f8598, {
        Component: $061808f38ff72f63$var$AKDynamicTable,
        head: head,
        isFixedSize: isFixedSize,
        onSetPage: onSetPage,
        page: page,
        rows: rows,
        rowsPerPage: rowsPerPage
    });
};
var $061808f38ff72f63$export$2e2bcd8739ae039 = $061808f38ff72f63$var$LazyLoadedTable;


function $f42d8d47d2541350$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f42d8d47d2541350$var$styles = {
    name: "a5j0nx",
    styles: "align-self:normal;margin-bottom:0px;word-break:initial"
};
const $f42d8d47d2541350$export$54ec01a60f47d33d = ({ head: head, rows: rows, rowsPerPage: rowsPerPage = 15 })=>{
    const [currentPage, setCurrentPage] = (0, $42omo.useState)(1);
    // rowsPerPage of 0 is a sentinel value for a fixed size Table
    const isFixedSize = rowsPerPage === 0 || rows.length <= rowsPerPage;
    rowsPerPage = isFixedSize ? Infinity : rowsPerPage;
    function onChange(i) {
        setCurrentPage(i);
    }
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $f42d8d47d2541350$var$styles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $061808f38ff72f63$export$2e2bcd8739ae039), {
        isFixedSize: isFixedSize,
        rowsPerPage: rowsPerPage,
        page: currentPage,
        onSetPage: onChange,
        head: head,
        rows: rows
    }));
};
const $f42d8d47d2541350$export$d1aa90943bebe2eb = ({ props: props, children: children, dispatch: dispatch, render: render, Components: Components })=>{
    const { rowsPerPage: rowsPerPage } = props;
    const convertRow = (row)=>{
        const cells = row.children.filter((child)=>child.type === 'Cell').map((cell)=>{
            const content = cell.children.map((child)=>{
                return render({
                    aux: child,
                    dispatch: dispatch,
                    Components: Components
                });
            });
            return {
                content: content
            };
        });
        return {
            cells: cells
        };
    };
    const head = children.filter((child)=>child.type === 'Head');
    const headData = head.length > 0 ? convertRow(head[0]) : {
        cells: []
    };
    const rows = children.filter((child)=>child.type === 'Row').map((row)=>convertRow(row));
    return /*#__PURE__*/ (0, $9K4OG.jsx)($f42d8d47d2541350$export$54ec01a60f47d33d, {
        head: headData,
        rows: rows,
        rowsPerPage: rowsPerPage
    });
};


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 



const $a07ec5c4d0f3df05$var$AKTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("ho0fc")).then((module)=>({
            default: module.SimpleTag
        })));
const $a07ec5c4d0f3df05$var$colorDict = {
    default: 'standard',
    green: 'green',
    blue: 'blue',
    red: 'red',
    purple: 'purple',
    grey: 'grey',
    teal: 'teal',
    yellow: 'yellow',
    'green-light': 'greenLight',
    'blue-light': 'blueLight',
    'red-light': 'redLight',
    'purple-light': 'purpleLight',
    'grey-light': 'greyLight',
    'teal-light': 'tealLight',
    'yellow-light': 'yellowLight'
};
const $a07ec5c4d0f3df05$var$mapColorToAK = (color)=>{
    return $a07ec5c4d0f3df05$var$colorDict[color];
};
const $a07ec5c4d0f3df05$var$Tag = ({ color: color = 'default', text: text })=>{
    const akColor = $a07ec5c4d0f3df05$var$mapColorToAK(color);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a07ec5c4d0f3df05$var$AKTag, {
        color: akColor,
        text: text
    });
};
const $a07ec5c4d0f3df05$export$3ee92cd923c64da4 = ({ props: props })=>{
    const { color: color, text: text } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a07ec5c4d0f3df05$var$Tag, {
        color: color,
        text: text
    });
};
var $a07ec5c4d0f3df05$export$2e2bcd8739ae039 = $a07ec5c4d0f3df05$var$Tag;





const $3d126440aa917d8a$var$AKTagGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("2wzBN")));
const $3d126440aa917d8a$var$TagGroup = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3d126440aa917d8a$var$AKTagGroup, null, children);
};
var $3d126440aa917d8a$export$2e2bcd8739ae039 = $3d126440aa917d8a$var$TagGroup;
const $3d126440aa917d8a$export$95fa80966968aa57 = ({ children: children, dispatch: dispatch, Components: Components, render: render, renderChildren: renderChildren })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3d126440aa917d8a$var$TagGroup, null, renderChildren({
        children: children,
        dispatch: dispatch,
        Components: Components,
        render: render
    }));
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $1c598 = parcelRequire("1c598");





var $5dK2X = parcelRequire("5dK2X");

function $a832f0cd6ed31fad$export$e56c262d45d65d3f(text) {
    return text.split(/\s*\n\s*\n[\n\s]*/).filter((str)=>str.length > 0);
}
function $a832f0cd6ed31fad$export$cc54e21c3860db3d({ content: content }) {
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", null, $a832f0cd6ed31fad$export$e56c262d45d65d3f(content).map((paragraph, i)=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), {
            as: "p",
            key: i
        }, paragraph)));
}
const $a832f0cd6ed31fad$var$ALIGN_ALLOWLIST = [
    'start',
    'center',
    'end'
];
const $a832f0cd6ed31fad$var$isTextAlign = (align)=>{
    return $a832f0cd6ed31fad$var$ALIGN_ALLOWLIST.includes(align);
};
function $a832f0cd6ed31fad$export$8af001e2d8bdb181(align) {
    if ($a832f0cd6ed31fad$var$isTextAlign(align)) return align;
    else return 'start';
}
function $a832f0cd6ed31fad$export$a4f87e7f51175d99({ children: children, align: align }) {
    const sanitizedAlign = $a832f0cd6ed31fad$export$8af001e2d8bdb181(align);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9UyM5.InlineContext).Provider, {
        value: {
            inline: true
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $9K4OG.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            textAlign: sanitizedAlign
        })
    }, children));
}
function $a832f0cd6ed31fad$var$filterMarkup(children, nested) {
    const isNestable = (child)=>(0, $1c598.MarkupRecursiveList).some((x)=>child.type === x);
    const isInline = (child)=>(0, $1c598.MarkupList).some((x)=>child.type === x);
    return children.map((child)=>{
        if (nested) {
            if (!isNestable(child)) return null;
        } else {
            if (!isInline(child)) return null;
        }
        return {
            ...child,
            children: $a832f0cd6ed31fad$var$filterMarkup(child.children, true)
        };
    }).filter((x)=>x !== null);
}
function $a832f0cd6ed31fad$export$e64c089f4186fe76({ Components: Components, children: children, align: align, dispatch: dispatch, render: render, renderChildren: renderChildren }) {
    // filter non Markup components
    children = $a832f0cd6ed31fad$var$filterMarkup(children, false);
    return /*#__PURE__*/ (0, $9K4OG.jsx)($a832f0cd6ed31fad$export$a4f87e7f51175d99, {
        align: align
    }, renderChildren({
        Components: Components,
        children: children,
        render: render,
        dispatch: dispatch
    }));
}
function $a832f0cd6ed31fad$export$c703e634d6a416c6({ props: props, children: children, type: type, dispatch: dispatch, render: render, renderChildren: renderChildren, Components: Components }) {
    const { content: content, format: format } = props;
    if (typeof content === 'string') return /*#__PURE__*/ (0, $9K4OG.jsx)($a832f0cd6ed31fad$export$cc54e21c3860db3d, {
        content: content
    });
    if (format === 'markup') {
        const { align: align } = props;
        return $a832f0cd6ed31fad$export$e64c089f4186fe76({
            children: children,
            align: align,
            type: type,
            dispatch: dispatch,
            render: render,
            renderChildren: renderChildren,
            Components: Components
        });
    }
    // otherwise, do nothing
    return null;
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766














const $e6aaecc72491f49a$var$AkFormField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.Field
        })));

const $e6aaecc72491f49a$var$AKTextArea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("8GA7i")));

const $e6aaecc72491f49a$var$AKErrorMessage = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.ErrorMessage
        })));

const $e6aaecc72491f49a$var$AKHelperMessage = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.HelperMessage
        })));
const $e6aaecc72491f49a$var$validate = (value)=>!value ? 'EMPTY' : undefined;
const $e6aaecc72491f49a$var$TextArea = (props)=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $3d18012f6ad4f2f5$export$b5c4b0e7cd7f148b), null, /*#__PURE__*/ (0, $9K4OG.jsx)($e6aaecc72491f49a$var$AkFormField, {
        name: props.name,
        label: props.label,
        defaultValue: props.defaultValue,
        isRequired: props.isRequired,
        validate: props.isRequired ? $e6aaecc72491f49a$var$validate : undefined
    }, ({ fieldProps: fieldProps, error: error })=>{
        const { id: id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, 'aria-labelledby': ariaLabelledBy } = fieldProps;
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $051f12b2e6795f2a$export$56c425463976216f), {
            name: props.name,
            value: fieldProps.value
        }), /*#__PURE__*/ (0, $9K4OG.jsx)($e6aaecc72491f49a$var$AKTextArea, {
            id: id,
            isRequired: isRequired,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            onChange: onChange,
            onBlur: onBlur,
            onFocus: onFocus,
            value: value,
            "aria-labelledby": ariaLabelledBy,
            appearance: "standard",
            resize: "smart",
            minimumRows: 2,
            isMonospaced: props.isMonospaced,
            placeholder: props.placeholder,
            spellCheck: props.spellCheck
        }), error === 'EMPTY' && /*#__PURE__*/ (0, $9K4OG.jsx)($e6aaecc72491f49a$var$AKErrorMessage, null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), $e6aaecc72491f49a$var$messages.requiredFieldMessage)), props.description && /*#__PURE__*/ (0, $9K4OG.jsx)($e6aaecc72491f49a$var$AKHelperMessage, null, props.description));
    }));
var $e6aaecc72491f49a$export$2e2bcd8739ae039 = $e6aaecc72491f49a$var$TextArea;
const $e6aaecc72491f49a$export$7c39c70ba43929a0 = ({ props: props })=>{
    const { name: name, label: label, defaultValue: defaultValue, isMonospaced: isMonospaced, isRequired: isRequired, description: description, placeholder: placeholder, spellCheck: spellCheck } = props;
    return /*#__PURE__*/ (0, $9K4OG.jsx)($e6aaecc72491f49a$var$TextArea, {
        name: name,
        label: label,
        defaultValue: defaultValue,
        isMonospaced: isMonospaced,
        isRequired: isRequired,
        placeholder: placeholder,
        description: description,
        spellCheck: spellCheck
    });
};
const $e6aaecc72491f49a$var$messages = (0, $cgtv4.defineMessages)({
    requiredFieldMessage: {
        id: "confluence.text.area.required.field.message",
        defaultMessage: "This field is required."
    }
});


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766






// eslint-disable-next-line import/no-extraneous-dependencies

var $h17uI = parcelRequire("h17uI");


var $1e2E5 = parcelRequire("1e2E5");

var $fI8ba = parcelRequire("fI8ba");



const $160238b3cd7f3114$var$cache = (0, $fI8ba.createIntlCache)();
const $160238b3cd7f3114$var$defaultIntl = (0, $1e2E5.createIntl)({
    locale: 'en'
}, $160238b3cd7f3114$var$cache);
function $160238b3cd7f3114$export$7e4aa119212bc614(value, propIntl) {
    const intl = propIntl ? propIntl : $160238b3cd7f3114$var$defaultIntl;
    const { formatMessage: formatMessage } = intl;
    return (0, (/*@__PURE__*/$parcel$interopDefault($h17uI)))(value) ? undefined : formatMessage($160238b3cd7f3114$var$messages.validNumber);
}
function $160238b3cd7f3114$export$7fbbfbca30081d0(value, propIntl) {
    const intl = propIntl ? propIntl : $160238b3cd7f3114$var$defaultIntl;
    const { formatMessage: formatMessage } = intl;
    if (typeof value === 'string' && /@/.test(value)) return;
    // return 'Enter a valid email.';
    return formatMessage($160238b3cd7f3114$var$messages.validEmail);
}
function $160238b3cd7f3114$export$d7aad9be675cc63d(value, propIntl) {
    const intl = propIntl ? propIntl : $160238b3cd7f3114$var$defaultIntl;
    const { formatMessage: formatMessage } = intl;
    if (typeof value === 'string' && /[0-9]/.test(value)) return;
    // return 'Enter a valid telephone.';
    return formatMessage($160238b3cd7f3114$var$messages.validTelephone);
}
const $160238b3cd7f3114$var$Validators = {
    email: $160238b3cd7f3114$export$7fbbfbca30081d0,
    number: $160238b3cd7f3114$export$7e4aa119212bc614,
    tel: $160238b3cd7f3114$export$d7aad9be675cc63d
};
function $160238b3cd7f3114$export$175ffc4a72fd9f6d(isRequired, type, propIntl) {
    return function Validate(value) {
        const intl = propIntl ? propIntl : $160238b3cd7f3114$var$defaultIntl;
        const { formatMessage: formatMessage } = intl;
        const isEmpty = typeof value === 'string' && value.length === 0;
        if (isRequired && isEmpty) // return 'This field is required.';
        return formatMessage($160238b3cd7f3114$var$messages.requiredFieldMessage);
        if (isEmpty) return;
        const isType = type in $160238b3cd7f3114$var$Validators ? $160238b3cd7f3114$var$Validators[type] : undefined;
        return isType ? isType(value, propIntl) : undefined;
    };
}
const $160238b3cd7f3114$var$messages = (0, $cgtv4.defineMessages)({
    validNumber: {
        id: "confluence.textfield.validator.number",
        defaultMessage: "Enter a valid number"
    },
    validEmail: {
        id: "confluence.textfield.validator.email",
        defaultMessage: "Enter a valid email."
    },
    validTelephone: {
        id: "confluence.textfield.validator.telephone",
        defaultMessage: "Enter a valid telephone."
    },
    requiredFieldMessage: {
        id: "confluence.textfield.validator.required.field.message",
        defaultMessage: "This field is required."
    }
});





const $fc4f6995b570b23c$var$AKTextField = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7DC2K")));

const $fc4f6995b570b23c$var$AKErrorMessage = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.ErrorMessage
        })));

const $fc4f6995b570b23c$var$AKField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.Field
        })));

const $fc4f6995b570b23c$var$AKHelperMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.HelperMessage
        })));
const $fc4f6995b570b23c$var$isValidType = (type)=>{
    return [
        'text',
        'number',
        'email',
        'tel',
        'password'
    ].includes(type);
};
function $fc4f6995b570b23c$var$TextField({ type: type = 'text', name: name, label: label, description: description, placeholder: // description about the field
placeholder, isRequired: isRequired = false, defaultValue: defaultValue = '', testId: testId, autoComplete: autoComplete }) {
    const validate = (0, $160238b3cd7f3114$export$175ffc4a72fd9f6d)(isRequired, type);
    // WARNING: for <input type=number> and React, native validation is strange, use type text
    const fieldType = !$fc4f6995b570b23c$var$isValidType(type) || type === 'number' ? 'text' : type;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3d18012f6ad4f2f5$export$b5c4b0e7cd7f148b), null, /*#__PURE__*/ (0, $9K4OG.jsx)($fc4f6995b570b23c$var$AKField, {
        name: name,
        label: label,
        defaultValue: defaultValue,
        isRequired: isRequired,
        validate: validate
    }, ({ fieldProps: fieldProps })=>{
        const { id: id, isDisabled: isDisabled, isInvalid: isInvalid, onBlur: onBlur, onFocus: onFocus, value: value, onChange: onChange, 'aria-labelledby': ariaLabelledBy } = fieldProps;
        const error = isInvalid ? validate(value) : null;
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $051f12b2e6795f2a$export$56c425463976216f), {
            name: name,
            value: value
        }), /*#__PURE__*/ (0, $9K4OG.jsx)($fc4f6995b570b23c$var$AKTextField, {
            type: fieldType,
            testId: testId,
            placeholder: placeholder,
            autoComplete: autoComplete,
            onFocus: onFocus,
            onBlur: onBlur,
            isDisabled: isDisabled,
            id: id,
            isInvalid: isInvalid,
            "aria-labelledby": ariaLabelledBy,
            defaultValue: defaultValue,
            onChange: onChange
        }), error ? /*#__PURE__*/ (0, $9K4OG.jsx)($fc4f6995b570b23c$var$AKErrorMessage, null, error) : null, description ? /*#__PURE__*/ (0, $9K4OG.jsx)($fc4f6995b570b23c$var$AKHelperMessage, null, description) : null);
    }));
}
var $fc4f6995b570b23c$export$2e2bcd8739ae039 = $fc4f6995b570b23c$var$TextField;
const $fc4f6995b570b23c$export$13e56753353ca8c = ({ props: props })=>{
    const { name: name, label: label, type: type, description: description, defaultValue: defaultValue, isRequired: isRequired, placeholder: placeholder, autoComplete: autoComplete } = props;
    return /*#__PURE__*/ (0, $9K4OG.jsx)($fc4f6995b570b23c$var$TextField, {
        type: type,
        name: name,
        label: label,
        defaultValue: defaultValue,
        isRequired: isRequired,
        description: description,
        placeholder: placeholder,
        autoComplete: autoComplete
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






function $b7e773ce945c54b2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $b7e773ce945c54b2$var$AKToggle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("j5Cmc")).then((module)=>({
            default: module.default
        })));

const $b7e773ce945c54b2$var$AKField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.Field
        })));
const $b7e773ce945c54b2$var$wrapperStyles = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
const $b7e773ce945c54b2$var$labelStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $b7e773ce945c54b2$var$Toggle = ({ name: name, defaultChecked: defaultChecked, testId: testId, label: label })=>/*#__PURE__*/ (0, $9K4OG.jsx)($b7e773ce945c54b2$var$AKField, {
        defaultValue: defaultChecked,
        name: name
    }, ({ fieldProps: fieldProps })=>{
        const { onChange: onChange, value: value, id: id, isDisabled: isDisabled, onBlur: onBlur, onFocus: onFocus, name: toggleName } = fieldProps;
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $b7e773ce945c54b2$var$wrapperStyles
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $051f12b2e6795f2a$export$56c425463976216f), {
            name: name,
            value: value
        }), /*#__PURE__*/ (0, $9K4OG.jsx)($b7e773ce945c54b2$var$AKToggle, {
            onChange: onChange,
            isChecked: value,
            size: "large",
            label: label,
            testId: testId,
            id: id,
            isDisabled: isDisabled,
            onBlur: onBlur,
            onFocus: onFocus,
            name: toggleName
        }), /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            css: $b7e773ce945c54b2$var$labelStyles,
            onClick: ()=>onChange(!value)
        }, label));
    });
var $b7e773ce945c54b2$export$2e2bcd8739ae039 = $b7e773ce945c54b2$var$Toggle;
const $b7e773ce945c54b2$export$65f25b46bc78faae = ({ props: props })=>{
    const { name: name, label: label, defaultChecked: defaultChecked } = props;
    return /*#__PURE__*/ (0, $9K4OG.jsx)($b7e773ce945c54b2$var$Toggle, {
        name: name,
        label: label,
        defaultChecked: defaultChecked
    });
};






const $32a10de568a6c426$var$AKTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("dWRcP")));
const $32a10de568a6c426$var$Tooltip = ({ text: text, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($32a10de568a6c426$var$AKTooltip, {
        content: text
    }, children);
var $32a10de568a6c426$export$2e2bcd8739ae039 = $32a10de568a6c426$var$Tooltip;
const $32a10de568a6c426$export$243693318987dcde = ({ props: props, children: children, Components: Components, render: render, renderChildren: renderChildren, dispatch: dispatch })=>{
    const { text: text } = props;
    const renderedChildren = renderChildren({
        Components: Components,
        children: children,
        render: render,
        dispatch: dispatch
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($32a10de568a6c426$var$Tooltip, {
        text: text
    }, Array.isArray(renderedChildren) ? renderedChildren[0] : renderedChildren);
};







var $cO1el = parcelRequire("cO1el");

function $c7292c6d1b431c1a$export$a8a3e93435678ff9({ size: size = 'medium', children: children }) {
    if (size === 'large') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xlarge"
    }, children);
    if (size === 'small') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, children);
    // size === 'medium'
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "medium"
    }, children);
}
var $c7292c6d1b431c1a$export$2e2bcd8739ae039 = $c7292c6d1b431c1a$export$a8a3e93435678ff9;
function $c7292c6d1b431c1a$export$fad8cd1e3bc5cd8a({ Components: Components, props: props, children: children, renderChildren: renderChildren, dispatch: dispatch, render: render }) {
    const { size: size } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c7292c6d1b431c1a$export$a8a3e93435678ff9, {
        size: size
    }, renderChildren({
        Components: Components,
        children: children,
        render: render,
        dispatch: dispatch
    }));
}



var $jLYRk = parcelRequire("jLYRk");





var $2XqLN = parcelRequire("2XqLN");

const $b88d3552b5359800$export$56cc4e6ad1676196 = (0, $2XqLN.default)((dispatch)=>(legacyEffects)=>{
        return Promise.all((Array.isArray(legacyEffects) ? legacyEffects : [
            legacyEffects
        ]).map((legacyEffect)=>{
            switch(legacyEffect.type){
                case 'initialize':
                    return dispatch({
                        type: 'render',
                        extensionData: {}
                    });
                case 'event':
                    return dispatch({
                        type: 'event',
                        handler: legacyEffect.handler,
                        args: legacyEffect.args,
                        extensionData: {}
                    });
                default:
                    throw Error(`Cannot dispatch "${legacyEffect.type}" effect`);
            }
        })).then(()=>{});
    });
const $b88d3552b5359800$export$d3f7e791718dec1c = (Comp)=>({ forgeDoc: forgeDoc, render: render, dispatch: dispatch })=>{
        const { children: children, key: key, props: props, type: type } = forgeDoc;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Comp, {
            type: type,
            key: key,
            props: props,
            dispatch: $b88d3552b5359800$export$56cc4e6ad1676196(dispatch),
            children: children,
            Components: {} /* no components actually use this component map */ ,
            render: (props)=>render(props.aux),
            renderChildren: (props)=>props.children.map(render)
        });
    };


const $ab8fc5e500e17686$export$65fce8c2f2babb3e = {
    Badge: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $1dc316a623d24040$export$c07d87ab1594bff4)),
    Button: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a42d48f6837420c9$export$353f5b6fc5456de1), {
            ...args,
            key: args.forgeDoc.key
        }),
    ButtonSet: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $5ff27bb82b284c52$export$1ff560ec9540c1a9)),
    CheckboxGroup: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $7d448eb063ac9d6b$export$b78851756f45833b)),
    Code: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $16e3655ad2cab112$export$9f067e9ed3ed058)),
    DateLozenge: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $b3d700e86f5ab7b3$export$607d2293d1fe73f9)),
    DatePicker: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $a50e7fe929d36a1e$export$946840bece97c37)),
    Em: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $jLYRk.EmFn)),
    ErrorPanel: (0, $gvvHu.ErrorPanelRenderFn),
    Form: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $051f12b2e6795f2a$export$a7fed597f4b8afd8), {
            ...args,
            key: args.forgeDoc.key
        }),
    FormCondition: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $32b8fbcc01788bcc$export$5063d3d804b7f0da)),
    Heading: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $c7292c6d1b431c1a$export$fad8cd1e3bc5cd8a)),
    Image: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $8f85478b37fe897b$export$f62f254e0954ca34)),
    InlineDialog: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7e8ee93f9359bd7$export$c7313f750e9cbc9d), {
            ...args,
            key: args.forgeDoc.key
        }),
    Link: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $jLYRk.LinkFn)),
    ModalDialog: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $30d941e03f46872c$export$1fa217be60c2f188), {
            ...args,
            key: args.forgeDoc.key
        }),
    RadioGroup: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $3dee357baf0d8c03$export$306cd3e63a0f2f51)),
    Range: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $a39f1476ebe09a75$export$da0b73f16fbcfd59)),
    SectionMessage: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $c0aa0bb1af76a24d$export$8376ed98c8f93829)),
    Select: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $22effabcab7a648e$export$747c8c62a73d26b4)),
    StatusLozenge: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $a9fcfda387e3540d$export$3cc3ebecc7f239e9)),
    Strike: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $jLYRk.StrikeFn)),
    String: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $jLYRk.StringFn)),
    Strong: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $jLYRk.StrongFn)),
    Table: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $f42d8d47d2541350$export$d1aa90943bebe2eb)),
    Tabs: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $d6f185b59b4c46eb$export$79714c2052a995e9)),
    Tag: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $a07ec5c4d0f3df05$export$3ee92cd923c64da4)),
    TagGroup: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $3d126440aa917d8a$export$95fa80966968aa57)),
    Text: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $a832f0cd6ed31fad$export$c703e634d6a416c6)),
    TextArea: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $e6aaecc72491f49a$export$7c39c70ba43929a0)),
    TextField: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $fc4f6995b570b23c$export$13e56753353ca8c)),
    Toggle: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $b7e773ce945c54b2$export$65f25b46bc78faae)),
    Tooltip: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $32a10de568a6c426$export$243693318987dcde)),
    View: (0, $b88d3552b5359800$export$d3f7e791718dec1c)((0, $e557af5bc1407d1c$export$9dd2b28001e5a44e))
};


/* internalComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");




const $7d5c5ef067e646f8$export$ffb0004e005737fa = ({ forgeDoc: forgeDoc, render: render })=>/*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, forgeDoc.children.map(render));
const $7d5c5ef067e646f8$export$be92b6f5f03c0fe9 = ({ forgeDoc: forgeDoc, render: render })=>{
    const { children: children } = forgeDoc;
    return /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_1qhqze3t _1jzaze3t _1bgsze3t _9b1aze3t _cog4ze3t _1gbhze3t"
        ])
    }, children.map(render));
};









var $7CLBv = parcelRequire("7CLBv");


var $dh538 = parcelRequire("dh538");


var $iXCQx = parcelRequire("iXCQx");


var $2Nwuj = parcelRequire("2Nwuj");


var $gIr1J = parcelRequire("gIr1J");





var $inPa6 = parcelRequire("inPa6");


var $6oQb1 = parcelRequire("6oQb1");


var $5U2YR = parcelRequire("5U2YR");

const $19eebf227db1d91e$export$5f39eab89195003c = (doc, componentCountMap)=>{
    if (!doc.props) return;
    Object.keys(doc.props).forEach((propName)=>{
        if (propName === 'children') return;
        const componentName = doc.type;
        if (componentCountMap[componentName].propCount[propName] !== undefined) componentCountMap[componentName].propCount[propName] += 1;
        else componentCountMap[componentName].propCount[propName] = 1;
    });
};
const $19eebf227db1d91e$var$getIconInformation = (doc, componentCountMap)=>{
    if (doc.type !== 'Icon' || !doc.props) return;
    const { glyph: glyph, primaryColor: primaryColor, secondaryColor: secondaryColor } = doc.props;
    if (!componentCountMap.Icon.uniqueGlyphs) componentCountMap.Icon.uniqueGlyphs = new Set();
    if (glyph) componentCountMap.Icon.uniqueGlyphs.add(glyph);
    // TODO: Stop tracking these props once they have been removed from the code base
    // https://ecosystem-platform.atlassian.net/browse/EXT-3350
    if (!componentCountMap.Icon.deprecatedPropsList) componentCountMap.Icon.deprecatedPropsList = new Set();
    if (primaryColor) componentCountMap.Icon.deprecatedPropsList.add('primaryColor');
    if (secondaryColor) componentCountMap.Icon.deprecatedPropsList.add('secondaryColor');
};
// Recursive function to get the total number of components and total number of props on a component
const $19eebf227db1d91e$var$getCountAnalytics = (forgeDoc, componentCountMap = {}, visitors = [])=>{
    const componentName = forgeDoc.type;
    // Type String is not a component
    if (componentName === 'String') return componentCountMap;
    // Don't send Root count as it's always one
    if (componentName !== 'Root') {
        const hasComponentEncountered = componentCountMap[componentName] !== undefined;
        if (hasComponentEncountered) componentCountMap[componentName].componentCount += 1;
        else componentCountMap[componentName] = {
            componentCount: 1,
            propCount: {}
        };
        // Call all visitor functions
        visitors.forEach((visitor)=>{
            visitor(forgeDoc, componentCountMap);
        });
    }
    forgeDoc.children.forEach((forgeDocChild)=>{
        $19eebf227db1d91e$var$getCountAnalytics(forgeDocChild, componentCountMap, visitors);
    });
    return componentCountMap;
};
const $19eebf227db1d91e$var$createKey = (countMap)=>{
    let key = '';
    Object.keys(countMap).sort().forEach((componentName)=>{
        key += `${componentName}${countMap[componentName].componentCount}`;
    });
    return key;
};
const $19eebf227db1d91e$export$a0feef3ec4af33b4 = ({ forgeDoc: forgeDoc, forgeEnvironment: forgeEnvironment, UIKitVersion: UIKitVersion })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { page: source } = (0, $5U2YR.useMetricsContext)();
    const prevCountMap = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef({});
    if (forgeDoc === undefined) return;
    const componentCount = $19eebf227db1d91e$var$getCountAnalytics(forgeDoc, {}, [
        $19eebf227db1d91e$export$5f39eab89195003c,
        $19eebf227db1d91e$var$getIconInformation
    ]);
    const componentCountAsKey = $19eebf227db1d91e$var$createKey(componentCount);
    // converting to a string here as a safety measure against mutations to the original forgeDoc object
    const forgeReactMajorVersion = forgeDoc.forgeReactMajorVersion?.toString() ?? null;
    // compare if a previous count has already been sent for analytics
    if (!prevCountMap.current.hasOwnProperty(componentCountAsKey)) {
        prevCountMap.current = {
            ...prevCountMap.current,
            [componentCountAsKey]: true
        };
        // NOTE: createAnalyticsEvent has a side effect of potentially mutating objects that are passed into it
        // Any objects passed in should not be reused or must be deep cloned first
        const components = {};
        for(let componentName in componentCount)if (componentName === 'Icon') components[componentName] = {
            count: componentCount[componentName].componentCount,
            propCount: componentCount[componentName].propCount,
            uniqueGlyphs: Array.from(componentCount[componentName].uniqueGlyphs ?? []),
            deprecatedPropsList: Array.from(componentCount[componentName].deprecatedPropsList ?? [])
        };
        else components[componentName] = {
            count: componentCount[componentName].componentCount,
            propCount: componentCount[componentName].propCount
        };
        (0, $6oQb1.trackComponentUsageRendered)(createAnalyticsEvent, {
            source: source,
            isLegacyUiKit: UIKitVersion === '1',
            forgeEnvironment: forgeEnvironment,
            components: components,
            forgeReactMajorVersion: forgeReactMajorVersion
        });
    }
};



var $gGmck = parcelRequire("gGmck");


var $aoVih = parcelRequire("aoVih");


var $1nSBE = parcelRequire("1nSBE");


var $ahOA5 = parcelRequire("ahOA5");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $cc2a49e40ee2e925$var$containerStyles = null;
const $cc2a49e40ee2e925$var$overlayStyles = null; /**
                             * Experimental component for wrapping UI Kit components with a skeleton overlay as a loading indicator.
                             */ 
const $cc2a49e40ee2e925$export$39d092904daf68db = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswh2mm _1e0c1o8l"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rko12b0 _kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _bfhk7qp0 _lcxv1wug _1pbyb4wl"
        ])
    }), children);









var $jed12 = parcelRequire("jed12");


var $durRy = parcelRequire("durRy");


var $cUcZ5 = parcelRequire("cUcZ5");

const $e0c91e5c3783b9b5$var$Fragment = 'Fragment';
// Handles the different cases of React's fragment component
const $e0c91e5c3783b9b5$var$isReactFragment = (type)=>type === 'Symbol(react.fragment)' || type === 'fragment' || type === undefined;
// Filter out any children that contain only whitespace
const $e0c91e5c3783b9b5$var$filterEmptyReactChildren = (children)=>{
    // Ensuring children is an array here as single elements will be an object
    // React.Children.toArray is not used as certain components could be passing JSX as an object to elementToForgeDoc
    const childrenAsArray = Array.isArray(children) ? children : [
        children
    ];
    return childrenAsArray.filter((child)=>!!child && (typeof child !== 'string' || child.trim() !== ''));
};
// converts react element(s) to forgeDoc(s) recursively
// and additionally prune and cleanup unnecessary empty fragments
const $e0c91e5c3783b9b5$var$elementToForgeDocConversionWithFragmentHandling = (elem, isRoot = false)=>{
    // Handles string child for components
    if (typeof elem === 'string' || typeof elem === 'number') return {
        type: 'String',
        props: {
            text: elem
        },
        children: []
    };
    else if (Array.isArray(elem)) return elem.flatMap((e)=>$e0c91e5c3783b9b5$var$elementToForgeDocConversionWithFragmentHandling(e));
    else if (typeof elem === 'object') {
        let type = elem.type?.toString();
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const key = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        if ($e0c91e5c3783b9b5$var$isReactFragment(type)) {
            type = $e0c91e5c3783b9b5$var$Fragment;
            if (!isRoot) {
                const { children: children } = elem.props;
                return $e0c91e5c3783b9b5$var$elementToForgeDocConversionWithFragmentHandling($e0c91e5c3783b9b5$var$filterEmptyReactChildren(children));
            }
        }
        // Remove children from props as we handle them separately
        const { children: children, ...rest } = elem.props;
        const props = rest;
        return {
            type: type,
            key: key,
            props: props,
            children: $e0c91e5c3783b9b5$var$elementToForgeDocConversionWithFragmentHandling($e0c91e5c3783b9b5$var$filterEmptyReactChildren(children))
        };
    }
    throw new Error(`Can\'t create ForgeDoc from ${elem}`);
};
const $e0c91e5c3783b9b5$export$1b341f978fa5ef9a = (elem)=>{
    const forgeDoc = $e0c91e5c3783b9b5$var$elementToForgeDocConversionWithFragmentHandling(elem, true);
    if (Array.isArray(forgeDoc)) throw new Error('Multiple root fragments are not supported');
    return forgeDoc;
};


/* makeMockUser.tsx generated by @compiled/babel-plugin v0.36.1 */ 














var $kpdGL = parcelRequire("kpdGL");

var $esRft = parcelRequire("esRft");


var $c4sKh = parcelRequire("c4sKh");

const $02bccb0809764c56$var$containerStyle = null;
const $02bccb0809764c56$var$messages = (0, $cgtv4.defineMessages)({
    unknownUser: {
        id: "confluence.user.unknown.user.message",
        defaultMessage: "Unknown User"
    }
});
const $02bccb0809764c56$var$Avatar = ({ name: name, picture: picture, hideDisplayName: hideDisplayName })=>{
    if (hideDisplayName) return /*#__PURE__*/ $42omo.createElement((0, $esRft.default), {
        name: name,
        src: picture
    });
    return /*#__PURE__*/ $42omo.createElement("div" // Reduce Atlaskit padding to vertically-align with other components
    , {
        className: (0, $gMc0m.default)([
            "_1gzjidpf _1plv1j28 _1r3373ad"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $kpdGL.default), {
        avatar: /*#__PURE__*/ $42omo.createElement((0, $esRft.default), {
            name: name,
            src: picture
        }),
        primaryText: name
    }));
};
function $02bccb0809764c56$var$UserInline({ name: name }) {
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ $42omo.createElement((0, $c4sKh.default), {
        appearance: "primary"
    }, name || intl.formatMessage($02bccb0809764c56$var$messages.unknownUser));
}
const $02bccb0809764c56$var$User = ({ hideDisplayName: hideDisplayName })=>{
    const name = 'John Smith';
    const picture = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAAAAAByaaZbAAAAzklEQVRIx9XUwQqDMAwGYN//2QKFQg4FQSj0IBQKhR5ycmMb00QlzUHc/puHr0j6p8NizPA/oFYygIzwDOZeEOCTQF0A4RukDhBgk6CDDCxZBZ4Dr4ECIkUBkwSTAlACVADscj2gu3/JPCXzPZhv2twle1vN+2DfOPtO218N+7t05VPZUtiOBiGkdg5a9HyY7wH7WA9BXW/MvU5tbi1I3YPKGpGI0nEHh5PSOSe+SYACSmYBRg14AUANMVB0MDMQdTAygDrwDEBHbmrrL4AHJIhvOJxwJfcAAAAASUVORK5CYII=';
    const { inline: inline } = (0, $9UyM5.useInlineContext)();
    if (!picture && !name) return null;
    if (inline) return /*#__PURE__*/ $42omo.createElement($02bccb0809764c56$var$UserInline, {
        name: name
    });
    return /*#__PURE__*/ $42omo.createElement($02bccb0809764c56$var$Avatar, {
        name: name,
        picture: picture,
        hideDisplayName: hideDisplayName
    });
}; // new approach requires ApolloClient as a prop
const $02bccb0809764c56$export$b6d1fca43cd2f8ac = ()=>{
    return function UserFnNext({ forgeDoc: { props: props } }) {
        const { accountId: accountId, hideDisplayName: hideDisplayName } = props;
        return /*#__PURE__*/ $42omo.createElement($02bccb0809764c56$var$User, {
            accountId: accountId,
            hideDisplayName: hideDisplayName
        });
    };
};



var $hEvav = parcelRequire("hEvav");

// set of components that should be wrapped with the experimental skeleton overlay
const $df586e6e6454f62e$var$COMPONENTS_TO_WRAP = {
    Button: true,
    Heading: true,
    Image: true,
    Link: true,
    Text: true,
    Textfield: true
};
const $df586e6e6454f62e$export$3baf935914e5d656 = (componentType)=>{
    return $df586e6e6454f62e$var$COMPONENTS_TO_WRAP[componentType];
};
const $df586e6e6454f62e$export$b65b83ec73ff6a54 = ({ elem: elem, config: config, shouldWrapWithSkeletonOverlay: shouldWrapWithSkeletonOverlay = false })=>{
    const forgeDoc = (0, $e0c91e5c3783b9b5$export$1b341f978fa5ef9a)(elem);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2E5.default), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jed12.default), {
        shouldWrapWithSkeletonOverlay: shouldWrapWithSkeletonOverlay,
        forgeDoc: {
            ...forgeDoc,
            forgeReactMajorVersion: config?.forgeReactMajorVersion
        },
        extension: {},
        // @ts-ignore dispatch is not used
        dispatch: ()=>{},
        components: (defaults)=>({
                ...defaults,
                User: config?.client ? (0, $hEvav.makeUser)({
                    client: config?.client
                }) : (0, $02bccb0809764c56$export$b6d1fca43cd2f8ac)(),
                UserGroup: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, "Mock User Group"),
                UserPicker: (0, $durRy.makeMockUserPicker)({
                    query: ()=>Promise.resolve([
                            {
                                id: '1',
                                name: 'John',
                                avatarUrl: '',
                                type: 'user'
                            },
                            {
                                id: '2',
                                name: 'Jane',
                                avatarUrl: '',
                                type: 'user'
                            }
                        ])
                }),
                // Handles React's fragment component in VR tests for UI kit 2(non-codegen)
                Fragment: ({ forgeDoc: forgeDoc, render: render })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, forgeDoc.children.map(render)),
                ...config?.components
            }),
        isNative: true,
        loading: true
    }));
};





const $6c27856e6e241b8f$export$7a0a827f8287b06d = (componentType, forgeEnvironment)=>{
    if (forgeEnvironment === 'PRODUCTION') return;
    if (componentType === 'Heading') (0, $1nSBE.default)(`[@forge/react: Heading] Warning: The functionality of the "as" prop is being updated and should no longer be used to determine heading sizes. To avoid breaking changes, migrate to using the "size" prop. For more details, visit: https://atlassian.design/components/heading`);
};
const $6c27856e6e241b8f$export$21a8719ce41a1de2 = (componentMap, componentType)=>{
    if (componentType === 'User' || componentType === 'Avatar') return componentMap['User'] || componentMap['Avatar'];
    if (componentType === 'UserGroup' || componentType === 'AvatarStack') return componentMap['UserGroup'] || componentMap['AvatarStack'];
    return componentMap[componentType];
};
const $6c27856e6e241b8f$var$isAlignFormButtonsEnd = (extensionType, forgeDoc)=>{
    // Confluence Byline and ContextMenu Forge apps with a Form component as
    // there only child shifts the form buttons to the end in the footer
    return (extensionType === (0, $1c598.ConfluenceExtension).BYLINE || extensionType === (0, $1c598.ConfluenceExtension).CONTEXT_MENU) && forgeDoc.children[0]?.type === 'Form';
};
const $6c27856e6e241b8f$var$forgeDocWithModalComponent = (forgeDoc, modalExtension)=>{
    const { closeModalExtension: closeModalExtension, title: title, modalWidth: modalWidth, onSubmitSuccess: onSubmitSuccess } = modalExtension;
    // ModalDialog component sets the default width to `medium`
    const akModalWidth = modalWidth ? (0, $gIr1J.getADSModalWidth)(modalWidth) : undefined;
    const forgeDocWithModal = {
        ...forgeDoc,
        children: [
            {
                type: 'ModalDialog',
                props: {
                    onClose: closeModalExtension,
                    header: title,
                    width: akModalWidth,
                    onSubmitSuccess: onSubmitSuccess
                },
                children: forgeDoc.children
            }
        ]
    };
    return forgeDocWithModal;
};
const $6c27856e6e241b8f$var$forgeDocWithFormEndButtons = (forgeDoc)=>{
    if (forgeDoc.children.length === 0) return forgeDoc;
    return {
        ...forgeDoc,
        children: [
            {
                ...forgeDoc.children[0],
                props: {
                    ...forgeDoc.children[0].props,
                    alignFooterButtons: 'end'
                }
            }
        ]
    };
};
const $6c27856e6e241b8f$var$forgeDocWithAdditionalProps = (forgeDoc, additionalProps)=>{
    return {
        ...forgeDoc,
        props: {
            ...forgeDoc.props,
            ...additionalProps
        }
    };
};
const $6c27856e6e241b8f$export$c18f98553e983d72 = ({ forgeDoc: forgeDoc, error: error, customRenderErrorFn: customRenderErrorFn, components: components, dispatch: dispatch, modalExtension: modalExtension, extensionType: extensionType, isNative: isNative, onSuccess: onSuccess, client: client, extension: extension, shouldWrapWithSkeletonOverlay: shouldWrapWithSkeletonOverlay = false })=>{
    const { forgeEnvironment: forgeEnvironment } = (0, $42omo.useContext)((0, $gGmck.RendererContext));
    (0, $19eebf227db1d91e$export$a0feef3ec4af33b4)({
        forgeDoc: forgeDoc,
        forgeEnvironment: forgeEnvironment ?? 'DEVELOPMENT',
        UIKitVersion: isNative ? '2' : '1'
    });
    const intl = (0, $8C5kA.default)();
    const render = (forgeDoc)=>{
        $6c27856e6e241b8f$export$7a0a827f8287b06d(forgeDoc.type, forgeEnvironment ?? 'DEVELOPMENT');
        // Restricts FilePicker and FileCard components to only be used in EAP
        if ((!(0, $dh538.fg)('forge-ui-display-object-store-components') || forgeEnvironment === 'PRODUCTION') && (forgeDoc.type === 'FilePicker' || forgeDoc.type === 'FileCard')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
            appearance: "error"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, intl.formatMessage({
            id: "/ntsJi",
            defaultMessage: "FilePicker and FileCard components are in EAP. To start testing,"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            href: "https://ecosystem.atlassian.net/servicedesk/customer/portal/1040/group/3496/create/18937",
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, intl.formatMessage({
            id: "b3bA6/",
            defaultMessage: "sign up here"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, "."));
        const renderFn = $6c27856e6e241b8f$export$21a8719ce41a1de2(components, forgeDoc.type);
        if (!renderFn) {
            if (customRenderErrorFn) customRenderErrorFn(forgeDoc.type);
            else throw new Error(`Error rendering app - encountered unknown component ${forgeDoc.type}.`);
        }
        onSuccess && onSuccess();
        const forgeDocWithLabel = (0, $dh538.fg)('eco_fcf_select_a11y_fix') ? $6c27856e6e241b8f$var$forgeDocWithAdditionalProps(forgeDoc, {
            label: extension?.properties?.name
        }) : forgeDoc;
        if (shouldWrapWithSkeletonOverlay && (0, $df586e6e6454f62e$export$3baf935914e5d656)(forgeDocWithLabel.type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cc2a49e40ee2e925$export$39d092904daf68db), null, renderFn({
            forgeDoc: forgeDocWithLabel,
            dispatch: dispatch,
            render: render
        }));
        return renderFn({
            forgeDoc: forgeDocWithLabel,
            dispatch: dispatch,
            render: render
        });
    };
    if (error) return modalExtension ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahOA5.ForgeExtensionPointModal), {
        modalExtension: modalExtension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: "Something went wrong",
        appearance: "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, error))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: "Something went wrong",
        appearance: "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, error));
    if (!forgeDoc) return null;
    // Extensions rendered in a modal for version 10 and onwards are handled here.
    // This is the default behavior for handles model extensions across product modules.
    // When the modelExtension prop is present, and the forgeReactMajorVersion is 10 or higher,
    // the provided foreDoc is rendered within a Modal component with the provided modalExtension props.
    // This setup is to ensure that the modal extension is rendered correctly across all product modules,
    // and is the resolution for the HOT described in: https://ops.internal.atlassian.com/jira/browse/HOT-108146
    if (forgeDoc.forgeReactMajorVersion && forgeDoc.forgeReactMajorVersion >= 10 && modalExtension) {
        const isFirstChildAForm = forgeDoc.children[0]?.type === 'Form';
        const { onSubmitSuccess: onSubmitSuccess } = modalExtension;
        // injects onSubmitSuccess to into the Form component submit handler
        if (isFirstChildAForm) {
            // doing a deep clone here to make a copy of onSubmit
            const formPropsCopy = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(forgeDoc.children[0].props);
            forgeDoc.children[0].props = {
                ...formPropsCopy,
                onSubmit: async ()=>{
                    const isSuccess = await formPropsCopy.onSubmit();
                    if (onSubmitSuccess && (isSuccess === true || isSuccess === undefined)) onSubmitSuccess();
                }
            };
        }
        const shouldShowFCFModalDeprecationMessage = (extensionType === (0, $1c598.JiraExtension).CUSTOM_FIELD || extensionType === (0, $1c598.JiraExtension).CUSTOM_FIELD_TYPE) && !(0, $dh538.fg)('forge_disable_fcf_modal_experience_on_issue_view');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahOA5.ForgeExtensionPointModal), {
            modalExtension: modalExtension,
            shouldShowFCFModalDeprecationMessage: shouldShowFCFModalDeprecationMessage,
            client: client,
            extension: extension
        }, render(forgeDoc));
    }
    const newForgeDoc = extensionType && $6c27856e6e241b8f$var$isAlignFormButtonsEnd(extensionType, forgeDoc) ? $6c27856e6e241b8f$var$forgeDocWithFormEndButtons(forgeDoc) : forgeDoc;
    const extensionForgeDoc = modalExtension ? $6c27856e6e241b8f$var$forgeDocWithModalComponent(newForgeDoc, modalExtension) : newForgeDoc;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, render(extensionForgeDoc));
};






var $dx0OV = parcelRequire("dx0OV");






// Convert child to number if possible
// Badge `max` prop will only work if the child is a number
const $637faf3c7a4c907e$var$getBadgeChildren = (forgeDoc)=>{
    const child = forgeDoc.children?.[0]?.props?.text;
    if (child && !isNaN(Number(child))) return Number(child);
    return child;
};
const $637faf3c7a4c907e$export$bf0162d825d6e13 = {
    appearance: true,
    /**
	 * The value displayed within the badge. A badge should only be used in cases where you want to represent a number. Use a lozenge for non-numeric information.
	 *
	 * @type string | number
	 */ children: {
        value: 'getBadgeChildren(props.forgeDoc)'
    },
    max: true,
    testId: true
};
const $637faf3c7a4c907e$export$37acb3580601e69a = (props)=>{
    const { appearance: appearance, max: max, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
        appearance: appearance,
        children: $637faf3c7a4c907e$var$getBadgeChildren(props.forgeDoc),
        max: max,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

/**
 * The below lint rules are disabled because Box relies on building styles at runtime in Forge apps.
 * This implementation is copied from @atlaskit/primitives/src/components/box.tsx which has the same
 * pattern. The css prop with runtime-computed values is required for the xcss prop to work correctly.
 * See go/DSP-18766 for more context.
 *
 * @atlaskit/design-system/consistent-css-prop-usage is disabled because this component must import
 * shared style maps (backgroundColorStylesMap, surfaceColorStylesMap, paddingStylesMap) for runtime
 * token resolution. Inlining these maps would create unmaintainable code duplication across Box and
 * Pressable components. This is an architectural requirement for Forge UI Kit's token system.
 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage -- Required for runtime xcss resolution with imported token style maps. See explanation above and go/DSP-18766 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values -- Required for token map imports. See go/DSP-18766 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values -- Required for runtime style computation. See go/DSP-18766 */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled







var $5rrZR = parcelRequire("5rrZR");







/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ /**
 * Token maps and utilities for Forge UI Kit
 * 
 * This file contains both:
 * 1. Auto-generated design token maps (between @codegen markers) from @atlaskit/primitives
 * 2. Manually maintained utility functions for working with these tokens
 * 
 * @see https://developer.atlassian.com/platform/forge/ui-kit/components/xcss/
 */ 
var $a9dFP = parcelRequire("a9dFP");




const $5a960931a5ccb935$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
const $5a960931a5ccb935$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
const $5a960931a5ccb935$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
const $5a960931a5ccb935$export$632685d741f3dbbf = {
    ...$5a960931a5ccb935$export$958d0ae7f2977ae4,
    ...$5a960931a5ccb935$export$d2dc61f58390201c
};
const $5a960931a5ccb935$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #BF2600)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #974F0C)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #0747A6)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
const $5a960931a5ccb935$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFBDAD)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FF8F73)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FF7452)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FFF0B3)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FFE380)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FFC400)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #ABF5D1)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #79F2C0)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #57D9A3)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #C0B6F2)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #998DD9)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #8777D9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #B3D4FF)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #4C9AFF)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #2684FF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
const $5a960931a5ccb935$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
const $5a960931a5ccb935$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $5a960931a5ccb935$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
const $5a960931a5ccb935$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
const $5a960931a5ccb935$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
const $5a960931a5ccb935$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
const $5a960931a5ccb935$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
const $5a960931a5ccb935$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
const $5a960931a5ccb935$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $5a960931a5ccb935$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
const $5a960931a5ccb935$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $5a960931a5ccb935$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $5a960931a5ccb935$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
const $5a960931a5ccb935$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $5a960931a5ccb935$export$5e65a44e5b6ecadb = (color)=>$5a960931a5ccb935$export$41a358c9c2356760[color] !== undefined;
const $5a960931a5ccb935$export$ca0f9c2de39ffed7 = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionMap, token)=>{
        emotionMap[token] = /*#__PURE__*/ (0, $9K4OG.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[token]
        });
        return emotionMap;
    }, {});
};
const $5a960931a5ccb935$export$e7af83bafe7f9e63 = $5a960931a5ccb935$export$ca0f9c2de39ffed7('backgroundColor', $5a960931a5ccb935$export$d1d79bf68ac056bd);
const $5a960931a5ccb935$export$ff257d957d48c421 = $5a960931a5ccb935$export$ca0f9c2de39ffed7((0, $a9dFP.CURRENT_SURFACE_CSS_VAR), $5a960931a5ccb935$export$41a358c9c2356760);
const $5a960931a5ccb935$export$e615f061ca585a6c = {
    padding: $5a960931a5ccb935$export$ca0f9c2de39ffed7('padding', $5a960931a5ccb935$export$958d0ae7f2977ae4),
    paddingBlock: $5a960931a5ccb935$export$ca0f9c2de39ffed7('paddingBlock', $5a960931a5ccb935$export$958d0ae7f2977ae4),
    paddingBlockStart: $5a960931a5ccb935$export$ca0f9c2de39ffed7('paddingBlockStart', $5a960931a5ccb935$export$958d0ae7f2977ae4),
    paddingBlockEnd: $5a960931a5ccb935$export$ca0f9c2de39ffed7('paddingBlockEnd', $5a960931a5ccb935$export$958d0ae7f2977ae4),
    paddingInline: $5a960931a5ccb935$export$ca0f9c2de39ffed7('paddingInline', $5a960931a5ccb935$export$958d0ae7f2977ae4),
    paddingInlineStart: $5a960931a5ccb935$export$ca0f9c2de39ffed7('paddingInlineStart', $5a960931a5ccb935$export$958d0ae7f2977ae4),
    paddingInlineEnd: $5a960931a5ccb935$export$ca0f9c2de39ffed7('paddingInlineEnd', $5a960931a5ccb935$export$958d0ae7f2977ae4)
};
const $5a960931a5ccb935$export$9a199fbafee0014e = {
    // Background
    backgroundColor: $5a960931a5ccb935$export$d1d79bf68ac056bd,
    // Text color
    color: $5a960931a5ccb935$export$8473307aa00d6ea1,
    // Opacity
    opacity: $5a960931a5ccb935$export$daf94a976c798b4f,
    // Shadow
    boxShadow: $5a960931a5ccb935$export$7aff6e7ba39bb774,
    // Border Color
    borderColor: $5a960931a5ccb935$export$1531ad5bb3fbedac,
    borderBlockColor: $5a960931a5ccb935$export$1531ad5bb3fbedac,
    borderBlockEndColor: $5a960931a5ccb935$export$1531ad5bb3fbedac,
    borderBlockStartColor: $5a960931a5ccb935$export$1531ad5bb3fbedac,
    borderBottomColor: $5a960931a5ccb935$export$1531ad5bb3fbedac,
    borderInlineColor: $5a960931a5ccb935$export$1531ad5bb3fbedac,
    borderInlineEndColor: $5a960931a5ccb935$export$1531ad5bb3fbedac,
    borderInlineStartColor: $5a960931a5ccb935$export$1531ad5bb3fbedac,
    borderLeftColor: $5a960931a5ccb935$export$1531ad5bb3fbedac,
    borderRightColor: $5a960931a5ccb935$export$1531ad5bb3fbedac,
    borderTopColor: $5a960931a5ccb935$export$1531ad5bb3fbedac,
    // Border Radius
    borderRadius: $5a960931a5ccb935$export$3c0a6c3e64bb180d,
    borderBottomLeftRadius: $5a960931a5ccb935$export$3c0a6c3e64bb180d,
    borderBottomRightRadius: $5a960931a5ccb935$export$3c0a6c3e64bb180d,
    borderTopLeftRadius: $5a960931a5ccb935$export$3c0a6c3e64bb180d,
    borderTopRightRadius: $5a960931a5ccb935$export$3c0a6c3e64bb180d,
    borderEndEndRadius: $5a960931a5ccb935$export$3c0a6c3e64bb180d,
    borderEndStartRadius: $5a960931a5ccb935$export$3c0a6c3e64bb180d,
    borderStartEndRadius: $5a960931a5ccb935$export$3c0a6c3e64bb180d,
    borderStartStartRadius: $5a960931a5ccb935$export$3c0a6c3e64bb180d,
    // Border Width
    borderWidth: $5a960931a5ccb935$export$e1b83c5210c471b8,
    borderBlockWidth: $5a960931a5ccb935$export$e1b83c5210c471b8,
    borderBlockEndWidth: $5a960931a5ccb935$export$e1b83c5210c471b8,
    borderBlockStartWidth: $5a960931a5ccb935$export$e1b83c5210c471b8,
    borderBottomWidth: $5a960931a5ccb935$export$e1b83c5210c471b8,
    borderInlineWidth: $5a960931a5ccb935$export$e1b83c5210c471b8,
    borderInlineEndWidth: $5a960931a5ccb935$export$e1b83c5210c471b8,
    borderInlineStartWidth: $5a960931a5ccb935$export$e1b83c5210c471b8,
    borderLeftWidth: $5a960931a5ccb935$export$e1b83c5210c471b8,
    borderRightWidth: $5a960931a5ccb935$export$e1b83c5210c471b8,
    borderTopWidth: $5a960931a5ccb935$export$e1b83c5210c471b8,
    // Padding
    padding: $5a960931a5ccb935$export$958d0ae7f2977ae4,
    paddingBlock: $5a960931a5ccb935$export$958d0ae7f2977ae4,
    paddingBlockStart: $5a960931a5ccb935$export$958d0ae7f2977ae4,
    paddingBlockEnd: $5a960931a5ccb935$export$958d0ae7f2977ae4,
    paddingBottom: $5a960931a5ccb935$export$958d0ae7f2977ae4,
    paddingInline: $5a960931a5ccb935$export$958d0ae7f2977ae4,
    paddingInlineEnd: $5a960931a5ccb935$export$958d0ae7f2977ae4,
    paddingInlineStart: $5a960931a5ccb935$export$958d0ae7f2977ae4,
    paddingLeft: $5a960931a5ccb935$export$958d0ae7f2977ae4,
    paddingRight: $5a960931a5ccb935$export$958d0ae7f2977ae4,
    paddingTop: $5a960931a5ccb935$export$958d0ae7f2977ae4,
    // Margin (can be negative)
    margin: $5a960931a5ccb935$export$632685d741f3dbbf,
    marginBlock: $5a960931a5ccb935$export$632685d741f3dbbf,
    marginBlockEnd: $5a960931a5ccb935$export$632685d741f3dbbf,
    marginBlockStart: $5a960931a5ccb935$export$632685d741f3dbbf,
    marginBottom: $5a960931a5ccb935$export$632685d741f3dbbf,
    marginInline: $5a960931a5ccb935$export$632685d741f3dbbf,
    marginInlineEnd: $5a960931a5ccb935$export$632685d741f3dbbf,
    marginInlineStart: $5a960931a5ccb935$export$632685d741f3dbbf,
    marginLeft: $5a960931a5ccb935$export$632685d741f3dbbf,
    marginRight: $5a960931a5ccb935$export$632685d741f3dbbf,
    marginTop: $5a960931a5ccb935$export$632685d741f3dbbf,
    // Dimensions
    width: $5a960931a5ccb935$export$6ccdbebca2ee545f,
    height: $5a960931a5ccb935$export$6ccdbebca2ee545f,
    minWidth: $5a960931a5ccb935$export$6ccdbebca2ee545f,
    maxWidth: $5a960931a5ccb935$export$6ccdbebca2ee545f,
    minHeight: $5a960931a5ccb935$export$6ccdbebca2ee545f,
    maxHeight: $5a960931a5ccb935$export$6ccdbebca2ee545f
};
const $5a960931a5ccb935$export$f29a18b877db27f8 = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
    const resolved = {};
    for (const [key, value] of Object.entries(styleObj)){
        if (typeof value === 'string') {
            // Only try to resolve if it looks like a token (contains a dot and starts with a letter)
            // This matches @atlaskit/primitives behavior of accepting both tokens and raw CSS
            const looksLikeToken = value.includes('.') && /^[a-z]/.test(value);
            if (looksLikeToken) {
                // Try to resolve as a token
                const tokenMapForProp = $5a960931a5ccb935$export$9a199fbafee0014e[key];
                if (tokenMapForProp && tokenMapForProp[value]) resolved[key] = tokenMapForProp[value];
                else // Token not found - pass through as-is (matches @atlaskit/primitives behavior)
                // The xcssValidator will catch invalid values if needed
                resolved[key] = value;
            } else // Raw CSS value - pass through (matches @atlaskit/primitives behavior)
            resolved[key] = value;
        } else if (typeof value === 'object' && value !== null) // Recursively resolve nested objects
        resolved[key] = $5a960931a5ccb935$export$f29a18b877db27f8(value);
        else // Numbers and other primitives - pass through (e.g. flexGrow: 1)
        resolved[key] = value;
    }
    return resolved;
};
const $5a960931a5ccb935$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    }
};


const $5c1031de888776bc$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $5c1031de888776bc$var$REX_CSS_SIMPLE_STRING_PROP_VALUE = /^[a-zA-Z-]+$/;
const $5c1031de888776bc$var$REX_CSS_WIDTH_PROP_VALUE = /^-?\d+(\.\d+)?(px|em|rem|%)?$/;
/**
 * Maintain a map of old -> new tokens to allow the Design System team to deprecate tokens without impacting Forge APIs
 * Key: old token (i.e. the value used in forge xcss)
 * Value: new token (i.e. the value that should be applied under the hood)
 *
 * This will transform any 'border.radius' value provided via forge xcss into the 'radius.small' token which is supported by platform xcss.
 */ const $5c1031de888776bc$var$tokenReplacementMap = {
    'border.radius': 'radius.small'
};
// Note: we currently support only free formed size related props (e.g. width).
//       the validation logic should be extended to support other props in the future.
const $5c1031de888776bc$var$defaultPropValidator = (rawValue)=>{
    const value = `${rawValue ?? ''}`.trim();
    return $5c1031de888776bc$var$REX_CSS_SIMPLE_STRING_PROP_VALUE.test(value) || $5c1031de888776bc$var$REX_CSS_WIDTH_PROP_VALUE.test(value);
};
const $5c1031de888776bc$var$xcssValidateAndCleanup = (styleObj, supportedXCSSPropsSpec, isRoot = true)=>{
    return Object.entries(styleObj).reduce((targetStyleObj, [key, value])=>{
        if (typeof value === 'object' && $5c1031de888776bc$var$safeSelectors.test(key) && isRoot) {
            // handle the case where the value is a media query or pseudo selector
            const cleanedValue = $5c1031de888776bc$var$xcssValidateAndCleanup(value, supportedXCSSPropsSpec, false);
            if (cleanedValue && Object.keys(cleanedValue).length > 0) targetStyleObj[key] = cleanedValue;
        } else if (value) {
            if (supportedXCSSPropsSpec[key]?.(value)) {
                // handle the case where the value is a design token value of a token prop
                // or a string value of a standard css prop that passes the validator function
                // if defined.
                // Check if the token should be replaced by a different token or value
                if ($5c1031de888776bc$var$tokenReplacementMap[value]) targetStyleObj[key] = $5c1031de888776bc$var$tokenReplacementMap[value];
                else targetStyleObj[key] = value;
            } else // eslint-disable-next-line no-console
            console.warn(`Unexpected XCSS property provided: ${key}: ${value}`);
        } else // in case the prop is not supported.
        // eslint-disable-next-line no-console
        console.warn(`Unsupported XCSS property provided: ${key}: ${value}`);
        return targetStyleObj;
    }, {});
};
const $5c1031de888776bc$var$isSupportedValuesConfig = (config)=>{
    return config !== true && 'supportedValues' in config && Array.isArray(config.supportedValues);
};
/**
 *
 * @param supportedXCSSProps - the list of css props to be supported for the intended component.
 *    If not provided, all the props will be supported. The props could be either standard css props
 *    or design token based props. If the prop is a design token based prop, the value of the prop
 *    will be validated against the design tokens map to ensure the value is a valid design token string.
 * @returns a function that takes a style object and returns a style object with only the supported props
 *    as specified in the supportedXCSSProps list. The props that are not supported will be removed from the
 *    returned style object and a warning will be logged in the console.
 */ const $5c1031de888776bc$export$4b24853998c191ec = (supportedXCSSProps)=>{
    const supportedXCSSPropsSpec = Object.entries(supportedXCSSProps).reduce((acc, [prop, config])=>{
        let validator;
        if (config === true) {
            const tokensMapStyle = (0, $5a960931a5ccb935$export$9a199fbafee0014e)[prop];
            if (tokensMapStyle) {
                const tokenSet = new Set(Object.keys(tokensMapStyle));
                validator = (value)=>tokenSet.has(value);
            } else throw new Error('invalid validation config applied to token only props');
        } else if ($5c1031de888776bc$var$isSupportedValuesConfig(config)) {
            const supportedValues = new Set(config.supportedValues);
            validator = (value)=>supportedValues.has(value);
        } else if (config?.allowCSS === true) validator = $5c1031de888776bc$var$defaultPropValidator;
        if (validator) acc[prop] = validator;
        return acc;
    }, {});
    return (styleObj)=>$5c1031de888776bc$var$xcssValidateAndCleanup(styleObj, supportedXCSSPropsSpec);
};
function $5c1031de888776bc$export$64515584d375f8d(styleObj) {
    const resolved = (0, $5a960931a5ccb935$export$f29a18b877db27f8)(styleObj);
    if ((0, $dh538.fg)('platform_forge_xcss_remove_specificity_hack')) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Runtime xcss style generation
    return /*#__PURE__*/ (0, $9K4OG.css)(resolved);
    // Legacy: increase specificity for backwards compatibility
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Runtime xcss style generation
    return /*#__PURE__*/ (0, $9K4OG.css)({
        '&&': resolved
    });
}


const $18a557183f782deb$var$borderRadiusTokens = [
    'radius.xsmall',
    'radius.small',
    'radius.medium',
    'radius.large',
    'radius.xlarge',
    'radius.full',
    'radius.tile'
];
// `border.radius` is a legacy token that is used in Forge UI. The token was initially supported by ADS but has since been removed.
// Forge needs to continue support this token for backwards compatibility.
const $18a557183f782deb$var$borderRadiusSupportedValues = [
    ...$18a557183f782deb$var$borderRadiusTokens,
    'border.radius'
];
const $18a557183f782deb$export$aa422b2708209a80 = (0, $5c1031de888776bc$export$4b24853998c191ec)({
    // text related props
    textAlign: {
        allowCSS: true
    },
    // color related props
    color: true,
    boxShadow: true,
    opacity: true,
    backgroundColor: true,
    borderColor: true,
    borderBlockColor: true,
    borderBlockEndColor: true,
    borderBlockStartColor: true,
    borderBottomColor: true,
    borderInlineColor: true,
    borderInlineEndColor: true,
    borderInlineStartColor: true,
    borderLeftColor: true,
    borderRightColor: true,
    borderTopColor: true,
    overflow: {
        supportedValues: [
            'hidden',
            'visible',
            'scroll',
            'auto'
        ]
    },
    overflowX: {
        supportedValues: [
            'hidden',
            'visible',
            'scroll',
            'auto'
        ]
    },
    overflowY: {
        supportedValues: [
            'hidden',
            'visible',
            'scroll',
            'auto'
        ]
    },
    // layout and space related props
    display: {
        supportedValues: [
            'block',
            'inline-block',
            'inline',
            'none'
        ]
    },
    flexGrow: {
        allowCSS: true
    },
    width: {
        allowCSS: true
    },
    height: {
        allowCSS: true
    },
    minWidth: {
        allowCSS: true
    },
    maxWidth: {
        allowCSS: true
    },
    minHeight: {
        allowCSS: true
    },
    maxHeight: {
        allowCSS: true
    },
    margin: true,
    marginBlock: true,
    marginBlockEnd: true,
    marginBlockStart: true,
    marginBottom: true,
    marginInline: true,
    marginInlineEnd: true,
    marginInlineStart: true,
    marginLeft: true,
    marginRight: true,
    marginTop: true,
    padding: true,
    paddingBlock: true,
    paddingBlockEnd: true,
    paddingBlockStart: true,
    paddingBottom: true,
    paddingInline: true,
    paddingInlineEnd: true,
    paddingInlineStart: true,
    paddingLeft: true,
    paddingRight: true,
    paddingTop: true,
    // other box related props
    borderRadius: {
        supportedValues: $18a557183f782deb$var$borderRadiusSupportedValues
    },
    borderBottomLeftRadius: {
        supportedValues: $18a557183f782deb$var$borderRadiusSupportedValues
    },
    borderBottomRightRadius: {
        supportedValues: $18a557183f782deb$var$borderRadiusSupportedValues
    },
    borderTopLeftRadius: {
        supportedValues: $18a557183f782deb$var$borderRadiusSupportedValues
    },
    borderTopRightRadius: {
        supportedValues: $18a557183f782deb$var$borderRadiusSupportedValues
    },
    borderEndEndRadius: {
        supportedValues: $18a557183f782deb$var$borderRadiusSupportedValues
    },
    borderEndStartRadius: {
        supportedValues: $18a557183f782deb$var$borderRadiusSupportedValues
    },
    borderStartEndRadius: {
        supportedValues: $18a557183f782deb$var$borderRadiusSupportedValues
    },
    borderStartStartRadius: {
        supportedValues: $18a557183f782deb$var$borderRadiusSupportedValues
    },
    borderWidth: true,
    borderBlockWidth: true,
    borderBlockEndWidth: true,
    borderBlockStartWidth: true,
    borderBottomWidth: true,
    borderInlineWidth: true,
    borderInlineEndWidth: true,
    borderInlineStartWidth: true,
    borderLeftWidth: true,
    borderRightWidth: true,
    borderTopWidth: true,
    // other props not in tokens based props
    borderTopStyle: {
        supportedValues: [
            'dotted',
            'dashed',
            'solid',
            'none',
            'hidden'
        ]
    },
    borderBottomStyle: {
        supportedValues: [
            'dotted',
            'dashed',
            'solid',
            'none',
            'hidden'
        ]
    },
    borderRightStyle: {
        supportedValues: [
            'dotted',
            'dashed',
            'solid',
            'none',
            'hidden'
        ]
    },
    borderLeftStyle: {
        supportedValues: [
            'dotted',
            'dashed',
            'solid',
            'none',
            'hidden'
        ]
    },
    borderStyle: {
        supportedValues: [
            'dotted',
            'dashed',
            'solid',
            'none',
            'hidden'
        ]
    },
    position: {
        supportedValues: [
            'relative',
            'static'
        ]
    }
});




function $9ee6a369e81bb48b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Base styles for the Box component
const $9ee6a369e81bb48b$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};
// Internal Box component implementation (migrated from @atlaskit/primitives)
const $9ee6a369e81bb48b$var$InternalBox = ({ children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, testId: testId, xcss: xcssValue, role: role })=>{
    const node = /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $9ee6a369e81bb48b$var$baseStyles,
            backgroundColor && (0, $5a960931a5ccb935$export$e7af83bafe7f9e63)[backgroundColor],
            (0, $5a960931a5ccb935$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $5a960931a5ccb935$export$ff257d957d48c421)[backgroundColor],
            padding && (0, $5a960931a5ccb935$export$e615f061ca585a6c).padding[padding],
            paddingBlock && (0, $5a960931a5ccb935$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $5a960931a5ccb935$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $5a960931a5ccb935$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $5a960931a5ccb935$export$e615f061ca585a6c).paddingInline[paddingInline],
            paddingInlineStart && (0, $5a960931a5ccb935$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $5a960931a5ccb935$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            xcssValue && (0, $5c1031de888776bc$export$64515584d375f8d)(xcssValue)
        ],
        "data-testid": testId,
        role: role
    }, children);
    // Provide surface context so child components (like Heading) can detect
    // the background color and apply inverse text colors automatically
    return backgroundColor ? // eslint-disable-next-line react/jsx-pascal-case -- UNSAFE_ prefix is from @atlaskit/primitives
    /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5rrZR.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
};
const $9ee6a369e81bb48b$export$e71c4d32a2263218 = (props)=>{
    const { padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, backgroundColor: backgroundColor, testId: testId, xcss: xcss, role: role } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $9K4OG.jsx)($9ee6a369e81bb48b$var$InternalBox, {
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockStart: paddingBlockStart,
        paddingBlockEnd: paddingBlockEnd,
        paddingInline: paddingInline,
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        backgroundColor: backgroundColor,
        testId: testId,
        xcss: xcss && (0, $18a557183f782deb$export$aa422b2708209a80)(xcss),
        role: role
    }, props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            key: c.key
        }, props.render(c))));
};




/** The SyntheticEvent object is not serialisable and cannot be passed to the runtime/backend as is.
 * This function filters out all non serialisable arguments and maintains important properties of the event object.
 */ const $a61a7775f4548bb7$var$getSerialisableEventObject = (syntheticEvent)=>{
    /** syntheticEvent.persist() is called to remove the synthetic event from React's event pool.
	 * Without this call, the properties of the event would be nullified after the event callback has been invoked,
	 * due to React's event pooling.
	 * By calling persist(), we ensure that the event properties remain available for the serialization process.
	 */ syntheticEvent?.persist?.();
    const target = syntheticEvent.target;
    const serialisableEvent = {
        bubbles: syntheticEvent.bubbles,
        cancelable: syntheticEvent.cancelable,
        defaultPrevented: syntheticEvent.defaultPrevented,
        eventPhase: syntheticEvent.eventPhase,
        isTrusted: syntheticEvent.isTrusted,
        target: {
            selectionStart: target?.selectionStart,
            selectionEnd: target?.selectionEnd,
            value: target?.value,
            checked: target?.checked,
            name: target?.name,
            id: target?.id,
            tagName: target?.tagName,
            type: target?.type
        },
        timeStamp: syntheticEvent.timeStamp,
        type: syntheticEvent.type
    };
    return serialisableEvent;
};
/**
 * Default handler args transformer that extract react synthetic event from
 * the handler args and creates a serialisable object so that it can be passed into the runtime.
 */ const $a61a7775f4548bb7$var$nativeEventHandlerArgsTransformer = (...args)=>{
    const [event, ...rest] = args;
    return [
        $a61a7775f4548bb7$var$getSerialisableEventObject(event),
        ...rest
    ];
};
const $a61a7775f4548bb7$export$f956703109d01f6a = (sourceEventHandler)=>{
    if (!sourceEventHandler) return sourceEventHandler;
    return (...args)=>{
        sourceEventHandler(...$a61a7775f4548bb7$var$nativeEventHandlerArgsTransformer(...args));
    };
};








var $iUjrf = parcelRequire("iUjrf");





var $1uzCd = parcelRequire("1uzCd");


var $6v6KC = parcelRequire("6v6KC");

/** The SyntheticEvent object is not serialisable and cannot be passed to the runtime/backend as is.
 * This function filters out all non serialisable arguments and maintains important properties of the event object.
 */ const $a55df4b138cf9873$var$getSerialisableEventObject = (syntheticEvent)=>{
    /** syntheticEvent.persist() is called to remove the synthetic event from React's event pool.
	 * Without this call, the properties of the event would be nullified after the event callback has been invoked,
	 * due to React's event pooling.
	 * By calling persist(), we ensure that the event properties remain available for the serialization process.
	 */ syntheticEvent?.persist?.();
    const target = syntheticEvent.target;
    const serialisableEvent = {
        bubbles: syntheticEvent.bubbles,
        cancelable: syntheticEvent.cancelable,
        defaultPrevented: syntheticEvent.defaultPrevented,
        eventPhase: syntheticEvent.eventPhase,
        isTrusted: syntheticEvent.isTrusted,
        target: {
            selectionStart: target?.selectionStart,
            selectionEnd: target?.selectionEnd,
            value: target?.value,
            checked: target?.checked,
            name: target?.name,
            id: target?.id,
            tagName: target?.tagName,
            type: target?.type
        },
        timeStamp: syntheticEvent.timeStamp,
        type: syntheticEvent.type
    };
    return serialisableEvent;
};
const $a55df4b138cf9873$var$extractClickEvents = ([syntheticEvent, ...args])=>{
    if (!syntheticEvent.isTrusted) return [];
    return args?.filter((0, $6v6KC.isUIAnalyticsEvent)).filter((event)=>event.payload.action === 'clicked');
};
/**
 * Default handler args transformer that extract react synthetic event from
 * the handler args and creates a serialisable object so that it can be passed into the runtime.
 */ const $a55df4b138cf9873$var$nativeEventHandlerArgsTransformer = (...args)=>{
    const [event, ...rest] = args;
    return [
        $a55df4b138cf9873$var$getSerialisableEventObject(event),
        ...rest
    ];
};
const $a55df4b138cf9873$export$5ce8c276f684a042 = ()=>{
    const { trackExtensionClicked: trackExtensionClicked } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    const { captureEvent: captureEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    const { extensionType: extensionType, forgeEnvironment: forgeEnvironment } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $gGmck.RendererContext));
    /**
	 * @param sourceEventHandler the source event handler defined by the app user
	 * @returns the adapted event handler that can be safely invoked.
	 */ const adaptEventHandler = (0, $42omo.useCallback)((sourceEventHandler)=>{
        if (!sourceEventHandler) return sourceEventHandler;
        return (...args)=>{
            sourceEventHandler(...$a55df4b138cf9873$var$nativeEventHandlerArgsTransformer(...args));
            // try catch to avoid blocking the event handler in case of error
            try {
                // Detect and fire certain component interaction events for Forge-specific
                // tracking. Does not interfere with propagation to downstream handlers.
                $a55df4b138cf9873$var$extractClickEvents(args).forEach((event)=>{
                    const componentName = event.payload.attributes.componentName;
                    captureEvent({
                        type: 'user-interacted',
                        elapsed: (0, $1uzCd.getPerformanceMark)()
                    });
                    trackExtensionClicked({
                        extensionType: extensionType,
                        appType: 'UIKit',
                        componentName: componentName,
                        forgeEnvironment: forgeEnvironment,
                        baseUrl: window.location.origin
                    });
                });
            } catch (e) {}
        };
    }, [
        captureEvent,
        extensionType,
        forgeEnvironment,
        trackExtensionClicked
    ]);
    return adaptEventHandler;
};






var $1vDIt = parcelRequire("1vDIt");




/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * lazy imports for all icons in @atlaskit/icon/glyph that are used in UI Kit 2 components
 *
 * @codegen <<SignedSource::8a325092633d61c36df237ac4ad7ae0f>>
 * @codegenCommand yarn workspace @atlassian/forge-ui codegen icon
 * @codegenDependency ../../../../../../../design-system/icon/src/migration-map.tsx <<SignedSource::b0e1ba760dff2c80335e4a1f17509daa>>
 * @codegenDependency ../../../../../../../design-system/icon/src/metadata-core.tsx <<SignedSource::49df08b88adf322e7e922c974bc5a169>>
 */ /* eslint @repo/internal/codegen/signed-source-integrity: "warn" */ 














































































































































































































































































































































































































































































































































































































const $900dde9a5d418d97$export$f7b1faa91259ef9d = {
    'activity': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lqx7l"))),
    'add-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2PjjQ"))),
    'add-item': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lOJWX"))),
    'addon': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hC0lJ"))),
    'editor-align-center': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hJDkv"))),
    'editor-align-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cjzh6"))),
    'editor-align-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3TSrz"))),
    'app-access': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aq2mx"))),
    'archive': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("c0RM1"))),
    'arrow-down-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("i5UJ2"))),
    'arrow-left-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ay0uJ"))),
    'arrow-right-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6286k"))),
    'arrow-up-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("P0T7b"))),
    'audio-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aeOb8"))),
    'hipchat-audio-only': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jAMGl"))),
    'bitbucket-branches': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("c5mtI"))),
    'bitbucket-commits': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bFkX8"))),
    'bitbucket-pullrequests': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fBD4z"))),
    'bitbucket-repos': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kWWMp"))),
    'bitbucket-snippets': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bq5o8"))),
    'bitbucket-source': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4GWjn"))),
    'book': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6Vy1g"))),
    'bullet-list': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("31Jgm"))),
    'calendar-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1SfIv"))),
    'camera-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("c87ww"))),
    'checkbox': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("vu9RG"))),
    'check-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("clYtu"))),
    'check-circle-outline': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("46xgu"))),
    'check': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ip99L"))),
    'chevron-down-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("d0YYY"))),
    'hipchat-chevron-down': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jTigW"))),
    'chevron-left-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iaczh"))),
    'chevron-left-large': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("CM6h0"))),
    'chevron-right-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bHl3R"))),
    'chevron-right-large': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ct8nm"))),
    'chevron-up-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eSjFK"))),
    'hipchat-chevron-up': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jDalq"))),
    'child-issues': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hAtvf"))),
    'code': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("13yNF"))),
    'creditcard-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4KALJ"))),
    'creditcard': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bQnLz"))),
    'detail-view': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cFyfk"))),
    'hipchat-dial-out': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("btBEU"))),
    'discover-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8lHdT"))),
    'discover': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kQPjS"))),
    'document-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8hkqT"))),
    'document': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2lE6q"))),
    'documents': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("f6fQ1"))),
    'drag-handler': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8KeUv"))),
    'edit-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("f7rw9"))),
    'editor-add': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1wDTU"))),
    'editor-align-image-center': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("d3jSp"))),
    'editor-align-image-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gmYni"))),
    'editor-align-image-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gNqls"))),
    'editor-attachment': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dB1Nv"))),
    'editor-background-color': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2bfxm"))),
    'editor-bold': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("itiI2"))),
    'editor-bullet-list': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7keB7"))),
    'editor-close': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ggFqS"))),
    'editor-code': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8iPox"))),
    'editor-collapse': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6vkZA"))),
    'editor-date': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("89wDl"))),
    'editor-decision': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ilrxR"))),
    'editor-divider': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8gsaE"))),
    'editor-done': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2Rl0r"))),
    'editor-edit': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3FFa6"))),
    'editor-emoji': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("f3G6B"))),
    'editor-error': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cai9t"))),
    'editor-expand': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9TBCi"))),
    'editor-feedback': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("krUqk"))),
    'editor-file': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("RB4dY"))),
    'editor-help': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("emhBh"))),
    'editor-hint': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6Jynt"))),
    'editor-horizontal-rule': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eEkhV"))),
    'editor-image': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9Q9Rz"))),
    'editor-image-resize': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("anQxx"))),
    'editor-indent': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hrdOf"))),
    'editor-info': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("39SpU"))),
    'editor-italic': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dPQX5"))),
    'editor-layout-single': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6v2HW"))),
    'editor-layout-three-equal': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("alXjD"))),
    'editor-layout-three-with-sidebars': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6v9BY"))),
    'editor-layout-two-equal': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6xIOm"))),
    'editor-layout-two-left-sidebar': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jijSP"))),
    'editor-layout-two-right-sidebar': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eEO2Q"))),
    'editor-link': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kD9V6"))),
    'editor-media-center': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gWUcY"))),
    'editor-media-full-width': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("a0Pus"))),
    'editor-media-wide': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3ZQlq"))),
    'editor-media-wrap-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aK5EN"))),
    'editor-media-wrap-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("91ebz"))),
    'editor-mention': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bNDSX"))),
    'editor-more': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hJCEs"))),
    'editor-note': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("js5De"))),
    'editor-number-list': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("k0Ss0"))),
    'editor-open': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kUVVp"))),
    'editor-outdent': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fCyNu"))),
    'editor-panel': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("c0IFj"))),
    'editor-photo': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("d6Pq7"))),
    'editor-quote': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("647gU"))),
    'editor-recent': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("CjiI6"))),
    'editor-redo': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("c2lxa"))),
    'editor-remove': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gXmJH"))),
    'editor-search': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aZfjN"))),
    'editor-settings': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iBTxt"))),
    'editor-success': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("66jkm"))),
    'editor-table': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2BCPl"))),
    'editor-task': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kmxPw"))),
    'editor-text-style': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2Rgtm"))),
    'editor-undo': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kl6K9"))),
    'editor-unlink': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gqeke"))),
    'editor-warning': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("poTZI"))),
    'emoji-activity': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("b61UF"))),
    'emoji-custom': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6hsfR"))),
    'emoji-emoji': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("flpqf"))),
    'emoji-flags': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("82xDz"))),
    'emoji-food': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("vgmoJ"))),
    'emoji-frequent': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("36VyW"))),
    'emoji-keyboard': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4Gtas"))),
    'emoji-nature': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bZgYy"))),
    'emoji-objects': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("646dK"))),
    'emoji-people': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kACwR"))),
    'emoji-productivity': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6UjQN"))),
    'emoji-symbols': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("b2gSa"))),
    'emoji-travel': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ewu8V"))),
    'error': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dMuqL"))),
    'export': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7ydOL"))),
    'folder': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("38uKy"))),
    'followers': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dzLzX"))),
    'graph-bar': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3XFZz"))),
    'graph-line': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jn3xX"))),
    'home-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5NLz5"))),
    'image-resize': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hBsAL"))),
    'info': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aqKbW"))),
    'invite-team': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("d2j0p"))),
    'issue': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lG1LJ"))),
    'issue-raise': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6kmjr"))),
    'issues': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cgca0"))),
    'jira-capture': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1yToV"))),
    'jira-labs': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cjutx"))),
    'jira-test-session': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("92rWM"))),
    'label': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("j4fYG"))),
    'lightbulb-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("zhSNO"))),
    'like': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("j40SF"))),
    'link-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eaAIo"))),
    'hipchat-lobby': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5NCUL"))),
    'lock-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8GHl1"))),
    'lock-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dAZQk"))),
    'lock': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4pNBU"))),
    'media-services-actual-size': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2LwQc"))),
    'media-services-add-comment': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cXTi8"))),
    'media-services-audio': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6FTqY"))),
    'media-services-code': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3l4J5"))),
    'media-services-document': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("idGLd"))),
    'media-services-filter': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fVobC"))),
    'media-services-fit-to-page': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kqNzg"))),
    'media-services-full-screen': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1ecFD"))),
    'media-services-grid': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5VM98"))),
    'media-services-image': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4cVHI"))),
    'media-services-line': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cf8Up"))),
    'media-services-preselected': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4sOXB"))),
    'media-services-presentation': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2uSAW"))),
    'media-services-scale-large': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gUgh6"))),
    'media-services-scale-small': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iGFQ4"))),
    'media-services-spreadsheet': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aHOa6"))),
    'media-services-video': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fxal7"))),
    'media-services-zoom-in': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9JycZ"))),
    'media-services-zoom-out': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8MHfg"))),
    'menu-expand': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8VwIo"))),
    'mobile': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dbXbW"))),
    'more': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6gXuZ"))),
    'more-vertical': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eEQCn"))),
    'notification-direct': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gufeV"))),
    'office-building-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gAUrB"))),
    'open': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3AZmM"))),
    'hipchat-outgoing-sound': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9kUYz"))),
    'overview': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8ow2q"))),
    'page-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3DW5N"))),
    'people': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("84mDk"))),
    'person-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lmcXF"))),
    'person-with-tick': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("es1iX"))),
    'preferences': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("htMQS"))),
    'question': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7mjky"))),
    'questions': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dcdzN"))),
    'queues': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2Krr9"))),
    'quote': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("86fKz"))),
    'radio': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("b9brh"))),
    'recent': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bot3S"))),
    'room-menu': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5QJiO"))),
    'schedule-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jMVTt"))),
    'schedule': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4Ty8t"))),
    'hipchat-sd-video': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iK7kb"))),
    'select-clear': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lH6nK"))),
    'ship': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("rXhNW"))),
    'shortcut': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fk6CD"))),
    'sign-in': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4UpBP"))),
    'sign-out': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ai2SG"))),
    'star-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("c6oj7"))),
    'star': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1YjBF"))),
    'star-large': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aeofx"))),
    'subtask': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5XD9a"))),
    'suitcase': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jSKZe"))),
    'switcher': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6fKvw"))),
    'table': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6JvUn"))),
    'trash': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4M37c"))),
    'tray': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5rbAo"))),
    'unlink': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iIXDH"))),
    'unlock-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8gLlN"))),
    'unlock-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5mXYe"))),
    'unlock': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3X0HN"))),
    'upload': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cpo1x"))),
    'user-avatar-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2BI2W"))),
    'vid-audio-on': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("k12mT"))),
    'vid-camera-on': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kk4CA"))),
    'video-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4cbxR"))),
    'video-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dl9oy"))),
    'vid-full-screen-off': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2pv4k"))),
    'vid-full-screen-on': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4Buu1"))),
    'vid-pause': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gFSQv"))),
    'vid-play': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6Zo2u"))),
    'vid-volume-full': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("biBlq"))),
    'vid-volume-half': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1Ba8p"))),
    'vid-volume-muted': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cFFVJ"))),
    'warning': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5IhZv"))),
    'watch-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("k4Fvm"))),
    'watch': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9Qn5v"))),
    'world': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1OZ8l"))),
    'world-small': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dym3N"))),
    'add': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9pplp"))),
    'app-switcher': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("d37sc"))),
    'arrow-down': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("451HB"))),
    'arrow-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6mTtW"))),
    'arrow-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2Kg3i"))),
    'arrow-up': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eN6JR"))),
    'attachment': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9bQbY"))),
    'audio': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jnlDm"))),
    'backlog': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jOZLF"))),
    'board': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6aCvX"))),
    'calendar': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dY0gO"))),
    'camera': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cTyTb"))),
    'checkbox-indeterminate': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6iZQ5"))),
    'chevron-down': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5htpY"))),
    'chevron-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dvOcg"))),
    'chevron-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1iZbG"))),
    'chevron-up': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2fguq"))),
    'comment': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("haajr"))),
    'component': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8QpYR"))),
    'copy': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("TgPF7"))),
    'cross-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3tnHG"))),
    'cross': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6CWtz"))),
    'dashboard': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fO6ZF"))),
    'decision': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7r8ra"))),
    'department': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("95BBF"))),
    'download': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1rx2U"))),
    'edit': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dS5lO"))),
    'email': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("k1OQc"))),
    'emoji-add': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cxfMk"))),
    'emoji': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aNO2q"))),
    'feedback': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bXzOw"))),
    'file': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7x6ip"))),
    'filter': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cKhAb"))),
    'flag-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4zF14"))),
    'home': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("a4lfW"))),
    'image': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("04vC5"))),
    'lightbulb': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("b6q3y"))),
    'link': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6d1Wp"))),
    'location': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bueET"))),
    'marketplace': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iDM7l"))),
    'menu': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fJMLJ"))),
    'notification': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cEJVR"))),
    'office-building': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1lydi"))),
    'page': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jYvn2"))),
    'people-group': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bleZq"))),
    'person': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7i7Nt"))),
    'premium': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("37gQz"))),
    'question-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bWFpF"))),
    'redo': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4lnj7"))),
    'refresh': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2n0Oi"))),
    'retry': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bIvLX"))),
    'roadmap': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2nHVr"))),
    'screen': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gCCjj"))),
    'search': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dWdaC"))),
    'send': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("V6sZ3"))),
    'settings': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5s8Sp"))),
    'share': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("j0o9v"))),
    'sprint': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hqIGy"))),
    'stopwatch': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8EJmE"))),
    'task': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3tXvA"))),
    'teams': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("0229H"))),
    'undo': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eiqfv"))),
    'accessibility': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jQJtd"))),
    'ai-agent': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("hge3g")))),
    'ai-chat': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("lDwiy")))),
    'ai-generative-text-summary': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("a6IPc")))),
    'alert': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("e6w7G"))),
    'align-image-center': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("dxgIg")))),
    'align-image-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("1dusJ")))),
    'align-image-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("9Y9Mx")))),
    'align-text-center': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("kiZiu")))),
    'align-text-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("6bJyJ")))),
    'align-text-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("cOZT3")))),
    'angle-brackets': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("eIlE7")))),
    'api': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gdchC"))),
    'app': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("jdPfT")))),
    'app-switcher-legacy': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1cFTA"))),
    'apps': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("tvI67")))),
    'archive-box': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("b0Ise"))),
    'arrow-down-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eLqYE"))),
    'arrow-down-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8DfOo"))),
    'arrow-up-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6xnVZ"))),
    'arrow-up-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4CZNu"))),
    'assets': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8OGHW"))),
    'atlassian-intelligence': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("3Mg7y")))),
    'automation': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("fxBfz")))),
    'basketball': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7G4aF"))),
    'boards': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7sOJP"))),
    'book-with-bookmark': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bUUKB"))),
    'border': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("6oGZN")))),
    'branch': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("iOozU")))),
    'briefcase': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("oeZjt")))),
    'bug': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("2ISy2")))),
    'calendar-plus': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ji6i4"))),
    'capture': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jaRFf"))),
    'card': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dVZCY"))),
    'cash': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ffvn3"))),
    'changes': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("4BqOc")))),
    'chart-bar': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("1zLiv")))),
    'chart-bubble': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eGJQ1"))),
    'chart-matrix': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fJZGy"))),
    'chart-pie': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8sr2T"))),
    'chart-trend': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fa9KH"))),
    'chart-trend-down': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("g6iJ6"))),
    'chart-trend-up': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jYcoW"))),
    'chat-widget': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7mL7x"))),
    'check-circle-unchecked': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4J3F1"))),
    'check-mark': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("cvXh8")))),
    'checkbox-checked': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("7FcUt")))),
    'checkbox-unchecked': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aAESG"))),
    'chevron-double-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("ey1uv")))),
    'chevron-double-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("iSulU")))),
    'child-work-items': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7unXI"))),
    'clipboard': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("iV0NL")))),
    'clock': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("kevJM")))),
    'close': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("604Ea"))),
    'cloud-arrow-up': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("fNJG8")))),
    'collapse-horizontal': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("knmQ0"))),
    'collapse-vertical': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("f81oT"))),
    'comment-add': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("c6fYi")))),
    'commit': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("fZeLS")))),
    'compass': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fceec"))),
    'content-width-narrow': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("3uQ0E")))),
    'content-width-wide': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("kDG8M")))),
    'content-wrap-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("9Ctkw")))),
    'content-wrap-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("kVA9C")))),
    'credit-card': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aCNkh"))),
    'curly-brackets': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("18OQC"))),
    'customize': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("isYda")))),
    'data-flow': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("72moH"))),
    'data-number': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2ZpXN"))),
    'data-string': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jfQIq"))),
    'database': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("6B0jU")))),
    'defect': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("70OpD"))),
    'delete': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("gKvd9")))),
    'device-mobile': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dbed0"))),
    'devices': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5dkIb"))),
    'discovery': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hDRFY"))),
    'drag-handle-horizontal': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jbxTW"))),
    'drag-handle-vertical': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("8aNCk")))),
    'edit-bulk': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("isxcK"))),
    'emoji-casual': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("j398X")))),
    'emoji-neutral': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("kMl1Y")))),
    'emoji-remove': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("2G5zx")))),
    'epic': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("4SWbm")))),
    'exclamation-square': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("k3i7k"))),
    'expand-horizontal': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("gzsfl")))),
    'expand-vertical': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("80Dj5"))),
    'eye-open': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("8cjip")))),
    'eye-open-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gNnOD"))),
    'eye-open-strikethrough': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ahwKL"))),
    'feed': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ehzTm"))),
    'field': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("92bYU"))),
    'field-alert': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1gLpn"))),
    'field-checkbox-group': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4ndNn"))),
    'field-dropdown': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("drcCL"))),
    'field-radio-group': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("65ATH"))),
    'files': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("gXn1S")))),
    'flag': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dTOT4"))),
    'flask': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aq8nA"))),
    'focus-area': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eNNHQ"))),
    'folder-closed': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("5tmwS")))),
    'folder-open': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("beZCo"))),
    'form': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2CaDj"))),
    'fullscreen-enter': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hCcYS"))),
    'fullscreen-exit': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9bwTb"))),
    'glasses': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("gWb8i")))),
    'globe': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("buthI")))),
    'goal': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("gJsgh")))),
    'grid': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("dk0le")))),
    'grow-diagonal': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("lOzEN")))),
    'grow-horizontal': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("1kVeP")))),
    'grow-vertical': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("lFPm8")))),
    'hashtag': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3ZQBR"))),
    'headphones': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cunhZ"))),
    'heart': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("j8LwF")))),
    'highlight': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("74Ajl")))),
    'image-fullscreen': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("eJ7sW")))),
    'image-inline': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("2tC8Z")))),
    'image-scaled': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kuKNT"))),
    'inbox': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("T2nmi"))),
    'incident': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("5LN4K")))),
    'information': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1A1QP"))),
    'information-circle': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("8tSmd")))),
    'key-result': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3miR4"))),
    'layout-one-column': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("bmsMK")))),
    'layout-three-columns': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("f22ZH")))),
    'layout-three-columns-sidebars': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("5NtbR")))),
    'layout-two-columns': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("asgOl")))),
    'layout-two-columns-sidebar-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("e0qVa")))),
    'layout-two-columns-sidebar-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("dIYpm")))),
    'library': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fxxLt"))),
    'link-broken': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("dZMVn")))),
    'link-external': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("8tdj3")))),
    'list-bulleted': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("cUQMr")))),
    'list-checklist': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("54tpX")))),
    'list-numbered': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("2y4tz")))),
    'lobby-bell': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("mZICS"))),
    'lock-locked': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("9Q2dU")))),
    'lock-unlocked': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("h1ewt")))),
    'log-in': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kURs4"))),
    'log-out': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9aQcQ"))),
    'magic-wand': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("lW0cT")))),
    'markdown': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eWBDn"))),
    'maximize': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("jNL69")))),
    'megaphone': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fzApj"))),
    'merge-failure': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("bQ6eU")))),
    'merge-success': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3mxkw"))),
    'microphone': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("bAxHS")))),
    'minimize': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3xZwm"))),
    'minus': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("5Yp2m")))),
    'minus-square': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jP7Dr"))),
    'node': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hRm77"))),
    'note': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("4Hqhn")))),
    'notification-muted': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ved2s"))),
    'objective': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8hglZ"))),
    'on-call': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("58GSK"))),
    'operations': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2O1J1"))),
    'pages': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1PFGt"))),
    'paint-bucket': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("7TXtV")))),
    'paint-palette': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("22P78"))),
    'panel-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cZ1wW"))),
    'panel-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("jypE9")))),
    'pen': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("do1Cc"))),
    'person-add': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kMEmh"))),
    'person-added': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("pt6v8"))),
    'person-avatar': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("4wwVl")))),
    'person-offboard': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1Fdl4"))),
    'person-remove': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("aWudE")))),
    'person-warning': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9QIq8"))),
    'phone': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("h17X9"))),
    'pin': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("6V1ly")))),
    'pin-filled': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("brxEJ")))),
    'plus-square': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("cHaKZ")))),
    'power-plug': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4AXoN"))),
    'presenter-mode': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("12wyz"))),
    'printer': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7cZ4v"))),
    'priority-blocker': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1vwzF"))),
    'priority-critical': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dj5Z1"))),
    'priority-high': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("h2qUl"))),
    'priority-highest': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("Mud1L"))),
    'priority-low': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3np9B"))),
    'priority-lowest': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("csTMY"))),
    'priority-major': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("h7Bos"))),
    'priority-medium': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cMLhW"))),
    'priority-minor': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jcBng"))),
    'priority-trivial': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3DthG"))),
    'problem': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("jz9js")))),
    'project': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("bVHZY")))),
    'project-status': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6E8pW"))),
    'projection-screen': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6WWPa"))),
    'pull-request': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("7OYaz")))),
    'pulse': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("186Qe"))),
    'quotation-mark': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("9RVmI")))),
    'radio-checked': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fJytx"))),
    'radio-unchecked': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("28PuG"))),
    'release': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("5j8et")))),
    'rovo-chat': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("cOQz3")))),
    'scales': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("g5Rb0"))),
    'scorecard': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6W0dI"))),
    'screen-plus': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("j7WtC"))),
    'shapes': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lulFc"))),
    'shield': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hHCqO"))),
    'shield-strikethrough': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1kcft"))),
    'show-more-horizontal': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("9VJDA")))),
    'show-more-vertical': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9KGGx"))),
    'shrink-diagonal': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("c9fOS"))),
    'shrink-horizontal': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("64M9v")))),
    'shrink-vertical': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("jPqj0")))),
    'sidebar-collapse': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("i64Sl"))),
    'sidebar-expand': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ePdXG"))),
    'smart-link': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("duwSm")))),
    'smart-link-card': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("65WMN")))),
    'smart-link-embed': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("99wB5")))),
    'smart-link-inline': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("erzkB")))),
    'smart-link-list': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("2g1PW")))),
    'snippet': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lf4xX"))),
    'sort-ascending': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("4c0se")))),
    'sort-descending': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("dmsGX")))),
    'spreadsheet': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gNsmn"))),
    'star-starred': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cMb72"))),
    'star-unstarred': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("agfuz"))),
    'status-discovery': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("3gddQ")))),
    'status-error': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("a3fRD")))),
    'status-information': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("eXmBZ")))),
    'status-success': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("3sFtD")))),
    'status-verified': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("bh5s2")))),
    'status-warning': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("ebrpi")))),
    'story': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("kR5QY")))),
    'stroke-weight-extra-large': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lDqsi"))),
    'stroke-weight-large': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("3jDos")))),
    'stroke-weight-medium': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("gfsOF")))),
    'stroke-weight-small': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("gDgeb")))),
    'subtasks': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("49GPt")))),
    'success': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gfJPQ"))),
    'support': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7vRpU"))),
    'table-cell-clear': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("iV7dk")))),
    'table-cell-merge': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("lZgFC")))),
    'table-cell-split': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("4nv4H")))),
    'table-column-add-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("luItc")))),
    'table-column-add-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("6p8nb")))),
    'table-column-delete': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("4Ilrk")))),
    'table-column-move-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("lvYQd")))),
    'table-column-move-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("batr4")))),
    'table-columns-distribute': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("iBNSQ")))),
    'table-row-add-above': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("kDG2N")))),
    'table-row-add-below': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("4s9K9")))),
    'table-row-delete': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("HbwpQ")))),
    'table-row-move-down': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("krMwx")))),
    'table-row-move-up': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("gzmk4")))),
    'tag': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("av0Vd")))),
    'takeout-food': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("OjCnH"))),
    'target': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jRJ8Y"))),
    'task-in-progress': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("j5eCx"))),
    'task-to-do': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("6DSrS")))),
    'tasks': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fC9Y7"))),
    'text': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("f8c3d")))),
    'text-bold': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("7gIXe")))),
    'text-heading': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jrHYC"))),
    'text-indent-left': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("dRLbl")))),
    'text-indent-right': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("ay6wY")))),
    'text-italic': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("2gUVF")))),
    'text-shorten': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("cH4SO")))),
    'text-spellcheck': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("dLjaJ")))),
    'text-strikethrough': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("jHpAD")))),
    'text-style': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("5gydP")))),
    'text-underline': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("4E5My")))),
    'text-wrap': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("aK2ZC")))),
    'theme': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7pJZg"))),
    'thumbs-down': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("9zIwY")))),
    'thumbs-up': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("9FnLD")))),
    'timeline': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("rYjug"))),
    'tools': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lIVwe"))),
    'transition': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aho4H"))),
    'translate': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("3tLv0")))),
    'tree': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kfugR"))),
    'vehicle-car': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fmmjI"))),
    'video': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("2Yaht")))),
    'video-next': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lBjOA"))),
    'video-next-overlay': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("IkTBS"))),
    'video-pause': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dYCDx"))),
    'video-pause-overlay': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ijbGz"))),
    'video-play': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jDt7y"))),
    'video-play-overlay': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("j8awz"))),
    'video-previous': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bRgbB"))),
    'video-previous-overlay': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("62oxM"))),
    'video-skip-backward-fifteen': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hDtlp"))),
    'video-skip-backward-ten': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hqoci"))),
    'video-skip-forward-fifteen': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iAJDb"))),
    'video-skip-forward-ten': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7xAVg"))),
    'video-stop': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kJLXJ"))),
    'video-stop-overlay': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("5lVpa")))),
    'volume-high': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("4rqtC"))),
    'volume-low': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("igaQ6"))),
    'volume-muted': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5ayJq"))),
    'whiteboard': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("ZDq1z")))),
    'work-item': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("2qVkt")))),
    'work-items': /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("7ZcJJ")))),
    'zoom-in': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cFlXM"))),
    'zoom-out': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cOJPH")))
};
const $900dde9a5d418d97$export$9ebdede3e2763d09 = new Set([
    'billing-filled',
    'billing',
    'bitbucket-builds',
    'bitbucket-clone',
    'bitbucket-compare',
    'bitbucket-forks',
    'bitbucket-output',
    'bitbucket-pipelines',
    'camera-rotate',
    'camera-take-picture',
    'canvas',
    'hipchat-chevron-double-down',
    'hipchat-chevron-double-up',
    'dropbox',
    'editor-addon',
    'editor-advanced',
    'editor-file-preview',
    'editor-image-border',
    'editor-remove-emoji',
    'editor-strikethrough',
    'editor-table-display-options',
    'editor-text-color',
    'editor-underline',
    'emoji-atlassian',
    'folder-filled',
    'following',
    'googledrive',
    'gsuite',
    'highlights',
    'image-border',
    'jira-failed-build-status',
    'list',
    'hipchat-media-attachment-count',
    'media-services-annotate',
    'media-services-arrow',
    'media-services-blur',
    'media-services-brush',
    'media-services-button-option',
    'media-services-line-thickness',
    'media-services-no-image',
    'media-services-open-mediaviewer',
    'media-services-oval',
    'media-services-pdf',
    'media-services-rectangle',
    'media-services-text',
    'media-services-unknown',
    'media-services-zip',
    'mention',
    'notification-all',
    'pdf',
    'person-with-circle',
    'person-with-cross',
    'portfolio',
    'presence-active',
    'presence-busy',
    'presence-unavailable',
    'status',
    'vid-audio-muted',
    'vid-backward',
    'vid-camera-off',
    'vid-connection-circle',
    'vid-forward',
    'vid-hang-up',
    'vid-hd-circle',
    'vid-raised-hand',
    'vid-share-screen',
    'vid-speaking-circle'
]);
const $900dde9a5d418d97$export$cb2011f34d4d5169 = new Set([
    'activity',
    'add-circle',
    'add-item',
    'addon',
    'editor-align-center',
    'editor-align-left',
    'editor-align-right',
    'app-access',
    'archive',
    'arrow-down-circle',
    'arrow-left-circle',
    'arrow-right-circle',
    'arrow-up-circle',
    'audio-circle',
    'hipchat-audio-only',
    'bitbucket-branches',
    'bitbucket-commits',
    'bitbucket-pullrequests',
    'bitbucket-repos',
    'bitbucket-snippets',
    'bitbucket-source',
    'book',
    'bullet-list',
    'calendar-filled',
    'camera-filled',
    'checkbox',
    'check-circle',
    'check-circle-outline',
    'check',
    'chevron-down-circle',
    'hipchat-chevron-down',
    'chevron-left-circle',
    'chevron-left-large',
    'chevron-right-circle',
    'chevron-right-large',
    'chevron-up-circle',
    'hipchat-chevron-up',
    'child-issues',
    'code',
    'creditcard-filled',
    'creditcard',
    'detail-view',
    'hipchat-dial-out',
    'discover-filled',
    'discover',
    'document-filled',
    'document',
    'documents',
    'drag-handler',
    'edit-filled',
    'editor-add',
    'editor-align-image-center',
    'editor-align-image-left',
    'editor-align-image-right',
    'editor-attachment',
    'editor-background-color',
    'editor-bold',
    'editor-bullet-list',
    'editor-close',
    'editor-code',
    'editor-collapse',
    'editor-date',
    'editor-decision',
    'editor-divider',
    'editor-done',
    'editor-edit',
    'editor-emoji',
    'editor-error',
    'editor-expand',
    'editor-feedback',
    'editor-file',
    'editor-help',
    'editor-hint',
    'editor-horizontal-rule',
    'editor-image',
    'editor-image-resize',
    'editor-indent',
    'editor-info',
    'editor-italic',
    'editor-layout-single',
    'editor-layout-three-equal',
    'editor-layout-three-with-sidebars',
    'editor-layout-two-equal',
    'editor-layout-two-left-sidebar',
    'editor-layout-two-right-sidebar',
    'editor-link',
    'editor-media-center',
    'editor-media-full-width',
    'editor-media-wide',
    'editor-media-wrap-left',
    'editor-media-wrap-right',
    'editor-mention',
    'editor-more',
    'editor-note',
    'editor-number-list',
    'editor-open',
    'editor-outdent',
    'editor-panel',
    'editor-photo',
    'editor-quote',
    'editor-recent',
    'editor-redo',
    'editor-remove',
    'editor-search',
    'editor-settings',
    'editor-success',
    'editor-table',
    'editor-task',
    'editor-text-style',
    'editor-undo',
    'editor-unlink',
    'editor-warning',
    'emoji-activity',
    'emoji-custom',
    'emoji-emoji',
    'emoji-flags',
    'emoji-food',
    'emoji-frequent',
    'emoji-keyboard',
    'emoji-nature',
    'emoji-objects',
    'emoji-people',
    'emoji-productivity',
    'emoji-symbols',
    'emoji-travel',
    'error',
    'export',
    'folder',
    'followers',
    'graph-bar',
    'graph-line',
    'home-circle',
    'image-resize',
    'info',
    'invite-team',
    'issue',
    'issue-raise',
    'issues',
    'jira-capture',
    'jira-labs',
    'jira-test-session',
    'label',
    'lightbulb-filled',
    'like',
    'link-filled',
    'hipchat-lobby',
    'lock-circle',
    'lock-filled',
    'lock',
    'media-services-actual-size',
    'media-services-add-comment',
    'media-services-audio',
    'media-services-code',
    'media-services-document',
    'media-services-filter',
    'media-services-fit-to-page',
    'media-services-full-screen',
    'media-services-grid',
    'media-services-image',
    'media-services-line',
    'media-services-preselected',
    'media-services-presentation',
    'media-services-scale-large',
    'media-services-scale-small',
    'media-services-spreadsheet',
    'media-services-video',
    'media-services-zoom-in',
    'media-services-zoom-out',
    'menu-expand',
    'mobile',
    'more',
    'more-vertical',
    'notification-direct',
    'office-building-filled',
    'open',
    'hipchat-outgoing-sound',
    'overview',
    'page-filled',
    'people',
    'person-circle',
    'person-with-tick',
    'preferences',
    'question',
    'questions',
    'queues',
    'quote',
    'radio',
    'recent',
    'room-menu',
    'schedule-filled',
    'schedule',
    'hipchat-sd-video',
    'select-clear',
    'ship',
    'shortcut',
    'sign-in',
    'sign-out',
    'star-filled',
    'star',
    'star-large',
    'subtask',
    'suitcase',
    'switcher',
    'table',
    'trash',
    'tray',
    'unlink',
    'unlock-circle',
    'unlock-filled',
    'unlock',
    'upload',
    'user-avatar-circle',
    'vid-audio-on',
    'vid-camera-on',
    'video-circle',
    'video-filled',
    'vid-full-screen-off',
    'vid-full-screen-on',
    'vid-pause',
    'vid-play',
    'vid-volume-full',
    'vid-volume-half',
    'vid-volume-muted',
    'warning',
    'watch-filled',
    'watch',
    'world',
    'world-small'
]);





const $5a7e52ec71d46eed$export$c44dcb4ac245d131 = 'iconography-refresh-early-adoption-2025-06';
const $5a7e52ec71d46eed$export$f9af3fb8cc704d8e = (0, $42omo.createContext)({
    [$5a7e52ec71d46eed$export$c44dcb4ac245d131]: false
});
const $5a7e52ec71d46eed$export$d34634bd9a1f8e23 = ()=>(0, $42omo.useContext)($5a7e52ec71d46eed$export$f9af3fb8cc704d8e);
const $5a7e52ec71d46eed$export$9600eab7eb2a5234 = $5a7e52ec71d46eed$export$f9af3fb8cc704d8e.Provider;





/**
 * The validateColor function and its helper functions could not be
 * moved to a separate file because it could potentially cause cyclic
 * dependencies since type IconColor must be defined here in order for
 * forge-react-types to recognise it.
 */ const $04d28833aacd5f6d$var$iconTokenSet = new Set(Object.keys((0, $1vDIt.default)).filter((token)=>token.startsWith('color')));
const $04d28833aacd5f6d$var$isInTokenSet = (color)=>$04d28833aacd5f6d$var$iconTokenSet.has(color);
const $04d28833aacd5f6d$export$69378c11ed599796 = (color)=>{
    if (!color) return undefined;
    if (!$04d28833aacd5f6d$var$isInTokenSet(color)) {
        (0, $1nSBE.default)(`[@forge/react: Icon] "${color}" is not a valid design token for color.`);
        return undefined;
    }
    return `var(${(0, $1vDIt.default)[color]})`;
};
const $04d28833aacd5f6d$var$iconTokenSetLegacy = new Set(Object.keys((0, $1vDIt.default)).filter((token)=>token.startsWith('color.icon')));
const $04d28833aacd5f6d$var$isInTokenSetLegacy = (color)=>$04d28833aacd5f6d$var$iconTokenSetLegacy.has(color);
const $04d28833aacd5f6d$export$fe4c6b7d8735b9f0 = (color)=>{
    if (!color) return undefined;
    if (!$04d28833aacd5f6d$var$isInTokenSetLegacy(color)) {
        (0, $1nSBE.default)(`[@forge/react: Icon] the value "${color}" is not a valid design token for primaryColor or secondaryColor.`);
        return undefined;
    }
    return `var(${(0, $1vDIt.default)[color]})`;
};
const $04d28833aacd5f6d$export$f508444e7933c2b1 = ({ glyph: glyph, label: label, color: color, size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>{
    let Component;
    let forceSize = false;
    let spacing = 'none';
    const featurePreview = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $5a7e52ec71d46eed$export$f9af3fb8cc704d8e));
    // Only use the backwards compatibility logic if the feature preview is not enabled.
    if (Boolean(featurePreview[0, $5a7e52ec71d46eed$export$c44dcb4ac245d131]) === false) {
        // The new icons have different dimensions:
        // medium: 24px by 24px => 16px by 16px
        // small:  16px by 16px => 12px by 12px
        // https://atlassian.design/components/icon/examples#default-16px
        // To avoid breaking changes, use the "spacing" prop to revert back to the old dimensions.
        if (size === 'small') spacing = 'compact';
        if (size === 'medium' || size === undefined) spacing = 'spacious';
    }
    // Regular lookup
    if (!Component) // @ts-ignore: TS2322: Type 'IconNext | IconRemoved | IconReplaced' is not assignable to type 'string'.
    Component = (0, $900dde9a5d418d97$export$f7b1faa91259ef9d)[glyph];
    const { forgeEnvironment: forgeEnvironment } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $gGmck.RendererContext));
    if (forgeEnvironment !== 'PRODUCTION') {
        // Using an array avoids TS issues checking for an invalid value type
        if (size !== undefined && ![
            'small',
            'medium'
        ].includes(size)) (0, $1nSBE.default)(`[@forge/react: Icon] Warning: The value "${size}" for the "size" prop has been deprecated and will be removed on the 22nd of December 2025. To avoid breaking changes, only use the values "small" or "medium". For more details, visit: https://atlassian.design/components/icon/usage#spacing-and-sizing`);
        if (primaryColor !== undefined) (0, $1nSBE.default)(`[@forge/react: Icon] Warning: The "primaryColor" is deprecated and will be removed on the 22nd of December 2025. Please use the "color" prop instead. For more information, visit: https://developer.atlassian.com/platform/forge/ui-kit/components/icon/.`);
        if (secondaryColor !== undefined) (0, $1nSBE.default)(`[@forge/react: Icon] Warning: The "secondaryColor" prop has been deprecated and will be removed on the 22nd of December 2025. Please refactor your code to avoid using this prop.`);
    }
    // Use a default icon if the glyph is not found (in case an app has not been updated after glyphs have been removed)
    if (!Component) {
        Component = (0, $900dde9a5d418d97$export$f7b1faa91259ef9d)['question'];
        const msg = `[@forge/react: Icon] no icon found for the glyph "${glyph}".`;
        if (forgeEnvironment === 'PRODUCTION') (0, $1nSBE.default)(msg);
        else // eslint-disable-next-line no-console
        console.error(msg);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
        // @ts-ignore: Jira only - TS2322: Type '{ label: string; glyph: Glyph; color: string | undefined; spacing: "none" | "compact" | "spacious" | undefined; size: "small" | "medium" | "large" | undefined; primaryColor: string | undefined; secondaryColor: string | undefined; LEGACY_size: "small" | ... 2 more ... | undefined; LEGACY_primaryColor: string | undefi...' is not assignable to type 'IntrinsicAttributes'
        label: label,
        glyph: glyph,
        color: $04d28833aacd5f6d$export$69378c11ed599796(color || primaryColor),
        size: forceSize ? 'medium' : size,
        primaryColor: $04d28833aacd5f6d$export$fe4c6b7d8735b9f0(color || primaryColor),
        secondaryColor: $04d28833aacd5f6d$export$fe4c6b7d8735b9f0(secondaryColor),
        spacing: spacing
    }));
};
const $04d28833aacd5f6d$export$f04a61298a47a40f = (props)=>{
    const { glyph: glyph, label: label, color: color, size: size, primaryColor: primaryColor, secondaryColor: secondaryColor } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($04d28833aacd5f6d$export$f508444e7933c2b1, {
        label: label,
        glyph: glyph,
        color: color,
        size: size,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
};



var $ccHMk = parcelRequire("ccHMk");




const $43e97c04e7296334$var$createIconComponent = (icon)=>{
    const Component = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $04d28833aacd5f6d$export$f508444e7933c2b1), {
            glyph: icon,
            label: icon
        });
    return Component;
};
/**
 * Mapping the deprecated 'none' spacing to 'compact'
 */ const $43e97c04e7296334$var$mapDeprecatedSpacing = (spacing)=>spacing === 'none' ? 'compact' : spacing;
const $43e97c04e7296334$var$OldButton = (props)=>{
    const { autoFocus: autoFocus, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, spacing: spacing, testId: testId, shouldFitContainer: shouldFitContainer, appearance: appearance, type: type, iconAfter: iconAfter, iconBefore: iconBefore } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onBlur),
        onClick: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onClick),
        onFocus: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onFocus),
        spacing: $43e97c04e7296334$var$mapDeprecatedSpacing(spacing),
        testId: testId,
        shouldFitContainer: shouldFitContainer,
        appearance: appearance,
        type: type,
        iconAfter: iconAfter && $43e97c04e7296334$var$createIconComponent(iconAfter),
        iconBefore: iconBefore && $43e97c04e7296334$var$createIconComponent(iconBefore)
    });
};
const $43e97c04e7296334$var$ButtonWithAnalytics = (props)=>{
    const { autoFocus: autoFocus, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, spacing: spacing, testId: testId, shouldFitContainer: shouldFitContainer, appearance: appearance, type: type, iconAfter: iconAfter, iconBefore: iconBefore } = props.forgeDoc.props;
    const adaptEventHandler = (0, $a55df4b138cf9873$export$5ce8c276f684a042)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: adaptEventHandler(onBlur),
        onClick: adaptEventHandler(onClick),
        onFocus: adaptEventHandler(onFocus),
        spacing: $43e97c04e7296334$var$mapDeprecatedSpacing(spacing),
        testId: testId,
        shouldFitContainer: shouldFitContainer,
        appearance: appearance,
        type: type,
        iconAfter: iconAfter && $43e97c04e7296334$var$createIconComponent(iconAfter),
        iconBefore: iconBefore && $43e97c04e7296334$var$createIconComponent(iconBefore)
    });
};
const $43e97c04e7296334$export$353f5b6fc5456de1 = (props)=>{
    if ((0, $dh538.fg)('forge-ui-ui-kit-click-events')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($43e97c04e7296334$var$ButtonWithAnalytics, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($43e97c04e7296334$var$OldButton, props);
};





var $hArLp = parcelRequire("hArLp");

const $e4393c0a53b02aba$export$bf0162d825d6e13 = {
    children: {
        value: "applyAppearanceToChildren(props.forgeDoc.children, props.render, appearance)",
        comment: "apply consistent appearance to children elements"
    },
    testId: true,
    label: true,
    titleId: true
};
/**
 * Applying the appearance prop directly to the children forgedocs.
 * It is because the logic for applying appearance to the children components
 * through React.cloneComponent can only be applied to the Forge component wrapper,
 * and not to the actual Button element.
 */ const $e4393c0a53b02aba$var$applyAppearanceToChildren = (children, render, appearance)=>{
    if (!appearance) return children.map(render);
    return children.map((child)=>{
        if (child.type !== 'String') return render({
            ...child,
            props: {
                appearance: appearance,
                ...child.props
            }
        });
        return render(child);
    });
};
const $e4393c0a53b02aba$export$69b1032f2ecdf404 = (props)=>{
    const { testId: testId, label: label, titleId: titleId, appearance: appearance } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), {
        // apply consistent appearance to children elements
        children: $e4393c0a53b02aba$var$applyAppearanceToChildren(props.forgeDoc.children, props.render, appearance),
        testId: testId,
        label: label,
        titleId: titleId
    });
}; /**
 * @codegenEnd
 */ 






var $91bEl = parcelRequire("91bEl");

const $9b97a2db8a6b7ad3$export$bf0162d825d6e13 = {
    day: true,
    defaultDay: true,
    defaultMonth: true,
    defaultYear: true,
    defaultPreviouslySelected: true,
    defaultSelected: true,
    disabled: true,
    disabledDateFilter: false,
    maxDate: true,
    minDate: true,
    nextMonthLabel: true,
    onBlur: {
        value: "adaptEventHandler(onBlur)"
    },
    onChange: true,
    onFocus: {
        value: "adaptEventHandler(onFocus)"
    },
    onSelect: true,
    previouslySelected: true,
    previousMonthLabel: true,
    selected: true,
    today: true,
    year: true,
    locale: true,
    testId: true,
    weekStartDay: true,
    tabIndex: true
};
const $9b97a2db8a6b7ad3$export$e1aef45b828286de = (props)=>{
    const { day: day, defaultDay: defaultDay, defaultMonth: defaultMonth, defaultYear: defaultYear, defaultPreviouslySelected: defaultPreviouslySelected, defaultSelected: defaultSelected, disabled: disabled, maxDate: maxDate, minDate: minDate, nextMonthLabel: nextMonthLabel, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onSelect: onSelect, previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, today: today, year: year, locale: locale, testId: testId, weekStartDay: weekStartDay, tabIndex: tabIndex } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $91bEl.default), {
        day: day,
        defaultDay: defaultDay,
        defaultMonth: defaultMonth,
        defaultYear: defaultYear,
        defaultPreviouslySelected: defaultPreviouslySelected,
        defaultSelected: defaultSelected,
        disabled: disabled,
        maxDate: maxDate,
        minDate: minDate,
        nextMonthLabel: nextMonthLabel,
        onBlur: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onBlur),
        onChange: onChange,
        onFocus: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onFocus),
        onSelect: onSelect,
        previouslySelected: previouslySelected,
        previousMonthLabel: previousMonthLabel,
        selected: selected,
        today: today,
        year: year,
        locale: locale,
        testId: testId,
        weekStartDay: weekStartDay,
        tabIndex: tabIndex
    });
}; /**
 * @codegenEnd
 */ 





var $7gpC4 = parcelRequire("7gpC4");


const $7cc3ee78c78f7f2c$export$bf0162d825d6e13 = {
    testId: true,
    defaultChecked: true,
    isChecked: true,
    isIndeterminate: true,
    label: true,
    size: false
};
const $7cc3ee78c78f7f2c$export$48513f6b9f8ce62d = (props)=>{
    const { testId: testId, defaultChecked: defaultChecked, isChecked: isChecked, isIndeterminate: isIndeterminate, label: label, id: // Field props
    id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, "aria-invalid": ariaInvalid, "aria-labelledby": ariaLabelledby, name: name } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
        testId: testId,
        defaultChecked: defaultChecked,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        label: label,
        // Field props
        id: id,
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onChange: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onChange),
        onBlur: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onBlur),
        onFocus: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onFocus),
        value: value,
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
}; /**
 * @codegenEnd
 */ 








var $gdv5Z = parcelRequire("gdv5Z");







const $8a6c935ee2f753cd$export$4aa08d5625cb8ead = (props)=>{
    const { name: name, options: options, value: value, onChange: onChange, defaultValue: defaultValue = [], isDisabled: isDisabled = false } = props.forgeDoc.props;
    const [selectedValues, setSelectedValues] = (0, $42omo.useState)(value ?? defaultValue);
    (0, $42omo.useEffect)(()=>{
        if (value) setSelectedValues(value);
    }, [
        value
    ]);
    const notStaticCheckbox = !value || onChange;
    const onCheckboxChange = (0, $42omo.useCallback)((event)=>{
        if (notStaticCheckbox) {
            const newSelectedValues = selectedValues.includes(event.target.value) ? selectedValues.filter((item)=>item !== event.target.value) : [
                ...selectedValues,
                event.target.value
            ];
            setSelectedValues(newSelectedValues);
            if (onChange) onChange(newSelectedValues);
        }
    }, [
        notStaticCheckbox,
        onChange,
        selectedValues,
        setSelectedValues
    ]);
    if ((0, $dh538.fg)('platform_migrate_checkboxgroup_to_compiled_box')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        role: "group"
    }, options.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
            key: index,
            name: name,
            value: item.value,
            label: item.label,
            isChecked: selectedValues.includes(item.value),
            isDisabled: item.isDisabled ?? isDisabled,
            onChange: onCheckboxChange
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        role: "group"
    }, options.map((item, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
            key: index,
            name: name,
            value: item.value,
            label: item.label,
            isChecked: selectedValues.includes(item.value),
            isDisabled: item.isDisabled ?? isDisabled,
            onChange: onCheckboxChange
        });
    }));
};

// Note: codeBidi props are not exposed to prevent misuse by malicious developers
const $7b3d0d2c6f33df23$export$550573b096470df3 = (forgeDoc)=>{
    return forgeDoc.children.map((child)=>{
        if (child?.props?.text) return child.props?.text;
        else return '';
    });
};






var $lwZHY = parcelRequire("lwZHY");

const $d25f8a1ec16dec2a$export$bf0162d825d6e13 = {
    children: {
        value: 'getTextFromForgeDocChildren(props.forgeDoc)',
        comment: 'Only render string children'
    },
    testId: true
};
const $d25f8a1ec16dec2a$export$52f0f02147b12c03 = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lwZHY.default), {
        // Only render string children
        children: (0, $7b3d0d2c6f33df23$export$550573b096470df3)(props.forgeDoc),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

// codeBidi props are not allowed to prevent malicious developers from misusing them.




var $9QfXi = parcelRequire("9QfXi");

const $df2eef1efb6606e5$export$bf0162d825d6e13 = {
    text: true,
    testId: true,
    showLineNumbers: true,
    language: true,
    highlight: true,
    highlightedStartText: true,
    highlightedEndText: true,
    shouldWrapLongLines: true
};
const $df2eef1efb6606e5$export$6c415d1fdae3dfdb = (props)=>{
    const { text: text, testId: testId, showLineNumbers: showLineNumbers, language: language, highlight: highlight, highlightedStartText: highlightedStartText, highlightedEndText: highlightedEndText, shouldWrapLongLines: shouldWrapLongLines } = props.forgeDoc.props;
    // warning: showLineNumbers is deprecated;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9QfXi.default), {
        text: text,
        testId: testId,
        showLineNumbers: showLineNumbers,
        language: language,
        highlight: highlight,
        highlightedStartText: highlightedStartText,
        highlightedEndText: highlightedEndText,
        shouldWrapLongLines: shouldWrapLongLines
    });
}; /**
 * @codegenEnd
 */ 






var $l998X = parcelRequire("l998X");





var $gxtzC = parcelRequire("gxtzC");


var $eEA8O = parcelRequire("eEA8O");

const $4e4a1d628a071f9a$var$ActionItem = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, onClick: providedOnClick, onFocus: onFocus, onMouseOver: onMouseOver, isDisabled: isDisabled }, ref)=>{
    const onClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>providedOnClick && providedOnClick(event, analyticsEvent),
        action: 'clicked',
        componentName: 'commentAction',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    return(/**
     * It is not normally acceptable to add click and key handlers to non-interactive
     * elements as this is an accessibility anti-pattern. However, because this
     * instance is to add support for analytics instead of creating an inaccessible
     * custom element, we can add role="presentation" so that there are no negative
     * impacts to assistive technologies.
     */ // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $l998X.jsx)("span", {
        role: "presentation",
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
            ref: ref,
            appearance: "subtle-link",
            spacing: "none",
            type: "button",
            isDisabled: isDisabled,
            children: children
        })
    }));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4e4a1d628a071f9a$export$2e2bcd8739ae039 = $4e4a1d628a071f9a$var$ActionItem;


var $fy6ox = parcelRequire("fy6ox");

var $9Z0wk = parcelRequire("9Z0wk");

var $fJJGs = parcelRequire("fJJGs");

var $hlzjm = parcelRequire("hlzjm");

const $22edd9209cc89f16$export$4d299b491347818a = (props)=>{
    const { actions: actions, afterContent: afterContent, author: author, edited: edited, errorActions: errorActions, errorIconLabel: errorIconLabel, headingLevel: headingLevel, highlighted: highlighted, id: id, isError: isError, isSaving: isSaving, restrictedTo: restrictedTo, savingText: savingText, shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline, testId: testId, time: time, type: type } = props.forgeDoc.props;
    const avatarForgeDoc = props.forgeDoc.children.find((child)=>{
        if (child.type === 'ContentWrapper' && child.props?.name === 'avatar') return child;
    });
    const contentForgeDoc = props.forgeDoc.children.find((child)=>{
        if (child.type === 'ContentWrapper' && child.props?.name === 'content') return child;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hlzjm.default), {
        actions: actions?.map((action, index)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4e4a1d628a071f9a$export$2e2bcd8739ae039), {
                key: index,
                onClick: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(action?.onClick)
            }, action.text);
        }),
        afterContent: afterContent,
        author: author ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fy6ox.default), {
            onClick: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(author?.onClick)
        }, author.text) : undefined,
        avatar: avatarForgeDoc?.children.map(props.render),
        children: props.forgeDoc.children.filter((child)=>child.type !== 'ContentWrapper').map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        content: contentForgeDoc?.children.map(props.render),
        edited: edited ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z0wk.default), null, edited) : undefined,
        errorActions: errorActions?.map((action, index)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4e4a1d628a071f9a$export$2e2bcd8739ae039), {
                key: index,
                onClick: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(action?.onClick)
            }, action.text);
        }),
        errorIconLabel: errorIconLabel,
        headingLevel: headingLevel,
        highlighted: highlighted,
        id: id,
        isError: isError,
        isSaving: isSaving,
        restrictedTo: restrictedTo,
        savingText: savingText,
        shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline,
        testId: testId,
        time: time ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fJJGs.default), {
            onClick: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(time?.onClick)
        }, time.text) : undefined,
        type: type
    });
};





var $c4Cbx = parcelRequire("c4Cbx");








const $027f1d2b522f28cb$var$ModalContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isInModal: false
});
const $027f1d2b522f28cb$export$178405afcd8c5eb = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($027f1d2b522f28cb$var$ModalContext.Provider, {
        value: {
            isInModal: true
        }
    }, children);
};
const $027f1d2b522f28cb$export$1b1a640376f863b2 = ()=>{
    const context = (0, $42omo.useContext)($027f1d2b522f28cb$var$ModalContext);
    if (!context) throw new Error('useIsInModal must be used within a ModalProvider');
    return context;
};


const $e5b413d620faca77$export$5109c6dd95d8fb00 = (props)=>{
    const { appearance: appearance, defaultIsOpen: defaultIsOpen, autoFocus: autoFocus, defaultValue: defaultValue, disabled: disabled, maxDate: maxDate, minDate: minDate, isOpen: isOpen, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps, spacing: spacing, dateFormat: dateFormat, shouldShowCalendarButton: shouldShowCalendarButton, placeholder: placeholder, locale: locale, testId: testId, weekStartDay: weekStartDay, onChange: onChange, value: value, id: // Field props
    id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onBlur: onBlur, onFocus: onFocus, 'aria-invalid': ariaInvalid, 'aria-labelledby': ariaLabelledby, name: name } = props.forgeDoc.props;
    const { isInModal: isInModal } = (0, $027f1d2b522f28cb$export$1b1a640376f863b2)();
    // The below is to address the following bug from DST: https://product-fabric.atlassian.net/browse/DSP-15700
    // If the bug is fixed, the workaround below can be removed
    const [isInitialRenderDisabled, setIsInitialRenderDisabled] = (0, $42omo.useState)(isInModal ?? false);
    (0, $42omo.useEffect)(()=>{
        if (isInitialRenderDisabled && (0, $dh538.fg)('forge-ui-datepicker-modal-fix')) setTimeout(()=>{
            setIsInitialRenderDisabled(false);
        // from testing, 800 ms was the minimum time required for the modal to mount first without impacting the datepicker calendar
        }, 800);
    // disabled to ensure this only ever runs once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4Cbx.default), {
        // Updates the id to force a remount of the component. This is required to ensure certain props like `autoFocus` provided by the developer is properly applied.
        // `autoFocus` is only applied on initial mount and if isDisabled is set, it does not activate the calendar even when isDisabled is returned to false.
        key: isInitialRenderDisabled ? '1' : '2',
        isDisabled: isInitialRenderDisabled ? true : isDisabled,
        appearance: appearance,
        defaultIsOpen: defaultIsOpen,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        disabled: disabled,
        maxDate: maxDate,
        minDate: minDate,
        ...isOpen ? {
            isOpen: isOpen
        } : undefined,
        nextMonthLabel: nextMonthLabel,
        previousMonthLabel: previousMonthLabel,
        selectProps: selectProps,
        spacing: spacing,
        dateFormat: dateFormat,
        shouldShowCalendarButton: shouldShowCalendarButton,
        placeholder: placeholder,
        locale: locale,
        testId: testId,
        weekStartDay: weekStartDay,
        onChange: onChange,
        ...value !== undefined ? {
            value: value
        } : undefined,
        id: id,
        isRequired: isRequired,
        isInvalid: isInvalid,
        onBlur: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onBlur),
        onFocus: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onFocus),
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
};

// stateful version of DynamicTable from @atlaskit




var $1RqgI = parcelRequire("1RqgI");


// stateful version of DynamicTable from @atlaskit







const $0914fdd51a14cb6f$export$bf0162d825d6e13 = {
    createAnalyticsEvent: false,
    caption: true,
    defaultPage: true,
    defaultSortKey: true,
    defaultSortOrder: true,
    emptyView: {
        value: 'emptyView ? props.render(elementToForgeDoc(emptyView)) as ReactElement : undefined'
    },
    head: {
        value: 'head ? renderRow(head, props.render): undefined',
        comment: "Rendering each cell's content as one React element"
    },
    highlightedRowIndex: true,
    isFixedSize: true,
    isLoading: true,
    isRankable: true,
    label: true,
    loadingSpinnerSize: true,
    onRankEnd: true,
    onRankStart: true,
    onSetPage: true,
    page: true,
    paginationi18n: true,
    rowsPerPage: true,
    rows: {
        value: 'rows?.map((r) => renderRow(r, props.render))',
        comment: "Rendering each cell's content as one React element"
    },
    sortKey: true,
    sortOrder: true,
    testId: true
};
const $0914fdd51a14cb6f$var$renderRow = (row, render)=>{
    // not supporting onClick and onKeyPress to simplify API
    const { cells: cells, onClick: onClick, onKeyPress: onKeyPress, ...rest } = row;
    return {
        ...rest,
        cells: cells.map((cell)=>{
            const preRenderedContent = cell.content !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
                key: cell.key
            }, render((0, $e0c91e5c3783b9b5$export$1b341f978fa5ef9a)(cell.content))) : null;
            return {
                ...cell,
                content: preRenderedContent
            };
        })
    };
};
const $0914fdd51a14cb6f$export$af35fa26cfd84ce3 = (props)=>{
    const { caption: caption, defaultPage: defaultPage, defaultSortKey: defaultSortKey, defaultSortOrder: defaultSortOrder, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, isFixedSize: isFixedSize, isLoading: isLoading, isRankable: isRankable, label: label, loadingSpinnerSize: loadingSpinnerSize, onRankEnd: onRankEnd, onRankStart: onRankStart, onSetPage: onSetPage, page: page, paginationi18n: paginationi18n, rowsPerPage: rowsPerPage, rows: rows, sortKey: sortKey, sortOrder: sortOrder, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1RqgI.default), {
        caption: caption,
        defaultPage: defaultPage,
        defaultSortKey: defaultSortKey,
        defaultSortOrder: defaultSortOrder,
        emptyView: emptyView ? props.render((0, $e0c91e5c3783b9b5$export$1b341f978fa5ef9a)(emptyView)) : undefined,
        // Rendering each cell's content as one React element
        head: head ? $0914fdd51a14cb6f$var$renderRow(head, props.render) : undefined,
        highlightedRowIndex: highlightedRowIndex,
        isFixedSize: isFixedSize,
        isLoading: isLoading,
        isRankable: isRankable,
        label: label,
        loadingSpinnerSize: loadingSpinnerSize,
        onRankEnd: onRankEnd,
        onRankStart: onRankStart,
        onSetPage: onSetPage,
        page: page,
        paginationi18n: paginationi18n,
        rowsPerPage: rowsPerPage,
        // Rendering each cell's content as one React element
        rows: rows?.map((r)=>$0914fdd51a14cb6f$var$renderRow(r, props.render)),
        sortKey: sortKey,
        sortOrder: sortOrder,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 


/**
 * Non working props excluded:
 * isRankingDisabled
 * onPageRowsUpdate
 * onSort
 */ const $470ecb33486442bb$var$renderCellForgeDoc = (cells, render)=>cells.filter((cell)=>cell.type === 'Cell').map((cell)=>{
        const { children: children, props: cellProps } = cell;
        const { cellKey: cellKey, ...restProps } = cellProps || {};
        return {
            ...restProps,
            key: cellKey,
            content: children.map(render).flat()
        };
    });
const $470ecb33486442bb$export$af35fa26cfd84ce3 = (props)=>{
    if (props.forgeDoc.children.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0914fdd51a14cb6f$export$af35fa26cfd84ce3), props);
    const { caption: caption, defaultPage: defaultPage, defaultSortKey: defaultSortKey, defaultSortOrder: defaultSortOrder, emptyView: emptyView, highlightedRowIndex: highlightedRowIndex, isFixedSize: isFixedSize, isLoading: isLoading, isRankable: isRankable, label: label, loadingSpinnerSize: loadingSpinnerSize, onRankEnd: onRankEnd, onRankStart: onRankStart, onSetPage: onSetPage, page: page, paginationi18n: paginationi18n, rowsPerPage: rowsPerPage, sortKey: sortKey, sortOrder: sortOrder, testId: testId } = props.forgeDoc.props;
    const headForgeDoc = props.forgeDoc.children.find((child)=>child.type === 'ContentWrapper' && child.props?.name === 'head');
    const head = headForgeDoc ? {
        cells: $470ecb33486442bb$var$renderCellForgeDoc(headForgeDoc?.children, props.render)
    } : undefined;
    const rowsForgeDoc = props.forgeDoc.children.find((child)=>child.type === 'ContentWrapper' && child.props?.name === 'rows');
    const rows = rowsForgeDoc?.children.filter((row)=>row.type === 'Row').map((row)=>{
        const { children: children, props: rowProps } = row;
        const { rowKey: rowKey, ...restProps } = rowProps || {};
        return {
            ...restProps,
            key: rowKey,
            cells: $470ecb33486442bb$var$renderCellForgeDoc(children, props.render)
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1RqgI.default), {
        caption: caption,
        defaultPage: defaultPage,
        defaultSortKey: defaultSortKey,
        defaultSortOrder: defaultSortOrder,
        emptyView: emptyView ? props.render((0, $e0c91e5c3783b9b5$export$1b341f978fa5ef9a)(emptyView)) : undefined,
        head: head,
        highlightedRowIndex: highlightedRowIndex,
        isFixedSize: isFixedSize,
        isLoading: isLoading,
        isRankable: isRankable,
        label: label,
        loadingSpinnerSize: loadingSpinnerSize,
        onRankEnd: onRankEnd,
        onRankStart: onRankStart,
        onSetPage: onSetPage,
        page: page,
        paginationi18n: paginationi18n,
        rowsPerPage: rowsPerPage,
        rows: rows,
        sortKey: sortKey,
        sortOrder: sortOrder,
        testId: testId
    });
};






var $abC4X = parcelRequire("abC4X");

const $7e65a5488f15879d$export$bf0162d825d6e13 = {
    buttonGroupLabel: true,
    description: {
        value: 'description ? props.render(elementToForgeDoc(description as ReactElement)) : undefined'
    },
    header: true,
    headingLevel: true,
    imageHeight: false,
    imageUrl: false,
    imageWidth: false,
    isLoading: true,
    maxImageHeight: false,
    maxImageWidth: false,
    primaryAction: {
        value: 'primaryAction ? props.render(elementToForgeDoc(primaryAction as ReactElement)) : undefined'
    },
    renderImage: false,
    secondaryAction: {
        value: 'secondaryAction ? props.render(elementToForgeDoc(secondaryAction as ReactElement)) : undefined'
    },
    tertiaryAction: {
        value: 'tertiaryAction ? props.render(elementToForgeDoc(tertiaryAction as ReactElement)) : undefined'
    },
    testId: true,
    width: true
};
const $7e65a5488f15879d$export$fddf379e22a74b00 = (props)=>{
    const { buttonGroupLabel: buttonGroupLabel, description: description, header: header, headingLevel: headingLevel, isLoading: isLoading, primaryAction: primaryAction, secondaryAction: secondaryAction, tertiaryAction: tertiaryAction, testId: testId, width: width } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $abC4X.default), {
        buttonGroupLabel: buttonGroupLabel,
        description: description ? props.render((0, $e0c91e5c3783b9b5$export$1b341f978fa5ef9a)(description)) : undefined,
        header: header,
        headingLevel: headingLevel,
        isLoading: isLoading,
        primaryAction: primaryAction ? props.render((0, $e0c91e5c3783b9b5$export$1b341f978fa5ef9a)(primaryAction)) : undefined,
        secondaryAction: secondaryAction ? props.render((0, $e0c91e5c3783b9b5$export$1b341f978fa5ef9a)(secondaryAction)) : undefined,
        tertiaryAction: tertiaryAction ? props.render((0, $e0c91e5c3783b9b5$export$1b341f978fa5ef9a)(tertiaryAction)) : undefined,
        testId: testId,
        width: width
    });
}; /**
 * @codegenEnd
 */  /* eslint @repo/internal/codegen/signed-source-integrity: "warn" */ 





var $gQhRa = parcelRequire("gQhRa");

const $03f0e1b1264f2dff$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $03f0e1b1264f2dff$export$915e9e7bd4f0f96d = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.ErrorMessage), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





var $eyWa4 = parcelRequire("eyWa4");







var $6UBEn = parcelRequire("6UBEn");


var $chO1Z = parcelRequire("chO1Z");


var $fZtQj = parcelRequire("fZtQj");


var $e3TOY = parcelRequire("e3TOY");


var $2Yaht = parcelRequire("2Yaht");


var $hmuev = parcelRequire("hmuev");


var $9aGns = parcelRequire("9aGns");





/**
 * Format file size in human-readable format
 */ const $aa8e2bb5396b7bf6$var$formatFileSize = (bytes)=>{
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = [
        'B',
        'KB',
        'MB',
        'GB',
        'TB'
    ];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
};
/**
 * Get file extension from filename (if included)
 */ const $aa8e2bb5396b7bf6$var$getFileExtension = (fileName)=>{
    const lastDot = fileName.lastIndexOf('.');
    return lastDot > 0 ? fileName.substring(lastDot + 1).toUpperCase() : '';
};
/**
 * Get file extension from MIME type by parsing the type
 */ const $aa8e2bb5396b7bf6$var$getExtensionFromMimeType = (mimeType)=>{
    // Extract the subtype from MIME type (e.g., "image/png" -> "png")
    const parts = mimeType.split('/');
    if (parts.length === 2) return parts[1].toUpperCase();
    return '';
};
/**
 * Get the appropriate icon component based on MIME type
 */ const $aa8e2bb5396b7bf6$var$getFileIcon = (mimeType)=>{
    if (!mimeType) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
        label: "File"
    });
    const type = mimeType.toLowerCase();
    if (type.startsWith('image/')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fZtQj))), {
        label: "Image file"
    });
    if (type.startsWith('audio/')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e3TOY))), {
        label: "Audio file"
    });
    if (type.startsWith('video/')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
        label: "Video file"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
        label: "File"
    });
};
const $aa8e2bb5396b7bf6$var$styles = {
    card: "_2rko12b0 _v5641hdd _zulppxbi _1dqonqa1 _189ee4h9 _1h6d1l7x _1e0c1txw _4cvr1h6o _1bsb1osq _4t3i1wug _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    fileIcon: "_1e0c1txw _4cvr1h6o _1bah1h6o",
    fileInfo: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    actionButtons: "_1e0c1txw _4cvr1h6o",
    progressBar: "_ca0qu2gc"
};
const $aa8e2bb5396b7bf6$export$593fd10f7e6c6505 = (props)=>{
    const { fileName: fileName, fileSize: fileSize, fileType: fileType, onDelete: onDelete, onDownload: onDownload, isUploading: isUploading = false, uploadProgress: uploadProgress = 0, testId: testId, error: error } = props.forgeDoc.props;
    const adaptEventHandler = (0, $a55df4b138cf9873$export$5ce8c276f684a042)();
    const formattedSize = fileSize ? $aa8e2bb5396b7bf6$var$formatFileSize(fileSize || 0) : undefined;
    const fileExtension = fileType ? $aa8e2bb5396b7bf6$var$getExtensionFromMimeType(fileType) : $aa8e2bb5396b7bf6$var$getFileExtension(fileName);
    const handleOnDownload = async (e)=>{
        e.stopPropagation();
        const wrappedHandler = adaptEventHandler(async ()=>{
            const result = await onDownload?.();
            if (result instanceof Blob) {
                const url = URL.createObjectURL(result);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                setTimeout(()=>{
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                }, 100);
            }
        });
        wrappedHandler?.(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $aa8e2bb5396b7bf6$var$styles.card,
        backgroundColor: "elevation.surface.raised",
        onMouseEnter: (e)=>{
            e.currentTarget.style.backgroundColor = "var(--ds-background-neutral-subtle-hovered, #0515240F)";
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.backgroundColor = "var(--ds-surface-raised, #FFFFFF)";
        },
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $aa8e2bb5396b7bf6$var$styles.fileIcon
    }, $aa8e2bb5396b7bf6$var$getFileIcon(fileType)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.050",
        xcss: $aa8e2bb5396b7bf6$var$styles.fileInfo
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, fileName), error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.ErrorMessage), null, error) : isUploading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $aa8e2bb5396b7bf6$var$styles.progressBar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UBEn.default), {
        value: uploadProgress,
        ariaLabel: `${fileName} is currently uploading`
    })) : (fileExtension || formattedSize) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle"
    }, [
        fileExtension,
        formattedSize
    ].filter(Boolean).join(" \u2022 "))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $aa8e2bb5396b7bf6$var$styles.actionButtons
    }, onDownload && !isUploading && !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: handleOnDownload,
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        "aria-label": `download ${fileName}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9aGns))), {
        label: "Download"
    })), onDelete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: (e)=>{
            e.stopPropagation();
            adaptEventHandler(onDelete)?.(e);
        },
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        "aria-label": `delete ${fileName}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        label: "Delete"
    }))));
};

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $fNJG8 = parcelRequire("fNJG8");







var $feJ8f = parcelRequire("feJ8f");


var $jq9iL = parcelRequire("jq9iL");



var $iA9co = parcelRequire("iA9co");

var $731ba4db03f9b44c$require$Buffer = $iA9co.Buffer;
const $731ba4db03f9b44c$var$dropzoneStyle = null;
const $731ba4db03f9b44c$var$inDropzoneStyle = null;
const $731ba4db03f9b44c$var$notInDropzoneStyle = null;
const $731ba4db03f9b44c$var$serializeFiles = async (files)=>{
    return Promise.all(files.map(async (file)=>{
        const buffer = await file.arrayBuffer();
        return {
            name: file.name,
            type: file.type,
            size: file.size,
            data: $731ba4db03f9b44c$require$Buffer.from(buffer).toString('base64')
        };
    }));
};
const $731ba4db03f9b44c$export$54dc470bcc5c41d1 = (props)=>{
    const { description: description, label: label, onChange: onChange, testId: testId } = props.forgeDoc.props;
    const [inDropzone, setInDropzone] = (0, $42omo.useState)(false);
    const adaptEventHandler = (0, $a55df4b138cf9873$export$5ce8c276f684a042)();
    const inputRef = (0, $42omo.useRef)(null);
    const dropRef = (0, $42omo.useRef)(null);
    const onInputTriggerClick = (0, $42omo.useCallback)(()=>{
        inputRef.current?.click();
    }, []);
    (0, $42omo.useEffect)(()=>{
        const element = dropRef.current;
        if (!element) return;
        return (0, $feJ8f.dropTargetForExternal)({
            element: element,
            onDragEnter: ()=>{
                setInDropzone(true);
            },
            onDragLeave: ()=>{
                setInDropzone(false);
            },
            onDrop: onChange ? async ({ source: source })=>{
                const files = await (0, $jq9iL.getFiles)({
                    source: source
                });
                const serializedFiles = await $731ba4db03f9b44c$var$serializeFiles(files);
                setInDropzone(false);
                await onChange(serializedFiles);
            } : ()=>{
                setInDropzone(false);
            }
        });
    }, [
        onChange
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        testId: testId
    }, label && /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        weight: "bold",
        size: "small"
    }, label), /*#__PURE__*/ $42omo.createElement("input", {
        type: "file",
        multiple: true,
        onChange: onChange ? async (e)=>{
            const files = Array.from(e.target.files || []);
            const serializedFiles = await $731ba4db03f9b44c$var$serializeFiles(files);
            adaptEventHandler(()=>onChange(serializedFiles))?.(e);
        } : undefined,
        hidden: true,
        ref: inputRef
    }), /*#__PURE__*/ $42omo.createElement("div", {
        ref: dropRef,
        className: (0, $gMc0m.default)([
            "_2rko12b0 _1dqogq9o _189ee4h9 _1h6drsbi _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _y3gn1h6o",
            inDropzone ? "_1h6dq98m _bfhk1s93" : "_1h6drsbi"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        color: inDropzone ? 'color.text.selected' : 'color.text.subtlest'
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fNJG8))), {
        label: "file-picker-icon",
        color: inDropzone ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
    }), '  ', "Drop files to attach or", '  ', /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
        onClick: onInputTriggerClick
    }, "Browse"))), description && /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest"
    }, description));
};





var $bUlM5 = parcelRequire("bUlM5");

const $1e214349972aaec0$export$bf0162d825d6e13 = {
    children: true,
    as: false,
    justifyContent: true,
    alignItems: true,
    columnGap: true,
    gap: true,
    rowGap: true,
    direction: true,
    wrap: true,
    testId: true,
    'data-testid': false,
    role: true,
    xcss: false
};
const $1e214349972aaec0$export$f51f4c4ede09e011 = (props)=>{
    const { justifyContent: justifyContent, alignItems: alignItems, columnGap: columnGap, gap: gap, rowGap: rowGap, direction: direction, wrap: wrap, testId: testId, role: role } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        justifyContent: justifyContent,
        alignItems: alignItems,
        columnGap: columnGap,
        gap: gap,
        rowGap: rowGap,
        direction: direction,
        wrap: wrap,
        testId: testId,
        role: role
    });
}; /**
 * @codegenEnd
 */ 




const $1ebfea88a67bc737$export$a7fed597f4b8afd8 = (props)=>{
    const { onSubmit: onSubmit } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("form", {
        onSubmit: (e)=>{
            e.preventDefault();
            onSubmit();
        }
    }, props.forgeDoc.children.map(props.render));
};
const $1ebfea88a67bc737$export$c24727297075ec6a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);





var $dn4ZF = parcelRequire("dn4ZF");

const $05422e99a34922d5$export$bf0162d825d6e13 = {
    children: true,
    /**
	 * Sets the alignment of the footer contents. This is often a button. Defaults to `end`.
	 */ align: true
};
const $05422e99a34922d5$export$e7277fd05612133d = (props)=>{
    const { align: align } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dn4ZF.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        align: align
    });
}; /**
 * @codegenEnd
 */ 





var $brqG4 = parcelRequire("brqG4");

const $8f165c1167364179$export$bf0162d825d6e13 = {
    title: true,
    description: true,
    children: true
};
const $8f165c1167364179$export$97ee2cbf37e5ebfe = (props)=>{
    const { title: title, description: description } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $brqG4.default), {
        title: title,
        description: description,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c)))
    });
}; /**
 * @codegenEnd
 */ 





var $3eD0p = parcelRequire("3eD0p");

const $767d61145e43c730$export$bf0162d825d6e13 = {
    title: true,
    children: true,
    description: true
};
const $767d61145e43c730$export$b5ff61ac8b0a660f = (props)=>{
    const { title: title, description: description } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eD0p.default), {
        title: title,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        description: description
    });
}; /**
 * @codegenEnd
 */ 

// Note that the prop `templateAreas` is removed as it requires child components to use `style`




var $cwkWT = parcelRequire("cwkWT");

const $96ceb9d2478856d1$export$bf0162d825d6e13 = {
    children: true,
    as: false,
    justifyContent: true,
    justifyItems: true,
    alignItems: true,
    alignContent: true,
    columnGap: true,
    gap: true,
    rowGap: true,
    autoFlow: true,
    templateRows: true,
    templateColumns: true,
    templateAreas: false,
    id: true,
    testId: true,
    'data-testid': false,
    role: true,
    xcss: false
};
const $96ceb9d2478856d1$export$ef2184bd89960b14 = (props)=>{
    const { justifyContent: justifyContent, justifyItems: justifyItems, alignItems: alignItems, alignContent: alignContent, columnGap: columnGap, gap: gap, rowGap: rowGap, autoFlow: autoFlow, templateRows: templateRows, templateColumns: templateColumns, id: id, testId: testId, role: role } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cwkWT.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        justifyContent: justifyContent,
        justifyItems: justifyItems,
        alignItems: alignItems,
        alignContent: alignContent,
        columnGap: columnGap,
        gap: gap,
        rowGap: rowGap,
        autoFlow: autoFlow,
        templateRows: templateRows,
        templateColumns: templateColumns,
        id: id,
        testId: testId,
        role: role
    });
}; /**
 * @codegenEnd
 */ 

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 

















const $ad0fe6534ffb7bc3$export$aabfca967ce25e7e = ()=>{
    const { extensionType: extensionType } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $gGmck.RendererContext));
    return extensionType === 'xen:macro';
};
const $ad0fe6534ffb7bc3$export$30f7d67d7263f4a6 = ()=>{
    const { extensionType: extensionType } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $gGmck.RendererContext));
    return extensionType === 'confluence:contentBylineItem';
};


const $a8f1295e388793f1$var$onlyAllowHeadingTag = (asProp)=>{
    if (!asProp) return undefined;
    if (asProp && [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'div',
        'span'
    ].includes(asProp)) return asProp;
    throw Error(`${asProp} is an invalid heading tag. Please use one of h1, h2, h3, h4, h5, h6, div, span.`);
};
const $a8f1295e388793f1$var$getSize = (asProp)=>{
    if (!asProp) return 'xlarge';
    const sizeMap = {
        h1: 'xlarge',
        h2: 'large',
        h3: 'medium',
        h4: 'small',
        h5: 'xsmall',
        h6: 'xxsmall'
    };
    return sizeMap[asProp];
};
// Sizes differ slightly from sizes in editor (confluence/next/packages/content-renderer/src/renderers/StyledRenderer.tsx)
// xxlarge (token = 1.714em) (editor = does not exist)
// xlarge (token = 1.43em) (editor = 1.428em)
// large (token = 1.2em) (editor = 1.166em)
// medium (token = 1em) (editor = 1.142em)
// small (token = 0.857em) (editor = 1em)
// xsmall (token = 0.785em) (editor = 0.857em)
// xxsmall (token = 0.714em) (editor = 0.785em)
const $a8f1295e388793f1$var$headingStyles = {
    xxlarge: "_1oodk2uz",
    xlarge: "_1oodz4t2",
    large: "_1ood1jif",
    medium: "_1ood1myh",
    small: "_1oodfr1v",
    xsmall: "_1ood12rj",
    xxsmall: "_1oodboy6"
}; /**
    * A heading is a typography component used to display text in different sizes and formats.
    */ 
const $a8f1295e388793f1$export$a8a3e93435678ff9 = (props)=>{
    const { size: size, color: color, as: as, id: id, testId: testId } = props.forgeDoc.props;
    const effectiveSize = size ? size : $a8f1295e388793f1$var$getSize(as);
    const isMacro = (0, $ad0fe6534ffb7bc3$export$aabfca967ce25e7e)();
    if (isMacro && (0, $dh538.fg)('forge-ui-override-heading-style-in-macro')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $a8f1295e388793f1$var$headingStyles[effectiveSize]
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: effectiveSize,
        color: color,
        as: $a8f1295e388793f1$var$onlyAllowHeadingTag(as),
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        id: id,
        testId: testId
    }));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: effectiveSize,
        color: color,
        as: $a8f1295e388793f1$var$onlyAllowHeadingTag(as),
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        id: id,
        testId: testId
    });
};







const $93789ff5869bb338$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $93789ff5869bb338$export$8fbe3c7d0ed2c683 = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.HelperMessage), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 








const $39a34e462e058bd0$export$baab7c95ad93ac5a = {
    xsmall: '25%',
    small: '37.5%',
    medium: '50%',
    large: '75%',
    xlarge: '100%'
};
function $39a34e462e058bd0$var$ImageInner({ forgeDoc: forgeDoc }) {
    const { src: src, alt: alt, size: size = 'xlarge', width: width, height: height } = forgeDoc.props;
    const isCustomSize = width || height;
    const fixedImageSize = $39a34e462e058bd0$export$baab7c95ad93ac5a[size] ? $39a34e462e058bd0$export$baab7c95ad93ac5a[size] : '100%';
    const maxWidth = isCustomSize ? '100%' : fixedImageSize; // the width and height props will override the size prop
    return /*#__PURE__*/ $42omo.createElement("img", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 'auto',
            maxWidth: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            maxWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textAlign: 'center'
        },
        src: src,
        alt: alt,
        width: width,
        height: height
    });
}
const $39a34e462e058bd0$var$ImageWithSrcValidation = (props)=>{
    const { src: src } = props.forgeDoc.props;
    const isValidUrl = (0, $kS0x0.useIsValidImageUrl)(src);
    if (isValidUrl) return /*#__PURE__*/ $42omo.createElement($39a34e462e058bd0$var$ImageInner, props);
    return /*#__PURE__*/ $42omo.createElement((0, $er4dw.EgressErrorMessage), {
        url: src
    });
};
const $39a34e462e058bd0$export$3e431a229df88919 = (props)=>{
    const { src: src } = props.forgeDoc.props;
    const isAbsolutePath = src.startsWith('/');
    // If `src` is an absolute path, we can render the image immediately.
    // The resolved path will be routed to the tenant domain which is already authorised in our egress service so no validation is required.
    // This is required as Confluence endpoints tend to return absolute paths for avatar images.
    if (isAbsolutePath) return /*#__PURE__*/ $42omo.createElement($39a34e462e058bd0$var$ImageInner, props);
    return /*#__PURE__*/ $42omo.createElement($39a34e462e058bd0$var$ImageWithSrcValidation, props);
};

// Grow is being excluded at the moment as it requires a Box component to have `flexGrow: 1` as a property




var $dcJ7R = parcelRequire("dcJ7R");

const $f76c54d59d098003$export$bf0162d825d6e13 = {
    children: true,
    alignBlock: true,
    alignInline: true,
    spread: true,
    grow: true,
    space: true,
    shouldWrap: true,
    separator: true,
    rowSpace: true,
    testId: true
};
const $f76c54d59d098003$export$fbae5b5ffd8af05e = (props)=>{
    const { alignBlock: alignBlock, alignInline: alignInline, spread: spread, grow: grow, space: space, shouldWrap: shouldWrap, separator: separator, rowSpace: rowSpace, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        alignBlock: alignBlock,
        alignInline: alignInline,
        spread: spread,
        grow: grow,
        space: space,
        shouldWrap: shouldWrap,
        separator: separator,
        rowSpace: rowSpace,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 





var $lUjjs = parcelRequire("lUjjs");

const $c6aec3aaf282f684$var$noop = ()=>{};
const $c6aec3aaf282f684$export$97bda0f90d93904c = (props)=>{
    const { label: label, startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, onConfirm: providedOnConfirm = $c6aec3aaf282f684$var$noop, onCancel: providedOnCancel = $c6aec3aaf282f684$var$noop, onEdit: providedOnEdit = $c6aec3aaf282f684$var$noop } = props.forgeDoc.props;
    const readViewForgeDoc = props.forgeDoc.children.find((child)=>{
        if (child.type === 'ContentWrapper' && child.props?.name === 'readView') return child;
    });
    const editViewForgeDoc = props.forgeDoc.children.find((child)=>{
        if (child.type === 'ContentWrapper' && child.props?.name === 'editView') return child;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lUjjs.default), {
        label: label,
        startWithEditViewOpen: startWithEditViewOpen,
        keepEditViewOpenOnBlur: keepEditViewOpenOnBlur,
        hideActionButtons: hideActionButtons,
        isRequired: isRequired,
        readViewFitContainerWidth: readViewFitContainerWidth,
        editButtonLabel: editButtonLabel,
        confirmButtonLabel: confirmButtonLabel,
        cancelButtonLabel: cancelButtonLabel,
        defaultValue: defaultValue,
        isEditing: isEditing,
        readView: ()=>readViewForgeDoc?.children.map(props.render),
        editView: ()=>editViewForgeDoc?.children.map(props.render),
        onConfirm: providedOnConfirm,
        onCancel: providedOnCancel,
        onEdit: providedOnEdit
    });
};





var $bfgIy = parcelRequire("bfgIy");

const $2949b71a9c026983$export$bf0162d825d6e13 = {
    /**
	 * Content of the label.
	 */ children: true,
    /**
	 * The unique identifier to match the label to the field component `id`.
	 */ htmlFor: {
        value: 'labelFor',
        excludeFromDeconstruct: true,
        comment: 'labelFor as prop name to remove reference to HTML'
    },
    /**
	 * The unique identifier for the label.
	 */ id: true,
    testId: true
};
const $2949b71a9c026983$export$b04be29aa201d4f5 = (props)=>{
    const { id: id, testId: testId, labelFor: labelFor } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bfgIy.Label), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        // labelFor as prop name to remove reference to HTML
        htmlFor: labelFor,
        id: id,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $kZjf5 = parcelRequire("kZjf5");


var $clpPd = parcelRequire("clpPd");

const $79ffaea80c8babc5$export$a6c7ac8248d6e38a = (props)=>{
    const { egress: egress, properties: properties } = (0, $42omo.useContext)((0, $gGmck.RendererContext));
    const { forgeDoc: forgeDoc, render: render } = props;
    const { href: href, openNewTab: openNewTab } = forgeDoc.props;
    const extension = {
        egress: egress,
        properties: properties
    };
    const { onNavigate: onNavigate, getModalJsx: getModalJsx } = (0, $kZjf5.useNavigation)({
        extension: extension
    });
    const santizedUrl = (0, $clpPd.sanitizeUrl)(href);
    return /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, getModalJsx(), /*#__PURE__*/ $42omo.createElement("a", {
        target: openNewTab ? '_blank' : undefined,
        href: santizedUrl,
        onClick: (e)=>{
            // stop the usual navigation event from anchor tags
            e.preventDefault();
            onNavigate({
                type: openNewTab ? 'new-tab' : 'same-tab',
                url: santizedUrl
            });
        },
        rel: "noopener noreferrer"
    }, forgeDoc.children.map(render)));
};

/* link-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $7p4As = parcelRequire("7p4As");















const $d8f17ec7cdc8b68d$var$defaultStyle = null;
const $d8f17ec7cdc8b68d$var$primaryStyle = null;
const $d8f17ec7cdc8b68d$var$warningStyle = null;
const $d8f17ec7cdc8b68d$var$dangerStyle = null;
const $d8f17ec7cdc8b68d$var$discoveryStyle = null;
const $d8f17ec7cdc8b68d$var$subtleStyle = null; /**
                           * Type for link button had to be defined here because the prop `href` should only take strings here
                           * and not custom RouterLinkConfigs
                           */ 
const $d8f17ec7cdc8b68d$var$mapDeprecatedAppearances = (appearance)=>appearance === 'link' || appearance === 'subtle-link' ? 'subtle' : appearance; /**
                                                                                                                                                                * Mapping the deprecated 'none' spacing to 'compact'
                                                                                                                                                                */ 
const $d8f17ec7cdc8b68d$var$mapDeprecatedSpacing = (spacing)=>spacing === 'none' ? 'compact' : spacing;
const $d8f17ec7cdc8b68d$var$BaseLinkButton = (props)=>{
    const { target: target, href: href, autoFocus: autoFocus, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, spacing: spacing, testId: testId, shouldFitContainer: shouldFitContainer, appearance: appearance } = props.forgeDoc.props;
    const { egress: egress, properties: properties } = (0, $42omo.useContext)((0, $gGmck.RendererContext));
    const extension = {
        egress: egress,
        properties: properties
    };
    const { onNavigate: onNavigate, getModalJsx: getModalJsx } = (0, $kZjf5.useNavigation)({
        extension: extension
    });
    const openNewTab = target === '_blank';
    const santizedUrl = (0, $clpPd.sanitizeUrl)(href);
    const onClickWithSafeNavigation = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        if (href) onNavigate({
            type: openNewTab ? 'new-tab' : 'same-tab',
            url: santizedUrl
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, getModalJsx(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        target: target,
        href: santizedUrl,
        rel: 'noopener noreferrer',
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onBlur),
        onClick: (e, ...args)=>{
            // stop the default navigation behaviour from anchor tags
            e.preventDefault();
            (0, $a61a7775f4548bb7$export$f956703109d01f6a)?.(onClickWithSafeNavigation)?.(e, ...args);
        },
        onFocus: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onFocus),
        spacing: $d8f17ec7cdc8b68d$var$mapDeprecatedSpacing(spacing),
        testId: testId,
        shouldFitContainer: shouldFitContainer,
        appearance: $d8f17ec7cdc8b68d$var$mapDeprecatedAppearances(appearance)
    }));
};
const $d8f17ec7cdc8b68d$var$BaseLinkButtonWithAnalytics = (props)=>{
    const { target: target, href: href, autoFocus: autoFocus, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, spacing: spacing, testId: testId, shouldFitContainer: shouldFitContainer, appearance: appearance } = props.forgeDoc.props;
    const adaptEventHandler = (0, $a55df4b138cf9873$export$5ce8c276f684a042)();
    const { egress: egress, properties: properties } = (0, $42omo.useContext)((0, $gGmck.RendererContext));
    const extension = {
        egress: egress,
        properties: properties
    };
    const { onNavigate: onNavigate, getModalJsx: getModalJsx } = (0, $kZjf5.useNavigation)({
        extension: extension
    });
    const openNewTab = target === '_blank';
    const santizedUrl = (0, $clpPd.sanitizeUrl)(href);
    const onClickWithSafeNavigation = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        if (href) onNavigate({
            type: openNewTab ? 'new-tab' : 'same-tab',
            url: santizedUrl
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, getModalJsx(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        target: target,
        href: santizedUrl,
        rel: 'noopener noreferrer',
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: adaptEventHandler(onBlur),
        onClick: (e, ...args)=>{
            // stop the default navigation behaviour from anchor tags
            e.preventDefault();
            adaptEventHandler?.(onClickWithSafeNavigation)?.(e, ...args);
        },
        onFocus: adaptEventHandler(onFocus),
        spacing: $d8f17ec7cdc8b68d$var$mapDeprecatedSpacing(spacing),
        testId: testId,
        shouldFitContainer: shouldFitContainer,
        appearance: $d8f17ec7cdc8b68d$var$mapDeprecatedAppearances(appearance)
    }));
};
const $d8f17ec7cdc8b68d$var$Component = (props)=>{
    if ((0, $dh538.fg)('forge-ui-performance-analytics-provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d8f17ec7cdc8b68d$var$BaseLinkButtonWithAnalytics, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d8f17ec7cdc8b68d$var$BaseLinkButton, props);
}; /**
    * Renders a link in the style of a button.
    */ 
const $d8f17ec7cdc8b68d$export$29d11c0fe2fc51d8 = (props)=>{
    const isBylineItem = (0, $ad0fe6534ffb7bc3$export$30f7d67d7263f4a6)();
    const { appearance: appearance } = props.forgeDoc.props; // This overrides global anchor tag styling that affects link button in byline content apps
    return isBylineItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            appearance === undefined && "_1tjqi7uo",
            appearance === 'primary' && "_1tjq15cr",
            appearance === 'warning' && "_1tjq1yd3",
            appearance === 'danger' && "_1tjq15cr",
            appearance === 'discovery' && "_1tjq15cr",
            appearance === 'subtle' && "_1tjqi7uo"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d8f17ec7cdc8b68d$var$Component, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d8f17ec7cdc8b68d$var$Component, props);
};

/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 









const $6528e052fc61f2c8$var$defaultMarginStyle = null;
const $6528e052fc61f2c8$var$styles = {
    macroMargin: "_18u01b66 _19pku2gc"
};
const $6528e052fc61f2c8$var$defaultStyle = null; // bullet style ordering
const $6528e052fc61f2c8$var$UNORDERED_LIST_STYLES = [
    'disc',
    'circle',
    'square'
];
const $6528e052fc61f2c8$var$ORDERED_LIST_STYLES = [
    'decimal',
    'lower-alpha',
    'lower-roman'
]; // create a type ForgeDocWihData that includes an indentLevel object, to avoid exposing indentLevel prop in ListProps
const $6528e052fc61f2c8$export$54c2e3dc7acea9f5 = (props)=>{
    const { forgeDoc: forgeDoc, render: render } = props;
    const { type: type } = props.forgeDoc.props;
    const forgeDocWithData = forgeDoc; // initialise indentLevel to 0 and add to forgeDocWithData
    if (forgeDocWithData.data === undefined) forgeDocWithData.data = {
        indentLevel: 0
    };
     // the indentLevel is used to determine the list item style that should be rendered for that level
    const { indentLevel: indentLevel } = forgeDocWithData.data;
    const isMacro = (0, $ad0fe6534ffb7bc3$export$aabfca967ce25e7e)(); // set the list style according to the list type
    const listType = type === 'ordered' ? $6528e052fc61f2c8$var$ORDERED_LIST_STYLES : $6528e052fc61f2c8$var$UNORDERED_LIST_STYLES; // pass iterated indentLevel to child
    forgeDocWithData.children.forEach((child)=>{
        // This `if` block needs to be deprecated. `List` children should always be `ListItem`s, not another `List`
        // Using `List` as a child of `List` fails accessibility tests
        if (child.type === 'List') child.data = {
            ...child.data,
            indentLevel: indentLevel + 1
        };
        if (child.type === 'ListItem') // Iterate through children of `ListItem` to find any `List` children to pass indentLevel
        // This is to render the correct list style
        child.children.forEach((grandChild)=>{
            if (grandChild.type === 'List') grandChild.data = {
                ...child.data,
                indentLevel: indentLevel + 1
            };
        });
    });
    const listChildren = forgeDocWithData.children.map((child)=>render(child)); // We have to use "style" here since the value for the "list-style-type" property is dynamic (based on the indentation level).
    // Compiled does not support dynamic values and @compiled/babel-plugin would not be able to transform this code.
    // See https://atlassian.design/components/eslint-plugin-ui-styling-standard/migration-guide#dynamic-styles
    const listComponent = type === 'ordered' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ol", {
        key: forgeDocWithData.key,
        style: {
            listStyleType: listType[indentLevel % listType.length]
        },
        className: (0, $gMc0m.default)([
            "_vwz41ejb _xhc01b66",
            "_18u0mgjw"
        ])
    }, listChildren) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
        key: forgeDocWithData.key,
        style: {
            listStyleType: listType[indentLevel % listType.length]
        },
        className: (0, $gMc0m.default)([
            "_vwz41ejb _xhc01b66",
            "_18u0mgjw"
        ])
    }, listChildren);
    if (isMacro && indentLevel === 0) // Applying an additional margin when used in a macro extension point as the editor contains styling that causes decimal bullets to overflow and be cut off. The additional margin shifts the List component to prevent the cut off.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $6528e052fc61f2c8$var$styles.macroMargin
    }, listComponent);
    return listComponent;
};




const $fda6ba8c44d5f6e4$export$a7b06bfba60a8a78 = (props)=>{
    const { forgeDoc: forgeDoc, render: render } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
        key: forgeDoc.key,
        children: forgeDoc.children.map(render)
    });
};

/* loading-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 








var $9YwaJ = parcelRequire("9YwaJ");




const $a7a849b4fabaa947$var$buttonStyle = null;
const $a7a849b4fabaa947$var$OldLoadingButton = (props)=>{
    const { appearance: appearance, autoFocus: autoFocus, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, spacing: spacing, testId: testId, shouldFitContainer: shouldFitContainer, type: type, isLoading: isLoading } = props.forgeDoc.props;
    const isMacro = (0, $ad0fe6534ffb7bc3$export$aabfca967ce25e7e)();
    const isBylineItem = (0, $ad0fe6534ffb7bc3$export$30f7d67d7263f4a6)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            (isMacro || isBylineItem) && "_11c8fhey"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9YwaJ.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onBlur),
        onClick: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onClick),
        onFocus: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onFocus),
        spacing: spacing,
        testId: testId,
        shouldFitContainer: shouldFitContainer,
        type: type,
        isLoading: isLoading
    }));
};
const $a7a849b4fabaa947$var$LoadingButtonWithAnalytics = (props)=>{
    const { appearance: appearance, autoFocus: autoFocus, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, spacing: spacing, testId: testId, shouldFitContainer: shouldFitContainer, type: type, isLoading: isLoading } = props.forgeDoc.props;
    const isMacro = (0, $ad0fe6534ffb7bc3$export$aabfca967ce25e7e)();
    const isBylineItem = (0, $ad0fe6534ffb7bc3$export$30f7d67d7263f4a6)();
    const adaptEventHandler = (0, $a55df4b138cf9873$export$5ce8c276f684a042)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            (isMacro || isBylineItem) && "_11c8fhey"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9YwaJ.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: adaptEventHandler(onBlur),
        onClick: adaptEventHandler(onClick),
        onFocus: adaptEventHandler(onFocus),
        spacing: spacing,
        testId: testId,
        shouldFitContainer: shouldFitContainer,
        type: type,
        isLoading: isLoading
    }));
}; /**
    * A button that shows an spinner as an overlay on the button when you set an isLoading prop to true.
    */ 
const $a7a849b4fabaa947$export$4ec83e90d030b2f3 = (props)=>{
    if ((0, $dh538.fg)('forge-ui-performance-analytics-provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a7a849b4fabaa947$var$LoadingButtonWithAnalytics, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a7a849b4fabaa947$var$OldLoadingButton, props);
};






var $5nBzc = parcelRequire("5nBzc");

const $8e74fad470730542$export$bf0162d825d6e13 = {
    appearance: true,
    children: {
        value: 'getTextFromForgeDocChildren(props.forgeDoc)',
        comment: 'Lozenge should only accept plain text as children'
    },
    isBold: true,
    maxWidth: true,
    testId: true
};
const $8e74fad470730542$export$a31cbe1bf5463979 = (props)=>{
    const { appearance: appearance, isBold: isBold, maxWidth: maxWidth, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        // Lozenge should only accept plain text as children
        children: (0, $7b3d0d2c6f33df23$export$550573b096470df3)(props.forgeDoc),
        isBold: isBold,
        maxWidth: maxWidth,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 





var $8CZUH = parcelRequire("8CZUH");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $hnPaP = parcelRequire("hnPaP");


var $1qfLF = parcelRequire("1qfLF");





var $gj7hi = parcelRequire("gj7hi");


var $u9agA = parcelRequire("u9agA");









const $a92a253d818c7c08$export$2b77a92f1a5ad772 = (props)=>{
    const { autoFocus: autoFocus, height: height, width: width, onClose: onClose, shouldScrollInViewport: shouldScrollInViewport, label: label, testId: testId, title: title, icon: icon } = props.forgeDoc.props;
    const adaptEventHandler = (0, $a55df4b138cf9873$export$5ce8c276f684a042)();
    const { properties: properties } = (0, $42omo.useContext)((0, $gGmck.RendererContext));
    const extensionTitle = properties?.title;
    const onCloseHandler = adaptEventHandler(onClose);
    const children = props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            key: c.key
        }, props.render(c)));
    const renderModalHeader = (title, icon)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.100",
            alignBlock: "center"
        }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: icon,
            alt: "",
            height: "var(--ds-space-300, 24px)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
            label: "Close Modal",
            onClick: onCloseHandler
        }));
    if (width === 'fullscreen' && (0, $dh538.fg)('forge-ui-kit-fullscreen-modal')) {
        const fullscreenModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnPaP.FullScreenModalDialog), {
            autoFocus: autoFocus,
            onClose: onCloseHandler,
            label: label,
            testId: testId
        }, renderModalHeader(title ?? extensionTitle, icon), children);
        return (0, $dh538.fg)('forge-ui-datepicker-modal-fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $027f1d2b522f28cb$export$178405afcd8c5eb), null, fullscreenModal) : fullscreenModal;
    }
    const regularModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        autoFocus: autoFocus,
        height: height,
        width: width,
        onClose: onCloseHandler,
        shouldScrollInViewport: shouldScrollInViewport,
        label: label,
        testId: testId
    }, title && (0, $dh538.fg)('forge-ui-kit-modal-title-icon-props') && renderModalHeader(title, icon), children);
    return (0, $dh538.fg)('forge-ui-datepicker-modal-fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $027f1d2b522f28cb$export$178405afcd8c5eb), null, regularModal) : regularModal;
};





var $1DHa6 = parcelRequire("1DHa6");

const $fc93215de45af324$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $fc93215de45af324$export$cb540d8b0ef7906c = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 





var $8o1lj = parcelRequire("8o1lj");

const $0317a808cd1fde51$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $0317a808cd1fde51$export$519437715052e656 = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 







const $9f7a43a09b6f4394$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $9f7a43a09b6f4394$export$f50a68e3694789ee = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 







const $953c31e66b49cd3a$export$bf0162d825d6e13 = {
    appearance: true,
    children: true,
    isMultiline: true,
    testId: true
};
const $953c31e66b49cd3a$export$b26fae16ba5468aa = (props)=>{
    const { appearance: appearance, isMultiline: isMultiline, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), {
        appearance: appearance,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        isMultiline: isMultiline,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 





var $6xdDU = parcelRequire("6xdDU");

const $e6ff594647c24f09$export$bf0162d825d6e13 = {
    children: true
};
const $e6ff594647c24f09$export$f0a3ab1cc2e7e9a6 = (props)=>{
    const {} = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c)))
    });
}; /**
 * @codegenEnd
 */ 

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $lGgRw = parcelRequire("lGgRw");





var $1Whri = parcelRequire("1Whri");

// This is required to keep the div width wrapped around the contents of trigger instead of the full width of the parent
const $6526f160ae33ce5b$var$styles = {
    triggerContainer: "_1e0c1o8l",
    fullWidth: "_1bsb1osq"
};
const $6526f160ae33ce5b$export$129a32eedafa97c5 = (props)=>{
    const { isOpen: isOpen, id: providedId, testId: testId, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement, fallbackPlacements: fallbackPlacements, autoFocus: autoFocus, shouldRenderToParent: shouldRenderToParent, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldFitContainer: shouldFitContainer, shouldDisableFocusLock: shouldDisableFocusLock, strategy: strategy, role: role, label: label, titleId: titleId } = props.forgeDoc.props;
    const contentForgeDoc = props.forgeDoc.children.find((child)=>{
        if (child.type === 'ContentWrapper' && child.props?.name === 'content') return child;
    });
    const triggerForgeDoc = props.forgeDoc.children.find((child)=>{
        if (child.type === 'ContentWrapper' && child.props?.name === 'trigger') return child;
    });
    // Trigger props need to be passed internally here because it contains a ref object which can't be passed in the runtime
    // The double span is a workaround to ensure the span is wrapped around the popup trigger component without it extending the width of the container when used within `Inline`. Otherwise, the popup trigger component will extend the width of the container.
    const TriggerComponent = ({ triggerProps: triggerProps, shouldFitContainer: shouldFitContainer })=>{
        // aria props removed as they fail accessibility tests when passed into a span
        const { 'aria-expanded': _expanded, 'aria-haspopup': _popup, ...restTriggerProps } = triggerProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span",
            xcss: (0, $1Whri.cx)($6526f160ae33ce5b$var$styles.triggerContainer, shouldFitContainer && $6526f160ae33ce5b$var$styles.fullWidth),
            ...restTriggerProps
        }, triggerForgeDoc?.children.map(props.render)));
    };
    /**
   * This check is necessary because of the conditional typing for PopupProps in ADS.
   * It has a union type `type PopupProps = StandardPopupProps | ShouldFitContainerPopupProps` where combined,
   * the `shouldFitContainer` prop is actually typed `(false | undefined) OR true`.
   * However, this resolves as `boolean | undefined`, which does not match the ADS typing. Therefore we need to declare two versions -
   * where `shouldFitContainer` is explicitly true (to match `ShouldFitContainerPopupProps`), and false (to match StandardPopupProps).
   */ if (shouldFitContainer) return(// eslint-disable-next-line @atlaskit/design-system/use-should-render-to-parent
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        content: ()=>contentForgeDoc?.children.map(props.render),
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        id: providedId,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldFitContainer: shouldFitContainer,
        shouldRenderToParent: shouldRenderToParent ? shouldRenderToParent : undefined,
        strategy: strategy ? 'absolute' : undefined,
        shouldDisableFocusLock: shouldDisableFocusLock,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(TriggerComponent, {
                triggerProps: triggerProps,
                shouldFitContainer: true
            }),
        role: role,
        label: label,
        titleId: titleId
    }));
    return(// eslint-disable-next-line @atlaskit/design-system/use-should-render-to-parent
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        content: ()=>contentForgeDoc?.children.map(props.render),
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        id: providedId,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(TriggerComponent, {
                triggerProps: triggerProps
            }),
        strategy: strategy,
        role: role,
        label: label,
        titleId: titleId
    }));
};








var $2W0qg = parcelRequire("2W0qg");



/**
 * The below lint rules are disabled because Pressable relies on building styles at runtime in Forge apps.
 * This implementation is copied from @atlaskit/primitives/src/components/pressable.tsx which has the same
 * pattern. The css prop with runtime-computed values is required for the xcss prop to work correctly.
 * See go/DSP-18766 for more context.
 *
 * @atlaskit/design-system/consistent-css-prop-usage is disabled because this component must import
 * shared style maps (backgroundColorStylesMap, surfaceColorStylesMap, paddingStylesMap) for runtime
 * token resolution. Inlining these maps would create unmaintainable code duplication across Box and
 * Pressable components. This is an architectural requirement for Forge UI Kit's token system.
 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage -- Required for runtime xcss resolution with imported token style maps. See explanation above and go/DSP-18766 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values -- Required for token map imports. See go/DSP-18766 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values -- Required for runtime style computation. See go/DSP-18766 */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled













function $a6c65a30a87b1bfc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Base styles for the Pressable component (matching @atlaskit/primitives)
const $a6c65a30a87b1bfc$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};
const $a6c65a30a87b1bfc$var$enabledStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $a6c65a30a87b1bfc$var$disabledStyles = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
// This duplicates FocusRing styles from `@atlaskit/focus-ring` (matching @atlaskit/primitives)
const $a6c65a30a87b1bfc$var$focusRingStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/ensure-design-token-usage
        outlineColor: (0, $5a960931a5ccb935$export$1531ad5bb3fbedac)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $5a960931a5ccb935$export$958d0ae7f2977ae4)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $5a960931a5ccb935$export$e1b83c5210c471b8)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none',
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $5a960931a5ccb935$export$e1b83c5210c471b8)['border.width']} solid`
        }
    }
});
// Internal Pressable component implementation (migrated from @atlaskit/primitives)
const $a6c65a30a87b1bfc$var$InternalPressable = ({ children: children, backgroundColor: backgroundColor, isDisabled: isDisabled, onClick: onClick, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, testId: testId, xcss: xcssValue })=>{
    // Build styles array from SerializedStyles (matching @atlaskit/primitives)
    const styles = [
        $a6c65a30a87b1bfc$var$baseStyles,
        $a6c65a30a87b1bfc$var$focusRingStyles,
        isDisabled ? $a6c65a30a87b1bfc$var$disabledStyles : $a6c65a30a87b1bfc$var$enabledStyles,
        backgroundColor && (0, $5a960931a5ccb935$export$e7af83bafe7f9e63)[backgroundColor],
        padding && (0, $5a960931a5ccb935$export$e615f061ca585a6c).padding[padding],
        paddingBlock && (0, $5a960931a5ccb935$export$e615f061ca585a6c).paddingBlock[paddingBlock],
        paddingBlockStart && (0, $5a960931a5ccb935$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
        paddingBlockEnd && (0, $5a960931a5ccb935$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
        paddingInline && (0, $5a960931a5ccb935$export$e615f061ca585a6c).paddingInline[paddingInline],
        paddingInlineStart && (0, $5a960931a5ccb935$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
        paddingInlineEnd && (0, $5a960931a5ccb935$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
        xcssValue && (0, $5c1031de888776bc$export$64515584d375f8d)(xcssValue)
    ].filter(Boolean);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("button", {
        css: styles,
        "data-testid": testId,
        disabled: isDisabled,
        onClick: onClick,
        type: "button"
    }, children);
};
const $a6c65a30a87b1bfc$export$27c701ed9e449e99 = (props)=>{
    const { backgroundColor: backgroundColor, isDisabled: isDisabled, onClick: onClick, padding: padding, paddingBlock: paddingBlock, paddingBlockEnd: paddingBlockEnd, paddingBlockStart: paddingBlockStart, paddingInline: paddingInline, paddingInlineEnd: paddingInlineEnd, paddingInlineStart: paddingInlineStart, testId: testId, xcss: xcss } = props.forgeDoc.props;
    // Use the appropriate event handler based on analytics feature flag
    const adaptEventHandlerHook = (0, $a55df4b138cf9873$export$5ce8c276f684a042)();
    const eventHandler = (0, $dh538.fg)('forge-ui-performance-analytics-provider') ? adaptEventHandlerHook(onClick) : (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onClick);
    return /*#__PURE__*/ (0, $9K4OG.jsx)($a6c65a30a87b1bfc$var$InternalPressable, {
        backgroundColor: backgroundColor,
        isDisabled: isDisabled,
        onClick: eventHandler,
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockEnd: paddingBlockEnd,
        paddingBlockStart: paddingBlockStart,
        paddingInline: paddingInline,
        paddingInlineEnd: paddingInlineEnd,
        paddingInlineStart: paddingInlineStart,
        testId: testId,
        xcss: xcss && (0, $18a557183f782deb$export$aa422b2708209a80)(xcss)
    }, props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            key: c.key
        }, props.render(c))));
};




const $1cdf72e8bfd5ddec$var$OldPressable = (props)=>{
    const { backgroundColor: backgroundColor, isDisabled: isDisabled, onClick: onClick, padding: padding, paddingBlock: paddingBlock, paddingBlockEnd: paddingBlockEnd, paddingBlockStart: paddingBlockStart, paddingInline: paddingInline, paddingInlineEnd: paddingInlineEnd, paddingInlineStart: paddingInlineStart, testId: testId, xcss: xcss } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        backgroundColor: backgroundColor,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        isDisabled: isDisabled,
        onClick: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onClick),
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockEnd: paddingBlockEnd,
        paddingBlockStart: paddingBlockStart,
        paddingInline: paddingInline,
        paddingInlineEnd: paddingInlineEnd,
        paddingInlineStart: paddingInlineStart,
        testId: testId,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        xcss: xcss && (0, $ecnYn.xcss)((0, $18a557183f782deb$export$aa422b2708209a80)(xcss))
    });
};
const $1cdf72e8bfd5ddec$var$PressableWithAnalytics = (props)=>{
    const { backgroundColor: backgroundColor, isDisabled: isDisabled, onClick: onClick, padding: padding, paddingBlock: paddingBlock, paddingBlockEnd: paddingBlockEnd, paddingBlockStart: paddingBlockStart, paddingInline: paddingInline, paddingInlineEnd: paddingInlineEnd, paddingInlineStart: paddingInlineStart, testId: testId, xcss: xcss } = props.forgeDoc.props;
    const adaptEventHandler = (0, $a55df4b138cf9873$export$5ce8c276f684a042)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        backgroundColor: backgroundColor,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        isDisabled: isDisabled,
        onClick: adaptEventHandler(onClick),
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockEnd: paddingBlockEnd,
        paddingBlockStart: paddingBlockStart,
        paddingInline: paddingInline,
        paddingInlineEnd: paddingInlineEnd,
        paddingInlineStart: paddingInlineStart,
        testId: testId,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        xcss: xcss && (0, $ecnYn.xcss)((0, $18a557183f782deb$export$aa422b2708209a80)(xcss))
    });
};
const $1cdf72e8bfd5ddec$export$27c701ed9e449e99 = (props)=>{
    if ((0, $dh538.fg)('platform_migrate_pressable_to_use_migrated_xcss')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6c65a30a87b1bfc$export$27c701ed9e449e99), props);
    if ((0, $dh538.fg)('forge-ui-performance-analytics-provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1cdf72e8bfd5ddec$var$PressableWithAnalytics, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1cdf72e8bfd5ddec$var$OldPressable, props);
};







const $662934f2ccc55a75$export$bf0162d825d6e13 = {
    appearance: true,
    ariaLabel: true,
    isIndeterminate: true,
    testId: true,
    value: true
};
const $662934f2ccc55a75$export$c17561cb55d4db30 = (props)=>{
    const { appearance: appearance, ariaLabel: ariaLabel, isIndeterminate: isIndeterminate, testId: testId, value: value } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UBEn.default), {
        appearance: appearance,
        ariaLabel: ariaLabel,
        isIndeterminate: isIndeterminate,
        testId: testId,
        value: value
    });
}; /**
 * @codegenEnd
 */ 





var $jwcwi = parcelRequire("jwcwi");

const $f27e71f81adf4ae0$export$bf0162d825d6e13 = {
    animated: true,
    items: {
        value: 'filterItems(items)'
    },
    label: true,
    spacing: true,
    testId: true
};
// Filters out href from items. @forge/bridge router must be used in onClick for in app navigation
const $f27e71f81adf4ae0$var$filterItems = (items)=>{
    return items.map((item)=>{
        // removes href and noLink props
        const { href: href, noLink: noLink, ...rest } = item;
        return {
            ...rest,
            noLink: !rest.onClick
        };
    });
};
const $f27e71f81adf4ae0$export$50a55323bc54fb79 = (props)=>{
    const { animated: animated, items: items, label: label, spacing: spacing, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jwcwi.default), {
        animated: animated,
        items: $f27e71f81adf4ae0$var$filterItems(items),
        label: label,
        spacing: spacing,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 





var $kZ5GD = parcelRequire("kZ5GD");


const $c471241698e6ee4a$export$bf0162d825d6e13 = {
    label: true,
    testId: true,
    isChecked: true,
    ariaLabel: true,
    onInvalid: true
};
const $c471241698e6ee4a$export$d7b12c4107be0d61 = (props)=>{
    const { label: label, testId: testId, isChecked: isChecked, ariaLabel: ariaLabel, onInvalid: onInvalid, id: // Field props
    id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, "aria-invalid": ariaInvalid, "aria-labelledby": ariaLabelledby, name: name } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
        label: label,
        testId: testId,
        isChecked: isChecked,
        ariaLabel: ariaLabel,
        onInvalid: onInvalid,
        // Field props
        id: id,
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onChange: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onChange),
        onBlur: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onBlur),
        onFocus: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onFocus),
        value: value,
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
}; /**
 * @codegenEnd
 */ 





var $lBvGi = parcelRequire("lBvGi");


const $294009ff50641444$export$bf0162d825d6e13 = {
    defaultValue: true,
    options: true,
    onInvalid: true,
    testId: true
};
const $294009ff50641444$export$a98f0dcb43a68a25 = (props)=>{
    const { defaultValue: defaultValue, options: options, onInvalid: onInvalid, testId: testId, isRequired: // Field props
    isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, value: value, "aria-labelledby": ariaLabelledby, name: name } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBvGi.default), {
        defaultValue: defaultValue,
        options: options,
        onInvalid: onInvalid,
        testId: testId,
        // Field props
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onChange: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onChange),
        value: value,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
}; /**
 * @codegenEnd
 */ 





var $epp7s = parcelRequire("epp7s");


const $aaf088545b88ebea$export$bf0162d825d6e13 = {
    defaultValue: true,
    max: true,
    min: true,
    step: true,
    testId: true,
    onChange: true
};
const $aaf088545b88ebea$export$9a58ef0d7ad3278c = (props)=>{
    const { defaultValue: defaultValue, max: max, min: min, step: step, testId: testId, onChange: onChange, id: // Field props
    id, isDisabled: isDisabled, onBlur: onBlur, onFocus: onFocus, value: value, "aria-invalid": ariaInvalid, "aria-labelledby": ariaLabelledby, name: name } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $epp7s.default), {
        defaultValue: defaultValue,
        max: max,
        min: min,
        step: step,
        testId: testId,
        onChange: onChange,
        // Field props
        id: id,
        isDisabled: isDisabled,
        onBlur: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onBlur),
        onFocus: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onFocus),
        value: value,
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
}; /**
 * @codegenEnd
 */ 





var $jVhgp = parcelRequire("jVhgp");

const $0889dc325a0feeeb$export$bf0162d825d6e13 = {};
const $0889dc325a0feeeb$export$a4bb55a1e3b8a49f = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jVhgp.default), null);
}; /**
 * @codegenEnd
 */ 

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 










const $e4b736d0f0e4a8a2$var$renderActions = (render, actions)=>Array.isArray(actions) ? actions.map((action)=>render((0, $e0c91e5c3783b9b5$export$1b341f978fa5ef9a)(action))) : [
        render((0, $e0c91e5c3783b9b5$export$1b341f978fa5ef9a)(actions))
    ];
const $e4b736d0f0e4a8a2$var$macroStyle = null; /**
                          * A section message is used to alert users to a particular section of the screen.
                          */ 
const $e4b736d0f0e4a8a2$export$a36903bd214cec06 = (props)=>{
    const { appearance: appearance, title: title, actions: actions, testId: testId } = props.forgeDoc.props;
    const isMacro = (0, $ad0fe6534ffb7bc3$export$aabfca967ce25e7e)();
    if (isMacro) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_17b0fr1v"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        appearance: appearance,
        title: title,
        actions: actions ? $e4b736d0f0e4a8a2$var$renderActions(props.render, actions) : undefined,
        testId: testId
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        appearance: appearance,
        title: title,
        actions: actions ? $e4b736d0f0e4a8a2$var$renderActions(props.render, actions) : undefined,
        testId: testId
    });
};









var $iHPbg = parcelRequire("iHPbg");

const $3ef8d014d092b03b$export$bf0162d825d6e13 = {
    children: true,
    linkComponent: false,
    onClick: {
        value: 'adaptEventHandler(onClick)'
    },
    href: {
        value: 'href ? sanitizeUrl(href): undefined',
        comment: 'safety measure'
    },
    testId: true
};
const $3ef8d014d092b03b$export$22cf410f36f6c7c1 = (props)=>{
    const { onClick: onClick, href: href, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iHPbg.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        onClick: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onClick),
        // safety measure
        href: href ? (0, $clpPd.sanitizeUrl)(href) : undefined,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 





var $2gD2K = parcelRequire("2gD2K");





const $7b3a4c57e538b052$export$ef9b1a59e592288f = (props)=>{
    const { spacing: spacing, appearance: appearance, testId: testId, autoFocus: autoFocus, defaultValue: defaultValue, closeMenuOnSelect: closeMenuOnSelect, inputValue: inputValue, inputId: inputId, isClearable: isClearable, isLoading: isLoading, isMulti: isMulti, isSearchable: isSearchable, menuIsOpen: menuIsOpen, openMenuOnFocus: openMenuOnFocus, onInputChange: onInputChange, options: options, placeholder: placeholder, onChange: onChange, isRequired: isRequired, id: // Field props
    id, isDisabled: isDisabled, isInvalid: isInvalid, onBlur: onBlur, onFocus: onFocus, value: value, name: name, label: label } = props.forgeDoc.props;
    return(// Portal is required to render the menu as a sibling of the select container so that it appears ontop of the parent when used within ModalBody
    // ModalBody is a scrollable area and the menu is hidden when rendered within it
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $JmaBh.PortalConsumer), null, (portal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2gD2K.SelectWithoutAnalytics), {
            spacing: spacing,
            appearance: appearance,
            testId: testId,
            autoFocus: autoFocus,
            defaultValue: defaultValue,
            closeMenuOnSelect: closeMenuOnSelect,
            inputValue: inputValue,
            inputId: id || inputId,
            isClearable: isClearable,
            isLoading: isLoading,
            isMulti: isMulti,
            isSearchable: isSearchable,
            menuIsOpen: menuIsOpen,
            openMenuOnFocus: openMenuOnFocus,
            menuPortalTarget: portal,
            isRequired: isRequired,
            // onInputChange must return a void type for this to work
            onInputChange: (value, metaData)=>{
                onInputChange?.(value, metaData);
                return;
            },
            options: options,
            placeholder: placeholder,
            onChange: onChange,
            // Field props
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            onBlur: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onBlur),
            onFocus: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onFocus),
            value: value,
            name: name,
            label: label
        })));
};





var $9hlns = parcelRequire("9hlns");

const $f1ce34ac4a8f6247$export$bf0162d825d6e13 = {
    appearance: true,
    delay: true,
    interactionName: false,
    label: true,
    size: true,
    testId: true
};
const $f1ce34ac4a8f6247$export$7f7cbe89f1eacd2 = (props)=>{
    const { appearance: appearance, delay: delay, label: label, size: size, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        appearance: appearance,
        delay: delay,
        label: label,
        size: size,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 





var $1GzhS = parcelRequire("1GzhS");

const $a571f3bae9da938e$export$bf0162d825d6e13 = {
    children: true,
    alignBlock: true,
    alignInline: true,
    grow: true,
    space: true,
    spread: true,
    testId: true
};
const $a571f3bae9da938e$export$694e0d28c7ffc90c = (props)=>{
    const { alignBlock: alignBlock, alignInline: alignInline, grow: grow, space: space, spread: spread, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        alignBlock: alignBlock,
        alignInline: alignInline,
        grow: grow,
        space: space,
        spread: spread,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 













const $631299c90d3ab822$export$f301627d437cff88 = (props)=>{
    const { extensionType: extensionType, forgeEnvironment: forgeEnvironment } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $gGmck.RendererContext));
    const isMacro = extensionType === 'xen:macro';
    const isProduction = forgeEnvironment === 'PRODUCTION';
    if (!isProduction) (0, $1nSBE.default)(`[@forge/react: Strong] Warning: The "Strong" component is deprecated and will be removed on the 28th of August 2025. Please use the "Text" component instead. For more information, visit: https://developer.atlassian.com/platform/forge/ui-kit/components/text/.`);
    return(// `p` tag in editor/page is set to 16px. The strong element is using the Text component which sets it to 14px. Resetting to large to match with the rest of the editor/page styles. In other modules, this would default to 14px to match with the rest of the typography styles.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: isMacro ? 'large' : undefined,
        as: "strong"
    }, props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            key: c.key
        }, props.render(c)))));
};





var $gCbPZ = parcelRequire("gCbPZ");

const $733f9fb8e2b38783$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $733f9fb8e2b38783$export$3e41faf802a29e71 = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gCbPZ.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 





var $0DTaW = parcelRequire("0DTaW");

const $2c03a219758d0996$export$bf0162d825d6e13 = {
    children: {
        value: "props.forgeDoc.children.flatMap((c) => c.type === 'String' ? [] : props.render(c))",
        comment: 'Filter out line spacing strings as TabList should only have Tab children'
    }
};
const $2c03a219758d0996$export$e51a686c67fdaa2d = (props)=>{
    const {} = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0DTaW.default), {
        // Filter out line spacing strings as TabList should only have Tab children
        children: props.forgeDoc.children.flatMap((c)=>c.type === 'String' ? [] : props.render(c))
    });
}; /**
 * @codegenEnd
 */ 





var $d2kvf = parcelRequire("d2kvf");

const $e11d57d02e0497c5$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $e11d57d02e0497c5$export$3d96ec278d3efce4 = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d2kvf.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 





var $4A7Gn = parcelRequire("4A7Gn");

const $c9acb431e4f41d1b$export$bf0162d825d6e13 = {
    id: true,
    children: {
        value: "props.forgeDoc.children.flatMap((c) => c.type === 'String' ? [] : props.render(c))",
        comment: 'Filter out line spacing strings as Tabs should only have TabList & TabPanel children'
    },
    defaultSelected: true,
    onChange: true,
    selected: true,
    shouldUnmountTabPanelOnChange: true,
    testId: true
};
const $c9acb431e4f41d1b$export$b2539bed5023c21c = (props)=>{
    const { id: id, defaultSelected: defaultSelected, onChange: onChange, selected: selected, shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4A7Gn.default), {
        id: id,
        // Filter out line spacing strings as Tabs should only have TabList & TabPanel children
        children: props.forgeDoc.children.flatMap((c)=>c.type === 'String' ? [] : props.render(c)),
        defaultSelected: defaultSelected,
        onChange: onChange,
        selected: selected,
        shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 









var $ho4zm = parcelRequire("ho4zm");

const $a7379c399c27a504$export$bf0162d825d6e13 = {
    text: true,
    appearance: true,
    color: true,
    elemBefore: {
        value: 'elemBefore ? props.render(elementToForgeDoc(elemBefore as React.ReactElement)): null',
        comment: 'forge/react reconciler does not convert components in props into ForgeDoc. We need to do it manually here'
    },
    href: {
        value: 'href ? sanitizeUrl(href) : undefined'
    },
    linkComponent: false,
    testId: true
};
const $a7379c399c27a504$export$774e1ef5dc84ebd4 = (props)=>{
    const { text: text, appearance: appearance, color: color, elemBefore: elemBefore, href: href, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ho4zm.default), {
        text: text,
        appearance: appearance,
        color: color,
        // forge/react reconciler does not convert components in props into ForgeDoc. We need to do it manually here
        elemBefore: elemBefore ? props.render((0, $e0c91e5c3783b9b5$export$1b341f978fa5ef9a)(elemBefore)) : null,
        href: href ? (0, $clpPd.sanitizeUrl)(href) : undefined,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 





var $bRPo1 = parcelRequire("bRPo1");

const $42125b5a45a10feb$export$bf0162d825d6e13 = {
    children: true,
    alignment: true
};
const $42125b5a45a10feb$export$67ea30858aaf75e3 = (props)=>{
    const { alignment: alignment } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bRPo1.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        alignment: alignment
    });
}; /**
 * @codegenEnd
 */ 

/* index.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $1bHXt = parcelRequire("1bHXt");













const $f221c6e2fc122a48$export$bf0162d825d6e13 = {
    align: true,
    as: {
        excludeFromDeconstruct: false,
        value: 'as === "strike" ? "span" : as'
    },
    color: true,
    maxLines: true,
    size: true,
    weight: true,
    children: true,
    testId: true,
    xcss: {
        excludeFromDeconstruct: true,
        value: 'cx(styles.regular, as === "strike" && styles.lineThrough)'
    }
};
const $f221c6e2fc122a48$var$styles = {
    regular: "_1i4q4jg8",
    lineThrough: "_1hms1911"
}; // If we're displaying a paragraph, unfortunately we still need to bring back the styles to add a top margin
// (unless the wrapper is the first one) to be fully backwards compatible with the legacy component.
const $f221c6e2fc122a48$var$wrapperStyles = null; // Override whitespace:nowrap styling inherited from confluence:ContentBylineItem wrapper
const $f221c6e2fc122a48$var$confluenceBylineItemStyle = null;
const $f221c6e2fc122a48$export$5f1af8db9871e1d6 = (props)=>{
    const { align: align, as: as, color: color, maxLines: maxLines, size: size, weight: weight, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        align: align,
        as: as === 'strike' ? 'span' : as,
        color: color,
        maxLines: maxLines,
        size: size,
        weight: weight,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        testId: testId,
        xcss: (0, $1bHXt.cx)($f221c6e2fc122a48$var$styles.regular, as === 'strike' && $f221c6e2fc122a48$var$styles.lineThrough)
    });
}; /**
    * @codegenEnd
    */ 
const $f221c6e2fc122a48$export$40702e9f235b31be = (props)=>{
    const textProps = props.forgeDoc.props;
    const componentProps = {
        ...props.forgeDoc.props
    }; // ADS Text will set value for "color" if none is provided. Since the only way to adjust the color of texts in
    // Forge UI was by using the `xcss` prop on a <Box>, we need to make sure that inheritance of that color
    // is still possible, otherwise we would not be backwards compatible.
    // We can achieve this by setting the default value for "color" to "inherit" if it is not provided.
    componentProps.color = textProps.color === undefined ? 'inherit' : textProps.color;
    const needsWrapper = componentProps.as === 'p' || componentProps.as === undefined;
    const { extensionType: extensionType } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $gGmck.RendererContext));
    const isConfluenceByLine = extensionType === 'confluence:contentBylineItem'; // If we don't have to worry about any margins (all inline elements), we can use the platform Text component directly
    if (!needsWrapper) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9UyM5.InlineContext).Provider, {
        value: {
            inline: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f221c6e2fc122a48$export$5f1af8db9871e1d6, {
        render: props.render,
        dispatch: props.dispatch,
        forgeDoc: {
            children: props.forgeDoc.children,
            type: props.forgeDoc.type,
            props: componentProps
        }
    }));
     // Default to <p> for backwards compatibility
    if (textProps.as === undefined) componentProps.as = 'p';
     // Use the wrapper to add the margin-top for all paragraphs except the first one
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_168kutpp",
            isConfluenceByLine && "_o5724jg8"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9UyM5.InlineContext).Provider, {
        value: {
            inline: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f221c6e2fc122a48$export$5f1af8db9871e1d6, {
        render: props.render,
        dispatch: props.dispatch,
        forgeDoc: {
            children: props.forgeDoc.children,
            type: props.forgeDoc.type,
            props: componentProps
        }
    })));
};





var $9EtP6 = parcelRequire("9EtP6");





const $8b156d7c4c07c50e$export$7dee127706cff7f2 = (value, onChange)=>{
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const [cursor, setCursor] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const input = inputRef.current;
        if (input && cursor !== null && input.selectionStart !== cursor) input.setSelectionRange(cursor, cursor);
    }, [
        inputRef,
        cursor,
        value
    ]);
    const onChangeWithCursorState = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((e)=>{
        onChange?.(e);
        if (e.target.selectionStart) setCursor(e.target?.selectionStart);
    }, [
        onChange
    ]);
    if (!onChange) return {
        onChangeWithCursorState: undefined,
        inputRef: inputRef
    };
    return {
        onChangeWithCursorState: onChangeWithCursorState,
        inputRef: inputRef
    };
};


const $1fc11daf0ad720e4$export$f5c9f3c2c4054eec = (props)=>{
    const { appearance: appearance, defaultValue: defaultValue, isCompact: isCompact, isMonospaced: isMonospaced, isReadOnly: isReadOnly, maxHeight: maxHeight, minimumRows: minimumRows, placeholder: placeholder, resize: resize, spellCheck: spellCheck, testId: testId, maxLength: maxLength, minLength: minLength, autoFocus: autoFocus, id: // Field props
    id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, 'aria-invalid': ariaInvalid, 'aria-labelledby': ariaLabelledby, name: name } = props.forgeDoc.props;
    const { onChangeWithCursorState: onChangeWithCursorState, inputRef: inputRef } = (0, $8b156d7c4c07c50e$export$7dee127706cff7f2)(value, onChange);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
        // @ts-ignore type from ADS is missing the ref object. It is still supported
        ref: inputRef,
        appearance: appearance,
        defaultValue: defaultValue,
        isCompact: isCompact,
        isMonospaced: isMonospaced,
        isReadOnly: isReadOnly,
        maxHeight: maxHeight,
        minimumRows: minimumRows,
        placeholder: placeholder,
        resize: resize,
        spellCheck: spellCheck,
        testId: testId,
        maxLength: maxLength,
        minLength: minLength,
        autoFocus: autoFocus,
        // Field props
        id: id,
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onChange: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onChangeWithCursorState),
        onBlur: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onBlur),
        onFocus: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onFocus),
        value: value,
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
};






var $4noo5 = parcelRequire("4noo5");



const $6fe27daa4a695a9d$export$d66ddc2063fc70a7 = (props)=>{
    const { appearance: appearance, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact, autoFocus: autoFocus, isReadOnly: isReadOnly, isMonospaced: isMonospaced, placeholder: placeholder, testId: testId, width: width, type: type, defaultValue: defaultValue, min: min, max: max, maxLength: maxLength, minLength: minLength, pattern: pattern, id: // Field props
    id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, 'aria-invalid': ariaInvalid, 'aria-labelledby': ariaLabelledby, name: name } = props.forgeDoc.props;
    const { onChangeWithCursorState: onChangeWithCursorState, inputRef: inputRef } = (0, $8b156d7c4c07c50e$export$7dee127706cff7f2)(value, onChange);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
        ref: inputRef,
        appearance: appearance,
        // forge/react reconciler does not convert components in props into ForgeDoc. We need to do it manually here
        elemAfterInput: elemAfterInput ? props.render((0, $e0c91e5c3783b9b5$export$1b341f978fa5ef9a)(elemAfterInput)) : null,
        // forge/react reconciler does not convert components in props into ForgeDoc. We need to do it manually here
        elemBeforeInput: elemBeforeInput ? props.render((0, $e0c91e5c3783b9b5$export$1b341f978fa5ef9a)(elemBeforeInput)) : null,
        isCompact: isCompact,
        autoFocus: autoFocus,
        isReadOnly: isReadOnly,
        isMonospaced: isMonospaced,
        placeholder: placeholder,
        testId: testId,
        width: width,
        type: type,
        defaultValue: defaultValue,
        min: min,
        max: max,
        maxLength: maxLength,
        minLength: minLength,
        pattern: pattern,
        // Field props
        id: id,
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onChange: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onChangeWithCursorState),
        onBlur: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onBlur),
        onFocus: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onFocus),
        value: value,
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
};

/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This component was generated against an existing platform component.
 * If you are seeing lint errors in this file, it means that this file's dependencies have been modified and the component will need to be regenerated.
 *
 * Please view https://hello.atlassian.net/wiki/spaces/ECO/pages/3358130330/How+to+Regenerate+UI+Kit+Components for more information on how to proceed.
 *
 * For further questions, please ping the #help-forge-ui channel.
 *
 * @codegen <<SignedSource::aadc8f093ff3f3e1730f42ea9a70a445>>
 * @codegenId #tile
 * @codegenCommand yarn workspace @atlassian/forge-ui codegen tile
 * @codegenParams { "props": { "backgroundColor": true, "label": true, "size": true, "children": true, "hasBorder": true, "isInset": true, "testId": true } }
 * @codegenDependency ../../../../../../../design-system/tile/src/types.tsx <<SignedSource::239e1f3506078a0ea513ee58a3b0bff7>>
 * @codegenDependency ../../../../../../../design-system/tile/src/tile.tsx <<SignedSource::cca0ee622daf7895fc5ad727d8ab3ca9>>
 */ /* eslint @repo/internal/codegen/signed-source-integrity: "warn" */ 



var $i7jPX = parcelRequire("i7jPX");

const $372c480ac3ebe393$export$235cb65c20ad2b7 = (props)=>{
    const { backgroundColor: backgroundColor, label: label, size: size, hasBorder: hasBorder, isInset: isInset, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        backgroundColor: backgroundColor,
        label: label,
        size: size,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        hasBorder: hasBorder,
        isInset: isInset,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 





var $bIBXx = parcelRequire("bIBXx");


const $086ee2e19305ab97$export$bf0162d825d6e13 = {
    appearance: true,
    defaultIsOpen: true,
    autoFocus: true,
    defaultValue: true,
    formatDisplayLabel: false,
    innerProps: false,
    isOpen: true,
    label: true,
    parseInputValue: false,
    spacing: true,
    times: true,
    timeIsEditable: true,
    hideIcon: true,
    timeFormat: true,
    placeholder: true,
    locale: true,
    testId: true,
    selectProps: true,
    onChange: true,
    value: {
        replaceLine: true,
        value: '{...(value !== undefined ? { value }: undefined) }',
        comment: 'Explicitly setting value to undefined is causing issues'
    }
};
const $086ee2e19305ab97$export$5f876910ea565cd3 = (props)=>{
    const { appearance: appearance, defaultIsOpen: defaultIsOpen, autoFocus: autoFocus, defaultValue: defaultValue, isOpen: isOpen, label: label, spacing: spacing, times: times, timeIsEditable: timeIsEditable, hideIcon: hideIcon, timeFormat: timeFormat, placeholder: placeholder, locale: locale, testId: testId, selectProps: selectProps, onChange: onChange, value: value, id: // Field props
    id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onBlur: onBlur, onFocus: onFocus, "aria-invalid": ariaInvalid, "aria-labelledby": ariaLabelledby, name: name } = props.forgeDoc.props;
    // warning: appearance is deprecated;
    // warning: defaultIsOpen is deprecated;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bIBXx.default), {
        appearance: appearance,
        defaultIsOpen: defaultIsOpen,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        isOpen: isOpen,
        label: label,
        spacing: spacing,
        times: times,
        timeIsEditable: timeIsEditable,
        hideIcon: hideIcon,
        timeFormat: timeFormat,
        placeholder: placeholder,
        locale: locale,
        testId: testId,
        selectProps: selectProps,
        onChange: onChange,
        ...value !== undefined ? {
            value: value
        } : undefined,
        // Field props
        id: id,
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onBlur: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onBlur),
        onFocus: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onFocus),
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
}; /**
 * @codegenEnd
 */ 





var $82gXq = parcelRequire("82gXq");


const $f4c002d535c36bd6$export$bf0162d825d6e13 = {
    size: true,
    testId: true,
    defaultChecked: true,
    isChecked: true,
    label: true
};
const $f4c002d535c36bd6$export$bea8ebba691c5813 = (props)=>{
    const { size: size, testId: testId, defaultChecked: defaultChecked, isChecked: isChecked, label: label, id: // Field props
    id, isDisabled: isDisabled, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, name: name } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82gXq.default), {
        size: size,
        testId: testId,
        defaultChecked: defaultChecked,
        isChecked: isChecked,
        label: label,
        // Field props
        id: id,
        isDisabled: isDisabled,
        onChange: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onChange),
        onBlur: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onBlur),
        onFocus: (0, $a61a7775f4548bb7$export$f956703109d01f6a)(onFocus),
        value: value,
        name: name
    });
}; /**
 * @codegenEnd
 */ 

/**
 * Excluded props to simplify API:
 * - strategy
 * - hideTooltipOnClick
 * - hideTooltipOnMouseDown
 * - onHide
 * - onShow
 */ 



var $3gadb = parcelRequire("3gadb");

const $16e7c2be5df3039d$export$bf0162d825d6e13 = {
    children: true,
    position: true,
    mousePosition: true,
    content: true,
    truncate: true,
    testId: true,
    delay: true,
    onShow: false,
    onHide: false,
    hideTooltipOnClick: false,
    hideTooltipOnMouseDown: false,
    strategy: false
};
const $16e7c2be5df3039d$export$28c660c63b792dea = (props)=>{
    const { position: position, mousePosition: mousePosition, content: content, truncate: truncate, testId: testId, delay: delay } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        position: position,
        mousePosition: mousePosition,
        content: content,
        truncate: truncate,
        testId: testId,
        delay: delay
    });
}; /**
 * @codegenEnd
 */ 







const $580da07d63cfd038$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $580da07d63cfd038$export$5505afb209a532c8 = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.ValidMessage), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                key: c.key
            }, props.render(c))),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 



var $g7rOD = parcelRequire("g7rOD");

const $83671bb8769a0504$export$7cbf6225478f6479 = {
    Badge: $637faf3c7a4c907e$export$37acb3580601e69a,
    Box: $9ee6a369e81bb48b$export$e71c4d32a2263218,
    Button: $43e97c04e7296334$export$353f5b6fc5456de1,
    ButtonGroup: $e4393c0a53b02aba$export$69b1032f2ecdf404,
    Calendar: $9b97a2db8a6b7ad3$export$e1aef45b828286de,
    Checkbox: $7cc3ee78c78f7f2c$export$48513f6b9f8ce62d,
    CheckboxGroup: $8a6c935ee2f753cd$export$4aa08d5625cb8ead,
    Code: $d25f8a1ec16dec2a$export$52f0f02147b12c03,
    CodeBlock: $df2eef1efb6606e5$export$6c415d1fdae3dfdb,
    Comment: $22edd9209cc89f16$export$4d299b491347818a,
    DatePicker: $e5b413d620faca77$export$5109c6dd95d8fb00,
    DynamicTable: $470ecb33486442bb$export$af35fa26cfd84ce3,
    EmptyState: $7e65a5488f15879d$export$fddf379e22a74b00,
    ErrorMessage: $03f0e1b1264f2dff$export$915e9e7bd4f0f96d,
    Flex: $1e214349972aaec0$export$f51f4c4ede09e011,
    FileCard: $aa8e2bb5396b7bf6$export$593fd10f7e6c6505,
    Form: $1ebfea88a67bc737$export$a7fed597f4b8afd8,
    FormFooter: $05422e99a34922d5$export$e7277fd05612133d,
    FormHeader: $8f165c1167364179$export$97ee2cbf37e5ebfe,
    FormSection: $767d61145e43c730$export$b5ff61ac8b0a660f,
    Grid: $96ceb9d2478856d1$export$ef2184bd89960b14,
    Heading: $a8f1295e388793f1$export$a8a3e93435678ff9,
    HelperMessage: $93789ff5869bb338$export$8fbe3c7d0ed2c683,
    Icon: $04d28833aacd5f6d$export$f04a61298a47a40f,
    Inline: $f76c54d59d098003$export$fbae5b5ffd8af05e,
    InlineEdit: $c6aec3aaf282f684$export$97bda0f90d93904c,
    Label: $2949b71a9c026983$export$b04be29aa201d4f5,
    LinkButton: $d8f17ec7cdc8b68d$export$29d11c0fe2fc51d8,
    List: $6528e052fc61f2c8$export$54c2e3dc7acea9f5,
    ListItem: $fda6ba8c44d5f6e4$export$a7b06bfba60a8a78,
    LoadingButton: $a7a849b4fabaa947$export$4ec83e90d030b2f3,
    Lozenge: $8e74fad470730542$export$a31cbe1bf5463979,
    Modal: $a92a253d818c7c08$export$2b77a92f1a5ad772,
    ModalBody: $fc93215de45af324$export$cb540d8b0ef7906c,
    ModalFooter: $0317a808cd1fde51$export$519437715052e656,
    ModalHeader: $9f7a43a09b6f4394$export$f50a68e3694789ee,
    ModalTitle: $953c31e66b49cd3a$export$b26fae16ba5468aa,
    ModalTransition: $e6ff594647c24f09$export$f0a3ab1cc2e7e9a6,
    Popup: $6526f160ae33ce5b$export$129a32eedafa97c5,
    Pressable: $1cdf72e8bfd5ddec$export$27c701ed9e449e99,
    ProgressBar: $662934f2ccc55a75$export$c17561cb55d4db30,
    ProgressTracker: $f27e71f81adf4ae0$export$50a55323bc54fb79,
    Radio: $c471241698e6ee4a$export$d7b12c4107be0d61,
    RadioGroup: $294009ff50641444$export$a98f0dcb43a68a25,
    Range: $aaf088545b88ebea$export$9a58ef0d7ad3278c,
    RequiredAsterisk: $0889dc325a0feeeb$export$a4bb55a1e3b8a49f,
    SectionMessage: $e4b736d0f0e4a8a2$export$a36903bd214cec06,
    SectionMessageAction: $3ef8d014d092b03b$export$22cf410f36f6c7c1,
    Select: $7b3a4c57e538b052$export$ef9b1a59e592288f,
    Spinner: $f1ce34ac4a8f6247$export$7f7cbe89f1eacd2,
    Stack: $a571f3bae9da938e$export$694e0d28c7ffc90c,
    Tab: $733f9fb8e2b38783$export$3e41faf802a29e71,
    TabList: $2c03a219758d0996$export$e51a686c67fdaa2d,
    TabPanel: $e11d57d02e0497c5$export$3d96ec278d3efce4,
    Tabs: $c9acb431e4f41d1b$export$b2539bed5023c21c,
    Tag: $a7379c399c27a504$export$774e1ef5dc84ebd4,
    TagGroup: $42125b5a45a10feb$export$67ea30858aaf75e3,
    TextArea: $1fc11daf0ad720e4$export$f5c9f3c2c4054eec,
    Textfield: $6fe27daa4a695a9d$export$d66ddc2063fc70a7,
    TimePicker: $086ee2e19305ab97$export$5f876910ea565cd3,
    Toggle: $f4c002d535c36bd6$export$bea8ebba691c5813,
    Tooltip: $16e7c2be5df3039d$export$28c660c63b792dea,
    ValidMessage: $580da07d63cfd038$export$5505afb209a532c8,
    AdfRenderer: $dx0OV.AdfRenderer,
    Image: $39a34e462e058bd0$export$3e431a229df88919,
    Link: $79ffaea80c8babc5$export$a6c7ac8248d6e38a,
    Text: $f221c6e2fc122a48$export$40702e9f235b31be,
    Strong: $631299c90d3ab822$export$f301627d437cff88,
    FilePicker: $731ba4db03f9b44c$export$54dc470bcc5c41d1,
    Tile: $372c480ac3ebe393$export$235cb65c20ad2b7
};
const $83671bb8769a0504$export$954661e84fee40f6 = Object.entries($83671bb8769a0504$export$7cbf6225478f6479).reduce((agg, [key, Component])=>{
    agg[key] = (0, $42omo.memo)(Component, (0, $g7rOD.forgePropsAreEqual));
    return agg;
}, {});








/* confluenceStyleWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $c9e454fe83f0fb0f$export$95df08bae54cb4df = ()=>{
    if (typeof window !== 'undefined' && window.navigator != null) {
        const ua = window.navigator.userAgent?.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
};








const $a1933e587948ea63$export$ad87aa198ab86978 = ()=>{
    const { extensionType: extensionType } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $gGmck.RendererContext));
    return extensionType === 'xen:macro' || !!extensionType?.startsWith('confluence');
};


const $284faf76aab47fa0$var$chartStyle = null; // Styling override in Safari for UI Kit chart y-axis (axis-left) label that gets overlapped by chart plot.
// (See https://ecosystem-platform.atlassian.net/browse/EXT-3078)
const $284faf76aab47fa0$var$safariChartStyle = null;
const $284faf76aab47fa0$export$579859975dfcad56 = (ChartComponent)=>{
    return function ConfluenceStyleWrapper(props) {
        const isConfluenceModule = (0, $a1933e587948ea63$export$ad87aa198ab86978)();
        return isConfluenceModule ? /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                "_1hurwadc _15ywze3t _xlx2ze3t _ohs21rpy _v8kvwadc _1t4h1rpy _12r81e3o _tc2gazsu _1prkfhey _1x82azsu _59eai4vh _9y82ze3t _7ve0ze3t _zi1a1rpy _125ipxbi",
                (0, $c9e454fe83f0fb0f$export$95df08bae54cb4df)() && "_15xdc38t"
            ])
        }, /*#__PURE__*/ $42omo.createElement(ChartComponent, props)) : /*#__PURE__*/ $42omo.createElement(ChartComponent, props);
    };
};


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * DEPRECATED, PLEASE DO NOT USE.
 * Default values can now be based on either light or legacy-light themes, whereas this only contains light theme values.
 *
 * Token names mapped to their value in the default Atlassian themes ('light').
 * These default values are used by the Babel plugin to optionally provide automatic fallbacks.
 *
 * @codegen <<SignedSource::e6225c65d5d4ce72381110479f6b4968>>
 * @codegenCommand yarn build tokens
 */ const $2306ee5eb624c5ad$var$defaultTokenValues = {
    'color.text': '#292A2E',
    'color.text.accent.lime': '#4C6B1F',
    'color.text.accent.lime.bolder': '#37471F',
    'color.text.accent.red': '#AE2E24',
    'color.text.accent.red.bolder': '#5D1F1A',
    'color.text.accent.orange': '#9E4C00',
    'color.text.accent.orange.bolder': '#693200',
    'color.text.accent.yellow': '#7F5F01',
    'color.text.accent.yellow.bolder': '#533F04',
    'color.text.accent.green': '#216E4E',
    'color.text.accent.green.bolder': '#164B35',
    'color.text.accent.teal': '#206A83',
    'color.text.accent.teal.bolder': '#164555',
    'color.text.accent.blue': '#1558BC',
    'color.text.accent.blue.bolder': '#123263',
    'color.text.accent.purple': '#803FA5',
    'color.text.accent.purple.bolder': '#48245D',
    'color.text.accent.magenta': '#943D73',
    'color.text.accent.magenta.bolder': '#50253F',
    'color.text.accent.gray': '#505258',
    'color.text.accent.gray.bolder': '#1E1F21',
    'color.text.disabled': '#080F214A',
    'color.text.inverse': '#FFFFFF',
    'color.text.selected': '#1868DB',
    'color.text.brand': '#1868DB',
    'color.text.danger': '#AE2E24',
    'color.text.danger.bolder': '#5D1F1A',
    'color.text.warning': '#9E4C00',
    'color.text.warning.inverse': '#292A2E',
    'color.text.warning.bolder': '#693200',
    'color.text.success': '#4C6B1F',
    'color.text.success.bolder': '#37471F',
    'color.text.discovery': '#803FA5',
    'color.text.discovery.bolder': '#48245D',
    'color.text.information': '#1558BC',
    'color.text.information.bolder': '#123263',
    'color.text.subtlest': '#6B6E76',
    'color.text.subtle': '#505258',
    'color.link': '#1868DB',
    'color.link.pressed': '#1558BC',
    'color.link.visited': '#803FA5',
    'color.link.visited.pressed': '#48245D',
    'color.icon': '#292A2E',
    'color.icon.accent.lime': '#6A9A23',
    'color.icon.accent.red': '#C9372C',
    'color.icon.accent.orange': '#E06C00',
    'color.icon.accent.yellow': '#B38600',
    'color.icon.accent.green': '#22A06B',
    'color.icon.accent.teal': '#2898BD',
    'color.icon.accent.blue': '#357DE8',
    'color.icon.accent.purple': '#AF59E1',
    'color.icon.accent.magenta': '#CD519D',
    'color.icon.accent.gray': '#7D818A',
    'color.icon.disabled': '#080F214A',
    'color.icon.inverse': '#FFFFFF',
    'color.icon.selected': '#1868DB',
    'color.icon.brand': '#1868DB',
    'color.icon.danger': '#C9372C',
    'color.icon.warning': '#E06C00',
    'color.icon.warning.inverse': '#292A2E',
    'color.icon.success': '#6A9A23',
    'color.icon.discovery': '#AF59E1',
    'color.icon.information': '#357DE8',
    'color.icon.subtlest': '#6B6E76',
    'color.icon.subtle': '#505258',
    'color.border': '#0B120E24',
    'color.border.accent.lime': '#6A9A23',
    'color.border.accent.red': '#E2483D',
    'color.border.accent.orange': '#E06C00',
    'color.border.accent.yellow': '#B38600',
    'color.border.accent.green': '#22A06B',
    'color.border.accent.teal': '#2898BD',
    'color.border.accent.blue': '#357DE8',
    'color.border.accent.purple': '#AF59E1',
    'color.border.accent.magenta': '#CD519D',
    'color.border.accent.gray': '#7D818A',
    'color.border.disabled': '#0515240F',
    'color.border.focused': '#4688EC',
    'color.border.input': '#8C8F97',
    'color.border.inverse': '#FFFFFF',
    'color.border.selected': '#1868DB',
    'color.border.brand': '#1868DB',
    'color.border.danger': '#E2483D',
    'color.border.warning': '#E06C00',
    'color.border.success': '#6A9A23',
    'color.border.discovery': '#AF59E1',
    'color.border.information': '#357DE8',
    'color.border.bold': '#7D818A',
    'color.background.accent.lime.subtlest': '#EFFFD6',
    'color.background.accent.lime.subtlest.hovered': '#D3F1A7',
    'color.background.accent.lime.subtlest.pressed': '#BDE97C',
    'color.background.accent.lime.subtler': '#D3F1A7',
    'color.background.accent.lime.subtler.hovered': '#BDE97C',
    'color.background.accent.lime.subtler.pressed': '#B3DF72',
    'color.background.accent.lime.subtle': '#94C748',
    'color.background.accent.lime.subtle.hovered': '#B3DF72',
    'color.background.accent.lime.subtle.pressed': '#BDE97C',
    'color.background.accent.lime.bolder': '#5B7F24',
    'color.background.accent.lime.bolder.hovered': '#4C6B1F',
    'color.background.accent.lime.bolder.pressed': '#3F5224',
    'color.background.accent.red.subtlest': '#FFECEB',
    'color.background.accent.red.subtlest.hovered': '#FFD5D2',
    'color.background.accent.red.subtlest.pressed': '#FFB8B2',
    'color.background.accent.red.subtler': '#FFD5D2',
    'color.background.accent.red.subtler.hovered': '#FFB8B2',
    'color.background.accent.red.subtler.pressed': '#FD9891',
    'color.background.accent.red.subtle': '#F87168',
    'color.background.accent.red.subtle.hovered': '#FD9891',
    'color.background.accent.red.subtle.pressed': '#FFB8B2',
    'color.background.accent.red.bolder': '#C9372C',
    'color.background.accent.red.bolder.hovered': '#AE2E24',
    'color.background.accent.red.bolder.pressed': '#872821',
    'color.background.accent.orange.subtlest': '#FFF5DB',
    'color.background.accent.orange.subtlest.hovered': '#FCE4A6',
    'color.background.accent.orange.subtlest.pressed': '#FBD779',
    'color.background.accent.orange.subtler': '#FCE4A6',
    'color.background.accent.orange.subtler.hovered': '#FBD779',
    'color.background.accent.orange.subtler.pressed': '#FBC828',
    'color.background.accent.orange.subtle': '#FCA700',
    'color.background.accent.orange.subtle.hovered': '#FBC828',
    'color.background.accent.orange.subtle.pressed': '#FBD779',
    'color.background.accent.orange.bolder': '#BD5B00',
    'color.background.accent.orange.bolder.hovered': '#9E4C00',
    'color.background.accent.orange.bolder.pressed': '#7A3B00',
    'color.background.accent.yellow.subtlest': '#FEF7C8',
    'color.background.accent.yellow.subtlest.hovered': '#F5E989',
    'color.background.accent.yellow.subtlest.pressed': '#EFDD4E',
    'color.background.accent.yellow.subtler': '#F5E989',
    'color.background.accent.yellow.subtler.hovered': '#EFDD4E',
    'color.background.accent.yellow.subtler.pressed': '#EED12B',
    'color.background.accent.yellow.subtle': '#EED12B',
    'color.background.accent.yellow.subtle.hovered': '#DDB30E',
    'color.background.accent.yellow.subtle.pressed': '#EFDD4E',
    'color.background.accent.yellow.bolder': '#946F00',
    'color.background.accent.yellow.bolder.hovered': '#7F5F01',
    'color.background.accent.yellow.bolder.pressed': '#614A05',
    'color.background.accent.green.subtlest': '#DCFFF1',
    'color.background.accent.green.subtlest.hovered': '#BAF3DB',
    'color.background.accent.green.subtlest.pressed': '#97EDC9',
    'color.background.accent.green.subtler': '#BAF3DB',
    'color.background.accent.green.subtler.hovered': '#97EDC9',
    'color.background.accent.green.subtler.pressed': '#7EE2B8',
    'color.background.accent.green.subtle': '#4BCE97',
    'color.background.accent.green.subtle.hovered': '#7EE2B8',
    'color.background.accent.green.subtle.pressed': '#97EDC9',
    'color.background.accent.green.bolder': '#1F845A',
    'color.background.accent.green.bolder.hovered': '#216E4E',
    'color.background.accent.green.bolder.pressed': '#19573D',
    'color.background.accent.teal.subtlest': '#E7F9FF',
    'color.background.accent.teal.subtlest.hovered': '#C6EDFB',
    'color.background.accent.teal.subtlest.pressed': '#B1E4F7',
    'color.background.accent.teal.subtler': '#C6EDFB',
    'color.background.accent.teal.subtler.hovered': '#B1E4F7',
    'color.background.accent.teal.subtler.pressed': '#9DD9EE',
    'color.background.accent.teal.subtle': '#6CC3E0',
    'color.background.accent.teal.subtle.hovered': '#9DD9EE',
    'color.background.accent.teal.subtle.pressed': '#B1E4F7',
    'color.background.accent.teal.bolder': '#227D9B',
    'color.background.accent.teal.bolder.hovered': '#206A83',
    'color.background.accent.teal.bolder.pressed': '#1A5265',
    'color.background.accent.blue.subtlest': '#E9F2FE',
    'color.background.accent.blue.subtlest.hovered': '#CFE1FD',
    'color.background.accent.blue.subtlest.pressed': '#ADCBFB',
    'color.background.accent.blue.subtler': '#CFE1FD',
    'color.background.accent.blue.subtler.hovered': '#ADCBFB',
    'color.background.accent.blue.subtler.pressed': '#8FB8F6',
    'color.background.accent.blue.subtle': '#669DF1',
    'color.background.accent.blue.subtle.hovered': '#8FB8F6',
    'color.background.accent.blue.subtle.pressed': '#ADCBFB',
    'color.background.accent.blue.bolder': '#1868DB',
    'color.background.accent.blue.bolder.hovered': '#1558BC',
    'color.background.accent.blue.bolder.pressed': '#144794',
    'color.background.accent.purple.subtlest': '#F8EEFE',
    'color.background.accent.purple.subtlest.hovered': '#EED7FC',
    'color.background.accent.purple.subtlest.pressed': '#E3BDFA',
    'color.background.accent.purple.subtler': '#EED7FC',
    'color.background.accent.purple.subtler.hovered': '#E3BDFA',
    'color.background.accent.purple.subtler.pressed': '#D8A0F7',
    'color.background.accent.purple.subtle': '#C97CF4',
    'color.background.accent.purple.subtle.hovered': '#D8A0F7',
    'color.background.accent.purple.subtle.pressed': '#E3BDFA',
    'color.background.accent.purple.bolder': '#964AC0',
    'color.background.accent.purple.bolder.hovered': '#803FA5',
    'color.background.accent.purple.bolder.pressed': '#673286',
    'color.background.accent.magenta.subtlest': '#FFECF8',
    'color.background.accent.magenta.subtlest.hovered': '#FDD0EC',
    'color.background.accent.magenta.subtlest.pressed': '#FCB6E1',
    'color.background.accent.magenta.subtler': '#FDD0EC',
    'color.background.accent.magenta.subtler.hovered': '#FCB6E1',
    'color.background.accent.magenta.subtler.pressed': '#F797D2',
    'color.background.accent.magenta.subtle': '#E774BB',
    'color.background.accent.magenta.subtle.hovered': '#F797D2',
    'color.background.accent.magenta.subtle.pressed': '#FCB6E1',
    'color.background.accent.magenta.bolder': '#AE4787',
    'color.background.accent.magenta.bolder.hovered': '#943D73',
    'color.background.accent.magenta.bolder.pressed': '#77325B',
    'color.background.accent.gray.subtlest': '#F0F1F2',
    'color.background.accent.gray.subtlest.hovered': '#DDDEE1',
    'color.background.accent.gray.subtlest.pressed': '#B7B9BE',
    'color.background.accent.gray.subtler': '#DDDEE1',
    'color.background.accent.gray.subtler.hovered': '#B7B9BE',
    'color.background.accent.gray.subtler.pressed': '#8C8F97',
    'color.background.accent.gray.subtle': '#8C8F97',
    'color.background.accent.gray.subtle.hovered': '#B7B9BE',
    'color.background.accent.gray.subtle.pressed': '#DDDEE1',
    'color.background.accent.gray.bolder': '#6B6E76',
    'color.background.accent.gray.bolder.hovered': '#505258',
    'color.background.accent.gray.bolder.pressed': '#3B3D42',
    'color.background.disabled': '#17171708',
    'color.background.input': '#FFFFFF',
    'color.background.input.hovered': '#F8F8F8',
    'color.background.input.pressed': '#FFFFFF',
    'color.background.inverse.subtle': '#00000029',
    'color.background.inverse.subtle.hovered': '#0000003D',
    'color.background.inverse.subtle.pressed': '#00000052',
    'color.background.neutral': '#0515240F',
    'color.background.neutral.hovered': '#0B120E24',
    'color.background.neutral.pressed': '#080F214A',
    'color.background.neutral.subtle': '#00000000',
    'color.background.neutral.subtle.hovered': '#0515240F',
    'color.background.neutral.subtle.pressed': '#0B120E24',
    'color.background.neutral.bold': '#292A2E',
    'color.background.neutral.bold.hovered': '#3B3D42',
    'color.background.neutral.bold.pressed': '#505258',
    'color.background.selected': '#E9F2FE',
    'color.background.selected.hovered': '#CFE1FD',
    'color.background.selected.pressed': '#8FB8F6',
    'color.background.selected.bold': '#1868DB',
    'color.background.selected.bold.hovered': '#1558BC',
    'color.background.selected.bold.pressed': '#123263',
    'color.background.brand.subtlest': '#E9F2FE',
    'color.background.brand.subtlest.hovered': '#CFE1FD',
    'color.background.brand.subtlest.pressed': '#ADCBFB',
    'color.background.brand.bold': '#1868DB',
    'color.background.brand.bold.hovered': '#1558BC',
    'color.background.brand.bold.pressed': '#144794',
    'color.background.brand.boldest': '#1C2B42',
    'color.background.brand.boldest.hovered': '#123263',
    'color.background.brand.boldest.pressed': '#144794',
    'color.background.danger': '#FFECEB',
    'color.background.danger.hovered': '#FFD5D2',
    'color.background.danger.pressed': '#FFB8B2',
    'color.background.danger.subtler': '#FFD5D2',
    'color.background.danger.subtler.hovered': '#FFB8B2',
    'color.background.danger.subtler.pressed': '#FD9891',
    'color.background.danger.bold': '#C9372C',
    'color.background.danger.bold.hovered': '#AE2E24',
    'color.background.danger.bold.pressed': '#872821',
    'color.background.warning': '#FFF5DB',
    'color.background.warning.hovered': '#FCE4A6',
    'color.background.warning.pressed': '#FBD779',
    'color.background.warning.subtler': '#FCE4A6',
    'color.background.warning.subtler.hovered': '#FBD779',
    'color.background.warning.subtler.pressed': '#FBC828',
    'color.background.warning.bold': '#FBC828',
    'color.background.warning.bold.hovered': '#FCA700',
    'color.background.warning.bold.pressed': '#F68909',
    'color.background.success': '#EFFFD6',
    'color.background.success.hovered': '#D3F1A7',
    'color.background.success.pressed': '#BDE97C',
    'color.background.success.subtler': '#D3F1A7',
    'color.background.success.subtler.hovered': '#BDE97C',
    'color.background.success.subtler.pressed': '#B3DF72',
    'color.background.success.bold': '#5B7F24',
    'color.background.success.bold.hovered': '#4C6B1F',
    'color.background.success.bold.pressed': '#3F5224',
    'color.background.discovery': '#F8EEFE',
    'color.background.discovery.hovered': '#EED7FC',
    'color.background.discovery.pressed': '#E3BDFA',
    'color.background.discovery.subtler': '#EED7FC',
    'color.background.discovery.subtler.hovered': '#E3BDFA',
    'color.background.discovery.subtler.pressed': '#D8A0F7',
    'color.background.discovery.bold': '#964AC0',
    'color.background.discovery.bold.hovered': '#803FA5',
    'color.background.discovery.bold.pressed': '#673286',
    'color.background.information': '#E9F2FE',
    'color.background.information.hovered': '#CFE1FD',
    'color.background.information.pressed': '#ADCBFB',
    'color.background.information.subtler': '#CFE1FD',
    'color.background.information.subtler.hovered': '#ADCBFB',
    'color.background.information.subtler.pressed': '#8FB8F6',
    'color.background.information.bold': '#1868DB',
    'color.background.information.bold.hovered': '#1558BC',
    'color.background.information.bold.pressed': '#144794',
    'color.blanket': '#050C1F75',
    'color.blanket.selected': '#388BFF14',
    'color.blanket.danger': '#EF5C4814',
    'color.interaction.hovered': '#00000029',
    'color.interaction.pressed': '#00000052',
    'color.skeleton': '#0515240F',
    'color.skeleton.subtle': '#17171708',
    'color.chart.categorical.1': '#357DE8',
    'color.chart.categorical.1.hovered': '#1868DB',
    'color.chart.categorical.2': '#82B536',
    'color.chart.categorical.2.hovered': '#6A9A23',
    'color.chart.categorical.3': '#BF63F3',
    'color.chart.categorical.3.hovered': '#AF59E1',
    'color.chart.categorical.4': '#F68909',
    'color.chart.categorical.4.hovered': '#E06C00',
    'color.chart.categorical.5': '#1558BC',
    'color.chart.categorical.5.hovered': '#123263',
    'color.chart.categorical.6': '#964AC0',
    'color.chart.categorical.6.hovered': '#803FA5',
    'color.chart.categorical.7': '#42B2D7',
    'color.chart.categorical.7.hovered': '#2898BD',
    'color.chart.categorical.8': '#BD5B00',
    'color.chart.categorical.8.hovered': '#7A3B00',
    'color.chart.lime.bold': '#6A9A23',
    'color.chart.lime.bold.hovered': '#5B7F24',
    'color.chart.lime.bolder': '#5B7F24',
    'color.chart.lime.bolder.hovered': '#4C6B1F',
    'color.chart.lime.boldest': '#4C6B1F',
    'color.chart.lime.boldest.hovered': '#37471F',
    'color.chart.neutral': '#8C8F97',
    'color.chart.neutral.hovered': '#7D818A',
    'color.chart.red.bold': '#F15B50',
    'color.chart.red.bold.hovered': '#E2483D',
    'color.chart.red.bolder': '#E2483D',
    'color.chart.red.bolder.hovered': '#C9372C',
    'color.chart.red.boldest': '#AE2E24',
    'color.chart.red.boldest.hovered': '#5D1F1A',
    'color.chart.orange.bold': '#E06C00',
    'color.chart.orange.bold.hovered': '#BD5B00',
    'color.chart.orange.bolder': '#BD5B00',
    'color.chart.orange.bolder.hovered': '#9E4C00',
    'color.chart.orange.boldest': '#7A3B00',
    'color.chart.orange.boldest.hovered': '#693200',
    'color.chart.yellow.bold': '#B38600',
    'color.chart.yellow.bold.hovered': '#946F00',
    'color.chart.yellow.bolder': '#946F00',
    'color.chart.yellow.bolder.hovered': '#7F5F01',
    'color.chart.yellow.boldest': '#7F5F01',
    'color.chart.yellow.boldest.hovered': '#533F04',
    'color.chart.green.bold': '#22A06B',
    'color.chart.green.bold.hovered': '#1F845A',
    'color.chart.green.bolder': '#1F845A',
    'color.chart.green.bolder.hovered': '#216E4E',
    'color.chart.green.boldest': '#216E4E',
    'color.chart.green.boldest.hovered': '#164B35',
    'color.chart.teal.bold': '#2898BD',
    'color.chart.teal.bold.hovered': '#227D9B',
    'color.chart.teal.bolder': '#227D9B',
    'color.chart.teal.bolder.hovered': '#206A83',
    'color.chart.teal.boldest': '#206A83',
    'color.chart.teal.boldest.hovered': '#164555',
    'color.chart.blue.bold': '#4688EC',
    'color.chart.blue.bold.hovered': '#357DE8',
    'color.chart.blue.bolder': '#357DE8',
    'color.chart.blue.bolder.hovered': '#1868DB',
    'color.chart.blue.boldest': '#1558BC',
    'color.chart.blue.boldest.hovered': '#123263',
    'color.chart.purple.bold': '#BF63F3',
    'color.chart.purple.bold.hovered': '#AF59E1',
    'color.chart.purple.bolder': '#AF59E1',
    'color.chart.purple.bolder.hovered': '#964AC0',
    'color.chart.purple.boldest': '#803FA5',
    'color.chart.purple.boldest.hovered': '#48245D',
    'color.chart.magenta.bold': '#DA62AC',
    'color.chart.magenta.bold.hovered': '#CD519D',
    'color.chart.magenta.bolder': '#CD519D',
    'color.chart.magenta.bolder.hovered': '#AE4787',
    'color.chart.magenta.boldest': '#943D73',
    'color.chart.magenta.boldest.hovered': '#50253F',
    'color.chart.gray.bold': '#8C8F97',
    'color.chart.gray.bold.hovered': '#7D818A',
    'color.chart.gray.bolder': '#7D818A',
    'color.chart.gray.bolder.hovered': '#6B6E76',
    'color.chart.gray.boldest': '#505258',
    'color.chart.gray.boldest.hovered': '#3B3D42',
    'color.chart.brand': '#357DE8',
    'color.chart.brand.hovered': '#1868DB',
    'color.chart.danger': '#E2483D',
    'color.chart.danger.hovered': '#C9372C',
    'color.chart.danger.bold': '#872821',
    'color.chart.danger.bold.hovered': '#5D1F1A',
    'color.chart.warning': '#F68909',
    'color.chart.warning.hovered': '#E06C00',
    'color.chart.warning.bold': '#BD5B00',
    'color.chart.warning.bold.hovered': '#9E4C00',
    'color.chart.success': '#82B536',
    'color.chart.success.hovered': '#6A9A23',
    'color.chart.success.bold': '#5B7F24',
    'color.chart.success.bold.hovered': '#4C6B1F',
    'color.chart.discovery': '#BF63F3',
    'color.chart.discovery.hovered': '#AF59E1',
    'color.chart.discovery.bold': '#803FA5',
    'color.chart.discovery.bold.hovered': '#964AC0',
    'color.chart.information': '#357DE8',
    'color.chart.information.hovered': '#1868DB',
    'color.chart.information.bold': '#1558BC',
    'color.chart.information.bold.hovered': '#123263',
    'elevation.surface': '#FFFFFF',
    'elevation.surface.hovered': '#F0F1F2',
    'elevation.surface.pressed': '#DDDEE1',
    'elevation.surface.overlay': '#FFFFFF',
    'elevation.surface.overlay.hovered': '#F0F1F2',
    'elevation.surface.overlay.pressed': '#DDDEE1',
    'elevation.surface.raised': '#FFFFFF',
    'elevation.surface.raised.hovered': '#F0F1F2',
    'elevation.surface.raised.pressed': '#DDDEE1',
    'elevation.surface.sunken': '#F8F8F8',
    'elevation.shadow.overflow': '0px 0px 8px #1E1F2129, 0px 0px 1px #1E1F211F',
    'elevation.shadow.overflow.perimeter': '#1E1F211f',
    'elevation.shadow.overflow.spread': '#1E1F2129',
    'elevation.shadow.overlay': '0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214F',
    'elevation.shadow.raised': '0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214F',
    'opacity.disabled': '0.4',
    'opacity.loading': '0.2',
    'utility.UNSAFE.transparent': 'transparent',
    'utility.elevation.surface.current': '#FFFFFF',
    'space.0': '0rem',
    'space.025': '0.125rem',
    'space.050': '0.25rem',
    'space.075': '0.375rem',
    'space.100': '0.5rem',
    'space.150': '0.75rem',
    'space.200': '1rem',
    'space.250': '1.25rem',
    'space.300': '1.5rem',
    'space.400': '2rem',
    'space.500': '2.5rem',
    'space.600': '3rem',
    'space.800': '4rem',
    'space.1000': '5rem',
    'space.negative.025': '-0.125rem',
    'space.negative.050': '-0.25rem',
    'space.negative.075': '-0.375rem',
    'space.negative.100': '-0.5rem',
    'space.negative.150': '-0.75rem',
    'space.negative.200': '-1rem',
    'space.negative.250': '-1.25rem',
    'space.negative.300': '-1.5rem',
    'space.negative.400': '-2rem',
    'font.heading.xxlarge': 'normal 653 2rem/2.25rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'font.heading.xlarge': 'normal 653 1.75rem/2rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'font.heading.large': 'normal 653 1.5rem/1.75rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'font.heading.medium': 'normal 653 1.25rem/1.5rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'font.heading.small': 'normal 653 1rem/1.25rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'font.heading.xsmall': 'normal 653 0.875rem/1.25rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'font.heading.xxsmall': 'normal 653 0.75rem/1rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'font.body.large': 'normal 400 1rem/1.5rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'font.body': 'normal 400 0.875rem/1.25rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'font.body.small': 'normal 400 0.75rem/1rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'font.body.UNSAFE_small': 'normal 400 0.75rem/1rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'font.metric.large': 'normal 653 1.75rem/2rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'font.metric.medium': 'normal 653 1.5rem/1.75rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'font.metric.small': 'normal 653 1rem/1.25rem "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'font.code': 'normal 400 0.875em/1 "Atlassian Mono", ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace',
    'font.weight.regular': '400',
    'font.weight.medium': '500',
    'font.weight.semibold': '600',
    'font.weight.bold': '653',
    'font.family.heading': '"Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'font.family.body': '"Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'font.family.code': '"Atlassian Mono", ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace',
    'font.family.brand.heading': '"Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'font.family.brand.body': '"Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'radius.xsmall': '0.125rem',
    'radius.small': '0.25rem',
    'radius.medium': '0.375rem',
    'radius.large': '0.5rem',
    'radius.xlarge': '0.75rem',
    'radius.xxlarge': '1rem',
    'radius.full': '624.9375rem',
    'radius.tile': '25%',
    'border.width': '0.0625rem',
    'border.width.selected': '0.125rem',
    'border.width.focused': '0.125rem'
};
var $2306ee5eb624c5ad$export$2e2bcd8739ae039 = $2306ee5eb624c5ad$var$defaultTokenValues;


const $3d3b0944fb057330$export$8cc478c78eff55eb = (margin)=>{
    if (!margin) return undefined;
    const value = (0, $2306ee5eb624c5ad$export$2e2bcd8739ae039)[margin];
    if (value && value.endsWith('rem')) {
        const rem = value.replace('rem', '');
        const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
        const marginValue = Number(rem) * rootFontSize;
        if (isNaN(marginValue)) return undefined;
        return marginValue;
    }
    return undefined;
};
const $3d3b0944fb057330$export$80fb3cd6b1db7d59 = (margin, marginLeft, marginRight, marginTop, marginBottom)=>{
    const base = $3d3b0944fb057330$export$8cc478c78eff55eb(margin);
    return {
        left: marginLeft ? $3d3b0944fb057330$export$8cc478c78eff55eb(marginLeft) ?? base : base,
        right: marginRight ? $3d3b0944fb057330$export$8cc478c78eff55eb(marginRight) ?? base : base,
        top: marginTop ? $3d3b0944fb057330$export$8cc478c78eff55eb(marginTop) ?? base : base,
        bottom: marginBottom ? $3d3b0944fb057330$export$8cc478c78eff55eb(marginBottom) ?? base : base
    };
};






const $d14c84df0f3e2985$var$PlatformBarChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.BarChart
        })));

const $d14c84df0f3e2985$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.BarChart.elements.Title
        })));

const $d14c84df0f3e2985$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.BarChart.elements.SubTitle
        })));

const $d14c84df0f3e2985$var$Layout = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.BarChart.elements.Layout
        })));

const $d14c84df0f3e2985$var$Theme = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.BarChart.elements.Theme
        })));
const $d14c84df0f3e2985$var$BaseBarChart = (props)=>{
    const { width: width, height: height, data: data, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, title: title, subtitle: subtitle, plotMargin: plotMargin, plotMarginTop: plotMarginTop, plotMarginRight: plotMarginRight, plotMarginBottom: plotMarginBottom, plotMarginLeft: plotMarginLeft, showBorder: showBorder, colorPalette: colorPalette } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d14c84df0f3e2985$var$PlatformBarChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d14c84df0f3e2985$var$Title, null, title), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d14c84df0f3e2985$var$SubTitle, null, subtitle), (0, $dh538.fg)('enable-margin-property-for-ui-kit-chart-components') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d14c84df0f3e2985$var$Layout, {
        plotMargin: (0, $3d3b0944fb057330$export$80fb3cd6b1db7d59)(plotMargin, plotMarginLeft, plotMarginRight, plotMarginTop, plotMarginBottom),
        showBorder: showBorder
    }), colorPalette && (0, $dh538.fg)('platform-enable-customisation-colors-for-charts') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d14c84df0f3e2985$var$Theme, {
        fillStyles: colorPalette
    }));
};
const $d14c84df0f3e2985$export$94aefc399ef206a9 = (0, $284faf76aab47fa0$export$579859975dfcad56)($d14c84df0f3e2985$var$BaseBarChart);









const $d7cc4faea5385b92$var$PlatformDonutChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.DonutChart
        })));

const $d7cc4faea5385b92$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.DonutChart.elements.Title
        })));

const $d7cc4faea5385b92$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.DonutChart.elements.SubTitle
        })));

const $d7cc4faea5385b92$var$MarkLabels = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.DonutChart.elements.MarkLabels
        })));

const $d7cc4faea5385b92$var$Layout = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.DonutChart.elements.Layout
        })));

const $d7cc4faea5385b92$var$Theme = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.DonutChart.elements.Theme
        })));
const $d7cc4faea5385b92$var$BaseDonutChart = (props)=>{
    const { width: width, height: height, data: data, colorAccessor: colorAccessor, labelAccessor: labelAccessor, valueAccessor: valueAccessor, title: title, subtitle: subtitle, showMarkLabels: showMarkLabels, innerRadius: innerRadius, outerRadius: outerRadius, showBorder: showBorder, colorPalette: colorPalette } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d7cc4faea5385b92$var$PlatformDonutChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        colorAccessor: colorAccessor,
        valueAccessor: valueAccessor,
        labelAccessor: labelAccessor,
        innerRadius: innerRadius,
        outerRadius: outerRadius
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d7cc4faea5385b92$var$MarkLabels, {
        hide: !showMarkLabels
    }), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d7cc4faea5385b92$var$Title, null, title), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d7cc4faea5385b92$var$SubTitle, null, subtitle), (0, $dh538.fg)('enable-margin-property-for-ui-kit-chart-components') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d7cc4faea5385b92$var$Layout, {
        showBorder: showBorder
    }), colorPalette && (0, $dh538.fg)('platform-enable-customisation-colors-for-charts') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d7cc4faea5385b92$var$Theme, {
        fillStyles: colorPalette
    }));
};
const $d7cc4faea5385b92$export$533707e2f61b59ec = (0, $284faf76aab47fa0$export$579859975dfcad56)($d7cc4faea5385b92$var$BaseDonutChart);










const $ed05019de36d5f33$var$PlatformHorizontalBarChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.HorizontalBarChart
        })));

const $ed05019de36d5f33$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.HorizontalBarChart.elements.Title
        })));

const $ed05019de36d5f33$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.HorizontalBarChart.elements.SubTitle
        })));

const $ed05019de36d5f33$var$Layout = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.HorizontalBarChart.elements.Layout
        })));

const $ed05019de36d5f33$var$Theme = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.HorizontalBarChart.elements.Theme
        })));
const $ed05019de36d5f33$var$BaseHorizontalBarChart = (props)=>{
    const { width: width, height: height, data: data, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, title: title, subtitle: subtitle, plotMargin: plotMargin, plotMarginTop: plotMarginTop, plotMarginRight: plotMarginRight, plotMarginBottom: plotMarginBottom, plotMarginLeft: plotMarginLeft, showBorder: showBorder, colorPalette: colorPalette } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed05019de36d5f33$var$PlatformHorizontalBarChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed05019de36d5f33$var$Title, null, title), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed05019de36d5f33$var$SubTitle, null, subtitle), (0, $dh538.fg)('enable-margin-property-for-ui-kit-chart-components') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed05019de36d5f33$var$Layout, {
        plotMargin: (0, $3d3b0944fb057330$export$80fb3cd6b1db7d59)(plotMargin, plotMarginLeft, plotMarginRight, plotMarginTop, plotMarginBottom),
        showBorder: showBorder
    }), colorPalette && (0, $dh538.fg)('platform-enable-customisation-colors-for-charts') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed05019de36d5f33$var$Theme, {
        fillStyles: colorPalette
    }));
};
const $ed05019de36d5f33$export$2d84115b1316e023 = (0, $284faf76aab47fa0$export$579859975dfcad56)($ed05019de36d5f33$var$BaseHorizontalBarChart);










const $00efd03eaf86ffe9$var$PlatformHorizontalStackBarChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.HorizontalStackBarChart
        })));

const $00efd03eaf86ffe9$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.HorizontalStackBarChart.elements.Title
        })));

const $00efd03eaf86ffe9$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.HorizontalStackBarChart.elements.SubTitle
        })));

const $00efd03eaf86ffe9$var$Layout = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.HorizontalStackBarChart.elements.Layout
        })));

const $00efd03eaf86ffe9$var$Theme = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.HorizontalStackBarChart.elements.Theme
        })));
const $00efd03eaf86ffe9$var$BaseHorizontalStackBarChart = (props)=>{
    const { width: width, height: height, data: data, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, title: title, subtitle: subtitle, plotMargin: plotMargin, plotMarginTop: plotMarginTop, plotMarginRight: plotMarginRight, plotMarginBottom: plotMarginBottom, plotMarginLeft: plotMarginLeft, showBorder: showBorder, colorPalette: colorPalette } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($00efd03eaf86ffe9$var$PlatformHorizontalStackBarChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($00efd03eaf86ffe9$var$Title, null, title), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($00efd03eaf86ffe9$var$SubTitle, null, subtitle), (0, $dh538.fg)('enable-margin-property-for-ui-kit-chart-components') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($00efd03eaf86ffe9$var$Layout, {
        plotMargin: (0, $3d3b0944fb057330$export$80fb3cd6b1db7d59)(plotMargin, plotMarginLeft, plotMarginRight, plotMarginTop, plotMarginBottom),
        showBorder: showBorder
    }), colorPalette && (0, $dh538.fg)('platform-enable-customisation-colors-for-charts') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($00efd03eaf86ffe9$var$Theme, {
        fillStyles: colorPalette
    }));
};
const $00efd03eaf86ffe9$export$68d163a36b4f8e7c = (0, $284faf76aab47fa0$export$579859975dfcad56)($00efd03eaf86ffe9$var$BaseHorizontalStackBarChart);










const $ae664695ea96b65e$var$PlatformLineChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.LineChart
        })));

const $ae664695ea96b65e$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.LineChart.elements.Title
        })));

const $ae664695ea96b65e$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.LineChart.elements.SubTitle
        })));

const $ae664695ea96b65e$var$Layout = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.LineChart.elements.Layout
        })));

const $ae664695ea96b65e$var$Theme = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.LineChart.elements.Theme
        })));
const $ae664695ea96b65e$var$BaseLineChart = (props)=>{
    const { width: width, height: height, data: data, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, title: title, subtitle: subtitle, plotMargin: plotMargin, plotMarginTop: plotMarginTop, plotMarginRight: plotMarginRight, plotMarginBottom: plotMarginBottom, plotMarginLeft: plotMarginLeft, showBorder: showBorder, colorPalette: colorPalette } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae664695ea96b65e$var$PlatformLineChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae664695ea96b65e$var$Title, null, title), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae664695ea96b65e$var$SubTitle, null, subtitle), (0, $dh538.fg)('enable-margin-property-for-ui-kit-chart-components') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae664695ea96b65e$var$Layout, {
        plotMargin: (0, $3d3b0944fb057330$export$80fb3cd6b1db7d59)(plotMargin, plotMarginLeft, plotMarginRight, plotMarginTop, plotMarginBottom),
        showBorder: showBorder
    }), colorPalette && (0, $dh538.fg)('platform-enable-customisation-colors-for-charts') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae664695ea96b65e$var$Theme, {
        fillStyles: colorPalette
    }));
};
const $ae664695ea96b65e$export$54d0e8420ac838ac = (0, $284faf76aab47fa0$export$579859975dfcad56)($ae664695ea96b65e$var$BaseLineChart);









const $eed44d9ffe8c9ca9$var$PlatformPieChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.PieChart
        })));

const $eed44d9ffe8c9ca9$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.PieChart.elements.Title
        })));

const $eed44d9ffe8c9ca9$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.PieChart.elements.SubTitle
        })));

const $eed44d9ffe8c9ca9$var$MarkLabels = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.PieChart.elements.MarkLabels
        })));

const $eed44d9ffe8c9ca9$var$Layout = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.PieChart.elements.Layout
        })));

const $eed44d9ffe8c9ca9$var$Theme = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.PieChart.elements.Theme
        })));
const $eed44d9ffe8c9ca9$var$BasePieChart = (props)=>{
    const { width: width, height: height, data: data, colorAccessor: colorAccessor, labelAccessor: labelAccessor, valueAccessor: valueAccessor, title: title, subtitle: subtitle, showMarkLabels: showMarkLabels, showBorder: showBorder, colorPalette: colorPalette } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eed44d9ffe8c9ca9$var$PlatformPieChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        colorAccessor: colorAccessor,
        valueAccessor: valueAccessor,
        labelAccessor: labelAccessor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eed44d9ffe8c9ca9$var$MarkLabels, {
        hide: !showMarkLabels
    }), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eed44d9ffe8c9ca9$var$Title, null, title), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eed44d9ffe8c9ca9$var$SubTitle, null, subtitle), (0, $dh538.fg)('enable-margin-property-for-ui-kit-chart-components') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eed44d9ffe8c9ca9$var$Layout, {
        showBorder: showBorder
    }), colorPalette && (0, $dh538.fg)('platform-enable-customisation-colors-for-charts') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eed44d9ffe8c9ca9$var$Theme, {
        fillStyles: colorPalette
    }));
};
const $eed44d9ffe8c9ca9$export$b99d3348f709c998 = (0, $284faf76aab47fa0$export$579859975dfcad56)($eed44d9ffe8c9ca9$var$BasePieChart);










const $ecdecb5af3a80cf9$var$PlatformStackBarChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.StackBarChart
        })));

const $ecdecb5af3a80cf9$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.StackBarChart.elements.Title
        })));

const $ecdecb5af3a80cf9$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.StackBarChart.elements.SubTitle
        })));

const $ecdecb5af3a80cf9$var$Layout = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.StackBarChart.elements.Layout
        })));

const $ecdecb5af3a80cf9$var$Theme = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("6pgd2")).then((module)=>({
            default: module.StackBarChart.elements.Theme
        })));
const $ecdecb5af3a80cf9$var$BaseStackBarChart = (props)=>{
    const { width: width, height: height, data: data, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, title: title, subtitle: subtitle, plotMargin: plotMargin, plotMarginTop: plotMarginTop, plotMarginRight: plotMarginRight, plotMarginBottom: plotMarginBottom, plotMarginLeft: plotMarginLeft, showBorder: showBorder, colorPalette: colorPalette } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ecdecb5af3a80cf9$var$PlatformStackBarChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ecdecb5af3a80cf9$var$Title, null, title), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ecdecb5af3a80cf9$var$SubTitle, null, subtitle), (0, $dh538.fg)('enable-margin-property-for-ui-kit-chart-components') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ecdecb5af3a80cf9$var$Layout, {
        plotMargin: (0, $3d3b0944fb057330$export$80fb3cd6b1db7d59)(plotMargin, plotMarginLeft, plotMarginRight, plotMarginTop, plotMarginBottom),
        showBorder: showBorder
    }), colorPalette && (0, $dh538.fg)('platform-enable-customisation-colors-for-charts') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ecdecb5af3a80cf9$var$Theme, {
        fillStyles: colorPalette
    }));
};
const $ecdecb5af3a80cf9$export$a0048b2d4c7b0c89 = (0, $284faf76aab47fa0$export$579859975dfcad56)($ecdecb5af3a80cf9$var$BaseStackBarChart);





const $2f0fd47f1e034052$export$7cbf6225478f6479 = {
    BarChart: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d14c84df0f3e2985$export$94aefc399ef206a9, args),
    StackBarChart: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ecdecb5af3a80cf9$export$a0048b2d4c7b0c89, args),
    HorizontalStackBarChart: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($00efd03eaf86ffe9$export$68d163a36b4f8e7c, args),
    HorizontalBarChart: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed05019de36d5f33$export$2d84115b1316e023, args),
    LineChart: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae664695ea96b65e$export$54d0e8420ac838ac, args),
    PieChart: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eed44d9ffe8c9ca9$export$b99d3348f709c998, args),
    DonutChart: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d7cc4faea5385b92$export$533707e2f61b59ec, args)
};
const $2f0fd47f1e034052$export$534226a750271d58 = Object.entries($2f0fd47f1e034052$export$7cbf6225478f6479).reduce((agg, [key, Component])=>{
    agg[key] = /*#__PURE__*/ (0, $42omo.memo)(Component, (0, $g7rOD.forgePropsAreEqual));
    return agg;
}, {});



var $4ZTaE = parcelRequire("4ZTaE");


var $hWJfj = parcelRequire("hWJfj");


const $31a02a62a2ca9c46$export$a200b9d079640a1 = new Set([
    'Badge',
    'Box',
    'Button',
    'ButtonGroup',
    'Calendar',
    'Checkbox',
    'CheckboxGroup',
    'Code',
    'CodeBlock',
    'Comment',
    'DatePicker',
    'DynamicTable',
    'EmptyState',
    'ErrorMessage',
    'Flex',
    'FileCard',
    'FilePicker',
    'Form',
    'FormFooter',
    'FormHeader',
    'FormSection',
    'Grid',
    'Heading',
    'HelperMessage',
    'Icon',
    'Inline',
    'InlineEdit',
    'Label',
    'LinkButton',
    'List',
    'ListItem',
    'LoadingButton',
    'Lozenge',
    'Modal',
    'ModalBody',
    'ModalFooter',
    'ModalHeader',
    'ModalTitle',
    'ModalTransition',
    'Popup',
    'Pressable',
    'ProgressBar',
    'ProgressTracker',
    'Radio',
    'RadioGroup',
    'Range',
    'RequiredAsterisk',
    'SectionMessage',
    'SectionMessageAction',
    'Select',
    'Spinner',
    'Stack',
    'Tab',
    'TabList',
    'TabPanel',
    'Tabs',
    'Tag',
    'TagGroup',
    'TextArea',
    'Textfield',
    'TimePicker',
    'Toggle',
    'Tooltip',
    'ValidMessage',
    'AdfRenderer',
    'Image',
    'Link',
    'Text',
    'Strong',
    'BarChart',
    'StackBarChart',
    'HorizontalStackBarChart',
    'HorizontalBarChart',
    'LineChart',
    'PieChart',
    'DonutChart',
    'String',
    'Em',
    'Strike',
    'Root',
    'Fragment',
    'ThreeLOPrompt',
    'User',
    'UserGroup',
    'UserPicker',
    'Frame',
    'ContentWrapper',
    'ValidationMessage',
    'ButtonSet',
    'DateLozenge',
    'ErrorPanel',
    'FormCondition',
    'InlineDialog',
    'ModalDialog',
    'StatusLozenge',
    'Table',
    'TextField',
    'View',
    'Tile'
]);
const $31a02a62a2ca9c46$var$rendererNextComponents = {
    ThreeLOPrompt: (0, $4ZTaE.ThreeLOPromptRenderFn)
};
// This was extracted from RendererNext Component due to UnknownComponent Error being
// incompatible with running in a server-side context.
const $31a02a62a2ca9c46$var$customRenderErrorFn = (forgeDocType)=>{
    // Buckets errors into two kinds, ComponentError - component errors we want to report on e.g. <Button/> vs ones we don't e.g. <Buton/> which will only show up in the users console
    if ($31a02a62a2ca9c46$export$a200b9d079640a1.has(forgeDocType)) throw new (0, $hWJfj.ComponentError)(`Error rendering app - component ${forgeDocType}.`, forgeDocType);
    else throw new Error(`Error rendering app - encountered unknown component ${forgeDocType}.`);
};
const $31a02a62a2ca9c46$export$593275278a807c58 = (props)=>{
    const uiKitComponents = Object.keys((0, $83671bb8769a0504$export$954661e84fee40f6)).reduce((acc, key)=>{
        const Component = (0, $83671bb8769a0504$export$954661e84fee40f6)[key];
        return {
            ...acc,
            [key]: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                    ...args,
                    key: args.forgeDoc.key
                })
        };
    }, {});
    const uiKitChartsComponents = Object.keys((0, $2f0fd47f1e034052$export$534226a750271d58)).reduce((acc, key)=>{
        const Component = (0, $2f0fd47f1e034052$export$534226a750271d58)[key];
        return {
            ...acc,
            [key]: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                    ...args,
                    key: args.forgeDoc.key
                })
        };
    }, {});
    const components = {
        ...uiKitComponents,
        ...uiKitChartsComponents,
        String: (0, $ab8fc5e500e17686$export$65fce8c2f2babb3e).String,
        Em: (0, $ab8fc5e500e17686$export$65fce8c2f2babb3e).Em,
        Strong: (0, $631299c90d3ab822$export$f301627d437cff88),
        Strike: (0, $ab8fc5e500e17686$export$65fce8c2f2babb3e).Strike,
        Root: $7d5c5ef067e646f8$export$be92b6f5f03c0fe9,
        Fragment: $7d5c5ef067e646f8$export$ffb0004e005737fa
    };
    const combinedComponents = {
        ...components,
        ...$31a02a62a2ca9c46$var$rendererNextComponents
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6c27856e6e241b8f$export$c18f98553e983d72), {
        ...props,
        components: props.components ? props.components(combinedComponents) : combinedComponents,
        customRenderErrorFn: $31a02a62a2ca9c46$var$customRenderErrorFn
    });
};
const $31a02a62a2ca9c46$export$6d81a7348fccd2a2 = (props)=>{
    const combinedComponents = {
        ...(0, $ab8fc5e500e17686$export$65fce8c2f2babb3e),
        ...$31a02a62a2ca9c46$var$rendererNextComponents
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6c27856e6e241b8f$export$c18f98553e983d72), {
        ...props,
        components: props.components ? props.components(combinedComponents) : combinedComponents,
        customRenderErrorFn: $31a02a62a2ca9c46$var$customRenderErrorFn
    });
};
module.exports["RendererNextLatest"] = $31a02a62a2ca9c46$export$593275278a807c58;
module.exports["RendererNextLegacy"] = $31a02a62a2ca9c46$export$6d81a7348fccd2a2;

});

parcelRegister("6OBBH", function(module, exports) {

let $4f64959523164cc6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4f64959523164cc6$var$load("2lpnu").then(()=>parcelRequire('byMHr'));

});

parcelRegister("hR6PJ", function(module, exports) {

let $cffcafe3334c17a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cffcafe3334c17a6$var$load("8JZKd").then(()=>parcelRequire('2V2Ld'));

});

parcelRegister("dC6xb", function(module, exports) {

let $9e93e48c5067e214$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9e93e48c5067e214$var$load("8JZKd").then(()=>parcelRequire('5Gq9J'));

});

parcelRegister("l1HVn", function(module, exports) {

let $f4ebc3728ecc9579$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f4ebc3728ecc9579$var$load("8JZKd").then(()=>parcelRequire('cUH4k'));

});

parcelRegister("dmdbb", function(module, exports) {

let $9b978d9beed4956b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9b978d9beed4956b$var$load("8JZKd").then(()=>parcelRequire('daxmT'));

});

parcelRegister("hqdtj", function(module, exports) {

let $caef5099e4e5e2ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $caef5099e4e5e2ad$var$load("8JZKd").then(()=>parcelRequire('lcVFI'));

});

parcelRegister("hePgN", function(module, exports) {

let $c8cb839a425b34b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c8cb839a425b34b0$var$load("8JZKd").then(()=>parcelRequire('blD8v'));

});

parcelRegister("lM9VV", function(module, exports) {

let $fda5c930afa6bb0d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fda5c930afa6bb0d$var$load("8JZKd").then(()=>parcelRequire('cCp8H'));

});

parcelRegister("aOJ8u", function(module, exports) {

let $7e0195f1eae3b243$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7e0195f1eae3b243$var$load("8JZKd").then(()=>parcelRequire('lfHMX'));

});

parcelRegister("1z0H8", function(module, exports) {

let $123999493307e0e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $123999493307e0e0$var$load("8JZKd").then(()=>parcelRequire('dxJ1i'));

});

parcelRegister("gOTB4", function(module, exports) {

let $c3ec7140807ffbb0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c3ec7140807ffbb0$var$load("8JZKd").then(()=>parcelRequire('eXoGj'));

});

parcelRegister("39VYB", function(module, exports) {

let $24cf2f43aaa87e36$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $24cf2f43aaa87e36$var$load("8JZKd").then(()=>parcelRequire('fJmzg'));

});

parcelRegister("88S5Q", function(module, exports) {

let $5ed907df41f160e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5ed907df41f160e1$var$load("8JZKd").then(()=>parcelRequire('9MOi4'));

});

parcelRegister("iTETO", function(module, exports) {

let $dc1d16c8f91d7b0a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc1d16c8f91d7b0a$var$load("8JZKd").then(()=>parcelRequire('eEQFA'));

});

parcelRegister("hAPFi", function(module, exports) {

let $ccede015457903e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ccede015457903e1$var$load("8JZKd").then(()=>parcelRequire('4ewpp'));

});

parcelRegister("gsmWv", function(module, exports) {

let $bfb10ecfd7868aaa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bfb10ecfd7868aaa$var$load("8JZKd").then(()=>parcelRequire('9umf9'));

});

parcelRegister("jR3I4", function(module, exports) {

let $e745d83ff10ec01c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e745d83ff10ec01c$var$load("8JZKd").then(()=>parcelRequire('dZu1d'));

});

parcelRegister("fIlIv", function(module, exports) {

let $b70bcf9a4f796cbc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b70bcf9a4f796cbc$var$load("8JZKd").then(()=>parcelRequire('hSAKW'));

});

parcelRegister("4ZwDS", function(module, exports) {

let $3a262dfbc4a9b174$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3a262dfbc4a9b174$var$load("8JZKd").then(()=>parcelRequire('g8im1'));

});

parcelRegister("gP79k", function(module, exports) {

let $c3f6f47a02c4aea1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c3f6f47a02c4aea1$var$load("8JZKd").then(()=>parcelRequire('icwjb'));

});

parcelRegister("1vytV", function(module, exports) {

let $11936f0b26dfab75$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $11936f0b26dfab75$var$load("8JZKd").then(()=>parcelRequire('8NAUH'));

});

parcelRegister("cviev", function(module, exports) {

let $91a685f8f79cb950$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $91a685f8f79cb950$var$load("8JZKd").then(()=>parcelRequire('88gzH'));

});

parcelRegister("jMSX1", function(module, exports) {

let $e67d201f769ddef0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e67d201f769ddef0$var$load("8JZKd").then(()=>parcelRequire('avmB1'));

});

parcelRegister("ebf5H", function(module, exports) {

let $a52dcc83156eb002$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a52dcc83156eb002$var$load("8JZKd").then(()=>parcelRequire('2jPbz'));

});

parcelRegister("2OYVW", function(module, exports) {

let $20df846efb179df8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $20df846efb179df8$var$load("8JZKd").then(()=>parcelRequire('lJWVr'));

});

parcelRegister("lfhly", function(module, exports) {

let $f77874620a7b9690$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f77874620a7b9690$var$load("8JZKd").then(()=>parcelRequire('5R8Ny'));

});

parcelRegister("1XK9X", function(module, exports) {

let $16df1b756c75114c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $16df1b756c75114c$var$load("8JZKd").then(()=>parcelRequire('2qpS7'));

});

parcelRegister("2dBoI", function(module, exports) {

let $19d9ce1028c192f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $19d9ce1028c192f0$var$load("8JZKd").then(()=>parcelRequire('1RMGH'));

});

parcelRegister("99CSU", function(module, exports) {

let $6aa31dfbb5a1b100$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6aa31dfbb5a1b100$var$load("8JZKd").then(()=>parcelRequire('43YGL'));

});

parcelRegister("g7Tsp", function(module, exports) {

let $bbd8516fbd92707f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bbd8516fbd92707f$var$load("8JZKd").then(()=>parcelRequire('5ua7I'));

});

parcelRegister("k12Jn", function(module, exports) {

let $e92604f12166acc1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e92604f12166acc1$var$load("8JZKd").then(()=>parcelRequire('7TpM2'));

});

parcelRegister("b4fvU", function(module, exports) {

let $80ec1a18679c0731$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $80ec1a18679c0731$var$load("8JZKd").then(()=>parcelRequire('gzYtx'));

});

parcelRegister("e4CKa", function(module, exports) {

let $a3ef7e16600c66eb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a3ef7e16600c66eb$var$load("8JZKd").then(()=>parcelRequire('cX5zm'));

});

parcelRegister("jzHH4", function(module, exports) {

let $e4032ddee92fc884$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e4032ddee92fc884$var$load("8JZKd").then(()=>parcelRequire('bx4yP'));

});

parcelRegister("j9rtJ", function(module, exports) {

let $df142c424a0729fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df142c424a0729fe$var$load("8JZKd").then(()=>parcelRequire('43JzQ'));

});

parcelRegister("2fxn7", function(module, exports) {

let $1a36de74a9b2003d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1a36de74a9b2003d$var$load("8JZKd").then(()=>parcelRequire('bnnuC'));

});

parcelRegister("hODzF", function(module, exports) {

let $cf85cdca82ff3de5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cf85cdca82ff3de5$var$load("8JZKd").then(()=>parcelRequire('6daub'));

});

parcelRegister("8xSHH", function(module, exports) {

let $638bd6daac5d86e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $638bd6daac5d86e0$var$load("8JZKd").then(()=>parcelRequire('iPlLr'));

});

parcelRegister("7b9Jb", function(module, exports) {

let $53a11b3697828bc0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $53a11b3697828bc0$var$load("8JZKd").then(()=>parcelRequire('32wsW'));

});

parcelRegister("4CTwO", function(module, exports) {

let $35e5c8cebb3ab51d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $35e5c8cebb3ab51d$var$load("8JZKd").then(()=>parcelRequire('9U9uL'));

});

parcelRegister("cIPG7", function(module, exports) {

let $9431ae57f6f8a0b2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9431ae57f6f8a0b2$var$load("8JZKd").then(()=>parcelRequire('ayPxh'));

});

parcelRegister("bbeuj", function(module, exports) {

let $823bf5cd0cf25227$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $823bf5cd0cf25227$var$load("8JZKd").then(()=>parcelRequire('8ZNcY'));

});

parcelRegister("hCgUy", function(module, exports) {

let $cd331a762475d9b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd331a762475d9b8$var$load("8JZKd").then(()=>parcelRequire('ddOgh'));

});

parcelRegister("aFoGZ", function(module, exports) {

let $7c40e32193c8a129$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7c40e32193c8a129$var$load("8JZKd").then(()=>parcelRequire('ezGM7'));

});

parcelRegister("zst8C", function(module, exports) {

let $06a95a57c3881bd7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $06a95a57c3881bd7$var$load("8JZKd").then(()=>parcelRequire('HLa04'));

});

parcelRegister("2srJR", function(module, exports) {

let $1ca3b69a2675204f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1ca3b69a2675204f$var$load("8JZKd").then(()=>parcelRequire('66FuL'));

});

parcelRegister("dwH8A", function(module, exports) {

let $028a938301d00f54$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $028a938301d00f54$var$load("8JZKd").then(()=>parcelRequire('eCByP'));

});

parcelRegister("cjTfC", function(module, exports) {

let $8f821e17163e709a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8f821e17163e709a$var$load("8JZKd").then(()=>parcelRequire('bJeNZ'));

});

parcelRegister("bMdLQ", function(module, exports) {

let $892edbfdba5ee393$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $892edbfdba5ee393$var$load("8JZKd").then(()=>parcelRequire('huub2'));

});

parcelRegister("7j8Tl", function(module, exports) {

let $55213477e81f16cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55213477e81f16cc$var$load("8JZKd").then(()=>parcelRequire('feYkj'));

});

parcelRegister("dvRoc", function(module, exports) {

let $9d6795a37914ac79$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9d6795a37914ac79$var$load("8JZKd").then(()=>parcelRequire('klvaQ'));

});

parcelRegister("2nzoX", function(module, exports) {

let $1bb930c6cc6fc995$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1bb930c6cc6fc995$var$load("8JZKd").then(()=>parcelRequire('5uIs5'));

});

parcelRegister("kY2rX", function(module, exports) {

let $f43b4fc2ef2f7995$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f43b4fc2ef2f7995$var$load("8JZKd").then(()=>parcelRequire('6jcw2'));

});

parcelRegister("amqTW", function(module, exports) {

let $78b0d37ae46be23e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $78b0d37ae46be23e$var$load("8JZKd").then(()=>parcelRequire('f0syu'));

});

parcelRegister("aVQLr", function(module, exports) {

let $7f58281e3286749d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f58281e3286749d$var$load("8JZKd").then(()=>parcelRequire('7jrhz'));

});

parcelRegister("3JA2m", function(module, exports) {

let $2b81874acd682fcc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2b81874acd682fcc$var$load("8JZKd").then(()=>parcelRequire('k1A8C'));

});

parcelRegister("jifNn", function(module, exports) {

let $e0bbf367062b3d5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e0bbf367062b3d5d$var$load("8JZKd").then(()=>parcelRequire('eowPm'));

});

parcelRegister("964w3", function(module, exports) {

let $69f82d5c8f8fccc0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $69f82d5c8f8fccc0$var$load("8JZKd").then(()=>parcelRequire('dskUg'));

});

parcelRegister("kcDAL", function(module, exports) {

let $eb53a3c2420eea73$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb53a3c2420eea73$var$load("8JZKd").then(()=>parcelRequire('8fhBi'));

});

parcelRegister("iEWAq", function(module, exports) {

let $d95968808fc3976c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d95968808fc3976c$var$load("8JZKd").then(()=>parcelRequire('cT2BR'));

});

parcelRegister("J3tuK", function(module, exports) {

let $0876e617916b60b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0876e617916b60b8$var$load("8JZKd").then(()=>parcelRequire('fhXcL'));

});

parcelRegister("hq1qR", function(module, exports) {

let $cae5f9c5748458e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cae5f9c5748458e6$var$load("8JZKd").then(()=>parcelRequire('9Fe9G'));

});

parcelRegister("fIqeU", function(module, exports) {

let $b70f51ad72735103$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b70f51ad72735103$var$load("8JZKd").then(()=>parcelRequire('kOV42'));

});

parcelRegister("7QEbW", function(module, exports) {

let $5b6c90ed57868736$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5b6c90ed57868736$var$load("8JZKd").then(()=>parcelRequire('1zg3D'));

});

parcelRegister("eMYmr", function(module, exports) {

let $ac445ed055aebdcd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac445ed055aebdcd$var$load("8JZKd").then(()=>parcelRequire('5mdwm'));

});

parcelRegister("7tteH", function(module, exports) {

let $5711eb814ac4657a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5711eb814ac4657a$var$load("8JZKd").then(()=>parcelRequire('1DwwI'));

});

parcelRegister("bDOuB", function(module, exports) {

let $879a81018cd92e01$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $879a81018cd92e01$var$load("8JZKd").then(()=>parcelRequire('aRQqo'));

});

parcelRegister("38ubZ", function(module, exports) {

let $24898a03966d6b37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $24898a03966d6b37$var$load("8JZKd").then(()=>parcelRequire('ge0Ua'));

});

parcelRegister("mno1u", function(module, exports) {

let $04343241184f2cdd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $04343241184f2cdd$var$load("8JZKd").then(()=>parcelRequire('jJfRl'));

});

parcelRegister("j1awj", function(module, exports) {

let $dd86456d6e042c68$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dd86456d6e042c68$var$load("8JZKd").then(()=>parcelRequire('d7cx7'));

});

parcelRegister("kzaD2", function(module, exports) {

let $ef8f522e1539293e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ef8f522e1539293e$var$load("8JZKd").then(()=>parcelRequire('5RMes'));

});

parcelRegister("h9SBZ", function(module, exports) {

let $c7dda3aa38898983$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c7dda3aa38898983$var$load("8JZKd").then(()=>parcelRequire('ak2ew'));

});

parcelRegister("kA6Oh", function(module, exports) {

let $efbc73c1cbffc14d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $efbc73c1cbffc14d$var$load("8JZKd").then(()=>parcelRequire('5TJ5b'));

});

parcelRegister("73ji6", function(module, exports) {

let $5227c7068345cc16$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5227c7068345cc16$var$load("8JZKd").then(()=>parcelRequire('aIx48'));

});

parcelRegister("9espj", function(module, exports) {

let $6b8b74f8157432e2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b8b74f8157432e2$var$load("8JZKd").then(()=>parcelRequire('bpKQ0'));

});

parcelRegister("eheOI", function(module, exports) {

let $a64e258dfe1e9e44$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a64e258dfe1e9e44$var$load("8JZKd").then(()=>parcelRequire('hnVTp'));

});

parcelRegister("hRobx", function(module, exports) {

let $d00a25909362020b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d00a25909362020b$var$load("8JZKd").then(()=>parcelRequire('1d4Mb'));

});

parcelRegister("4tNhi", function(module, exports) {

let $3430186df7094b9c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3430186df7094b9c$var$load("8JZKd").then(()=>parcelRequire('6NyjW'));

});

parcelRegister("9btog", function(module, exports) {

let $6afbf06d0535a375$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6afbf06d0535a375$var$load("8JZKd").then(()=>parcelRequire('3UCaN'));

});

parcelRegister("a3XEq", function(module, exports) {

let $753874a880639738$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $753874a880639738$var$load("8JZKd").then(()=>parcelRequire('6Dqb4'));

});

parcelRegister("jgcu2", function(module, exports) {

let $e05931e863c43ef4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e05931e863c43ef4$var$load("8JZKd").then(()=>parcelRequire('7PhkK'));

});

parcelRegister("efWml", function(module, exports) {

let $a60fbc5d380661e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a60fbc5d380661e7$var$load("8JZKd").then(()=>parcelRequire('1Nklh'));

});

parcelRegister("cGYRn", function(module, exports) {

let $93d89dce133535de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $93d89dce133535de$var$load("8JZKd").then(()=>parcelRequire('Dlgdv'));

});

parcelRegister("6KbnA", function(module, exports) {

let $4e8fddb0c6669273$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4e8fddb0c6669273$var$load("8JZKd").then(()=>parcelRequire('ln6ck'));

});

parcelRegister("9wNwY", function(module, exports) {

let $6efd85fb623c7239$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6efd85fb623c7239$var$load("8JZKd").then(()=>parcelRequire('aKJ2P'));

});

parcelRegister("a0P6w", function(module, exports) {

let $74a18bac67d6b621$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74a18bac67d6b621$var$load("8JZKd").then(()=>parcelRequire('qgbsm'));

});

parcelRegister("9ycXh", function(module, exports) {

let $6f4156a7403369c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6f4156a7403369c5$var$load("8JZKd").then(()=>parcelRequire('lkHRD'));

});

parcelRegister("3luMr", function(module, exports) {

let $26fb359506bae22a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $26fb359506bae22a$var$load("8JZKd").then(()=>parcelRequire('fVPpU'));

});

parcelRegister("iVyEQ", function(module, exports) {

let $dc786f3113892c8f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc786f3113892c8f$var$load("8JZKd").then(()=>parcelRequire('4z9XK'));

});

parcelRegister("5Hc7r", function(module, exports) {

let $425a5e800451b370$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $425a5e800451b370$var$load("8JZKd").then(()=>parcelRequire('dm7sF'));

});

parcelRegister("jVl3O", function(module, exports) {

let $e813ad60619909cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e813ad60619909cb$var$load("8JZKd").then(()=>parcelRequire('iCiYs'));

});

parcelRegister("3pZ62", function(module, exports) {

let $27d3195ff2df7dfb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $27d3195ff2df7dfb$var$load("8JZKd").then(()=>parcelRequire('4EFIZ'));

});

parcelRegister("gbZIQ", function(module, exports) {

let $bc9d8d2f0883b229$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bc9d8d2f0883b229$var$load("8JZKd").then(()=>parcelRequire('fgThH'));

});

parcelRegister("1qokz", function(module, exports) {

let $109b17baed786133$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $109b17baed786133$var$load("8JZKd").then(()=>parcelRequire('3KXjR'));

});

parcelRegister("dJxgB", function(module, exports) {

let $9ff9486b3733ab8b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9ff9486b3733ab8b$var$load("8JZKd").then(()=>parcelRequire('bX0fK'));

});

parcelRegister("7W0Vz", function(module, exports) {

let $5c6eab62b9d88a2d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5c6eab62b9d88a2d$var$load("8JZKd").then(()=>parcelRequire('gPkH3'));

});

parcelRegister("3B5om", function(module, exports) {

let $29e9027f7ea80d53$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $29e9027f7ea80d53$var$load("8JZKd").then(()=>parcelRequire('d0d2M'));

});

parcelRegister("c04Yt", function(module, exports) {

let $8bc957f0e9cc20ce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8bc957f0e9cc20ce$var$load("8JZKd").then(()=>parcelRequire('kG2Cm'));

});

parcelRegister("eByCW", function(module, exports) {

let $aa1f619599f85ed0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa1f619599f85ed0$var$load("8JZKd").then(()=>parcelRequire('fvYtK'));

});

parcelRegister("eCGhk", function(module, exports) {

let $aa5568e899bd2bf5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa5568e899bd2bf5$var$load("8JZKd").then(()=>parcelRequire('bmrnl'));

});

parcelRegister("dWWRT", function(module, exports) {

let $a27e5b2321008e6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a27e5b2321008e6e$var$load("8JZKd").then(()=>parcelRequire('8JMZ0'));

});

parcelRegister("hSDBt", function(module, exports) {

let $d046333e9ce1c59d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d046333e9ce1c59d$var$load("8JZKd").then(()=>parcelRequire('1Ks4Q'));

});

parcelRegister("1RnbY", function(module, exports) {

let $15acbb2be7d7c587$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $15acbb2be7d7c587$var$load("8JZKd").then(()=>parcelRequire('6Eilg'));

});

parcelRegister("aOrXc", function(module, exports) {

let $7df441f4724e5d6a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7df441f4724e5d6a$var$load("8JZKd").then(()=>parcelRequire('byKJT'));

});

parcelRegister("45w5X", function(module, exports) {

let $2fa0867e56fbffe9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2fa0867e56fbffe9$var$load("8JZKd").then(()=>parcelRequire('i6rUi'));

});

parcelRegister("klhw9", function(module, exports) {

let $ecf35b709e7c2b66$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ecf35b709e7c2b66$var$load("8JZKd").then(()=>parcelRequire('dOtw2'));

});

parcelRegister("gfKb7", function(module, exports) {

let $bd51de206629943d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bd51de206629943d$var$load("8JZKd").then(()=>parcelRequire('inR50'));

});

parcelRegister("fpk9k", function(module, exports) {

let $b378d219f746232a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b378d219f746232a$var$load("8JZKd").then(()=>parcelRequire('41bOz'));

});

parcelRegister("buqwa", function(module, exports) {

let $85d710eccf9df35a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85d710eccf9df35a$var$load("8JZKd").then(()=>parcelRequire('fEmHe'));

});

parcelRegister("L6p80", function(module, exports) {

let $08d95ba8e7525b0b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $08d95ba8e7525b0b$var$load("8JZKd").then(()=>parcelRequire('fKEXu'));

});

parcelRegister("7ftFc", function(module, exports) {

let $5470f1afb73c1d9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5470f1afb73c1d9b$var$load("8JZKd").then(()=>parcelRequire('8icpB'));

});

parcelRegister("a2FUj", function(module, exports) {

let $74fa9934267b1fcc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74fa9934267b1fcc$var$load("8JZKd").then(()=>parcelRequire('l4ZyA'));

});

parcelRegister("fQTfl", function(module, exports) {

let $b8a69126eae4d68e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b8a69126eae4d68e$var$load("8JZKd").then(()=>parcelRequire('5b9Z9'));

});

parcelRegister("9YoNL", function(module, exports) {

let $742cf4bac759cbe3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $742cf4bac759cbe3$var$load("8JZKd").then(()=>parcelRequire('glU04'));

});

parcelRegister("05j0s", function(module, exports) {

let $00ff36028c128560$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $00ff36028c128560$var$load("8JZKd").then(()=>parcelRequire('8j2ZH'));

});

parcelRegister("jSdVw", function(module, exports) {

let $e77ddd06e9522eeb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e77ddd06e9522eeb$var$load("8JZKd").then(()=>parcelRequire('h4Kkd'));

});

parcelRegister("8Cm29", function(module, exports) {

let $6462f6ca54607101$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6462f6ca54607101$var$load("8JZKd").then(()=>parcelRequire('cDCCl'));

});

parcelRegister("f6kYs", function(module, exports) {

let $afe7af96c82157af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $afe7af96c82157af$var$load("8JZKd").then(()=>parcelRequire('4NIhb'));

});

parcelRegister("g47Q7", function(module, exports) {

let $bb2319d5ddced5ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bb2319d5ddced5ac$var$load("8JZKd").then(()=>parcelRequire('4AGyV'));

});

parcelRegister("clMi6", function(module, exports) {

let $8fdce7cdc65bb307$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8fdce7cdc65bb307$var$load("8JZKd").then(()=>parcelRequire('31Ui6'));

});

parcelRegister("ePuor", function(module, exports) {

let $acbd678d3304c366$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $acbd678d3304c366$var$load("8JZKd").then(()=>parcelRequire('lS9G7'));

});

parcelRegister("2pEHb", function(module, exports) {

let $1c1d7bda48a19fea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c1d7bda48a19fea$var$load("8JZKd").then(()=>parcelRequire('i12BE'));

});

parcelRegister("khqhV", function(module, exports) {

let $ec39c96dbab8362f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec39c96dbab8362f$var$load("8JZKd").then(()=>parcelRequire('9HSvn'));

});

parcelRegister("5bLIn", function(module, exports) {

let $3c72fdfe21305bee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3c72fdfe21305bee$var$load("8JZKd").then(()=>parcelRequire('fBY8v'));

});

parcelRegister("6S4t2", function(module, exports) {

let $500b40576ff86c19$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $500b40576ff86c19$var$load("8JZKd").then(()=>parcelRequire('7sUdD'));

});

parcelRegister("aEQsV", function(module, exports) {

let $7c2656613f7b707b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7c2656613f7b707b$var$load("8JZKd").then(()=>parcelRequire('8IxMf'));

});

parcelRegister("aRaOJ", function(module, exports) {

let $7e773eb803f13cd4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7e773eb803f13cd4$var$load("8JZKd").then(()=>parcelRequire('fecYF'));

});

parcelRegister("4pjtl", function(module, exports) {

let $33589a0222073d0a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $33589a0222073d0a$var$load("8JZKd").then(()=>parcelRequire('bWDfG'));

});

parcelRegister("2MjY4", function(module, exports) {

let $205f8da551b2fe2f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $205f8da551b2fe2f$var$load("8JZKd").then(()=>parcelRequire('h188A'));

});

parcelRegister("awNW8", function(module, exports) {

let $7aa3a0ed71760409$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7aa3a0ed71760409$var$load("8JZKd").then(()=>parcelRequire('5042u'));

});

parcelRegister("lFoqY", function(module, exports) {

let $fc6061621b961cbb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fc6061621b961cbb$var$load("8JZKd").then(()=>parcelRequire('gTjFa'));

});

parcelRegister("luSCR", function(module, exports) {

let $fa66c5e259f1601c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fa66c5e259f1601c$var$load("8JZKd").then(()=>parcelRequire('aBZC5'));

});

parcelRegister("iRkfA", function(module, exports) {

let $dbace2847e20f52c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dbace2847e20f52c$var$load("8JZKd").then(()=>parcelRequire('buUDP'));

});

parcelRegister("5fiKg", function(module, exports) {

let $3d1ce4dd9bf88e72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3d1ce4dd9bf88e72$var$load("8JZKd").then(()=>parcelRequire('4ODVn'));

});

parcelRegister("49VGi", function(module, exports) {

let $3074befe6ab0b1c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3074befe6ab0b1c2$var$load("8JZKd").then(()=>parcelRequire('dGf3x'));

});

parcelRegister("Ww4SE", function(module, exports) {

let $0afe4cdc5b29d958$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0afe4cdc5b29d958$var$load("8JZKd").then(()=>parcelRequire('8B7Mv'));

});

parcelRegister("lHYlB", function(module, exports) {

let $fcdc6cdaf9219cb7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fcdc6cdaf9219cb7$var$load("8JZKd").then(()=>parcelRequire('cSfLu'));

});

parcelRegister("jE1Ny", function(module, exports) {

let $e4d325dec325b610$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e4d325dec325b610$var$load("8JZKd").then(()=>parcelRequire('gmTTR'));

});

parcelRegister("gQWHK", function(module, exports) {

let $c44f0a2c3fa78e0a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c44f0a2c3fa78e0a$var$load("8JZKd").then(()=>parcelRequire('2Jysk'));

});

parcelRegister("84dCx", function(module, exports) {

let $5df9433c64e56a9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5df9433c64e56a9b$var$load("8JZKd").then(()=>parcelRequire('hO1ce'));

});

parcelRegister("lxzyu", function(module, exports) {

let $fae84295f9293ffa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fae84295f9293ffa$var$load("8JZKd").then(()=>parcelRequire('dVfWe'));

});

parcelRegister("3EkzP", function(module, exports) {

let $2a8511a4cbaf6f6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2a8511a4cbaf6f6b$var$load("8JZKd").then(()=>parcelRequire('k1LfU'));

});

parcelRegister("jTzoC", function(module, exports) {

let $e7be9c497ef478fb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e7be9c497ef478fb$var$load("8JZKd").then(()=>parcelRequire('5bJFE'));

});

parcelRegister("eUTRn", function(module, exports) {

let $adc1a0468474f18f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $adc1a0468474f18f$var$load("8JZKd").then(()=>parcelRequire('1hn1F'));

});

parcelRegister("b4jvo", function(module, exports) {

let $80ef32ca35feba70$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $80ef32ca35feba70$var$load("8JZKd").then(()=>parcelRequire('66gZz'));

});

parcelRegister("9iUtD", function(module, exports) {

let $6c619aac163c4872$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6c619aac163c4872$var$load("8JZKd").then(()=>parcelRequire('a6h9M'));

});

parcelRegister("btq5i", function(module, exports) {

let $85a6a2f79871d609$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85a6a2f79871d609$var$load("8JZKd").then(()=>parcelRequire('bOUpD'));

});

parcelRegister("dbque", function(module, exports) {

let $9990d91e66187f2c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9990d91e66187f2c$var$load("8JZKd").then(()=>parcelRequire('6alL7'));

});

parcelRegister("aqQGa", function(module, exports) {

let $7985320fa78211a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7985320fa78211a1$var$load("8JZKd").then(()=>parcelRequire('7rLeu'));

});

parcelRegister("iYr5w", function(module, exports) {

let $dd02d7bc3bd364b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dd02d7bc3bd364b0$var$load("8JZKd").then(()=>parcelRequire('iSy9M'));

});

parcelRegister("k8Qz7", function(module, exports) {

let $ea9d5462e771aec1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ea9d5462e771aec1$var$load("8JZKd").then(()=>parcelRequire('j0spP'));

});

parcelRegister("8e8xH", function(module, exports) {

let $5fd641eae11434db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5fd641eae11434db$var$load("8JZKd").then(()=>parcelRequire('8naep'));

});

parcelRegister("2Ua5l", function(module, exports) {

let $21d8a26ce970278e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $21d8a26ce970278e$var$load("8JZKd").then(()=>parcelRequire('aNOf2'));

});

parcelRegister("eI4RG", function(module, exports) {

let $ab58f2c9d294ad15$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ab58f2c9d294ad15$var$load("8JZKd").then(()=>parcelRequire('iyPh3'));

});

parcelRegister("cMHFe", function(module, exports) {

let $94ebd67ee0421cdb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $94ebd67ee0421cdb$var$load("8JZKd").then(()=>parcelRequire('7Zzmn'));

});

parcelRegister("7V0QM", function(module, exports) {

let $5c3e841d8d99a243$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5c3e841d8d99a243$var$load("8JZKd").then(()=>parcelRequire('bnpWc'));

});

parcelRegister("apyBI", function(module, exports) {

let $794715797c3fdbb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $794715797c3fdbb9$var$load("8JZKd").then(()=>parcelRequire('5MbuW'));

});

parcelRegister("eIiHy", function(module, exports) {

let $ab63ae7ecf058ec6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ab63ae7ecf058ec6$var$load("8JZKd").then(()=>parcelRequire('jc9Cb'));

});

parcelRegister("e6UDC", function(module, exports) {

let $a45d8f5ef9917c96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a45d8f5ef9917c96$var$load("8JZKd").then(()=>parcelRequire('6bEAi'));

});

parcelRegister("4Sdps", function(module, exports) {

let $38c69b6cce98c4c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $38c69b6cce98c4c2$var$load("8JZKd").then(()=>parcelRequire('3puEE'));

});

parcelRegister("lrt6E", function(module, exports) {

let $f9c2b2814e9246f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f9c2b2814e9246f7$var$load("8JZKd").then(()=>parcelRequire('7x9yK'));

});

parcelRegister("51eYZ", function(module, exports) {

let $3a78aafcf0198e93$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3a78aafcf0198e93$var$load("8JZKd").then(()=>parcelRequire('hhOn3'));

});

parcelRegister("hJZBx", function(module, exports) {

let $cea66cfe7fd0cff8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cea66cfe7fd0cff8$var$load("8JZKd").then(()=>parcelRequire('jH3CX'));

});

parcelRegister("3uU0n", function(module, exports) {

let $28bf9ddc9959662f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $28bf9ddc9959662f$var$load("8JZKd").then(()=>parcelRequire('9vAtn'));

});

parcelRegister("blLgP", function(module, exports) {

let $843652d2a1fe1660$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $843652d2a1fe1660$var$load("8JZKd").then(()=>parcelRequire('aPaXw'));

});

parcelRegister("kUFGD", function(module, exports) {

let $f3995fb728baf0b9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3995fb728baf0b9$var$load("8JZKd").then(()=>parcelRequire('lLg7I'));

});

parcelRegister("2m1kb", function(module, exports) {

let $1b6ea9e2549253fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1b6ea9e2549253fd$var$load("8JZKd").then(()=>parcelRequire('ltXJB'));

});

parcelRegister("VM0ZU", function(module, exports) {

let $0ada91c856778116$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ada91c856778116$var$load("8JZKd").then(()=>parcelRequire('kcmYy'));

});

parcelRegister("bWocZ", function(module, exports) {

let $8b17e3d20d098c63$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8b17e3d20d098c63$var$load("8JZKd").then(()=>parcelRequire('jO8pH'));

});

parcelRegister("8DUC2", function(module, exports) {

let $64ade14bd28fbe6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $64ade14bd28fbe6b$var$load("8JZKd").then(()=>parcelRequire('kxiVw'));

});

parcelRegister("gH7uE", function(module, exports) {

let $c276798666a65035$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c276798666a65035$var$load("8JZKd").then(()=>parcelRequire('eWpan'));

});

parcelRegister("iiP0D", function(module, exports) {

let $d53179cd31d370cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d53179cd31d370cf$var$load("8JZKd").then(()=>parcelRequire('kQ3RN'));

});

parcelRegister("lo0FS", function(module, exports) {

let $f91c5cc9dc589c1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f91c5cc9dc589c1c$var$load("8JZKd").then(()=>parcelRequire('dfteC'));

});

parcelRegister("k8GiV", function(module, exports) {

let $ea955ec1e584edd7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ea955ec1e584edd7$var$load("8JZKd").then(()=>parcelRequire('CggUl'));

});

parcelRegister("1ZKpk", function(module, exports) {

let $173f7c81de4e9fe3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $173f7c81de4e9fe3$var$load("8JZKd").then(()=>parcelRequire('8QILn'));

});

parcelRegister("6DU2F", function(module, exports) {

let $4d61db5b610ea623$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d61db5b610ea623$var$load("8JZKd").then(()=>parcelRequire('hoxEe'));

});

parcelRegister("1jMYO", function(module, exports) {

let $0f5d8f3070bca302$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0f5d8f3070bca302$var$load("8JZKd").then(()=>parcelRequire('45NuA'));

});

parcelRegister("5Dpm8", function(module, exports) {

let $41a4436cba24141d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $41a4436cba24141d$var$load("8JZKd").then(()=>parcelRequire('4behf'));

});

parcelRegister("cvTzJ", function(module, exports) {

let $91c37d694fdb2890$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $91c37d694fdb2890$var$load("8JZKd").then(()=>parcelRequire('jIcpb'));

});

parcelRegister("6or9j", function(module, exports) {

let $4a7a0b3885484a78$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4a7a0b3885484a78$var$load("8JZKd").then(()=>parcelRequire('15j5l'));

});

parcelRegister("lCkm6", function(module, exports) {

let $fbccefc77473b959$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fbccefc77473b959$var$load("8JZKd").then(()=>parcelRequire('hCM3u'));

});

parcelRegister("dKKbb", function(module, exports) {

let $a03364803cb657eb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a03364803cb657eb$var$load("8JZKd").then(()=>parcelRequire('5aQLI'));

});

parcelRegister("gcsah", function(module, exports) {

let $bcb39d4690798728$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bcb39d4690798728$var$load("8JZKd").then(()=>parcelRequire('jFo4x'));

});

parcelRegister("9OJ2O", function(module, exports) {

let $725bb972fef60b5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $725bb972fef60b5e$var$load("8JZKd").then(()=>parcelRequire('1ygpC'));

});

parcelRegister("5ZZrc", function(module, exports) {

let $45e24e83aa150c8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $45e24e83aa150c8a$var$load("8JZKd").then(()=>parcelRequire('eNWU9'));

});

parcelRegister("bsBpI", function(module, exports) {

let $857f54d8765d2033$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $857f54d8765d2033$var$load("8JZKd").then(()=>parcelRequire('7Nofo'));

});

parcelRegister("cBuni", function(module, exports) {

let $92d08083b82f0e72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $92d08083b82f0e72$var$load("8JZKd").then(()=>parcelRequire('hJjEH'));

});

parcelRegister("2J7iA", function(module, exports) {

let $1fc5721b84e71064$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1fc5721b84e71064$var$load("8JZKd").then(()=>parcelRequire('iBmSz'));

});

parcelRegister("77NdO", function(module, exports) {

let $52ff5e47267c418c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $52ff5e47267c418c$var$load("8JZKd").then(()=>parcelRequire('94DZY'));

});

parcelRegister("bPJCW", function(module, exports) {

let $89d7d9bb2b52bc37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $89d7d9bb2b52bc37$var$load("8JZKd").then(()=>parcelRequire('61dq6'));

});

parcelRegister("31uxZ", function(module, exports) {

let $2339291feebe1c9f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2339291feebe1c9f$var$load("8JZKd").then(()=>parcelRequire('cMnm9'));

});

parcelRegister("4O5jI", function(module, exports) {

let $37fff4ca0e92120c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $37fff4ca0e92120c$var$load("8JZKd").then(()=>parcelRequire('k2c1s'));

});

parcelRegister("9TNEo", function(module, exports) {

let $734fc3ac59d946e5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $734fc3ac59d946e5$var$load("8JZKd").then(()=>parcelRequire('3rvkR'));

});

parcelRegister("30QTS", function(module, exports) {

let $231a68104f78d75d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $231a68104f78d75d$var$load("8JZKd").then(()=>parcelRequire('lj1Sg'));

});

parcelRegister("d8ht4", function(module, exports) {

let $98f99274279a3024$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $98f99274279a3024$var$load("8JZKd").then(()=>parcelRequire('8RrFV'));

});

parcelRegister("bOeBu", function(module, exports) {

let $898fb135a3bf5d46$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $898fb135a3bf5d46$var$load("8JZKd").then(()=>parcelRequire('4ZJrP'));

});

parcelRegister("81y2K", function(module, exports) {

let $5d78d303f30f4b6c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5d78d303f30f4b6c$var$load("8JZKd").then(()=>parcelRequire('dCvxM'));

});

parcelRegister("jQSKc", function(module, exports) {

let $03bacbb89dc19ac3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $03bacbb89dc19ac3$var$load("8JZKd").then(()=>parcelRequire('37m2U'));

});

parcelRegister("j9lu1", function(module, exports) {

let $df0f85b1b0250fa9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df0f85b1b0250fa9$var$load("8JZKd").then(()=>parcelRequire('3Ba1h'));

});

parcelRegister("39CX7", function(module, exports) {

let $24c06d8935961afe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $24c06d8935961afe$var$load("8JZKd").then(()=>parcelRequire('djWMf'));

});

parcelRegister("daSLP", function(module, exports) {

let $9976b1c89c872a28$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9976b1c89c872a28$var$load("8JZKd").then(()=>parcelRequire('2fH53'));

});

parcelRegister("kj7xK", function(module, exports) {

let $ec8b6eed322acbcf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec8b6eed322acbcf$var$load("8JZKd").then(()=>parcelRequire('12opN'));

});

parcelRegister("2tNba", function(module, exports) {

let $1ce47027eedcb651$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1ce47027eedcb651$var$load("8JZKd").then(()=>parcelRequire('9HIUE'));

});

parcelRegister("XPI8H", function(module, exports) {

let $0b3d9f83e1cfc8e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0b3d9f83e1cfc8e7$var$load("8JZKd").then(()=>parcelRequire('bYWX4'));

});

parcelRegister("gjQhw", function(module, exports) {

let $be16f9be68209396$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be16f9be68209396$var$load("8JZKd").then(()=>parcelRequire('a7lwr'));

});

parcelRegister("9khkZ", function(module, exports) {

let $6ca36e3049cb1d31$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6ca36e3049cb1d31$var$load("8JZKd").then(()=>parcelRequire('lmzTx'));

});

parcelRegister("3Wbgn", function(module, exports) {

let $2ddf8686615e2c6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2ddf8686615e2c6b$var$load("8JZKd").then(()=>parcelRequire('dHCVo'));

});

parcelRegister("5yfOO", function(module, exports) {

let $40ac65fc8e7a80a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $40ac65fc8e7a80a6$var$load("8JZKd").then(()=>parcelRequire('6ul0c'));

});

parcelRegister("b6XEm", function(module, exports) {

let $816e8683fcf97efd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $816e8683fcf97efd$var$load("8JZKd").then(()=>parcelRequire('lYh3a'));

});

parcelRegister("KRJU9", function(module, exports) {

let $08cdfb8464dc90b7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $08cdfb8464dc90b7$var$load("8JZKd").then(()=>parcelRequire('fqv9g'));

});

parcelRegister("5ufZi", function(module, exports) {

let $3fec27e62c7d5498$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3fec27e62c7d5498$var$load("8JZKd").then(()=>parcelRequire('lzIWk'));

});

parcelRegister("8V5LC", function(module, exports) {

let $67e81ed1a8753235$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $67e81ed1a8753235$var$load("8JZKd").then(()=>parcelRequire('28QRh'));

});

parcelRegister("lqtml", function(module, exports) {

let $f992ccd76c186e2f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f992ccd76c186e2f$var$load("8JZKd").then(()=>parcelRequire('2JrrX'));

});

parcelRegister("2Wwhr", function(module, exports) {

let $224a09c157514450$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $224a09c157514450$var$load("8JZKd").then(()=>parcelRequire('eiQQV'));

});

parcelRegister("e2Q9l", function(module, exports) {

let $a399b46c03b8c065$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a399b46c03b8c065$var$load("8JZKd").then(()=>parcelRequire('kNFe8'));

});

parcelRegister("gDpHC", function(module, exports) {

let $c1c439d9a8a30767$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c1c439d9a8a30767$var$load("8JZKd").then(()=>parcelRequire('6egTz'));

});

parcelRegister("7go8k", function(module, exports) {

let $549cbf68f6c1999d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $549cbf68f6c1999d$var$load("8JZKd").then(()=>parcelRequire('jgpZe'));

});

parcelRegister("jIOax", function(module, exports) {

let $e5b90ae97e5d502d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e5b90ae97e5d502d$var$load("8JZKd").then(()=>parcelRequire('2D7De'));

});

parcelRegister("kr3bo", function(module, exports) {

let $ee08cc501824b043$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee08cc501824b043$var$load("8JZKd").then(()=>parcelRequire('jzipv'));

});

parcelRegister("2i5H8", function(module, exports) {

let $1ab1ae15398f67cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1ab1ae15398f67cd$var$load("8JZKd").then(()=>parcelRequire('AHo5e'));

});

parcelRegister("79iWF", function(module, exports) {

let $534811d2bdf4be05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $534811d2bdf4be05$var$load("8JZKd").then(()=>parcelRequire('3Ry19'));

});

parcelRegister("j8ZNs", function(module, exports) {

let $defeb33a213a9e05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $defeb33a213a9e05$var$load("8JZKd").then(()=>parcelRequire('kfDgS'));

});

parcelRegister("bOwxO", function(module, exports) {

let $899d9bda027817ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $899d9bda027817ee$var$load("8JZKd").then(()=>parcelRequire('l1U4U'));

});

parcelRegister("3ivMi", function(module, exports) {

let $266bb3fd22432b9a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $266bb3fd22432b9a$var$load("8JZKd").then(()=>parcelRequire('17uVW'));

});

parcelRegister("aZaIv", function(module, exports) {

let $7ff7ea0aa8c210b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7ff7ea0aa8c210b3$var$load("8JZKd").then(()=>parcelRequire('cPPcH'));

});

parcelRegister("dpVnI", function(module, exports) {

let $9c4a1eef4f81f291$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9c4a1eef4f81f291$var$load("8JZKd").then(()=>parcelRequire('bJViO'));

});

parcelRegister("1tZnn", function(module, exports) {

let $11481bdcd5456d25$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $11481bdcd5456d25$var$load("8JZKd").then(()=>parcelRequire('6Kkwl'));

});

parcelRegister("9bbst", function(module, exports) {

let $6aee0782e3decd24$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6aee0782e3decd24$var$load("8JZKd").then(()=>parcelRequire('8YzrV'));

});

parcelRegister("7JjMa", function(module, exports) {

let $5a0c136fc175921d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5a0c136fc175921d$var$load("8JZKd").then(()=>parcelRequire('9mwm7'));

});

parcelRegister("dcgXf", function(module, exports) {

let $99b98c2aea04116b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99b98c2aea04116b$var$load("8JZKd").then(()=>parcelRequire('GDUgu'));

});

parcelRegister("a8uWi", function(module, exports) {

let $7612a69c7d236b6a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7612a69c7d236b6a$var$load("8JZKd").then(()=>parcelRequire('bDl1z'));

});

parcelRegister("h0cX5", function(module, exports) {

let $c60c7bbbbb3bef96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c60c7bbbbb3bef96$var$load("8JZKd").then(()=>parcelRequire('5EKtz'));

});

parcelRegister("cPIK5", function(module, exports) {

let $957cf45f91f0fdfe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $957cf45f91f0fdfe$var$load("8JZKd").then(()=>parcelRequire('ei5Sx'));

});

parcelRegister("ixaLP", function(module, exports) {

let $d7e3a9dec410b6c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d7e3a9dec410b6c8$var$load("8JZKd").then(()=>parcelRequire('f4aeC'));

});

parcelRegister("8yoML", function(module, exports) {

let $63a4b99c4e44d5b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $63a4b99c4e44d5b3$var$load("8JZKd").then(()=>parcelRequire('kn29b'));

});

parcelRegister("lYoEY", function(module, exports) {

let $fff2548288b4a33d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fff2548288b4a33d$var$load("8JZKd").then(()=>parcelRequire('2ao8s'));

});

parcelRegister("j5A1r", function(module, exports) {

let $de5a6d3217d8d887$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de5a6d3217d8d887$var$load("8JZKd").then(()=>parcelRequire('01szy'));

});

parcelRegister("5MBn9", function(module, exports) {

let $435e6cd3b2db64eb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $435e6cd3b2db64eb$var$load("8JZKd").then(()=>parcelRequire('in7zw'));

});

parcelRegister("cb3Lj", function(module, exports) {

let $8dd96e2a78482eb2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8dd96e2a78482eb2$var$load("8JZKd").then(()=>parcelRequire('krYSF'));

});

parcelRegister("1ubwJ", function(module, exports) {

let $115188d0fafe840f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $115188d0fafe840f$var$load("8JZKd").then(()=>parcelRequire('e2mYq'));

});

parcelRegister("hOKHE", function(module, exports) {

let $cf8b55746b1283c7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cf8b55746b1283c7$var$load("8JZKd").then(()=>parcelRequire('gOItI'));

});

parcelRegister("gthbx", function(module, exports) {

let $bfdcaf62560138b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bfdcaf62560138b8$var$load("8JZKd").then(()=>parcelRequire('aOUdU'));

});

parcelRegister("9974f", function(module, exports) {

let $6a8a6fc9d81b9c8d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a8a6fc9d81b9c8d$var$load("8JZKd").then(()=>parcelRequire('9aBYD'));

});

parcelRegister("1lThz", function(module, exports) {

let $0fc2a285f6a21eab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0fc2a285f6a21eab$var$load("8JZKd").then(()=>parcelRequire('iEc3v'));

});

parcelRegister("cZC9E", function(module, exports) {

let $9758c7466892afa6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9758c7466892afa6$var$load("8JZKd").then(()=>parcelRequire('aVpt4'));

});

parcelRegister("1mSPh", function(module, exports) {

let $0ff25fd7b15a3412$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ff25fd7b15a3412$var$load("8JZKd").then(()=>parcelRequire('gcdUq'));

});

parcelRegister("9mUtj", function(module, exports) {

let $6d21f9435e0076fb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d21f9435e0076fb$var$load("8JZKd").then(()=>parcelRequire('1hOxD'));

});

parcelRegister("f7ISB", function(module, exports) {

let $b02a52a3ee34db1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b02a52a3ee34db1e$var$load("8JZKd").then(()=>parcelRequire('99IS5'));

});

parcelRegister("EbKPS", function(module, exports) {

let $078cdab939ede9ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $078cdab939ede9ee$var$load("8JZKd").then(()=>parcelRequire('er7lB'));

});

parcelRegister("8kOsA", function(module, exports) {

let $611755539ca5f2b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $611755539ca5f2b0$var$load("8JZKd").then(()=>parcelRequire('i2GOL'));

});

parcelRegister("eAyWm", function(module, exports) {

let $a9ef87e5a0a9436e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a9ef87e5a0a9436e$var$load("8JZKd").then(()=>parcelRequire('gyvV1'));

});

parcelRegister("d9nUt", function(module, exports) {

let $992ea9a2464c7f9d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $992ea9a2464c7f9d$var$load("8JZKd").then(()=>parcelRequire('nnywf'));

});

parcelRegister("btFwi", function(module, exports) {

let $85b29c1d3b64ccba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85b29c1d3b64ccba$var$load("8JZKd").then(()=>parcelRequire('9o9gx'));

});

parcelRegister("4krpA", function(module, exports) {

let $326e4b147a048d83$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $326e4b147a048d83$var$load("8JZKd").then(()=>parcelRequire('h0iV6'));

});

parcelRegister("hZaDl", function(module, exports) {

let $d18061c2941e7754$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d18061c2941e7754$var$load("8JZKd").then(()=>parcelRequire('4i9CF'));

});

parcelRegister("1zJUD", function(module, exports) {

let $125cac950b0efe96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $125cac950b0efe96$var$load("8JZKd").then(()=>parcelRequire('aheLq'));

});

parcelRegister("iIMmz", function(module, exports) {

let $da11d9f6f392f113$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $da11d9f6f392f113$var$load("8JZKd").then(()=>parcelRequire('jA3Z9'));

});

parcelRegister("eMmwT", function(module, exports) {

let $ac27064b7be1c586$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac27064b7be1c586$var$load("8JZKd").then(()=>parcelRequire('27bo9'));

});

parcelRegister("9G3SL", function(module, exports) {

let $70bb0c43131cdd5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $70bb0c43131cdd5e$var$load("8JZKd").then(()=>parcelRequire('7aMFL'));

});

parcelRegister("8stkn", function(module, exports) {

let $6287b0215db6a63c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6287b0215db6a63c$var$load("8JZKd").then(()=>parcelRequire('kBnhd'));

});

parcelRegister("2m9He", function(module, exports) {

let $1b75285245a42a8c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1b75285245a42a8c$var$load("8JZKd").then(()=>parcelRequire('6ZEj6'));

});

parcelRegister("ltxhg", function(module, exports) {

let $fa261e9bebdc1cc1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fa261e9bebdc1cc1$var$load("8JZKd").then(()=>parcelRequire('jQfjq'));

});

parcelRegister("cOdMJ", function(module, exports) {

let $9534d8f77ab12afd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9534d8f77ab12afd$var$load("8JZKd").then(()=>parcelRequire('8j0Ak'));

});

parcelRegister("4dg2p", function(module, exports) {

let $3114d1214d97f2e8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3114d1214d97f2e8$var$load("8JZKd").then(()=>parcelRequire('alzqi'));

});

parcelRegister("6J2Sn", function(module, exports) {

let $4e592d2b73d09887$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4e592d2b73d09887$var$load("8JZKd").then(()=>parcelRequire('jOLOx'));

});

parcelRegister("YAoD4", function(module, exports) {

let $0b61d63f48a200cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0b61d63f48a200cc$var$load("8JZKd").then(()=>parcelRequire('4OQXl'));

});

parcelRegister("matJm", function(module, exports) {

let $042a2f016bbfcdc8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $042a2f016bbfcdc8$var$load("8JZKd").then(()=>parcelRequire('3PK42'));

});

parcelRegister("hjOwT", function(module, exports) {

let $c9bb68274b39f929$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c9bb68274b39f929$var$load("8JZKd").then(()=>parcelRequire('eVv9d'));

});

parcelRegister("arLS1", function(module, exports) {

let $79b18f0e8795fc0a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $79b18f0e8795fc0a$var$load("8JZKd").then(()=>parcelRequire('h3njx'));

});

parcelRegister("gFvhr", function(module, exports) {

let $c228bd455ebdc77c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c228bd455ebdc77c$var$load("8JZKd").then(()=>parcelRequire('5JtnX'));

});

parcelRegister("2RcFm", function(module, exports) {

let $214a5b3f8c6be233$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $214a5b3f8c6be233$var$load("8JZKd").then(()=>parcelRequire('bfgbA'));

});

parcelRegister("hYVZR", function(module, exports) {

let $d1750732205699a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d1750732205699a0$var$load("8JZKd").then(()=>parcelRequire('7Lcpq'));

});

parcelRegister("evwy5", function(module, exports) {

let $a8fd357458e10fac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a8fd357458e10fac$var$load("8JZKd").then(()=>parcelRequire('ld96b'));

});

parcelRegister("9lXmM", function(module, exports) {

let $6cf420293fc229e2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6cf420293fc229e2$var$load("8JZKd").then(()=>parcelRequire('9GCsh'));

});

parcelRegister("etVgP", function(module, exports) {

let $a8b032d21100328d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a8b032d21100328d$var$load("8JZKd").then(()=>parcelRequire('f9sHQ'));

});

parcelRegister("ctkLN", function(module, exports) {

let $91484df33ed70956$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $91484df33ed70956$var$load("8JZKd").then(()=>parcelRequire('duHPY'));

});

parcelRegister("gw31F", function(module, exports) {

let $c061fb611efe624e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c061fb611efe624e$var$load("8JZKd").then(()=>parcelRequire('3Jfdd'));

});

parcelRegister("35Ray", function(module, exports) {

let $240b1506d53d4b1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $240b1506d53d4b1e$var$load("8JZKd").then(()=>parcelRequire('2OqZy'));

});

parcelRegister("lmYEP", function(module, exports) {

let $f8eab460528c5afe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f8eab460528c5afe$var$load("8JZKd").then(()=>parcelRequire('lW5j9'));

});

parcelRegister("dadmB", function(module, exports) {

let $99569348b05d6643$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99569348b05d6643$var$load("8JZKd").then(()=>parcelRequire('bq6BP'));

});

parcelRegister("fCb3J", function(module, exports) {

let $b5e2fbbbd727cffd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b5e2fbbbd727cffd$var$load("8JZKd").then(()=>parcelRequire('9dLgx'));

});

parcelRegister("fXo5h", function(module, exports) {

let $b9df0c5236b499a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b9df0c5236b499a6$var$load("8JZKd").then(()=>parcelRequire('74dfH'));

});

parcelRegister("schya", function(module, exports) {

let $054c249a2d465d0d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $054c249a2d465d0d$var$load("8JZKd").then(()=>parcelRequire('jPIdX'));

});

parcelRegister("3nJAu", function(module, exports) {

let $2766e1cddef962fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2766e1cddef962fe$var$load("8JZKd").then(()=>parcelRequire('6X2vu'));

});

parcelRegister("2YYOI", function(module, exports) {

let $22c05c6166007425$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $22c05c6166007425$var$load("8JZKd").then(()=>parcelRequire('6xEso'));

});

parcelRegister("avHGQ", function(module, exports) {

let $7a6eb0910614453c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7a6eb0910614453c$var$load("8JZKd").then(()=>parcelRequire('eWJYw'));

});

parcelRegister("6VxbR", function(module, exports) {

let $50b1cfddffd9f077$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $50b1cfddffd9f077$var$load("8JZKd").then(()=>parcelRequire('koTfG'));

});

parcelRegister("5PuGi", function(module, exports) {

let $43e983cfcfaec76c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $43e983cfcfaec76c$var$load("8JZKd").then(()=>parcelRequire('5sFnD'));

});

parcelRegister("5zfGK", function(module, exports) {

let $40dc640bae52bf98$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $40dc640bae52bf98$var$load("8JZKd").then(()=>parcelRequire('8nVd9'));

});

parcelRegister("cwUD9", function(module, exports) {

let $91f466d4bfdac843$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $91f466d4bfdac843$var$load("8JZKd").then(()=>parcelRequire('1uqxU'));

});

parcelRegister("k4Sa0", function(module, exports) {

let $e9de317c4b9234b7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e9de317c4b9234b7$var$load("8JZKd").then(()=>parcelRequire('4JTpJ'));

});

parcelRegister("hDL78", function(module, exports) {

let $cd7aa0102bf7b83e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd7aa0102bf7b83e$var$load("8JZKd").then(()=>parcelRequire('h0sHG'));

});

parcelRegister("0tmcS", function(module, exports) {

let $0016c5ecc77695fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0016c5ecc77695fa$var$load("8JZKd").then(()=>parcelRequire('eJPDm'));

});

parcelRegister("is8pI", function(module, exports) {

let $d6f15e57c09c5c4c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d6f15e57c09c5c4c$var$load("8JZKd").then(()=>parcelRequire('loik3'));

});

parcelRegister("gwR2Y", function(module, exports) {

let $c088c88b6eb98430$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c088c88b6eb98430$var$load("8JZKd").then(()=>parcelRequire('RZ5dr'));

});

parcelRegister("f7j8T", function(module, exports) {

let $b0165bc0cc17f441$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b0165bc0cc17f441$var$load("8JZKd").then(()=>parcelRequire('1Ce5i'));

});

parcelRegister("lOjXt", function(module, exports) {

let $fe0dbfc9a2f15427$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fe0dbfc9a2f15427$var$load("8JZKd").then(()=>parcelRequire('fiSL0'));

});

parcelRegister("aPC7f", function(module, exports) {

let $7e2c3bd21d0c7570$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7e2c3bd21d0c7570$var$load("8JZKd").then(()=>parcelRequire('c5Qhh'));

});

parcelRegister("eUzDD", function(module, exports) {

let $adb1f0af2c35930d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $adb1f0af2c35930d$var$load("8JZKd").then(()=>parcelRequire('gC1BV'));

});

parcelRegister("9JZS8", function(module, exports) {

let $71784f85da147acc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $71784f85da147acc$var$load("8JZKd").then(()=>parcelRequire('21Xtm'));

});

parcelRegister("dZOLy", function(module, exports) {

let $a30859ee82c6604d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a30859ee82c6604d$var$load("8JZKd").then(()=>parcelRequire('cegX4'));

});

parcelRegister("jSIHw", function(module, exports) {

let $e795bc2adb13ae13$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e795bc2adb13ae13$var$load("8JZKd").then(()=>parcelRequire('5RvEg'));

});

parcelRegister("6e2Bk", function(module, exports) {

let $4886116d7ec36494$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4886116d7ec36494$var$load("8JZKd").then(()=>parcelRequire('5NBJG'));

});

parcelRegister("f88Ac", function(module, exports) {

let $b03e42bd4ccfdc16$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b03e42bd4ccfdc16$var$load("8JZKd").then(()=>parcelRequire('cPXGO'));

});

parcelRegister("4yCwN", function(module, exports) {

let $35183943ce1eb9ce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $35183943ce1eb9ce$var$load("8JZKd").then(()=>parcelRequire('eCzgA'));

});

parcelRegister("19Gs0", function(module, exports) {

let $0d778f8befc0dab7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d778f8befc0dab7$var$load("8JZKd").then(()=>parcelRequire('b0kd3'));

});

parcelRegister("YtPOn", function(module, exports) {

let $0b5cbf41523789ab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0b5cbf41523789ab$var$load("8JZKd").then(()=>parcelRequire('hycEC'));

});

parcelRegister("cpuWo", function(module, exports) {

let $908fd2035b81925c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $908fd2035b81925c$var$load("8JZKd").then(()=>parcelRequire('duwZb'));

});

parcelRegister("jNCHZ", function(module, exports) {

let $e6a09ea201f0f078$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e6a09ea201f0f078$var$load("8JZKd").then(()=>parcelRequire('8bFzt'));

});

parcelRegister("5LjxN", function(module, exports) {

let $43208095e48504c7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $43208095e48504c7$var$load("8JZKd").then(()=>parcelRequire('iRXVy'));

});

parcelRegister("2wRpI", function(module, exports) {

let $1d7800c7fa7f39c7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1d7800c7fa7f39c7$var$load("8JZKd").then(()=>parcelRequire('eszxl'));

});

parcelRegister("4nlya", function(module, exports) {

let $32fa06ce2a3469a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $32fa06ce2a3469a3$var$load("8JZKd").then(()=>parcelRequire('dmAzn'));

});

parcelRegister("khrNE", function(module, exports) {

let $ec3af5a8d38c3a6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec3af5a8d38c3a6e$var$load("8JZKd").then(()=>parcelRequire('h09kj'));

});

parcelRegister("epS2U", function(module, exports) {

let $a7ed52e26ee2e2b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7ed52e26ee2e2b5$var$load("8JZKd").then(()=>parcelRequire('fEvxc'));

});

parcelRegister("4pIdf", function(module, exports) {

let $336bcaea7fe1e7c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $336bcaea7fe1e7c3$var$load("8JZKd").then(()=>parcelRequire('aHroS'));

});

parcelRegister("lYCLL", function(module, exports) {

let $fffd46591a26fd38$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fffd46591a26fd38$var$load("8JZKd").then(()=>parcelRequire('53aPg'));

});

parcelRegister("4xFp0", function(module, exports) {

let $34ea5c216fe911b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $34ea5c216fe911b4$var$load("8JZKd").then(()=>parcelRequire('fXTeH'));

});

parcelRegister("9akcO", function(module, exports) {

let $6ac4b8a1dfb2a18f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6ac4b8a1dfb2a18f$var$load("8JZKd").then(()=>parcelRequire('kLgX2'));

});

parcelRegister("ibF6V", function(module, exports) {

let $d3d924ceeb36ca93$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d3d924ceeb36ca93$var$load("8JZKd").then(()=>parcelRequire('fe39K'));

});

parcelRegister("2qLto", function(module, exports) {

let $1c52d5a02d954af2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c52d5a02d954af2$var$load("8JZKd").then(()=>parcelRequire('5u94T'));

});

parcelRegister("8c8xN", function(module, exports) {

let $5f7612609ca6518f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5f7612609ca6518f$var$load("8JZKd").then(()=>parcelRequire('kYJU9'));

});

parcelRegister("9T5Ga", function(module, exports) {

let $732da7dd4bff8e03$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $732da7dd4bff8e03$var$load("8JZKd").then(()=>parcelRequire('4CMZN'));

});

parcelRegister("7A2yi", function(module, exports) {

let $584de003e371969a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $584de003e371969a$var$load("8JZKd").then(()=>parcelRequire('28sfx'));

});

parcelRegister("9nYlG", function(module, exports) {

let $6d551305810b02eb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d551305810b02eb$var$load("8JZKd").then(()=>parcelRequire('8z6iG'));

});

parcelRegister("kP3Ak", function(module, exports) {

let $f28b59fae8ae7fc8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f28b59fae8ae7fc8$var$load("8JZKd").then(()=>parcelRequire('bfvre'));

});

parcelRegister("69CG1", function(module, exports) {

let $47b195c25c51b55c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $47b195c25c51b55c$var$load("8JZKd").then(()=>parcelRequire('a73CT'));

});

parcelRegister("8C8i1", function(module, exports) {

let $64584d8095841e4b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $64584d8095841e4b$var$load("8JZKd").then(()=>parcelRequire('8g9bp'));

});

parcelRegister("8pv0y", function(module, exports) {

let $61f8b613a88f410a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $61f8b613a88f410a$var$load("8JZKd").then(()=>parcelRequire('1J0Iy'));

});

parcelRegister("2FLeD", function(module, exports) {

let $1f240cfe5dde2fbe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1f240cfe5dde2fbe$var$load("8JZKd").then(()=>parcelRequire('3x0ud'));

});

parcelRegister("jGAhZ", function(module, exports) {

let $e54e16d234075e2b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e54e16d234075e2b$var$load("8JZKd").then(()=>parcelRequire('hdhNx'));

});

parcelRegister("78mD0", function(module, exports) {

let $531ad5370ae154a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $531ad5370ae154a7$var$load("8JZKd").then(()=>parcelRequire('kLlX5'));

});

parcelRegister("4wQ7A", function(module, exports) {

let $34c294d28dc1c990$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $34c294d28dc1c990$var$load("8JZKd").then(()=>parcelRequire('im18V'));

});

parcelRegister("dfqU4", function(module, exports) {

let $9a518b880b19586e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9a518b880b19586e$var$load("8JZKd").then(()=>parcelRequire('1V9Sw'));

});

parcelRegister("eCuOW", function(module, exports) {

let $aa4c85a12f23d0bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa4c85a12f23d0bf$var$load("8JZKd").then(()=>parcelRequire('95zUF'));

});

parcelRegister("kXBau", function(module, exports) {

let $f4262627a51bf2b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f4262627a51bf2b0$var$load("8JZKd").then(()=>parcelRequire('apyf6'));

});

parcelRegister("4g2LT", function(module, exports) {

let $319ace66ba6d4315$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $319ace66ba6d4315$var$load("8JZKd").then(()=>parcelRequire('7KUlu'));

});

parcelRegister("iw61s", function(module, exports) {

let $d7afe31dc9e7a24c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d7afe31dc9e7a24c$var$load("8JZKd").then(()=>parcelRequire('lAkuy'));

});

parcelRegister("epXVg", function(module, exports) {

let $a7f1e1e0431a7182$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7f1e1e0431a7182$var$load("8JZKd").then(()=>parcelRequire('gfxP2'));

});

parcelRegister("l2K9z", function(module, exports) {

let $f51d95f55a85b4f9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f51d95f55a85b4f9$var$load("8JZKd").then(()=>parcelRequire('2azQc'));

});

parcelRegister("av9CY", function(module, exports) {

let $7a5444767c15f6dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7a5444767c15f6dd$var$load("8JZKd").then(()=>parcelRequire('if0JX'));

});

parcelRegister("fw4FO", function(module, exports) {

let $b4bd78316527a114$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b4bd78316527a114$var$load("8JZKd").then(()=>parcelRequire('aE3qX'));

});

parcelRegister("hY1Sf", function(module, exports) {

let $d1497e6341ce65c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d1497e6341ce65c5$var$load("8JZKd").then(()=>parcelRequire('cnE20'));

});

parcelRegister("eqf57", function(module, exports) {

let $a7ff3145e4d92aca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7ff3145e4d92aca$var$load("8JZKd").then(()=>parcelRequire('jSqTP'));

});

parcelRegister("kZddz", function(module, exports) {

let $f473c1f423b1f164$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f473c1f423b1f164$var$load("8JZKd").then(()=>parcelRequire('hNHih'));

});

parcelRegister("i2Pmz", function(module, exports) {

let $d2304186a8ad3c68$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d2304186a8ad3c68$var$load("8JZKd").then(()=>parcelRequire('bFn0v'));

});

parcelRegister("27sKA", function(module, exports) {

let $18b28976426cc96c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $18b28976426cc96c$var$load("8JZKd").then(()=>parcelRequire('ijw8O'));

});

parcelRegister("aiNXK", function(module, exports) {

let $7802575ac593d0b9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7802575ac593d0b9$var$load("8JZKd").then(()=>parcelRequire('cZ3Is'));

});

parcelRegister("2oPij", function(module, exports) {

let $1bf59cacb01c74ab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1bf59cacb01c74ab$var$load("8JZKd").then(()=>parcelRequire('8gVta'));

});

parcelRegister("PF89G", function(module, exports) {

let $09b4ab33d59a0df9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $09b4ab33d59a0df9$var$load("8JZKd").then(()=>parcelRequire('3MgcY'));

});

parcelRegister("2XqY1", function(module, exports) {

let $2276028c87d5b040$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2276028c87d5b040$var$load("8JZKd").then(()=>parcelRequire('lbx4H'));

});

parcelRegister("f7f30", function(module, exports) {

let $b0132e8eecbbe01b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b0132e8eecbbe01b$var$load("8JZKd").then(()=>parcelRequire('dHx1n'));

});

parcelRegister("9LJJJ", function(module, exports) {

let $71cbfb317c32a666$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $71cbfb317c32a666$var$load("8JZKd").then(()=>parcelRequire('8eWoD'));

});

parcelRegister("hWFXV", function(module, exports) {

let $d10867ed3b80d5d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d10867ed3b80d5d2$var$load("8JZKd").then(()=>parcelRequire('g5Ogf'));

});

parcelRegister("lkwxc", function(module, exports) {

let $f874b3e963b9328e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f874b3e963b9328e$var$load("8JZKd").then(()=>parcelRequire('5Xi9J'));

});

parcelRegister("g0b0z", function(module, exports) {

let $ba652f6bf77c4eef$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ba652f6bf77c4eef$var$load("8JZKd").then(()=>parcelRequire('j6o0p'));

});

parcelRegister("6e7Vd", function(module, exports) {

let $488a31fb16ea3560$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $488a31fb16ea3560$var$load("8JZKd").then(()=>parcelRequire('5I6Jc'));

});

parcelRegister("28wrY", function(module, exports) {

let $18e58009b073e5a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $18e58009b073e5a3$var$load("8JZKd").then(()=>parcelRequire('a6Kaz'));

});

parcelRegister("h5Y78", function(module, exports) {

let $c72188b3308705ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c72188b3308705ec$var$load("8JZKd").then(()=>parcelRequire('emmAW'));

});

parcelRegister("dNhZD", function(module, exports) {

let $a0adcf081bd94e45$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a0adcf081bd94e45$var$load("hhss7"),
    $a0adcf081bd94e45$var$load("2BKk9")
]).then(()=>parcelRequire('aDVvJ'));

});

parcelRegister("iqGOe", function(module, exports) {

let $d6abdcb2a0aeeaf9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d6abdcb2a0aeeaf9$var$load("bnZwG").then(()=>parcelRequire('oZKrL'));

});

parcelRegister("43ZQt", function(module, exports) {

let $2f576a6a70f65000$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2f576a6a70f65000$var$load("fhI6j").then(()=>parcelRequire('a58PP'));

});

parcelRegister("icwLg", function(module, exports) {

let $d402c2aef584e6bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d402c2aef584e6bc$var$load("4kAUE").then(()=>parcelRequire('1JGUg'));

});

parcelRegister("cTiNr", function(module, exports) {

let $962933ad83a0334f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $962933ad83a0334f$var$load("hvGeE"),
    $962933ad83a0334f$var$load("jHT17")
]).then(()=>parcelRequire('8ctJl'));

});

parcelRegister("9FlsF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hXuPC = parcelRequire("hXuPC");


$hXuPC.__exportStar((parcelRequire("3kxyJ")), module.exports);

$hXuPC.__exportStar((parcelRequire("3HJQU")), module.exports);

});

parcelRegister("3kxyJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CSPInjectionService = module.exports.EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS = module.exports.getAtlassianImageHost = void 0;

var $87m1m = parcelRequire("87m1m");

const $26cd45857053dc7c$var$isICEnvKey = (env)=>env === 'ic-prod' || env === 'ic-stg';
const $26cd45857053dc7c$var$makeICDomain = (env, icLabel)=>`${icLabel}.${env === 'ic-prod' ? 'atlassian-isolated.net' : 'oasis-stg.com'}`;
const $26cd45857053dc7c$var$getICDomain = (env, icOptions)=>{
    if ('getICDomain' in icOptions) return icOptions.getICDomain();
    return $26cd45857053dc7c$var$makeICDomain(env, icOptions.icLabel);
};
const $26cd45857053dc7c$var$makeICHosts = (targetHostFunction)=>{
    return {
        'ic-stg': (icOptions)=>targetHostFunction('ic-stg', icOptions),
        'ic-prod': (icOptions)=>targetHostFunction('ic-prod', icOptions)
    };
};
const $26cd45857053dc7c$var$ATLASSIAN_HOST = {
    ATLASSIAN_API_GATEWAY_HOST: {
        dev: 'https://api.dev.atlassian.com',
        stg: 'https://api.stg.atlassian.com',
        prod: 'https://api.atlassian.com',
        'fedramp-stg': 'https://api.stg.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://api.atlassian-us-gov-mod.com',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>`https://api.${$26cd45857053dc7c$var$getICDomain(env, icOptions)}`)
    },
    ATLASSIAN_MEDIA_GATEWAY_HOST: {
        dev: 'https://media.dev.atl-paas.net',
        stg: 'https://media.staging.atl-paas.net',
        prod: 'https://api.media.atlassian.com',
        'fedramp-stg': 'https://api-media.stg.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://api-media.atlassian-us-gov-mod.com',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>`https://media-api.${$26cd45857053dc7c$var$getICDomain(env, icOptions)}`)
    },
    ATLASSIAN_AVATAR_HOST: {
        dev: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
        stg: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
        prod: 'avatar-management--avatars.us-west-2.prod.public.atl-paas.net',
        'fedramp-stg': 'avatar-management--avatars.us-east-1.staging.cdn.atlassian-us-gov-mod.com',
        'fedramp-prod': 'avatar-management--avatars.us-east-1.prod.cdn.atlassian-us-gov-mod.com',
        'ic-stg': (_icOptions)=>'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
        'ic-prod': (_icOptions)=>'avatar-management--avatars.us-west-2.prod.public.atl-paas.net'
    },
    ATLASSIAN_TEAM_HEADER_HOST: {
        dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/gradients/',
        stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/gradients/',
        prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/gradients/',
        'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
        'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>`https://teams-directory-frontend.services.${$26cd45857053dc7c$var$getICDomain(env, icOptions)}/bfa/`)
    },
    ATLASSIAN_TEAM_AVATAR_HOST: {
        dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
        stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
        prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/',
        'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
        'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>`https://teams-directory-frontend.services.${$26cd45857053dc7c$var$getICDomain(env, icOptions)}/bfa/`)
    },
    ATLASSIAN_EMOJIS_HOST: {
        dev: 'https://pf-emoji-service--cdn.ap-southeast-2.dev.public.atl-paas.net',
        stg: 'https://pf-emoji-service--cdn.us-east-1.staging.public.atl-paas.net',
        prod: 'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net',
        'fedramp-stg': 'https://pf-emoji-service--cdn.us-east-1.staging.cdn.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://pf-emoji-service--cdn.us-east-1.prod.cdn.atlassian-us-gov-mod.com',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>`https://pf-emoji-service.${$26cd45857053dc7c$var$getICDomain(env, icOptions)}`)
    },
    ATLASSIAN_FOP_GE_HOST: {
        dev: 'https://forge-outbound-proxy.dev.services.atlassian.com',
        stg: 'https://forge-outbound-proxy.stg.services.atlassian.com',
        prod: 'https://forge-outbound-proxy.services.atlassian.com',
        'fedramp-stg': '',
        'fedramp-prod': '',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>'')
    },
    ATLASSIAN_FOS_HOST: {
        dev: 'https://tdp-os.dev.services.atlassian.com',
        stg: 'https://tdp-os.stg.services.atlassian.com',
        prod: 'https://tdp-os.services.atlassian.com',
        'fedramp-stg': 'https://tdp-os.stg.services.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://tdp-os.services.atlassian-us-gov-mod.com',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>`https://tdp-os.services.${$26cd45857053dc7c$var$getICDomain(env, icOptions)}`)
    }
};
const $26cd45857053dc7c$var$getAtlassianHost = (hostType, microsEnv, icOptions)=>{
    const hostMap = $26cd45857053dc7c$var$ATLASSIAN_HOST[hostType];
    if ($26cd45857053dc7c$var$isICEnvKey(microsEnv)) {
        if (!icOptions) throw new Error('Missing IC label');
        return hostMap[microsEnv](icOptions);
    }
    return hostMap[microsEnv];
};
const $26cd45857053dc7c$var$getFOSHostDownload = (microsEnv, icOptions)=>{
    const fosHost = $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_FOS_HOST', microsEnv, icOptions);
    return $26cd45857053dc7c$var$isICEnvKey(microsEnv) ? [
        `${fosHost}/fos/app/download/`,
        `${fosHost}/fos/cdn/download/`
    ] : [
        `${fosHost}/fos-eap/download/`,
        `${fosHost}/fos/app/download/`,
        `${fosHost}/fos/cdn/download/`
    ];
};
const $26cd45857053dc7c$var$getFOSHostUpload = (microsEnv, icOptions)=>{
    const fosHost = $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_FOS_HOST', microsEnv, icOptions);
    return $26cd45857053dc7c$var$isICEnvKey(microsEnv) ? [
        `${fosHost}/fos/app/upload/`,
        `${fosHost}/fos/cdn/upload/`
    ] : [
        `${fosHost}/fos-eap/upload/`,
        `${fosHost}/fos/app/upload/`,
        `${fosHost}/fos/cdn/upload/`
    ];
};
const $26cd45857053dc7c$var$getAtlassianImageHost = (microsEnv, icOptions)=>{
    return [
        `https://${$26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_AVATAR_HOST', microsEnv, icOptions)}`,
        `https://*.wp.com/${$26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_AVATAR_HOST', microsEnv, icOptions)}/`,
        $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_API_GATEWAY_HOST', microsEnv, icOptions),
        $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_MEDIA_GATEWAY_HOST', microsEnv, icOptions),
        $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_EMOJIS_HOST', microsEnv, icOptions),
        $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_TEAM_AVATAR_HOST', microsEnv, icOptions),
        $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_TEAM_HEADER_HOST', microsEnv, icOptions),
        ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions)
    ];
};
module.exports.getAtlassianImageHost = $26cd45857053dc7c$var$getAtlassianImageHost;
module.exports.EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS = [
    'https://secure.gravatar.com',
    'https://images.unsplash.com'
];
class $26cd45857053dc7c$var$CSPInjectionService {
    getCSPReportUri(microsEnv, icOptions) {
        const serviceName = $26cd45857053dc7c$var$isICEnvKey(microsEnv) && icOptions ? icOptions.serviceName : 'forge-cdn';
        if (microsEnv === 'dev' || microsEnv === 'stg') return `https://web-security-reports.stg.services.atlassian.com/csp-report/${serviceName}`;
        return `https://web-security-reports.services.atlassian.com/csp-report/${serviceName}`;
    }
    getForgeGlobalCSP(microsEnv, isFedRAMP = false, icOptions) {
        if ($26cd45857053dc7c$var$isICEnvKey(microsEnv) && icOptions) return `https://forge.forge-cdn.${$26cd45857053dc7c$var$getICDomain(microsEnv, icOptions)}`;
        return isFedRAMP ? `https://forge.cdn.${microsEnv.split('-')[1]}.atlassian-dev-us-gov-mod.net` : `https://forge.cdn.${microsEnv}.atlassian-dev.net`;
    }
    getMetalClientCSP(microsEnv, icOptions) {
        if ($26cd45857053dc7c$var$isICEnvKey(microsEnv) && icOptions) return `https://api.${$26cd45857053dc7c$var$getICDomain(microsEnv, icOptions)}/metal/ingest`;
        return `https://api.${microsEnv === 'prod' ? '' : 'stg.'}atlassian.com/metal/ingest`;
    }
    getExistingCSPDetails(cspType, cspDetails) {
        var _a;
        return (_a = cspDetails[cspType]) !== null && _a !== void 0 ? _a : [];
    }
    getConnectSrc(microsEnv, isTunnelling, icOptions) {
        const allowed = [];
        if (isTunnelling) allowed.push(...[
            'ws://localhost:*',
            'http://localhost:*'
        ]);
        const metalClientCSP = this.getMetalClientCSP(microsEnv, icOptions);
        allowed.push(metalClientCSP);
        allowed.push(`${$26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_API_GATEWAY_HOST', microsEnv, icOptions)}/gateway/api/emoji/`);
        allowed.push($26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_MEDIA_GATEWAY_HOST', microsEnv, icOptions));
        const fopGeHost = $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_FOP_GE_HOST', microsEnv, icOptions);
        if (fopGeHost) allowed.push(fopGeHost);
        allowed.push(...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions));
        allowed.push(...$26cd45857053dc7c$var$getFOSHostUpload(microsEnv, icOptions));
        return allowed;
    }
    getFrameAncestors(microsEnv, hostname, icOptions) {
        let frameAncestors = [];
        switch(microsEnv){
            case 'dev':
            case 'stg':
                frameAncestors = [
                    '*.jira-dev.com',
                    'http://localhost:*',
                    'http://devbucket.localhost',
                    'https://integration.bb-inf.net',
                    '*.atl-paas.net',
                    '*.stg.atlassian.com'
                ];
                break;
            case 'fedramp-stg':
                frameAncestors = [
                    '*.atlassian-stg-fedm.net'
                ];
                break;
            case 'fedramp-prod':
                frameAncestors = [
                    '*.atlassian-us-gov-mod.net'
                ];
                break;
            case 'ic-stg':
            case 'ic-prod':
                if (icOptions) frameAncestors = [
                    `*.${$26cd45857053dc7c$var$getICDomain(microsEnv, icOptions)}`
                ];
                break;
            case 'prod':
            default:
                frameAncestors = [
                    '*.atlassian.net',
                    'bitbucket.org',
                    '*.jira.com',
                    '*.atlassian.com',
                    '*.frontend.public.atl-paas.net'
                ];
                break;
        }
        if (hostname) frameAncestors.push(hostname);
        return frameAncestors;
    }
    constructor(){
        this.getInjectableCSP = ({ existingCSPDetails: existingCSPDetails, microsEnv: microsEnv, tunnelCSPReporterUri: tunnelCSPReporterUri, hostname: hostname, isFedRAMP: isFedRAMP, icOptions: icOptions })=>{
            const reportUri = tunnelCSPReporterUri || this.getCSPReportUri(microsEnv, icOptions);
            const defaultSrc = [
                "'self'",
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions)
            ].join(' ');
            const frameAncestors = [
                "'self'",
                ...this.getFrameAncestors(microsEnv, hostname, icOptions),
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions)
            ].join(' ');
            const frameSrc = [
                "'self'",
                hostname,
                $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_MEDIA_GATEWAY_HOST', microsEnv, icOptions),
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.FRAME_SRC, existingCSPDetails),
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions)
            ].filter((a)=>a).join(' ');
            const fontSrc = [
                "'self'",
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions),
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.FONT_SRC, existingCSPDetails)
            ].join(' ');
            const imgSrc = [
                "'self'",
                'data:',
                'blob:',
                hostname,
                ...module.exports.EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS,
                ...(0, module.exports.getAtlassianImageHost)(microsEnv, icOptions),
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.IMG_SRC, existingCSPDetails)
            ].filter((a)=>a).join(' ');
            const mediaSrc = [
                "'self'",
                'data:',
                'blob:',
                hostname,
                $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_MEDIA_GATEWAY_HOST', microsEnv, icOptions),
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.MEDIA_SRC, existingCSPDetails),
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions)
            ].filter((a)=>a).join(' ');
            const connectSrc = [
                "'self'",
                ...this.getConnectSrc(microsEnv, !!tunnelCSPReporterUri, icOptions),
                this.getForgeGlobalCSP(microsEnv, isFedRAMP, icOptions),
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.CONNECT_SRC, existingCSPDetails)
            ].join(' ');
            const scriptSrc = [
                "'self'",
                this.getForgeGlobalCSP(microsEnv, isFedRAMP, icOptions),
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions),
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.SCRIPT_SRC, existingCSPDetails)
            ].join(' ');
            const styleSrc = [
                "'self'",
                hostname,
                this.getForgeGlobalCSP(microsEnv, isFedRAMP, icOptions),
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions),
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.STYLE_SRC, existingCSPDetails)
            ].filter((a)=>a).join(' ');
            return [
                `default-src ${defaultSrc}`,
                `frame-ancestors ${frameAncestors}`,
                `frame-src ${frameSrc}`,
                `font-src ${fontSrc}`,
                `img-src ${imgSrc}`,
                `media-src ${mediaSrc}`,
                `connect-src ${connectSrc}`,
                `script-src ${scriptSrc}`,
                `style-src ${styleSrc}`,
                `form-action 'self'`,
                `sandbox allow-popups allow-popups-to-escape-sandbox allow-downloads allow-forms allow-modals allow-pointer-lock allow-same-origin allow-scripts`,
                `report-uri ${reportUri}`
            ];
        };
    }
}
module.exports.CSPInjectionService = $26cd45857053dc7c$var$CSPInjectionService;

});

parcelRegister("87m1m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExternalCspType = void 0;
var $5e900f11265deb7e$var$ExternalCspType;
(function(ExternalCspType) {
    ExternalCspType["IMG_SRC"] = "img-src";
    ExternalCspType["MEDIA_SRC"] = "media-src";
    ExternalCspType["SCRIPT_SRC"] = "script-src";
    ExternalCspType["STYLE_SRC"] = "style-src";
    ExternalCspType["CONNECT_SRC"] = "connect-src";
    ExternalCspType["FONT_SRC"] = "font-src";
    ExternalCspType["FRAME_SRC"] = "frame-src";
})($5e900f11265deb7e$var$ExternalCspType = module.exports.ExternalCspType || (module.exports.ExternalCspType = {}));

});

parcelRegister("3HJQU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CSPProcessingService = module.exports.InvalidConnectSrc = void 0;

var $hXuPC = parcelRequire("hXuPC");


const $2b28f4994d3f7e47$var$content_security_policy_parser_1 = $hXuPC.__importDefault((parcelRequire("bqRJT")));

const $2b28f4994d3f7e47$var$crypto_1 = $hXuPC.__importDefault((parcelRequire("7UOIm")));
class $2b28f4994d3f7e47$var$InvalidConnectSrc extends Error {
    constructor(){
        super('fetch.client should be an array of strings');
    }
}
module.exports.InvalidConnectSrc = $2b28f4994d3f7e47$var$InvalidConnectSrc;
class $2b28f4994d3f7e47$var$CSPProcessingService {
    getCspDetails(body, permissions) {
        var _a, _b;
        const { scripts: scripts, styles: styles } = (_a = permissions === null || permissions === void 0 ? void 0 : permissions.content) !== null && _a !== void 0 ? _a : {
            scripts: [],
            styles: []
        };
        const external = (_b = permissions === null || permissions === void 0 ? void 0 : permissions.external) !== null && _b !== void 0 ? _b : {};
        const $ = this.cheerioLoader(body, {
            xml: {
                xmlMode: false
            }
        });
        const { 'script-src': scriptSrc, 'style-src': styleSrc, ...mappedExternalCsp } = this.mapExternalPermissionsToCsp(external);
        return {
            'style-src': [
                ...this.getStyleSrc($, styles),
                ...styleSrc
            ],
            'script-src': [
                ...this.getScriptSrc($, scripts),
                ...scriptSrc
            ],
            ...mappedExternalCsp
        };
    }
    getInvalidCspPermissions(contentPermissions) {
        var _a, _b;
        const { styles: styles, scripts: scripts } = contentPermissions;
        const invalidStyles = (_a = styles === null || styles === void 0 ? void 0 : styles.filter((styleSrc)=>!this.isValidUserStyleSrc(`'${styleSrc}'`))) !== null && _a !== void 0 ? _a : [];
        const invalidScripts = (_b = scripts === null || scripts === void 0 ? void 0 : scripts.filter((scriptSrc)=>!this.isValidUserScriptSrc(scriptSrc))) !== null && _b !== void 0 ? _b : [];
        return [
            ...invalidStyles,
            ...invalidScripts
        ];
    }
    assertValidFetchClient(fetch) {
        if (fetch === null || fetch === void 0 ? void 0 : fetch.client) for (const client of fetch === null || fetch === void 0 ? void 0 : fetch.client){
            if (typeof client !== 'string') throw new $2b28f4994d3f7e47$var$InvalidConnectSrc();
        }
    }
    egressesToStringMap(externalPermissions) {
        return externalPermissions === null || externalPermissions === void 0 ? void 0 : externalPermissions.map((egress)=>typeof egress === 'object' ? egress.address : egress);
    }
    mapExternalPermissionsToCsp(externalPermissions) {
        var _a, _b, _c, _d, _e, _f, _g;
        const { images: images, media: media, scripts: scripts, fetch: fetch, styles: styles, fonts: fonts, frames: frames } = externalPermissions;
        this.assertValidFetchClient(fetch);
        return {
            'img-src': (_a = this.egressesToStringMap(images)) !== null && _a !== void 0 ? _a : [],
            'media-src': (_b = this.egressesToStringMap(media)) !== null && _b !== void 0 ? _b : [],
            'script-src': (_c = this.egressesToStringMap(scripts)) !== null && _c !== void 0 ? _c : [],
            'style-src': (_d = this.egressesToStringMap(styles)) !== null && _d !== void 0 ? _d : [],
            'connect-src': (_e = fetch === null || fetch === void 0 ? void 0 : fetch.client) !== null && _e !== void 0 ? _e : [],
            'font-src': (_f = this.egressesToStringMap(fonts)) !== null && _f !== void 0 ? _f : [],
            'frame-src': (_g = this.egressesToStringMap(frames)) !== null && _g !== void 0 ? _g : []
        };
    }
    getStyleSrc($, userStyleSrc) {
        var _a, _b;
        const quotedUserStyleSrc = (_a = userStyleSrc === null || userStyleSrc === void 0 ? void 0 : userStyleSrc.map((x)=>`'${x}'`)) !== null && _a !== void 0 ? _a : [];
        const deprecatedUserStyleSrc = (_b = this.getDeprecatedUserCsp($)['style-src']) !== null && _b !== void 0 ? _b : [];
        const uniqueStyleSrc = [
            ...new Set([
                ...deprecatedUserStyleSrc,
                ...quotedUserStyleSrc
            ])
        ];
        return uniqueStyleSrc.filter((x)=>this.isValidUserStyleSrc(x));
    }
    getScriptSrc($, userScriptSrc) {
        var _a;
        const validUserScriptSrc = (_a = userScriptSrc === null || userScriptSrc === void 0 ? void 0 : userScriptSrc.filter((x)=>this.isValidUserScriptSrc(x))) !== null && _a !== void 0 ? _a : [];
        const generatedScriptHashes = validUserScriptSrc.includes('unsafe-inline') ? [] : this.getInlineScriptHashes($);
        const { scriptSrc: scriptSrc, userScriptHashes: userScriptHashes } = this.extractUniqueHashes(validUserScriptSrc, generatedScriptHashes);
        return [
            ...scriptSrc,
            ...generatedScriptHashes,
            ...userScriptHashes
        ].map((x)=>this.formatScriptSrc(x));
    }
    extractUniqueHashes(userScriptSrc, existingScriptHashes) {
        var _a;
        const userScriptHashes = [];
        const scriptSrc = (_a = userScriptSrc === null || userScriptSrc === void 0 ? void 0 : userScriptSrc.filter((scriptSrc)=>{
            const isValidHash = this.isValidHash(scriptSrc);
            if (isValidHash && !existingScriptHashes.includes(scriptSrc)) userScriptHashes.push(scriptSrc);
            return !isValidHash;
        })) !== null && _a !== void 0 ? _a : [];
        return {
            scriptSrc: scriptSrc,
            userScriptHashes: userScriptHashes
        };
    }
    getInlineScriptHashes($) {
        return $('script:not([src])').map((_index, script)=>{
            const html = $(script).html();
            return html && `sha256-${this.hashScript(html)}`;
        }).get();
    }
    hashScript(content) {
        const sha256 = $2b28f4994d3f7e47$var$crypto_1.default.createHash('sha256');
        return sha256.update(content).digest('base64');
    }
    formatScriptSrc(scriptSrc) {
        if (this.UNQUOTED_SCRIPT_SRC_ALLOWLIST.includes(scriptSrc)) return scriptSrc;
        return `'${scriptSrc}'`;
    }
    isValidUserScriptSrc(scriptSrc) {
        if (!this.isSafeCsp(scriptSrc)) return false;
        return this.isValidHash(scriptSrc) || this.SCRIPT_SRC_ALLOWLIST.includes(scriptSrc);
    }
    isValidUserStyleSrc(styleSrc) {
        if (!this.isSafeCsp(styleSrc)) {
            this.logger.info('discarding potentially-malicious CSP');
            return false;
        }
        return this.STYLE_SRC_ALLOWLIST.includes(styleSrc);
    }
    isSafeCsp(cspString) {
        return /^([a-zA-Z0-9='"+\/ -]|blob:)*$/.test(cspString);
    }
    isValidHash(cspString) {
        return this.BASE_64_HASH_PATTERNS.some((pattern)=>pattern.test(cspString));
    }
    getDeprecatedUserCsp($) {
        const cspContent = $('meta[http-equiv="Content-Security-Policy"]').attr('content');
        if (!cspContent) return {};
        if (!this.isSafeCsp(cspContent)) {
            this.logger.info('discarding potentially-malicious CSP');
            return {};
        }
        return (0, $2b28f4994d3f7e47$var$content_security_policy_parser_1.default)(cspContent);
    }
    constructor(logger, cheerioLoader){
        this.logger = logger;
        this.cheerioLoader = cheerioLoader;
        this.STYLE_SRC_ALLOWLIST = [
            `'unsafe-inline'`
        ];
        this.QUOTED_SCRIPT_SRC_ALLOWLIST = [
            'unsafe-inline',
            'unsafe-eval',
            'unsafe-hashes'
        ];
        this.UNQUOTED_SCRIPT_SRC_ALLOWLIST = [
            'blob:'
        ];
        this.SCRIPT_SRC_ALLOWLIST = [
            ...this.QUOTED_SCRIPT_SRC_ALLOWLIST,
            ...this.UNQUOTED_SCRIPT_SRC_ALLOWLIST
        ];
        this.BASE_64_HASH_PATTERNS = [
            /^sha256-[a-zA-Z0-9=+/]{44}$/,
            /^sha384-[a-zA-Z0-9=+/]{64}$/,
            /^sha512-[a-zA-Z0-9=+/]{88}$/
        ];
    }
}
module.exports.CSPProcessingService = $2b28f4994d3f7e47$var$CSPProcessingService;

});

parcelRegister("bqRJT", function(module, exports) {
"use strict";
module.exports = (policy)=>{
    const result = {};
    policy.split(";").forEach((directive)=>{
        const [directiveKey, ...directiveValue] = directive.trim().split(/\s+/g);
        if (directiveKey && !Object.prototype.hasOwnProperty.call(result, directiveKey)) {
            if (directiveKey === "__proto__") Object.defineProperty(result, directiveKey, {
                configurable: true,
                enumerable: true,
                writable: true,
                value: directiveValue
            });
            else result[directiveKey] = directiveValue;
        }
    });
    return result;
};

});

parcelRegister("7EIk4", function(module, exports) {

let $592ea6683012081e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $592ea6683012081e$var$load("iOQWp").then(()=>parcelRequire('liy3y'));

});

parcelRegister("g4pg0", function(module, exports) {

let $bb309c98da1b0d64$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bb309c98da1b0d64$var$load("hhss7"),
    $bb309c98da1b0d64$var$load("2BKk9")
]).then(()=>parcelRequire('9IQWX'));

});

parcelRegister("7gfRx", function(module, exports) {

let $549654fe5723e5ff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $549654fe5723e5ff$var$load("69F1b").then(()=>parcelRequire('2QizT'));

});

parcelRegister("cQBlt", function(module, exports) {

let $95a74f5aa5ce6ced$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $95a74f5aa5ce6ced$var$load("1su9U").then(()=>parcelRequire('aIk0I'));

});

parcelRegister("lebYT", function(module, exports) {

let $f74432f98faf8f64$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f74432f98faf8f64$var$load("fLGVd").then(()=>parcelRequire('3fhoV'));

});

parcelRegister("fwIdy", function(module, exports) {

let $b4dc24de5a69ac7f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b4dc24de5a69ac7f$var$load("b2tMY").then(()=>parcelRequire('cUOL6'));

});

parcelRegister("ho0fc", function(module, exports) {

let $ca84de04ed1672ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ca84de04ed1672ae$var$load("Wowvf"),
    $ca84de04ed1672ae$var$load("6Ue6S")
]).then(()=>parcelRequire('A6kZA'));

});

parcelRegister("2wzBN", function(module, exports) {

let $1d6a310d0fdfb3df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1d6a310d0fdfb3df$var$load("hBcQv").then(()=>parcelRequire('kDUfG'));

});

parcelRegister("8GA7i", function(module, exports) {

let $652e42f9478d0fe8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $652e42f9478d0fe8$var$load("32YGB").then(()=>parcelRequire('jQy0H'));

});

parcelRegister("7DC2K", function(module, exports) {

let $58f9af8ee6104809$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $58f9af8ee6104809$var$load("1zUjn").then(()=>parcelRequire('7ycLr'));

});

parcelRegister("j5Cmc", function(module, exports) {

let $de5c3cdc1d8622df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de5c3cdc1d8622df$var$load("iXv73").then(()=>parcelRequire('ju5RD'));

});

parcelRegister("dWRcP", function(module, exports) {

let $a279f6b565ca3fab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a279f6b565ca3fab$var$load("764nc").then(()=>parcelRequire('SMbnh'));

});

parcelRegister("lqx7l", function(module, exports) {

let $f995b724b8136dca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f995b724b8136dca$var$load("8JZKd"),
    $f995b724b8136dca$var$load("lRtGG"),
    $f995b724b8136dca$var$load("2UhBp")
]).then(()=>parcelRequire('lk4NH'));

});

parcelRegister("2PjjQ", function(module, exports) {

let $20ef5491adab65e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $20ef5491adab65e9$var$load("8JZKd"),
    $20ef5491adab65e9$var$load("jYlpr")
]).then(()=>parcelRequire('1czi3'));

});

parcelRegister("lOJWX", function(module, exports) {

let $fe21e93413f0e1f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fe21e93413f0e1f8$var$load("8JZKd"),
    $fe21e93413f0e1f8$var$load("bJFAm")
]).then(()=>parcelRequire('l1ZVR'));

});

parcelRegister("hC0lJ", function(module, exports) {

let $cd2641ad873e0169$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cd2641ad873e0169$var$load("8JZKd"),
    $cd2641ad873e0169$var$load("6LbZE")
]).then(()=>parcelRequire('imvZl'));

});

parcelRegister("hJDkv", function(module, exports) {

let $ce9525ba7ad34d59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ce9525ba7ad34d59$var$load("8JZKd"),
    $ce9525ba7ad34d59$var$load("6wr18"),
    $ce9525ba7ad34d59$var$load("ffEVr"),
    $ce9525ba7ad34d59$var$load("7OMSL")
]).then(()=>parcelRequire('h5EpV'));

});

parcelRegister("cjzh6", function(module, exports) {

let $8f729f35fe2a22c4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8f729f35fe2a22c4$var$load("8JZKd"),
    $8f729f35fe2a22c4$var$load("6wr18"),
    $8f729f35fe2a22c4$var$load("ffEVr"),
    $8f729f35fe2a22c4$var$load("laRLn")
]).then(()=>parcelRequire('fzPWw'));

});

parcelRegister("3TSrz", function(module, exports) {

let $2d70bd8c2612de21$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2d70bd8c2612de21$var$load("8JZKd"),
    $2d70bd8c2612de21$var$load("6wr18"),
    $2d70bd8c2612de21$var$load("ffEVr"),
    $2d70bd8c2612de21$var$load("3Ltfd")
]).then(()=>parcelRequire('7dWlC'));

});

parcelRegister("aq2mx", function(module, exports) {

let $795e2a3bebaf1386$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $795e2a3bebaf1386$var$load("8JZKd"),
    $795e2a3bebaf1386$var$load("4rKYa"),
    $795e2a3bebaf1386$var$load("aVAYO")
]).then(()=>parcelRequire('3Z9Vg'));

});

parcelRegister("c0RM1", function(module, exports) {

let $8bef3268adab3b3b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8bef3268adab3b3b$var$load("8JZKd"),
    $8bef3268adab3b3b$var$load("fzHDF"),
    $8bef3268adab3b3b$var$load("ao3hz")
]).then(()=>parcelRequire('2nrfl'));

});

parcelRegister("i5UJ2", function(module, exports) {

let $d2c4b2199eff8556$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d2c4b2199eff8556$var$load("8JZKd"),
    $d2c4b2199eff8556$var$load("2vwGI")
]).then(()=>parcelRequire('gUl5c'));

});

parcelRegister("ay0uJ", function(module, exports) {

let $7add7699cd8bfa29$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7add7699cd8bfa29$var$load("8JZKd"),
    $7add7699cd8bfa29$var$load("6wr18"),
    $7add7699cd8bfa29$var$load("ffEVr"),
    $7add7699cd8bfa29$var$load("7g0Fh")
]).then(()=>parcelRequire('hGBO1'));

});

parcelRegister("6286k", function(module, exports) {

let $464936ac67547913$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $464936ac67547913$var$load("8JZKd"),
    $464936ac67547913$var$load("6wr18"),
    $464936ac67547913$var$load("ffEVr"),
    $464936ac67547913$var$load("igu8p")
]).then(()=>parcelRequire('9Fedt'));

});

parcelRegister("P0T7b", function(module, exports) {

let $099573dd0a407366$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $099573dd0a407366$var$load("8JZKd"),
    $099573dd0a407366$var$load("abjVx")
]).then(()=>parcelRequire('gnDWx'));

});

parcelRegister("aeOb8", function(module, exports) {

let $7742229f6f599faa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7742229f6f599faa$var$load("8JZKd"),
    $7742229f6f599faa$var$load("dFB8r")
]).then(()=>parcelRequire('35HFk'));

});

parcelRegister("jAMGl", function(module, exports) {

let $e4372452df9d7ee6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e4372452df9d7ee6$var$load("8JZKd"),
    $e4372452df9d7ee6$var$load("e2ujj"),
    $e4372452df9d7ee6$var$load("arXBs")
]).then(()=>parcelRequire('kIwZQ'));

});

parcelRegister("c5mtI", function(module, exports) {

let $8cc76361da7e2dbb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8cc76361da7e2dbb$var$load("8JZKd"),
    $8cc76361da7e2dbb$var$load("6wr18"),
    $8cc76361da7e2dbb$var$load("ffEVr"),
    $8cc76361da7e2dbb$var$load("cIdhz")
]).then(()=>parcelRequire('5fItb'));

});

parcelRegister("bFkX8", function(module, exports) {

let $87e3c6d2a9470abd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $87e3c6d2a9470abd$var$load("8JZKd"),
    $87e3c6d2a9470abd$var$load("6wr18"),
    $87e3c6d2a9470abd$var$load("ffEVr"),
    $87e3c6d2a9470abd$var$load("iZtWv")
]).then(()=>parcelRequire('8aLHI'));

});

parcelRegister("fBD4z", function(module, exports) {

let $b5c89ebe88f0ddbd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b5c89ebe88f0ddbd$var$load("8JZKd"),
    $b5c89ebe88f0ddbd$var$load("6wr18"),
    $b5c89ebe88f0ddbd$var$load("ffEVr"),
    $b5c89ebe88f0ddbd$var$load("6UUcD")
]).then(()=>parcelRequire('juFuY'));

});

parcelRegister("kWWMp", function(module, exports) {

let $f406d1dba81c5d67$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f406d1dba81c5d67$var$load("8JZKd"),
    $f406d1dba81c5d67$var$load("6GprY")
]).then(()=>parcelRequire('48rbd'));

});

parcelRegister("bq5o8", function(module, exports) {

let $85064d6dc884cc1f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $85064d6dc884cc1f$var$load("8JZKd"),
    $85064d6dc884cc1f$var$load("124I9"),
    $85064d6dc884cc1f$var$load("95ven")
]).then(()=>parcelRequire('l0J6Z'));

});

parcelRegister("4GWjn", function(module, exports) {

let $36a8511c422fa89f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $36a8511c422fa89f$var$load("8JZKd"),
    $36a8511c422fa89f$var$load("iJubl")
]).then(()=>parcelRequire('6iKDu'));

});

parcelRegister("6Vy1g", function(module, exports) {

let $50b2747e8db50ed5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $50b2747e8db50ed5$var$load("8JZKd"),
    $50b2747e8db50ed5$var$load("eEyVs"),
    $50b2747e8db50ed5$var$load("4Gn8k")
]).then(()=>parcelRequire('bwILF'));

});

parcelRegister("31Jgm", function(module, exports) {

let $23449355a1189c35$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $23449355a1189c35$var$load("8JZKd"),
    $23449355a1189c35$var$load("2Ah6F")
]).then(()=>parcelRequire('frUrQ'));

});

parcelRegister("1SfIv", function(module, exports) {

let $15d7069ba5cd5c8f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $15d7069ba5cd5c8f$var$load("8JZKd"),
    $15d7069ba5cd5c8f$var$load("hVZx8")
]).then(()=>parcelRequire('fezgF'));

});

parcelRegister("c87ww", function(module, exports) {

let $8d4c1162c62791a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8d4c1162c62791a4$var$load("8JZKd"),
    $8d4c1162c62791a4$var$load("1MRWu")
]).then(()=>parcelRequire('kcWkD'));

});

parcelRegister("vu9RG", function(module, exports) {

let $05ea4a234a51a67a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $05ea4a234a51a67a$var$load("8JZKd"),
    $05ea4a234a51a67a$var$load("6wr18"),
    $05ea4a234a51a67a$var$load("ffEVr"),
    $05ea4a234a51a67a$var$load("bejYa")
]).then(()=>parcelRequire('2h5ZX'));

});

parcelRegister("clYtu", function(module, exports) {

let $8fe65b3b1c26f8e8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8fe65b3b1c26f8e8$var$load("8JZKd"),
    $8fe65b3b1c26f8e8$var$load("iMCRX")
]).then(()=>parcelRequire('8Y8Qi'));

});

parcelRegister("46xgu", function(module, exports) {

let $2fd186b3bd98256c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2fd186b3bd98256c$var$load("8JZKd"),
    $2fd186b3bd98256c$var$load("6wr18"),
    $2fd186b3bd98256c$var$load("ffEVr"),
    $2fd186b3bd98256c$var$load("bP7LP")
]).then(()=>parcelRequire('6Ecy6'));

});

parcelRegister("ip99L", function(module, exports) {

let $d661aa13ecbcf0ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d661aa13ecbcf0ec$var$load("8JZKd"),
    $d661aa13ecbcf0ec$var$load("4VmDs")
]).then(()=>parcelRequire('jzhw9'));

});

parcelRegister("d0YYY", function(module, exports) {

let $979a9449a668ad74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $979a9449a668ad74$var$load("8JZKd"),
    $979a9449a668ad74$var$load("7kGWT")
]).then(()=>parcelRequire('lfUze'));

});

parcelRegister("jTigW", function(module, exports) {

let $e7b153dc9be61ccc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e7b153dc9be61ccc$var$load("8JZKd"),
    $e7b153dc9be61ccc$var$load("dBGOH")
]).then(()=>parcelRequire('lh5eH'));

});

parcelRegister("iaczh", function(module, exports) {

let $d392e8e76f8800dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d392e8e76f8800dc$var$load("8JZKd"),
    $d392e8e76f8800dc$var$load("3wVig")
]).then(()=>parcelRequire('fdCEb'));

});

parcelRegister("CM6h0", function(module, exports) {

let $0748dc6b38a21692$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0748dc6b38a21692$var$load("8JZKd"),
    $0748dc6b38a21692$var$load("ln9z6")
]).then(()=>parcelRequire('kiq1W'));

});

parcelRegister("bHl3R", function(module, exports) {

let $88440c331d48794d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $88440c331d48794d$var$load("8JZKd"),
    $88440c331d48794d$var$load("7unAr")
]).then(()=>parcelRequire('dVtAn'));

});

parcelRegister("ct8nm", function(module, exports) {

let $913eb0b8da1571f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $913eb0b8da1571f1$var$load("8JZKd"),
    $913eb0b8da1571f1$var$load("hnWPW")
]).then(()=>parcelRequire('hNEaN'));

});

parcelRegister("eSjFK", function(module, exports) {

let $ad455e58be336783$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ad455e58be336783$var$load("8JZKd"),
    $ad455e58be336783$var$load("atuqa")
]).then(()=>parcelRequire('aIunP'));

});

parcelRegister("jDalq", function(module, exports) {

let $e4a9af12b48c33a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e4a9af12b48c33a8$var$load("8JZKd"),
    $e4a9af12b48c33a8$var$load("692B4")
]).then(()=>parcelRequire('bcA7r'));

});

parcelRegister("hAtvf", function(module, exports) {

let $ccdcaf279c2cc5d5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ccdcaf279c2cc5d5$var$load("8JZKd"),
    $ccdcaf279c2cc5d5$var$load("c4vbc"),
    $ccdcaf279c2cc5d5$var$load("l5eTG")
]).then(()=>parcelRequire('e6PFM'));

});

parcelRegister("13yNF", function(module, exports) {

let $0c5110d64e986fe4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0c5110d64e986fe4$var$load("8JZKd"),
    $0c5110d64e986fe4$var$load("9PQvE")
]).then(()=>parcelRequire('4rZmd'));

});

parcelRegister("4KALJ", function(module, exports) {

let $3757fad6298e81a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3757fad6298e81a2$var$load("8JZKd"),
    $3757fad6298e81a2$var$load("eeaKR"),
    $3757fad6298e81a2$var$load("6KFfh")
]).then(()=>parcelRequire('yGNI1'));

});

parcelRegister("bQnLz", function(module, exports) {

let $89f6fc85a1b86315$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $89f6fc85a1b86315$var$load("8JZKd"),
    $89f6fc85a1b86315$var$load("eeaKR"),
    $89f6fc85a1b86315$var$load("b02wj")
]).then(()=>parcelRequire('5Sq8i'));

});

parcelRegister("cFyfk", function(module, exports) {

let $9393e0f6adf9a3a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9393e0f6adf9a3a4$var$load("8JZKd"),
    $9393e0f6adf9a3a4$var$load("6wr18"),
    $9393e0f6adf9a3a4$var$load("ffEVr"),
    $9393e0f6adf9a3a4$var$load("gCrt0")
]).then(()=>parcelRequire('2qfqx'));

});

parcelRegister("btBEU", function(module, exports) {

let $85af9d676907725e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $85af9d676907725e$var$load("8JZKd"),
    $85af9d676907725e$var$load("becB8"),
    $85af9d676907725e$var$load("axWnt")
]).then(()=>parcelRequire('dLvuL'));

});

parcelRegister("8lHdT", function(module, exports) {

let $6141d01b0265cdf3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6141d01b0265cdf3$var$load("8JZKd"),
    $6141d01b0265cdf3$var$load("4Viii"),
    $6141d01b0265cdf3$var$load("aFxfI")
]).then(()=>parcelRequire('lXNAf'));

});

parcelRegister("kQPjS", function(module, exports) {

let $f2e078f96ebae904$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f2e078f96ebae904$var$load("8JZKd"),
    $f2e078f96ebae904$var$load("4Viii"),
    $f2e078f96ebae904$var$load("aS6Ln")
]).then(()=>parcelRequire('bVqSD'));

});

parcelRegister("8hkqT", function(module, exports) {

let $606fc2cb46d47ea2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $606fc2cb46d47ea2$var$load("8JZKd"),
    $606fc2cb46d47ea2$var$load("k6H7B")
]).then(()=>parcelRequire('2YaGf'));

});

parcelRegister("2lE6q", function(module, exports) {

let $1b5ca6824b74eed6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1b5ca6824b74eed6$var$load("8JZKd"),
    $1b5ca6824b74eed6$var$load("5RGlB")
]).then(()=>parcelRequire('hfeyG'));

});

parcelRegister("f6fQ1", function(module, exports) {

let $afe3b3acf439ba1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $afe3b3acf439ba1c$var$load("8JZKd"),
    $afe3b3acf439ba1c$var$load("6wr18"),
    $afe3b3acf439ba1c$var$load("ffEVr"),
    $afe3b3acf439ba1c$var$load("ftKoO")
]).then(()=>parcelRequire('nigEg'));

});

parcelRegister("8KeUv", function(module, exports) {

let $65de2f84c2b82f04$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $65de2f84c2b82f04$var$load("8JZKd"),
    $65de2f84c2b82f04$var$load("6wr18"),
    $65de2f84c2b82f04$var$load("ffEVr"),
    $65de2f84c2b82f04$var$load("aFS1j")
]).then(()=>parcelRequire('1dmTi'));

});

parcelRegister("f7rw9", function(module, exports) {

let $b01cdae19054e6de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b01cdae19054e6de$var$load("8JZKd"),
    $b01cdae19054e6de$var$load("j3OO7")
]).then(()=>parcelRequire('eCikN'));

});

parcelRegister("1wDTU", function(module, exports) {

let $11c7bb10f8a03147$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $11c7bb10f8a03147$var$load("8JZKd"),
    $11c7bb10f8a03147$var$load("5bk8V")
]).then(()=>parcelRequire('chErI'));

});

parcelRegister("d3jSp", function(module, exports) {

let $980af9406cb77182$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $980af9406cb77182$var$load("8JZKd"),
    $980af9406cb77182$var$load("6wr18"),
    $980af9406cb77182$var$load("ffEVr"),
    $980af9406cb77182$var$load("5f6xv")
]).then(()=>parcelRequire('djUMe'));

});

parcelRegister("gmYni", function(module, exports) {

let $bead88901add088d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bead88901add088d$var$load("8JZKd"),
    $bead88901add088d$var$load("6wr18"),
    $bead88901add088d$var$load("ffEVr"),
    $bead88901add088d$var$load("WNHlb")
]).then(()=>parcelRequire('ciWIJ'));

});

parcelRegister("gNqls", function(module, exports) {

let $c3a5a88baca912c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c3a5a88baca912c3$var$load("8JZKd"),
    $c3a5a88baca912c3$var$load("6wr18"),
    $c3a5a88baca912c3$var$load("ffEVr"),
    $c3a5a88baca912c3$var$load("fhMxZ")
]).then(()=>parcelRequire('aePRm'));

});

parcelRegister("dB1Nv", function(module, exports) {

let $9e601ffd62bcd94c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9e601ffd62bcd94c$var$load("8JZKd"),
    $9e601ffd62bcd94c$var$load("6wr18"),
    $9e601ffd62bcd94c$var$load("ffEVr"),
    $9e601ffd62bcd94c$var$load("gbD8o")
]).then(()=>parcelRequire('94rSt'));

});

parcelRegister("2bfxm", function(module, exports) {

let $1968a93700ac93ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1968a93700ac93ea$var$load("8JZKd"),
    $1968a93700ac93ea$var$load("6wr18"),
    $1968a93700ac93ea$var$load("ffEVr"),
    $1968a93700ac93ea$var$load("f1gnF")
]).then(()=>parcelRequire('j4ae9'));

});

parcelRegister("itiI2", function(module, exports) {

let $d72972b7b61ca577$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d72972b7b61ca577$var$load("8JZKd"),
    $d72972b7b61ca577$var$load("8IhZd")
]).then(()=>parcelRequire('l6sV5'));

});

parcelRegister("7keB7", function(module, exports) {

let $5555b971de586395$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5555b971de586395$var$load("8JZKd"),
    $5555b971de586395$var$load("adPR4")
]).then(()=>parcelRequire('gNtj9'));

});

parcelRegister("ggFqS", function(module, exports) {

let $bd7e4798aca981f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bd7e4798aca981f5$var$load("8JZKd"),
    $bd7e4798aca981f5$var$load("daJyN")
]).then(()=>parcelRequire('3DbzI'));

});

parcelRegister("8iPox", function(module, exports) {

let $60b7df1629b6d05b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $60b7df1629b6d05b$var$load("8JZKd"),
    $60b7df1629b6d05b$var$load("aW5qr")
]).then(()=>parcelRequire('f4Rpb'));

});

parcelRegister("6vkZA", function(module, exports) {

let $4bc5ebf34d28dd96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4bc5ebf34d28dd96$var$load("8JZKd"),
    $4bc5ebf34d28dd96$var$load("6wr18"),
    $4bc5ebf34d28dd96$var$load("ffEVr"),
    $4bc5ebf34d28dd96$var$load("6Prrd")
]).then(()=>parcelRequire('f9qTu'));

});

parcelRegister("89wDl", function(module, exports) {

let $5ef87a5d8c2cbc5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5ef87a5d8c2cbc5e$var$load("8JZKd"),
    $5ef87a5d8c2cbc5e$var$load("eCCso")
]).then(()=>parcelRequire('ehmAO'));

});

parcelRegister("ilrxR", function(module, exports) {

let $d5af8e0c4528c637$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d5af8e0c4528c637$var$load("8JZKd"),
    $d5af8e0c4528c637$var$load("2Ks20")
]).then(()=>parcelRequire('ibMH8'));

});

parcelRegister("8gsaE", function(module, exports) {

let $6045ab7c39739ce7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6045ab7c39739ce7$var$load("8JZKd"),
    $6045ab7c39739ce7$var$load("d5qd0")
]).then(()=>parcelRequire('fMWYe'));

});

parcelRegister("2Rl0r", function(module, exports) {

let $2150d360356d4392$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2150d360356d4392$var$load("8JZKd"),
    $2150d360356d4392$var$load("kGBuu")
]).then(()=>parcelRequire('aymRb'));

});

parcelRegister("3FFa6", function(module, exports) {

let $2ac521592399a600$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2ac521592399a600$var$load("8JZKd"),
    $2ac521592399a600$var$load("dl8qO")
]).then(()=>parcelRequire('2K1WS'));

});

parcelRegister("f3G6B", function(module, exports) {

let $af67cc2094a74f84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $af67cc2094a74f84$var$load("8JZKd"),
    $af67cc2094a74f84$var$load("eq9bw")
]).then(()=>parcelRequire('4XQel'));

});

parcelRegister("cai9t", function(module, exports) {

let $8db47fca5e06d746$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8db47fca5e06d746$var$load("8JZKd"),
    $8db47fca5e06d746$var$load("cM0nn")
]).then(()=>parcelRequire('5R9Iq'));

});

parcelRegister("9TBCi", function(module, exports) {

let $73466df9c6b3a861$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $73466df9c6b3a861$var$load("8JZKd"),
    $73466df9c6b3a861$var$load("6wr18"),
    $73466df9c6b3a861$var$load("ffEVr"),
    $73466df9c6b3a861$var$load("6jOkU")
]).then(()=>parcelRequire('jfOH7'));

});

parcelRegister("krUqk", function(module, exports) {

let $ee3218d49dc4a033$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ee3218d49dc4a033$var$load("8JZKd"),
    $ee3218d49dc4a033$var$load("6wr18"),
    $ee3218d49dc4a033$var$load("ffEVr"),
    $ee3218d49dc4a033$var$load("hl547")
]).then(()=>parcelRequire('gMgiH'));

});

parcelRegister("RB4dY", function(module, exports) {

let $0a11b41cec527da7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0a11b41cec527da7$var$load("8JZKd"),
    $0a11b41cec527da7$var$load("4zuJf")
]).then(()=>parcelRequire('bha8O'));

});

parcelRegister("emhBh", function(module, exports) {

let $a740c5d5d5e93fb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a740c5d5d5e93fb9$var$load("8JZKd"),
    $a740c5d5d5e93fb9$var$load("fLyma")
]).then(()=>parcelRequire('J79bO'));

});

parcelRegister("6Jynt", function(module, exports) {

let $4e719cbddfb7c82f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4e719cbddfb7c82f$var$load("8JZKd"),
    $4e719cbddfb7c82f$var$load("6wr18"),
    $4e719cbddfb7c82f$var$load("ffEVr"),
    $4e719cbddfb7c82f$var$load("cdQyo")
]).then(()=>parcelRequire('bzy7z'));

});

parcelRegister("eEkhV", function(module, exports) {

let $aaa489e908c5389f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aaa489e908c5389f$var$load("8JZKd"),
    $aaa489e908c5389f$var$load("fnYyw")
]).then(()=>parcelRequire('c8Les'));

});

parcelRegister("9Q9Rz", function(module, exports) {

let $72a09f00c062c290$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $72a09f00c062c290$var$load("8JZKd"),
    $72a09f00c062c290$var$load("kdOTn")
]).then(()=>parcelRequire('6fpJf'));

});

parcelRegister("anQxx", function(module, exports) {

let $78f4ceb3c72f185c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $78f4ceb3c72f185c$var$load("8JZKd"),
    $78f4ceb3c72f185c$var$load("6wr18"),
    $78f4ceb3c72f185c$var$load("ffEVr"),
    $78f4ceb3c72f185c$var$load("6Y42j")
]).then(()=>parcelRequire('grjfA'));

});

parcelRegister("hrdOf", function(module, exports) {

let $cb1fab87c8ed80e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cb1fab87c8ed80e4$var$load("8JZKd"),
    $cb1fab87c8ed80e4$var$load("kp6bf")
]).then(()=>parcelRequire('ctKFx'));

});

parcelRegister("39SpU", function(module, exports) {

let $24cc6c6ea87b587d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $24cc6c6ea87b587d$var$load("8JZKd"),
    $24cc6c6ea87b587d$var$load("jav2e")
]).then(()=>parcelRequire('btnxO'));

});

parcelRegister("dPQX5", function(module, exports) {

let $a1291cf6a962f740$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a1291cf6a962f740$var$load("8JZKd"),
    $a1291cf6a962f740$var$load("2uRLO")
]).then(()=>parcelRequire('85Ln8'));

});

parcelRegister("6v2HW", function(module, exports) {

let $4bb7bd094f142b3b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4bb7bd094f142b3b$var$load("8JZKd"),
    $4bb7bd094f142b3b$var$load("6wr18"),
    $4bb7bd094f142b3b$var$load("ffEVr"),
    $4bb7bd094f142b3b$var$load("cU1ZR")
]).then(()=>parcelRequire('2I7Ze'));

});

parcelRegister("alXjD", function(module, exports) {

let $7899e0668b67aa9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7899e0668b67aa9b$var$load("8JZKd"),
    $7899e0668b67aa9b$var$load("6wr18"),
    $7899e0668b67aa9b$var$load("ffEVr"),
    $7899e0668b67aa9b$var$load("1GBtp")
]).then(()=>parcelRequire('gFlPH'));

});

parcelRegister("6v9BY", function(module, exports) {

let $4bbd17fd2951393e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4bbd17fd2951393e$var$load("8JZKd"),
    $4bbd17fd2951393e$var$load("6wr18"),
    $4bbd17fd2951393e$var$load("ffEVr"),
    $4bbd17fd2951393e$var$load("cNXjH")
]).then(()=>parcelRequire('hdbFN'));

});

parcelRegister("6xIOm", function(module, exports) {

let $4c3895bba120c903$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4c3895bba120c903$var$load("8JZKd"),
    $4c3895bba120c903$var$load("54CHV")
]).then(()=>parcelRequire('hIlvQ'));

});

parcelRegister("jijSP", function(module, exports) {

let $e0bf1f27995e91e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e0bf1f27995e91e3$var$load("8JZKd"),
    $e0bf1f27995e91e3$var$load("6wr18"),
    $e0bf1f27995e91e3$var$load("ffEVr"),
    $e0bf1f27995e91e3$var$load("euqkR")
]).then(()=>parcelRequire('hXbEU'));

});

parcelRegister("eEO2Q", function(module, exports) {

let $aabb9ef8b9e028c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aabb9ef8b9e028c9$var$load("8JZKd"),
    $aabb9ef8b9e028c9$var$load("6wr18"),
    $aabb9ef8b9e028c9$var$load("ffEVr"),
    $aabb9ef8b9e028c9$var$load("d5CqN")
]).then(()=>parcelRequire('6W8H3'));

});

parcelRegister("kD9V6", function(module, exports) {

let $f04f25185679d184$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f04f25185679d184$var$load("8JZKd"),
    $f04f25185679d184$var$load("1j38z")
]).then(()=>parcelRequire('5l8Gz'));

});

parcelRegister("gWUcY", function(module, exports) {

let $c56da9e2e5bfaeb2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c56da9e2e5bfaeb2$var$load("8JZKd"),
    $c56da9e2e5bfaeb2$var$load("6wr18"),
    $c56da9e2e5bfaeb2$var$load("ffEVr"),
    $c56da9e2e5bfaeb2$var$load("992TS")
]).then(()=>parcelRequire('bOmSM'));

});

parcelRegister("a0Pus", function(module, exports) {

let $74a1d85ffd85cd16$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $74a1d85ffd85cd16$var$load("8JZKd"),
    $74a1d85ffd85cd16$var$load("6wr18"),
    $74a1d85ffd85cd16$var$load("ffEVr"),
    $74a1d85ffd85cd16$var$load("j3TI9")
]).then(()=>parcelRequire('11w2e'));

});

parcelRegister("3ZQlq", function(module, exports) {

let $2e8fac288cecdf24$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2e8fac288cecdf24$var$load("8JZKd"),
    $2e8fac288cecdf24$var$load("6wr18"),
    $2e8fac288cecdf24$var$load("ffEVr"),
    $2e8fac288cecdf24$var$load("g77Um")
]).then(()=>parcelRequire('97auY'));

});

parcelRegister("aK5EN", function(module, exports) {

let $7d2296a63752ebc2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7d2296a63752ebc2$var$load("8JZKd"),
    $7d2296a63752ebc2$var$load("6wr18"),
    $7d2296a63752ebc2$var$load("ffEVr"),
    $7d2296a63752ebc2$var$load("hWNQu")
]).then(()=>parcelRequire('9wv9U'));

});

parcelRegister("91ebz", function(module, exports) {

let $690f36045090c06f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $690f36045090c06f$var$load("8JZKd"),
    $690f36045090c06f$var$load("6wr18"),
    $690f36045090c06f$var$load("ffEVr"),
    $690f36045090c06f$var$load("azjbo")
]).then(()=>parcelRequire('kA815'));

});

parcelRegister("bNDSX", function(module, exports) {

let $897335b464d97183$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $897335b464d97183$var$load("8JZKd"),
    $897335b464d97183$var$load("9IkuP")
]).then(()=>parcelRequire('9pWzB'));

});

parcelRegister("hJCEs", function(module, exports) {

let $ce949f02664e4ae7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ce949f02664e4ae7$var$load("8JZKd"),
    $ce949f02664e4ae7$var$load("3ZGnz")
]).then(()=>parcelRequire('2wS8M'));

});

parcelRegister("js5De", function(module, exports) {

let $e29500377f22aa76$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e29500377f22aa76$var$load("8JZKd"),
    $e29500377f22aa76$var$load("ciYLs"),
    $e29500377f22aa76$var$load("55D5A")
]).then(()=>parcelRequire('sBHk4'));

});

parcelRegister("k0Ss0", function(module, exports) {

let $e91e0b7e5a9b8b75$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e91e0b7e5a9b8b75$var$load("8JZKd"),
    $e91e0b7e5a9b8b75$var$load("jmUI3")
]).then(()=>parcelRequire('bfMUY'));

});

parcelRegister("kUVVp", function(module, exports) {

let $f3a5f84e6c86aacd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f3a5f84e6c86aacd$var$load("8JZKd"),
    $f3a5f84e6c86aacd$var$load("5uN9h"),
    $f3a5f84e6c86aacd$var$load("8hSeL")
]).then(()=>parcelRequire('g1gHM'));

});

parcelRegister("fCyNu", function(module, exports) {

let $b5f565a22b263ba0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b5f565a22b263ba0$var$load("8JZKd"),
    $b5f565a22b263ba0$var$load("lKwhU")
]).then(()=>parcelRequire('aAUnB'));

});

parcelRegister("c0IFj", function(module, exports) {

let $8be821bab02ab261$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8be821bab02ab261$var$load("8JZKd"),
    $8be821bab02ab261$var$load("8n1qz")
]).then(()=>parcelRequire('9d81r'));

});

parcelRegister("d6Pq7", function(module, exports) {

let $98b3b8dea3cb9fac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $98b3b8dea3cb9fac$var$load("8JZKd"),
    $98b3b8dea3cb9fac$var$load("9vLSy")
]).then(()=>parcelRequire('ctWHe'));

});

parcelRegister("647gU", function(module, exports) {

let $46a8c1d29b0e4685$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $46a8c1d29b0e4685$var$load("8JZKd"),
    $46a8c1d29b0e4685$var$load("dSYJ4")
]).then(()=>parcelRequire('iQ8us'));

});

parcelRegister("CjiI6", function(module, exports) {

let $073285752eebe5a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $073285752eebe5a1$var$load("8JZKd"),
    $073285752eebe5a1$var$load("6wr18"),
    $073285752eebe5a1$var$load("ffEVr"),
    $073285752eebe5a1$var$load("avqhQ")
]).then(()=>parcelRequire('7Y37G'));

});

parcelRegister("c2lxa", function(module, exports) {

let $8c366021d5d8e040$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8c366021d5d8e040$var$load("8JZKd"),
    $8c366021d5d8e040$var$load("6wr18"),
    $8c366021d5d8e040$var$load("ffEVr"),
    $8c366021d5d8e040$var$load("7Ia6J")
]).then(()=>parcelRequire('9vGWY'));

});

parcelRegister("gXmJH", function(module, exports) {

let $c583caf20beeb52d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c583caf20beeb52d$var$load("8JZKd"),
    $c583caf20beeb52d$var$load("2EaO7")
]).then(()=>parcelRequire('hJIZ7'));

});

parcelRegister("aZfjN", function(module, exports) {

let $7ffb7bc765dcbe37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7ffb7bc765dcbe37$var$load("8JZKd"),
    $7ffb7bc765dcbe37$var$load("k3RGX")
]).then(()=>parcelRequire('1F7NQ'));

});

parcelRegister("iBTxt", function(module, exports) {

let $d8c6c39219bc740d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d8c6c39219bc740d$var$load("8JZKd"),
    $d8c6c39219bc740d$var$load("6wr18"),
    $d8c6c39219bc740d$var$load("ffEVr"),
    $d8c6c39219bc740d$var$load("6oNwG")
]).then(()=>parcelRequire('jRCDI'));

});

parcelRegister("66jkm", function(module, exports) {

let $47124ba74f56f78a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $47124ba74f56f78a$var$load("8JZKd"),
    $47124ba74f56f78a$var$load("fZzpO")
]).then(()=>parcelRequire('adWKh'));

});

parcelRegister("2BCPl", function(module, exports) {

let $1e5d27c227aab7ce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1e5d27c227aab7ce$var$load("8JZKd"),
    $1e5d27c227aab7ce$var$load("3C0I6")
]).then(()=>parcelRequire('8srHq'));

});

parcelRegister("kmxPw", function(module, exports) {

let $ed301aa1139d9c87$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ed301aa1139d9c87$var$load("8JZKd"),
    $ed301aa1139d9c87$var$load("6wr18"),
    $ed301aa1139d9c87$var$load("ffEVr"),
    $ed301aa1139d9c87$var$load("8WFt5")
]).then(()=>parcelRequire('9Mqt3'));

});

parcelRegister("2Rgtm", function(module, exports) {

let $214d4f18cbfeb552$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $214d4f18cbfeb552$var$load("8JZKd"),
    $214d4f18cbfeb552$var$load("hFTtZ")
]).then(()=>parcelRequire('cRk3F'));

});

parcelRegister("kl6K9", function(module, exports) {

let $eceaffe181a7af4f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $eceaffe181a7af4f$var$load("8JZKd"),
    $eceaffe181a7af4f$var$load("6wr18"),
    $eceaffe181a7af4f$var$load("ffEVr"),
    $eceaffe181a7af4f$var$load("4PWPx")
]).then(()=>parcelRequire('bbKg4'));

});

parcelRegister("gqeke", function(module, exports) {

let $bf4a2fc8f317f808$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bf4a2fc8f317f808$var$load("8JZKd"),
    $bf4a2fc8f317f808$var$load("ec2Qn")
]).then(()=>parcelRequire('bEj0i'));

});

parcelRegister("poTZI", function(module, exports) {

let $04c5a6f5c0e21cc1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $04c5a6f5c0e21cc1$var$load("8JZKd"),
    $04c5a6f5c0e21cc1$var$load("4FrFP")
]).then(()=>parcelRequire('kCWfQ'));

});

parcelRegister("b61UF", function(module, exports) {

let $8141bd1d4b576cd6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8141bd1d4b576cd6$var$load("8JZKd"),
    $8141bd1d4b576cd6$var$load("5t3NJ"),
    $8141bd1d4b576cd6$var$load("hllqt")
]).then(()=>parcelRequire('65rPF'));

});

parcelRegister("6hsfR", function(module, exports) {

let $492a3f6d10c4b062$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $492a3f6d10c4b062$var$load("8JZKd"),
    $492a3f6d10c4b062$var$load("fCcIi")
]).then(()=>parcelRequire('iKyoZ'));

});

parcelRegister("flpqf", function(module, exports) {

let $b2bc89834e38d04d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b2bc89834e38d04d$var$load("8JZKd"),
    $b2bc89834e38d04d$var$load("kfr6k")
]).then(()=>parcelRequire('2fsbx'));

});

parcelRegister("82xDz", function(module, exports) {

let $5da89a4f2deab134$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5da89a4f2deab134$var$load("8JZKd"),
    $5da89a4f2deab134$var$load("f1x0y"),
    $5da89a4f2deab134$var$load("f2tqy")
]).then(()=>parcelRequire('kfwI9'));

});

parcelRegister("vgmoJ", function(module, exports) {

let $05df962bcabc8c8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $05df962bcabc8c8a$var$load("8JZKd"),
    $05df962bcabc8c8a$var$load("a5PnA"),
    $05df962bcabc8c8a$var$load("1XElS")
]).then(()=>parcelRequire('60ePl'));

});

parcelRegister("36VyW", function(module, exports) {

let $243e955b0500ea4d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $243e955b0500ea4d$var$load("8JZKd"),
    $243e955b0500ea4d$var$load("6wr18"),
    $243e955b0500ea4d$var$load("ffEVr"),
    $243e955b0500ea4d$var$load("61fF8")
]).then(()=>parcelRequire('aEOt2'));

});

parcelRegister("4Gtas", function(module, exports) {

let $3691b5bfb8d7b5ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3691b5bfb8d7b5ad$var$load("8JZKd"),
    $3691b5bfb8d7b5ad$var$load("3GhFp")
]).then(()=>parcelRequire('ktVXi'));

});

parcelRegister("bZgYy", function(module, exports) {

let $8ba28f39e8bf270d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8ba28f39e8bf270d$var$load("8JZKd"),
    $8ba28f39e8bf270d$var$load("ljaqI"),
    $8ba28f39e8bf270d$var$load("3W8o1")
]).then(()=>parcelRequire('eMG9c'));

});

parcelRegister("646dK", function(module, exports) {

let $46a7f11e2bb862d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $46a7f11e2bb862d2$var$load("8JZKd"),
    $46a7f11e2bb862d2$var$load("6wr18"),
    $46a7f11e2bb862d2$var$load("ffEVr"),
    $46a7f11e2bb862d2$var$load("2TvrU")
]).then(()=>parcelRequire('5N11J'));

});

parcelRegister("kACwR", function(module, exports) {

let $efd50e7f6870b2a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $efd50e7f6870b2a6$var$load("8JZKd"),
    $efd50e7f6870b2a6$var$load("hmR49")
]).then(()=>parcelRequire('7gC3k'));

});

parcelRegister("6UjQN", function(module, exports) {

let $50775ef132a7cfc0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $50775ef132a7cfc0$var$load("8JZKd"),
    $50775ef132a7cfc0$var$load("6wr18"),
    $50775ef132a7cfc0$var$load("ffEVr"),
    $50775ef132a7cfc0$var$load("cyCEv")
]).then(()=>parcelRequire('jeR8p'));

});

parcelRegister("b2gSa", function(module, exports) {

let $808cf82a1e7d0292$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $808cf82a1e7d0292$var$load("8JZKd"),
    $808cf82a1e7d0292$var$load("6wr18"),
    $808cf82a1e7d0292$var$load("ffEVr"),
    $808cf82a1e7d0292$var$load("9yJZ4")
]).then(()=>parcelRequire('PZCzy'));

});

parcelRegister("ewu8V", function(module, exports) {

let $a92b6f95c7a39e55$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a92b6f95c7a39e55$var$load("8JZKd"),
    $a92b6f95c7a39e55$var$load("1cGGc"),
    $a92b6f95c7a39e55$var$load("h9S5s")
]).then(()=>parcelRequire('jju36'));

});

parcelRegister("dMuqL", function(module, exports) {

let $a0875cf34d77101a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a0875cf34d77101a$var$load("8JZKd"),
    $a0875cf34d77101a$var$load("io1wi")
]).then(()=>parcelRequire('2Agkp'));

});

parcelRegister("7ydOL", function(module, exports) {

let $57f66d4aa6078f8f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $57f66d4aa6078f8f$var$load("8JZKd"),
    $57f66d4aa6078f8f$var$load("6wr18"),
    $57f66d4aa6078f8f$var$load("ffEVr"),
    $57f66d4aa6078f8f$var$load("kFIxb")
]).then(()=>parcelRequire('hZX9t'));

});

parcelRegister("38uKy", function(module, exports) {

let $2489f8bdbfb3a12d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2489f8bdbfb3a12d$var$load("8JZKd"),
    $2489f8bdbfb3a12d$var$load("6wr18"),
    $2489f8bdbfb3a12d$var$load("ffEVr"),
    $2489f8bdbfb3a12d$var$load("8vIG7")
]).then(()=>parcelRequire('f6Wsg'));

});

parcelRegister("dzLzX", function(module, exports) {

let $9e23736d2be27535$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9e23736d2be27535$var$load("8JZKd"),
    $9e23736d2be27535$var$load("gkHyQ"),
    $9e23736d2be27535$var$load("1EXva")
]).then(()=>parcelRequire('4y97X'));

});

parcelRegister("3XFZz", function(module, exports) {

let $2e27748e50518bb2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2e27748e50518bb2$var$load("8JZKd"),
    $2e27748e50518bb2$var$load("6wr18"),
    $2e27748e50518bb2$var$load("ffEVr"),
    $2e27748e50518bb2$var$load("dLlMx")
]).then(()=>parcelRequire('8OCNt'));

});

parcelRegister("jn3xX", function(module, exports) {

let $e1a2ea9ae4e2fdf7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e1a2ea9ae4e2fdf7$var$load("8JZKd"),
    $e1a2ea9ae4e2fdf7$var$load("6jw5Q"),
    $e1a2ea9ae4e2fdf7$var$load("kHq0J")
]).then(()=>parcelRequire('d0wlc'));

});

parcelRegister("5NLz5", function(module, exports) {

let $43966cbcf3653115$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $43966cbcf3653115$var$load("8JZKd"),
    $43966cbcf3653115$var$load("bDBJF")
]).then(()=>parcelRequire('4cxac'));

});

parcelRegister("hBsAL", function(module, exports) {

let $034ea574191a6a6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $034ea574191a6a6b$var$load("8JZKd"),
    $034ea574191a6a6b$var$load("6wr18"),
    $034ea574191a6a6b$var$load("ffEVr"),
    $034ea574191a6a6b$var$load("25s5r")
]).then(()=>parcelRequire('a9Pym'));

});

parcelRegister("aqKbW", function(module, exports) {

let $798029c15b943b0b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $798029c15b943b0b$var$load("8JZKd"),
    $798029c15b943b0b$var$load("5WgIL")
]).then(()=>parcelRequire('lVBH4'));

});

parcelRegister("d2j0p", function(module, exports) {

let $97da34615a8fda9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $97da34615a8fda9b$var$load("8JZKd"),
    $97da34615a8fda9b$var$load("fjOTL"),
    $97da34615a8fda9b$var$load("9UbYE")
]).then(()=>parcelRequire('3EL4j'));

});

parcelRegister("lG1LJ", function(module, exports) {

let $fc7ee4807c4e823f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fc7ee4807c4e823f$var$load("8JZKd"),
    $fc7ee4807c4e823f$var$load("SvDaI")
]).then(()=>parcelRequire('kpXSH'));

});

parcelRegister("6kmjr", function(module, exports) {

let $49b5eb1f229e78d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $49b5eb1f229e78d0$var$load("8JZKd"),
    $49b5eb1f229e78d0$var$load("6wr18"),
    $49b5eb1f229e78d0$var$load("ffEVr"),
    $49b5eb1f229e78d0$var$load("g2T9E")
]).then(()=>parcelRequire('glw7S'));

});

parcelRegister("cgca0", function(module, exports) {

let $8ed06975c2415036$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8ed06975c2415036$var$load("8JZKd"),
    $8ed06975c2415036$var$load("6wr18"),
    $8ed06975c2415036$var$load("ffEVr"),
    $8ed06975c2415036$var$load("1qGJz")
]).then(()=>parcelRequire('jA8da'));

});

parcelRegister("1yToV", function(module, exports) {

let $1233f0ed5b5c3f9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1233f0ed5b5c3f9b$var$load("8JZKd"),
    $1233f0ed5b5c3f9b$var$load("WOIba"),
    $1233f0ed5b5c3f9b$var$load("hxViA")
]).then(()=>parcelRequire('iwuXz'));

});

parcelRegister("cjutx", function(module, exports) {

let $8f6ee6296f75a090$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8f6ee6296f75a090$var$load("8JZKd"),
    $8f6ee6296f75a090$var$load("j2bbk"),
    $8f6ee6296f75a090$var$load("3grNP")
]).then(()=>parcelRequire('jrNxd'));

});

parcelRegister("92rWM", function(module, exports) {

let $6949faa8f28fd246$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6949faa8f28fd246$var$load("8JZKd"),
    $6949faa8f28fd246$var$load("h8ehw")
]).then(()=>parcelRequire('g0ddd'));

});

parcelRegister("j4fYG", function(module, exports) {

let $de1ac8e32432677c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $de1ac8e32432677c$var$load("8JZKd"),
    $de1ac8e32432677c$var$load("6wr18"),
    $de1ac8e32432677c$var$load("ffEVr"),
    $de1ac8e32432677c$var$load("cNgMu")
]).then(()=>parcelRequire('1VUT1'));

});

parcelRegister("zhSNO", function(module, exports) {

let $06a1242c1f6506af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $06a1242c1f6506af$var$load("8JZKd"),
    $06a1242c1f6506af$var$load("6wr18"),
    $06a1242c1f6506af$var$load("ffEVr"),
    $06a1242c1f6506af$var$load("8wF9x")
]).then(()=>parcelRequire('8cvV4'));

});

parcelRegister("j40SF", function(module, exports) {

let $de0f12f1ca83ed5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $de0f12f1ca83ed5d$var$load("8JZKd"),
    $de0f12f1ca83ed5d$var$load("6wr18"),
    $de0f12f1ca83ed5d$var$load("ffEVr"),
    $de0f12f1ca83ed5d$var$load("kgJcP")
]).then(()=>parcelRequire('4azDt'));

});

parcelRegister("eaAIo", function(module, exports) {

let $a50e7ab1d3002256$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a50e7ab1d3002256$var$load("8JZKd"),
    $a50e7ab1d3002256$var$load("a0ogJ")
]).then(()=>parcelRequire('8Ldri'));

});

parcelRegister("5NCUL", function(module, exports) {

let $438fb6f928a6edf2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $438fb6f928a6edf2$var$load("8JZKd"),
    $438fb6f928a6edf2$var$load("cqT0F"),
    $438fb6f928a6edf2$var$load("esOEn")
]).then(()=>parcelRequire('cJjT8'));

});

parcelRegister("8GHl1", function(module, exports) {

let $6533dd05719e1258$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6533dd05719e1258$var$load("8JZKd"),
    $6533dd05719e1258$var$load("1S9KM")
]).then(()=>parcelRequire('fKVtj'));

});

parcelRegister("dAZQk", function(module, exports) {

let $9e5e9be288f7488f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9e5e9be288f7488f$var$load("8JZKd"),
    $9e5e9be288f7488f$var$load("8LPnw")
]).then(()=>parcelRequire('bRfUA'));

});

parcelRegister("4pNBU", function(module, exports) {

let $336ffad552f80184$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $336ffad552f80184$var$load("8JZKd"),
    $336ffad552f80184$var$load("6faJ6")
]).then(()=>parcelRequire('d25NA'));

});

parcelRegister("2LwQc", function(module, exports) {

let $203972130a8cd509$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $203972130a8cd509$var$load("8JZKd"),
    $203972130a8cd509$var$load("6wr18"),
    $203972130a8cd509$var$load("ffEVr"),
    $203972130a8cd509$var$load("fSqvO")
]).then(()=>parcelRequire('bgJk4'));

});

parcelRegister("cXTi8", function(module, exports) {

let $9705e27bcbe58520$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9705e27bcbe58520$var$load("8JZKd"),
    $9705e27bcbe58520$var$load("6wr18"),
    $9705e27bcbe58520$var$load("ffEVr"),
    $9705e27bcbe58520$var$load("iCgtd")
]).then(()=>parcelRequire('6YzLt'));

});

parcelRegister("6FTqY", function(module, exports) {

let $4dc1927732d72ec1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4dc1927732d72ec1$var$load("8JZKd"),
    $4dc1927732d72ec1$var$load("fc7K0")
]).then(()=>parcelRequire('kYDnZ'));

});

parcelRegister("3l4J5", function(module, exports) {

let $26e6ffc424370a76$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $26e6ffc424370a76$var$load("8JZKd"),
    $26e6ffc424370a76$var$load("hc4DE")
]).then(()=>parcelRequire('4ykLR'));

});

parcelRegister("idGLd", function(module, exports) {

let $d43a9c3a78f420b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d43a9c3a78f420b3$var$load("8JZKd"),
    $d43a9c3a78f420b3$var$load("7TGYM")
]).then(()=>parcelRequire('kg3vi'));

});

parcelRegister("fVobC", function(module, exports) {

let $b97ef0cb62b3af57$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b97ef0cb62b3af57$var$load("8JZKd"),
    $b97ef0cb62b3af57$var$load("17usw")
]).then(()=>parcelRequire('6S2qG'));

});

parcelRegister("kqNzg", function(module, exports) {

let $edfcaf7d4fdcf7da$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $edfcaf7d4fdcf7da$var$load("8JZKd"),
    $edfcaf7d4fdcf7da$var$load("1oAGT"),
    $edfcaf7d4fdcf7da$var$load("f9Wnm")
]).then(()=>parcelRequire('8BsHU'));

});

parcelRegister("1ecFD", function(module, exports) {

let $0e50ed5c4f33f557$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0e50ed5c4f33f557$var$load("8JZKd"),
    $0e50ed5c4f33f557$var$load("bFS2f"),
    $0e50ed5c4f33f557$var$load("eMnEL")
]).then(()=>parcelRequire('gFN1F'));

});

parcelRegister("5VM98", function(module, exports) {

let $45179f81816ca226$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $45179f81816ca226$var$load("8JZKd"),
    $45179f81816ca226$var$load("gxdLv")
]).then(()=>parcelRequire('7i4GE'));

});

parcelRegister("4cVHI", function(module, exports) {

let $31050b44616dfc41$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $31050b44616dfc41$var$load("8JZKd"),
    $31050b44616dfc41$var$load("7gCPT")
]).then(()=>parcelRequire('9Yjeb'));

});

parcelRegister("cf8Up", function(module, exports) {

let $8e9dcbdb652079d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8e9dcbdb652079d3$var$load("8JZKd"),
    $8e9dcbdb652079d3$var$load("6wr18"),
    $8e9dcbdb652079d3$var$load("ffEVr"),
    $8e9dcbdb652079d3$var$load("8nvpQ")
]).then(()=>parcelRequire('gozhT'));

});

parcelRegister("4sOXB", function(module, exports) {

let $34014ea2212b3999$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $34014ea2212b3999$var$load("8JZKd"),
    $34014ea2212b3999$var$load("kyUks"),
    $34014ea2212b3999$var$load("3UkvT")
]).then(()=>parcelRequire('ifYIQ'));

});

parcelRegister("2uSAW", function(module, exports) {

let $1d18bb7eb18c7f87$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1d18bb7eb18c7f87$var$load("8JZKd"),
    $1d18bb7eb18c7f87$var$load("6wr18"),
    $1d18bb7eb18c7f87$var$load("ffEVr"),
    $1d18bb7eb18c7f87$var$load("j0wnn")
]).then(()=>parcelRequire('fdOBP'));

});

parcelRegister("gUgh6", function(module, exports) {

let $c4ee802ba4429edf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c4ee802ba4429edf$var$load("8JZKd"),
    $c4ee802ba4429edf$var$load("6QXPb")
]).then(()=>parcelRequire('6ccC4'));

});

parcelRegister("iGFQ4", function(module, exports) {

let $d9ac9a93dacb9ce3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d9ac9a93dacb9ce3$var$load("8JZKd"),
    $d9ac9a93dacb9ce3$var$load("g9I9R")
]).then(()=>parcelRequire('eKCAo'));

});

parcelRegister("aHOa6", function(module, exports) {

let $7cb4d4a6f70d0653$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7cb4d4a6f70d0653$var$load("8JZKd"),
    $7cb4d4a6f70d0653$var$load("ijPJo"),
    $7cb4d4a6f70d0653$var$load("8hh2h")
]).then(()=>parcelRequire('aJZgI'));

});

parcelRegister("fxal7", function(module, exports) {

let $b4f1f54c2926cadb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b4f1f54c2926cadb$var$load("8JZKd"),
    $b4f1f54c2926cadb$var$load("6g8jt")
]).then(()=>parcelRequire('8nxKq'));

});

parcelRegister("9JycZ", function(module, exports) {

let $7162da247148f361$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7162da247148f361$var$load("8JZKd"),
    $7162da247148f361$var$load("llcfA"),
    $7162da247148f361$var$load("bA4nr")
]).then(()=>parcelRequire('1UxsQ'));

});

parcelRegister("8MHfg", function(module, exports) {

let $66545a04f28c2f39$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $66545a04f28c2f39$var$load("8JZKd"),
    $66545a04f28c2f39$var$load("azCDs"),
    $66545a04f28c2f39$var$load("kJZ90")
]).then(()=>parcelRequire('3yLKm'));

});

parcelRegister("8VwIo", function(module, exports) {

let $67fd062343304cea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $67fd062343304cea$var$load("8JZKd"),
    $67fd062343304cea$var$load("gLVA1")
]).then(()=>parcelRequire('gmyB9'));

});

parcelRegister("dbXbW", function(module, exports) {

let $99aa37acae58f605$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $99aa37acae58f605$var$load("8JZKd"),
    $99aa37acae58f605$var$load("1Qnbg"),
    $99aa37acae58f605$var$load("kZ0xy")
]).then(()=>parcelRequire('5riP2'));

});

parcelRegister("6gXuZ", function(module, exports) {

let $491263f18b762b23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $491263f18b762b23$var$load("8JZKd"),
    $491263f18b762b23$var$load("3QNT6")
]).then(()=>parcelRequire('8JHjV'));

});

parcelRegister("eEQCn", function(module, exports) {

let $aabd9defffd6d58c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aabd9defffd6d58c$var$load("8JZKd"),
    $aabd9defffd6d58c$var$load("3xuDK"),
    $aabd9defffd6d58c$var$load("52WuW")
]).then(()=>parcelRequire('lSAtq'));

});

parcelRegister("gufeV", function(module, exports) {

let $c00b44f9846dc087$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c00b44f9846dc087$var$load("8JZKd"),
    $c00b44f9846dc087$var$load("zy381")
]).then(()=>parcelRequire('5PZ1b'));

});

parcelRegister("gAUrB", function(module, exports) {

let $c14bcac99e9398eb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c14bcac99e9398eb$var$load("8JZKd"),
    $c14bcac99e9398eb$var$load("6wr18"),
    $c14bcac99e9398eb$var$load("ffEVr"),
    $c14bcac99e9398eb$var$load("b7MVU")
]).then(()=>parcelRequire('lNABS'));

});

parcelRegister("3AZmM", function(module, exports) {

let $29e456016ae11407$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $29e456016ae11407$var$load("8JZKd"),
    $29e456016ae11407$var$load("5uN9h"),
    $29e456016ae11407$var$load("1d7Ag")
]).then(()=>parcelRequire('2sbaw'));

});

parcelRegister("9kUYz", function(module, exports) {

let $6cc22d8bb72eb55d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6cc22d8bb72eb55d$var$load("8JZKd"),
    $6cc22d8bb72eb55d$var$load("8Ned5"),
    $6cc22d8bb72eb55d$var$load("eEX4w")
]).then(()=>parcelRequire('c2BSo'));

});

parcelRegister("8ow2q", function(module, exports) {

let $61c96ab421fca093$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $61c96ab421fca093$var$load("8JZKd"),
    $61c96ab421fca093$var$load("6wr18"),
    $61c96ab421fca093$var$load("ffEVr"),
    $61c96ab421fca093$var$load("5RaHt")
]).then(()=>parcelRequire('kXC4U'));

});

parcelRegister("3DW5N", function(module, exports) {

let $2a721392fee5474c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2a721392fee5474c$var$load("8JZKd"),
    $2a721392fee5474c$var$load("7Jkpx")
]).then(()=>parcelRequire('2wW9g'));

});

parcelRegister("84mDk", function(module, exports) {

let $5e0040f9c473424c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5e0040f9c473424c$var$load("8JZKd"),
    $5e0040f9c473424c$var$load("9FBaW")
]).then(()=>parcelRequire('7D93v'));

});

parcelRegister("lmcXF", function(module, exports) {

let $f8c5b4ec24ae1088$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f8c5b4ec24ae1088$var$load("8JZKd"),
    $f8c5b4ec24ae1088$var$load("6wr18"),
    $f8c5b4ec24ae1088$var$load("ffEVr"),
    $f8c5b4ec24ae1088$var$load("8Ccla")
]).then(()=>parcelRequire('4v6NO'));

});

parcelRegister("es1iX", function(module, exports) {

let $a854b14a83bcc651$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a854b14a83bcc651$var$load("8JZKd"),
    $a854b14a83bcc651$var$load("4rKYa"),
    $a854b14a83bcc651$var$load("895MG")
]).then(()=>parcelRequire('cTlOE'));

});

parcelRegister("htMQS", function(module, exports) {

let $cb9b0a126220b769$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cb9b0a126220b769$var$load("8JZKd"),
    $cb9b0a126220b769$var$load("6wr18"),
    $cb9b0a126220b769$var$load("ffEVr"),
    $cb9b0a126220b769$var$load("01FuX")
]).then(()=>parcelRequire('5CLlM'));

});

parcelRegister("7mjky", function(module, exports) {

let $55b9951be6bb7eef$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $55b9951be6bb7eef$var$load("8JZKd"),
    $55b9951be6bb7eef$var$load("7owaE")
]).then(()=>parcelRequire('dTP2L'));

});

parcelRegister("dcdzN", function(module, exports) {

let $99b6ed52dd0b9e73$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $99b6ed52dd0b9e73$var$load("8JZKd"),
    $99b6ed52dd0b9e73$var$load("6wr18"),
    $99b6ed52dd0b9e73$var$load("ffEVr"),
    $99b6ed52dd0b9e73$var$load("8tSNw")
]).then(()=>parcelRequire('3R8RS'));

});

parcelRegister("2Krr9", function(module, exports) {

let $2005290771299864$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2005290771299864$var$load("8JZKd"),
    $2005290771299864$var$load("19uFC"),
    $2005290771299864$var$load("eKqiP")
]).then(()=>parcelRequire('1ZBVj'));

});

parcelRegister("86fKz", function(module, exports) {

let $5e5b19f09f42a60a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5e5b19f09f42a60a$var$load("8JZKd"),
    $5e5b19f09f42a60a$var$load("dJPwY")
]).then(()=>parcelRequire('am4ic'));

});

parcelRegister("b9brh", function(module, exports) {

let $81d96883f080b56d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $81d96883f080b56d$var$load("8JZKd"),
    $81d96883f080b56d$var$load("3opZo"),
    $81d96883f080b56d$var$load("8h9C3")
]).then(()=>parcelRequire('29Qqv'));

});

parcelRegister("bot3S", function(module, exports) {

let $84b87aa26a7d097d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $84b87aa26a7d097d$var$load("8JZKd"),
    $84b87aa26a7d097d$var$load("6wr18"),
    $84b87aa26a7d097d$var$load("ffEVr"),
    $84b87aa26a7d097d$var$load("48HMF")
]).then(()=>parcelRequire('evxCV'));

});

parcelRegister("5QJiO", function(module, exports) {

let $4424f33734a1af9e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4424f33734a1af9e$var$load("8JZKd"),
    $4424f33734a1af9e$var$load("6wr18"),
    $4424f33734a1af9e$var$load("ffEVr"),
    $4424f33734a1af9e$var$load("2ysPX")
]).then(()=>parcelRequire('3NNQM'));

});

parcelRegister("jMVTt", function(module, exports) {

let $e67f687d09e90d6d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e67f687d09e90d6d$var$load("8JZKd"),
    $e67f687d09e90d6d$var$load("5BMnr"),
    $e67f687d09e90d6d$var$load("9QNjl")
]).then(()=>parcelRequire('8FuhP'));

});

parcelRegister("4Ty8t", function(module, exports) {

let $3906c71c0ba6fe5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3906c71c0ba6fe5e$var$load("8JZKd"),
    $3906c71c0ba6fe5e$var$load("5BMnr"),
    $3906c71c0ba6fe5e$var$load("lm8M5")
]).then(()=>parcelRequire('b8XGo'));

});

parcelRegister("iK7kb", function(module, exports) {

let $da52345e62140364$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $da52345e62140364$var$load("8JZKd"),
    $da52345e62140364$var$load("3RVxb")
]).then(()=>parcelRequire('7WjpT'));

});

parcelRegister("lH6nK", function(module, exports) {

let $fcb2907affda6496$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fcb2907affda6496$var$load("8JZKd"),
    $fcb2907affda6496$var$load("jciW0")
]).then(()=>parcelRequire('gqQg4'));

});

parcelRegister("rXhNW", function(module, exports) {

let $054082babf9a7466$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $054082babf9a7466$var$load("8JZKd"),
    $054082babf9a7466$var$load("6HzIk")
]).then(()=>parcelRequire('bTSBD'));

});

parcelRegister("fk6CD", function(module, exports) {

let $b27ddc46f19efc81$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b27ddc46f19efc81$var$load("8JZKd"),
    $b27ddc46f19efc81$var$load("gwlMC")
]).then(()=>parcelRequire('bP2lm'));

});

parcelRegister("4UpBP", function(module, exports) {

let $393041d49aab5937$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $393041d49aab5937$var$load("8JZKd"),
    $393041d49aab5937$var$load("iMSgb"),
    $393041d49aab5937$var$load("65NKm")
]).then(()=>parcelRequire('gYFpk'));

});

parcelRegister("ai2SG", function(module, exports) {

let $77ddd1f3d97b16a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $77ddd1f3d97b16a0$var$load("8JZKd"),
    $77ddd1f3d97b16a0$var$load("kTnVa"),
    $77ddd1f3d97b16a0$var$load("10PAX")
]).then(()=>parcelRequire('e8df7'));

});

parcelRegister("c6oj7", function(module, exports) {

let $8cf8e67ef84cea18$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8cf8e67ef84cea18$var$load("8JZKd"),
    $8cf8e67ef84cea18$var$load("lUlCu"),
    $8cf8e67ef84cea18$var$load("kvwtq")
]).then(()=>parcelRequire('gaX6P'));

});

parcelRegister("1YjBF", function(module, exports) {

let $16fa9a785bbee598$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $16fa9a785bbee598$var$load("8JZKd"),
    $16fa9a785bbee598$var$load("3qsjq"),
    $16fa9a785bbee598$var$load("aKNGF")
]).then(()=>parcelRequire('cX83Y'));

});

parcelRegister("aeofx", function(module, exports) {

let $772e05a592c36ff8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $772e05a592c36ff8$var$load("8JZKd"),
    $772e05a592c36ff8$var$load("3qsjq"),
    $772e05a592c36ff8$var$load("W5lfD")
]).then(()=>parcelRequire('jrLqA'));

});

parcelRegister("5XD9a", function(module, exports) {

let $4570d432d3222ef0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4570d432d3222ef0$var$load("8JZKd"),
    $4570d432d3222ef0$var$load("6wr18"),
    $4570d432d3222ef0$var$load("ffEVr"),
    $4570d432d3222ef0$var$load("9dfxa")
]).then(()=>parcelRequire('cOAGo'));

});

parcelRegister("jSKZe", function(module, exports) {

let $e797820d20cc5b30$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e797820d20cc5b30$var$load("8JZKd"),
    $e797820d20cc5b30$var$load("6wr18"),
    $e797820d20cc5b30$var$load("ffEVr"),
    $e797820d20cc5b30$var$load("3RGYS")
]).then(()=>parcelRequire('3MAnl'));

});

parcelRegister("6fKvw", function(module, exports) {

let $48d83832258ae41b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $48d83832258ae41b$var$load("8JZKd"),
    $48d83832258ae41b$var$load("8bkDf"),
    $48d83832258ae41b$var$load("iZHNx")
]).then(()=>parcelRequire('4dgmL'));

});

parcelRegister("6JvUn", function(module, exports) {

let $4e6fb2586f2486e2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4e6fb2586f2486e2$var$load("8JZKd"),
    $4e6fb2586f2486e2$var$load("fis9i")
]).then(()=>parcelRequire('bztMz'));

});

parcelRegister("4M37c", function(module, exports) {

let $379e0fb78c9de9f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $379e0fb78c9de9f7$var$load("8JZKd"),
    $379e0fb78c9de9f7$var$load("0apDi")
]).then(()=>parcelRequire('jJD3v'));

});

parcelRegister("5rbAo", function(module, exports) {

let $3f58761c55c62dd2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3f58761c55c62dd2$var$load("8JZKd"),
    $3f58761c55c62dd2$var$load("7ouuO"),
    $3f58761c55c62dd2$var$load("9uS8C")
]).then(()=>parcelRequire('eg7HA'));

});

parcelRegister("iIXDH", function(module, exports) {

let $da1a992f10da53ef$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $da1a992f10da53ef$var$load("8JZKd"),
    $da1a992f10da53ef$var$load("j4ThT")
]).then(()=>parcelRequire('5rIoV'));

});

parcelRegister("8gLlN", function(module, exports) {

let $60548c312de3bf90$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $60548c312de3bf90$var$load("8JZKd"),
    $60548c312de3bf90$var$load("lBQ2X")
]).then(()=>parcelRequire('aMXh0'));

});

parcelRegister("5mXYe", function(module, exports) {

let $3e8d86bb90368661$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3e8d86bb90368661$var$load("8JZKd"),
    $3e8d86bb90368661$var$load("6wr18"),
    $3e8d86bb90368661$var$load("ffEVr"),
    $3e8d86bb90368661$var$load("ebi0a")
]).then(()=>parcelRequire('jJGPx'));

});

parcelRegister("3X0HN", function(module, exports) {

let $2e076dd83a4b49fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2e076dd83a4b49fd$var$load("8JZKd"),
    $2e076dd83a4b49fd$var$load("6wr18"),
    $2e076dd83a4b49fd$var$load("ffEVr"),
    $2e076dd83a4b49fd$var$load("1B0KU")
]).then(()=>parcelRequire('6e8pq'));

});

parcelRegister("cpo1x", function(module, exports) {

let $908a74713f094fb7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $908a74713f094fb7$var$load("8JZKd"),
    $908a74713f094fb7$var$load("7jFoE")
]).then(()=>parcelRequire('kZhca'));

});

parcelRegister("2BI2W", function(module, exports) {

let $1e613433b89a3f54$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1e613433b89a3f54$var$load("8JZKd"),
    $1e613433b89a3f54$var$load("6wr18"),
    $1e613433b89a3f54$var$load("ffEVr"),
    $1e613433b89a3f54$var$load("2Mjri")
]).then(()=>parcelRequire('5cJSs'));

});

parcelRegister("k12mT", function(module, exports) {

let $e925bcee2d022e70$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e925bcee2d022e70$var$load("8JZKd"),
    $e925bcee2d022e70$var$load("6wr18"),
    $e925bcee2d022e70$var$load("ffEVr"),
    $e925bcee2d022e70$var$load("6tDMS")
]).then(()=>parcelRequire('1dP1H'));

});

parcelRegister("kk4CA", function(module, exports) {

let $ecb9429c866ab821$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ecb9429c866ab821$var$load("8JZKd"),
    $ecb9429c866ab821$var$load("7T1my")
]).then(()=>parcelRequire('c71XV'));

});

parcelRegister("4cbxR", function(module, exports) {

let $30e13d068f7fb8f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $30e13d068f7fb8f3$var$load("8JZKd"),
    $30e13d068f7fb8f3$var$load("hk9qq")
]).then(()=>parcelRequire('kVJTD'));

});

parcelRegister("dl9oy", function(module, exports) {

let $9b6486343c86d11d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9b6486343c86d11d$var$load("8JZKd"),
    $9b6486343c86d11d$var$load("hfVcp")
]).then(()=>parcelRequire('bmxmm'));

});

parcelRegister("2pv4k", function(module, exports) {

let $1c16042cc909aa14$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1c16042cc909aa14$var$load("8JZKd"),
    $1c16042cc909aa14$var$load("1oAGT"),
    $1c16042cc909aa14$var$load("5rr9F")
]).then(()=>parcelRequire('2uLtj'));

});

parcelRegister("4Buu1", function(module, exports) {

let $35a24379bafb3471$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $35a24379bafb3471$var$load("8JZKd"),
    $35a24379bafb3471$var$load("hpePq"),
    $35a24379bafb3471$var$load("aIbV9")
]).then(()=>parcelRequire('7wMxS'));

});

parcelRegister("gFSQv", function(module, exports) {

let $c23b04ea93a39c0e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c23b04ea93a39c0e$var$load("8JZKd"),
    $c23b04ea93a39c0e$var$load("6aY84"),
    $c23b04ea93a39c0e$var$load("7e0wS")
]).then(()=>parcelRequire('lbcRX'));

});

parcelRegister("6Zo2u", function(module, exports) {

let $516b163f45adbfff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $516b163f45adbfff$var$load("8JZKd"),
    $516b163f45adbfff$var$load("5CaYW"),
    $516b163f45adbfff$var$load("wtJUp")
]).then(()=>parcelRequire('kjbjY'));

});

parcelRegister("biBlq", function(module, exports) {

let $839e57fb4fea661a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $839e57fb4fea661a$var$load("8JZKd"),
    $839e57fb4fea661a$var$load("8Ned5"),
    $839e57fb4fea661a$var$load("1Scxq")
]).then(()=>parcelRequire('3aZBP'));

});

parcelRegister("1Ba8p", function(module, exports) {

let $12a11bad24bb9644$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $12a11bad24bb9644$var$load("8JZKd"),
    $12a11bad24bb9644$var$load("9LI4y"),
    $12a11bad24bb9644$var$load("iQkbX")
]).then(()=>parcelRequire('5rq0t'));

});

parcelRegister("cFFVJ", function(module, exports) {

let $9399d6d5ae8bd541$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9399d6d5ae8bd541$var$load("8JZKd"),
    $9399d6d5ae8bd541$var$load("iGFLn"),
    $9399d6d5ae8bd541$var$load("i2eRZ")
]).then(()=>parcelRequire('2QLXh'));

});

parcelRegister("5IhZv", function(module, exports) {

let $428f0476d25eaaa4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $428f0476d25eaaa4$var$load("8JZKd"),
    $428f0476d25eaaa4$var$load("32JUC")
]).then(()=>parcelRequire('5MACL'));

});

parcelRegister("k4Fvm", function(module, exports) {

let $e9d46056683b63db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e9d46056683b63db$var$load("8JZKd"),
    $e9d46056683b63db$var$load("e2ujj"),
    $e9d46056683b63db$var$load("fmD6y")
]).then(()=>parcelRequire('8ysYv'));

});

parcelRegister("9Qn5v", function(module, exports) {

let $72aae122ddeaa605$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $72aae122ddeaa605$var$load("8JZKd"),
    $72aae122ddeaa605$var$load("6wr18"),
    $72aae122ddeaa605$var$load("ffEVr"),
    $72aae122ddeaa605$var$load("jSJrn")
]).then(()=>parcelRequire('33aqb'));

});

parcelRegister("1OZ8l", function(module, exports) {

let $1539e1c9d12d26a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1539e1c9d12d26a7$var$load("8JZKd"),
    $1539e1c9d12d26a7$var$load("6wr18"),
    $1539e1c9d12d26a7$var$load("ffEVr"),
    $1539e1c9d12d26a7$var$load("h99tz")
]).then(()=>parcelRequire('gKToq'));

});

parcelRegister("dym3N", function(module, exports) {

let $9ddf900bf7c2ef11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9ddf900bf7c2ef11$var$load("8JZKd"),
    $9ddf900bf7c2ef11$var$load("6wr18"),
    $9ddf900bf7c2ef11$var$load("ffEVr"),
    $9ddf900bf7c2ef11$var$load("9x17X")
]).then(()=>parcelRequire('kaqd0'));

});

parcelRegister("9pplp", function(module, exports) {

let $6d9a1bb6a89786f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6d9a1bb6a89786f8$var$load("8JZKd"),
    $6d9a1bb6a89786f8$var$load("lTwVO")
]).then(()=>parcelRequire('4xFCz'));

});

parcelRegister("d37sc", function(module, exports) {

let $980156598212830c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $980156598212830c$var$load("8JZKd"),
    $980156598212830c$var$load("48rvp"),
    $980156598212830c$var$load("aOHmb")
]).then(()=>parcelRequire('9RjLU'));

});

parcelRegister("451HB", function(module, exports) {

let $2f88f31ad50a4292$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2f88f31ad50a4292$var$load("8JZKd"),
    $2f88f31ad50a4292$var$load("3VL8p")
]).then(()=>parcelRequire('2K9q0'));

});

parcelRegister("6mTtW", function(module, exports) {

let $4a2fd5b28eb11494$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4a2fd5b28eb11494$var$load("8JZKd"),
    $4a2fd5b28eb11494$var$load("6wr18"),
    $4a2fd5b28eb11494$var$load("ffEVr"),
    $4a2fd5b28eb11494$var$load("cpKS3")
]).then(()=>parcelRequire('3bV1Q'));

});

parcelRegister("2Kg3i", function(module, exports) {

let $1ffc54421cd86e8d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1ffc54421cd86e8d$var$load("8JZKd"),
    $1ffc54421cd86e8d$var$load("6wr18"),
    $1ffc54421cd86e8d$var$load("ffEVr"),
    $1ffc54421cd86e8d$var$load("5tWQe")
]).then(()=>parcelRequire('4HvFx'));

});

parcelRegister("eN6JR", function(module, exports) {

let $ac4ade6e5f9262a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ac4ade6e5f9262a6$var$load("8JZKd"),
    $ac4ade6e5f9262a6$var$load("513ba")
]).then(()=>parcelRequire('5MyoV'));

});

parcelRegister("9bQbY", function(module, exports) {

let $6b0da0680b36826d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6b0da0680b36826d$var$load("8JZKd"),
    $6b0da0680b36826d$var$load("6wr18"),
    $6b0da0680b36826d$var$load("ffEVr"),
    $6b0da0680b36826d$var$load("3vYMs")
]).then(()=>parcelRequire('ekFKF'));

});

parcelRegister("jnlDm", function(module, exports) {

let $e1b0f2562b112c85$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e1b0f2562b112c85$var$load("8JZKd"),
    $e1b0f2562b112c85$var$load("7DbhO")
]).then(()=>parcelRequire('6yqQG'));

});

parcelRegister("jOZLF", function(module, exports) {

let $e6e299a24983850e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e6e299a24983850e$var$load("8JZKd"),
    $e6e299a24983850e$var$load("4JM6n")
]).then(()=>parcelRequire('2L1tP'));

});

parcelRegister("6aCvX", function(module, exports) {

let $47e18d6e53e923ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $47e18d6e53e923ec$var$load("8JZKd"),
    $47e18d6e53e923ec$var$load("6wr18"),
    $47e18d6e53e923ec$var$load("ffEVr"),
    $47e18d6e53e923ec$var$load("kMc37")
]).then(()=>parcelRequire('95OKa'));

});

parcelRegister("dY0gO", function(module, exports) {

let $a2b11695763eea2a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a2b11695763eea2a$var$load("8JZKd"),
    $a2b11695763eea2a$var$load("5c5k7")
]).then(()=>parcelRequire('9RVYh'));

});

parcelRegister("cTyTb", function(module, exports) {

let $9635af585d870940$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9635af585d870940$var$load("8JZKd"),
    $9635af585d870940$var$load("fuKvq")
]).then(()=>parcelRequire('ipsZS'));

});

parcelRegister("6iZQ5", function(module, exports) {

let $497464750a205970$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $497464750a205970$var$load("8JZKd"),
    $497464750a205970$var$load("eZC0X")
]).then(()=>parcelRequire('bXDj3'));

});

parcelRegister("5htpY", function(module, exports) {

let $3d855c0df81345a5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3d855c0df81345a5$var$load("8JZKd"),
    $3d855c0df81345a5$var$load("lkZs8")
]).then(()=>parcelRequire('7kzZ3'));

});

parcelRegister("dvOcg", function(module, exports) {

let $9d651ba7c4cdd2b1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9d651ba7c4cdd2b1$var$load("8JZKd"),
    $9d651ba7c4cdd2b1$var$load("kTv6A")
]).then(()=>parcelRequire('hGK0I'));

});

parcelRegister("1iZbG", function(module, exports) {

let $0f36ef6e45d63972$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0f36ef6e45d63972$var$load("8JZKd"),
    $0f36ef6e45d63972$var$load("duHli")
]).then(()=>parcelRequire('15HFc'));

});

parcelRegister("2fguq", function(module, exports) {

let $1a29c5fb435f08e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1a29c5fb435f08e1$var$load("8JZKd"),
    $1a29c5fb435f08e1$var$load("gxkWc")
]).then(()=>parcelRequire('dDJDQ'));

});

parcelRegister("haajr", function(module, exports) {

let $c7eb5eb671b5d836$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c7eb5eb671b5d836$var$load("8JZKd"),
    $c7eb5eb671b5d836$var$load("6wr18"),
    $c7eb5eb671b5d836$var$load("ffEVr"),
    $c7eb5eb671b5d836$var$load("acQiP")
]).then(()=>parcelRequire('3gPdG'));

});

parcelRegister("8QpYR", function(module, exports) {

let $67075542afbfd135$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $67075542afbfd135$var$load("8JZKd"),
    $67075542afbfd135$var$load("jNyUd"),
    $67075542afbfd135$var$load("hlgZa")
]).then(()=>parcelRequire('lAsab'));

});

parcelRegister("TgPF7", function(module, exports) {

let $0a6231b496176c5a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0a6231b496176c5a$var$load("8JZKd"),
    $0a6231b496176c5a$var$load("7kQoV")
]).then(()=>parcelRequire('gt9HV'));

});

parcelRegister("3tnHG", function(module, exports) {

let $2876779367b0b113$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2876779367b0b113$var$load("8JZKd"),
    $2876779367b0b113$var$load("5DQDD")
]).then(()=>parcelRequire('bRp3h'));

});

parcelRegister("6CWtz", function(module, exports) {

let $4d33a6c8c6f85f5b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4d33a6c8c6f85f5b$var$load("8JZKd"),
    $4d33a6c8c6f85f5b$var$load("lKIR9")
]).then(()=>parcelRequire('jNfTW'));

});

parcelRegister("fO6ZF", function(module, exports) {

let $b820f35311ff91f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b820f35311ff91f6$var$load("8JZKd"),
    $b820f35311ff91f6$var$load("lRtGG"),
    $b820f35311ff91f6$var$load("l8LL6")
]).then(()=>parcelRequire('bKXvo'));

});

parcelRegister("7r8ra", function(module, exports) {

let $0165b4061689f79b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0165b4061689f79b$var$load("8JZKd"),
    $0165b4061689f79b$var$load("j91mf")
]).then(()=>parcelRequire('fBv4g'));

});

parcelRegister("95BBF", function(module, exports) {

let $69e1c091d5e8624b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $69e1c091d5e8624b$var$load("8JZKd"),
    $69e1c091d5e8624b$var$load("6wr18"),
    $69e1c091d5e8624b$var$load("ffEVr"),
    $69e1c091d5e8624b$var$load("lvdR8")
]).then(()=>parcelRequire('crcDg'));

});

parcelRegister("1rx2U", function(module, exports) {

let $10d1f249e78c3b5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $10d1f249e78c3b5d$var$load("8JZKd"),
    $10d1f249e78c3b5d$var$load("6trI7")
]).then(()=>parcelRequire('7rrdI'));

});

parcelRegister("dS5lO", function(module, exports) {

let $a1947817d5d7bd0f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a1947817d5d7bd0f$var$load("8JZKd"),
    $a1947817d5d7bd0f$var$load("5zCZE")
]).then(()=>parcelRequire('3QhJU'));

});

parcelRegister("k1OQc", function(module, exports) {

let $e94b5693fdb69210$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e94b5693fdb69210$var$load("8JZKd"),
    $e94b5693fdb69210$var$load("gSaV1")
]).then(()=>parcelRequire('5GDNB'));

});

parcelRegister("cxfMk", function(module, exports) {

let $9204ce62e86d00bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9204ce62e86d00bf$var$load("8JZKd"),
    $9204ce62e86d00bf$var$load("dxwAu")
]).then(()=>parcelRequire('gRg7d'));

});

parcelRegister("aNO2q", function(module, exports) {

let $7dd54b7e54f685bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7dd54b7e54f685bb$var$load("8JZKd"),
    $7dd54b7e54f685bb$var$load("0307d")
]).then(()=>parcelRequire('cYjkU'));

});

parcelRegister("bXzOw", function(module, exports) {

let $8b50fc43b3c13ead$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8b50fc43b3c13ead$var$load("8JZKd"),
    $8b50fc43b3c13ead$var$load("6wr18"),
    $8b50fc43b3c13ead$var$load("ffEVr"),
    $8b50fc43b3c13ead$var$load("kinTi")
]).then(()=>parcelRequire('9coBC'));

});

parcelRegister("7x6ip", function(module, exports) {

let $57c07fb1da9ff3dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $57c07fb1da9ff3dc$var$load("8JZKd"),
    $57c07fb1da9ff3dc$var$load("bWcRJ")
]).then(()=>parcelRequire('kd3D9'));

});

parcelRegister("cKhAb", function(module, exports) {

let $94776b790c237ea3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $94776b790c237ea3$var$load("8JZKd"),
    $94776b790c237ea3$var$load("dD4ld")
]).then(()=>parcelRequire('7LKLe'));

});

parcelRegister("4zF14", function(module, exports) {

let $354a3f4ee0a1919a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $354a3f4ee0a1919a$var$load("8JZKd"),
    $354a3f4ee0a1919a$var$load("h71ah")
]).then(()=>parcelRequire('4x46F'));

});

parcelRegister("a4lfW", function(module, exports) {

let $754ac41ac3393daf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $754ac41ac3393daf$var$load("8JZKd"),
    $754ac41ac3393daf$var$load("gpyq7")
]).then(()=>parcelRequire('3f9CL'));

});

parcelRegister("04vC5", function(module, exports) {

let $00d8e598a29b71e8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $00d8e598a29b71e8$var$load("8JZKd"),
    $00d8e598a29b71e8$var$load("hwluq")
]).then(()=>parcelRequire('cubS7'));

});

parcelRegister("b6q3y", function(module, exports) {

let $8154777d75c73cbc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8154777d75c73cbc$var$load("8JZKd"),
    $8154777d75c73cbc$var$load("6wr18"),
    $8154777d75c73cbc$var$load("ffEVr"),
    $8154777d75c73cbc$var$load("llPKJ")
]).then(()=>parcelRequire('jGdzU'));

});

parcelRegister("6d1Wp", function(module, exports) {

let $4855766fa92a7cff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4855766fa92a7cff$var$load("8JZKd"),
    $4855766fa92a7cff$var$load("iLtTR")
]).then(()=>parcelRequire('8Q3VW'));

});

parcelRegister("bueET", function(module, exports) {

let $85cdddf0dbeb0f99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $85cdddf0dbeb0f99$var$load("8JZKd"),
    $85cdddf0dbeb0f99$var$load("7jH9e")
]).then(()=>parcelRequire('7vcce'));

});

parcelRegister("iDM7l", function(module, exports) {

let $d921319d8f49a452$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d921319d8f49a452$var$load("8JZKd"),
    $d921319d8f49a452$var$load("cpn8T")
]).then(()=>parcelRequire('haABh'));

});

parcelRegister("fJMLJ", function(module, exports) {

let $b750e372e3c59f84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b750e372e3c59f84$var$load("8JZKd"),
    $b750e372e3c59f84$var$load("cQVlr")
]).then(()=>parcelRequire('6cfbi'));

});

parcelRegister("cEJVR", function(module, exports) {

let $936cd9a2ba1011f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $936cd9a2ba1011f5$var$load("8JZKd"),
    $936cd9a2ba1011f5$var$load("lpfAf")
]).then(()=>parcelRequire('3bb5K'));

});

parcelRegister("1lydi", function(module, exports) {

let $0fb24ab139113218$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0fb24ab139113218$var$load("8JZKd"),
    $0fb24ab139113218$var$load("6wr18"),
    $0fb24ab139113218$var$load("ffEVr"),
    $0fb24ab139113218$var$load("8lF3J")
]).then(()=>parcelRequire('hYhtq'));

});

parcelRegister("jYvn2", function(module, exports) {

let $e8abf46fd73e409c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e8abf46fd73e409c$var$load("8JZKd"),
    $e8abf46fd73e409c$var$load("7lyIx")
]).then(()=>parcelRequire('4XWss'));

});

parcelRegister("bleZq", function(module, exports) {

let $841d488bff456783$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $841d488bff456783$var$load("8JZKd"),
    $841d488bff456783$var$load("4x0L6")
]).then(()=>parcelRequire('fXYLR'));

});

parcelRegister("7i7Nt", function(module, exports) {

let $54f043288eaac54e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $54f043288eaac54e$var$load("8JZKd"),
    $54f043288eaac54e$var$load("3uTnS")
]).then(()=>parcelRequire('4NVxh'));

});

parcelRegister("37gQz", function(module, exports) {

let $244f17fd92f4f7a9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $244f17fd92f4f7a9$var$load("8JZKd"),
    $244f17fd92f4f7a9$var$load("jle6Z"),
    $244f17fd92f4f7a9$var$load("lmFmb")
]).then(()=>parcelRequire('4MjXY'));

});

parcelRegister("bWFpF", function(module, exports) {

let $8b253c40b0fe4dfc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8b253c40b0fe4dfc$var$load("8JZKd"),
    $8b253c40b0fe4dfc$var$load("g0jqS")
]).then(()=>parcelRequire('195qZ'));

});

parcelRegister("4lnj7", function(module, exports) {

let $329b33f09d15949d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $329b33f09d15949d$var$load("8JZKd"),
    $329b33f09d15949d$var$load("6wr18"),
    $329b33f09d15949d$var$load("ffEVr"),
    $329b33f09d15949d$var$load("4ODyJ")
]).then(()=>parcelRequire('60Odx'));

});

parcelRegister("2n0Oi", function(module, exports) {

let $1b9e5ba511885a14$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1b9e5ba511885a14$var$load("8JZKd"),
    $1b9e5ba511885a14$var$load("jBtK5")
]).then(()=>parcelRequire('gWDJV'));

});

parcelRegister("bIvLX", function(module, exports) {

let $887c7325385d85bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $887c7325385d85bc$var$load("8JZKd"),
    $887c7325385d85bc$var$load("6wr18"),
    $887c7325385d85bc$var$load("ffEVr"),
    $887c7325385d85bc$var$load("l3kSC")
]).then(()=>parcelRequire('5Mwkx'));

});

parcelRegister("2nHVr", function(module, exports) {

let $1bbfcd6f64ec5de3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1bbfcd6f64ec5de3$var$load("8JZKd"),
    $1bbfcd6f64ec5de3$var$load("adH3p"),
    $1bbfcd6f64ec5de3$var$load("gP6i7")
]).then(()=>parcelRequire('2rHP3'));

});

parcelRegister("gCCjj", function(module, exports) {

let $c19de998920eed04$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c19de998920eed04$var$load("8JZKd"),
    $c19de998920eed04$var$load("41WZS")
]).then(()=>parcelRequire('ktB7u'));

});

parcelRegister("dWdaC", function(module, exports) {

let $a25ae881c705fd8d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a25ae881c705fd8d$var$load("8JZKd"),
    $a25ae881c705fd8d$var$load("aBZVG")
]).then(()=>parcelRequire('jEno1'));

});

parcelRegister("V6sZ3", function(module, exports) {

let $0aba57180e349bd2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0aba57180e349bd2$var$load("8JZKd"),
    $0aba57180e349bd2$var$load("6wr18"),
    $0aba57180e349bd2$var$load("ffEVr"),
    $0aba57180e349bd2$var$load("3z4WK")
]).then(()=>parcelRequire('9cHXw'));

});

parcelRegister("5s8Sp", function(module, exports) {

let $3f8673f8da0419b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3f8673f8da0419b5$var$load("8JZKd"),
    $3f8673f8da0419b5$var$load("6wr18"),
    $3f8673f8da0419b5$var$load("ffEVr"),
    $3f8673f8da0419b5$var$load("aL59j")
]).then(()=>parcelRequire('14Meb'));

});

parcelRegister("j0o9v", function(module, exports) {

let $dd60c094968391a9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dd60c094968391a9$var$load("8JZKd"),
    $dd60c094968391a9$var$load("gwFU3")
]).then(()=>parcelRequire('8gU8P'));

});

parcelRegister("hqIGy", function(module, exports) {

let $cb0786f3e46117bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cb0786f3e46117bf$var$load("8JZKd"),
    $cb0786f3e46117bf$var$load("4Jbf1"),
    $cb0786f3e46117bf$var$load("eelW7")
]).then(()=>parcelRequire('3Z8XG'));

});

parcelRegister("8EJmE", function(module, exports) {

let $64d53f93efbeb44e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $64d53f93efbeb44e$var$load("8JZKd"),
    $64d53f93efbeb44e$var$load("ebebP")
]).then(()=>parcelRequire('i2nZ3'));

});

parcelRegister("3tXvA", function(module, exports) {

let $28923daee620ec88$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $28923daee620ec88$var$load("8JZKd"),
    $28923daee620ec88$var$load("9UmxH")
]).then(()=>parcelRequire('jwRB3'));

});

parcelRegister("0229H", function(module, exports) {

let $0061dc0a43c92a30$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0061dc0a43c92a30$var$load("8JZKd"),
    $0061dc0a43c92a30$var$load("6wr18"),
    $0061dc0a43c92a30$var$load("ffEVr"),
    $0061dc0a43c92a30$var$load("63Cs1")
]).then(()=>parcelRequire('hOcku'));

});

parcelRegister("eiqfv", function(module, exports) {

let $a6871bacfc5a2609$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a6871bacfc5a2609$var$load("8JZKd"),
    $a6871bacfc5a2609$var$load("6wr18"),
    $a6871bacfc5a2609$var$load("ffEVr"),
    $a6871bacfc5a2609$var$load("3DjfH")
]).then(()=>parcelRequire('h9Ymt'));

});

parcelRegister("jQJtd", function(module, exports) {

let $e7362513c08e1bd9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e7362513c08e1bd9$var$load("eeFSJ").then(()=>parcelRequire('gQMaD'));

});

parcelRegister("e6w7G", function(module, exports) {

let $a44a8b2afa568976$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a44a8b2afa568976$var$load("2ABJz").then(()=>parcelRequire('7Shff'));

});

parcelRegister("gdchC", function(module, exports) {

let $bcd7636cb53057f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bcd7636cb53057f3$var$load("h9Ycm").then(()=>parcelRequire('8joEn'));

});

parcelRegister("1cFTA", function(module, exports) {

let $0e0769024f075167$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0e0769024f075167$var$load("bdfLA").then(()=>parcelRequire('akTVo'));

});

parcelRegister("b0Ise", function(module, exports) {

let $80422d8236d2dafb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $80422d8236d2dafb$var$load("fzHDF").then(()=>parcelRequire('4WZ5N'));

});

parcelRegister("eLqYE", function(module, exports) {

let $abfa61970e0f708c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $abfa61970e0f708c$var$load("a08Vk").then(()=>parcelRequire('h3IRN'));

});

parcelRegister("8DfOo", function(module, exports) {

let $648e3b217aa3a33a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $648e3b217aa3a33a$var$load("GO1NB").then(()=>parcelRequire('hbHIR'));

});

parcelRegister("6xnVZ", function(module, exports) {

let $4c2863fc25953fb4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c2863fc25953fb4$var$load("5wzlX").then(()=>parcelRequire('i9WT6'));

});

parcelRegister("4CZNu", function(module, exports) {

let $35eaa5ab44fe445c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $35eaa5ab44fe445c$var$load("5uN9h").then(()=>parcelRequire('69PnT'));

});

parcelRegister("8OGHW", function(module, exports) {

let $66b41f16e830c814$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $66b41f16e830c814$var$load("1yrlK").then(()=>parcelRequire('2LFoe'));

});

parcelRegister("7G4aF", function(module, exports) {

let $596fb0ed977b47d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $596fb0ed977b47d6$var$load("5t3NJ").then(()=>parcelRequire('549Do'));

});

parcelRegister("7sOJP", function(module, exports) {

let $56f2817a66b2b2a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $56f2817a66b2b2a8$var$load("8bkDf").then(()=>parcelRequire('3NfW0'));

});

parcelRegister("bUUKB", function(module, exports) {

let $8ad0f22d78bb8f65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8ad0f22d78bb8f65$var$load("eEyVs").then(()=>parcelRequire('9D6Kx'));

});

parcelRegister("ji6i4", function(module, exports) {

let $e0b493e7dacf4679$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e0b493e7dacf4679$var$load("5BMnr").then(()=>parcelRequire('6uENn'));

});

parcelRegister("jaRFf", function(module, exports) {

let $df5894198345712c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df5894198345712c$var$load("WOIba").then(()=>parcelRequire('k0doW'));

});

parcelRegister("dVZCY", function(module, exports) {

let $a25067326f40a234$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a25067326f40a234$var$load("3wI9H").then(()=>parcelRequire('jo350'));

});

parcelRegister("ffvn3", function(module, exports) {

let $b1a0974e4bc86442$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b1a0974e4bc86442$var$load("gRwQ3").then(()=>parcelRequire('bQGuP'));

});

parcelRegister("eGJQ1", function(module, exports) {

let $ab188b69e8b951d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ab188b69e8b951d6$var$load("5cBQs").then(()=>parcelRequire('7oLdW'));

});

parcelRegister("fJZGy", function(module, exports) {

let $b75ae8656d3339f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b75ae8656d3339f6$var$load("bneOJ").then(()=>parcelRequire('ibWo3'));

});

parcelRegister("8sr2T", function(module, exports) {

let $6285eaf809731400$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6285eaf809731400$var$load("8vVzT").then(()=>parcelRequire('4DzVW'));

});

parcelRegister("fa9KH", function(module, exports) {

let $b09f5ac79d769e80$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b09f5ac79d769e80$var$load("6jw5Q").then(()=>parcelRequire('lTRsf'));

});

parcelRegister("g6iJ6", function(module, exports) {

let $bb8bbb8a3302d433$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bb8bbb8a3302d433$var$load("aMMhv").then(()=>parcelRequire('l5aUM'));

});

parcelRegister("jYcoW", function(module, exports) {

let $e89d3d92e927718a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e89d3d92e927718a$var$load("8UKe0").then(()=>parcelRequire('cyLm6'));

});

parcelRegister("7mL7x", function(module, exports) {

let $55cf23a4ed0ed185$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55cf23a4ed0ed185$var$load("1WVCN").then(()=>parcelRequire('jkipX'));

});

parcelRegister("4J3F1", function(module, exports) {

let $370e3451b84c6bee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $370e3451b84c6bee$var$load("fix5E").then(()=>parcelRequire('fPK4h'));

});

parcelRegister("aAESG", function(module, exports) {

let $7b5cfa4c4dea21d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7b5cfa4c4dea21d6$var$load("e0XLT").then(()=>parcelRequire('kHV97'));

});

parcelRegister("7unXI", function(module, exports) {

let $573dec22ec9e4fb7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $573dec22ec9e4fb7$var$load("c4vbc").then(()=>parcelRequire('1utEm'));

});

parcelRegister("604Ea", function(module, exports) {

let $45e658e8d9f2d4fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $45e658e8d9f2d4fe$var$load("9LQGG").then(()=>parcelRequire('lnqHu'));

});

parcelRegister("knmQ0", function(module, exports) {

let $ed57abc2f53906f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ed57abc2f53906f2$var$load("6J6Ti").then(()=>parcelRequire('bomBS'));

});

parcelRegister("f81oT", function(module, exports) {

let $b038b075b667d4a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b038b075b667d4a3$var$load("agAjs").then(()=>parcelRequire('h8GF6'));

});

parcelRegister("fceec", function(module, exports) {

let $b103035f3618c600$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b103035f3618c600$var$load("4Viii").then(()=>parcelRequire('fEibl'));

});

parcelRegister("aCNkh", function(module, exports) {

let $7bc3b71e0b103ca6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7bc3b71e0b103ca6$var$load("eeaKR").then(()=>parcelRequire('i3uiK'));

});

parcelRegister("18OQC", function(module, exports) {

let $0d4dfb1188e1f999$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d4dfb1188e1f999$var$load("aoczY").then(()=>parcelRequire('7zoWf'));

});

parcelRegister("72moH", function(module, exports) {

let $51fa17f816d92e52$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $51fa17f816d92e52$var$load("hWZz2").then(()=>parcelRequire('33kXB'));

});

parcelRegister("2ZpXN", function(module, exports) {

let $22d56b0e6f037f0f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $22d56b0e6f037f0f$var$load("l8LQp").then(()=>parcelRequire('jk4YF'));

});

parcelRegister("jfQIq", function(module, exports) {

let $e0484f42c86901a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e0484f42c86901a4$var$load("1CRbg").then(()=>parcelRequire('ejLrs'));

});

parcelRegister("70OpD", function(module, exports) {

let $51afa356db93048f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $51afa356db93048f$var$load("f2Cco").then(()=>parcelRequire('3Y6Au'));

});

parcelRegister("dbed0", function(module, exports) {

let $998752fcdd587991$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $998752fcdd587991$var$load("1Qnbg").then(()=>parcelRequire('fvDx3'));

});

parcelRegister("5dkIb", function(module, exports) {

let $3cbe3b8dbe28ae55$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3cbe3b8dbe28ae55$var$load("gjVBG").then(()=>parcelRequire('k8Fbb'));

});

parcelRegister("hDRFY", function(module, exports) {

let $cd7fb71f08678b9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd7fb71f08678b9b$var$load("ciYLs").then(()=>parcelRequire('4jUBz'));

});

parcelRegister("jbxTW", function(module, exports) {

let $df79577af3dea273$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df79577af3dea273$var$load("8l69A").then(()=>parcelRequire('7xkxF'));

});

parcelRegister("isxcK", function(module, exports) {

let $d7049947037a5931$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d7049947037a5931$var$load("hHrTM").then(()=>parcelRequire('2MNkP'));

});

parcelRegister("k3i7k", function(module, exports) {

let $e992242aff75c1bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e992242aff75c1bc$var$load("f11F6").then(()=>parcelRequire('oUNja'));

});

parcelRegister("80Dj5", function(module, exports) {

let $5d4cd0532c0a1e5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5d4cd0532c0a1e5d$var$load("9lBT0").then(()=>parcelRequire('eKi5T'));

});

parcelRegister("gNnOD", function(module, exports) {

let $c3a3b239cfa20306$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c3a3b239cfa20306$var$load("e2ujj").then(()=>parcelRequire('fCjCI'));

});

parcelRegister("ahwKL", function(module, exports) {

let $77c4e60a83cbd22f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $77c4e60a83cbd22f$var$load("3kUQf").then(()=>parcelRequire('aRCWA'));

});

parcelRegister("ehzTm", function(module, exports) {

let $a65e7e9efa0c7777$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a65e7e9efa0c7777$var$load("9mBQe").then(()=>parcelRequire('1ljzV'));

});

parcelRegister("92bYU", function(module, exports) {

let $693d9835dc53d05a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $693d9835dc53d05a$var$load("r2GGB").then(()=>parcelRequire('1jjJq'));

});

parcelRegister("1gLpn", function(module, exports) {

let $0ecc0f62e9601e33$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ecc0f62e9601e33$var$load("aNM5M").then(()=>parcelRequire('dqRYQ'));

});

parcelRegister("4ndNn", function(module, exports) {

let $32f402dcbcf7747f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $32f402dcbcf7747f$var$load("ekw50").then(()=>parcelRequire('aJoMX'));

});

parcelRegister("drcCL", function(module, exports) {

let $9c8796e69b0d6787$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9c8796e69b0d6787$var$load("iFEfD").then(()=>parcelRequire('26itv'));

});

parcelRegister("65ATH", function(module, exports) {

let $46efd4c42c94673b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $46efd4c42c94673b$var$load("kSI4e").then(()=>parcelRequire('gfPZB'));

});

parcelRegister("dTOT4", function(module, exports) {

let $a1e7e29330497323$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a1e7e29330497323$var$load("f1x0y").then(()=>parcelRequire('c8wfa'));

});

parcelRegister("aq8nA", function(module, exports) {

let $7962d515b35ed5bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7962d515b35ed5bd$var$load("j2bbk").then(()=>parcelRequire('5csm1'));

});

parcelRegister("eNNHQ", function(module, exports) {

let $ac6c32e5c80c429d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac6c32e5c80c429d$var$load("k97iL").then(()=>parcelRequire('lFkSe'));

});

parcelRegister("beZCo", function(module, exports) {

let $82f0cca32111607d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $82f0cca32111607d$var$load("a4yJG").then(()=>parcelRequire('eG1e2'));

});

parcelRegister("2CaDj", function(module, exports) {

let $1e7760e1b1d31574$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1e7760e1b1d31574$var$load("3TFqP").then(()=>parcelRequire('4JtPF'));

});

parcelRegister("hCcYS", function(module, exports) {

let $cd300dfcc82e8939$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd300dfcc82e8939$var$load("hpePq").then(()=>parcelRequire('avrhI'));

});

parcelRegister("9bwTb", function(module, exports) {

let $6afea73db44698ba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6afea73db44698ba$var$load("bFS2f").then(()=>parcelRequire('bz48R'));

});

parcelRegister("3ZQBR", function(module, exports) {

let $2e8fe0caf2b88b29$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2e8fe0caf2b88b29$var$load("81eQE").then(()=>parcelRequire('la4Nn'));

});

parcelRegister("cunhZ", function(module, exports) {

let $917a5a1ad7a54edd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $917a5a1ad7a54edd$var$load("crVgG").then(()=>parcelRequire('5Vlto'));

});

parcelRegister("kuKNT", function(module, exports) {

let $eebaea3fe92b9da8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eebaea3fe92b9da8$var$load("9tCGc").then(()=>parcelRequire('garUX'));

});

parcelRegister("T2nmi", function(module, exports) {

let $0a56faf1a6f626d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0a56faf1a6f626d7$var$load("7ouuO").then(()=>parcelRequire('6S3N0'));

});

parcelRegister("1A1QP", function(module, exports) {

let $126a96d6c475aa05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $126a96d6c475aa05$var$load("ibVcz").then(()=>parcelRequire('4vzBZ'));

});

parcelRegister("3miR4", function(module, exports) {

let $27220d5c79e8f6c7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $27220d5c79e8f6c7$var$load("1Pok1").then(()=>parcelRequire('8UTuu'));

});

parcelRegister("fxxLt", function(module, exports) {

let $b504210cc115ddec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b504210cc115ddec$var$load("iYnaF").then(()=>parcelRequire('ltbyB'));

});

parcelRegister("mZICS", function(module, exports) {

let $0451ee406cfc17e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0451ee406cfc17e0$var$load("cqT0F").then(()=>parcelRequire('g8gEr'));

});

parcelRegister("kURs4", function(module, exports) {

let $f3a28009260eef94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3a28009260eef94$var$load("iMSgb").then(()=>parcelRequire('ilSNM'));

});

parcelRegister("9aQcQ", function(module, exports) {

let $6add8b484fb90400$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6add8b484fb90400$var$load("kTnVa").then(()=>parcelRequire('jK29N'));

});

parcelRegister("eWBDn", function(module, exports) {

let $ae13acd64f927867$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ae13acd64f927867$var$load("ifibj").then(()=>parcelRequire('fkv8d'));

});

parcelRegister("fzApj", function(module, exports) {

let $b5665da5893dea78$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b5665da5893dea78$var$load("2Mq3f").then(()=>parcelRequire('6fjxX'));

});

parcelRegister("3mxkw", function(module, exports) {

let $272d47d3be217e93$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $272d47d3be217e93$var$load("6HxBR").then(()=>parcelRequire('2KFft'));

});

parcelRegister("3xZwm", function(module, exports) {

let $29542cf4ec9803db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $29542cf4ec9803db$var$load("2Gceu").then(()=>parcelRequire('bvjDB'));

});

parcelRegister("jP7Dr", function(module, exports) {

let $e6e8b3ef8b9a5daf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e6e8b3ef8b9a5daf$var$load("jtwfh").then(()=>parcelRequire('6ZUmE'));

});

parcelRegister("hRm77", function(module, exports) {

let $d0088a3cf576d203$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d0088a3cf576d203$var$load("4mgLr").then(()=>parcelRequire('e66a9'));

});

parcelRegister("ved2s", function(module, exports) {

let $05ddeb092db22da9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $05ddeb092db22da9$var$load("6upDJ").then(()=>parcelRequire('35obO'));

});

parcelRegister("8hglZ", function(module, exports) {

let $606c98c6618abd5c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $606c98c6618abd5c$var$load("jtcRz").then(()=>parcelRequire('h5al3'));

});

parcelRegister("58GSK", function(module, exports) {

let $3bdef699839ed9ab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3bdef699839ed9ab$var$load("becB8").then(()=>parcelRequire('172dN'));

});

parcelRegister("2O1J1", function(module, exports) {

let $20b196de3761ac1f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $20b196de3761ac1f$var$load("eovHv").then(()=>parcelRequire('hR87Z'));

});

parcelRegister("1PFGt", function(module, exports) {

let $155ae377ae02081d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $155ae377ae02081d$var$load("19uFC").then(()=>parcelRequire('bTdbD'));

});

parcelRegister("22P78", function(module, exports) {

let $17d36adc955169cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $17d36adc955169cf$var$load("4drdS").then(()=>parcelRequire('lLRaS'));

});

parcelRegister("cZ1wW", function(module, exports) {

let $973c5e691f5abbf8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $973c5e691f5abbf8$var$load("iZ7F9").then(()=>parcelRequire('2YvUG'));

});

parcelRegister("do1Cc", function(module, exports) {

let $9beec4f7b450ddc1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9beec4f7b450ddc1$var$load("iDB1L").then(()=>parcelRequire('lM0k7'));

});

parcelRegister("kMEmh", function(module, exports) {

let $f21798a7023c2d22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f21798a7023c2d22$var$load("fjOTL").then(()=>parcelRequire('cDMVr'));

});

parcelRegister("pt6v8", function(module, exports) {

let $04c8e955877b500e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $04c8e955877b500e$var$load("4rKYa").then(()=>parcelRequire('l8mxb'));

});

parcelRegister("1Fdl4", function(module, exports) {

let $1363f79985da2c54$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1363f79985da2c54$var$load("gkHyQ").then(()=>parcelRequire('7Otbp'));

});

parcelRegister("9QIq8", function(module, exports) {

let $72bb6d62b272755e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $72bb6d62b272755e$var$load("4EFsN").then(()=>parcelRequire('dTezu'));

});

parcelRegister("h17X9", function(module, exports) {

let $c638b2f3e17195ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c638b2f3e17195ac$var$load("aE4di").then(()=>parcelRequire('k8wt9'));

});

parcelRegister("4AXoN", function(module, exports) {

let $3588999b6014b786$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3588999b6014b786$var$load("fZldR").then(()=>parcelRequire('1CbwT'));

});

parcelRegister("12wyz", function(module, exports) {

let $0c1f3b6ace5d21ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0c1f3b6ace5d21ea$var$load("jwSno").then(()=>parcelRequire('3KUzn'));

});

parcelRegister("7cZ4v", function(module, exports) {

let $53f906fb030af788$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $53f906fb030af788$var$load("fGvqc").then(()=>parcelRequire('6Izja'));

});

parcelRegister("1vwzF", function(module, exports) {

let $1191f441d4ee3c5c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1191f441d4ee3c5c$var$load("ggA0n").then(()=>parcelRequire('1lutJ'));

});

parcelRegister("dj5Z1", function(module, exports) {

let $9b01b0d56c559c22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9b01b0d56c559c22$var$load("3WvIq").then(()=>parcelRequire('j612B'));

});

parcelRegister("h2qUl", function(module, exports) {

let $c6777eec1b0ad477$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c6777eec1b0ad477$var$load("1Ll72").then(()=>parcelRequire('1qIfR'));

});

parcelRegister("Mud1L", function(module, exports) {

let $091beab62993c493$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $091beab62993c493$var$load("3yhAw").then(()=>parcelRequire('7wN2t'));

});

parcelRegister("3np9B", function(module, exports) {

let $27570823520274ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $27570823520274ee$var$load("6hW9n").then(()=>parcelRequire('b6O1u'));

});

parcelRegister("csTMY", function(module, exports) {

let $9133600d4505bbb1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9133600d4505bbb1$var$load("49C5w").then(()=>parcelRequire('jQsne'));

});

parcelRegister("h7Bos", function(module, exports) {

let $c77018a870a04e62$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c77018a870a04e62$var$load("2ZYfI").then(()=>parcelRequire('b8JQ4'));

});

parcelRegister("cMLhW", function(module, exports) {

let $94eea63408e2832e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $94eea63408e2832e$var$load("g0XZO").then(()=>parcelRequire('6Xm0L'));

});

parcelRegister("jcBng", function(module, exports) {

let $dfac2106ee9353c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dfac2106ee9353c8$var$load("1EsE1").then(()=>parcelRequire('cDmEt'));

});

parcelRegister("3DthG", function(module, exports) {

let $2a5bbadbde7cdc84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2a5bbadbde7cdc84$var$load("bDP5R").then(()=>parcelRequire('9kLXx'));

});

parcelRegister("6E8pW", function(module, exports) {

let $4d6d0204a36cd6bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d6d0204a36cd6bd$var$load("l4YAS").then(()=>parcelRequire('f2ref'));

});

parcelRegister("6WWPa", function(module, exports) {

let $50f5ca23c29639be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $50f5ca23c29639be$var$load("dMOc8").then(()=>parcelRequire('5XpHP'));

});

parcelRegister("186Qe", function(module, exports) {

let $0d2bd8617a14a4d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d2bd8617a14a4d3$var$load("cSj9q").then(()=>parcelRequire('8uomH'));

});

parcelRegister("fJytx", function(module, exports) {

let $b745cd15e407b53a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b745cd15e407b53a$var$load("3opZo").then(()=>parcelRequire('2kmFP'));

});

parcelRegister("28PuG", function(module, exports) {

let $18f445b7e8d779ce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $18f445b7e8d779ce$var$load("kyUks").then(()=>parcelRequire('88Ffj'));

});

parcelRegister("g5Rb0", function(module, exports) {

let $bb765cb7b36355c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bb765cb7b36355c9$var$load("akTOz").then(()=>parcelRequire('2HXHP'));

});

parcelRegister("6W0dI", function(module, exports) {

let $50c8549a14c632f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $50c8549a14c632f7$var$load("jdWk3").then(()=>parcelRequire('kPlRa'));

});

parcelRegister("j7WtC", function(module, exports) {

let $decc080416c08175$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $decc080416c08175$var$load("945IO").then(()=>parcelRequire('dDVca'));

});

parcelRegister("lulFc", function(module, exports) {

let $fa4d344134009835$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fa4d344134009835$var$load("eRoc9").then(()=>parcelRequire('4CxKE'));

});

parcelRegister("hHCqO", function(module, exports) {

let $ce34438645ac4639$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ce34438645ac4639$var$load("gctwz").then(()=>parcelRequire('4GKfl'));

});

parcelRegister("1kcft", function(module, exports) {

let $0f712905628c3c80$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0f712905628c3c80$var$load("dQjUN").then(()=>parcelRequire('boxbG'));

});

parcelRegister("9KGGx", function(module, exports) {

let $7199854d824298f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7199854d824298f0$var$load("3xuDK").then(()=>parcelRequire('iKCDr'));

});

parcelRegister("c9fOS", function(module, exports) {

let $8d8298be9a46c9d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8d8298be9a46c9d6$var$load("1oAGT").then(()=>parcelRequire('heJQp'));

});

parcelRegister("i64Sl", function(module, exports) {

let $d2cc91b7843ec0fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d2cc91b7843ec0fe$var$load("QDkFg").then(()=>parcelRequire('3uA7H'));

});

parcelRegister("ePdXG", function(module, exports) {

let $acb0a896ecf1975e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $acb0a896ecf1975e$var$load("15N8O").then(()=>parcelRequire('cN7t9'));

});

parcelRegister("lf4xX", function(module, exports) {

let $f76e86909fae85d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f76e86909fae85d9$var$load("124I9").then(()=>parcelRequire('3HGjj'));

});

parcelRegister("gNsmn", function(module, exports) {

let $c3a7389d823fcf78$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c3a7389d823fcf78$var$load("ijPJo").then(()=>parcelRequire('g7f9W'));

});

parcelRegister("cMb72", function(module, exports) {

let $94d29673f8ce7d7e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $94d29673f8ce7d7e$var$load("lUlCu").then(()=>parcelRequire('gI8uy'));

});

parcelRegister("agfuz", function(module, exports) {

let $77876a6c0386549b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $77876a6c0386549b$var$load("3qsjq").then(()=>parcelRequire('kfYj7'));

});

parcelRegister("lDqsi", function(module, exports) {

let $fc01c2fec4bcb762$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fc01c2fec4bcb762$var$load("1pGC4").then(()=>parcelRequire('ifqTJ'));

});

parcelRegister("gfJPQ", function(module, exports) {

let $bd5199fd346934f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bd5199fd346934f6$var$load("xvDzM").then(()=>parcelRequire('aUEBE'));

});

parcelRegister("7vRpU", function(module, exports) {

let $5784dd27fa72f55d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5784dd27fa72f55d$var$load("8yLIX").then(()=>parcelRequire('jJ3pS'));

});

parcelRegister("OjCnH", function(module, exports) {

let $0973e35cfbfd8e1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0973e35cfbfd8e1e$var$load("a5PnA").then(()=>parcelRequire('lSioh'));

});

parcelRegister("jRJ8Y", function(module, exports) {

let $e765fc2575077e3f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e765fc2575077e3f$var$load("fiOV9").then(()=>parcelRequire('lY7ys'));

});

parcelRegister("j5eCx", function(module, exports) {

let $de49d346aed99d73$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de49d346aed99d73$var$load("dWFQg").then(()=>parcelRequire('6FING'));

});

parcelRegister("fC9Y7", function(module, exports) {

let $b5e22336c0ec2554$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b5e22336c0ec2554$var$load("j4CTh").then(()=>parcelRequire('4NZXC'));

});

parcelRegister("jrHYC", function(module, exports) {

let $e282a6c63619da9e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e282a6c63619da9e$var$load("67PqR").then(()=>parcelRequire('lFEej'));

});

parcelRegister("7pJZg", function(module, exports) {

let $565e8a476a1211c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $565e8a476a1211c2$var$load("4CfTY").then(()=>parcelRequire('28NpI'));

});

parcelRegister("rYjug", function(module, exports) {

let $05414eb29d80f517$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $05414eb29d80f517$var$load("eONDg").then(()=>parcelRequire('cLU2s'));

});

parcelRegister("lIVwe", function(module, exports) {

let $fd0a5319f7eae420$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd0a5319f7eae420$var$load("7Owog").then(()=>parcelRequire('lC9BK'));

});

parcelRegister("aho4H", function(module, exports) {

let $77be2ab0ef9d3474$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $77be2ab0ef9d3474$var$load("8Qv5g").then(()=>parcelRequire('cnlZf'));

});

parcelRegister("kfugR", function(module, exports) {

let $ebdcb08ce8f936c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ebdcb08ce8f936c0$var$load("ljaqI").then(()=>parcelRequire('hP5xt'));

});

parcelRegister("fmmjI", function(module, exports) {

let $b2ea38c7a96f8fad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b2ea38c7a96f8fad$var$load("1cGGc").then(()=>parcelRequire('jHTzX'));

});

parcelRegister("lBjOA", function(module, exports) {

let $fb9c6c83eb0bdfe3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fb9c6c83eb0bdfe3$var$load("ebISg").then(()=>parcelRequire('55KXF'));

});

parcelRegister("IkTBS", function(module, exports) {

let $085451ac28f7bdd0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $085451ac28f7bdd0$var$load("hBdsK").then(()=>parcelRequire('288Gr'));

});

parcelRegister("dYCDx", function(module, exports) {

let $a2ced961c9d10200$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a2ced961c9d10200$var$load("6aY84").then(()=>parcelRequire('7YEWU'));

});

parcelRegister("ijbGz", function(module, exports) {

let $d54310e2d32afc5a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d54310e2d32afc5a$var$load("lLK0D").then(()=>parcelRequire('hpDFj'));

});

parcelRegister("jDt7y", function(module, exports) {

let $e4b83fa362121b83$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e4b83fa362121b83$var$load("5CaYW").then(()=>parcelRequire('lOHzS'));

});

parcelRegister("j8awz", function(module, exports) {

let $ded6ed9852b772a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ded6ed9852b772a8$var$load("fisfU").then(()=>parcelRequire('hLeLq'));

});

parcelRegister("bRgbB", function(module, exports) {

let $8a2133339dc0b4f9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8a2133339dc0b4f9$var$load("3ZAtx").then(()=>parcelRequire('1f7Pm'));

});

parcelRegister("62oxM", function(module, exports) {

let $4655f7da19e6b57e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4655f7da19e6b57e$var$load("8gJl0").then(()=>parcelRequire('bqp2a'));

});

parcelRegister("hDtlp", function(module, exports) {

let $cd6cd75a89434fe2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd6cd75a89434fe2$var$load("lVBal").then(()=>parcelRequire('aolCq'));

});

parcelRegister("hqoci", function(module, exports) {

let $caf7a271af0d2061$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $caf7a271af0d2061$var$load("fZ3WI").then(()=>parcelRequire('immoC'));

});

parcelRegister("iAJDb", function(module, exports) {

let $d88efc2980b7b86d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d88efc2980b7b86d$var$load("7t5Ax").then(()=>parcelRequire('7xRSp'));

});

parcelRegister("7xAVg", function(module, exports) {

let $57d841892a047f20$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $57d841892a047f20$var$load("c52tG").then(()=>parcelRequire('5lbHB'));

});

parcelRegister("kJLXJ", function(module, exports) {

let $f18d36f5100cbcd9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f18d36f5100cbcd9$var$load("gM7lZ").then(()=>parcelRequire('dsxwV'));

});

parcelRegister("4rqtC", function(module, exports) {

let $33be38be117aaf2f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $33be38be117aaf2f$var$load("8Ned5").then(()=>parcelRequire('lm1k2'));

});

parcelRegister("igaQ6", function(module, exports) {

let $d4b2211b1503f96c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d4b2211b1503f96c$var$load("9LI4y").then(()=>parcelRequire('lnvJ5'));

});

parcelRegister("5ayJq", function(module, exports) {

let $3c38d3e7f2acc2ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3c38d3e7f2acc2ae$var$load("iGFLn").then(()=>parcelRequire('3OMt0'));

});

parcelRegister("cFlXM", function(module, exports) {

let $938a59d475de5622$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $938a59d475de5622$var$load("llcfA").then(()=>parcelRequire('gzpsB'));

});

parcelRegister("cOJPH", function(module, exports) {

let $954db4fcffd784be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $954db4fcffd784be$var$load("azCDs").then(()=>parcelRequire('7PhbA'));

});

parcelRegister("6pgd2", function(module, exports) {

let $4aa1a6b5ffd56ccf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4aa1a6b5ffd56ccf$var$load("lYvov"),
    $4aa1a6b5ffd56ccf$var$load("6wr18"),
    $4aa1a6b5ffd56ccf$var$load("7sx4A"),
    $4aa1a6b5ffd56ccf$var$load("k5bNG"),
    $4aa1a6b5ffd56ccf$var$load("ffEVr"),
    $4aa1a6b5ffd56ccf$var$load("lNb0L"),
    $4aa1a6b5ffd56ccf$var$load("bQUGu"),
    $4aa1a6b5ffd56ccf$var$load("slRZz")
]).then(()=>parcelRequire('4rnXZ'));

});

parcelRegister("aX7Hk", function(module, exports) {

let $7f9562b5d26d7b61$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7f9562b5d26d7b61$var$load("awqCy"),
    $7f9562b5d26d7b61$var$load("dTsOE"),
    $7f9562b5d26d7b61$var$load("7EorR"),
    $7f9562b5d26d7b61$var$load("19qJC")
]).then(()=>parcelRequire('jl3SG'));

});

parcelRegister("7pHhJ", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7EEGh = parcelRequire("7EEGh");


var $h9yJL = parcelRequire("h9yJL");


var $eTuC8 = parcelRequire("eTuC8");

const $f4dc0d6b8df1531b$export$5252bd745392dcde = (props)=>{
    const { onChange: onChange, defaultValue: defaultValue, features: features, isDisabled: isDisabled } = props.forgeDoc.props;
    const transformer = (0, $42omo.useMemo)(()=>new (0, $h9yJL.JSONTransformer)(), []);
    const { preset: preset } = (0, $eTuC8.usePresetByFeatures)('chromeless', features);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7EEGh.ChromelessEditor), {
        disabled: isDisabled,
        defaultValue: defaultValue,
        preset: preset,
        onChange: (editorView)=>{
            const jsonDocNode = transformer.encode(editorView.state.doc);
            onChange?.(jsonDocNode);
        }
    });
};
module.exports["ChromelessEditor"] = $f4dc0d6b8df1531b$export$5252bd745392dcde;

});

parcelRegister("ivfUe", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lesF8 = parcelRequire("lesF8");


var $eTuC8 = parcelRequire("eTuC8");

const $e8e906385914cd2a$export$4153d6fbc2386422 = (props)=>{
    const { onChange: onChange, defaultValue: defaultValue, features: features, isDisabled: isDisabled, onSave: onSave, onCancel: onCancel } = props.forgeDoc.props;
    const { preset: preset, editorApi: editorApi } = (0, $eTuC8.usePresetByFeatures)('comment', features);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lesF8.CommentEditor), {
        disabled: isDisabled,
        defaultValue: defaultValue,
        preset: preset,
        onSave: onSave ? ()=>{
            editorApi?.core.actions.requestDocument((jsonDocNode)=>{
                onSave?.(jsonDocNode);
            });
        } : undefined,
        onCancel: onCancel ? ()=>onCancel() : undefined,
        onChange: ()=>{
            editorApi?.core.actions.requestDocument((jsonDocNode)=>{
                onChange?.(jsonDocNode);
            });
        }
    });
};
module.exports["CommentEditor"] = $e8e906385914cd2a$export$4153d6fbc2386422;

});

parcelRegister("ha5sn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6jPem = parcelRequire("6jPem");


var $jRNsq = parcelRequire("jRNsq");


var $dh538 = parcelRequire("dh538");


var $67O0h = parcelRequire("67O0h");


var $lspPP = parcelRequire("lspPP");


var $er4dw = parcelRequire("er4dw");

var $fgm2d = parcelRequire("fgm2d");

var $kS0x0 = parcelRequire("kS0x0");

var $gGmck = parcelRequire("gGmck");

var $clpPd = parcelRequire("clpPd");

var $lMJg3 = parcelRequire("lMJg3");

var $kZjf5 = parcelRequire("kZjf5");

const $28b4b46ff5265566$var$filterInvalidMediaUrls = (appDomainName, egressServices, document)=>{
    const invalidUrls = new Set();
    const visitors = {
        media: (node)=>{
            const url = node?.attrs?.url;
            if (url && !egressServices.some((service)=>(0, $kS0x0.isValidImageUrl)(url, service, appDomainName))) {
                invalidUrls.add(url);
                return {
                    ...node,
                    attrs: {
                        ...node.attrs,
                        // Remove the URL so it fails to load
                        // We use a space because an empty string causes an infinite loading spinner
                        url: ' '
                    }
                };
            }
        }
    };
    const filteredDocument = (0, $6jPem.traverse)(document, visitors);
    return {
        filteredDocument: filteredDocument ? filteredDocument : document,
        invalidUrls: Array.from(invalidUrls)
    };
};
const $28b4b46ff5265566$var$useSupportsMedia = ()=>{
    try {
        (0, $jRNsq.useMediaClient)();
        return true;
    // eslint-disable-next-line no-unused-vars
    } catch (e) {
        // Throws if no MediaClientProvider is found
        return false;
    }
};
const $28b4b46ff5265566$export$a504d7ec22d4b3f4 = ({ client: client, bridge: bridge })=>{
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($28b4b46ff5265566$export$c334f442ba514f7d, {
            client: client,
            bridge: bridge,
            ...props
        });
};
const $28b4b46ff5265566$export$c334f442ba514f7d = (props)=>{
    const supportsMedia = $28b4b46ff5265566$var$useSupportsMedia();
    const { egress: egress, properties: properties, appDomainName: appDomainName, forgeEnvironment: forgeEnvironment } = (0, $42omo.useContext)((0, $gGmck.RendererContext));
    const imagesEgressService = (0, $lMJg3.useEgressPermissionService)('IMAGES', egress);
    const mediaEgressService = (0, $lMJg3.useEgressPermissionService)('MEDIA', egress);
    const egressServices = [
        imagesEgressService,
        mediaEgressService
    ];
    const client = props.client;
    const bridge = props.bridge;
    const { onNavigate: onNavigate, getModalJsx: getModalJsx } = (0, $kZjf5.useNavigation)({
        extension: {
            egress: egress,
            properties: properties
        }
    });
    const { document: document, documentWithoutMedia: documentWithoutMedia, ...adfRendererProps } = props.forgeDoc.props;
    // The client provides both the document with media and without media, as it doesn't know whether the MediaClientProvider is present
    // Then, in the parent product, we can decide whether to render the document with media or without media
    const doc = !supportsMedia && documentWithoutMedia ? documentWithoutMedia : document;
    if (!doc && (0, $dh538.fg)('platform-ui-kit-adf-renderer-require-document')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
    const { filteredDocument: filteredDocument, invalidUrls: invalidUrls } = $28b4b46ff5265566$var$filterInvalidMediaUrls(appDomainName, egressServices, doc);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, forgeEnvironment === 'DEVELOPMENT' && invalidUrls.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $er4dw.EgressErrorMessage), {
            key: url,
            url: url
        })), getModalJsx(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67O0h.default), {
        ...adfRendererProps,
        eventHandlers: {
            link: {
                onClick: (e)=>{
                    e.preventDefault();
                    adfRendererProps?.eventHandlers?.link?.onClick?.(e, e.currentTarget.href);
                    onNavigate({
                        type: 'same-tab',
                        url: (0, $clpPd.sanitizeUrl)(e.currentTarget.href)
                    });
                }
            }
        },
        document: filteredDocument,
        extensionHandlers: client && (0, $dh538.fg)('platform_add_embedded_macro_support_to_ui_kit') ? {
            'com.atlassian.ecosystem': (props)=>{
                const { localId: localId, parameters: parameters } = props;
                const { extension: extension, extensionData: extensionData, accountId: accountId, cloudId: cloudId, contextIds: contextIds } = parameters.extensionProperties;
                // Extract config from extension parameters (can be in guestParams or config)
                const config = parameters.guestParams || parameters.config;
                // ForgeUIRenderer will fetch fresh extension data from XLS when isEmbeddedMacro is true
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fgm2d.ForgeUIRenderer), {
                    accountId: accountId,
                    cloudId: cloudId,
                    client: client,
                    contextIds: contextIds,
                    extension: extension,
                    extensionData: extensionData,
                    // Pass config via extensionPayload so it's available in context.extension.config
                    extensionPayload: config ? {
                        config: config
                    } : undefined,
                    localId: localId,
                    product: 'confluence',
                    // Only required for bodied macros. Since we are currently not supporting embedded bodied macros, this should be empty.
                    extensionViewData: {},
                    // Pass the same bridge so embedded macro can communicate with product
                    bridge: bridge,
                    isEmbeddedMacro: true
                });
            }
        } : undefined
    })));
};
module.exports["makeADFRenderer"] = $28b4b46ff5265566$export$a504d7ec22d4b3f4;
module.exports["AdfRenderer"] = $28b4b46ff5265566$export$c334f442ba514f7d;

});

parcelRegister("8z3oB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $aD1SW = parcelRequire("aD1SW");


var $gqqjz = parcelRequire("gqqjz");

const $0ffa514f9611729c$export$723a1497b2536563 = ({ showFlag: showFlag, hideFlag: hideFlag })=>{
    const createFlag = (flagOptions)=>{
        const { isAutoDismiss: isAutoDismiss, ...restOptions } = flagOptions;
        const { type: type, appearance: appearance, actions: actions } = flagOptions;
        const shouldAutoDismiss = isAutoDismiss ?? (appearance === 'info' || appearance === 'success');
        showFlag({
            ...restOptions,
            type: appearance ?? type,
            actions: actions?.map(({ text: content, onClick: onClick })=>({
                    onClick: ()=>onClick(),
                    content: content
                })),
            customComponent: shouldAutoDismiss ? (0, $aD1SW.default) : undefined
        });
        return true;
    };
    const closeFlag = ({ id: id })=>{
        hideFlag(id);
        return true;
    };
    return {
        showFlag: createFlag,
        closeFlag: closeFlag
    };
};
const $0ffa514f9611729c$export$b0063bae72b769ca = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, children);
module.exports["getFlagProvider"] = $0ffa514f9611729c$export$723a1497b2536563;
module.exports["FlagProvider"] = $0ffa514f9611729c$export$b0063bae72b769ca;

});

parcelRegister("kaOT1", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $74f9941a52315579$export$e775b9769343d051 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $74f9941a52315579$export$73f470ced5fdc319 = (props)=>{
    const breadCrumbs = (0, $42omo.useRef)([]);
    const tracingService = (0, $42omo.useRef)({
        getBreadcrumbs: ()=>breadCrumbs.current,
        recordBridgeCall: (description)=>breadCrumbs.current = [
                ...breadCrumbs.current,
                {
                    category: `forge.bridge`,
                    message: description,
                    timestamp: new Date().toISOString()
                }
            ],
        recordGqlCall: (description)=>breadCrumbs.current = [
                ...breadCrumbs.current,
                {
                    type: 'http',
                    category: 'gql',
                    timestamp: new Date().toISOString(),
                    data: {
                        url: description
                    }
                }
            ],
        recordConsentFlow: (description, result)=>breadCrumbs.current = [
                ...breadCrumbs.current,
                {
                    category: `user.consent`,
                    message: description,
                    timestamp: new Date().toISOString(),
                    ...result ? {
                        data: {
                            result: result
                        }
                    } : {}
                }
            ]
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($74f9941a52315579$export$e775b9769343d051.Provider, {
        value: tracingService.current
    }, props.children);
};
const $74f9941a52315579$export$1bd6b93107e60cf1 = ()=>{
    const tracingContext = (0, $42omo.useContext)($74f9941a52315579$export$e775b9769343d051);
    return tracingContext;
};
module.exports["TracingProvider"] = $74f9941a52315579$export$73f470ced5fdc319;
module.exports["useTracingContext"] = $74f9941a52315579$export$1bd6b93107e60cf1;

});

parcelRegister("5oEbs", function(module, exports) {

var $lzcvT = parcelRequire("lzcvT");

var $T9xHm = parcelRequire("T9xHm");


var $1c598 = parcelRequire("1c598");


var $dh538 = parcelRequire("dh538");


var $b7qxC = parcelRequire("b7qxC");


var $cqiXo = parcelRequire("cqiXo");

const $83c738174c625218$export$9b5c32eaf7c2ac3d = {
    [(0, $1c598.ProductEnvironment).PRODUCTION]: 'prod',
    [(0, $1c598.ProductEnvironment).STAGING]: 'stg',
    [(0, $1c598.ProductEnvironment).DEVELOPMENT]: 'stg'
};
const $83c738174c625218$export$158d41afab8f2af8 = (appId, extension, environment, entryPoint)=>{
    if ((0, $dh538.fg)('forge-ui-oasis-enabled')) return (0, $T9xHm.isIsolatedCloud)() ? $83c738174c625218$export$d68551323b971eed(appId, extension, entryPoint) : $83c738174c625218$export$b1a4a6ad329e6bd2(appId, extension, environment, entryPoint);
    return $83c738174c625218$export$b1a4a6ad329e6bd2(appId, extension, environment, entryPoint);
};
const $83c738174c625218$export$b1a4a6ad329e6bd2 = (appId, extension, environment, entryPoint)=>{
    const cdnEnv = (0, $b7qxC.getCDNEnvironment)(environment);
    // Map the dev environment to staging here for local development. The dev environment is not set up to load Forge apps.
    const urlEnv = cdnEnv === (0, $1c598.ForgeCDNEnvironment).DEVELOPMENT ? (0, $1c598.ForgeCDNEnvironment).STAGING : cdnEnv;
    const { installationId: installationId, environmentId: environmentId, appVersion: appVersion, properties: properties } = extension;
    const resourceUploadId = properties.resourceUploadId || appVersion;
    const secondLevelDomain = (0, $lzcvT.isFedRamp)() ? 'atlassian-dev-us-gov-mod' : 'atlassian-dev';
    const domain = `${$83c738174c625218$export$d4a94ef9062fefbf(installationId)}--${$83c738174c625218$export$d4a94ef9062fefbf(appId)}.cdn.${urlEnv}.${secondLevelDomain}.net`;
    /**
	 * The appId is also included in the subdomain so that it can be compared against the appId in the
	 * resource path. This comparison is performed by the routing Lambda@ Edge to prevent a malicious
	 * developer from appending their malicious app path to a legitimate installation id.
	 */ const encodedAppContext = (0, $cqiXo.getEncodedAppContext)(extension);
    const urlSafeContext = $83c738174c625218$export$223741b87b7c6af6(encodedAppContext);
    return `https://${domain}/${appId}/${environmentId}/${resourceUploadId}/${entryPoint}/${(0, $dh538.fg)('forge-ui-remove-hostname-src-url') ? '' : `_hostname_${window.location.hostname}/`}_ctx_${urlSafeContext}/`;
};
const $83c738174c625218$export$d68551323b971eed = (appId, extension, entryPoint)=>{
    const { installationId: installationId, environmentId: environmentId, appVersion: appVersion, properties: properties } = extension;
    const resourceUploadId = properties.resourceUploadId || appVersion;
    const icDomain = (0, $T9xHm.isolatedCloudDomain)();
    const domain = `${$83c738174c625218$export$d4a94ef9062fefbf(installationId)}--${$83c738174c625218$export$d4a94ef9062fefbf(appId)}.forge-cdn.${icDomain}`;
    const encodedAppContext = (0, $cqiXo.getEncodedAppContext)(extension);
    const urlSafeContext = $83c738174c625218$export$223741b87b7c6af6(encodedAppContext);
    return `https://${domain}/forge-cdn/${appId}/${environmentId}/${resourceUploadId}/${entryPoint}/_hostname_${window.location.hostname}/_ctx_${urlSafeContext}/`;
};
function $83c738174c625218$export$d4a94ef9062fefbf(uuid) {
    const [a, b, c, d, e] = uuid.split('-');
    const combinedUuid = [
        a,
        `${b}${c}${d}`,
        e
    ];
    return combinedUuid.map((s)=>parseInt(s, 16)).map((s)=>s.toString(36)).join('-');
}
function $83c738174c625218$export$824f5b1835a75769(shortenedUuid) {
    const [a, b, c] = shortenedUuid.split('-').map((s)=>parseInt(s, 36)).map((s)=>s.toString(16));
    // expands the middle segment into the original UUID
    // ffffffff-abcdabcdabcd-ffffffffffff ===> ffffffff-abcd-abcd-abcd-ffffffffffff
    const middleExpanded = b.match(/.{1,4}/g) || b;
    return [
        a,
        ...middleExpanded,
        c
    ].join('-');
}
function $83c738174c625218$export$223741b87b7c6af6(str) {
    return str.replace(/\+/g, '-') // Replace '+' with '-'
    .replace(/\//g, '_') // Replace '/' with '_'
    .replace(/=+$/, ''); // Remove padding
}
module.exports["createSrcFromExtension"] = $83c738174c625218$export$158d41afab8f2af8;
module.exports["urlSafeB64"] = $83c738174c625218$export$223741b87b7c6af6;

});

parcelRegister("LiNdD", function(module, exports) {
const $3ac7139ae0ef30fb$export$563e375d286a76a7 = ()=>{
    if (navigator.languages) return navigator.languages[0];
    return navigator.language;
};
module.exports["getBrowserLocale"] = $3ac7139ae0ef30fb$export$563e375d286a76a7;

});

parcelRegister("4jZsH", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $337f83d71a1a0efc$export$bd17c6970f4d989e = ()=>{
    const platformFeatureFlags = [];
    // Each feature flag name is required to be an inline string for static analysis
    if ((0, $dh538.fg)('platform-visual-refresh-icons')) platformFeatureFlags.push('platform-visual-refresh-icons');
    if ((0, $dh538.fg)('platform-component-visual-refresh')) platformFeatureFlags.push('platform-component-visual-refresh');
    // https://switcheroo.atlassian.com/ui/gates/17cdb9ff-f909-4978-8265-2acd26e02102/key/forge-ui-iframe-analytics
    if ((0, $dh538.fg)('forge-ui-performance-analytics-provider') || (0, $dh538.fg)('forge-ui-iframe-analytics')) platformFeatureFlags.push('forge-ui-iframe-analytics');
    return platformFeatureFlags;
};


const $f045517dec5f1afb$export$6dd3d030a75d6dba = (tunnels, extensionResource, defaultUrl, urlSafeContext)=>{
    const matchTunnel = tunnels.find((tunnel)=>tunnel.resourceKey === extensionResource);
    const platformFeatureFlags = (0, $337f83d71a1a0efc$export$bd17c6970f4d989e)();
    const queryParams = new URLSearchParams({
        ...platformFeatureFlags.length > 0 ? {
            platformFeatureFlags: platformFeatureFlags.join(',')
        } : {},
        // when tunnelling, pass hostname into query param to be passed into CSP
        ...matchTunnel ? {
            hostname: window.location.hostname,
            ctx: urlSafeContext
        } : {}
    }).toString();
    const query = queryParams ? `?${queryParams}` : '';
    if (matchTunnel) return `${matchTunnel.tunnelUrl}${query}`;
    return `${defaultUrl}${query}`;
};
module.exports["getSrcUrl"] = $f045517dec5f1afb$export$6dd3d030a75d6dba;

});

parcelRegister("6hkBe", function(module, exports) {
const $79126e23f70deddc$export$5dfdba3e408a8d60 = (extension, entryPoint)=>{
    const defaultEntryPoint = extension.properties.resource;
    const alternativeEntryPoint = entryPoint && extension.properties[entryPoint]?.resource;
    return alternativeEntryPoint || defaultEntryPoint;
};
module.exports["getExtensionEntryPoint"] = $79126e23f70deddc$export$5dfdba3e408a8d60;

});

parcelRegister("ge8sG", function(module, exports) {
const $ac41360860378247$export$c34ac5b863279caa = (coreData, extensionData)=>({
        ...coreData,
        extension: extensionData
    });
module.exports["getResolverContext"] = $ac41360860378247$export$c34ac5b863279caa;

});

parcelRegister("UZU5S", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $fff5b396b669afc2$export$68ca3577dbf1f96c = (scopes = [], egress = [])=>{
    // Create a map to store egress data by type then loop through the map to populate the external permissions object
    const egressMap = new Map();
    egress.forEach(({ type: type, addresses: addresses })=>{
        egressMap.set(type, addresses);
    });
    // Construct external permissions from the map
    const externalPermissions = {
        fetch: {
            backend: egressMap.get('FETCH_BACKEND_SIDE') ?? [],
            client: egressMap.get('FETCH_CLIENT_SIDE') ?? []
        },
        fonts: egressMap.get('FONTS') ?? [],
        styles: egressMap.get('STYLES') ?? [],
        frames: egressMap.get('FRAMES') ?? [],
        images: egressMap.get('IMAGES') ?? [],
        media: egressMap.get('MEDIA') ?? [],
        scripts: egressMap.get('SCRIPTS') ?? []
    };
    return {
        scopes: scopes,
        external: externalPermissions
    };
};
const $fff5b396b669afc2$export$20af16720c0f9c71 = ({ resolverContext: resolverContext, accountId: accountId, extension: extension, timezone: timezone, locale: locale, location: location, extensionPayload: extensionPayload, extensionViewData: extensionViewData, theme: theme, surfaceColor: surfaceColor })=>{
    // Combine the static macro extension data with the dynamic extension view data (macro body) into a single macro object
    const macro = {
        ...resolverContext.extension?.macro,
        ...extensionViewData?.macro,
        ...(0, $dh538.fg)('platform_move_dynamic_macro_context') || (0, $dh538.fg)('only-include-macro-config-from-payload-in-reload') ? extensionPayload?.macro : {}
    };
    /* adding hasAccess separately instead of using userAccess as a whole is to avoid appending __typename in the context */ const userAccess = extension.userAccess ?? {
        enabled: false,
        hasAccess: false
    };
    // Construct permissions object from scopes and egress
    const permissions = $fff5b396b669afc2$export$68ca3577dbf1f96c(extension?.scopes || [], extension?.egress || []);
    return {
        ...resolverContext,
        extension: {
            ...resolverContext.extension,
            ...extensionViewData,
            ...extensionPayload,
            ...Object.keys(macro).length > 0 ? {
                macro: macro
            } : {},
            location: extension.type === 'jira:globalBackgroundScript' && (0, $dh538.fg)('ditto_fcf_jira_globalbackgroundscript') ? '' : location
        },
        accountId: accountId,
        license: extension?.license || null,
        timezone: timezone,
        locale: locale,
        theme: theme,
        surfaceColor: surfaceColor,
        userAccess: userAccess,
        permissions: permissions
    };
};
module.exports["getViewContext"] = $fff5b396b669afc2$export$20af16720c0f9c71;

});

parcelRegister("iRhnt", function(module, exports) {
/**
 * Utilities for JWT token decoding and comparison logic used in shadow invocation feature
 */ 
var $6oQb1 = parcelRequire("6oQb1");

function $bf12390738a3ef23$export$96751ef617237d7e(jwt) {
    if (!jwt) return undefined;
    try {
        const payload = jwt.split('.')[1];
        if (!payload) return undefined;
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');
        return JSON.parse(atob(padded));
    } catch (e) {
        return undefined;
    }
}
/**
 * Checks if a value is a plain object (not array, null, or primitive)
 * @param value - The value to check
 * @returns True if the value is a plain object
 */ function $bf12390738a3ef23$var$isPlainObject(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}
/**
 * Recursively compares two objects and returns the differences
 * @param shadow - The shadow object to compare
 * @param regular - The regular object to compare
 * @param path - The current path in the object hierarchy
 * @param result - The result object to accumulate differences
 */ function $bf12390738a3ef23$var$visitObjectDifferences(shadow, regular, path, result) {
    const sObj = $bf12390738a3ef23$var$isPlainObject(shadow) ? shadow : {};
    const rObj = $bf12390738a3ef23$var$isPlainObject(regular) ? regular : {};
    const sKeys = new Set(Object.keys(sObj));
    const rKeys = new Set(Object.keys(rObj));
    // Find keys only in shadow
    sKeys.forEach((k)=>{
        if (!rKeys.has(k)) result.onlyInShadow.push([
            ...path,
            k
        ].join('.'));
    });
    // Find keys only in regular
    rKeys.forEach((k)=>{
        if (!sKeys.has(k)) result.onlyInRegular.push([
            ...path,
            k
        ].join('.'));
    });
    // Compare common keys
    sKeys.forEach((k)=>{
        if (!rKeys.has(k)) return;
        const sv = sObj[k];
        const rv = rObj[k];
        if ($bf12390738a3ef23$var$isPlainObject(sv) && $bf12390738a3ef23$var$isPlainObject(rv)) $bf12390738a3ef23$var$visitObjectDifferences(sv, rv, [
            ...path,
            k
        ], result);
        else if (JSON.stringify(sv) !== JSON.stringify(rv)) result.mismatchedValues.push({
            key: [
                ...path,
                k
            ].join('.'),
            shadow: sv,
            regular: rv
        });
    });
}
function $bf12390738a3ef23$export$c88750430cbf4afc(shadowToken, regularToken) {
    const shadow = shadowToken?.context || {};
    const regular = regularToken?.context || {};
    const result = {
        onlyInShadow: [],
        onlyInRegular: [],
        mismatchedValues: []
    };
    $bf12390738a3ef23$var$visitObjectDifferences(shadow, regular, [], result);
    return result;
}
function $bf12390738a3ef23$export$ad8401ab212af28d(differences) {
    const allDifferingKeys = new Set();
    // Add keys that are only in shadow token
    differences.onlyInShadow.forEach((key)=>allDifferingKeys.add(key));
    // Add keys that are only in regular token
    differences.onlyInRegular.forEach((key)=>allDifferingKeys.add(key));
    // Add keys that have mismatched values
    differences.mismatchedValues.forEach((mismatch)=>allDifferingKeys.add(mismatch.key));
    // Return sorted array for consistent output
    return Array.from(allDifferingKeys).sort();
}
function $bf12390738a3ef23$export$6c4ccde2488ac6b8(differences) {
    const keyValues = {};
    // Keys only in shadow token
    differences.onlyInShadow.forEach((key)=>{
        keyValues[key] = {
            shadow: 'present',
            regular: undefined
        };
    });
    // Keys only in regular token
    differences.onlyInRegular.forEach((key)=>{
        keyValues[key] = {
            regular: 'present',
            shadow: undefined
        };
    });
    // Keys with mismatched values
    differences.mismatchedValues.forEach((mismatch)=>{
        keyValues[mismatch.key] = {
            regular: mismatch.regular,
            shadow: mismatch.shadow
        };
    });
    return keyValues;
}
function $bf12390738a3ef23$export$91cd38f87a379a31(shadowToken, regularToken) {
    const shadow = shadowToken || {};
    const regular = regularToken || {};
    const result = {
        onlyInShadow: [],
        onlyInRegular: [],
        mismatchedValues: []
    };
    $bf12390738a3ef23$var$visitObjectDifferences(shadow, regular, [], result);
    return result;
}
function $bf12390738a3ef23$export$ce683f7fc0bd28b1(differences, regularToken) {
    const mismatchesEmpty = differences.mismatchedValues.length === 0;
    const onlyInRegularOk = differences.onlyInRegular.length <= 1;
    if (!mismatchesEmpty || !onlyInRegularOk) return false;
    if (differences.onlyInRegular.length === 1) {
        const onlyKey = differences.onlyInRegular[0];
        // When using context-only paths, this should be 'extension.content.subtype'
        const regularCtx = regularToken?.context || {};
        const regularSubtype = regularCtx?.extension?.content?.subtype;
        return onlyKey === 'extension.content.subtype' && regularSubtype === null;
    }
    // No differences inside context
    return true;
}
function $bf12390738a3ef23$export$86c16fc1ae19506b(differences, useShadow, regularResponse, shadowResponse) {
    const differingKeys = $bf12390738a3ef23$export$ad8401ab212af28d(differences);
    const differingKeysWithValues = $bf12390738a3ef23$export$6c4ccde2488ac6b8(differences);
    const hasDifferences = differingKeys.length > 0;
    return {
        action: 'contextTokenComparison',
        actionSubject: 'forge.ui.invocation',
        source: 'forge.ui.iframe',
        attributes: {
            comparisonResult: hasDifferences ? 'different' : 'same',
            hasDifferences: hasDifferences,
            differenceCount: differingKeys.length,
            differingKeys: differingKeys,
            differingKeysWithValues: differingKeysWithValues,
            onlyInRegularCount: differences.onlyInRegular.length,
            onlyInShadowCount: differences.onlyInShadow.length,
            mismatchedValuesCount: differences.mismatchedValues.length,
            useShadowResponse: useShadow,
            extensionId: regularResponse.extensionId || shadowResponse.extensionId,
            extensionType: regularResponse.extensionType || shadowResponse.extensionType
        }
    };
}
function $bf12390738a3ef23$export$782f13e8807e97e6(regularResponse, shadowResponse, createAnalyticsEvent) {
    if (!shadowResponse || !regularResponse) return regularResponse;
    const decodedTokens = {
        shadow: $bf12390738a3ef23$export$96751ef617237d7e(shadowResponse.contextToken?.jwt),
        regular: $bf12390738a3ef23$export$96751ef617237d7e(regularResponse.contextToken?.jwt)
    };
    // Use context-only comparison for the decision logic (existing behavior)
    const contextDifferences = $bf12390738a3ef23$export$c88750430cbf4afc(decodedTokens.shadow, decodedTokens.regular);
    const useShadow = $bf12390738a3ef23$export$ce683f7fc0bd28b1(contextDifferences, decodedTokens.regular);
    if (createAnalyticsEvent) {
        // Use full token comparison for comprehensive analytics
        const fullDifferences = $bf12390738a3ef23$export$91cd38f87a379a31(decodedTokens.shadow, decodedTokens.regular);
        const analyticsPayload = $bf12390738a3ef23$export$86c16fc1ae19506b(fullDifferences, useShadow, regularResponse, shadowResponse);
        (0, $6oQb1.fireEvent)(createAnalyticsEvent, analyticsPayload);
    }
    return useShadow ? shadowResponse : regularResponse;
}
module.exports["selectOptimalInvocationResponse"] = $bf12390738a3ef23$export$782f13e8807e97e6;

});

parcelRegister("6baEI", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $42omo = parcelRequire("42omo");


var $T9xHm = parcelRequire("T9xHm");

const $3169be2c7bdce757$export$98b91f32256d29a8 = ()=>{
    const [isLoading, setIsLoading] = (0, $42omo.useState)($3169be2c7bdce757$export$a6dd2b5c1fe5c76e());
    (0, $42omo.useEffect)(()=>{
        let cancelled = false;
        if (isLoading) $3169be2c7bdce757$var$loadCDNAuthSignedCookie().catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('Error loading CDN auth signed cookie:', err);
        }).finally(()=>{
            if (!cancelled) setIsLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        isLoading
    ]);
    return isLoading;
};
const $3169be2c7bdce757$var$MAX_SIGNED_COOKIE_AGE_MS = 1800000; // 30 minutes
let $3169be2c7bdce757$var$lastSignedCookieFetchTime = 0;
let $3169be2c7bdce757$var$loadingPromise = null;
const $3169be2c7bdce757$var$doLoadCDNAuthSignedCookie = async ()=>{
    // Step 1: Get the signed cookies URL from our backend -> session token based auth
    const signedCookiesUrlResponse = await fetch('/gateway/api/forge-cdn/signed-cookies-url');
    if (!signedCookiesUrlResponse.ok) throw new Error(`Failed to get signed cookies URL: ${signedCookiesUrlResponse.statusText}`);
    // Step 2: Fetch the signed cookies using the obtained URL (with signed URL) -> this will set the cookies in the browser
    const { data: signedCookiesUrl } = await signedCookiesUrlResponse.json();
    if (!signedCookiesUrl || typeof signedCookiesUrl !== 'string') throw new Error('Invalid signed cookies URL received from backend');
    const response = await fetch(signedCookiesUrl, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) throw new Error(`Failed to fetch signed cookies: ${response.statusText}`);
};
const $3169be2c7bdce757$var$loadCDNAuthSignedCookie = async ()=>{
    if (Date.now() - $3169be2c7bdce757$var$lastSignedCookieFetchTime < $3169be2c7bdce757$var$MAX_SIGNED_COOKIE_AGE_MS) return;
    // this is to ensure only one loadingPromise is active at a time (to avoid multiple simultaneous requests)
    if ($3169be2c7bdce757$var$loadingPromise) await $3169be2c7bdce757$var$loadingPromise;
    else {
        $3169be2c7bdce757$var$loadingPromise = (async ()=>{
            try {
                await $3169be2c7bdce757$var$doLoadCDNAuthSignedCookie();
                $3169be2c7bdce757$var$lastSignedCookieFetchTime = Date.now();
            } finally{
                $3169be2c7bdce757$var$loadingPromise = null;
            }
        })();
        await $3169be2c7bdce757$var$loadingPromise;
    }
};
const $3169be2c7bdce757$export$a6dd2b5c1fe5c76e = ()=>{
    return (0, $dh538.fg)('forge-ui-cdn-auth') && (0, $T9xHm.isIsolatedCloud)();
};
const $3169be2c7bdce757$export$1b22f04514004ab6 = ()=>{
    $3169be2c7bdce757$var$lastSignedCookieFetchTime = 0;
    $3169be2c7bdce757$var$loadingPromise = null;
};
module.exports["useCDNAuthSignedCookie"] = $3169be2c7bdce757$export$98b91f32256d29a8;
module.exports["shouldUseCDNAuth"] = $3169be2c7bdce757$export$a6dd2b5c1fe5c76e;

});

parcelRegister("i35rc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fgbwU = parcelRequire("fgbwU");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $dcJ7R = parcelRequire("dcJ7R");


var $ebrpi = parcelRequire("ebrpi");


var $9P47v = parcelRequire("9P47v");


var $dh538 = parcelRequire("dh538");

// TODO: We should make appName non-optional later: http://go/j/AUX-570
// appName was made optional because it isn't in already inserted apps prior to the change in http://go/j/AUX-411
const $cf1792e251a9a919$var$defaultPromptMessage = (intl, appName)=>{
    return intl.formatMessage((0, $dh538.fg)('product-terminology-refresh') ? $cf1792e251a9a919$var$messages.defaultPromptMessageAppify : $cf1792e251a9a919$var$messages.defaultPromptMessage, {
        appString: appName ? appName : intl.formatMessage($cf1792e251a9a919$var$messages.thisAppLower)
    });
};
const $cf1792e251a9a919$var$externalAuthPromptMessage = (intl, appName)=>{
    return intl.formatMessage($cf1792e251a9a919$var$messages.externalAuthPromptMessage, {
        appString: appName ? appName : intl.formatMessage($cf1792e251a9a919$var$messages.thisAppUpper)
    });
};
const $cf1792e251a9a919$export$1d39dc5b47e56ff0 = ({ message: message, promptText: promptText, appName: appName, authUrl: authUrl, onSuccess: onSuccess, metadata: metadata })=>{
    const [failedToAuthenticate, setFailedToAuthenticate] = (0, $42omo.useState)(false);
    const [authFailureMessage, setAuthFailureMessage] = (0, $42omo.useState)(false);
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const promptIsForExternalAuth = (0, $fgbwU.isExternalAuth)(authUrl);
    const intl = (0, $8C5kA.default)();
    const startAuth = (0, $42omo.useCallback)(()=>{
        setLoading(true);
        setAuthFailureMessage(false);
        (0, $fgbwU.safeAuth)(authUrl).then(()=>{
            onSuccess().then((callbackAfterConsentFlowHasFinished)=>{
                setLoading(false);
                setFailedToAuthenticate(false);
                if (callbackAfterConsentFlowHasFinished && typeof callbackAfterConsentFlowHasFinished === 'function') callbackAfterConsentFlowHasFinished();
            });
        }, (err)=>{
            setLoading(false);
            setFailedToAuthenticate(true);
            if ((0, $9P47v.isOfTypeAuthError)(err.type)) setAuthFailureMessage(err.message);
        });
    }, [
        authUrl,
        onSuccess,
        setLoading,
        setFailedToAuthenticate,
        setAuthFailureMessage
    ]);
    const promptMessage = failedToAuthenticate ? authFailureMessage || intl.formatMessage($cf1792e251a9a919$var$messages.defaultFailedToAuthMessage) : message || (promptIsForExternalAuth ? $cf1792e251a9a919$var$externalAuthPromptMessage(intl, appName) : $cf1792e251a9a919$var$defaultPromptMessage(intl, appName));
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
        label: intl.formatMessage($cf1792e251a9a919$var$messages.externalAuthWarning),
        color: "var(--ds-icon-warning, #FF8B00)",
        spacing: "spacious"
    }), promptMessage);
    const externalAuthButtonText = intl.formatMessage($cf1792e251a9a919$var$messages.configureAccess);
    const buttonText = promptText || (promptIsForExternalAuth ? externalAuthButtonText : intl.formatMessage($cf1792e251a9a919$var$messages.allowAccess));
    return {
        loading: loading,
        startAuth: startAuth,
        promptMessage: content,
        buttonText: buttonText
    };
};
const $cf1792e251a9a919$var$messages = (0, $cgtv4.defineMessages)({
    defaultPromptMessage: {
        id: "confluence.threeLOPrompt.use-auth.default.prompt.message",
        defaultMessage: "For {appString} to display, you need to allow the app to access Atlassian products on your behalf."
    },
    defaultPromptMessageAppify: {
        id: "confluence.threeLOPrompt.use-auth.default.prompt.message-appify",
        defaultMessage: "For {appString} to display, you need to grant it access to Atlassian apps on your behalf."
    },
    externalAuthPromptMessage: {
        id: "confluence.threeLOPrompt.use-auth.external.auth.prompt.message",
        defaultMessage: "{appString} requires additional access to your account."
    },
    thisAppUpper: {
        id: "confluence.threeLOPrompt.use-auth.this.app.upper.message",
        defaultMessage: "This app"
    },
    thisAppLower: {
        id: "confluence.threeLOPrompt.use-auth.this.app.lower.message",
        defaultMessage: "this app"
    },
    defaultFailedToAuthMessage: {
        id: "confluence.threeLOPrompt.use-auth.default.failed.to.auth.message",
        defaultMessage: "Failed to authenticate."
    },
    externalAuthWarning: {
        id: "confluence.threeLOPrompt.use-auth.external.auth.warning.message",
        defaultMessage: "External Auth Warning"
    },
    configureAccess: {
        id: "confluence.threeLOPrompt.use-auth.configure.access.button.text",
        defaultMessage: "Configure access"
    },
    allowAccess: {
        id: "confluence.threeLOPrompt.use-auth.allow.access.button.text",
        defaultMessage: "Allow access"
    }
});
module.exports["useAuth"] = $cf1792e251a9a919$export$1d39dc5b47e56ff0;

});

parcelRegister("7oKJR", function(module, exports) {

var $c4TO3 = parcelRequire("c4TO3");

const $65eef95050715244$var$SESSION_APPS_KEY = 'forge-ui.seen-app-keys';
/**
 *  This module is used to track the seen app context keys in session storage specifically
 *  for the forge.ui.extension loaded analytic event
 *  - Stores the last accessed date and the seen app context keys in session storage
 *  - The last accessed date is used to determine if the session is expired
 *  - The seen app context keys are used to determine if the event has already been sent
 *  - Session storage is used to avoid sending duplicate events on page refreshes or navigations
 */ let $65eef95050715244$var$storageState = {
    lastUpdated: null,
    appKeys: null
};
// Use a number for faster comparisons
const $65eef95050715244$var$getTodayAsNumberOfDaysSinceEpoch = ()=>{
    return Math.floor(Date.now() / 86400000);
};
const $65eef95050715244$var$checkIsExpired = ()=>{
    const today = $65eef95050715244$var$getTodayAsNumberOfDaysSinceEpoch();
    // If the last updated date is not today, the state has expired and so we reset it
    return today !== $65eef95050715244$var$storageState.lastUpdated;
};
const $65eef95050715244$var$resetState = ()=>{
    $65eef95050715244$var$storageState.appKeys = new Set();
    $65eef95050715244$var$storageState.lastUpdated = $65eef95050715244$var$getTodayAsNumberOfDaysSinceEpoch();
};
const $65eef95050715244$export$b103ab7a7dac10e9 = ()=>{
    // If the app context keys have values, this call has already been made by another renderer and so we can return here
    if ($65eef95050715244$var$storageState.appKeys !== null) return;
    // Check for the app context keys in session storage and store it into memory
    // This is called once across any number of ForgeUIRenderers on the page guarded by the above `if` statement
    try {
        const appKeyfilterSessionStorageContextInStorage = JSON.parse((0, $c4TO3.AtlBrowserStorageSession).getItem($65eef95050715244$var$SESSION_APPS_KEY) ?? '{}');
        $65eef95050715244$var$storageState = {
            appKeys: new Set(appKeyfilterSessionStorageContextInStorage.appKeys),
            lastUpdated: Number(appKeyfilterSessionStorageContextInStorage.lastUpdated)
        };
        // If the state is expired, we reset it
        if ($65eef95050715244$var$checkIsExpired()) {
            $65eef95050715244$var$resetState();
            return;
        }
    } catch  {
        $65eef95050715244$var$resetState();
    }
};
const $65eef95050715244$var$writeToSessionStorage = ()=>{
    try {
        // Set a limit to avoid overloading session storage
        if ($65eef95050715244$var$storageState?.appKeys?.size && $65eef95050715244$var$storageState?.appKeys?.size < 100) (0, $c4TO3.AtlBrowserStorageSession).setItem($65eef95050715244$var$SESSION_APPS_KEY, JSON.stringify({
            appKeys: Array.from($65eef95050715244$var$storageState.appKeys ?? []),
            lastUpdated: $65eef95050715244$var$getTodayAsNumberOfDaysSinceEpoch()
        }));
    } catch  {
    // If session storage is not available, we don't want to throw an error
    }
};
// Catches navigation or page refresh events and writes to session storage synchronously
window.addEventListener('beforeunload', ()=>{
    $65eef95050715244$var$writeToSessionStorage();
});
const $65eef95050715244$var$shouldAllowAndTrackEvent = (contextKey)=>{
    // State has expired
    if ($65eef95050715244$var$checkIsExpired()) {
        $65eef95050715244$var$resetState();
        $65eef95050715244$var$storageState.appKeys?.add(contextKey);
        return true;
    }
    if ($65eef95050715244$var$storageState.appKeys?.has(contextKey)) return false;
    $65eef95050715244$var$storageState.appKeys?.add(contextKey);
    return true;
};
const $65eef95050715244$var$findAppContextKeyInEvent = (event)=>{
    if (!event.context) return undefined;
    for (const context of event.context){
        const { appId: appId, extensionKey: extensionKey } = context.forgeUIAttributes ?? {};
        if (appId && extensionKey) return `${appId}/${extensionKey}`;
    }
    return undefined;
};
const $65eef95050715244$export$8869481ff1a02956 = (event)=>{
    try {
        const appContextKey = $65eef95050715244$var$findAppContextKeyInEvent(event);
        if (appContextKey) {
            const shouldAllow = $65eef95050715244$var$shouldAllowAndTrackEvent(appContextKey);
            return shouldAllow;
        }
    } catch  {
    // in case of any error, we let the event through, so we don't accidentally break analytics
    }
    return true;
};
module.exports["setupContextKeysFromSessionStorage"] = $65eef95050715244$export$b103ab7a7dac10e9;
module.exports["extensionLoadedEventFilter"] = $65eef95050715244$export$8869481ff1a02956;

});

parcelRegister("471wb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hXuPC = parcelRequire("hXuPC");


$hXuPC.__exportStar((parcelRequire("kRUUL")), module.exports);

});

parcelRegister("gGmck", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $4a7ba83bf95919d5$export$1e9ea4edb6d1bfe6 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
module.exports["RendererContext"] = $4a7ba83bf95919d5$export$1e9ea4edb6d1bfe6;

});

parcelRegister("dRFAM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hXuPC = parcelRequire("hXuPC");


$hXuPC.__exportStar((parcelRequire("9FlsF")), module.exports);

$hXuPC.__exportStar((parcelRequire("87m1m")), module.exports);

});

parcelRegister("9wL22", function(module, exports) {
/*
 * File: iframeResizer.js
 * Desc: Force iframes to size to content.
 * Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 * Contributor: Jure Mav - jure.mav@gmail.com
 * Contributor: Reed Dadoune - reed@dadoune.com
 */ // eslint-disable-next-line sonarjs/cognitive-complexity, no-shadow-restricted-names
(function(undefined) {
    if (typeof window === 'undefined') return; // don't run for server side render
    var count = 0, logEnabled = false, hiddenCheckEnabled = false, msgHeader = 'message', msgHeaderLen = msgHeader.length, msgId = '[iFrameSizer]', msgIdLen = msgId.length, pagePosition = null, requestAnimationFrame = window.requestAnimationFrame, resetRequiredMethods = {
        max: 1,
        scroll: 1,
        bodyScroll: 1,
        documentElementScroll: 1
    }, settings = {}, timer = null, defaults = {
        autoResize: true,
        bodyBackground: null,
        bodyMargin: null,
        bodyMarginV1: 8,
        bodyPadding: null,
        checkOrigin: true,
        inPageLinks: false,
        enablePublicMethods: true,
        heightCalculationMethod: 'bodyOffset',
        id: 'iFrameResizer',
        interval: 32,
        log: false,
        maxHeight: Infinity,
        maxWidth: Infinity,
        minHeight: 0,
        minWidth: 0,
        mouseEvents: true,
        resizeFrom: 'parent',
        scrolling: false,
        sizeHeight: true,
        sizeWidth: false,
        warningTimeout: 5000,
        tolerance: 0,
        widthCalculationMethod: 'scroll',
        onClose: function() {
            return true;
        },
        onClosed: function() {},
        onInit: function() {},
        onMessage: function() {
            warn('onMessage function not defined');
        },
        onMouseEnter: function() {},
        onMouseLeave: function() {},
        onResized: function() {},
        onScroll: function() {
            return true;
        }
    };
    function getMutationObserver() {
        return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    }
    function addEventListener(el, evt, func) {
        el.addEventListener(evt, func, false);
    }
    function removeEventListener(el, evt, func) {
        el.removeEventListener(evt, func, false);
    }
    function setupRequestAnimationFrame() {
        var vendors = [
            'moz',
            'webkit',
            'o',
            'ms'
        ];
        var x;
        // Remove vendor prefixing if prefixed and break early if not
        for(x = 0; x < vendors.length && !requestAnimationFrame; x += 1)requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        if (!requestAnimationFrame) log('setup', 'RequestAnimationFrame not supported');
        else // Firefox extension content-scripts have a globalThis object that is not the same as window.
        // Binding `requestAnimationFrame` to window allows the function to work and prevents errors
        // being thrown when run in that context, and should be a no-op in every other context.
        requestAnimationFrame = requestAnimationFrame.bind(window);
    }
    function getMyID(iframeId) {
        var retStr = 'Host page: ' + iframeId;
        if (window.top !== window.self) retStr = window.parentIFrame && window.parentIFrame.getId ? window.parentIFrame.getId() + ': ' + iframeId : 'Nested host page: ' + iframeId;
        return retStr;
    }
    function formatLogHeader(iframeId) {
        return msgId + '[' + getMyID(iframeId) + ']';
    }
    function isLogEnabled(iframeId) {
        return settings[iframeId] ? settings[iframeId].log : logEnabled;
    }
    function log(iframeId, msg) {
        output('log', iframeId, msg, isLogEnabled(iframeId));
    }
    function info(iframeId, msg) {
        output('info', iframeId, msg, isLogEnabled(iframeId));
    }
    function warn(iframeId, msg) {
        output('warn', iframeId, msg, true);
    }
    function output(type, iframeId, msg, enabled) {
        if (true === enabled && 'object' === typeof window.console) // eslint-disable-next-line no-console
        console[type](formatLogHeader(iframeId), msg);
    }
    function iFrameListener(event) {
        function resizeIFrame() {
            function resize() {
                setSize(messageData);
                setPagePosition(iframeId);
                on('onResized', messageData);
            }
            ensureInRange('Height');
            ensureInRange('Width');
            syncResize(resize, messageData, 'init');
        }
        function processMsg() {
            var data = msg.substr(msgIdLen).split(':');
            var height = data[1] ? parseInt(data[1], 10) : 0;
            var iframe = settings[data[0]] && settings[data[0]].iframe;
            var compStyle = getComputedStyle(iframe);
            return {
                iframe: iframe,
                id: data[0],
                height: height + getPaddingEnds(compStyle) + getBorderEnds(compStyle),
                width: data[2],
                type: data[3]
            };
        }
        function getPaddingEnds(compStyle) {
            if (compStyle.boxSizing !== 'border-box') return 0;
            var top = compStyle.paddingTop ? parseInt(compStyle.paddingTop, 10) : 0;
            var bot = compStyle.paddingBottom ? parseInt(compStyle.paddingBottom, 10) : 0;
            return top + bot;
        }
        function getBorderEnds(compStyle) {
            if (compStyle.boxSizing !== 'border-box') return 0;
            var top = compStyle.borderTopWidth ? parseInt(compStyle.borderTopWidth, 10) : 0;
            var bot = compStyle.borderBottomWidth ? parseInt(compStyle.borderBottomWidth, 10) : 0;
            return top + bot;
        }
        function ensureInRange(Dimension) {
            var max = Number(settings[iframeId]['max' + Dimension]), min = Number(settings[iframeId]['min' + Dimension]), dimension = Dimension.toLowerCase(), size = Number(messageData[dimension]);
            log(iframeId, 'Checking ' + dimension + ' is in range ' + min + '-' + max);
            if (size < min) {
                size = min;
                log(iframeId, 'Set ' + dimension + ' to min value');
            }
            if (size > max) {
                size = max;
                log(iframeId, 'Set ' + dimension + ' to max value');
            }
            messageData[dimension] = '' + size;
        }
        function isMessageFromIFrame() {
            function checkAllowedOrigin() {
                function checkList() {
                    var i = 0, retCode = false;
                    log(iframeId, 'Checking connection is from allowed list of origins: ' + checkOrigin);
                    for(; i < checkOrigin.length; i++)if (checkOrigin[i] === origin) {
                        retCode = true;
                        break;
                    }
                    return retCode;
                }
                function checkSingle() {
                    var remoteHost = settings[iframeId] && settings[iframeId].remoteHost;
                    log(iframeId, 'Checking connection is from: ' + remoteHost);
                    return origin === remoteHost;
                }
                return checkOrigin.constructor === Array ? checkList() : checkSingle();
            }
            var origin = event.origin, checkOrigin = settings[iframeId] && settings[iframeId].checkOrigin;
            if (checkOrigin && '' + origin !== 'null' && !checkAllowedOrigin()) throw new Error('Unexpected message received from: ' + origin + ' for ' + messageData.iframe.id + '. Message was: ' + event.data + '. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.');
            return true;
        }
        function isMessageForUs() {
            return msgId === ('' + msg).substr(0, msgIdLen) && msg.substr(msgIdLen).split(':')[0] in settings // ''+Protects against non-string msg
            ;
        }
        function isMessageFromMetaParent() {
            // Test if this message is from a parent above us. This is an ugly test, however, updating
            // the message format would break backwards compatibity.
            var retCode = messageData.type in {
                true: 1,
                false: 1,
                undefined: 1
            };
            if (retCode) log(iframeId, 'Ignoring init message from meta parent page');
            return retCode;
        }
        function getMsgBody(offset) {
            return msg.substr(msg.indexOf(':') + msgHeaderLen + offset);
        }
        function forwardMsgFromIFrame(msgBody) {
            log(iframeId, 'onMessage passed: {iframe: ' + messageData.iframe.id + ', message: ' + msgBody + '}');
            on('onMessage', {
                iframe: messageData.iframe,
                message: JSON.parse(msgBody)
            });
            log(iframeId, '--');
        }
        function getPageInfo() {
            var bodyPosition = document.body.getBoundingClientRect(), iFramePosition = messageData.iframe.getBoundingClientRect();
            return JSON.stringify({
                iframeHeight: iFramePosition.height,
                iframeWidth: iFramePosition.width,
                clientHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
                clientWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
                offsetTop: parseInt(iFramePosition.top - bodyPosition.top, 10),
                offsetLeft: parseInt(iFramePosition.left - bodyPosition.left, 10),
                scrollTop: window.pageYOffset,
                scrollLeft: window.pageXOffset,
                documentHeight: document.documentElement.clientHeight,
                documentWidth: document.documentElement.clientWidth,
                windowHeight: window.innerHeight,
                windowWidth: window.innerWidth
            });
        }
        function sendPageInfoToIframe(iframe, iframeId) {
            function debouncedTrigger() {
                trigger('Send Page Info', 'pageInfo:' + getPageInfo(), iframe, iframeId);
            }
            debounceFrameEvents(debouncedTrigger, 32, iframeId);
        }
        function startPageInfoMonitor() {
            function setListener(type, func) {
                function sendPageInfo() {
                    if (settings[id]) sendPageInfoToIframe(settings[id].iframe, id);
                    else stop();
                }
                [
                    'scroll',
                    'resize'
                ].forEach(function(evt) {
                    log(id, type + evt + ' listener for sendPageInfo');
                    func(window, evt, sendPageInfo);
                });
            }
            function stop() {
                setListener('Remove ', removeEventListener);
            }
            function start() {
                setListener('Add ', addEventListener);
            }
            var id = iframeId // Create locally scoped copy of iFrame ID
            ;
            start();
            if (settings[id]) settings[id].stopPageInfo = stop;
        }
        function stopPageInfoMonitor() {
            if (settings[iframeId] && settings[iframeId].stopPageInfo) {
                settings[iframeId].stopPageInfo();
                delete settings[iframeId].stopPageInfo;
            }
        }
        function checkIFrameExists() {
            var retBool = true;
            if (null === messageData.iframe) {
                warn(iframeId, 'IFrame (' + messageData.id + ') not found');
                retBool = false;
            }
            return retBool;
        }
        function getElementPosition(target) {
            var iFramePosition = target.getBoundingClientRect();
            getPagePosition(iframeId);
            return {
                x: Math.floor(Number(iFramePosition.left) + Number(pagePosition.x)),
                y: Math.floor(Number(iFramePosition.top) + Number(pagePosition.y))
            };
        }
        function scrollRequestFromChild(addOffset) {
            /* istanbul ignore next */ // Not testable in Karma
            function reposition() {
                pagePosition = newPosition;
                scrollTo();
                log(iframeId, '--');
            }
            function calcOffset() {
                return {
                    x: Number(messageData.width) + offset.x,
                    y: Number(messageData.height) + offset.y
                };
            }
            function scrollParent() {
                if (window.parentIFrame) window.parentIFrame['scrollTo' + (addOffset ? 'Offset' : '')](newPosition.x, newPosition.y);
                else warn(iframeId, 'Unable to scroll to requested position, window.parentIFrame not found');
            }
            var offset = addOffset ? getElementPosition(messageData.iframe) : {
                x: 0,
                y: 0
            }, newPosition = calcOffset();
            log(iframeId, 'Reposition requested from iFrame (offset x:' + offset.x + ' y:' + offset.y + ')');
            if (window.top !== window.self) scrollParent();
            else reposition();
        }
        function scrollTo() {
            if (false !== on('onScroll', pagePosition)) setPagePosition(iframeId);
            else unsetPagePosition();
        }
        function findTarget(location) {
            function jumpToTarget() {
                var jumpPosition = getElementPosition(target);
                log(iframeId, 'Moving to in page link (#' + hash + ') at x: ' + jumpPosition.x + ' y: ' + jumpPosition.y);
                pagePosition = {
                    x: jumpPosition.x,
                    y: jumpPosition.y
                };
                scrollTo();
                log(iframeId, '--');
            }
            function jumpToParent() {
                if (window.parentIFrame) window.parentIFrame.moveToAnchor(hash);
                else log(iframeId, 'In page link #' + hash + ' not found and window.parentIFrame not found');
            }
            var hash = location.split('#')[1] || '', hashData = decodeURIComponent(hash), target = document.getElementById(hashData) || document.getElementsByName(hashData)[0];
            if (target) jumpToTarget();
            else if (window.top !== window.self) jumpToParent();
            else log(iframeId, 'In page link #' + hash + ' not found');
        }
        function onMouse(event) {
            var mousePos = {};
            if (Number(messageData.width) === 0 && Number(messageData.height) === 0) {
                var data = getMsgBody(9).split(':');
                mousePos = {
                    x: data[1],
                    y: data[0]
                };
            } else mousePos = {
                x: messageData.width,
                y: messageData.height
            };
            on(event, {
                iframe: messageData.iframe,
                screenX: Number(mousePos.x),
                screenY: Number(mousePos.y),
                type: messageData.type
            });
        }
        function on(funcName, val) {
            return chkEvent(iframeId, funcName, val);
        }
        function actionMsg() {
            if (settings[iframeId] && settings[iframeId].firstRun) firstRun();
            switch(messageData.type){
                case 'close':
                    closeIFrame(messageData.iframe);
                    break;
                case 'message':
                    forwardMsgFromIFrame(getMsgBody(6));
                    break;
                case 'mouseenter':
                    onMouse('onMouseEnter');
                    break;
                case 'mouseleave':
                    onMouse('onMouseLeave');
                    break;
                case 'autoResize':
                    settings[iframeId].autoResize = JSON.parse(getMsgBody(9));
                    break;
                case 'scrollTo':
                    scrollRequestFromChild(false);
                    break;
                case 'scrollToOffset':
                    scrollRequestFromChild(true);
                    break;
                case 'pageInfo':
                    sendPageInfoToIframe(settings[iframeId] && settings[iframeId].iframe, iframeId);
                    startPageInfoMonitor();
                    break;
                case 'pageInfoStop':
                    stopPageInfoMonitor();
                    break;
                case 'inPageLink':
                    findTarget(getMsgBody(9));
                    break;
                case 'reset':
                    resetIFrame(messageData);
                    break;
                case 'init':
                    resizeIFrame();
                    on('onInit', messageData.iframe);
                    break;
                default:
                    if (Number(messageData.width) === 0 && Number(messageData.height) === 0) warn('Unsupported message received (' + messageData.type + '), this is likely due to the iframe containing a later ' + 'version of iframe-resizer than the parent page');
                    else resizeIFrame();
            }
        }
        function hasSettings(iframeId) {
            var retBool = true;
            if (!settings[iframeId]) {
                retBool = false;
                warn(messageData.type + ' No settings for ' + iframeId + '. Message was: ' + msg);
            }
            return retBool;
        }
        function iFrameReadyMsgReceived() {
            // eslint-disable-next-line no-restricted-syntax, guard-for-in
            for(var iframeId in settings)trigger('iFrame requested init', createOutgoingMsg(iframeId), settings[iframeId].iframe, iframeId);
        }
        function firstRun() {
            if (settings[iframeId]) settings[iframeId].firstRun = false;
        }
        var msg = event.data, messageData = {}, iframeId = null;
        if ('[iFrameResizerChild]Ready' === msg) iFrameReadyMsgReceived();
        else if (isMessageForUs()) {
            messageData = processMsg();
            iframeId = messageData.id;
            if (settings[iframeId]) settings[iframeId].loaded = true;
            if (!isMessageFromMetaParent() && hasSettings(iframeId)) {
                log(iframeId, 'Received: ' + msg);
                if (checkIFrameExists() && isMessageFromIFrame()) actionMsg();
            }
        } else info(iframeId, 'Ignored: ' + msg);
    }
    function chkEvent(iframeId, funcName, val) {
        var func = null, retVal = null;
        if (settings[iframeId]) {
            func = settings[iframeId][funcName];
            if ('function' === typeof func) retVal = func(val);
            else throw new TypeError(funcName + ' on iFrame[' + iframeId + '] is not a function');
        }
        return retVal;
    }
    function removeIframeListeners(iframe) {
        var iframeId = iframe.id;
        delete settings[iframeId];
    }
    function closeIFrame(iframe) {
        var iframeId = iframe.id;
        if (chkEvent(iframeId, 'onClose', iframeId) === false) {
            log(iframeId, 'Close iframe cancelled by onClose event');
            return;
        }
        log(iframeId, 'Removing iFrame: ' + iframeId);
        try {
            // Catch race condition error with React
            if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        } catch (error) {
            warn(error);
        }
        chkEvent(iframeId, 'onClosed', iframeId);
        log(iframeId, '--');
        removeIframeListeners(iframe);
    }
    function getPagePosition(iframeId) {
        if (null === pagePosition) {
            pagePosition = {
                x: window.pageXOffset !== undefined ? window.pageXOffset : document.documentElement.scrollLeft,
                y: window.pageYOffset !== undefined ? window.pageYOffset : document.documentElement.scrollTop
            };
            log(iframeId, 'Get page position: ' + pagePosition.x + ',' + pagePosition.y);
        }
    }
    function setPagePosition(iframeId) {
        if (null !== pagePosition) {
            window.scrollTo(pagePosition.x, pagePosition.y);
            log(iframeId, 'Set page position: ' + pagePosition.x + ',' + pagePosition.y);
            unsetPagePosition();
        }
    }
    function unsetPagePosition() {
        pagePosition = null;
    }
    function resetIFrame(messageData) {
        function reset() {
            setSize(messageData);
            trigger('reset', 'reset', messageData.iframe, messageData.id);
        }
        log(messageData.id, 'Size reset requested by ' + ('init' === messageData.type ? 'host page' : 'iFrame'));
        getPagePosition(messageData.id);
        syncResize(reset, messageData, 'reset');
    }
    function setSize(messageData) {
        function setDimension(dimension) {
            if (!messageData.id) {
                log('undefined', 'messageData id not set');
                return;
            }
            messageData.iframe.style[dimension] = messageData[dimension] + 'px';
            log(messageData.id, 'IFrame (' + iframeId + ') ' + dimension + ' set to ' + messageData[dimension] + 'px');
        }
        function chkZero(dimension) {
            // FireFox sets dimension of hidden iFrames to zero.
            // So if we detect that set up an event to check for
            // when iFrame becomes visible.
            /* istanbul ignore next */ // Not testable in PhantomJS
            if (!hiddenCheckEnabled && '0' === messageData[dimension]) {
                hiddenCheckEnabled = true;
                log(iframeId, 'Hidden iFrame detected, creating visibility listener');
                fixHiddenIFrames();
            }
        }
        function processDimension(dimension) {
            setDimension(dimension);
            chkZero(dimension);
        }
        var iframeId = messageData.iframe.id;
        if (settings[iframeId]) {
            if (settings[iframeId].sizeHeight) processDimension('height');
            if (settings[iframeId].sizeWidth) processDimension('width');
        }
    }
    function syncResize(func, messageData, doNotSync) {
        /* istanbul ignore if */ // Not testable in PhantomJS
        if (doNotSync !== messageData.type && requestAnimationFrame && // including check for jasmine because had trouble getting spy to work in unit test using requestAnimationFrame
        !window.jasmine) {
            log(messageData.id, 'Requesting animation frame');
            requestAnimationFrame(func);
        } else func();
    }
    function trigger(calleeMsg, msg, iframe, id, noResponseWarning) {
        function postMessageToIFrame() {
            var target = settings[id] && settings[id].targetOrigin;
            log(id, '[' + calleeMsg + '] Sending msg to iframe[' + id + '] (' + msg + ') targetOrigin: ' + target);
            iframe.contentWindow.postMessage(msgId + msg, target);
        }
        function iFrameNotFound() {
            warn(id, '[' + calleeMsg + '] IFrame(' + id + ') not found');
        }
        function chkAndSend() {
            if (iframe && 'contentWindow' in iframe && null !== iframe.contentWindow) // Null test for PhantomJS
            postMessageToIFrame();
            else iFrameNotFound();
        }
        function warnOnNoResponse() {
            function warning() {
                if (settings[id] && !settings[id].loaded && !errorShown) {
                    errorShown = true;
                    warn(id, 'IFrame has not responded within ' + settings[id].warningTimeout / 1000 + ' seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ignored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning.');
                }
            }
            if (!!noResponseWarning && settings[id] && !!settings[id].warningTimeout) settings[id].msgTimeout = setTimeout(warning, settings[id].warningTimeout);
        }
        var errorShown = false;
        id = id || iframe.id;
        if (settings[id]) {
            chkAndSend();
            warnOnNoResponse();
        }
    }
    function createOutgoingMsg(iframeId) {
        return iframeId + ':' + settings[iframeId].bodyMarginV1 + ':' + settings[iframeId].sizeWidth + ':' + settings[iframeId].log + ':' + settings[iframeId].interval + ':' + settings[iframeId].enablePublicMethods + ':' + settings[iframeId].autoResize + ':' + settings[iframeId].bodyMargin + ':' + settings[iframeId].heightCalculationMethod + ':' + settings[iframeId].bodyBackground + ':' + settings[iframeId].bodyPadding + ':' + settings[iframeId].tolerance + ':' + settings[iframeId].inPageLinks + ':' + settings[iframeId].resizeFrom + ':' + settings[iframeId].widthCalculationMethod + ':' + settings[iframeId].mouseEvents;
    }
    function isNumber(value) {
        return typeof value === 'number';
    }
    function setupIFrame(iframe, options) {
        function setLimits() {
            function addStyle(style) {
                var styleValue = settings[iframeId][style];
                if (Infinity !== styleValue && 0 !== styleValue) {
                    iframe.style[style] = isNumber(styleValue) ? styleValue + 'px' : styleValue;
                    log(iframeId, 'Set ' + style + ' = ' + iframe.style[style]);
                }
            }
            function chkMinMax(dimension) {
                if (settings[iframeId]['min' + dimension] > settings[iframeId]['max' + dimension]) throw new Error('Value for min' + dimension + ' can not be greater than max' + dimension);
            }
            chkMinMax('Height');
            chkMinMax('Width');
            addStyle('maxHeight');
            addStyle('minHeight');
            addStyle('maxWidth');
            addStyle('minWidth');
        }
        function newId() {
            var id = options && options.id || defaults.id + count++;
            if (null !== document.getElementById(id)) id += count++;
            return id;
        }
        function ensureHasId(iframeId) {
            if ('' === iframeId) {
                // eslint-disable-next-line no-multi-assign
                iframe.id = iframeId = newId();
                logEnabled = (options || {}).log;
                log(iframeId, 'Added missing iframe ID: ' + iframeId + ' (' + iframe.src + ')');
            }
            return iframeId;
        }
        function setScrolling() {
            log(iframeId, 'IFrame scrolling ' + (settings[iframeId] && settings[iframeId].scrolling ? 'enabled' : 'disabled') + ' for ' + iframeId);
            iframe.style.overflow = false === (settings[iframeId] && settings[iframeId].scrolling) ? 'hidden' : 'auto';
            switch(settings[iframeId] && settings[iframeId].scrolling){
                case 'omit':
                    break;
                case true:
                    iframe.scrolling = 'yes';
                    break;
                case false:
                    iframe.scrolling = 'no';
                    break;
                default:
                    iframe.scrolling = settings[iframeId] ? settings[iframeId].scrolling : 'no';
            }
        }
        // The V1 iFrame script expects an int, where as in V2 expects a CSS
        // string value such as '1px 3em', so if we have an int for V2, set V1=V2
        // and then convert V2 to a string PX value.
        function setupBodyMarginValues() {
            if ('number' === typeof (settings[iframeId] && settings[iframeId].bodyMargin) || '0' === (settings[iframeId] && settings[iframeId].bodyMargin)) {
                settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin;
                settings[iframeId].bodyMargin = '' + settings[iframeId].bodyMargin + 'px';
            }
        }
        function checkReset() {
            // Reduce scope of firstRun to function, because IE8's JS execution
            // context stack is borked and this value gets externally
            // changed midway through running this function!!!
            var firstRun = settings[iframeId] && settings[iframeId].firstRun, resetRequertMethod = settings[iframeId] && settings[iframeId].heightCalculationMethod in resetRequiredMethods;
            if (!firstRun && resetRequertMethod) resetIFrame({
                iframe: iframe,
                height: 0,
                width: 0,
                type: 'init'
            });
        }
        function setupIFrameObject() {
            if (settings[iframeId]) settings[iframeId].iframe.iFrameResizer = {
                close: closeIFrame.bind(null, settings[iframeId].iframe),
                removeListeners: removeIframeListeners.bind(null, settings[iframeId].iframe),
                resize: trigger.bind(null, 'Window resize', 'resize', settings[iframeId].iframe),
                moveToAnchor: function(anchor) {
                    trigger('Move to anchor', 'moveToAnchor:' + anchor, settings[iframeId].iframe, iframeId);
                },
                sendMessage: function(message) {
                    message = JSON.stringify(message);
                    trigger('Send Message', 'message:' + message, settings[iframeId].iframe, iframeId);
                }
            };
        }
        // We have to call trigger twice, as we can not be sure if all
        // iframes have completed loading when this code runs. The
        // event listener also catches the page changing in the iFrame.
        function init(msg) {
            function iFrameLoaded() {
                trigger('iFrame.onload', msg, iframe, undefined, true);
                checkReset();
            }
            function createDestroyObserver(MutationObserver) {
                if (!iframe.parentNode) return;
                var destroyObserver = new MutationObserver(function(mutations) {
                    mutations.forEach(function(mutation) {
                        var removedNodes = Array.prototype.slice.call(mutation.removedNodes) // Transform NodeList into an Array
                        ;
                        removedNodes.forEach(function(removedNode) {
                            if (removedNode === iframe) closeIFrame(iframe);
                        });
                    });
                });
                destroyObserver.observe(iframe.parentNode, {
                    childList: true
                });
            }
            var MutationObserver = getMutationObserver();
            if (MutationObserver) createDestroyObserver(MutationObserver);
            addEventListener(iframe, 'load', iFrameLoaded);
            trigger('init', msg, iframe, undefined, true);
        }
        function checkOptions(options) {
            if ('object' !== typeof options) throw new TypeError('Options is not an object');
        }
        function copyOptions(options) {
            // eslint-disable-next-line no-restricted-syntax
            for(var option in defaults)if (Object.prototype.hasOwnProperty.call(defaults, option)) settings[iframeId][option] = Object.prototype.hasOwnProperty.call(options, option) ? options[option] : defaults[option];
        }
        function getTargetOrigin(remoteHost) {
            return '' === remoteHost || null !== remoteHost.match(/^(about:blank|javascript:|file:\/\/)/) ? '*' : remoteHost;
        }
        function depricate(key) {
            var splitName = key.split('Callback');
            if (splitName.length === 2) {
                var name = 'on' + splitName[0].charAt(0).toUpperCase() + splitName[0].slice(1);
                this[name] = this[key];
                delete this[key];
                warn(iframeId, "Deprecated: '" + key + "' has been renamed '" + name + "'. The old method will be removed in the next major version.");
            }
        }
        function processOptions(options) {
            options = options || {};
            settings[iframeId] = {
                firstRun: true,
                iframe: iframe,
                remoteHost: iframe.src && iframe.src.split('/').slice(0, 3).join('/')
            };
            checkOptions(options);
            Object.keys(options).forEach(depricate, options);
            copyOptions(options);
            if (settings[iframeId]) settings[iframeId].targetOrigin = true === settings[iframeId].checkOrigin ? getTargetOrigin(settings[iframeId].remoteHost) : '*';
        }
        function beenHere() {
            return iframeId in settings && 'iFrameResizer' in iframe;
        }
        var iframeId = ensureHasId(iframe.id);
        if (!beenHere()) {
            processOptions(options);
            setScrolling();
            setLimits();
            setupBodyMarginValues();
            init(createOutgoingMsg(iframeId));
            setupIFrameObject();
        } else warn(iframeId, 'Ignored iFrame, already setup.');
    }
    function debouce(fn, time) {
        if (null === timer) timer = setTimeout(function() {
            timer = null;
            fn();
        }, time);
    }
    var frameTimer = {};
    function debounceFrameEvents(fn, time, frameId) {
        if (!frameTimer[frameId]) frameTimer[frameId] = setTimeout(function() {
            frameTimer[frameId] = null;
            fn();
        }, time);
    }
    // Not testable in PhantomJS
    /* istanbul ignore next */ function fixHiddenIFrames() {
        function checkIFrames() {
            function checkIFrame(settingId) {
                function chkDimension(dimension) {
                    return '0px' === (settings[settingId] && settings[settingId].iframe.style[dimension]);
                }
                function isVisible(el) {
                    return null !== el.offsetParent;
                }
                if (settings[settingId] && isVisible(settings[settingId].iframe) && (chkDimension('height') || chkDimension('width'))) trigger('Visibility change', 'resize', settings[settingId].iframe, settingId);
            }
            Object.keys(settings).forEach(function(key) {
                checkIFrame(key);
            });
        }
        function mutationObserved(mutations) {
            log('window', 'Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type);
            debouce(checkIFrames, 16);
        }
        function createMutationObserver() {
            var target = document.querySelector('body'), config = {
                attributes: true,
                attributeOldValue: false,
                characterData: true,
                characterDataOldValue: false,
                childList: true,
                subtree: true
            }, observer = new MutationObserver(mutationObserved);
            observer.observe(target, config);
        }
        var MutationObserver = getMutationObserver();
        if (MutationObserver) createMutationObserver();
    }
    function resizeIFrames(event) {
        function resize() {
            sendTriggerMsg('Window ' + event, 'resize');
        }
        log('window', 'Trigger event: ' + event);
        debouce(resize, 16);
    }
    // Not testable in PhantomJS
    /* istanbul ignore next */ function tabVisible() {
        function resize() {
            sendTriggerMsg('Tab Visable', 'resize');
        }
        if ('hidden' !== document.visibilityState) {
            log('document', 'Trigger event: Visiblity change');
            debouce(resize, 16);
        }
    }
    function sendTriggerMsg(eventName, event) {
        function isIFrameResizeEnabled(iframeId) {
            return settings[iframeId] && 'parent' === settings[iframeId].resizeFrom && settings[iframeId].autoResize && !settings[iframeId].firstRun;
        }
        Object.keys(settings).forEach(function(iframeId) {
            if (isIFrameResizeEnabled(iframeId)) trigger(eventName, event, settings[iframeId].iframe, iframeId);
        });
    }
    function setupEventListeners() {
        addEventListener(window, 'message', iFrameListener);
        addEventListener(window, 'resize', function() {
            resizeIFrames('resize');
        });
        addEventListener(document, 'visibilitychange', tabVisible);
        addEventListener(document, '-webkit-visibilitychange', tabVisible);
    }
    function factory() {
        function init(options, element) {
            function chkType() {
                if (!element.tagName) throw new TypeError('Object is not a valid DOM element');
                else if ('IFRAME' !== element.tagName.toUpperCase()) throw new TypeError('Expected <IFRAME> tag, found <' + element.tagName + '>');
            }
            if (element) {
                chkType();
                setupIFrame(element, options);
                iFrames.push(element);
            }
        }
        function warnDeprecatedOptions(options) {
            if (options && options.enablePublicMethods) warn('enablePublicMethods option has been removed, public methods are now always available in the iFrame');
        }
        var iFrames;
        setupRequestAnimationFrame();
        setupEventListeners();
        return function iFrameResizeF(options, target) {
            iFrames = [] // Only return iFrames past in on this call
            ;
            warnDeprecatedOptions(options);
            switch(typeof target){
                case 'undefined':
                case 'string':
                    Array.prototype.forEach.call(document.querySelectorAll(target || 'iframe'), init.bind(undefined, options));
                    break;
                case 'object':
                    init(options, target);
                    break;
                default:
                    throw new TypeError('Unexpected data type (' + typeof target + ')');
            }
            return iFrames;
        };
    }
    function createJQueryPublicMethod($) {
        if (!$.fn) info('', 'Unable to bind to jQuery, it is not fully loaded.');
        else if (!$.fn.iFrameResize) $.fn.iFrameResize = function $iFrameResizeF(options) {
            function init(index, element) {
                setupIFrame(element, options);
            }
            return this.filter('iframe').each(init).end();
        };
    }
    if (window.jQuery) createJQueryPublicMethod(window.jQuery);
    if (typeof define === 'function' && define.amd) define([], factory);
    else if (typeof module.exports === 'object') // Node for browserfy
    module.exports = factory();
    window.iFrameResize = window.iFrameResize || factory();
})();

});

parcelRegister("ijfiP", function(module, exports) {

var $7MEO5 = parcelRequire("7MEO5");

const $e2d7503e18a8780a$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const ari = (0, $7MEO5.parse)(extensionId);
    const [appId, environmentId, groupId, moduleKey] = ari.resourceId.split('/');
    return {
        appId: appId,
        environmentId: environmentId,
        groupId: groupId,
        moduleKey: moduleKey
    };
};
module.exports["parseExtensionId"] = $e2d7503e18a8780a$export$bae42cbaf7fa3e1b;

});

parcelRegister("bsX2q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $grQpA = parcelRequire("grQpA");


var $5U2YR = parcelRequire("5U2YR");


var $39Ajm = parcelRequire("39Ajm");


var $inPa6 = parcelRequire("inPa6");


var $7TH2w = parcelRequire("7TH2w");


var $3Spjc = parcelRequire("3Spjc");


var $1Igmn = parcelRequire("1Igmn");

const $0f17c7f20af36c2d$export$73c0408abd298d1b = (client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale, ssr = false)=>{
    const variables = filter ? {
        contextIds: contextIds,
        locale: locale,
        filter: filter
    } : {
        contextIds: contextIds,
        locale: locale,
        type: extensionType
    };
    const query = filter ? (0, $39Ajm.getExtensionListQuery)(expandAppOwner, dataClassificationTagIds) : (0, $39Ajm.getExtensionListQueryOld)(expandAppOwner, undefined, dataClassificationTagIds);
    // In SSR mode render and fetch is one-pass we can't do cache-and-network
    if (ssr && queryOptions?.fetchPolicy === 'cache-and-network') queryOptions.fetchPolicy = 'cache-first';
    return {
        variables: variables,
        ...queryOptions,
        query: query,
        client: client,
        /**
		 * We don't want to set 'ignore' because that discards errors and we need to inspect
		 * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
		 * https://www.apollographql.com/docs/react/data/error-handling/
		 */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
            }
        }
    };
};
const $0f17c7f20af36c2d$export$1e6dc3c07340999 = ({ loading: loading, data: data })=>{
    if (!loading && data && data.extensionContexts && data.extensionContexts[0]) {
        if ('extensions' in data.extensionContexts[0]) return data.extensionContexts[0].extensions ?? null;
        else if ('extensionsByType' in data.extensionContexts[0]) return data.extensionContexts[0].extensionsByType ?? null;
    }
    return null;
};
const $0f17c7f20af36c2d$export$cab421e039d23b2 = ({ contextIds: contextIds, type: extensionType, filter: filter, client: client, queryOptions: queryOptions, expandAppOwner: expandAppOwner, dataClassificationTagIds: dataClassificationTagIds, locale: locale })=>{
    const requestOptions = $0f17c7f20af36c2d$export$73c0408abd298d1b(client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale);
    const query = filter ? (0, $39Ajm.getExtensionListQuery)(expandAppOwner) : (0, $39Ajm.getExtensionListQueryOld)(expandAppOwner);
    const { error: error, loading: loading, data: data } = (0, $xQxzY.useQuery)(requestOptions.query || query, requestOptions);
    const extensions = $0f17c7f20af36c2d$export$1e6dc3c07340999({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'useExtensionList'
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err = error.graphQLErrors.find((err)=>(0, $grQpA.isGQLUnderlyingServiceError)(err) || (0, $grQpA.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'useExtensionList',
                        errorName: err ? (0, $grQpA.isGQLUnderlyingServiceError)(err) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};
module.exports["createExtensionListQueryOptions"] = $0f17c7f20af36c2d$export$73c0408abd298d1b;
module.exports["getExtensionsFromGQLResult"] = $0f17c7f20af36c2d$export$1e6dc3c07340999;
module.exports["useExtensionList"] = $0f17c7f20af36c2d$export$cab421e039d23b2;

});

parcelRegister("i2hng", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4JDbp = parcelRequire("4JDbp");

const $e15251f056a7fc02$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(0);
const $e15251f056a7fc02$var$SCROLLBAR_WIDTH = 30;
const $e15251f056a7fc02$export$7921e18173e8c666 = ({ children: children })=>{
    const [width, setWidth] = (0, $42omo.useState)(0);
    const handleWidthChange = (newWidth)=>{
        // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
        if (!newWidth || Math.abs(width - newWidth) < $e15251f056a7fc02$var$SCROLLBAR_WIDTH) return;
        setWidth(newWidth);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4JDbp.WidthObserver), {
        setWidth: handleWidthChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e15251f056a7fc02$export$27e39f636459b9f.Provider, {
        value: width
    }, children));
};
const $e15251f056a7fc02$export$5d8538aa831b6ebb = $e15251f056a7fc02$export$27e39f636459b9f.Consumer;
module.exports["WidthContext"] = $e15251f056a7fc02$export$27e39f636459b9f;
module.exports["WidthProvider"] = $e15251f056a7fc02$export$7921e18173e8c666;

});

parcelRegister("9UyM5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d399cb7128821634$export$75ab56226e2d3efd = /*#__PURE__*/ (0, $42omo.createContext)({
    inline: false
});
const $d399cb7128821634$export$3828d4e780bd54a = ()=>(0, $42omo.useContext)($d399cb7128821634$export$75ab56226e2d3efd);
module.exports["InlineContext"] = $d399cb7128821634$export$75ab56226e2d3efd;
module.exports["useInlineContext"] = $d399cb7128821634$export$3828d4e780bd54a;

});

parcelRegister("gvvHu", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");


var $CMcde = parcelRequire("CMcde");

function $3044cb8be034d2df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $3044cb8be034d2df$var$AKSectionMessage = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9uD5t")));

const $3044cb8be034d2df$var$SectionMessageAction = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hAO4A")));
const $3044cb8be034d2df$var$textWrapCss = {
    name: "1089mxj",
    styles: "white-space:pre-wrap"
};
var $3044cb8be034d2df$var$_ref = {
    name: "1axjbqe",
    styles: "width:100%;ul{padding-left:0;}"
};
const $3044cb8be034d2df$var$ErrorPanel = ({ error: error, dispatch: dispatch, isReloadPage: isReloadPage })=>{
    const { message: message, errorDetails: errorDetails, errorMessage: errorMessage } = error;
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const intl = (0, $8C5kA.default)();
    const reinitializeApp = async ()=>{
        if (isReloadPage) window.location.reload();
        setIsLoading(true);
        try {
            if (dispatch) await dispatch({
                type: 'render',
                extensionData: {}
            });
        } finally{
            setIsLoading(false);
        }
    };
    if (isLoading) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $CMcde.Loader), null);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: $3044cb8be034d2df$var$_ref
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($3044cb8be034d2df$var$AKSectionMessage, {
        appearance: "error",
        title: message,
        actions: [
            {
                key: 'refresh',
                text: intl.formatMessage(isReloadPage ? $3044cb8be034d2df$var$messages.reloadPage : $3044cb8be034d2df$var$messages.refreshApp),
                onClick: reinitializeApp
            }
        ].map(({ text: text, key: key, onClick: onClick })=>/*#__PURE__*/ (0, $9K4OG.jsx)($3044cb8be034d2df$var$SectionMessageAction, {
                key: key,
                onClick: onClick
            }, text))
    }, errorMessage && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $3044cb8be034d2df$var$textWrapCss
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), {
        as: "p"
    }, errorMessage)), errorDetails && /*#__PURE__*/ (0, $9K4OG.jsx)("pre", {
        css: $3044cb8be034d2df$var$textWrapCss
    }, errorDetails)));
};
var $3044cb8be034d2df$export$2e2bcd8739ae039 = $3044cb8be034d2df$var$ErrorPanel;
const $3044cb8be034d2df$export$1fe699079d0f690f = ({ forgeDoc: forgeDoc, dispatch: dispatch })=>{
    const { error: error } = forgeDoc.props;
    return /*#__PURE__*/ (0, $9K4OG.jsx)($3044cb8be034d2df$var$ErrorPanel, {
        key: "error",
        error: error,
        dispatch: dispatch
    });
};
const $3044cb8be034d2df$var$messages = (0, $cgtv4.defineMessages)({
    refreshApp: {
        id: "confluence.error.panel.refresh.app",
        defaultMessage: "Refresh app"
    },
    reloadPage: {
        id: "confluence.error.panel.reload.page",
        defaultMessage: "Reload page"
    }
});
module.exports["default"] = $3044cb8be034d2df$export$2e2bcd8739ae039;
module.exports["ErrorPanelRenderFn"] = $3044cb8be034d2df$export$1fe699079d0f690f;

});

parcelRegister("er4dw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gGmck = parcelRequire("gGmck");


var $5dK2X = parcelRequire("5dK2X");


var $aoVih = parcelRequire("aoVih");


var $2Nwuj = parcelRequire("2Nwuj");

const $4da241c59eddfab6$export$5cfbc54f19d7d1a4 = ({ url: url })=>{
    const { forgeEnvironment: forgeEnvironment } = (0, $42omo.useContext)((0, $gGmck.RendererContext));
    const dataUriRegex = /^data/;
    const isDataUri = dataUriRegex.test(url);
    if (forgeEnvironment === 'DEVELOPMENT') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "error",
        testId: "egress-error-message"
    }, isDataUri ? // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, "Please use the ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        as: "strong"
    }, "data:image"), " scheme for an image source.") : // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, "Egress permissions for", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: url,
        target: "_blank"
    }, url), ' ', "missing in the manifest. For more information", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: "https://developer.atlassian.com/platform/forge/manifest-reference/permissions/#images",
        target: "_blank"
    }, "see reference docs"), "."));
    return(// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "error"
    }, "Unable to display due to an image link issue."));
};
module.exports["EgressErrorMessage"] = $4da241c59eddfab6$export$5cfbc54f19d7d1a4;

});

parcelRegister("kS0x0", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lzcvT = parcelRequire("lzcvT");

var $T9xHm = parcelRequire("T9xHm");


var $1c598 = parcelRequire("1c598");


var $lMJg3 = parcelRequire("lMJg3");


var $jIiuI = parcelRequire("jIiuI");

var $gGmck = parcelRequire("gGmck");


var $b7qxC = parcelRequire("b7qxC");


var $dh538 = parcelRequire("dh538");


var $dRFAM = parcelRequire("dRFAM");

// --------------------------------------------------------------------------------------------------------------------
//
// NOTE: any changes to these hosts MUST BE applied to the Forge Monorepo -- and vice versa.
// See packages/forge-csp/src/csp/csp-injection-service.ts for the original source code.
//
// --------------------------------------------------------------------------------------------------------------------
/**
 * Media API is used to store product attachments.
 * URLs are defined here: https://developer.atlassian.com/platform/media/support/faq/#which-environment-should-i-use-
 */ const $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST = {
    dev: 'https://api.dev.atlassian.com',
    stg: 'https://api.stg.atlassian.com',
    prod: 'https://api.atlassian.com',
    'fedramp-stg': 'https://api.stg.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://api.atlassian-us-gov-mod.com'
};
const $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST = {
    dev: 'https://media.dev.atl-paas.net',
    stg: 'https://media.staging.atl-paas.net',
    prod: 'https://api.media.atlassian.com',
    'fedramp-stg': 'https://api-media.stg.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://api-media.atlassian-us-gov-mod.com'
};
const $576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST = {
    dev: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
    stg: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
    prod: 'avatar-management--avatars.us-west-2.prod.public.atl-paas.net',
    'fedramp-stg': 'avatar-management--avatars.us-east-1.staging.cdn.atlassian-us-gov-mod.com',
    'fedramp-prod': 'avatar-management--avatars.us-east-1.prod.cdn.atlassian-us-gov-mod.com'
};
const $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST = {
    dev: 'https://pf-emoji-service--cdn.ap-southeast-2.dev.public.atl-paas.net',
    stg: 'https://pf-emoji-service--cdn.us-east-1.staging.public.atl-paas.net',
    prod: 'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net',
    'fedramp-stg': 'https://pf-emoji-service--cdn.us-east-1.staging.cdn.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://pf-emoji-service--cdn.us-east-1.prod.cdn.atlassian-us-gov-mod.com'
};
const $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST = {
    dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/gradients/',
    stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/gradients/',
    prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/gradients/',
    'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
    'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/'
};
const $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST = {
    dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
    stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
    prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/',
    'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
    'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/'
};
const $576cfccaadb64755$var$ATLASSIAN_FOS_HOST = {
    dev: 'https://tdp-os.dev.services.atlassian.com',
    stg: 'https://tdp-os.stg.services.atlassian.com',
    prod: 'https://tdp-os.services.atlassian.com',
    'fedramp-stg': 'https://tdp-os.stg.services.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://tdp-os.services.atlassian-us-gov-mod.com'
};
const $576cfccaadb64755$var$getFOSHosts = (env)=>[
        `${$576cfccaadb64755$var$ATLASSIAN_FOS_HOST[env]}/fos-eap/download/*`,
        `${$576cfccaadb64755$var$ATLASSIAN_FOS_HOST[env]}/fos/app/download/*`,
        `${$576cfccaadb64755$var$ATLASSIAN_FOS_HOST[env]}/fos/cdn/download/*`
    ];
/**
 * Atlassian products use Wordpress as a proxy to serve avatar images in certain conditions.
 * Not allowing them by default forces developers to add the `*.wp.com` domain to the CSP image policy.
 * See: https://hello.atlassian.net/wiki/x/XJpuCgE
 */ const $576cfccaadb64755$var$ATLASSIAN_IMAGES_HOSTS = {
    dev: [
        `https://${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['dev']}`,
        `https://*.wp.com/${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['dev']}/`,
        $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST['dev'],
        $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST['dev'],
        $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST['dev'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST['dev'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST['dev']
    ],
    stg: [
        `https://${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['stg']}`,
        `https://*.wp.com/${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['stg']}/`,
        $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST['stg'],
        $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST['stg'],
        $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST['stg'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST['stg'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST['stg']
    ],
    prod: [
        `https://${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['prod']}`,
        `https://*.wp.com/${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['prod']}/`,
        $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST['prod'],
        $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST['prod'],
        $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST['prod'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST['prod'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST['prod']
    ],
    'fedramp-stg': [
        `https://${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['fedramp-stg']}`,
        `https://*.wp.com/${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['fedramp-stg']}/`,
        $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST['fedramp-stg'],
        $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST['fedramp-stg'],
        $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST['fedramp-stg'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST['fedramp-stg'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST['fedramp-stg']
    ],
    'fedramp-prod': [
        `https://${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['fedramp-prod']}`,
        `https://*.wp.com/${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['fedramp-prod']}/`,
        $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST['fedramp-prod'],
        $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST['fedramp-prod'],
        $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST['fedramp-prod'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST['fedramp-prod'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST['fedramp-prod']
    ]
};
// --------------------------------------------------------------------------------------------------------------------
/**
 * Gravatar is still used internally to serve legacy Atlassian avatars.
 * Unsplash is integrated by default in Confluence to the header image picker functionality.
 */ const $576cfccaadb64755$var$EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS = [
    'https://secure.gravatar.com',
    'https://images.unsplash.com'
];
const $576cfccaadb64755$export$189ea7794c50ff15 = (url, iframeDomainName)=>{
    if (!iframeDomainName) return false;
    let imageSrcUrl;
    try {
        imageSrcUrl = new URL(url);
        // Image is valid if it comes from the same domain as the iframe OR if it's being served from localhost (when using forge tunnel)
        return iframeDomainName === imageSrcUrl.host || imageSrcUrl.hostname === 'localhost';
    } catch (e) {
        return false;
    }
};
const $576cfccaadb64755$var$getImageHostsEnvironment = (environment)=>{
    if ((0, $lzcvT.isFedRamp)()) {
        if (environment === (0, $1c598.ProductEnvironment).STAGING) return 'fedramp-stg';
        return 'fedramp-prod';
    }
    return (0, $b7qxC.getCDNEnvironment)(environment);
};
const $576cfccaadb64755$var$getImageHostsEnvironmentForIC = (environment)=>{
    return environment === (0, $1c598.ProductEnvironment).PRODUCTION ? 'ic-prod' : 'ic-stg';
};
const $576cfccaadb64755$var$getAtlassianImageHosts = (environment)=>{
    if ((0, $dh538.fg)('forge-ui-oasis-enabled')) {
        if ((0, $T9xHm.isIsolatedCloud)()) {
            const icImageHostsEnvironment = $576cfccaadb64755$var$getImageHostsEnvironmentForIC(environment);
            return (0, $dRFAM.getAtlassianImageHost)(icImageHostsEnvironment, {
                getICDomain: ()=>(0, $T9xHm.isolatedCloudDomain)()
            });
        }
        const imageHostsEnvironment = $576cfccaadb64755$var$getImageHostsEnvironment(environment);
        return (0, $dRFAM.getAtlassianImageHost)(imageHostsEnvironment);
    }
    return $576cfccaadb64755$var$getAtlassianImageHostsForCommercialAndFedRamp(environment);
};
const $576cfccaadb64755$var$getAtlassianImageHostsForCommercialAndFedRamp = (environment)=>{
    const imageHostsEnvironment = $576cfccaadb64755$var$getImageHostsEnvironment(environment);
    return [
        ...$576cfccaadb64755$var$ATLASSIAN_IMAGES_HOSTS[imageHostsEnvironment],
        ...$576cfccaadb64755$var$getFOSHosts(imageHostsEnvironment)
    ];
};
const $576cfccaadb64755$export$3a08b61b3ed9a4da = (url)=>{
    const { egress: egress, appDomainName: appDomainName } = (0, $42omo.useContext)((0, $gGmck.RendererContext));
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const allowListedImageHosts = [
        window.location.hostname,
        ...$576cfccaadb64755$var$getAtlassianImageHosts(environment),
        ...$576cfccaadb64755$var$EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS
    ];
    const egressService = (0, $lMJg3.useEgressPermissionService)('IMAGES', [
        ...egress || [],
        {
            type: 'IMAGES',
            addresses: allowListedImageHosts
        }
    ]);
    return $576cfccaadb64755$export$6e0a24fd7459483a(url, egressService, appDomainName);
};
const $576cfccaadb64755$export$6e0a24fd7459483a = (url, egressService, appDomainName)=>{
    const dataImageUrlRegex = /^data:image/;
    try {
        const isValidUrl = $576cfccaadb64755$export$189ea7794c50ff15(url, appDomainName) || dataImageUrlRegex.test(url) || egressService.isValidUrl(url);
        return isValidUrl;
    } catch (e) {
        return false;
    }
};
module.exports["useIsValidImageUrl"] = $576cfccaadb64755$export$3a08b61b3ed9a4da;
module.exports["isValidImageUrl"] = $576cfccaadb64755$export$6e0a24fd7459483a;

});

parcelRegister("JmaBh", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $caX7N = parcelRequire("caX7N");


var $dTk3A = parcelRequire("dTk3A");

const $f76408e65cd851d4$var$dest = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $f76408e65cd851d4$var$Provider = $f76408e65cd851d4$var$dest.Provider;
const $f76408e65cd851d4$export$7d41556b227a95c9 = $f76408e65cd851d4$var$dest.Consumer;
const $f76408e65cd851d4$export$6df4068a17305b10 = ({ children: children })=>{
    const [portal, setPortal] = (0, $42omo.useState)();
    const [isPortalReady, setIsPortalReady] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (portal !== null) setIsPortalReady(true);
    }, [
        portal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isPortalReady && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f76408e65cd851d4$var$Provider, {
        value: portal
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caX7N.default), {
        zIndex: (0, $dTk3A.layers).modal() + 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "forge-ui-portal",
        ref: setPortal
    })));
};
module.exports["PortalConsumer"] = $f76408e65cd851d4$export$7d41556b227a95c9;
module.exports["PortalProvider"] = $f76408e65cd851d4$export$6df4068a17305b10;

});

parcelRegister("jLYRk", function(module, exports) {

var $2Nwuj = parcelRequire("2Nwuj");


var $dh538 = parcelRequire("dh538");


var $42omo = parcelRequire("42omo");


var $5dK2X = parcelRequire("5dK2X");


var $gGmck = parcelRequire("gGmck");


var $1nSBE = parcelRequire("1nSBE");

const $a08eb7c3df84467c$var$useDeprecationWarning = (componentName)=>{
    const { forgeEnvironment: forgeEnvironment } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $gGmck.RendererContext));
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (forgeEnvironment !== 'PRODUCTION') (0, $1nSBE.default)(`[@forge/react: ${componentName}] Warning: The "${componentName}" component is deprecated and will be removed on the 28th of August 2025. Please use the "Text" component instead. For more information, visit: https://developer.atlassian.com/platform/forge/ui-kit/components/text/.`);
    }, [
        forgeEnvironment,
        componentName
    ]);
};

const $a08eb7c3df84467c$var$AkButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("6fyld")));
// taken from https://hello.atlassian.net/wiki/spaces/PRODSEC/pages/158006558/URI+scheme+Allow+listing
const $a08eb7c3df84467c$var$PROTOCOL_ALLOWLIST = [
    'http:',
    'https:',
    'ftp:',
    'ftps:',
    'mailto:',
    'skype:',
    'callto:',
    'facetime:',
    'git:',
    'irc:',
    'irc6:',
    'news:',
    'nntp:',
    'feed:',
    'cvs:',
    'svn:',
    'mvn:',
    'ssh:',
    'scp:',
    'sftp:',
    'itms:',
    'notes:',
    'hipchat:',
    'sourcetree:',
    'urn:',
    'tel:',
    'xmpp:',
    'telnet:',
    'vnc:',
    'rdp:',
    'whatsapp:',
    'slack:',
    'sip:',
    'sips:',
    'magnet:',
    'tds:'
];
const $a08eb7c3df84467c$export$300bd6d67c49dbfc = (urlString)=>{
    const url = new URL(urlString || '', window.location.href);
    if ($a08eb7c3df84467c$var$PROTOCOL_ALLOWLIST.includes(url.protocol)) return url.toString();
    else return 'about:blank';
};
function $a08eb7c3df84467c$export$e7bdca014c19fc5c({ children: children }) {
    $a08eb7c3df84467c$var$useDeprecationWarning('Em');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        as: "em"
    }, children);
}
function $a08eb7c3df84467c$export$a6c7ac8248d6e38a({ href: href, children: children, openNewTab: openNewTab, appearance: appearance }) {
    const sanitizedHref = $a08eb7c3df84467c$export$300bd6d67c49dbfc(href);
    if (appearance === 'primary-button' || appearance === 'button') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a08eb7c3df84467c$var$AkButton, {
        appearance: appearance === 'primary-button' ? 'primary' : 'default',
        href: sanitizedHref,
        rel: "noopener noreferrer",
        target: openNewTab ? '_blank' : undefined
    }, children);
    else return (0, $dh538.fg)('dst-a11y__replace-anchor-with-link__forge-ui') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: sanitizedHref,
        rel: "noopener noreferrer",
        target: openNewTab ? '_blank' : undefined
    }, children) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        href: sanitizedHref,
        rel: "noopener noreferrer",
        target: openNewTab ? '_blank' : undefined
    }, children);
}
function $a08eb7c3df84467c$export$97176b8d51d2058f({ children: children }) {
    $a08eb7c3df84467c$var$useDeprecationWarning('Strike');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("s", null, children);
}
function $a08eb7c3df84467c$export$89b8e0fa65f6a914({ text: text }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, text);
}
function $a08eb7c3df84467c$export$f301627d437cff88({ children: children }) {
    $a08eb7c3df84467c$var$useDeprecationWarning('Strong');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        as: "strong"
    }, children);
}
function $a08eb7c3df84467c$var$wrap(Component) {
    return function WrappedComponent({ Components: Components, children: children, props: propsAny, render: render, renderChildren: renderChildren, dispatch: dispatch }) {
        const props = propsAny;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props, renderChildren({
            Components: Components,
            children: children,
            render: render,
            dispatch: dispatch
        }));
    };
}
const $a08eb7c3df84467c$export$fec26b2d751c6d95 = $a08eb7c3df84467c$var$wrap($a08eb7c3df84467c$export$e7bdca014c19fc5c);
const $a08eb7c3df84467c$export$7c70dc97eeeaf683 = $a08eb7c3df84467c$var$wrap($a08eb7c3df84467c$export$a6c7ac8248d6e38a);
const $a08eb7c3df84467c$export$e9e7c187aef6a83a = $a08eb7c3df84467c$var$wrap($a08eb7c3df84467c$export$97176b8d51d2058f);
const $a08eb7c3df84467c$export$11a9c970dcafffc0 = $a08eb7c3df84467c$var$wrap($a08eb7c3df84467c$export$89b8e0fa65f6a914);
const $a08eb7c3df84467c$export$566c617eb72a5976 = $a08eb7c3df84467c$var$wrap($a08eb7c3df84467c$export$f301627d437cff88);
module.exports["sanitizeUrl"] = $a08eb7c3df84467c$export$300bd6d67c49dbfc;
module.exports["EmFn"] = $a08eb7c3df84467c$export$fec26b2d751c6d95;
module.exports["LinkFn"] = $a08eb7c3df84467c$export$7c70dc97eeeaf683;
module.exports["StrikeFn"] = $a08eb7c3df84467c$export$e9e7c187aef6a83a;
module.exports["StringFn"] = $a08eb7c3df84467c$export$11a9c970dcafffc0;
module.exports["StrongFn"] = $a08eb7c3df84467c$export$566c617eb72a5976;

});

parcelRegister("gIr1J", function(module, exports) {
const $6740a775674ef88d$export$2d5db5bd91fc0e = (modalSize)=>{
    switch(modalSize){
        case 'xlarge':
            return 'x-large';
        case 'max':
            return '100%';
        default:
            return modalSize;
    }
};
module.exports["getADSModalWidth"] = $6740a775674ef88d$export$2d5db5bd91fc0e;

});

parcelRegister("6oQb1", function(module, exports) {

var $7TH2w = parcelRequire("7TH2w");


var $inPa6 = parcelRequire("inPa6");


var $5U2YR = parcelRequire("5U2YR");


var $3Spjc = parcelRequire("3Spjc");


var $hQK66 = parcelRequire("hQK66");


var $dh538 = parcelRequire("dh538");


var $1Mfb8 = parcelRequire("1Mfb8");


var $7oKJR = parcelRequire("7oKJR");

const $eccfed1aa8771b08$export$43835e9acf248a15 = (createAnalyticsEvent, { action: action, actionSubject: actionSubject, source: source, attributes: attributes }, options)=>{
    const { sampleRate: sampleRate, filter: filter } = options ?? {};
    // If a sample rate is provided, we can use it to determine whether to fire the event
    if (sampleRate) {
        const randomValue = Math.random();
        if (randomValue > sampleRate) return; // Don't fire the event
    }
    const event = createAnalyticsEvent({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        data: {
            action: action,
            actionSubject: actionSubject,
            attributes: attributes,
            source: source,
            tags: [
                'forge'
            ]
        }
    });
    // Don't fire the event if there's a filter and event does not pass it
    if (filter && !filter(event)) return;
    event.fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
};
// Ideally this should be removed entirely in the future.
// see: https://hello.atlassian.net/wiki/spaces/ECO/pages/5687458412/Why+is+GASv3+Event+Costs+and+Volumes+Climbing+Cost+Saving+Proposal
const $eccfed1aa8771b08$var$legacyTrackBridgeSucceed = (createAnalyticsEvent, { source: source, method: method, additionalAttributes: additionalAttributes, forgeEnvironment: forgeEnvironment })=>$eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'succeeded',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            ...additionalAttributes ?? {},
            method: method,
            forgeEnvironment: forgeEnvironment
        }
    });
// We limit the type of bridge methods we track to only the ones we are analysing in databricks to avoid sending too many events
const $eccfed1aa8771b08$var$allowedBridgeMethods = {
    navigate: {
        allowed: true,
        options: {
            sampleRate: 0.1
        }
    },
    openRovo: {
        allowed: true
    }
};
const $eccfed1aa8771b08$var$optimisedTrackBridgeSucceed = (createAnalyticsEvent, { source: source, method: method, additionalAttributes: additionalAttributes, forgeEnvironment: forgeEnvironment })=>{
    if ((0, $dh538.fg)('forge-ui-allowed-bridge-methods-events')) {
        if ($eccfed1aa8771b08$var$allowedBridgeMethods[method]?.allowed) $eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
            action: 'succeeded',
            actionSubject: 'forge.ui.bridge',
            source: source,
            attributes: {
                ...additionalAttributes ?? {},
                method: method,
                forgeEnvironment: forgeEnvironment
            }
        }, $eccfed1aa8771b08$var$allowedBridgeMethods[method]?.options);
        return;
    }
    // currently only `navigate` bridge method is used in the product dashboard
    if (method === 'navigate') // send only 10% of the events as sampled data should sufficient to infer the frequence of feature usage.
    $eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'succeeded',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            ...additionalAttributes ?? {},
            method: method,
            forgeEnvironment: forgeEnvironment
        }
    }, {
        sampleRate: 0.1
    });
};
const $eccfed1aa8771b08$var$trackForgeFeatureFlagEvent = (createAnalyticsEvent, { source: source, appType: appType, baseUrl: baseUrl, appId: appId, flagName: flagName, eventType: eventType, success: success, featureFlagEnv: featureFlagEnv, forgeEnvironment: forgeEnvironment })=>{
    $eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: eventType,
        actionSubject: 'forge.ui.feature_flag',
        source: source,
        attributes: {
            appType: appType,
            baseUrl: baseUrl,
            appId: appId,
            flagName: flagName,
            eventType: eventType,
            success: success,
            featureFlagEnv: featureFlagEnv,
            forgeEnvironment: forgeEnvironment
        }
    });
};
const $eccfed1aa8771b08$var$trackObjectStoreAction = (createAnalyticsEvent, { source: source, appType: appType, appId: appId, action: action, forgeEnvironment: forgeEnvironment })=>{
    $eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: action,
        actionSubject: 'forge.ui.object_store',
        source: source,
        attributes: {
            appType: appType,
            appId: appId,
            forgeEnvironment: forgeEnvironment
        }
    });
};
const $eccfed1aa8771b08$export$f4ca3aaa7a36404 = (createAnalyticsEvent, payload)=>(0, $dh538.fg)('forge-ui-event-cost-optimisation') ? $eccfed1aa8771b08$var$optimisedTrackBridgeSucceed(createAnalyticsEvent, payload) : $eccfed1aa8771b08$var$legacyTrackBridgeSucceed(createAnalyticsEvent, payload);
const $eccfed1aa8771b08$export$5c425ded9b0e7602 = (createAnalyticsEvent, { source: source, errorName: errorName, method: method, forgeEnvironment: forgeEnvironment, additionalAttributes: additionalAttributes })=>$eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'failed',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            ...additionalAttributes ?? {},
            error: errorName,
            method: method,
            forgeEnvironment: forgeEnvironment
        }
    });
const $eccfed1aa8771b08$export$d84d2f0ce1c82c0 = (createAnalyticsEvent, { source: source, isLegacyUiKit: isLegacyUiKit, forgeEnvironment: forgeEnvironment, components: components, forgeReactMajorVersion: forgeReactMajorVersion })=>$eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'rendered',
        actionSubject: 'forge.ui.analytics.component_usage',
        source: source,
        attributes: {
            appType: `UIKit${isLegacyUiKit ? '1' : ''}`,
            forgeEnvironment: forgeEnvironment,
            components: components,
            forgeReactMajorVersion: forgeReactMajorVersion
        }
    });
const $eccfed1aa8771b08$export$7e97f0f47f75f097 = (createAnalyticsEvent, { source: source, target: target })=>$eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'rendered',
        actionSubject: 'forge.ui.renderer',
        source: source,
        attributes: {
            target: target
        }
    });
const $eccfed1aa8771b08$var$extensionLoadedEventFilterOld = (0, $1Mfb8.createSingleEventPerAppFilter)();
const $eccfed1aa8771b08$var$trackExtensionLoaded = (createAnalyticsEvent, { source: source, forgeEnvironment: forgeEnvironment, renderType: renderType, extensionType: extensionType, isConfiguring: isConfiguring, isInserting: isInserting })=>{
    const options = (0, $dh538.fg)('forge-ui-event-cost-optimisation') ? {
        filter: (0, $dh538.fg)('forge-ui-new-event-filter') ? (0, $7oKJR.extensionLoadedEventFilter) : $eccfed1aa8771b08$var$extensionLoadedEventFilterOld
    } : undefined;
    $eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'loaded',
        actionSubject: 'forge.ui.extension',
        source: source,
        attributes: {
            forgeEnvironment: forgeEnvironment,
            renderType: renderType,
            extensionType: extensionType,
            isConfiguring: isConfiguring,
            isInserting: isInserting
        }
    }, options);
};
const $eccfed1aa8771b08$var$trackExtensionRemounted = (createAnalyticsEvent, { source: source, mountCount: mountCount, isUseBridgeReinit: isUseBridgeReinit })=>$eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'remounted',
        actionSubject: 'forge.ui.extension',
        source: source,
        attributes: {
            mountCount: mountCount,
            isUseBridgeReinit: isUseBridgeReinit
        }
    });
const $eccfed1aa8771b08$var$trackExtensionResized = (createAnalyticsEvent, { source: source, resizeTotal: resizeTotal, appType: appType, extensionType: extensionType, navigationTimeStart: navigationTimeStart, resizedValues: resizedValues, forgeEnvironment: forgeEnvironment })=>$eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'resized',
        actionSubject: 'forge.ui.extension',
        source: source,
        attributes: {
            extensionType: extensionType,
            resizeTotal: resizeTotal,
            appType: appType,
            navigationTimeStart: navigationTimeStart,
            resizedValues: resizedValues,
            forgeEnvironment: forgeEnvironment
        }
    });
const $eccfed1aa8771b08$var$trackExtensionClicked = (createAnalyticsEvent, { source: source, appType: appType, extensionType: extensionType, forgeEnvironment: forgeEnvironment, baseUrl: baseUrl, componentName: component })=>$eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'clicked',
        actionSubject: 'forge.ui.extension',
        source: source,
        attributes: {
            extensionType: extensionType,
            appType: appType,
            forgeEnvironment: forgeEnvironment,
            baseUrl: baseUrl,
            component: component
        }
    });
const $eccfed1aa8771b08$var$createForgeUiAnalyticsEventTrackers = ({ createAnalyticsEvent: createAnalyticsEvent, source: source })=>{
    return {
        trackComponentUsageRendered: ({ isLegacyUiKit: isLegacyUiKit, forgeEnvironment: forgeEnvironment, components: components, forgeReactMajorVersion: forgeReactMajorVersion })=>$eccfed1aa8771b08$export$d84d2f0ce1c82c0(createAnalyticsEvent, {
                source: source,
                isLegacyUiKit: isLegacyUiKit,
                forgeEnvironment: forgeEnvironment,
                components: components,
                forgeReactMajorVersion: forgeReactMajorVersion
            }),
        trackRendererRendered: ({ target: target })=>$eccfed1aa8771b08$export$7e97f0f47f75f097(createAnalyticsEvent, {
                source: source,
                target: target
            }),
        trackExtensionLoaded: ({ forgeEnvironment: forgeEnvironment, renderType: renderType, extensionType: extensionType, isConfiguring: isConfiguring, isInserting: isInserting })=>$eccfed1aa8771b08$var$trackExtensionLoaded(createAnalyticsEvent, {
                source: source,
                forgeEnvironment: forgeEnvironment,
                renderType: renderType,
                extensionType: extensionType,
                isConfiguring: isConfiguring,
                isInserting: isInserting
            }),
        trackExtensionRemounted: ({ mountCount: mountCount })=>$eccfed1aa8771b08$var$trackExtensionRemounted(createAnalyticsEvent, {
                source: source,
                mountCount: mountCount
            }),
        trackBridgeSucceed: ({ method: method, forgeEnvironment: forgeEnvironment })=>$eccfed1aa8771b08$export$f4ca3aaa7a36404(createAnalyticsEvent, {
                source: source,
                method: method,
                forgeEnvironment: forgeEnvironment
            }),
        trackBridgeFailed: ({ method: method, errorName: errorName, forgeEnvironment: forgeEnvironment })=>$eccfed1aa8771b08$export$5c425ded9b0e7602(createAnalyticsEvent, {
                source: source,
                errorName: errorName,
                method: method,
                forgeEnvironment: forgeEnvironment
            }),
        trackExtensionResized: ({ navigationTimeStart: navigationTimeStart, resizedValues: resizedValues, resizeTotal: resizeTotal, appType: appType, extensionType: extensionType, forgeEnvironment: forgeEnvironment })=>$eccfed1aa8771b08$var$trackExtensionResized(createAnalyticsEvent, {
                source: source,
                navigationTimeStart: navigationTimeStart,
                resizeTotal: resizeTotal,
                resizedValues: resizedValues,
                appType: appType,
                extensionType: extensionType,
                forgeEnvironment: forgeEnvironment
            }),
        trackExtensionClicked: ({ extensionType: extensionType, appType: appType, forgeEnvironment: forgeEnvironment, baseUrl: baseUrl, componentName: componentName })=>$eccfed1aa8771b08$var$trackExtensionClicked(createAnalyticsEvent, {
                source: source,
                extensionType: extensionType,
                appType: appType,
                forgeEnvironment: forgeEnvironment,
                baseUrl: baseUrl,
                componentName: componentName
            }),
        trackForgeFeatureFlagEvent: ({ appType: appType, baseUrl: baseUrl, appId: appId, flagName: flagName, eventType: eventType, success: success, featureFlagEnv: featureFlagEnv, forgeEnvironment: forgeEnvironment })=>$eccfed1aa8771b08$var$trackForgeFeatureFlagEvent(createAnalyticsEvent, {
                source: source,
                appType: appType,
                baseUrl: baseUrl,
                appId: appId,
                flagName: flagName,
                eventType: eventType,
                success: success,
                featureFlagEnv: featureFlagEnv,
                forgeEnvironment: forgeEnvironment
            }),
        trackObjectStoreAction: ({ appType: appType, appId: appId, action: action, forgeEnvironment: forgeEnvironment })=>$eccfed1aa8771b08$var$trackObjectStoreAction(createAnalyticsEvent, {
                source: source,
                appType: appType,
                appId: appId,
                action: action,
                forgeEnvironment: forgeEnvironment
            })
    };
};
const $eccfed1aa8771b08$export$4b165c4db6e19dc5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { page: source } = (0, $5U2YR.useMetricsContext)();
    const cachedTrackers = (0, $hQK66.useMemoOne)(()=>$eccfed1aa8771b08$var$createForgeUiAnalyticsEventTrackers({
            createAnalyticsEvent: createAnalyticsEvent,
            source: source
        }), [
        createAnalyticsEvent,
        source
    ]);
    return cachedTrackers;
};
module.exports["fireEvent"] = $eccfed1aa8771b08$export$43835e9acf248a15;
module.exports["trackBridgeSucceed"] = $eccfed1aa8771b08$export$f4ca3aaa7a36404;
module.exports["trackBridgeFailed"] = $eccfed1aa8771b08$export$5c425ded9b0e7602;
module.exports["trackComponentUsageRendered"] = $eccfed1aa8771b08$export$d84d2f0ce1c82c0;
module.exports["trackRendererRendered"] = $eccfed1aa8771b08$export$7e97f0f47f75f097;
module.exports["useForgeUiAnalyticsEvent"] = $eccfed1aa8771b08$export$4b165c4db6e19dc5;

});

parcelRegister("1nSBE", function(module, exports) {
$parcel$export(module.exports, "default", () => $da27ee5222cf5f14$export$2e2bcd8739ae039);
// Displays a warning message only once per message to avoid spamming the console with the same message multiple times.
const $da27ee5222cf5f14$var$messages = new Set();
function $da27ee5222cf5f14$export$2e2bcd8739ae039(message) {
    if ($da27ee5222cf5f14$var$messages.has(message)) return;
    $da27ee5222cf5f14$var$messages.add(message);
    if (typeof window !== 'undefined') // eslint-disable-next-line no-console
    console.warn(message);
}

});

parcelRegister("ahOA5", function(module, exports) {
/* ForgeExtensionPointModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $jdPfT = parcelRequire("jdPfT");


var $gj7hi = parcelRequire("gj7hi");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $hnPaP = parcelRequire("hnPaP");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");


var $amyZ5 = parcelRequire("amyZ5");


var $gIr1J = parcelRequire("gIr1J");


var $dh538 = parcelRequire("dh538");


var $1c598 = parcelRequire("1c598");

const $10efe874cdee2bbf$var$styles = {
    modalWrapper: "_n3td1ejb"
};
const $10efe874cdee2bbf$var$getExtensionIcon = (extension)=>{
    return extension?.properties?.config?.icon ?? extension?.properties?.icon;
};
const $10efe874cdee2bbf$var$ModalWrapper = (props)=>{
    const { closeModalExtension: closeModalExtension, extensionType: extensionType, width: width, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress } = props;
    const isFullscreenAllowed = extensionType === (0, $1c598.ConfluenceExtension).MACRO && (0, $dh538.fg)('forge_enable_fullscreen_viewport_for_custom_config') || extensionType === (0, $1c598.ConfluenceExtension).BYLINE && (0, $dh538.fg)('platform_add_modal_support_to_bylineitem_extension');
    if (width === 'fullscreen' && isFullscreenAllowed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnPaP.FullScreenModalDialog), {
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        onClose: closeModalExtension
    }, props.children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        onClose: closeModalExtension,
        width: width
    }, props.children);
};
const $10efe874cdee2bbf$export$bf4fcca1fb0dca1e = ({ children: children, modalExtension: modalExtension, shouldShowFCFModalDeprecationMessage: shouldShowFCFModalDeprecationMessage, client: client, extension: extension })=>{
    const { closeModalExtension: closeModalExtension, title: title, modalWidth: modalWidth, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress } = modalExtension;
    const ADSModalWidth = modalWidth ? (0, $gIr1J.getADSModalWidth)(modalWidth) : undefined;
    const isMacroExtension = extension?.type === (0, $1c598.ConfluenceExtension).MACRO;
    const extensionIcon = isMacroExtension ? $10efe874cdee2bbf$var$getExtensionIcon(extension) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10efe874cdee2bbf$var$ModalWrapper, {
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        closeModalExtension: closeModalExtension,
        extensionType: extension?.type,
        width: ADSModalWidth,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, isMacroExtension && modalWidth === 'fullscreen' && (0, $dh538.fg)('forge_enable_fullscreen_viewport_for_custom_config') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, extensionIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: extensionIcon,
        alt: "Macro custom config icon",
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: "",
        color: "var(--ds-icon-accent-gray, #7D818A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: "Close Modal",
        onClick: closeModalExtension
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, shouldShowFCFModalDeprecationMessage && extension && client ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $amyZ5.ForgeModalDeprecationMessage), {
        client: client,
        extension: extension
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $10efe874cdee2bbf$var$styles.modalWrapper
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $10efe874cdee2bbf$var$styles.modalWrapper
    }, children)));
};
module.exports["ForgeExtensionPointModal"] = $10efe874cdee2bbf$export$bf4fcca1fb0dca1e;

});

parcelRegister("jed12", function(module, exports) {
$parcel$export(module.exports, "default", () => $9248c53ed364f1d5$export$2e2bcd8739ae039);
/* eslint-disable import/dynamic-import-chunkname */ 
var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $dh538 = parcelRequire("dh538");


var $hWJfj = parcelRequire("hWJfj");

var $1qp4n = parcelRequire("1qp4n");

var $3EkSF = parcelRequire("3EkSF");


var $JmaBh = parcelRequire("JmaBh");


var $jIiuI = parcelRequire("jIiuI");

var $gGmck = parcelRequire("gGmck");

var $i2hng = parcelRequire("i2hng");


var $CMcde = parcelRequire("CMcde");


var $gzd7F = parcelRequire("gzd7F");


var $2Jivw = parcelRequire("2Jivw");


var $69400 = parcelRequire("69400");


var $ijfiP = parcelRequire("ijfiP");


var $5oEbs = parcelRequire("5oEbs");


var $eahkE = parcelRequire("eahkE");


var $hoVr8 = parcelRequire("hoVr8");


var $ahOA5 = parcelRequire("ahOA5");

const $9248c53ed364f1d5$var$getLoadingComponent = (loadingComponent)=>{
    if (loadingComponent) // Wrapping loadingComponent in a valid react element (fragment)
    // ReactNode type is not necessarily a valid React element, unable to change this type as different extension points pass in various loadingComponent types
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, loadingComponent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $CMcde.Loader), null);
};
const $9248c53ed364f1d5$var$getAppDomainName = (extension, environment)=>{
    const parsedExtension = extension && extension?.id ? (0, $ijfiP.parseExtensionId)(extension.id) : undefined;
    if (parsedExtension) {
        const iframeSrc = (0, $5oEbs.createSrcFromExtension)(parsedExtension.appId, extension, environment, '');
        const iframeUrl = new URL(iframeSrc);
        return iframeUrl.host;
    }
    return;
};

const $9248c53ed364f1d5$var$RendererNextLatest = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>/* webpackChunkName: "forge-ui-renderer-with-components" */ Promise.resolve((parcelRequire("2Jivw"))).then((module)=>({
            default: module.RendererNextLatest
        })));
const $9248c53ed364f1d5$var$shouldRenderDeprecationErrorMessage = (appId, isNative, forgeReactMajorVersion, error)=>{
    if (error === (0, $eahkE.SANDBOX_DEPRECATION_ERROR)) return true;
    // Currently supported - UI Kit 2 and @forge/react >=10
    if (isNative && forgeReactMajorVersion) return false;
    // Deprecated - UI Kit 2 @forge/react < 10.
    if (isNative && !forgeReactMajorVersion) return true;
    // Deprecated - UI Kit 1
    if (!(0, $dh538.fg)('platform_disable_ui_kit_1')) return false;
    // Non excluded UI Kit 1 apps
    return true;
};
// This extra component exists so errors from the "render" function are caught in the an error boundary
// Also the error boundary requires a suspense fallback
const $9248c53ed364f1d5$var$RendererNextWithProviders = (props)=>{
    const { extension: extension, forgeDoc: forgeDoc, dispatch: dispatch, locale: locale, client: client, error: error } = props;
    const defaultDispatch = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(async ()=>{}, []);
    const forgeReactMajorVersion = forgeDoc?.forgeReactMajorVersion;
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const domainName = $9248c53ed364f1d5$var$getAppDomainName(extension, environment);
    // true while fetching initial forgeDoc
    if (props.loading && props.isNative && !forgeDoc) return $9248c53ed364f1d5$var$getLoadingComponent(props.loadingComponent);
    if ($9248c53ed364f1d5$var$shouldRenderDeprecationErrorMessage(extension.appId, props.isNative, forgeReactMajorVersion, error)) return props.modalExtension ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahOA5.ForgeExtensionPointModal), {
        modalExtension: props.modalExtension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eahkE.ForgeDeprecationMessage), {
        client: client,
        extension: extension,
        error: error
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eahkE.ForgeDeprecationMessage), {
        client: client,
        extension: extension,
        error: error
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: $9248c53ed364f1d5$var$getLoadingComponent(props.loadingComponent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qp4n.default), {
        dispatch: dispatch,
        extension: extension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hWJfj.default), {
        dispatch: dispatch,
        extension: extension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gzd7F.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3EkSF.default), {
        onError: props.onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i2hng.WidthProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2E5.default), {
        locale: locale ?? 'en',
        defaultLocale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $JmaBh.PortalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gGmck.RendererContext).Provider, {
        value: {
            egress: extension?.egress,
            properties: extension?.properties,
            forgeEnvironment: extension?.environmentType,
            forgeReactMajorVersion: forgeReactMajorVersion,
            appDomainName: domainName,
            extensionType: extension?.type
        }
    }, props.isNative && forgeReactMajorVersion && forgeReactMajorVersion >= 10 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $69400.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9248c53ed364f1d5$var$RenderTrackingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9248c53ed364f1d5$var$RendererNextLatest, {
        ...props,
        dispatch: dispatch ?? defaultDispatch
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Jivw.RendererNextLegacy), {
        ...props,
        dispatch: dispatch ?? defaultDispatch
    }))))))))));
};
const $9248c53ed364f1d5$var$RenderTrackingWrapper = ({ children: children })=>{
    if ((0, $dh538.fg)('forge-ui-track-ui-kit-renderer-rendered-event')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9248c53ed364f1d5$var$RenderTrackingWrapperActual, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $9248c53ed364f1d5$var$RenderTrackingWrapperActual = ({ children: children })=>{
    (0, $hoVr8.useSendRendererRenderedAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
var $9248c53ed364f1d5$export$2e2bcd8739ae039 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9248c53ed364f1d5$var$RendererNextWithProviders, props);
};

});

parcelRegister("durRy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6vnrx = parcelRequire("6vnrx");


var $cWPLt = parcelRequire("cWPLt");


var $iamDk = parcelRequire("iamDk");


// Format the values(UserData) returned from useUsers hook, to pass to defaultValue prop
const $482c9d0ed1050096$var$hydrateDefaultValue = (users, isMulti = false)=>{
    const defaultValues = [];
    for(const userId in users){
        const { name: name, picture: picture } = users[userId];
        // Only grabbing the values where user name exist
        if (name) defaultValues.push({
            name: name,
            avatarUrl: picture,
            id: userId,
            type: 'user'
        });
    }
    return isMulti ? defaultValues : defaultValues[0];
};
const $482c9d0ed1050096$var$UserPickerFn = ({ client: client, mentionProvider: mentionProvider, accountId: accountId, cloudId: cloudId, productAttributes: productAttributes, productKey: productKey, baseUrl: baseUrl, props: props })=>{
    const { name: name, label: label, placeholder: placeholder, description: description, // Warning: Smart user picker ONLY supports default value hydration
    // of *users*, not groups!
    defaultValue: defaultUserValue = '', isRequired: isRequired, isMulti: isMulti, includeUsers: includeUsers, includeGroups: includeGroups, onChange: onChange } = props;
    const query = (0, $cWPLt.useMentionResource)(mentionProvider);
    const accountIds = Array.isArray(defaultUserValue) ? defaultUserValue : [
        defaultUserValue
    ];
    const usersData = (0, $6vnrx.useUsers)(accountIds, client);
    // Hydrate the default value ourselves, since we are controlling value from <Field>
    // component value. It will get passed into the user picker as simply `value`.
    const hydratedDefaultValue = $482c9d0ed1050096$var$hydrateDefaultValue(usersData, isMulti);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iamDk.UserPicker), {
        accountId: accountId,
        cloudId: cloudId,
        productAttributes: productAttributes,
        productKey: productKey,
        mentionProvider: mentionProvider,
        name: name,
        label: label,
        placeholder: placeholder,
        description: description,
        defaultValue: hydratedDefaultValue,
        isRequired: isRequired,
        isMulti: isMulti,
        includeUsers: includeUsers,
        includeGroups: includeGroups,
        baseUrl: baseUrl,
        onChange: onChange,
        query: query
    });
};
const $482c9d0ed1050096$export$89c0f5a165dc562a = ({ query: query, accountId: accountId, cloudId: cloudId, productKey: productKey, baseUrl: baseUrl })=>{
    return function UserPickerNext({ forgeDoc: { props: props } }) {
        const { name: name, label: label, placeholder: placeholder, description: description, isRequired: isRequired, isMulti: isMulti, includeUsers: includeUsers, includeGroups: includeGroups, onChange: onChange, defaultValue: defaultUserId } = props;
        const [defaultValueLoaded, setDefaultValueLoaded] = (0, $42omo.useState)(!defaultUserId);
        const [defaultValue, setDefaultValue] = (0, $42omo.useState)();
        (0, $42omo.useEffect)(()=>{
            if (defaultUserId && !defaultValueLoaded) query().then((users)=>{
                const targetUsers = users.filter(({ id: id })=>Array.isArray(defaultUserId) ? defaultUserId.includes(id) : defaultUserId === id);
                if (targetUsers.length === 0) setDefaultValue(undefined);
                else if (isMulti) setDefaultValue(targetUsers);
                else setDefaultValue(targetUsers[0]);
                setDefaultValueLoaded(true);
            });
        }, [
            isMulti,
            defaultUserId,
            defaultValueLoaded,
            setDefaultValue,
            setDefaultValueLoaded
        ]);
        if (!defaultValueLoaded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iamDk.UserPicker), {
            accountId: accountId,
            cloudId: cloudId,
            productKey: productKey,
            baseUrl: baseUrl,
            name: name,
            label: label,
            placeholder: placeholder,
            description: description,
            isRequired: isRequired,
            isMulti: isMulti,
            includeUsers: includeUsers,
            includeGroups: includeGroups,
            onChange: onChange,
            query: query,
            defaultValue: defaultValue
        });
    };
};
const $482c9d0ed1050096$export$57fb7dc1c2438e62 = ({ client: client, mentionProvider: mentionProvider, accountId: accountId, cloudId: cloudId, productKey: productKey, baseUrl: baseUrl, productAttributes: productAttributes })=>{
    return function UserPickerNext({ forgeDoc: { props: props } }) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($482c9d0ed1050096$var$UserPickerFn, {
            props: props,
            client: client,
            mentionProvider: mentionProvider,
            accountId: accountId,
            cloudId: cloudId,
            productAttributes: productAttributes,
            productKey: productKey,
            baseUrl: baseUrl
        });
    };
};
module.exports["makeMockUserPicker"] = $482c9d0ed1050096$export$89c0f5a165dc562a;
module.exports["makeNativeUserPicker"] = $482c9d0ed1050096$export$57fb7dc1c2438e62;

});

parcelRegister("hEvav", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $6vnrx = parcelRequire("6vnrx");


var $9UyM5 = parcelRequire("9UyM5");


var $kpdGL = parcelRequire("kpdGL");

var $esRft = parcelRequire("esRft");


var $c4sKh = parcelRequire("c4sKh");

const $556ea5977eff619b$var$containerStyle = null;
const $556ea5977eff619b$var$messages = (0, $cgtv4.defineMessages)({
    unknownUser: {
        id: "confluence.user.unknown.user.message",
        defaultMessage: "Unknown User"
    }
});
const $556ea5977eff619b$var$Avatar = ({ name: name, picture: picture, hideDisplayName: hideDisplayName })=>{
    if (hideDisplayName) return /*#__PURE__*/ $42omo.createElement((0, $esRft.default), {
        name: name,
        src: picture
    });
    return /*#__PURE__*/ $42omo.createElement("div" // Reduce Atlaskit padding to vertically-align with other components
    , {
        className: (0, $gMc0m.default)([
            "_1gzjidpf _1plv1j28 _1r3373ad"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $kpdGL.default), {
        avatar: /*#__PURE__*/ $42omo.createElement((0, $esRft.default), {
            name: name,
            src: picture
        }),
        primaryText: name
    }));
};
function $556ea5977eff619b$var$UserInline({ name: name }) {
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ $42omo.createElement((0, $c4sKh.default), {
        appearance: "primary"
    }, name || intl.formatMessage($556ea5977eff619b$var$messages.unknownUser));
}
const $556ea5977eff619b$var$User = ({ accountId: accountId, client: client, hideDisplayName: hideDisplayName })=>{
    const { picture: picture, name: name } = (0, $6vnrx.useUser)(accountId, client);
    const { inline: inline } = (0, $9UyM5.useInlineContext)();
    if (!picture && !name) return null;
    if (inline) return /*#__PURE__*/ $42omo.createElement($556ea5977eff619b$var$UserInline, {
        name: name
    });
    return /*#__PURE__*/ $42omo.createElement($556ea5977eff619b$var$Avatar, {
        name: name,
        picture: picture,
        hideDisplayName: hideDisplayName
    });
};
const $556ea5977eff619b$export$4e4c41e4152a9f8a = ({ client: client })=>{
    return function UserFnNext({ forgeDoc: { props: props } }) {
        const { accountId: accountId, hideDisplayName: hideDisplayName } = props;
        return /*#__PURE__*/ $42omo.createElement($556ea5977eff619b$var$User, {
            accountId: accountId,
            client: client,
            hideDisplayName: hideDisplayName
        });
    };
};
module.exports["makeUser"] = $556ea5977eff619b$export$4e4c41e4152a9f8a;

});

parcelRegister("dx0OV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $67O0h = parcelRequire("67O0h");


var $6jPem = parcelRequire("6jPem");


var $lspPP = parcelRequire("lspPP");


var $jRNsq = parcelRequire("jRNsq");


var $dh538 = parcelRequire("dh538");


var $er4dw = parcelRequire("er4dw");


var $gGmck = parcelRequire("gGmck");


var $lMJg3 = parcelRequire("lMJg3");


var $kS0x0 = parcelRequire("kS0x0");


var $kZjf5 = parcelRequire("kZjf5");


var $clpPd = parcelRequire("clpPd");


var $fgm2d = parcelRequire("fgm2d");

const $d2c1e8bb42c60a10$var$filterInvalidMediaUrls = (appDomainName, egressServices, document)=>{
    const invalidUrls = new Set();
    const visitors = {
        media: (node)=>{
            const url = node?.attrs?.url;
            if (url && !egressServices.some((service)=>(0, $kS0x0.isValidImageUrl)(url, service, appDomainName))) {
                invalidUrls.add(url);
                return {
                    ...node,
                    attrs: {
                        ...node.attrs,
                        // Remove the URL so it fails to load
                        // We use a space because an empty string causes an infinite loading spinner
                        url: ' '
                    }
                };
            }
        }
    };
    const filteredDocument = (0, $6jPem.traverse)(document, visitors);
    return {
        filteredDocument: filteredDocument ? filteredDocument : document,
        invalidUrls: Array.from(invalidUrls)
    };
};
const $d2c1e8bb42c60a10$var$useSupportsMedia = ()=>{
    try {
        (0, $jRNsq.useMediaClient)();
        return true;
    // eslint-disable-next-line no-unused-vars
    } catch (e) {
        // Throws if no MediaClientProvider is found
        return false;
    }
};
const $d2c1e8bb42c60a10$export$a504d7ec22d4b3f4 = ({ client: client, bridge: bridge })=>{
    return function ADFRendererNext(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d2c1e8bb42c60a10$export$c334f442ba514f7d, {
            bridge: bridge,
            client: client,
            ...props
        });
    };
};
const $d2c1e8bb42c60a10$export$c334f442ba514f7d = (props)=>{
    const supportsMedia = $d2c1e8bb42c60a10$var$useSupportsMedia();
    const { egress: egress, properties: properties, appDomainName: appDomainName, forgeEnvironment: forgeEnvironment } = (0, $42omo.useContext)((0, $gGmck.RendererContext));
    const imagesEgressService = (0, $lMJg3.useEgressPermissionService)('IMAGES', egress);
    const mediaEgressService = (0, $lMJg3.useEgressPermissionService)('MEDIA', egress);
    const egressServices = [
        imagesEgressService,
        mediaEgressService
    ];
    const client = props.client;
    const bridge = props.bridge;
    const { onNavigate: onNavigate, getModalJsx: getModalJsx } = (0, $kZjf5.useNavigation)({
        extension: {
            egress: egress,
            properties: properties
        }
    });
    const { document: document, documentWithoutMedia: documentWithoutMedia, ...adfRendererProps } = props.forgeDoc.props;
    // The client provides both the document with media and without media, as it doesn't know whether the MediaClientProvider is present
    // Then, in the parent product, we can decide whether to render the document with media or without media
    const doc = !supportsMedia && documentWithoutMedia ? documentWithoutMedia : document;
    if (!doc && (0, $dh538.fg)('platform-ui-kit-adf-renderer-require-document')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
    const { filteredDocument: filteredDocument, invalidUrls: invalidUrls } = $d2c1e8bb42c60a10$var$filterInvalidMediaUrls(appDomainName, egressServices, doc);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, forgeEnvironment === 'DEVELOPMENT' && invalidUrls.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $er4dw.EgressErrorMessage), {
            key: url,
            url: url
        })), getModalJsx(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67O0h.default), {
        ...adfRendererProps,
        eventHandlers: {
            link: {
                onClick: (e)=>{
                    e.preventDefault();
                    adfRendererProps?.eventHandlers?.link?.onClick?.(e, e.currentTarget.href);
                    onNavigate({
                        type: 'same-tab',
                        url: (0, $clpPd.sanitizeUrl)(e.currentTarget.href)
                    });
                }
            }
        },
        document: filteredDocument,
        extensionHandlers: client && (0, $dh538.fg)('platform_add_embedded_macro_support_to_ui_kit') ? {
            'com.atlassian.ecosystem': (props)=>{
                const { localId: localId, parameters: parameters } = props;
                const { extension: extension, extensionData: extensionData, accountId: accountId, cloudId: cloudId, contextIds: contextIds } = parameters.extensionProperties;
                // Extract config from extension parameters (can be in guestParams or config)
                const config = parameters.guestParams || parameters.config;
                // ForgeUIRenderer will fetch fresh extension data from XLS when isEmbeddedMacro is true
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fgm2d.ForgeUIRenderer), {
                    accountId: accountId,
                    cloudId: cloudId,
                    client: client,
                    contextIds: contextIds,
                    extension: extension,
                    extensionData: extensionData,
                    // Pass config via extensionPayload so it's available in context.extension.config
                    extensionPayload: config ? {
                        config: config
                    } : undefined,
                    localId: localId,
                    product: 'confluence',
                    bridge: bridge,
                    // Only required for bodied macros. Since we are currently not supporting embedded bodied macros, this should be empty.
                    extensionViewData: {},
                    isEmbeddedMacro: true
                });
            }
        } : undefined
    })));
};
module.exports["makeADFRenderer"] = $d2c1e8bb42c60a10$export$a504d7ec22d4b3f4;
module.exports["AdfRenderer"] = $d2c1e8bb42c60a10$export$c334f442ba514f7d;

});

parcelRegister("iUjrf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eI4ye = parcelRequire("eI4ye");


var $1FKSs = parcelRequire("1FKSs");


var $dh538 = parcelRequire("dh538");

const $031ec269e4b6a566$export$a8c9835719b09864 = ()=>{
    const timelineRef = (0, $42omo.useContext)((0, $eI4ye.PerformanceAnalyticsContext));
    // Use for out-of-frame capture in platform code.
    const captureEvent = (0, $42omo.useCallback)((event)=>{
        if (!(0, $dh538.fg)('forge-ui-performance-analytics-provider')) return;
        timelineRef.current.events.push(event);
        timelineRef.current.listeners.forEach((listener)=>listener(event));
    }, [
        timelineRef
    ]);
    // Use for capturing events from untrusted sources (e.g. in-frame via bridge).
    const captureUntrustedEvent = (0, $42omo.useCallback)((event)=>{
        if (!(0, $dh538.fg)('forge-ui-performance-analytics-provider')) return;
        const result = (0, $1FKSs.FrameProfilingEventCaptureTransformer).safeParse(event);
        if (!result.success) // TODO: log failed validations to detect contract mismatches/tampering.
        return;
        captureEvent(result.data);
    }, [
        captureEvent
    ]);
    return {
        captureEvent: captureEvent,
        captureUntrustedEvent: captureUntrustedEvent
    };
};
module.exports["usePerformanceAnalytics"] = $031ec269e4b6a566$export$a8c9835719b09864;

});

parcelRegister("1uzCd", function(module, exports) {
const $3034561136ba9291$export$a728e3e4d9df1392 = ()=>Math.trunc(performance.now());
module.exports["getPerformanceMark"] = $3034561136ba9291$export$a728e3e4d9df1392;

});

parcelRegister("kZjf5", function(module, exports) {
/* useNavigation.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $inPa6 = parcelRequire("inPa6");


var $7TH2w = parcelRequire("7TH2w");


var $eEA8O = parcelRequire("eEA8O");


var $5dK2X = parcelRequire("5dK2X");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $3Spjc = parcelRequire("3Spjc");


var $kxKUs = parcelRequire("kxKUs");


var $i5CVI = parcelRequire("i5CVI");


var $2kGKp = parcelRequire("2kGKp");


var $lMJg3 = parcelRequire("lMJg3");


var $kTcrU = parcelRequire("kTcrU");


var $9v4R2 = parcelRequire("9v4R2");

const $c92260a0208e3eb8$var$cssActionItem = null;
function $c92260a0208e3eb8$export$d0fd4b7106de2769({ extension: extension, push: push }) {
    const [modalState, setModalState] = (0, $42omo.useState)({
        state: 'closed'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const egressService = (0, $lMJg3.useEgressPermissionService)('FETCH_CLIENT_SIDE', extension.egress);
    return {
        onNavigate: async ({ type: type, url: urlString })=>{
            const url = (0, $kTcrU.makeUrl)(urlString);
            const linkType = $c92260a0208e3eb8$export$8071740a02e53ce2(url, egressService);
            if (linkType === 'invalid' || !url) throw new (0, $kxKUs.BridgeClientError)(`link is invalid: ${urlString}`);
            if (linkType === 'trusted') {
                (0, $i5CVI.navigate)(url.href, type, push);
                return;
            }
            const analyticsAttributes = $c92260a0208e3eb8$export$e748b6351ba5f204(url);
            return new Promise((resolve, reject)=>{
                // TODO: remove this event once we have switched over to the new event schema
                // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                createAnalyticsEvent({
                    eventType: (0, $7TH2w.UI_EVENT_TYPE),
                    data: {
                        action: 'viewed',
                        actionSubject: 'externalLinkModal',
                        attributes: analyticsAttributes
                    }
                }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                setModalState({
                    state: 'open',
                    url: url,
                    onConfirm: ()=>{
                        (0, $i5CVI.navigate)(url.href, type, push); // TODO: remove this event once we have switched over to the new event schema
                        // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                        createAnalyticsEvent({
                            eventType: (0, $7TH2w.UI_EVENT_TYPE),
                            data: {
                                action: 'approved',
                                actionSubject: 'externalLinkModal',
                                attributes: analyticsAttributes
                            }
                        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                        resolve();
                    },
                    onCancel: ()=>{
                        // TODO: remove this event once we have switched over to the new event schema
                        // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                        createAnalyticsEvent({
                            eventType: (0, $7TH2w.UI_EVENT_TYPE),
                            data: {
                                action: 'cancelled',
                                actionSubject: 'externalLinkModal',
                                attributes: analyticsAttributes
                            }
                        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                        reject(new (0, $kxKUs.BridgeClientError)('cancelled'));
                    }
                });
            });
        },
        getModalJsx: ()=>{
            if (modalState.state === 'closed') return /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null);
            const ModalFooter = ()=>{
                return /*#__PURE__*/ $42omo.createElement((0, $8o1lj.default), null, /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- to avoid import of css module from @compiled/react
                , {
                    className: (0, $gMc0m.default)([
                        "_1e0c1txw _1bah1yb4 _1bsb1osq"
                    ])
                }, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
                    href: "https://go.atlassian.com/forge-help-app-security",
                    appearance: "subtle-link",
                    target: "_blank",
                    rel: "noopener noreferrer" // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
                    ,
                    className: (0, $gMc0m.default)([
                        "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf"
                    ])
                }, "Learn more about app security"), /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                , {
                    className: (0, $gMc0m.default)([
                        "_1e0c116y _19pkidpf _2hwxr5cr _otyridpf _18u0r5cr"
                    ])
                }, /*#__PURE__*/ $42omo.createElement("div", {
                    className: (0, $gMc0m.default)([
                        "_16jlkb7n _1o9zidpf _i0dl1wug _19pkidpf _2hwx1b66 _otyridpf _18u01b66"
                    ])
                }, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
                    appearance: "subtle",
                    onClick: ()=>{
                        setModalState({
                            state: 'closed'
                        });
                        modalState.onCancel();
                    }
                }, "Cancel")), /*#__PURE__*/ $42omo.createElement("div", {
                    className: (0, $gMc0m.default)([
                        "_16jlkb7n _1o9zidpf _i0dl1wug _19pkidpf _2hwx1b66 _otyridpf _18u01b66"
                    ])
                }, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
                    appearance: "warning",
                    onClick: ()=>{
                        modalState.onConfirm();
                        setModalState({
                            state: 'closed'
                        });
                    }
                }, "Continue")))));
            };
            return /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null, /*#__PURE__*/ $42omo.createElement((0, $8CZUH.default), {
                onClose: ()=>{
                    setModalState({
                        state: 'closed'
                    });
                    modalState.onCancel();
                }
            }, /*#__PURE__*/ $42omo.createElement((0, $9ot3w.default), null, /*#__PURE__*/ $42omo.createElement((0, $d8eRd.default), {
                appearance: "warning"
            }, `Opening external page on ${modalState.url.hostname}`)), /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, extension.properties?.title ? /*#__PURE__*/ $42omo.createElement((0, $5dK2X.default), {
                as: "p"
            }, /*#__PURE__*/ $42omo.createElement((0, $5dK2X.default), {
                as: "strong"
            }, extension.properties.title), " is sending you to an external page. Ensure you trust that page before you continue.") : /*#__PURE__*/ $42omo.createElement((0, $5dK2X.default), {
                as: "p"
            }, /*#__PURE__*/ $42omo.createElement((0, $5dK2X.default), {
                as: "strong"
            }, "This app"), " is sending you to an external page. Ensure you trust that page before you continue."), /*#__PURE__*/ $42omo.createElement((0, $5dK2X.default), {
                as: "p",
                maxLines: 1
            }, modalState.url.href)), /*#__PURE__*/ $42omo.createElement(ModalFooter, null)));
        }
    };
}
const $c92260a0208e3eb8$var$getRootDomain = (url)=>{
    const hostnameParts = url.hostname.split('.'); // Root domain consists of the last two parts of the hostname
    if (hostnameParts.length > 1) return hostnameParts.slice(-2).join('.');
    else // If there's only one part, return it (e.g., 'localhost')
    return url.hostname;
}; // Exported for testing only
function $c92260a0208e3eb8$export$8071740a02e53ce2(url, egressService) {
    if (!url) return 'invalid';
    if (url.protocol === 'mailto:') return 'trusted';
    if (url.protocol === 'tel:') return 'trusted';
    try {
        // URL is listed under permissions in manifest
        if (egressService.isValidUrl(url.href)) return 'trusted';
         // URL is from same origin
        if (url.origin === (0, $2kGKp.getOrigin)()) return 'trusted';
         // URL is under a trusted atlassian domain
        const rootDomain = $c92260a0208e3eb8$var$getRootDomain(url);
        if ((0, $9v4R2.TRUSTED_ROOT_DOMAINS).includes(rootDomain)) return 'trusted';
        if ([
            'https:',
            'http:'
        ].includes(url.protocol)) return 'external';
    } catch  {}
    return 'invalid';
} // Exported for testing only
function $c92260a0208e3eb8$export$e748b6351ba5f204(url) {
    // Don't count the initial `?` in the query string length.
    const queryStringSize = url.search.length > 1 ? url.search.length - 1 : 0;
    return {
        url: url.href,
        queryStringSize: queryStringSize
    };
}
module.exports["useNavigation"] = $c92260a0208e3eb8$export$d0fd4b7106de2769;

});

parcelRegister("clpPd", function(module, exports) {
// taken from https://hello.atlassian.net/wiki/spaces/PRODSEC/pages/158006558/URI+scheme+Allow+listing
const $1501019f8cb42aef$export$4da13fcc37d580b4 = [
    'javascript:',
    'data:',
    'vbscript:',
    'view-source:',
    'resource:',
    'about:',
    'chrome:',
    'livescript:',
    'mocha:',
    'file:',
    'mhtml:',
    'smb:'
];
const $1501019f8cb42aef$export$300bd6d67c49dbfc = (urlString)=>{
    const url = new URL(urlString || '', window.location.href);
    return $1501019f8cb42aef$export$4da13fcc37d580b4.includes(url.protocol) ? 'about:blank' : url.toString();
};
module.exports["sanitizeUrl"] = $1501019f8cb42aef$export$300bd6d67c49dbfc;

});

parcelRegister("g7rOD", function(module, exports) {
/**
 * this function assume the inputs are not same object, and hence
 * it doesn't check for reference equality.
 *
 * Additionally, it check keys of the object and then check the values
 * for better performance.
 */ const $9678c1c47c1b0bc2$var$objectValuesAreEqual = (prev, next, valuesAreEqual)=>{
    const keys = Object.keys(prev);
    const length = keys.length;
    if (length !== Object.keys(next).length) return false;
    // there are two small optimization techniques used in this file:
    // 1. using decrementing for loop instead of incrementing for loop,
    //    to reduce 1 instruction per iteration.
    // 2. for object equality check, we check the key match first and then
    //    the value match. This is to identify the inequality as soon as possible.
    for(let i = length; i-- !== 0;){
        if (!(keys[i] in next)) return false;
    }
    for(let i = length; i-- !== 0;){
        const key = keys[i];
        if (!valuesAreEqual(prev[key], next[key])) return false;
    }
    return true;
};
/**
 * Some of the ideas are based on https://github.com/FormidableLabs/react-fast-compare
 */ const $9678c1c47c1b0bc2$var$forgeDocPropValuesAreEqual = (prev, next)=>{
    if (prev === next) return true;
    else if (!prev || !next) return false;
    else if (typeof prev === 'function' && typeof next === 'function') // if the function is a crossDomainFunctionWrapper (i.e. post-bot),
    // then we can check if the function is the same by looking at the
    // __id__ property.
    return prev.__id__ === next.__id__;
    else if (typeof prev === 'object' && typeof next === 'object') {
        if (prev.constructor !== next.constructor) return false;
        else if (Array.isArray(prev)) {
            const length = prev.length;
            if (length !== next.length) return false;
            for(let i = length; i-- !== 0;){
                if (!$9678c1c47c1b0bc2$var$forgeDocPropValuesAreEqual(prev[i], next[i])) return false;
            }
            return true;
        } else if (prev.valueOf !== Object.prototype.valueOf && typeof prev.valueOf === 'function' && typeof next.valueOf === 'function') return prev.valueOf() === next.valueOf();
        else if (prev.toString !== Object.prototype.toString && typeof prev.toString === 'function' && typeof next.toString === 'function') return prev.toString() === next.toString();
        return $9678c1c47c1b0bc2$var$objectValuesAreEqual(prev, next, $9678c1c47c1b0bc2$var$forgeDocPropValuesAreEqual);
    }
    return false;
};
const $9678c1c47c1b0bc2$var$forgeDocPropsAreEqual = (prev, next)=>{
    if (prev === next) return true;
    else if (!prev || !next) return false;
    return $9678c1c47c1b0bc2$var$objectValuesAreEqual(prev, next, $9678c1c47c1b0bc2$var$forgeDocPropValuesAreEqual);
};
/**
 * the function is used to cache the hasChanged value in the ForgeDoc.
 * Please note, the cached result need to be stored in the next prop not the prev prop.
 * This is because react internally caches the props, and the cache become stale
 * at every render, if the calculation depends on the prev prop, the stale cache
 * will impact the accuracy of the result.
 */ const $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged = (nextDoc, hasChanged)=>{
    nextDoc.hasChanged = hasChanged;
    return !hasChanged;
};
const $9678c1c47c1b0bc2$var$forgeDocsAreEqual = (prev, next)=>{
    if (next.hasChanged !== undefined) return !next.hasChanged;
    else if (prev === next) return $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, false);
    else if (!prev || !next) return next ? $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, true) : false;
    if (prev.type !== next.type || prev.key !== next.key) return $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, true);
    else if (prev.children !== next.children) {
        if (prev.children?.length !== next.children?.length) return $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, true);
        const length = prev.children?.length ?? 0;
        for(let i = length; i-- !== 0;){
            if (!$9678c1c47c1b0bc2$var$forgeDocsAreEqual(prev.children[i], next.children[i])) return $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, true);
        }
    }
    return $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, !$9678c1c47c1b0bc2$var$forgeDocPropsAreEqual(prev.props, next.props));
};
const $9678c1c47c1b0bc2$export$5d1c9ea31ee6a28f = (prev, next)=>$9678c1c47c1b0bc2$var$forgeDocsAreEqual(prev.forgeDoc, next.forgeDoc);
module.exports["forgePropsAreEqual"] = $9678c1c47c1b0bc2$export$5d1c9ea31ee6a28f;

});

parcelRegister("4ZTaE", function(module, exports) {
/* threeLOPrompt.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $1GzhS = parcelRequire("1GzhS");


var $gdv5Z = parcelRequire("gdv5Z");


var $aoVih = parcelRequire("aoVih");


var $ccHMk = parcelRequire("ccHMk");


var $i35rc = parcelRequire("i35rc");

const $e24cf88a4f07ee68$var$styles = {
    box: "_1h6d1xiv _1dqonqa1 _189e1dm9"
};
const $e24cf88a4f07ee68$var$ThreeLOPrompt = (props)=>{
    const { loading: loading, startAuth: startAuth, promptMessage: promptMessage, buttonText: buttonText } = (0, $i35rc.useAuth)(props);
    const { authUrl: authUrl, onInitialization: onInitialization } = props;
    (0, $42omo.useEffect)(()=>{
        if (onInitialization) onInitialization();
    }, [
        onInitialization
    ]);
    if (!authUrl || authUrl === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $e24cf88a4f07ee68$var$messages.noAuthURLErrorMessage));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        onClick: (e)=>e.stopPropagation(),
        padding: "space.250",
        xcss: $e24cf88a4f07ee68$var$styles.box
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        alignInline: "start",
        space: "space.250",
        grow: "hug",
        testId: "three-lo-prompt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, promptMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: startAuth,
        isLoading: loading
    }, buttonText))));
};
var $e24cf88a4f07ee68$export$2e2bcd8739ae039 = $e24cf88a4f07ee68$var$ThreeLOPrompt;
const $e24cf88a4f07ee68$export$92dadb4ff2941f34 = ({ forgeDoc: forgeDoc, dispatch: dispatch })=>{
    const { message: message, authUrl: authUrl, promptText: promptText } = forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e24cf88a4f07ee68$var$ThreeLOPrompt, {
        message: message,
        authUrl: authUrl,
        promptText: promptText,
        onSuccess: ()=>dispatch({
                type: 'render',
                extensionData: {}
            })
    });
};
const $e24cf88a4f07ee68$export$388ff2bd3ce4e348 = ({ appName: appName, onSuccess: onSuccess })=>{
    return function threeLOPrompt({ forgeDoc: { props: props }, dispatch: dispatch }) {
        const { message: message, authUrl: authUrl, promptText: promptText } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e24cf88a4f07ee68$var$ThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            appName: appName,
            onSuccess: ()=>{
                if (onSuccess) onSuccess();
                return dispatch({
                    type: 'render',
                    extensionData: {}
                });
            }
        });
    };
};
const $e24cf88a4f07ee68$export$7519b5f6e74be543 = ({ appName: appName, onSuccess: onSuccess, message: message, onInitialization: onInitialization })=>{
    return function threeLOPrompt(props) {
        const { authUrl: authUrl, promptText: promptText, onSuccess: onSuccessFromIframeComponent } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e24cf88a4f07ee68$var$ThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            appName: appName,
            onSuccess: ()=>{
                if (onSuccess) onSuccess();
                return Promise.resolve(onSuccessFromIframeComponent);
            },
            onInitialization: onInitialization
        });
    };
};
const $e24cf88a4f07ee68$var$messages = (0, $cgtv4.defineMessages)({
    noAuthURLErrorMessage: {
        id: "confluence.threeLOPrompt.no.authURL.error-message",
        defaultMessage: "Consent URL not found. Please refresh the page and try again."
    }
});
module.exports["default"] = $e24cf88a4f07ee68$export$2e2bcd8739ae039;
module.exports["ThreeLOPromptRenderFn"] = $e24cf88a4f07ee68$export$92dadb4ff2941f34;
module.exports["makeThreeLOPromptForCustomUI"] = $e24cf88a4f07ee68$export$7519b5f6e74be543;

});

parcelRegister("hWJfj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1c598 = parcelRequire("1c598");


var $gvvHu = parcelRequire("gvvHu");


var $7KMPr = parcelRequire("7KMPr");


var $inPa6 = parcelRequire("inPa6");


var $7TH2w = parcelRequire("7TH2w");


var $3Spjc = parcelRequire("3Spjc");


var $5U2YR = parcelRequire("5U2YR");

class $2104b77b1f0c0326$export$925737f92c0570a1 extends Error {
    constructor(message, component){
        super(message);
        this.component = void 0;
        this.component = component;
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $2104b77b1f0c0326$export$925737f92c0570a1.prototype);
    }
}
class $2104b77b1f0c0326$var$ComponentErrorBoundaryWithCreateAnalyticsEvent extends (0, $42omo.Component) {
    componentDidCatch(error, errorInfo) {
        // Filters out reporting errors for components that are not valid e.g. <Buton/>
        if (!(error instanceof $2104b77b1f0c0326$export$925737f92c0570a1)) throw error;
        const { extension: extension } = this.props;
        const { page: page, environment: environment } = this.context;
        (0, $7KMPr.captureAndReportError)({
            error: error,
            errorInfo: errorInfo,
            page: page,
            environment: environment ?? (0, $1c598.ProductEnvironment).DEVELOPMENT,
            errorExtensionDetails: extension ? {
                type: extension.type,
                environmentType: extension.environmentType,
                appOwnerAccountId: extension.appOwner?.accountId,
                properties: extension.properties,
                id: extension?.id
            } : undefined
        });
        this.props.createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'failed',
                actionSubject: 'forge.ui.renderer',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'errorBoundary',
                    errorName: 'componentError',
                    component: error.component
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        this.setState({
            thrownError: {
                error: error,
                errorInfo: errorInfo
            }
        });
    }
    render() {
        const { thrownError: thrownError } = this.state;
        if (!thrownError) return this.props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvvHu.default), {
            error: thrownError.error,
            dispatch: this.props.dispatch
        });
    }
    constructor(...args){
        super(...args);
        this.context = void 0;
        this.state = {
            thrownError: undefined
        };
    }
}
$2104b77b1f0c0326$var$ComponentErrorBoundaryWithCreateAnalyticsEvent.contextType = (0, $5U2YR.MetricsContext);
const $2104b77b1f0c0326$var$ComponentErrorBoundary = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2104b77b1f0c0326$var$ComponentErrorBoundaryWithCreateAnalyticsEvent, {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent
    });
};
var $2104b77b1f0c0326$export$2e2bcd8739ae039 = $2104b77b1f0c0326$var$ComponentErrorBoundary;
module.exports["ComponentError"] = $2104b77b1f0c0326$export$925737f92c0570a1;
module.exports["default"] = $2104b77b1f0c0326$export$2e2bcd8739ae039;

});

parcelRegister("eTuC8", function(module, exports) {

var $1JdaQ = parcelRequire("1JdaQ");


var $c5hPD = parcelRequire("c5hPD");


var $la0HD = parcelRequire("la0HD");

const $3b182436257331a8$export$cdae2f05238f63a2 = (appearance, features)=>{
    const memoisedFeatures = (0, $la0HD.useMemoisedFeatures)(features);
    const preset = (0, $1JdaQ.usePreset)((builder)=>(0, $c5hPD.createPreset)(builder, appearance, memoisedFeatures), [
        memoisedFeatures
    ]);
    return preset;
};
module.exports["usePresetByFeatures"] = $3b182436257331a8$export$cdae2f05238f63a2;

});

parcelRegister("lMJg3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $471wb = parcelRequire("471wb");

const $462f7dce88626787$export$440f6339165c68d2 = (permissionType, egress)=>{
    const egressUrls = (egress || []).find((permission)=>permission.type === permissionType);
    const allowedUrls = egressUrls ? egressUrls.addresses : [];
    return new (0, $471wb.EgressFilteringService)(allowedUrls);
};
const $462f7dce88626787$export$8a0b6b45ac3015d5 = (permissionType, egress)=>{
    return (0, $42omo.useMemo)(()=>{
        return $462f7dce88626787$export$440f6339165c68d2(permissionType, egress);
    }, [
        permissionType,
        egress
    ]);
};
module.exports["egressPermissionService"] = $462f7dce88626787$export$440f6339165c68d2;
module.exports["useEgressPermissionService"] = $462f7dce88626787$export$8a0b6b45ac3015d5;

});

parcelRegister("b7qxC", function(module, exports) {

var $1c598 = parcelRequire("1c598");


var $lzcvT = parcelRequire("lzcvT");

const $ea538cc77ceb57f0$export$d86e18ec9052db2c = (productEnvironment)=>{
    if ((0, $lzcvT.isFedRamp)()) {
        if (productEnvironment === (0, $1c598.ProductEnvironment).STAGING) return (0, $1c598.ForgeCDNEnvironment).STAGING;
        else return (0, $1c598.ForgeCDNEnvironment).PRODUCTION;
    }
    if (productEnvironment === (0, $1c598.ProductEnvironment).DEVELOPMENT) return (0, $1c598.ForgeCDNEnvironment).DEVELOPMENT;
    else if (productEnvironment === (0, $1c598.ProductEnvironment).STAGING) return (0, $1c598.ForgeCDNEnvironment).STAGING;
    else return (0, $1c598.ForgeCDNEnvironment).PRODUCTION;
};
module.exports["getCDNEnvironment"] = $ea538cc77ceb57f0$export$d86e18ec9052db2c;

});

parcelRegister("cqiXo", function(module, exports) {

var $2uzbP = parcelRequire("2uzbP");


var $6otn0 = parcelRequire("6otn0");


var $dh538 = parcelRequire("dh538");


var $hTKp4 = parcelRequire("hTKp4");

const $11028dbc0e45417b$export$423a62223c29d468 = (extension)=>{
    const { egress: egress = [], installationConfig: installationConfig = [] } = extension;
    const getMacroParentHostDomain = ()=>{
        const doc = (0, $hTKp4.getDocument)();
        if (doc?.referrer && extension.type === 'xen:macro') {
            const referrerUrl = new URL(doc.referrer);
            const hostnameParts = referrerUrl.hostname.split('.');
            // Check if the second subdomain is 'cdn' to confirm it's a CDN URL
            const isCdnUrl = hostnameParts.length > 1 && hostnameParts[1] === 'cdn';
            if (isCdnUrl) return hostnameParts[0];
            const isLocalHost = referrerUrl.hostname === 'localhost';
            if (isLocalHost) return referrerUrl.host;
        }
    };
    const macroParentHostDomain = getMacroParentHostDomain();
    return $11028dbc0e45417b$var$gzipAndB64Encode({
        egress: egress,
        installationConfig: installationConfig,
        hostname: window.location.hostname,
        ...macroParentHostDomain && (0, $dh538.fg)('platform_pass_macroparenthostdomain_in_appcontext') ? {
            macroParentHostDomain: macroParentHostDomain,
            macroParentHost: macroParentHostDomain
        } : {}
    });
};
const $11028dbc0e45417b$var$gzipAndB64Encode = (json)=>{
    const jsonString = (0, (/*@__PURE__*/$parcel$interopDefault($2uzbP)))(json); // We use fast-json-stable-stringify to ensure that the JSON is deterministic
    try {
        const zippedData = (0, $6otn0.gzipSync)(new TextEncoder().encode(jsonString), {
            level: 9,
            mtime: 0
        });
        return btoa(String.fromCharCode(...zippedData));
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err.message);
    }
    return '';
};
module.exports["getEncodedAppContext"] = $11028dbc0e45417b$export$423a62223c29d468;

});

parcelRegister("fgbwU", function(module, exports) {

var $3uVVG = parcelRequire("3uVVG");


var $jLYRk = parcelRequire("jLYRk");

const $40dbef35f15607cc$export$6baf9fc1d877ea76 = 'atlassian-token-service-key';
const $40dbef35f15607cc$export$5a2d35665f488c3c = async (startUrl, windowFeatures)=>{
    return (0, $3uVVG.auth)((0, $jLYRk.sanitizeUrl)(startUrl), windowFeatures);
};
const $40dbef35f15607cc$export$4211976e157c7ad8 = (startUrl)=>{
    const url = new URL(startUrl || '', window.location.href);
    const serviceKey = url.searchParams.get('serviceKey');
    return serviceKey !== $40dbef35f15607cc$export$6baf9fc1d877ea76;
};
module.exports["safeAuth"] = $40dbef35f15607cc$export$5a2d35665f488c3c;
module.exports["isExternalAuth"] = $40dbef35f15607cc$export$4211976e157c7ad8;

});

parcelRegister("1Mfb8", function(module, exports) {
const $a6bd50f1f3df3fd2$var$findAppContextKeyInEvent = (event)=>{
    if (!event.context) return undefined;
    for (const context of event.context){
        const { appId: appId, extensionKey: extensionKey } = context.forgeUIAttributes ?? {};
        if (appId && extensionKey) return `${appId}/${extensionKey}`;
    }
    return undefined;
};
const $a6bd50f1f3df3fd2$export$7d41ad2f735979f7 = ()=>{
    const seenAppContextKeys = new Set();
    return (event)=>{
        try {
            const appContextKey = $a6bd50f1f3df3fd2$var$findAppContextKeyInEvent(event);
            if (appContextKey) {
                // only reject the event if we have clear evidence that we've seen it before
                if (seenAppContextKeys.has(appContextKey)) return false;
                seenAppContextKeys.add(appContextKey);
            }
        } catch  {
        // in case of any error, we let the event through, so we don't accidentally break analytics
        }
        return true;
    };
};
module.exports["createSingleEventPerAppFilter"] = $a6bd50f1f3df3fd2$export$7d41ad2f735979f7;

});

parcelRegister("amyZ5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aoVih = parcelRequire("aoVih");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $lp6ii = parcelRequire("lp6ii");


var $1Igmn = parcelRequire("1Igmn");

function $3ed8ce0b7cea2643$export$5b67d59ebd4f147c(props) {
    const { client: client, extension: extension } = props;
    const [appName, setAppName] = (0, $42omo.useState)(undefined);
    (0, $42omo.useEffect)(()=>{
        if (client && extension) {
            const response = client.query({
                query: (0, $lp6ii.GET_APP_NAME),
                variables: {
                    id: extension.id
                },
                context: {
                    headers: {
                        'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
                    }
                }
            });
            response.then((data)=>{
                const appName = data.data?.app.name;
                setAppName(appName);
            });
        }
    }, [
        client,
        extension
    ]);
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: intl.formatMessage($3ed8ce0b7cea2643$var$messages.title),
        appearance: "error"
    }, intl.formatMessage($3ed8ce0b7cea2643$var$messages.message, {
        appName: appName
    }));
}
const $3ed8ce0b7cea2643$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "forge.modal.deprecation.title",
        defaultMessage: "Update your app"
    },
    message: {
        id: "forge.modal.deprecation.message",
        defaultMessage: "Your app {appName} uses the deprecated modal editing experience for custom fields, which is being phased out. Please have your system admin update the app to use inline editing instead. If issues remain, contact the app developer."
    }
});
module.exports["ForgeModalDeprecationMessage"] = $3ed8ce0b7cea2643$export$5b67d59ebd4f147c;

});

parcelRegister("1qp4n", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1c598 = parcelRequire("1c598");


var $gvvHu = parcelRequire("gvvHu");


var $5U2YR = parcelRequire("5U2YR");


var $7KMPr = parcelRequire("7KMPr");


var $inPa6 = parcelRequire("inPa6");


var $7TH2w = parcelRequire("7TH2w");


var $3Spjc = parcelRequire("3Spjc");

class $3a7e2bde20e8f4eb$export$a707936a384f62f9 extends Error {
    constructor(error){
        super(error.logMessage);
        this.logMessage = void 0;
        this.errorTitle = void 0;
        this.errorBody = void 0;
        this.errorTitle = error.errorTitle;
        this.logMessage = error.logMessage;
        this.errorBody = error.errorBody;
    }
}
class $3a7e2bde20e8f4eb$var$GenericErrorBoundaryWithCreateAnalyticsEvent extends (0, $42omo.Component) {
    componentDidCatch(error, errorInfo) {
        const { page: page, environment: environment } = this.context;
        const { createAnalyticsEvent: createAnalyticsEvent, extension: extension } = this.props;
        (0, $7KMPr.captureAndReportError)({
            error: error,
            errorInfo: errorInfo,
            page: page,
            environment: environment || (0, $1c598.ProductEnvironment).DEVELOPMENT,
            errorExtensionDetails: extension ? {
                type: extension.type,
                environmentType: extension.environmentType,
                appOwnerAccountId: extension.appOwner?.accountId,
                properties: extension.properties,
                id: extension?.id
            } : undefined
        });
        createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'failed',
                actionSubject: 'forge.ui.renderer',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'errorBoundary',
                    errorName: error.name
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        if (error instanceof $3a7e2bde20e8f4eb$export$a707936a384f62f9) this.setState({
            thrownError: {
                error: {
                    name: 'error',
                    message: error.errorTitle,
                    errorMessage: error.errorBody
                },
                errorInfo: errorInfo
            }
        });
        else this.setState({
            thrownError: {
                error: error,
                errorInfo: errorInfo
            }
        });
    }
    render() {
        const { thrownError: thrownError } = this.state;
        if (!thrownError) return this.props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvvHu.default), {
            error: thrownError.error,
            dispatch: this.props.dispatch
        });
    }
    constructor(...args){
        super(...args);
        this.context = void 0;
        this.state = {
            thrownError: undefined
        };
    }
}
$3a7e2bde20e8f4eb$var$GenericErrorBoundaryWithCreateAnalyticsEvent.contextType = (0, $5U2YR.MetricsContext);
const $3a7e2bde20e8f4eb$var$GenericErrorBoundary = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a7e2bde20e8f4eb$var$GenericErrorBoundaryWithCreateAnalyticsEvent, {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent
    });
};
var $3a7e2bde20e8f4eb$export$2e2bcd8739ae039 = $3a7e2bde20e8f4eb$var$GenericErrorBoundary;
module.exports["default"] = $3a7e2bde20e8f4eb$export$2e2bcd8739ae039;

});

parcelRegister("3EkSF", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $49e1d4758686470f$var$IntegrationErrorHandlerBoundary extends (0, $42omo.Component) {
    componentDidCatch(error) {
        if (this.props.onError) this.props.onError(error);
        throw error;
    }
    render() {
        return this.props.children;
    }
}
var $49e1d4758686470f$export$2e2bcd8739ae039 = $49e1d4758686470f$var$IntegrationErrorHandlerBoundary;
module.exports["default"] = $49e1d4758686470f$export$2e2bcd8739ae039;

});

parcelRegister("gzd7F", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gvvHu = parcelRequire("gvvHu");

class $cec67f48175aa836$export$51ac3312edef55d7 extends Error {
    get issue() {
        return this._issue;
    }
    get property() {
        return this._property;
    }
    set property(value) {
        this._property = value;
    }
    constructor({ issue: issue, message: message }){
        super(message);
        this._issue = void 0;
        this._property = void 0;
        this._issue = issue;
        this._property = '';
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $cec67f48175aa836$export$51ac3312edef55d7.prototype);
    }
}
class $cec67f48175aa836$var$StyleErrorBoundary extends (0, $42omo.Component) {
    componentDidCatch(error) {
        if (!(error instanceof $cec67f48175aa836$export$51ac3312edef55d7)) throw error;
        this.setState({
            error: error
        });
    }
    render() {
        const { error: error } = this.state;
        if (!error) return this.props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvvHu.default), {
            error: {
                name: 'style-error',
                message: `Error was thrown on style property: ${error.property}`,
                errorMessage: `${error.issue}\n${error.message}`
            },
            isReloadPage: true
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            error: null
        };
    }
}
var $cec67f48175aa836$export$2e2bcd8739ae039 = $cec67f48175aa836$var$StyleErrorBoundary;
module.exports["default"] = $cec67f48175aa836$export$2e2bcd8739ae039;

});

parcelRegister("69400", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6b91a44b41ae4f33$export$61945ff869c3ddb = /*#__PURE__*/ (0, $42omo.createContext)({
    frameCount: 0,
    setFrameCount: ()=>{}
});
const $6b91a44b41ae4f33$var$FrameCountProvider = ({ children: children })=>{
    const [frameCount, setFrameCount] = (0, $42omo.useState)(0);
    const value = {
        frameCount: frameCount,
        setFrameCount: setFrameCount
    };
    (0, $42omo.useEffect)(()=>{
        if (frameCount > 1) throw new Error('Max limit of one frame component per module.');
    }, [
        frameCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6b91a44b41ae4f33$export$61945ff869c3ddb.Provider, {
        value: value
    }, children);
};
var $6b91a44b41ae4f33$export$2e2bcd8739ae039 = $6b91a44b41ae4f33$var$FrameCountProvider;
module.exports["FrameCount"] = $6b91a44b41ae4f33$export$61945ff869c3ddb;
module.exports["default"] = $6b91a44b41ae4f33$export$2e2bcd8739ae039;

});

parcelRegister("eahkE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aoVih = parcelRequire("aoVih");


var $lp6ii = parcelRequire("lp6ii");


var $1Igmn = parcelRequire("1Igmn");

const $83b849164997a777$export$22d69806bfc9e8c1 = 'INVALID_INVOCATION_RUNTIME_ERROR';
const $83b849164997a777$var$buildMessage = (title, error)=>{
    if (error === $83b849164997a777$export$22d69806bfc9e8c1) return `Your app ${title} is no longer working as it uses a deprecated platform feature. Please check if an update for this app is available through Atlassian Administration, or ask the app developer to upgrade the app.\nIf the app is listed on the marketplace, contact the developer using the Support tab.`;
    return `${title} version is outdated due to a deprecated platform component.\nThe app developer needs to update it to a compatible version.\nPlease ask your admin to check for updates or contact the app developer.`;
};
const $83b849164997a777$export$e812f4e5298c004d = (props)=>{
    const { client: client, extension: extension, error: error } = props;
    const [appName, setAppName] = (0, $42omo.useState)(undefined);
    (0, $42omo.useEffect)(()=>{
        if (client) {
            const response = client.query({
                query: (0, $lp6ii.GET_APP_NAME),
                variables: {
                    id: extension.id
                },
                context: {
                    headers: {
                        'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
                    }
                }
            });
            response.then((data)=>{
                const appName = data.data?.app.name;
                setAppName(appName);
            });
        }
    }, [
        client,
        extension.id
    ]);
    const title = appName ? appName : extension.properties.title;
    const message = $83b849164997a777$var$buildMessage(title, error);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: "App update required",
        appearance: "error"
    }, message);
};
module.exports["SANDBOX_DEPRECATION_ERROR"] = $83b849164997a777$export$22d69806bfc9e8c1;
module.exports["ForgeDeprecationMessage"] = $83b849164997a777$export$e812f4e5298c004d;

});

parcelRegister("hoVr8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $6oQb1 = parcelRequire("6oQb1");


var $5U2YR = parcelRequire("5U2YR");

const $fbc50d5752c05105$export$1e4237f96323a8a1 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { page: source } = (0, $5U2YR.useMetricsContext)();
    (0, $42omo.useEffect)(()=>{
        (0, $6oQb1.trackRendererRendered)(createAnalyticsEvent, {
            source: source,
            target: 'renderer'
        });
    });
};
module.exports["useSendRendererRenderedAnalytics"] = $fbc50d5752c05105$export$1e4237f96323a8a1;

});

parcelRegister("6vnrx", function(module, exports) {

var $xQxzY = parcelRequire("xQxzY");


var $eSUdr = parcelRequire("eSUdr");


var $1Igmn = parcelRequire("1Igmn");

const $d67925c3490b4618$export$25f4d46d5dabadfc = (0, $eSUdr.default)`query forge_ui_userQuery($accountId:ID!){user(accountId:$accountId){name picture}}`;
const $d67925c3490b4618$export$ef7fb495aeba8901 = (0, $eSUdr.default)`query forge_ui_usersQuery($accountIds:[ID!]!){users(accountIds:$accountIds){name accountId picture}}`;
const $d67925c3490b4618$export$90f4370c54dd43c9 = (accountIds, client)=>{
    const nonEmptyAccountIds = accountIds.filter((id)=>!(id === ''));
    const { data: data } = (0, $xQxzY.useQuery)($d67925c3490b4618$export$ef7fb495aeba8901, {
        variables: {
            accountIds: nonEmptyAccountIds
        },
        client: client,
        context: {
            headers: {
                'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
            }
        }
    });
    let users = {};
    if (data && data.users) users = data.users.reduce((prev, user)=>{
        if (user.accountId) prev[user.accountId] = {
            picture: user.picture,
            accountId: user.accountId,
            name: user.name
        };
        return prev;
    }, {});
    return users;
};
const $d67925c3490b4618$export$23bbbc4533528f03 = (accountId, client)=>{
    const { data: data } = (0, $xQxzY.useQuery)($d67925c3490b4618$export$25f4d46d5dabadfc, {
        variables: {
            accountId: accountId
        },
        skip: !accountId,
        client: client,
        context: {
            headers: {
                'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
            }
        }
    });
    if (data && data.user) {
        const { picture: picture, name: name } = data.user;
        return {
            name: name,
            picture: picture
        };
    }
    return {
        name: '',
        picture: ''
    };
};
module.exports["useUsers"] = $d67925c3490b4618$export$90f4370c54dd43c9;
module.exports["useUser"] = $d67925c3490b4618$export$23bbbc4533528f03;

});

parcelRegister("cWPLt", function(module, exports) {

var $42omo = parcelRequire("42omo");

// Key for registering and unregistering the subscriber
const $d0f49770ff4f5279$var$MENTION_SUBSCRIBER_KEY = 'forge-ui-user-select';
const $d0f49770ff4f5279$var$mentionResultsToUsers = (results)=>{
    return results.map((result)=>({
            id: result.id,
            name: result.name,
            avatarUrl: result.avatarUrl || '',
            type: 'user'
        })).filter((user)=>typeof user.name !== 'undefined');
};
const $d0f49770ff4f5279$export$f4d09562dcb13ab = (mentionProvider)=>{
    const query = (0, $42omo.useCallback)(async (search)=>{
        const provider = await mentionProvider;
        if (provider && search) return new Promise((resolve)=>{
            provider.filter(search);
            provider.subscribe($d0f49770ff4f5279$var$MENTION_SUBSCRIBER_KEY, (results)=>{
                provider.unsubscribe($d0f49770ff4f5279$var$MENTION_SUBSCRIBER_KEY);
                resolve($d0f49770ff4f5279$var$mentionResultsToUsers(results));
            }, ()=>{
                provider.unsubscribe($d0f49770ff4f5279$var$MENTION_SUBSCRIBER_KEY);
                resolve([]);
            });
        });
        return Promise.resolve([]);
    }, [
        mentionProvider
    ]);
    if (mentionProvider) return query;
};
module.exports["useMentionResource"] = $d0f49770ff4f5279$export$f4d09562dcb13ab;

});

parcelRegister("iamDk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j9gwA = parcelRequire("j9gwA");


var $kSKAi = parcelRequire("kSKAi");


var $7rus4 = parcelRequire("7rus4");


var $gQhRa = parcelRequire("gQhRa");


var $JmaBh = parcelRequire("JmaBh");


var $7LZ4R = parcelRequire("7LZ4R");

const $a8c4b840c9ca4704$var$BITBUCKET_FIELD_ID = 'BitbucketMentions';
// the value prop in UserPicker component can only take undefined for empty value.
// null is not allowed and will resulted in unexpected behavior.
const $a8c4b840c9ca4704$var$ensureUserPickerValue = (value)=>{
    if (!value || Array.isArray(value) && value.length === 0) return undefined;
    return value;
};
// by forcing a key update when defaultValue is present, we force the SmartUserPicker to re-render.
// this is because the SmartUserPicker does not re-render when the defaultValue changes in its
// current implementation.
const $a8c4b840c9ca4704$var$makeUserPickerKey = (id, defaultValue)=>{
    if (!defaultValue || Array.isArray(defaultValue) && defaultValue.length === 0) return id;
    return `${id}-with-default`;
};
const $a8c4b840c9ca4704$var$RawUserPicker = ({ id: id, name: name, description: description, placeholder: placeholder, isMulti: isMulti, includeUsers: includeUsers = true, includeGroups: includeGroups = false, accountId: currentAccountId, cloudId: suppliedCloudId, productKey: productKey, baseUrl: baseUrl, onChange: onChange, query: query, defaultValue: defaultValue, value: providedValue, width: width, productAttributes: productAttributes })=>{
    const [value, setValue] = (0, $42omo.useState)(defaultValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $JmaBh.PortalConsumer), null, (portal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, suppliedCloudId && productKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rus4.default), {
            key: $a8c4b840c9ca4704$var$makeUserPickerKey(id, defaultValue),
            onChange: (user)=>onChange?.(user),
            isMulti: isMulti,
            menuPortalTarget: portal || undefined,
            noOptionsMessage: ()=>null,
            placeholder: placeholder,
            width: width,
            fieldId: // Bitbucket User Recommendations does not support generic contextType
            productKey === 'bitbucket' ? $a8c4b840c9ca4704$var$BITBUCKET_FIELD_ID : id,
            debounceTime: 400,
            includeUsers: includeUsers,
            includeGroups: includeGroups,
            siteId: suppliedCloudId,
            productAttributes: productAttributes,
            // If principalId === 'Context', upstream attempts to use other context
            // to discover the principal ID
            principalId: currentAccountId ?? 'Context',
            productKey: productKey,
            baseUrl: baseUrl,
            inputId: name || id,
            defaultValue: defaultValue,
            // Override the default height of user picker so that it aligns with other input components from design system
            styles: {
                control: (base)=>({
                        ...base,
                        minHeight: '40px',
                        height: '40px'
                    })
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kSKAi.UserPicker), {
            value: $a8c4b840c9ca4704$var$ensureUserPickerValue(providedValue ?? value),
            onChange: (user)=>{
                setValue(user);
                onChange?.(user);
            },
            // Override the default height of user picker so that it aligns with other input components from design system
            styles: {
                control: (base)=>({
                        ...base,
                        minHeight: '40px',
                        height: '40px'
                    })
            },
            isMulti: isMulti,
            menuPortalTarget: portal || undefined,
            noOptionsMessage: ()=>null,
            placeholder: placeholder,
            width: width,
            loadOptions: query,
            fieldId: null,
            inputId: id,
            defaultValue: defaultValue
        }), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.HelperMessage), null, description)));
};
const $a8c4b840c9ca4704$export$83e0c73b09b3a9cd = (props)=>{
    const uid = (0, $j9gwA.useUID)();
    const { name: name, isRequired: isRequired, label: label } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7LZ4R.Label), {
        name: name,
        isRequired: isRequired,
        label: label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a8c4b840c9ca4704$var$RawUserPicker, {
        id: name || uid,
        width: "100%",
        ...props
    }));
};
module.exports["UserPicker"] = $a8c4b840c9ca4704$export$83e0c73b09b3a9cd;

});

parcelRegister("eI4ye", function(module, exports) {

var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $bedQP = parcelRequire("bedQP");


var $42omo = parcelRequire("42omo");


var $6oQb1 = parcelRequire("6oQb1");


var $5U2YR = parcelRequire("5U2YR");


var $1uzCd = parcelRequire("1uzCd");


var $65XYT = parcelRequire("65XYT");

const $7f6ed9fbce688d04$export$433ff3d294755246 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $7f6ed9fbce688d04$export$e943a7fca26f09e4 = 10000;
const $7f6ed9fbce688d04$var$offsetElapsedTimestamps = (events, elapsedBaselineMark)=>{
    return events.map((event)=>{
        const evaluatedElapsedTime = event.elapsed - elapsedBaselineMark;
        event.elapsed = evaluatedElapsedTime;
        return event;
    });
};
const $7f6ed9fbce688d04$var$isPerformanceAnalyticsEnabled = (extensionType)=>{
    return (0, $65XYT.getEnabledModulesForPerformanceProfiling)().includes(extensionType) && (0, $dh538.fg)('forge-ui-performance-analytics-provider');
};
const $7f6ed9fbce688d04$export$9cdba3450d9c6cdc = ({ children: children, appType: appType, forgeEnvironment: forgeEnvironment, profileKey: profileKey, extensionType: extensionType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { page: source } = (0, $5U2YR.useMetricsContext)();
    // Rely on refs to avoid re-rendering all children components when the state changes
    const performanceTimelineRef = (0, $42omo.useRef)({
        events: [],
        listeners: new Set()
    });
    const hasSent = (0, $42omo.useRef)(false);
    const elapsedBaselineMark = (0, $42omo.useRef)(0);
    (0, $42omo.useEffect)(()=>{
        hasSent.current = false;
        performanceTimelineRef.current.events = [];
        elapsedBaselineMark.current = (0, $1uzCd.getPerformanceMark)();
    // Use `profileKey` to reset the all state when the extension or entryPoint changes to collect a new set of analytics
    }, [
        profileKey
    ]);
    (0, $42omo.useEffect)(()=>{
        if (hasSent.current || !$7f6ed9fbce688d04$var$isPerformanceAnalyticsEnabled(extensionType || '')) return;
        // Send all collected performance related analytics in a single event
        const timeout = setTimeout(()=>{
            // Clone the eventRef to avoid the possibility of mutating the original object
            const eventsPayload = structuredClone(performanceTimelineRef.current.events);
            if ((0, $dh538.fg)('forge-ui-performance-sampling')) (0, $6oQb1.fireEvent)(createAnalyticsEvent, {
                action: 'performance.profiled',
                actionSubject: 'forge.ui.extension',
                attributes: {
                    events: $7f6ed9fbce688d04$var$offsetElapsedTimestamps(eventsPayload, elapsedBaselineMark.current),
                    // Time difference since this event was fired and since page loaded
                    navigationTimeStart: elapsedBaselineMark.current,
                    appType: appType,
                    forgeEnvironment: forgeEnvironment
                },
                source: source
            });
            hasSent.current = true;
        }, $7f6ed9fbce688d04$export$e943a7fca26f09e4);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        appType,
        createAnalyticsEvent,
        elapsedBaselineMark,
        performanceTimelineRef,
        extensionType,
        forgeEnvironment,
        hasSent,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7f6ed9fbce688d04$export$433ff3d294755246.Provider, {
        value: performanceTimelineRef
    }, children);
};
const $7f6ed9fbce688d04$export$ec3453941beb4064 = (0, $bedQP.componentWithFG)('forge-ui-performance-analytics-provider', $7f6ed9fbce688d04$export$9cdba3450d9c6cdc, (0, $42omo.Fragment));
module.exports["PerformanceAnalyticsContext"] = $7f6ed9fbce688d04$export$433ff3d294755246;
module.exports["PERFORMANCE_ANALYTICS_INTERVAL"] = $7f6ed9fbce688d04$export$e943a7fca26f09e4;
module.exports["PerformanceAnalyticsProviderRollout"] = $7f6ed9fbce688d04$export$ec3453941beb4064;

});

parcelRegister("1FKSs", function(module, exports) {

var $c2Y0n = parcelRequire("c2Y0n");


var $1uzCd = parcelRequire("1uzCd");

const $e9d25c3abed1c1e7$var$ClickedProfilingCapturableEventTransform = (0, $c2Y0n.ClickedProfilingEventSchema).transform((_)=>{
    return {
        type: 'user-interacted',
        elapsed: (0, $1uzCd.getPerformanceMark)()
    };
});
const $e9d25c3abed1c1e7$var$NavigationTimingProfilingCapturableEventTransform = (0, $c2Y0n.NavigationTimingProfilingEventSchema).transform((e)=>{
    return {
        type: 'navigation-timing',
        elapsed: (0, $1uzCd.getPerformanceMark)(),
        duration: Math.trunc(e.duration),
        transferSize: e.transferSize
    };
});
const $e9d25c3abed1c1e7$var$ResourceTimingProfilingCapturableEventTransform = (0, $c2Y0n.ResourceTimingProfilingEventSchema).transform((e)=>{
    return {
        type: 'resource-timing',
        elapsed: (0, $1uzCd.getPerformanceMark)(),
        start: Math.trunc(e.start),
        duration: Math.trunc(e.duration),
        transferSize: Math.trunc(e.transferSize),
        initiatorType: e.initiatorType
    };
});
const $e9d25c3abed1c1e7$var$LayoutShiftProfilingCapturableEventTransform = (0, $c2Y0n.LayoutShiftProfilingEventSchema).transform((e)=>{
    return {
        type: 'dcls-score',
        elapsed: (0, $1uzCd.getPerformanceMark)(),
        timestamp: Math.trunc(e.timestamp),
        // Transport 2dp truncated to avoid precision errors.
        score: Math.trunc(e.score * 100),
        inputFlag: e.inputFlag
    };
});
const $e9d25c3abed1c1e7$var$FCPProfilingCapturableEventTransform = (0, $c2Y0n.FCPProfilingEventSchema).transform((e)=>{
    return {
        type: 'fcp-snapshot',
        elapsed: (0, $1uzCd.getPerformanceMark)(),
        start: Math.trunc(e.start)
    };
});
const $e9d25c3abed1c1e7$var$LCPProfilingCapturableEventTransform = (0, $c2Y0n.LCPProfilingEventSchema).transform((e)=>{
    return {
        type: 'lcp-snapshot',
        elapsed: (0, $1uzCd.getPerformanceMark)(),
        start: Math.trunc(e.start),
        size: Math.trunc(e.size)
    };
});
// For each in-frame event type, there should be a transformer to a safely ingestible event.
const $e9d25c3abed1c1e7$var$transformers = {
    'navigation-timing': $e9d25c3abed1c1e7$var$NavigationTimingProfilingCapturableEventTransform,
    'resource-timing': $e9d25c3abed1c1e7$var$ResourceTimingProfilingCapturableEventTransform,
    'dcls-score': $e9d25c3abed1c1e7$var$LayoutShiftProfilingCapturableEventTransform,
    click: $e9d25c3abed1c1e7$var$ClickedProfilingCapturableEventTransform,
    'fcp-snapshot': $e9d25c3abed1c1e7$var$FCPProfilingCapturableEventTransform,
    'lcp-snapshot': $e9d25c3abed1c1e7$var$LCPProfilingCapturableEventTransform
};
const $e9d25c3abed1c1e7$export$d85e1d6e65aaba29 = (0, $c2Y0n.AppFrameProfilingEventSchema).transform((e)=>$e9d25c3abed1c1e7$var$transformers[e.event].parse(e));
module.exports["FrameProfilingEventCaptureTransformer"] = $e9d25c3abed1c1e7$export$d85e1d6e65aaba29;

});

parcelRegister("kxKUs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5yfLD = parcelRequire("5yfLD");


var $9zb43 = parcelRequire("9zb43");


var $inPa6 = parcelRequire("inPa6");


var $lzcvT = parcelRequire("lzcvT");


var $8z9j5 = parcelRequire("8z9j5");


var $dWSaf = parcelRequire("dWSaf");


var $4c2yb = parcelRequire("4c2yb");


var $b4nol = parcelRequire("b4nol");


var $luNHV = parcelRequire("luNHV");


var $7KMPr = parcelRequire("7KMPr");

var $kaOT1 = parcelRequire("kaOT1");


var $7TH2w = parcelRequire("7TH2w");


var $3Spjc = parcelRequire("3Spjc");


var $5U2YR = parcelRequire("5U2YR");


var $cMiG0 = parcelRequire("cMiG0");


var $iqcSr = parcelRequire("iqcSr");

var $ijfiP = parcelRequire("ijfiP");


var $1JDPF = parcelRequire("1JDPF");


var $dh538 = parcelRequire("dh538");


var $a2ksR = parcelRequire("a2ksR");


var $2gNWY = parcelRequire("2gNWY");


var $ly9ul = parcelRequire("ly9ul");


var $6oQb1 = parcelRequire("6oQb1");


var $1uzCd = parcelRequire("1uzCd");


var $iUjrf = parcelRequire("iUjrf");


var $buzAL = parcelRequire("buzAL");


var $hQK66 = parcelRequire("hQK66");

let $2472ed5b4088eda9$var$createIframeBridge = null;
let $2472ed5b4088eda9$var$postRobotSend = null;


// bridge-core import relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') {
    $2472ed5b4088eda9$var$createIframeBridge = (parcelRequire("eLUTa")).createIframeBridge;
    $2472ed5b4088eda9$var$postRobotSend = (parcelRequire("eLUTa")).postRobotSend;
}
const $2472ed5b4088eda9$var$mapCustomBridgeMethods = ({ customBridgeMethods: customBridgeMethods, createMessageForwarder: createMessageForwarder, isEmbeddedMacro: isEmbeddedMacro })=>{
    if (!customBridgeMethods) return {};
    const shouldForwardBridgeForEmbeddedMacro = isEmbeddedMacro && createMessageForwarder && (0, $dh538.fg)('platform_add_bridge_message_forwarding_from_faus');
    return Object.keys(customBridgeMethods).reduce((acc, key)=>{
        return {
            ...acc,
            [key]: shouldForwardBridgeForEmbeddedMacro ? createMessageForwarder(key) : (payload)=>{
                return customBridgeMethods[key](payload?.data);
            }
        };
    }, {});
};
class $2472ed5b4088eda9$export$d86296fe47e644cc extends Error {
    constructor(cause){
        super(cause);
    }
}
const $2472ed5b4088eda9$var$MACRO_MODULE_NAME = 'xen:macro';
// Tracks re-initialisation of the bridge and logs a warning to console and analytics
const $2472ed5b4088eda9$var$useBridgeReinitTracker = ()=>{
    const { trackExtensionRemounted: trackExtensionRemounted } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    const mountedCount = (0, $42omo.useRef)(0);
    const trackBridgeReinited = (0, $hQK66.useCallbackOne)(()=>{
        try {
            mountedCount.current += 1;
            if (mountedCount.current > 1) {
                trackExtensionRemounted({
                    mountCount: mountedCount.current,
                    isUseBridgeReinit: true
                });
                // eslint-disable-next-line no-console
                console.warn(`Warning: useBridge re-initialised the bridge ${mountedCount.current} times.`);
            }
        } catch  {}
    }, [
        mountedCount,
        trackExtensionRemounted
    ]);
    return trackBridgeReinited;
};
const $2472ed5b4088eda9$export$23a7a1286dcfa590 = ({ cloudId: cloudId, theme: theme, surfaceColor: surfaceColor, origin: origin, api: api, customBridgeMethods: customBridgeMethods, onLoad: onLoad, isResizable: isResizable, height: height, environment: environment, extension: extension, iframeRef: iframeRef, client: client, contextIds: contextIds, isInModal: isInModal, localId: localId, isEmbeddedMacro: isEmbeddedMacro = false, embeddedParentLocalId: embeddedParentLocalId })=>{
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [loadedAt, setLoadedAt] = (0, $42omo.useState)(null);
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    // This ref avoids the api object ending up in the dep array
    // of the effect that calls createIframeBridge. It means that
    // people can pass anonymous functions as the api without the
    // bridge being re-created every render.
    const apiRef = (0, $42omo.useRef)(api);
    (0, $42omo.useEffect)(()=>{
        apiRef.current = api;
    }, [
        api
    ]);
    const enableThemingRef = (0, $42omo.useRef)();
    const setThemeRef = (0, $42omo.useRef)();
    // this ref tracks the initial theme to avoid unnecessary theme updates.
    // specifically, it is used in createIframeBridge during the initial forge runtime initialization,
    // so that the iframe can set the theme correctly on the ready event (initial handshake).
    // however, subsequent theme should not cause createIframeBridge to be called again.
    const initialThemeRef = (0, $42omo.useRef)({
        theme: theme,
        surfaceColor: surfaceColor
    });
    const trackBridgeReinited = $2472ed5b4088eda9$var$useBridgeReinitTracker();
    (0, $42omo.useEffect)(()=>{
        if (!setThemeRef.current) return;
        // we track the theme changes here to avoid calling createIframeBridge (expensive and error prone) unnecessarily
        initialThemeRef.current = {
            theme: theme,
            surfaceColor: surfaceColor
        };
        setThemeRef.current(theme, surfaceColor, environment);
        (0, $dh538.fg)('forge-ui-use-theme') && (0, $luNHV.emit)('FORGE_CORE_THEME_CHANGED', {
            theme: theme
        });
    }, [
        theme,
        surfaceColor,
        loading,
        environment
    ]);
    // same as above, but for customBridgeMethods
    const customBridgeMethodsRef = (0, $42omo.useRef)(customBridgeMethods);
    (0, $42omo.useEffect)(()=>{
        customBridgeMethodsRef.current = customBridgeMethods;
    }, [
        customBridgeMethods
    ]);
    const [errorExtensionDetails, setErrorExtensionDetails] = (0, $42omo.useState)({
        id: extension.id,
        properties: extension.properties,
        type: extension.type,
        environmentType: extension.environmentType,
        appOwnerAccountId: extension.appOwner?.accountId
    });
    const tracing = (0, $kaOT1.useTracingContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { trackExtensionClicked: trackExtensionClicked, trackForgeFeatureFlagEvent: trackForgeFeatureFlagEvent, trackObjectStoreAction: trackObjectStoreAction } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    (0, $42omo.useEffect)(()=>{
        const { type: type, environmentType: environmentType, properties: properties, appOwnerAccountId: appOwnerAccountId, id: id } = errorExtensionDetails;
        if (extension.id !== id || extension.type !== type || extension.environmentType !== environmentType || extension.appOwner?.accountId !== appOwnerAccountId || !(0, (/*@__PURE__*/$parcel$interopDefault($5yfLD)))(extension.properties, properties)) setErrorExtensionDetails({
            id: extension.id,
            properties: extension.properties,
            type: extension.type,
            environmentType: extension.environmentType,
            appOwnerAccountId: extension.appOwner?.accountId
        });
    }, [
        extension,
        errorExtensionDetails
    ]);
    const { id: id, installationId: installationId } = extension;
    // Need to retrieve appId here because extension.appId could be undefined in certain products. For example, Jira extensions do not provide the appId.
    const appId = extension.appId ?? (0, $ijfiP.parseExtensionId)(extension.id).appId;
    const getAppForgeUIExtensions = (0, $1JDPF.useGetAppForgeUIExtensions)({
        client: client,
        appId: appId,
        environmentId: extension.environmentId,
        moduleType: extension.type,
        contextIds: contextIds,
        context: {},
        includeHidden: false,
        cloudId: cloudId,
        bypassNewForgeExtensionListCall: true
    });
    // Query to retrieve the base url of a tenant.
    // The same Atlassian tenant could have a different custom domain for each product.
    // We retrieve the underlying Atlassian domain here to use for URL creation in routing to support cross custom domain routing
    const getBaseUrl = (0, $42omo.useCallback)(async ()=>{
        return cloudId ? await (0, $a2ksR.getBaseUrl)(client, cloudId) : window.location.origin;
    }, [
        client,
        cloudId
    ]);
    const appType = (0, $42omo.useMemo)(()=>(0, $iqcSr.isCustomUI)(extension) ? 'CustomUI' : 'UIKit', [
        extension
    ]);
    const { captureEvent: captureEvent, captureUntrustedEvent: captureUntrustedEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    // The event subscription need to be maintained outside of useEffect to avoid missing events when the createIframeBridge is re-created
    // specifically, createIframeBridge could be re-created when the app "re-render", however, in such cases we do not want to lose the existing event subscriptions
    // after all, we should consider ensure createIframeBridge not to be re-created unnecessarily (only when completely app re-mount is really needed)
    const eventCallbacksRef = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            for (const subscription of eventCallbacksRef.current)subscription.unsubscribe();
            eventCallbacksRef.current = [];
        };
    }, []);
    const { properties: { layout: layout }, type: type, environmentType: environmentType } = extension;
    (0, $42omo.useEffect)(()=>{
        //this should never happen on client side
        if (!$2472ed5b4088eda9$var$createIframeBridge) return;
        const iframeEl = iframeRef.current;
        if (iframeEl?.contentWindow && !loading && typeof loadedAt === 'number') {
            const extensionDetails = {
                id: id.split('/').slice(0, 3).join('/'),
                installationId: installationId
            };
            const sendHandshakeMetric = (page)=>{
                return (success, error)=>{
                    if (success) createAnalyticsEvent({
                        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                        data: {
                            action: 'succeeded',
                            actionSubject: 'forge.ui.bridge',
                            attributes: {
                                target: 'handshake'
                            },
                            source: page,
                            tags: [
                                'forge'
                            ]
                        }
                    }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                    else {
                        createAnalyticsEvent({
                            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                            data: {
                                action: 'failed',
                                actionSubject: 'forge.ui.bridge',
                                attributes: {
                                    target: 'handshake',
                                    reason: error instanceof Error ? error.message : 'Unknown error',
                                    isUnrecoverable: (0, $ly9ul.isUnrecoverableError)(error)
                                },
                                source: page,
                                tags: [
                                    'forge'
                                ]
                            }
                        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                        const handshakeError = error instanceof Error ? new Error(`Bridge handshake error: ${error.message}`) : new Error('Unknown bridge handshake error');
                        (0, $7KMPr.captureAndReportError)({
                            error: handshakeError,
                            environment: environment,
                            errorExtensionDetails: errorExtensionDetails,
                            page: page,
                            tracing: tracing
                        });
                    }
                };
            };
            // Creates a forwarder that sends messages to the product (via window.parent.parent)
            // Used by FAUS to forward showFlag/closeFlag/openModal calls from nested apps
            // For openModal, includes the extension details so the product can render the modal with the correct app
            const createMessageForwarder = (eventKey)=>async ({ data: data })=>{
                    // This would need to be changed if we want to support multiple nesting levels
                    const targetWindow = window.parent?.parent;
                    if (targetWindow && targetWindow !== window) {
                        // Only forward to same hostname as FAUS for security (allow different ports for local dev)
                        const targetDomain = `${window.location.protocol}//${window.location.hostname}`;
                        // emitReadyEvent method calls the event method and also the actual emitReadyEvent method.
                        // This is referring to the former. For the latter, event key will be 'emitReadyEvent'
                        const isEmitEvent = eventKey === 'emit';
                        const isNativeConfluenceEvent = data?.event === 'FORGE_CONTENT_PROPERTY_UPDATE' || data?.event === 'EXTENSION_READY';
                        const isOpenRovoEvent = eventKey === 'openRovo';
                        const forwardedData = {
                            eventKey: eventKey,
                            // Pass child extensionDetails object for emit event bridge method
                            ...isEmitEvent ? {
                                embeddedMacroExtensionDetails: extensionDetails
                            } : {},
                            // Pass appId for openRovo so the receiving bridge uses the correct app context
                            ...isOpenRovoEvent ? {
                                sourceAppId: appId,
                                installationId: installationId,
                                environmentId: extension.environmentId
                            } : {},
                            ...data
                        };
                        // Emit event as usual unless it is emitReadyEvent or updateBylineProperties event
                        if (isEmitEvent && !isNativeConfluenceEvent) (0, $luNHV.emit)(data?.event, data?.payload, extensionDetails);
                        else // TODO: the below requires `extension` to be passed into the useEffect deps which is causing the entire bridge to be re-created on every render and causing a regression on Frame
                        // https://ecosystem-platform.atlassian.net/browse/EXT-4186
                        // For openModal, include the extension details so the product knows which app to use
                        // if (eventKey === 'openModal') {
                        // 	forwardedData.extension = extension;
                        // }
                        $2472ed5b4088eda9$var$postRobotSend && $2472ed5b4088eda9$var$postRobotSend(targetWindow, `messageFromEmbeddedFAUS_${embeddedParentLocalId}`, forwardedData, {
                            domain: targetDomain
                        }).catch((error)=>{
                            // eslint-disable-next-line no-console
                            console.error(`Failed to forward ${eventKey} to product:`, error);
                        });
                    }
                };
            const platform_add_bridge_message_forwarding_from_faus = (0, $dh538.fg)('platform_add_bridge_message_forwarding_from_faus');
            // Only bodied macros should receive embedded macro messages
            const isBodiedMacro = layout === 'bodied';
            // Confluence embed card has the same origin as top level product
            const isNativeConfluenceEmbeddedCard = ()=>{
                try {
                    window.parent.location.href;
                    return true;
                } catch  {
                    return false;
                }
            };
            const isProductLevel = typeof window !== 'undefined' && (window.location.ancestorOrigins?.length === 0 || isNativeConfluenceEmbeddedCard()) && !isInModal;
            const { open: open } = $2472ed5b4088eda9$var$createIframeBridge({
                theme: initialThemeRef.current.theme,
                surfaceColor: initialThemeRef.current.surfaceColor,
                withDomain: origin,
                withWindow: iframeEl.contentWindow,
                metadata: {
                    env: environment,
                    module: type,
                    product: type.split(':')[0],
                    isFedRamp: (0, $lzcvT.isFedRamp)(),
                    localId: localId
                },
                features: (0, $dWSaf.withMetricsAndAnalytics)({
                    features: {
                        invoke: async ({ data: data })=>{
                            const performanceStart = (0, $1uzCd.getPerformanceMark)();
                            if ((0, $dh538.fg)('forge-ui-performance-analytics-provider')) captureEvent({
                                type: 'resolver-invoke-initiated',
                                elapsed: performanceStart
                            });
                            const { onInvoke: onInvoke, onThreeLO: onThreeLO } = apiRef.current;
                            const result = await onInvoke(data);
                            if (result.type === '3lo') return new Promise((resolve, reject)=>{
                                onThreeLO(result.authUrl, ()=>{
                                    const performanceAuthEnd = (0, $1uzCd.getPerformanceMark)();
                                    return onInvoke(data).then((res)=>{
                                        if (res.type === 'ok') resolve(res.response);
                                        if ((0, $dh538.fg)('forge-ui-performance-analytics-provider')) {
                                            const performanceEnd = (0, $1uzCd.getPerformanceMark)();
                                            captureEvent({
                                                type: 'resolver-invoked',
                                                duration: performanceEnd - performanceStart,
                                                authDuration: performanceAuthEnd - performanceStart,
                                                elapsed: performanceEnd
                                            });
                                        }
                                        // Unexpected case where 3LO consent requested again after consenting
                                        reject();
                                    }, reject);
                                });
                            });
                            if ((0, $dh538.fg)('forge-ui-performance-analytics-provider')) {
                                const performanceEnd = (0, $1uzCd.getPerformanceMark)();
                                captureEvent({
                                    type: 'resolver-invoked',
                                    duration: performanceEnd - performanceStart,
                                    authDuration: 0,
                                    elapsed: performanceEnd
                                });
                            }
                            if (result.type === 'err') throw new Error(result.message);
                            return result.response;
                        },
                        initFeatureFlags: async ({ data: data })=>{
                            if (!(0, $dh538.fg)('platform_forge_ff_client_sdk')) return {};
                            const { onInitFeatureFlags: onInitFeatureFlags } = apiRef.current;
                            const result = await onInitFeatureFlags(data);
                            if ((0, $dh538.fg)('platform_forge_ff_ui_analytics')) trackForgeFeatureFlagEvent({
                                appType: appType,
                                appId: appId,
                                baseUrl: window.location.origin,
                                eventType: (0, $b4nol.FeatureFlagEventTypes).INITIALIZATION,
                                success: result.type !== 'err',
                                featureFlagEnv: data.user?.statsigEnvironment?.tier || (0, $b4nol.FeatureFlagEnv).development,
                                forgeEnvironment: environmentType
                            });
                            if (result.type === 'err') return {};
                            return result.response;
                        },
                        trackFeatureFlagEvent: async ({ data: data })=>{
                            if (!(0, $dh538.fg)('platform_forge_ff_ui_analytics')) return;
                            const allowedEventTypes = [
                                (0, $b4nol.FeatureFlagEventTypes).CHECKFLAG.toUpperCase()
                            ];
                            try {
                                // basic validations
                                if (!data.type || !allowedEventTypes.includes(data.type.toUpperCase())) return;
                                if (data.type.toUpperCase() === (0, $b4nol.FeatureFlagEventTypes).CHECKFLAG && data.properties.name && (data.properties.name.length < 3 || data.properties.name > 50)) return;
                                if (typeof data.properties.success !== 'boolean') return;
                                if (!(data.properties.environment && data.properties.environment.toLowerCase() in (0, $b4nol.FeatureFlagEnv))) return;
                                trackForgeFeatureFlagEvent({
                                    appType: appType,
                                    appId: appId,
                                    baseUrl: window.location.origin,
                                    flagName: data.properties.name || '',
                                    eventType: data.type,
                                    success: data.properties.success,
                                    featureFlagEnv: data.properties.environment,
                                    forgeEnvironment: environmentType
                                });
                            } catch  {
                            // all errors are ignored
                            }
                            return;
                        },
                        'iframe-analytics': async ({ data: data })=>{
                            if ((0, $dh538.fg)('forge-ui-performance-analytics-provider')) captureUntrustedEvent(data);
                            if ((0, $dh538.fg)('forge-ui-iframe-analytics')) {
                                if (data.event === 'click') trackExtensionClicked({
                                    extensionType: type,
                                    appType: appType,
                                    forgeEnvironment: environmentType,
                                    baseUrl: window.location.origin
                                });
                            }
                        },
                        getUrl: async ({ data: data })=>{
                            if (data.target && getAppForgeUIExtensions) {
                                const path = await (0, $cMiG0.createNavigateTargetPath)(data, {
                                    getContext: apiRef.current.getContext,
                                    getAppForgeUIExtensions: getAppForgeUIExtensions
                                });
                                if (!path) return null;
                                // If the current domain is a custom domain, we need to request for the base url
                                const baseUrl = (0, $2gNWY.isCustomDomain)(window.location.hostname) ? await getBaseUrl() : window.location.origin;
                                // `getUrl` from `@forge/bridge` will return a URL object.
                                // We are returning a string here as a URL object will serialised into a string when being passed across the bridge
                                return `${baseUrl}${path}`;
                            }
                            return null;
                        },
                        navigate: platform_add_bridge_message_forwarding_from_faus && isEmbeddedMacro ? createMessageForwarder('navigate') : async ({ data: data })=>{
                            // If a NavigationLocation object was provided:
                            if ('target' in data && data.target && getAppForgeUIExtensions && (0, $dh538.fg)('forge-ui-navigation')) {
                                const path = await (0, $cMiG0.createNavigateTargetPath)(data, {
                                    getContext: apiRef.current.getContext,
                                    getAppForgeUIExtensions: getAppForgeUIExtensions
                                });
                                if (!path) {
                                    // eslint-disable-next-line no-console
                                    console.warn('Path was not found for the parameters provided');
                                    return;
                                }
                                // Request for the base url if the current domain is a custom domain
                                if ((0, $2gNWY.isCustomDomain)(window.location.hostname)) {
                                    const baseUrl = await getBaseUrl();
                                    return apiRef.current.onNavigate({
                                        type: data.type,
                                        url: `${baseUrl}${path}`
                                    });
                                } else return apiRef.current.onNavigate({
                                    type: data.type,
                                    url: path
                                });
                            }
                            return apiRef.current.onNavigate(data);
                        },
                        reconcile: async ({ data: data })=>{
                            return apiRef.current.reconcile(data);
                        },
                        onError: async ({ data: data })=>{
                            return apiRef.current.onError(data);
                        },
                        reload: platform_add_bridge_message_forwarding_from_faus && isEmbeddedMacro ? createMessageForwarder('reload') : async ()=>{
                            (0, $4c2yb.reload)();
                        },
                        refresh: async ()=>{
                            return apiRef.current.refresh();
                        },
                        submit: async (payload)=>{
                            return apiRef.current.submit(payload);
                        },
                        open: platform_add_bridge_message_forwarding_from_faus && isEmbeddedMacro ? createMessageForwarder('open') : async ()=>{
                            return apiRef.current.open();
                        },
                        onClose: async (payload)=>{
                            return apiRef.current.onClose(payload);
                        },
                        close: async (payload)=>{
                            return apiRef.current.close(payload);
                        },
                        emitReadyEvent: platform_add_bridge_message_forwarding_from_faus && isEmbeddedMacro ? createMessageForwarder('emitReadyEvent') : async ()=>{
                            if ((0, $dh538.fg)('forge-ui-performance-analytics-provider')) captureEvent({
                                type: 'emit-ready-event',
                                elapsed: (0, $1uzCd.getPerformanceMark)()
                            });
                            return apiRef.current.emitReadyEvent();
                        },
                        getContext: ()=>{
                            return apiRef.current.getContext();
                        },
                        openModal: platform_add_bridge_message_forwarding_from_faus && isEmbeddedMacro ? createMessageForwarder('openModal') : async (payload)=>{
                            return apiRef.current.openModal(payload);
                        },
                        createHistory: async ()=>{
                            return apiRef.current.createHistory();
                        },
                        fetchProduct: async ({ data: data })=>{
                            return apiRef.current.fetchProduct(data);
                        },
                        fetchRemote: async ({ data: data })=>{
                            return apiRef.current.fetchRemote(data);
                        },
                        showFlag: platform_add_bridge_message_forwarding_from_faus && isEmbeddedMacro ? createMessageForwarder('showFlag') : async ({ data: data })=>{
                            const flagActions = data.actions?.map((action)=>{
                                const { onClick: onClick } = action;
                                return {
                                    ...action,
                                    onClick: onClick ? ()=>onClick() : ()=>{}
                                };
                            });
                            return apiRef.current.showFlag({
                                ...data,
                                actions: flagActions
                            });
                        },
                        closeFlag: platform_add_bridge_message_forwarding_from_faus && isEmbeddedMacro ? createMessageForwarder('closeFlag') : async ({ data: data })=>apiRef.current.closeFlag(data),
                        on: async (payload)=>{
                            const { event: event, callback: callback } = payload.data;
                            const subscription = (0, $luNHV.on)(event, callback, extensionDetails);
                            eventCallbacksRef.current.push(subscription);
                            return {
                                unsubscribe: ()=>{
                                    eventCallbacksRef.current.splice(eventCallbacksRef.current.indexOf(subscription), 1);
                                    subscription.unsubscribe();
                                }
                            };
                        },
                        emit: platform_add_bridge_message_forwarding_from_faus ? isEmbeddedMacro ? createMessageForwarder('emit') : async (payload)=>{
                            return (0, $luNHV.emit)(payload.data.event, payload.data.payload, payload.data.embeddedMacroExtensionDetails || extensionDetails);
                        } : async (payload)=>{
                            return (0, $luNHV.emit)(payload.data.event, payload.data.payload, extensionDetails);
                        },
                        enableTheming: async ()=>{
                            await enableThemingRef.current?.();
                            const currentTheme = (0, $8z9j5.default)();
                            const surfaceColor = null;
                            setThemeRef.current?.(currentTheme, surfaceColor, environment);
                        },
                        changeWindowTitle: async ({ data: data })=>{
                            apiRef.current.changeWindowTitle(data);
                        },
                        getFrameId: async ()=>{
                            return apiRef.current.getFrameId();
                        },
                        subscribeRealtimeChannel: async (payload)=>{
                            return apiRef.current.subscribeRealtimeChannel?.(payload);
                        },
                        publishRealtimeChannel: async (payload)=>{
                            return apiRef.current.publishRealtimeChannel?.(payload);
                        },
                        openRovo: platform_add_bridge_message_forwarding_from_faus && isEmbeddedMacro ? createMessageForwarder('openRovo') : async ({ data: data })=>{
                            return apiRef.current.openRovo?.(data);
                        },
                        trackObjectStoreAction: async ({ data: data })=>{
                            trackObjectStoreAction({
                                appType: appType,
                                appId: appId,
                                action: data.action,
                                forgeEnvironment: environmentType
                            });
                        },
                        ...(0, $buzAL.getUseBridgePermissionFunctions)(apiRef),
                        ...$2472ed5b4088eda9$var$mapCustomBridgeMethods({
                            customBridgeMethods: customBridgeMethodsRef.current,
                            createMessageForwarder: createMessageForwarder,
                            isEmbeddedMacro: isEmbeddedMacro
                        })
                    },
                    page: page,
                    environment: environment,
                    forgeEnvironment: environmentType,
                    errorExtensionDetails: errorExtensionDetails,
                    createAnalyticsEvent: createAnalyticsEvent,
                    tracing: tracing
                }),
                sendHandshakeMetric: sendHandshakeMetric(page),
                shouldReceiveEmbeddedMacroMessages: platform_add_bridge_message_forwarding_from_faus && isBodiedMacro && isProductLevel
            });
            if (isResizable) (0, $9zb43.iframeResizer)({
                heightCalculationMethod: 'bodyScroll',
                widthCalculationMethod: 'bodyScroll',
                scrolling: true,
                // @ts-ignore minHeight can be a string
                minHeight: height,
                // sizeWidth is enabled for resizing only for inline macros
                sizeWidth: layout === 'inline' && type === $2472ed5b4088eda9$var$MACRO_MODULE_NAME,
                initCallback: (iframe)=>{
                    iframe?.iFrameResizer?.resize();
                }
            }, iframeEl);
            const { close: close, enableTheming: enableTheming, setTheme: setTheme } = open();
            setThemeRef.current = setTheme;
            enableThemingRef.current = enableTheming;
            // this tracking is to identify re-initializations of the bridge, which should never happen (or we should try avoid)
            // during the lifecycle of a Forge app. re-initialise bridge could be expensive and error prone (losing existing event subscriptions, etc)
            trackBridgeReinited();
            return ()=>{
                close?.(); // close may be undefined here if createIframeBridge call fails
                iframeEl?.iFrameResizer && iframeEl?.iFrameResizer.removeListeners();
            };
        }
    // We intentionally add react-hooks/exhaustive-deps disable here, so that we don't blindly
    // add new dependencies without considering the impact of re-creating the bridge.
    // The following dependencies are excluded for the reasons stated:
    //   - trackBridgeReinited - it's memoised and used for observability and should not trigger bridge recreation
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        getBaseUrl,
        iframeRef,
        origin,
        loading,
        page,
        isResizable,
        height,
        environment,
        errorExtensionDetails,
        id,
        layout,
        type,
        environmentType,
        installationId,
        tracing,
        createAnalyticsEvent,
        loadedAt,
        getAppForgeUIExtensions,
        trackExtensionClicked,
        appType,
        captureEvent,
        captureUntrustedEvent,
        appId,
        trackForgeFeatureFlagEvent,
        trackObjectStoreAction,
        isInModal,
        localId,
        isEmbeddedMacro,
        embeddedParentLocalId
    ]);
    // [WARN] Please take careful consideration when adding new dependencies to the above useEffect.
    // createIframeBridge is expensive to call and re-creating the bridge could lead to lost event subscriptions.
    // - Try to avoid adding dependencies that could change on every render (e.g. objects or functions defined inline).
    // - If you need to add a function, consider wrapping it in useCallbackOne / useRef / useMemoOne to stabilise the reference.
    // - Please ensure multiple revewers in the Forge UI team review and approve the change.
    // - As the standard lint for dependency array is disabled, please ensure the dependency array is kept up to date with necessary dependencies.
    return {
        loading: loading,
        iframeProps: {
            ref: iframeRef,
            onLoad: ()=>{
                onLoad && onLoad();
                setLoading(false);
                setLoadedAt(Date.now());
            }
        }
    };
};
module.exports["BridgeClientError"] = $2472ed5b4088eda9$export$d86296fe47e644cc;
module.exports["useBridge"] = $2472ed5b4088eda9$export$23a7a1286dcfa590;

});

parcelRegister("i5CVI", function(module, exports) {
function $6828e685c7239bdd$export$ff7962acd6052c28(url, type, push) {
    switch(type){
        case 'new-tab':
            window.open(url, '_blank', 'noopener noreferrer');
            break;
        case 'same-tab':
            if (push) push(url);
            else window.location.href = url;
            break;
    }
}
module.exports["navigate"] = $6828e685c7239bdd$export$ff7962acd6052c28;

});

parcelRegister("2kGKp", function(module, exports) {
const $676d2d098e4ba6be$export$5a759dc7a1cfb72a = ()=>{
    return window.location.origin;
};
module.exports["getOrigin"] = $676d2d098e4ba6be$export$5a759dc7a1cfb72a;

});

parcelRegister("kTcrU", function(module, exports) {

var $2kGKp = parcelRequire("2kGKp");

const $3716a239e20d61f7$var$emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// Filters out all parameters that may be used for malicious purposes such as attaching local files or adding bcc recipients
// Only subject and body are allowed
const $3716a239e20d61f7$var$filterMailtoParams = (mailtoLink)=>{
    try {
        const url = new URL(mailtoLink);
        const params = url.searchParams;
        const email = url.pathname;
        let newParams = '';
        if (!$3716a239e20d61f7$var$emailRegex.test(email)) // throw empty error for makeUrl to catch
        throw new Error();
        if (params.has('subject')) newParams += 'subject=' + encodeURIComponent(params.get('subject') || '');
        if (params.has('body')) {
            newParams += newParams ? '&body=' : 'body=';
            newParams += encodeURIComponent(params.get('body') || '');
        }
        return `${url.protocol}${email}` + (newParams ? '?' + newParams : '');
    } catch (error) {
        // throw empty error for makeUrl to catch
        throw new Error();
    }
};
function $3716a239e20d61f7$export$e98ca45c96b2aafe(urlString) {
    try {
        if (urlString.startsWith('mailto:')) return new URL($3716a239e20d61f7$var$filterMailtoParams(urlString));
        if (urlString.startsWith('tel:')) // For telephone links, we just return the URL as is
        return new URL(urlString);
        // Check if URL starts with a custom URL scheme (e.g., forge:\\, spotify:, etc.)
        const customURLSchemeRegex = /^[a-zA-Z]+:(\\\\)?/;
        if (customURLSchemeRegex.test(urlString)) return new URL(urlString);
        // We decode the URL string to handle cases where a malicious app might pass in a URL with encoded characters to bypass our egress checks
        const decodedUrlString = decodeURIComponent(urlString);
        const fullUrl = decodedUrlString.startsWith('/') ? `${(0, $2kGKp.getOrigin)()}${urlString}` : urlString;
        // Checks if `fullUrl` has a protocol(eg. http://, https://, etc), if not, add the `https://` protocol
        const protocolRegex = /^(.*?:\/\/)/;
        const urlWithProtocol = protocolRegex.test(fullUrl) ? fullUrl : `https://${fullUrl}`;
        // We use the URL constructor to validate the URL
        const url = new URL(urlWithProtocol);
        return url;
    } catch  {
        return undefined;
    }
}
module.exports["makeUrl"] = $3716a239e20d61f7$export$e98ca45c96b2aafe;

});

parcelRegister("9v4R2", function(module, exports) {
// domains from https://support.atlassian.com/organization-administration/docs/ip-addresses-and-domains-for-atlassian-cloud-products/
const $6946f2676d93d3f0$export$bbc6c05835b799fc = [
    'atl-paas.net',
    'atlassian.com',
    'atlassian.net',
    'ss-inf.net',
    'jira.com',
    'bitbucket.org',
    'atlassian-us-gov-mod.com',
    'atlassian-us-gov-mod.net'
];
module.exports["TRUSTED_ROOT_DOMAINS"] = $6946f2676d93d3f0$export$bbc6c05835b799fc;

});

parcelRegister("c5hPD", function(module, exports) {

var $gATpw = parcelRequire("gATpw");


var $1KHo7 = parcelRequire("1KHo7");


var $2P8JV = parcelRequire("2P8JV");


var $stVm3 = parcelRequire("stVm3");


var $cNucV = parcelRequire("cNucV");


var $czo2Z = parcelRequire("czo2Z");


var $jiT42 = parcelRequire("jiT42");


var $7aKg5 = parcelRequire("7aKg5");


var $8exqI = parcelRequire("8exqI");


var $12MPQ = parcelRequire("12MPQ");


var $1AOco = parcelRequire("1AOco");


var $5zfRA = parcelRequire("5zfRA");


var $88OoA = parcelRequire("88OoA");


var $3HEm4 = parcelRequire("3HEm4");


var $k2RCe = parcelRequire("k2RCe");


var $gcsWd = parcelRequire("gcsWd");


var $inOAE = parcelRequire("inOAE");


var $1hEK8 = parcelRequire("1hEK8");

const $b040040bbf689f3f$var$shouldShow = (option)=>{
    // if option is not defined, return false
    if (option === undefined) return false;
    return option;
};
const $b040040bbf689f3f$export$b956d067c5bcf6b = (builder, appearance, features)=>{
    const defaultFeatures = {
        blockType: true,
        textFormatting: true,
        list: true,
        insertBlock: true,
        textColor: true,
        hyperLink: true,
        quickInsert: true,
        codeBlock: true
    };
    // if `features` is not defined, set all options to true
    // if `features` is provided, only options that are set to true by the developer will render. This is so any new plugin additions made by us will not be rendered by default as the developer has intentionally only set certain options to appear
    const enabledPlugins = features ?? defaultFeatures;
    return builder.add((0, $2P8JV.basePlugin)).maybeAdd((0, $cNucV.blockTypePlugin), $b040040bbf689f3f$var$shouldShow(enabledPlugins?.blockType)) // allows for different text tags(paragraphs, heading levels) and quote blocks to be added
    .add((0, $stVm3.betterTypeHistoryPlugin)) // required for paste plugin
    .add([
        (0, $3HEm4.pastePlugin),
        {}
    ]) // allows links to be converted to hyper link on paste
    .add((0, $1hEK8.typeAheadPlugin)).maybeAdd((0, $k2RCe.quickInsertPlugin), $b040040bbf689f3f$var$shouldShow(enabledPlugins?.quickInsert)) // allows for `/` to insert nodes from a menu
    .maybeAdd((0, $inOAE.textFormattingPlugin), $b040040bbf689f3f$var$shouldShow(enabledPlugins?.textFormatting)).maybeAdd((0, $gcsWd.textColorPlugin), $b040040bbf689f3f$var$shouldShow(enabledPlugins?.textColor)).maybeAdd((0, $88OoA.listPlugin), $b040040bbf689f3f$var$shouldShow(enabledPlugins?.list)) // required for `-` to insert lists
    .maybeAdd([
        (0, $1KHo7.toolbarListsIndentationPlugin),
        {
            showIndentationButtons: false,
            allowHeadingAndParagraphIndentation: false
        }
    ], $b040040bbf689f3f$var$shouldShow(enabledPlugins?.list)).add((0, $7aKg5.copyButtonPlugin)) // required for floating toolbar plugins
    .add((0, $12MPQ.editorDisabledPlugin)) // required for floating toolbar and `disabled` prop
    .add((0, $8exqI.decorationsPlugin)) // required for floating toolbar
    .add((0, $1AOco.floatingToolbarPlugin)) // required for toolbar to appear under links
    .maybeAdd([
        (0, $gATpw.hyperlinkPlugin),
        {
            editorAppearance: appearance,
            lpLinkPicker: true
        }
    ], $b040040bbf689f3f$var$shouldShow(enabledPlugins?.hyperLink)).add((0, $jiT42.compositionPlugin)) // required for codeblock
    .maybeAdd([
        (0, $czo2Z.codeBlockPlugin),
        {}
    ], $b040040bbf689f3f$var$shouldShow(enabledPlugins?.codeBlock)).maybeAdd([
        (0, $5zfRA.insertBlockPlugin),
        {
            appearance: appearance
        }
    ], $b040040bbf689f3f$var$shouldShow(enabledPlugins?.insertBlock));
};
module.exports["createPreset"] = $b040040bbf689f3f$export$b956d067c5bcf6b;

});

parcelRegister("la0HD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");

const $8ae13ba37c42793b$var$featuresAreEqual = (_previousFeatures, _currentFeatures)=>{
    // If both are references point to the same object, return true
    if (_previousFeatures === _currentFeatures) return true;
    const previousFeatures = _previousFeatures || {};
    const currentFeatures = _currentFeatures || {};
    if (Object.keys(previousFeatures).length !== Object.keys(currentFeatures).length) return false;
    // if any properties has changed, return false
    for(const key in previousFeatures){
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(previousFeatures[key], currentFeatures[key])) return false;
    }
    return true;
};
const $8ae13ba37c42793b$export$67693d05a6051899 = (features)=>{
    const previousFeatures = (0, $42omo.useRef)();
    const shouldUpdate = !$8ae13ba37c42793b$var$featuresAreEqual(previousFeatures.current, features);
    if (shouldUpdate) previousFeatures.current = features;
    return previousFeatures.current;
};
module.exports["useMemoisedFeatures"] = $8ae13ba37c42793b$export$67693d05a6051899;

});

parcelRegister("lp6ii", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $8d90d7c7a35ed227$export$d55d1cb9c5e0f267 = (0, $eSUdr.default)`query app($id:ID!){app(id:$id){name}}`;
module.exports["GET_APP_NAME"] = $8d90d7c7a35ed227$export$d55d1cb9c5e0f267;

});

parcelRegister("7LZ4R", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");


const $4dadbd8988869e85$var$AKLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("dNhZD")).then((module)=>({
            default: module.Label
        })));
const $4dadbd8988869e85$export$b04be29aa201d4f5 = ({ isRequired: isRequired, label: label, name: name })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4dadbd8988869e85$var$AKLabel, {
        htmlFor: name,
        id: `${name}-label`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.025"
    }, label, isRequired && // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        as: "strong",
        color: "color.text.danger",
        size: "UNSAFE_small"
    }, "*")));
};
module.exports["Label"] = $4dadbd8988869e85$export$b04be29aa201d4f5;

});

parcelRegister("65XYT", function(module, exports) {

var $dh538 = parcelRequire("dh538");

// List of modules that should send performance metrics.
// Add new modules behind feature gate to monitor event volumes.
const $bb678f18ba43cf1b$var$allowlist = [
    // Jira Modules
    'jira:adminPage',
    'jira:customField',
    'jira:customFieldType',
    'jira:dashboardGadget',
    'jira:globalPage',
    'jira:issueAction',
    'jira:issueActivity',
    'jira:issueContext',
    'jira:issuePanel',
    'jira:projectPage',
    'jira:projectSettingsPage',
    // Confluence Modules
    'confluence:contentAction',
    'confluence:contentBylineItem',
    'confluence:globalPage',
    'confluence:globalSettings',
    'confluence:spacePage',
    'xen:macro'
];
const $bb678f18ba43cf1b$export$e6c1c2523bf4461 = ()=>{
    // Rolling out UIM in-frame perf capture.
    if ((0, $dh538.fg)('forge-ui-uim-perf-profiling-enabled')) return [
        ...$bb678f18ba43cf1b$var$allowlist,
        'jira:uiModifications'
    ];
    return $bb678f18ba43cf1b$var$allowlist;
};
module.exports["getEnabledModulesForPerformanceProfiling"] = $bb678f18ba43cf1b$export$e6c1c2523bf4461;

});

parcelRegister("c2Y0n", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $169953af4b6e4ccf$export$8da39d297b8df514 = (0, $gLLcz.z).object({
    event: (0, $gLLcz.z).literal('click')
}).strip();
const $169953af4b6e4ccf$export$1226cd123c17e5c1 = (0, $gLLcz.z).object({
    event: (0, $gLLcz.z).literal('navigation-timing'),
    transferSize: (0, $gLLcz.z).number().nonnegative().finite(),
    duration: (0, $gLLcz.z).number().nonnegative().finite()
}).strict();
const $169953af4b6e4ccf$var$initiatorTypeValues = (0, $gLLcz.z).enum([
    'script',
    'fetch',
    'css',
    'link',
    'iframe',
    'img',
    'image',
    'xmlhttprequest',
    'other'
]);
const $169953af4b6e4ccf$export$53d51f558d70545c = (0, $gLLcz.z).object({
    event: (0, $gLLcz.z).literal('resource-timing'),
    start: (0, $gLLcz.z).number().nonnegative().finite(),
    duration: (0, $gLLcz.z).number().nonnegative().finite(),
    transferSize: (0, $gLLcz.z).number().nonnegative().finite(),
    initiatorType: (0, $gLLcz.z).string().pipe($169953af4b6e4ccf$var$initiatorTypeValues.catch($169953af4b6e4ccf$var$initiatorTypeValues.Values.other)).pipe((0, $gLLcz.z).string())
}).strict();
const $169953af4b6e4ccf$export$dcaedcbfb2a9bf04 = (0, $gLLcz.z).object({
    event: (0, $gLLcz.z).literal('dcls-score'),
    score: (0, $gLLcz.z).number().nonnegative().finite(),
    timestamp: (0, $gLLcz.z).number().nonnegative().finite(),
    inputFlag: (0, $gLLcz.z).boolean()
}).strict();
const $169953af4b6e4ccf$export$ea631521a752c0a8 = (0, $gLLcz.z).object({
    event: (0, $gLLcz.z).literal('fcp-snapshot'),
    start: (0, $gLLcz.z).number().nonnegative().finite()
}).strict();
const $169953af4b6e4ccf$export$23e438485c66108 = (0, $gLLcz.z).object({
    event: (0, $gLLcz.z).literal('lcp-snapshot'),
    size: (0, $gLLcz.z).number().nonnegative().finite(),
    start: (0, $gLLcz.z).number().nonnegative().finite()
}).strict();
const $169953af4b6e4ccf$export$d659b0ed364a2533 = (0, $gLLcz.z).discriminatedUnion('event', [
    $169953af4b6e4ccf$export$8da39d297b8df514,
    $169953af4b6e4ccf$export$1226cd123c17e5c1,
    $169953af4b6e4ccf$export$53d51f558d70545c,
    $169953af4b6e4ccf$export$dcaedcbfb2a9bf04,
    $169953af4b6e4ccf$export$ea631521a752c0a8,
    $169953af4b6e4ccf$export$23e438485c66108
]);
module.exports["ClickedProfilingEventSchema"] = $169953af4b6e4ccf$export$8da39d297b8df514;
module.exports["NavigationTimingProfilingEventSchema"] = $169953af4b6e4ccf$export$1226cd123c17e5c1;
module.exports["ResourceTimingProfilingEventSchema"] = $169953af4b6e4ccf$export$53d51f558d70545c;
module.exports["LayoutShiftProfilingEventSchema"] = $169953af4b6e4ccf$export$dcaedcbfb2a9bf04;
module.exports["FCPProfilingEventSchema"] = $169953af4b6e4ccf$export$ea631521a752c0a8;
module.exports["LCPProfilingEventSchema"] = $169953af4b6e4ccf$export$23e438485c66108;
module.exports["AppFrameProfilingEventSchema"] = $169953af4b6e4ccf$export$d659b0ed364a2533;

});

parcelRegister("9zb43", function(module, exports) {

module.exports = (parcelRequire("1BqC1"));

});

parcelRegister("dWSaf", function(module, exports) {

var $7TH2w = parcelRequire("7TH2w");


var $7KMPr = parcelRequire("7KMPr");


var $kxKUs = parcelRequire("kxKUs");


var $fSMLG = parcelRequire("fSMLG");


var $3Spjc = parcelRequire("3Spjc");


var $6oQb1 = parcelRequire("6oQb1");


var $dh538 = parcelRequire("dh538");


var $ly9ul = parcelRequire("ly9ul");

const $053a3977db87c15f$var$prepareBridgeEventAttributes = (bridgeMethod, payload, isSucceed)=>{
    if (bridgeMethod === 'submit' && isSucceed) {
        const payloadFields = Array.from(Object.entries(payload?.data ?? {})).filter(([, value])=>value).map(([key])=>key);
        return {
            payloadFields: payloadFields
        };
    }
    if ((0, $dh538.fg)('forge-ui-navigation')) {
        if (bridgeMethod === 'navigate') {
            const { target: target, url: url, type: type } = payload?.data ?? {};
            const navigationContext = {
                target: 'trusted',
                type: type
            };
            if (url && typeof url === 'string') try {
                if ([
                    'https:',
                    'http:'
                ].includes(new URL(url).protocol)) navigationContext.target = 'external';
            } catch (e) {}
            else if (target && typeof target === 'string') navigationContext.target = target;
            return navigationContext;
        }
    }
    if ((0, $dh538.fg)('platform_forge_ui_open_rovo_bridge')) {
        if (bridgeMethod === 'openRovo' && isSucceed) {
            const { agentName: agentName, agentKey: agentKey, agentAppId: agentAppId } = payload?.data ?? {};
            const agentDetails = {
                agentName: agentName,
                agentKey: agentKey,
                agentAppId: agentAppId,
                isForgeAgent: false
            };
            if (agentName && agentKey && agentAppId) agentDetails.isForgeAgent = true;
            return agentDetails;
        }
    }
    return {};
};
const $053a3977db87c15f$var$wrapFeatureWithMetricsAndAnalytics = ({ feature: feature, createAnalyticsEvent: createAnalyticsEvent, page: page, bridgeMethod: bridgeMethod, environment: environment, forgeEnvironment: forgeEnvironment, errorExtensionDetails: errorExtensionDetails, tracing: tracing })=>async (payload)=>{
        try {
            tracing?.recordBridgeCall(`${bridgeMethod}() - start`);
            const result = await feature(payload);
            tracing?.recordBridgeCall(`${bridgeMethod}() - end`);
            if (bridgeMethod === 'on') createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'subscribed',
                    actionSubject: 'bridgeEvent',
                    attributes: {
                        // TODO: remove the condition (and related test) once Developer UGC spec is ready
                        event: payload.data.event === 'JIRA_ISSUE_CHANGED' ? 'JIRA_ISSUE_CHANGED' : 'other'
                    },
                    source: page,
                    tags: [
                        'forge'
                    ]
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
            // this replaces the BRIDGE_REQUEST_RECEIVED metal client event
            (0, $6oQb1.trackBridgeSucceed)(createAnalyticsEvent, {
                source: page,
                method: bridgeMethod,
                forgeEnvironment: forgeEnvironment,
                additionalAttributes: $053a3977db87c15f$var$prepareBridgeEventAttributes(bridgeMethod, payload, true)
            });
            return result;
        } catch (err) {
            const error = err instanceof Error ? err : new Error(`Unknown Custom UI Bridge error: ${typeof err}`);
            if (!(error instanceof (0, $kxKUs.BridgeClientError))) {
                if (!(0, $fSMLG.blocklistedErrorMessagePatterns).some((pattern)=>pattern.test(error.message))) {
                    (0, $6oQb1.trackBridgeFailed)(createAnalyticsEvent, {
                        source: page,
                        errorName: error.name,
                        method: bridgeMethod,
                        forgeEnvironment: forgeEnvironment,
                        additionalAttributes: {
                            ...$053a3977db87c15f$var$prepareBridgeEventAttributes(bridgeMethod, payload, false),
                            reason: error.message,
                            isUnrecoverable: (0, $ly9ul.isUnrecoverableError)(error)
                        }
                    });
                    (0, $7KMPr.captureAndReportError)({
                        error: error,
                        environment: environment,
                        errorExtensionDetails: errorExtensionDetails,
                        page: page,
                        tracing: tracing
                    });
                }
            }
            throw err;
        }
    };
const $053a3977db87c15f$export$68a362b9cb2811d7 = ({ features: features, createAnalyticsEvent: createAnalyticsEvent, page: page, environment: environment, forgeEnvironment: forgeEnvironment, errorExtensionDetails: errorExtensionDetails, tracing: tracing })=>Object.entries(features).reduce((acc, [key, feature])=>({
            ...acc,
            [key]: $053a3977db87c15f$var$wrapFeatureWithMetricsAndAnalytics({
                feature: feature,
                createAnalyticsEvent: createAnalyticsEvent,
                page: page,
                bridgeMethod: key,
                environment: environment,
                forgeEnvironment: forgeEnvironment,
                errorExtensionDetails: errorExtensionDetails,
                tracing: tracing
            })
        }), {});
module.exports["withMetricsAndAnalytics"] = $053a3977db87c15f$export$68a362b9cb2811d7;

});

parcelRegister("4c2yb", function(module, exports) {
function $3a24103e0164297d$export$32da5b5043dcd88c() {
    window.location.reload();
}
module.exports["reload"] = $3a24103e0164297d$export$32da5b5043dcd88c;

});

parcelRegister("b4nol", function(module, exports) {
var $32cb6d3cd1e17c5c$export$d0163c7b07301739 = /*#__PURE__*/ function(FeatureFlagEnv) {
    FeatureFlagEnv["development"] = "development";
    FeatureFlagEnv["staging"] = "staging";
    FeatureFlagEnv["production"] = "production";
    return FeatureFlagEnv;
}({});
var $32cb6d3cd1e17c5c$export$35879154c49e2b67 = /*#__PURE__*/ function(FeatureFlagEventTypes) {
    FeatureFlagEventTypes["INITIALIZATION"] = "initialization";
    FeatureFlagEventTypes["CHECKFLAG"] = "checkFlag";
    return FeatureFlagEventTypes;
}({});
module.exports["FeatureFlagEnv"] = $32cb6d3cd1e17c5c$export$d0163c7b07301739;
module.exports["FeatureFlagEventTypes"] = $32cb6d3cd1e17c5c$export$35879154c49e2b67;

});

parcelRegister("cMiG0", function(module, exports) {

var $faCvF = parcelRequire("faCvF");


var $6usda = parcelRequire("6usda");


var $6wbTo = parcelRequire("6wbTo");


var $j4W8T = parcelRequire("j4W8T");

const $bd08d1f86405f93a$var$extensionURLHelpers = {
    ...(0, $faCvF.confluenceExtensionURLHelpers),
    ...(0, $6wbTo.jiraExtensionURLHelpers)
};
const $bd08d1f86405f93a$var$navigationTargetHandlers = {
    ...(0, $6wbTo.jiraNavigationTargetHandlers),
    ...(0, $faCvF.confluenceNavigationTargetURLHelpers),
    userProfile: async ({ accountId: accountId })=>(0, $j4W8T.ensureURLPath)(`/people/${accountId}`),
    module: async ({ moduleKey: moduleKey, ...params }, { getAppForgeUIExtensions: getAppForgeUIExtensions })=>{
        if (!moduleKey) throw (0, $6usda.NavigationError).MissingProperty('moduleKey');
        const module = await (0, $6usda.getModuleByKey)(getAppForgeUIExtensions, moduleKey);
        if (!module || !module.appId || !module.environmentId) throw (0, $6usda.NavigationError).ModuleNotFound(moduleKey);
        const moduleUrlHelper = $bd08d1f86405f93a$var$extensionURLHelpers[module.type];
        if (!moduleUrlHelper) throw (0, $6usda.NavigationError).NotSupportedExtensionType(module.type);
        return moduleUrlHelper(module, params);
    }
};
const $bd08d1f86405f93a$export$6aa8556afece32b2 = async (targetInfo, utils)=>{
    const { target: target, ...payload } = targetInfo;
    const handler = $bd08d1f86405f93a$var$navigationTargetHandlers[target];
    if (!handler) return null;
    try {
        const path = await handler(payload, utils);
        return path;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e.message);
        return null;
    }
};
module.exports["createNavigateTargetPath"] = $bd08d1f86405f93a$export$6aa8556afece32b2;

});

parcelRegister("1JDPF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fYGGr = parcelRequire("fYGGr");


var $grQpA = parcelRequire("grQpA");


var $a4TK8 = parcelRequire("a4TK8");


var $dh538 = parcelRequire("dh538");

const $a32dcdb2dcf56aee$var$useCustomCompareMemo = (factory, dependency, isEqual)=>{
    const dependencyRef = (0, $42omo.useRef)(dependency);
    const valueRef = (0, $42omo.useRef)(factory());
    if (!isEqual(dependency, dependencyRef.current)) {
        dependencyRef.current = dependency;
        valueRef.current = factory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $42omo.useMemo)(()=>valueRef.current, [
        dependencyRef.current
    ]);
};
const $a32dcdb2dcf56aee$var$isSameDeps = (a, b)=>{
    if (a === b) return true;
    if (!a || !b) return false;
    const [clientA, appIdA, environmentIdA, contextIdsA] = a;
    const [clientB, appIdB, environmentIdB, contextIdsB] = b;
    return clientA === clientB && appIdA === appIdB && environmentIdA === environmentIdB && (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(contextIdsA.sort(), contextIdsB.sort());
};
const $a32dcdb2dcf56aee$export$eafa2a08bf8a8e04 = ({ client: client, appId: appId, environmentId: environmentId, contextIds: contextIds, cloudId: cloudId, includeHidden: includeHidden, moduleType: moduleType, bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall })=>{
    return $a32dcdb2dcf56aee$var$useCustomCompareMemo(()=>{
        return async (params)=>{
            return await (0, $fYGGr.getForgeUIExtensionsAsync)({
                client: client,
                contextIds: contextIds,
                extensionsFilter: [
                    {
                        type: (0, $grQpA.GQLExtensionContextsFilterType).AppIdEnvironmentId,
                        value: `${appId}:${environmentId}`
                    }
                ],
                ...params,
                cloudId: cloudId,
                includeHidden: includeHidden,
                moduleType: moduleType,
                bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall
            });
        };
    }, [
        client,
        appId,
        environmentId,
        contextIds
    ], $a32dcdb2dcf56aee$var$isSameDeps);
};
const $a32dcdb2dcf56aee$export$10dcd63d9a8843c4 = (params)=>{
    const getAppForgeUIExtensions = $a32dcdb2dcf56aee$export$eafa2a08bf8a8e04(params);
    return (0, $dh538.fg)('forge-ui-navigation') ? getAppForgeUIExtensions : null;
};
module.exports["useGetAppForgeUIExtensions"] = $a32dcdb2dcf56aee$export$10dcd63d9a8843c4;

});

parcelRegister("a2ksR", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $30bfa984f438bcb7$var$GET_BASE_URL = (0, $eSUdr.default)`query tenant_user_query($cloudIds:[ID!]){tenantContexts(cloudIds:$cloudIds){cloudUrl}}`;
// Storing baseUrl in memory here so that it can be reused across all extension points for all apps.
// Only called once per session or full page reload
let $30bfa984f438bcb7$var$storedBaseUrl = '';
const $30bfa984f438bcb7$export$f654b28f82155665 = async (client, cloudId)=>{
    if ($30bfa984f438bcb7$var$storedBaseUrl) return $30bfa984f438bcb7$var$storedBaseUrl;
    if (cloudId) {
        const response = await client.query({
            query: $30bfa984f438bcb7$var$GET_BASE_URL,
            variables: {
                cloudIds: cloudId
            }
        });
        const baseUrl = response.data?.tenantContexts?.[0].cloudUrl;
        $30bfa984f438bcb7$var$storedBaseUrl = baseUrl;
        return baseUrl;
    }
    return null;
};
module.exports["getBaseUrl"] = $30bfa984f438bcb7$export$f654b28f82155665;

});

parcelRegister("2gNWY", function(module, exports) {

var $9v4R2 = parcelRequire("9v4R2");

const $3722eb8dac50bf58$export$97f4c254b641e719 = (hostname)=>{
    return ![
        ...(0, $9v4R2.TRUSTED_ROOT_DOMAINS),
        'localhost',
        'jira-dev.com'
    ].some((trustedDomain)=>hostname.includes(trustedDomain));
};
module.exports["isCustomDomain"] = $3722eb8dac50bf58$export$97f4c254b641e719;

});

parcelRegister("ly9ul", function(module, exports) {
const $b9631ed1ce649aaf$var$messages = [
    'Window closed for',
    'Window did not load after'
];
const $b9631ed1ce649aaf$export$fab3177d2bcbd98a = (error)=>error instanceof Error && $b9631ed1ce649aaf$var$messages.some((message)=>error.message.startsWith(message));
module.exports["isUnrecoverableError"] = $b9631ed1ce649aaf$export$fab3177d2bcbd98a;

});

parcelRegister("buzAL", function(module, exports) {
/* usePermission.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $kxKUs = parcelRequire("kxKUs");


var $fJCAk = parcelRequire("fJCAk");


var $dh538 = parcelRequire("dh538");


var $20GoR = parcelRequire("20GoR");


var $4LgCj = parcelRequire("4LgCj");


var $dhMrf = parcelRequire("dhMrf");

const $5ea234701956fa1d$export$9d631cbf20f994be = [
    'egressSet',
    'egressGet',
    'egressDeleteDomain',
    'egressDeleteGroup',
    'remoteGet',
    'remoteSet'
];
const $5ea234701956fa1d$export$e6656e96c25a61f6 = '__permission__';
const $5ea234701956fa1d$export$6adf362786c5a28e = (apiRef)=>({
        __permission__egressSet: async ({ data: data })=>{
            return apiRef.current.__permission__egressSet?.(data);
        },
        __permission__egressGet: async ({ data: data })=>{
            return apiRef.current.__permission__egressGet?.(data);
        },
        __permission__egressDeleteDomain: async ({ data: data })=>{
            return apiRef.current.__permission__egressDeleteDomain?.(data);
        },
        __permission__egressDeleteGroup: async ({ data: data })=>{
            return apiRef.current.__permission__egressDeleteGroup?.(data);
        },
        __permission__remoteGet: async ({ data: data })=>{
            return apiRef.current.__permission__remoteGet?.(data);
        },
        __permission__remoteSet: async ({ data: data })=>{
            return apiRef.current.__permission__remoteSet?.(data);
        }
    });
const $5ea234701956fa1d$export$dc21730956491a4c = (bridge)=>Object.fromEntries($5ea234701956fa1d$export$9d631cbf20f994be.map((method)=>[
            `${$5ea234701956fa1d$export$e6656e96c25a61f6}${method}`,
            (0, $4LgCj.createBridgeMethod)(bridge?.[`${$5ea234701956fa1d$export$e6656e96c25a61f6}${method}`])
        ]));
function $5ea234701956fa1d$export$d7376454a3cf5ab4({ appId: appId, installationId: installationId, contextIds: contextIds, extensionId: extensionId, options: options, renderThreeLOPrompt: renderThreeLOPrompt }) {
    const [modalState, setModalState] = (0, $42omo.useState)({
        state: 'closed'
    });
    const permissionFetchClient = (0, $20GoR.usePermissionFetchClient)({
        appId: appId,
        installationId: installationId,
        contextIds: contextIds,
        extensionId: extensionId,
        options: options,
        renderThreeLOPrompt: renderThreeLOPrompt
    });
    if (!options?.client) throw new (0, $kxKUs.BridgeClientError)(`GraphQL client has not been initialized`);
    const queryForgeApp = (0, $dhMrf.useForgeAppQuery)({
        client: options.client
    });
    const getAllCurrentEgress = async ()=>{
        const getEgress = await permissionFetchClient.egressGet({});
        return await getEgress.json();
    };
    const shouldDisplayModalForEgress = async (payload)=>{
        const allCurrentEgressResp = await getAllCurrentEgress();
        const currentDomainMap = (allCurrentEgressResp?.results ?? []).reduce((acc, result)=>{
            result.configured.forEach((d)=>acc[d.domain] = true);
            return acc;
        }, {});
        const domains = payload.egresses.reduce((acc, group)=>{
            const urls = group.configured.map((c)=>c.domain);
            acc.push(...urls);
            return acc;
        }, []);
        return domains.some((d)=>!currentDomainMap[d]);
    };
    const fetchAppData = async (id)=>{
        try {
            return await queryForgeApp(id);
        } catch (e) {
            if (e instanceof Error) {
                const error = new (0, $kxKUs.BridgeClientError)(e.message);
                error.stack = e.stack;
                throw error;
            }
            throw new (0, $kxKUs.BridgeClientError)(typeof e === 'string' ? e : String(e));
        }
    };
    return {
        shouldDisplayModalForEgress: shouldDisplayModalForEgress,
        getModalJsx: ()=>(0, $dh538.fg)('configurable-egress-mvp-frontend') ? /*#__PURE__*/ $42omo.createElement((0, $fJCAk.AdminModal), {
                modalState: modalState
            }) : null,
        egressSet: async (payload)=>{
            if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
            const app = await fetchAppData(appId);
            const response = await permissionFetchClient.egressSet(payload, true);
            if (!response.ok) throw new (0, $kxKUs.BridgeClientError)('Dry run failed');
            try {
                const shouldDisplay = await shouldDisplayModalForEgress(payload);
                if (shouldDisplay) return new Promise((resolve, reject)=>{
                    setModalState({
                        state: 'open',
                        onCancel: ()=>{
                            setModalState({
                                state: 'closed'
                            });
                            reject('Setting egress was rejected by admin');
                        },
                        onConfirm: async ()=>{
                            try {
                                const setEgressResp = await permissionFetchClient.egressSet(payload, false);
                                const json = await setEgressResp.json();
                                if (!setEgressResp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
                                setModalState({
                                    state: 'closed'
                                });
                                resolve(json);
                            } catch (err) {
                                reject(err);
                            }
                        },
                        domainInfo: {
                            type: 'EGRESS',
                            payload: payload
                        },
                        appName: app.name,
                        termsOfUseLink: app.termsOfService,
                        privacyPolicyLink: app.privacyPolicy
                    });
                });
                else {
                    const setEgressResp = await permissionFetchClient.egressSet(payload, false);
                    const json = await setEgressResp.json();
                    if (!setEgressResp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
                    return json;
                }
            } catch (err) {
                throw new (0, $kxKUs.BridgeClientError)(`Could not set egress due to ${err}`);
            }
        },
        egressGet: async (payload)=>{
            if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
            try {
                const getEgressResp = await permissionFetchClient.egressGet(payload);
                const json = await getEgressResp.json();
                if (!getEgressResp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
                return json;
            } catch (err) {
                throw new (0, $kxKUs.BridgeClientError)(`Could not get egress due to: ${err}`);
            }
        },
        egressDeleteDomain: async (payload)=>{
            if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
            try {
                const egressDeleteDomainResp = await permissionFetchClient.egressDeleteDomain(payload);
                const json = await egressDeleteDomainResp.json();
                if (!egressDeleteDomainResp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
                return json;
            } catch (err) {
                throw new (0, $kxKUs.BridgeClientError)(`Could not delete egress domain due to ${err}`);
            }
        },
        egressDeleteGroup: async (payload)=>{
            if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
            try {
                const egressDeleteGroupResp = await permissionFetchClient.egressDeleteGroup(payload);
                const json = await egressDeleteGroupResp.json();
                if (!egressDeleteGroupResp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
                return json;
            } catch (err) {
                throw new (0, $kxKUs.BridgeClientError)(`Could not delete egress group due to ${err}`);
            }
        },
        remoteGet: async (payload)=>{
            if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
            try {
                const remoteGetResp = await permissionFetchClient.remoteGet(payload);
                const json = await remoteGetResp.json();
                if (!remoteGetResp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
                return json;
            } catch (err) {
                throw new (0, $kxKUs.BridgeClientError)(`Could not get remote due to: ${err}`);
            }
        },
        remoteSet: async (payload)=>{
            if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
            const app = await fetchAppData(appId);
            const response = await permissionFetchClient.remoteSet(payload, true);
            if (!response.ok) throw new (0, $kxKUs.BridgeClientError)('Dry run failed');
            return new Promise((resolve, reject)=>{
                setModalState({
                    state: 'open',
                    onCancel: ()=>{
                        setModalState({
                            state: 'closed'
                        });
                        reject(new (0, $kxKUs.BridgeClientError)('Setting remote was rejected by admin'));
                    },
                    onConfirm: async ()=>{
                        try {
                            const remoteSetResp = await permissionFetchClient.remoteSet(payload, false);
                            if (!remoteSetResp.ok) throw new (0, $kxKUs.BridgeClientError)(remoteSetResp.statusText);
                            setModalState({
                                state: 'closed'
                            });
                            resolve();
                        } catch (err) {
                            reject(new (0, $kxKUs.BridgeClientError)(`API call was rejected with the following error: ${err}`));
                        }
                    },
                    domainInfo: {
                        type: 'REMOTE',
                        payload: payload
                    },
                    appName: app.name,
                    termsOfUseLink: app.termsOfService,
                    privacyPolicyLink: app.privacyPolicy
                });
            });
        }
    };
}
module.exports["permissionMethods"] = $5ea234701956fa1d$export$9d631cbf20f994be;
module.exports["PERMISSION_METHOD_PREFIX"] = $5ea234701956fa1d$export$e6656e96c25a61f6;
module.exports["getUseBridgePermissionFunctions"] = $5ea234701956fa1d$export$6adf362786c5a28e;
module.exports["getCreateBridgeApiPermissionFunctions"] = $5ea234701956fa1d$export$dc21730956491a4c;
module.exports["usePermission"] = $5ea234701956fa1d$export$d7376454a3cf5ab4;

});

parcelRegister("fSMLG", function(module, exports) {
const $796443ed50933d56$export$5458688a52e32026 = [
    // Error in user code
    /^There was an error invoking the function/,
    // User code returned non-JSON value, so XIS threw an InvalidInvocationPayloadError.
    /^Invalid response body, data must be JSON or undefined$/,
    // Networking errors
    /^Failed to fetch$/,
    /^Network error: Failed to fetch$/,
    /^Network error: Network failure: TypeError: Failed to fetch$/,
    /^NetworkError when attempting to fetch resource.$/,
    /^Network error: Received status 504$/,
    /^GraphQL error: The underlying service call timed out$/,
    // Unauthenticated requests made from public confluence content
    /^GraphQL error: Auth category: UNAUTHENTICATED is not allowed in service xen_invocation_service$/
];
module.exports["blocklistedErrorMessagePatterns"] = $796443ed50933d56$export$5458688a52e32026;

});

parcelRegister("faCvF", function(module, exports) {

var $1c598 = parcelRequire("1c598");


var $j4W8T = parcelRequire("j4W8T");


var $6usda = parcelRequire("6usda");

const $04ed449cb34fa9a4$var$makeConfluenceURLPath = (0, $j4W8T.createMakeProductURLPath)('/wiki');
const $04ed449cb34fa9a4$var$isCustomContentType = (contentType)=>contentType.startsWith('forge:');
const $04ed449cb34fa9a4$export$68f051c1b56c060f = {
    [(0, $1c598.ConfluenceExtension).GLOBAL_PAGE]: ({ properties: properties, environmentId: environmentId, appId: appId })=>{
        const { route: route } = properties;
        if (appId && environmentId && route) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/apps/${appId}/${environmentId}/${route}`);
        return null;
    },
    [(0, $1c598.ConfluenceExtension).GLOBAL_SETTINGS]: ({ id: id })=>$04ed449cb34fa9a4$var$makeConfluenceURLPath('/admin/forge', {
            id: id
        }),
    [(0, $1c598.ConfluenceExtension).SPACE_PAGE]: ({ properties: properties, environmentId: environmentId, appId: appId }, { spaceKey: spaceKey })=>{
        const { route: route } = properties;
        if (route && environmentId && appId) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/spaces/${(0, $6usda.ensurePropertyExists)('spaceKey', spaceKey)}/apps/${appId}/${environmentId}/${route}`);
        return null;
    },
    [(0, $1c598.ConfluenceExtension).SPACE_SETTINGS]: ({ properties: properties, appId: appId, environmentId: environmentId }, { spaceKey: spaceKey })=>{
        const { route: route } = properties;
        if (!spaceKey) throw (0, $6usda.NavigationError).MissingProperty('spaceKey');
        if (route && environmentId && appId) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/spaces/${(0, $6usda.ensurePropertyExists)('spaceKey', spaceKey)}/settings/apps/${appId}/${environmentId}/${route}`);
        return null;
    }
};
const $04ed449cb34fa9a4$export$f91bdc214ca5389d = {
    contentView: async ({ contentId: contentId, version: version })=>{
        if (!contentId) throw (0, $6usda.NavigationError).MissingProperty('contentId');
        let resp = null;
        try {
            resp = await fetch(`/wiki/rest/api/content/${contentId}`);
        } catch (e) {
            throw (0, $6usda.NavigationError).FailedToFetchContentInfo(contentId);
        }
        const { id: id, type: type, _links: { webui: webui } } = await resp.json();
        // if version is provided, we should use it, however, it only works for none-custom content type
        if (version && version >= 0) {
            if ($04ed449cb34fa9a4$var$isCustomContentType(type)) throw new Error('Version is not supported for custom content type');
            return $04ed449cb34fa9a4$var$makeConfluenceURLPath('/pages/viewpage.action', {
                pageId: id,
                pageVersion: `${version}`
            });
        } else if (webui) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(webui);
        throw (0, $6usda.NavigationError).LinkForContentNotFound(contentId);
    },
    contentEdit: async ({ contentId: contentId })=>{
        let resp;
        try {
            resp = await fetch(`/wiki/rest/api/content/${contentId}`);
        } catch (e) {
            throw (0, $6usda.NavigationError).FailedToFetchContentInfo(contentId);
        }
        const { _links: { edituiv2: edituiv2 } } = await resp.json();
        // content with custom content type doesn't have edit link
        if (edituiv2) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(edituiv2);
        throw (0, $6usda.NavigationError).LinkForContentNotFound(contentId);
    },
    spaceView: async ({ spaceKey: spaceKey })=>{
        return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/spaces/${(0, $6usda.ensurePropertyExists)('spaceKey', spaceKey)}`);
    },
    contentList: async (params, { getAppForgeUIExtensions: getAppForgeUIExtensions })=>{
        const { contentType: contentType } = params;
        if (!contentType) throw (0, $6usda.NavigationError).MissingProperty('contentType');
        if (contentType === 'customContent' && params.moduleKey) {
            const { moduleKey: moduleKey } = params;
            const module = await (0, $6usda.getModuleByKey)(getAppForgeUIExtensions, moduleKey);
            if (!module) throw (0, $6usda.NavigationError).ModuleNotFound(moduleKey);
            const { appId: appId, environmentId: environmentId } = module;
            if (appId && environmentId) return $04ed449cb34fa9a4$var$makeConfluenceURLPath('/search', {
                type: `forge:${appId}:${environmentId}:${moduleKey}`
            });
        } else if (contentType === 'page' && params.spaceKey) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/spaces/${params.spaceKey}/pages`);
        else if (contentType === 'blogpost' && params.spaceKey) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/spaces/${params.spaceKey}/blogs`);
        throw (0, $6usda.NavigationError).InvalidValueForProperty('contentType', contentType);
    }
};
module.exports["confluenceExtensionURLHelpers"] = $04ed449cb34fa9a4$export$68f051c1b56c060f;
module.exports["confluenceNavigationTargetURLHelpers"] = $04ed449cb34fa9a4$export$f91bdc214ca5389d;

});

parcelRegister("6usda", function(module, exports) {
const $9406182ad5621a53$export$c1f2bec49c0b084d = async (getAppForgeUIExtensions, moduleKey)=>{
    const { extensions: extensions } = await getAppForgeUIExtensions({
        expandAppOwner: false
    });
    const module = extensions?.find(({ key: key })=>key === moduleKey);
    return module?.type ? module : null;
};
const $9406182ad5621a53$export$c53ed1333d39ada3 = {
    ModuleNotFound: (moduleKey)=>{
        return new Error(`Navigation failed: Module with moduleKey ${moduleKey} was not found`);
    },
    MissingProperty: (property)=>{
        return new Error(`Navigation failed: ${property} not provided`);
    },
    FailedToFetchContentInfo: (contentId)=>{
        return new Error(`Navigation failed: Failed to fetch content information with id ${contentId}. Please check if the ID provided is correct`);
    },
    NotSupportedExtensionType: (moduleType)=>{
        return new Error(`Navigation failed: Module type ${moduleType} is not supported`);
    },
    InvalidValueForProperty: (property, value)=>{
        return new Error(`Navigation failed: ${value} is not a valid value for ${property}`);
    },
    LinkForContentNotFound: (contentId)=>{
        return new Error(`Navigation failed: Link for content with id ${contentId} was not found`);
    }
};
const $9406182ad5621a53$export$ae701e18d3b38cae = (propertyName, propertyValue)=>{
    if (propertyValue === undefined || propertyValue === null) throw $9406182ad5621a53$export$c53ed1333d39ada3.MissingProperty(propertyName);
    return propertyValue;
};
module.exports["getModuleByKey"] = $9406182ad5621a53$export$c1f2bec49c0b084d;
module.exports["NavigationError"] = $9406182ad5621a53$export$c53ed1333d39ada3;
module.exports["ensurePropertyExists"] = $9406182ad5621a53$export$ae701e18d3b38cae;

});

parcelRegister("6wbTo", function(module, exports) {

var $1c598 = parcelRequire("1c598");


var $j4W8T = parcelRequire("j4W8T");


var $6usda = parcelRequire("6usda");

const $d3b8e1134d73790d$var$makeJiraURLPath = (0, $j4W8T.createMakeProductURLPath)('/jira');
const $d3b8e1134d73790d$export$47842863b73e9046 = {
    [(0, $1c598.JiraExtension).ADMIN_PAGE]: ({ appId: appId, environmentId: environmentId, properties: properties })=>{
        const { useAsGetStarted: useAsGetStarted, useAsConfig: useAsConfig } = properties;
        if (useAsGetStarted) return $d3b8e1134d73790d$var$makeJiraURLPath(`/settings/apps/get-started/${appId}/${environmentId}`);
        if (useAsConfig) return $d3b8e1134d73790d$var$makeJiraURLPath(`/settings/apps/configure/${appId}/${environmentId}`);
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/settings/apps/${appId}/${environmentId}`);
    },
    [(0, $1c598.JiraExtension).GLOBAL_PAGE]: ({ appId: appId, environmentId: environmentId })=>{
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/apps/${appId}/${environmentId}`);
    },
    [(0, $1c598.JiraExtension).PERSONAL_SETTINGS_PAGE]: ({ appId: appId, environmentId: environmentId })=>{
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/settings/personal/apps/${appId}/${environmentId}`);
    },
    [(0, $1c598.JiraExtension).PROJECT_SETTINGS_PAGE]: ({ appId: appId, environmentId: environmentId }, { projectKey: projectKey })=>{
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/software/projects/${(0, $6usda.ensurePropertyExists)('projectKey', projectKey).toUpperCase()}/settings/apps/${appId}/${environmentId}`);
    },
    [(0, $1c598.JiraExtension).PROJECT_PAGE]: ({ appId: appId, environmentId: environmentId }, { projectKey: projectKey })=>{
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/software/projects/${(0, $6usda.ensurePropertyExists)('projectKey', projectKey).toUpperCase()}/apps/${appId}/${environmentId}`);
    }
};
const $d3b8e1134d73790d$export$ca7043166c283e6d = {
    dashboard: async ({ dashboardId: dashboardId })=>{
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/dashboards/${(0, $6usda.ensurePropertyExists)('dashboardId', dashboardId)}`);
    },
    issue: async ({ issueKey: issueKey })=>{
        return `/browse/${(0, $6usda.ensurePropertyExists)('issueKey', issueKey)}`;
    },
    // equivalent to Connects projectAdminSummary target
    projectSettingsDetails: async ({ projectKey: projectKey })=>{
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/software/projects/${(0, $6usda.ensurePropertyExists)('projectKey', projectKey).toUpperCase()}/settings/details`);
    }
};
module.exports["jiraExtensionURLHelpers"] = $d3b8e1134d73790d$export$47842863b73e9046;
module.exports["jiraNavigationTargetHandlers"] = $d3b8e1134d73790d$export$ca7043166c283e6d;

});

parcelRegister("j4W8T", function(module, exports) {
// Ensures that the path structured correctly and adds provided parameters to the path
const $ae891dc783a5dbcf$export$26e2379e0018d084 = (path, parameters)=>{
    let encodedPath = (path ?? '').split('/').map(encodeURIComponent).join('/');
    if (parameters && Object.keys(parameters).length > 0) encodedPath += '?' + new URLSearchParams(parameters).toString();
    return encodedPath;
};
const $ae891dc783a5dbcf$export$ab31bc7dd6e328ce = (productPathPrefix)=>(path, parameters)=>{
        return $ae891dc783a5dbcf$export$26e2379e0018d084(path ? productPathPrefix + path : productPathPrefix, parameters);
    };
module.exports["ensureURLPath"] = $ae891dc783a5dbcf$export$26e2379e0018d084;
module.exports["createMakeProductURLPath"] = $ae891dc783a5dbcf$export$ab31bc7dd6e328ce;

});

parcelRegister("fJCAk", function(module, exports) {
/* AdminConsentModal.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/i18n/no-literal-string-in-jsx */ 
var $42omo = parcelRequire("42omo");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $ccHMk = parcelRequire("ccHMk");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");


var $cO1el = parcelRequire("cO1el");


var $2Nwuj = parcelRequire("2Nwuj");

const $f58f5052b341dbb2$var$styles = {
    titleContainer: "_otyrxy5q",
    modalFooterContainer: "_15a5nqa1 _uwhke4h9 _1i531l7x",
    disclaimerContainer: "_19pkxy5q _otyrxy5q",
    rowContainer: "_ca0qu2gc _n3tdu2gc _u5f3u2gc _19bvu2gc _1il9nqa1 _1doce4h9 _1o3i1l7x"
};
const $f58f5052b341dbb2$export$24cbef36aabf5e56 = ({ modalState: modalState })=>{
    if (modalState.state === 'closed') return /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null);
    const ModalFooter = ()=>{
        return /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
            xcss: $f58f5052b341dbb2$var$styles.modalFooterContainer
        }, /*#__PURE__*/ $42omo.createElement((0, $8o1lj.default), null, /*#__PURE__*/ $42omo.createElement((0, $dcJ7R.default), {
            space: "space.075"
        }, /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
            onClick: modalState.onCancel
        }, "Decline"), /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
            onClick: modalState.onConfirm,
            appearance: "primary"
        }, "Approve"))));
    };
    const renderDomains = ()=>{
        const getHumanReadableName = (operation)=>{
            switch(operation){
                case 'FETCH_BACKEND_SIDE':
                    return 'Fetch backend side';
                case 'FETCH_CLIENT_SIDE':
                    return 'Fetch client side';
                case 'FONTS':
                    return 'Fonts';
                case 'FRAMES':
                    return 'Frames';
                case 'IMAGES':
                    return 'Images';
                case 'MEDIA':
                    return 'Media';
                case 'NAVIGATION':
                    return 'Navigation';
                case 'SCRIPTS':
                    return 'Scripts';
                case 'STYLES':
                    return 'Styles';
                default:
                    return 'Egress';
            }
        };
        const domainInfo = modalState.domainInfo;
        if (Object.keys(domainInfo).length === 0) return null;
        if (domainInfo.type === 'REMOTE') return /*#__PURE__*/ $42omo.createElement((0, $bUlM5.default), {
            direction: "column",
            gap: "space.150"
        }, domainInfo.payload.remotes.map((r)=>/*#__PURE__*/ $42omo.createElement((0, $1GzhS.default), {
                key: r.key,
                space: "space.150"
            }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
                size: "small"
            }, "Remote"), /*#__PURE__*/ $42omo.createElement((0, $dcJ7R.default), {
                xcss: $f58f5052b341dbb2$var$styles.rowContainer,
                spread: "space-between",
                grow: "fill"
            }, /*#__PURE__*/ $42omo.createElement((0, $5dK2X.default), null, r.configured.endpoint === null ? 'This remote is being reset to the default value' : r.configured.endpoint), /*#__PURE__*/ $42omo.createElement((0, $5dK2X.default), null, r.key)))));
        if (domainInfo.type === 'EGRESS') return /*#__PURE__*/ $42omo.createElement((0, $bUlM5.default), {
            direction: "column",
            gap: "space.150"
        }, domainInfo.payload.egresses.map((e)=>/*#__PURE__*/ $42omo.createElement((0, $1GzhS.default), {
                key: e.key,
                space: "space.150"
            }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
                size: "xsmall"
            }, e.description), e.configured.map((c)=>{
                return c.type.map((t)=>{
                    return /*#__PURE__*/ $42omo.createElement((0, $dcJ7R.default), {
                        xcss: $f58f5052b341dbb2$var$styles.rowContainer,
                        spread: "space-between",
                        grow: "fill"
                    }, /*#__PURE__*/ $42omo.createElement((0, $5dK2X.default), null, c.domain), /*#__PURE__*/ $42omo.createElement((0, $5dK2X.default), null, getHumanReadableName(t)));
                });
            }))));
    };
    const Notice = ()=>{
        const { appName: appName, termsOfUseLink: termsOfUseLink, privacyPolicyLink: privacyPolicyLink } = modalState;
        if (termsOfUseLink && privacyPolicyLink) return /*#__PURE__*/ $42omo.createElement((0, $5dK2X.default), null, "For more details, refer to ", appName ?? 'the app', "'s", ' ', /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: termsOfUseLink
        }, "terms of use"), " and", ' ', /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: privacyPolicyLink
        }, "privacy policy"));
        else if (termsOfUseLink) return /*#__PURE__*/ $42omo.createElement((0, $5dK2X.default), null, "For more details, refer to ", appName ?? 'the app', "'s", ' ', /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: termsOfUseLink
        }, "terms of use"));
        else if (privacyPolicyLink) return /*#__PURE__*/ $42omo.createElement((0, $5dK2X.default), null, "For more details, refer to ", appName ?? 'the app', "'s", ' ', /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: privacyPolicyLink
        }, "privacy policy"));
    };
    return /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null, /*#__PURE__*/ $42omo.createElement((0, $8CZUH.default), {
        onClose: ()=>{
            modalState.onCancel();
        },
        width: "large"
    }, /*#__PURE__*/ $42omo.createElement((0, $9ot3w.default), null, /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $f58f5052b341dbb2$var$styles.titleContainer
    }, /*#__PURE__*/ $42omo.createElement((0, $d8eRd.default), null, "Data storage, sharing, receiving and processing"))), /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, /*#__PURE__*/ $42omo.createElement((0, $1GzhS.default), {
        space: "space.300"
    }, /*#__PURE__*/ $42omo.createElement((0, $5dK2X.default), null, modalState.appName ?? 'The app', " is requesting to share with and receive data from the following domains:"), /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), null, renderDomains(), /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $f58f5052b341dbb2$var$styles.disclaimerContainer
    }, /*#__PURE__*/ $42omo.createElement(Notice, null))))), /*#__PURE__*/ $42omo.createElement(ModalFooter, null)));
};
module.exports["AdminModal"] = $f58f5052b341dbb2$export$24cbef36aabf5e56;

});

parcelRegister("20GoR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1KmJq = parcelRequire("1KmJq");


var $dh538 = parcelRequire("dh538");


var $1uzCd = parcelRequire("1uzCd");


var $iUjrf = parcelRequire("iUjrf");


var $9XihO = parcelRequire("9XihO");


var $7MEO5 = parcelRequire("7MEO5");


var $kaOT1 = parcelRequire("kaOT1");


var $1Igmn = parcelRequire("1Igmn");

const $703d3a3574eac153$var$EGRESS_GET = ()=>({
        method: 'GET',
        route: '/forge/installation/v1/dynamic/egress'
    });
const $703d3a3574eac153$var$EGRESS_SET = (installationId, dryRun = false)=>({
        method: 'PUT',
        route: `/forge/installation/v1/${installationId}/dynamic/egress?dryRun=${dryRun}`
    });
const $703d3a3574eac153$var$EGRESS_DELETE_GROUP = (installationId)=>({
        method: 'DELETE',
        route: `/forge/installation/v1/${installationId}/dynamic/egress`
    });
const $703d3a3574eac153$var$EGRESS_DELETE_DOMAIN = (installationId)=>({
        method: 'PATCH',
        route: `/forge/installation/v1/${installationId}/dynamic/egress/delete-domain`
    });
const $703d3a3574eac153$var$REMOTE_GET = ()=>({
        method: 'GET',
        route: '/forge/installation/v1/dynamic/remote'
    });
const $703d3a3574eac153$var$REMOTE_SET = (installationId, dryRun = false)=>({
        method: 'PUT',
        route: `/forge/installation/v1/${installationId}/dynamic/remote?dryRun=${dryRun}`
    });
function $703d3a3574eac153$export$70250d945629938a({ appId: appId, installationId: installationId, extensionId: extensionId, accountType: accountType, renderThreeLOPrompt: renderThreeLOPrompt, options: options, contextIds: contextIds = [] }) {
    function getBaseUrl() {
        const currentUrl = new URL(document.URL);
        return `${currentUrl.origin}/gateway/api`;
    }
    const authTokenRef = (0, $42omo.useRef)(undefined);
    const { captureEvent: captureEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    const [userAuthTokenForExtensionMutationFunction] = (0, $1KmJq.useMutation)((0, $9XihO.authTokenForExtensionMutation), options);
    const tracing = (0, $kaOT1.useTracingContext)();
    const fetchOAuthToken = async (extensionId, contextIds)=>{
        tracing?.recordGqlCall('userAuthTokenForExtension - start');
        const { data: data } = await userAuthTokenForExtensionMutationFunction({
            variables: {
                input: {
                    extensionId: extensionId,
                    contextIds: contextIds
                }
            },
            context: {
                headers: {
                    'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
                }
            }
        });
        if (data?.userAuthTokenForExtension) {
            const { success: success, authToken: authToken, errors: errors } = data.userAuthTokenForExtension;
            tracing?.recordGqlCall('userAuthTokenForExtension - end');
            if (!success && errors && errors[0].message.includes('No Atlassian OAuth token found for this user and extension')) return new Promise((resolve)=>{
                renderThreeLOPrompt(async ()=>{
                    const token = await fetchOAuthToken(extensionId, contextIds);
                    resolve(token);
                });
            });
            if (success && authToken) {
                const { token: token, ttl: ttl } = authToken;
                return {
                    token: token,
                    expiry: Date.now() + ttl * (0, $9XihO.MILLIS_IN_SECOND)
                };
            }
        }
        throw new Error('An unexpected error occurred when fetching an auth token');
    };
    const oauthFetch = async (restPath, init)=>{
        const requestAuthStartMark = (0, $1uzCd.getPerformanceMark)();
        if ((0, $dh538.fg)('forge-ui-performance-analytics-provider')) captureEvent?.({
            type: 'permission-api-request-initiated',
            elapsed: requestAuthStartMark
        });
        const atlassianAccount = !accountType || accountType === 'atlassian';
        if (!(0, $9XihO.isTokenValid)(authTokenRef.current) && atlassianAccount) authTokenRef.current = await fetchOAuthToken(extensionId, contextIds);
        const headers = new Headers(init.headers);
        headers.set('Authorization', `Bearer ${authTokenRef?.current?.token}`);
        // this header is used to identify requests made by Forge, based on:
        // https://hello.atlassian.net/wiki/x/O5jUIwE?atlOrigin=eyJpIjoiM2NhNjU1MDUxOWJkNDcxNThiNzJjNWU1NzE5Y2FmZTMiLCJwIjoiYyJ9
        const appAri = (0, $7MEO5.createAppAri)({
            appId: appId
        }).toString();
        headers.set('x-ecosystem-user-agent', `forge ${appAri}`);
        const requestAuthEndMark = (0, $1uzCd.getPerformanceMark)();
        const request = fetch(new URL(`${getBaseUrl()}${restPath}`), {
            ...init,
            body: init.body,
            headers: headers
        });
        if ((0, $dh538.fg)('forge-ui-performance-analytics-provider')) request.then(()=>{
            const requestEndMark = (0, $1uzCd.getPerformanceMark)();
            captureEvent?.({
                type: 'permission-api-requested',
                duration: requestEndMark - requestAuthStartMark,
                authDuration: requestAuthEndMark - requestAuthStartMark,
                elapsed: requestEndMark
            });
        });
        return request;
    };
    const sessionFetch = async (restPath, init)=>{
        const request = fetch(`${getBaseUrl()}${restPath}`, {
            ...init,
            body: init.body
        });
        return request;
    };
    return {
        egressGet: async (payload)=>{
            const { route: route, method: method } = $703d3a3574eac153$var$EGRESS_GET();
            const init = {
                method: method
            };
            const sp = new URLSearchParams();
            if (payload.keys && payload.keys.length > 0) payload.keys.forEach((k)=>{
                sp.append('keys', k);
            });
            if (payload.pageSize) sp.append('pageSize', `${payload.pageSize}`);
            if (payload.nextPageToken) sp.append('nextPageToken', payload.nextPageToken);
            let routeToUse = route;
            if (sp.size > 0) routeToUse = `${route}?${sp.toString()}`;
            return oauthFetch(routeToUse, init);
        },
        egressSet: async (payload, isDryRun)=>{
            const { route: route, method: method } = $703d3a3574eac153$var$EGRESS_SET(installationId, isDryRun);
            const body = JSON.stringify(payload);
            const init = {
                method: method,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: body
            };
            return sessionFetch(route, init);
        },
        egressDeleteDomain: async (payload)=>{
            const { route: route, method: method } = $703d3a3574eac153$var$EGRESS_DELETE_DOMAIN(installationId);
            const body = JSON.stringify(payload);
            const init = {
                method: method,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: body
            };
            return sessionFetch(route, init);
        },
        egressDeleteGroup: async (payload)=>{
            const { route: route, method: method } = $703d3a3574eac153$var$EGRESS_DELETE_GROUP(installationId);
            const init = {
                method: method
            };
            const sp = new URLSearchParams();
            if (payload.key) sp.append('key', payload.key);
            let routeToUse = route;
            if (sp.size > 0) routeToUse = `${route}?${sp.toString()}`;
            return sessionFetch(routeToUse, init);
        },
        remoteGet: async (payload)=>{
            const { route: route, method: method } = $703d3a3574eac153$var$REMOTE_GET();
            const init = {
                method: method
            };
            const sp = new URLSearchParams();
            if (payload.keys && payload.keys.length > 0) payload.keys.forEach((k)=>{
                sp.append('keys', k);
            });
            if (payload.pageSize) sp.append('pageSize', `${payload.pageSize}`);
            if (payload.nextPageToken) sp.append('nextPageToken', payload.nextPageToken);
            let routeToUse = route;
            if (sp.size > 0) routeToUse = `${route}?${sp.toString()}`;
            return oauthFetch(routeToUse, init);
        },
        remoteSet: async (payload, isDryRun)=>{
            const { route: route, method: method } = $703d3a3574eac153$var$REMOTE_SET(installationId, isDryRun);
            const body = JSON.stringify(payload);
            const init = {
                method: method,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: body
            };
            return sessionFetch(route, init);
        }
    };
}
module.exports["usePermissionFetchClient"] = $703d3a3574eac153$export$70250d945629938a;

});

parcelRegister("4LgCj", function(module, exports) {

var $hvvoj = parcelRequire("hvvoj");


var $buzAL = parcelRequire("buzAL");

const $53fbfe482eb8d8a0$export$41b5b6d6fbe1e6b6 = (bridge, args)=>{
    const { userConsentRequired: userConsentRequired } = args;
    return {
        refresh: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.refresh),
        submit: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.submit),
        open: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.open),
        close: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.close),
        onClose: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.onClose),
        openModal: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.openModal, {
            requiresUserConsent: userConsentRequired
        }),
        showFlag: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.showFlag),
        closeFlag: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.closeFlag),
        reconcile: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.reconcile),
        emitReadyEvent: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.emitReadyEvent),
        onError: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.onError),
        createHistory: ()=>(0, $hvvoj.createHistory)({
                history: bridge?.history,
                extensionBasePath: bridge?.extensionBasePath
            }),
        changeWindowTitle: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.changeWindowTitle),
        ...(0, $buzAL.getCreateBridgeApiPermissionFunctions)(bridge)
    };
};
const $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8 = (method, ...args)=>{
    return async (payload)=>{
        if (method) return method(payload, ...args) ?? true;
        return false;
    };
};
module.exports["createBridgeApi"] = $53fbfe482eb8d8a0$export$41b5b6d6fbe1e6b6;
module.exports["createBridgeMethod"] = $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8;

});

parcelRegister("dhMrf", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $7MEO5 = parcelRequire("7MEO5");


var $kaOT1 = parcelRequire("kaOT1");


var $42omo = parcelRequire("42omo");

const $c2921b3ec001e75a$export$b9698c172c64625 = (0, $eSUdr.default)`query appById($appAri:ID!){app(id:$appAri){name privacyPolicy termsOfService}}`;
class $c2921b3ec001e75a$export$67e3479a9f34cffa extends Error {
}
function $c2921b3ec001e75a$export$cea4d5b903e9aab5({ client: client }) {
    const tracing = (0, $kaOT1.useTracingContext)();
    const fetchAppData = async (appId)=>{
        const appAri = (0, $7MEO5.createAppAri)({
            appId: appId
        }).toString();
        tracing?.recordGqlCall('APP_BY_ID_QUERY - start');
        const { data: data, errors: errors } = await client.query({
            query: $c2921b3ec001e75a$export$b9698c172c64625,
            variables: {
                appAri: appAri
            }
        });
        tracing?.recordGqlCall('APP_BY_ID_QUERY - end');
        if (errors) {
            const details = JSON.stringify(errors);
            throw new $c2921b3ec001e75a$export$67e3479a9f34cffa(`Failed to fetch app data by its ID: ${appAri}, GraphQLError: ${details}`);
        }
        return data.app;
    };
    return (0, $42omo.useCallback)(fetchAppData, [
        client,
        tracing
    ]);
}
module.exports["useForgeAppQuery"] = $c2921b3ec001e75a$export$cea4d5b903e9aab5;

});

parcelRegister("9XihO", function(module, exports) {

var $1KmJq = parcelRequire("1KmJq");


var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $lzcvT = parcelRequire("lzcvT");

var $T9xHm = parcelRequire("T9xHm");


var $kaOT1 = parcelRequire("kaOT1");


var $JsJ4Y = parcelRequire("JsJ4Y");

var $1Igmn = parcelRequire("1Igmn");

var $b7qxC = parcelRequire("b7qxC");


var $dh538 = parcelRequire("dh538");


var $7MEO5 = parcelRequire("7MEO5");


var $1uzCd = parcelRequire("1uzCd");


var $iUjrf = parcelRequire("iUjrf");

const $d04645d643f36821$export$ed8186c9e5e5ba23 = (0, $eSUdr.default)`mutation forge_ui_userAuthTokenForExtension($input:UserAuthTokenForExtensionInput!){userAuthTokenForExtension(input:$input){success errors{message}authToken{token ttl}}}`;
const $d04645d643f36821$export$44ef24e77cee8e40 = (0, $eSUdr.default)`query tcsByCloudId($cloudIds:[ID!]$product:String!){tenantContexts(cloudIds:$cloudIds){activationIdByProduct(product:$product){targetRegion}}}`;
const $d04645d643f36821$var$validProducts = [
    'confluence',
    'jira',
    'bitbucket'
];
const $d04645d643f36821$var$apiGatewayUrlMap = {
    dev: 'api.stg.atlassian.com',
    stg: 'api.stg.atlassian.com',
    prod: 'api.atlassian.com'
};
const $d04645d643f36821$var$getApiGatewayUrl = (environment)=>{
    const apiBase = $d04645d643f36821$var$apiGatewayUrlMap[environment];
    const url = (0, $lzcvT.isFedRamp)() ? apiBase.replace('atlassian.com', 'atlassian-us-gov-mod.com') : apiBase;
    if (!url) throw new Error(`Invalid environment: ${environment}`);
    return url;
};
const $d04645d643f36821$var$getBaseUrlForIsolatedCloud = (product, cloudId)=>{
    if (product === 'bitbucket') throw new Error('product not supported in Isolated Cloud yet.');
    const apiBase = `api.${(0, $T9xHm.isolatedCloudDomain)()}`;
    return `https://${apiBase}/ex/${product}/${cloudId}`;
};
function $d04645d643f36821$var$getBaseUrlForCommercialAndFedRamp(environment, product, cloudId) {
    if (product === 'bitbucket') return environment === 'prod' ? 'https://api.bitbucket.org' : 'https://api.integration.bb-inf.net';
    const apiBase = $d04645d643f36821$var$getApiGatewayUrl(environment);
    return `https://${apiBase}/ex/${product}/${cloudId}`;
}
function $d04645d643f36821$var$getBaseUrl(environment, product, cloudId) {
    if ((0, $dh538.fg)('forge-ui-oasis-enabled')) return (0, $T9xHm.isIsolatedCloud)() ? $d04645d643f36821$var$getBaseUrlForIsolatedCloud(product, cloudId) : $d04645d643f36821$var$getBaseUrlForCommercialAndFedRamp(environment, product, cloudId);
    return $d04645d643f36821$var$getBaseUrlForCommercialAndFedRamp(environment, product, cloudId);
}
function $d04645d643f36821$var$createProductUrl(environment, product, restPath, cloudId) {
    const baseUrl = $d04645d643f36821$var$getBaseUrl(environment, product, cloudId);
    const fullUrl = // bitbucket requests could be made with absolute URLs
    // e.g. when following href links in API responses
    product === 'bitbucket' && restPath.startsWith(`${baseUrl}/`) ? restPath : `${baseUrl}${restPath}`;
    const productUrl = new URL(fullUrl).toString();
    if (!productUrl.startsWith(`${baseUrl}/`)) throw new Error('Invalid product URL');
    return productUrl;
}
function $d04645d643f36821$export$d1a8c8b605234fe8(token) {
    return !!(token && token.expiry > Date.now());
}
function $d04645d643f36821$var$isProduct(product) {
    return $d04645d643f36821$var$validProducts.includes(product);
}
function $d04645d643f36821$export$da8d8c42bfb20907(contentType) {
    return Boolean(contentType && !contentType.includes('application/json') && contentType.search(/text\//) === -1);
}
function $d04645d643f36821$var$parseFormData(formLike) {
    const form = new FormData();
    for (const [key, value] of Object.entries(formLike))if (key === 'file') {
        const fileName = formLike['__fileName'];
        const mimeType = formLike['__fileType'];
        // convert back from base64 to File (Blob)
        const blob = (0, $JsJ4Y.base64ToBlob)(value, mimeType);
        const file = new File([
            blob
        ], fileName, {
            type: mimeType
        });
        form.append('file', file);
    } else form.append(key, value);
    // remove request metadata properties
    form.delete('__fileName');
    form.delete('__fileType');
    return form;
}
const $d04645d643f36821$export$5d72c9fa1086d504 = 1000;
const $d04645d643f36821$var$requestProduct = async (url, init)=>{
    const response = await fetch(url, init);
    const isAttachment = $d04645d643f36821$export$da8d8c42bfb20907(response.headers.get('content-type'));
    if (response.ok && response.body !== null && response.status !== 204 && isAttachment) {
        const b64Content = await (0, $JsJ4Y.blobToBase64)(await response.blob());
        return new Response(b64Content, {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers
        });
    }
    return response;
};
const $d04645d643f36821$var$getTenantRegion = async (product, cloudIds, client)=>{
    const { data: data } = await client.query({
        query: $d04645d643f36821$export$44ef24e77cee8e40,
        variables: {
            cloudIds: cloudIds,
            product: product
        }
    });
    return data?.tenantContexts[0].activationIdByProduct.targetRegion || '';
};
function $d04645d643f36821$export$2f041121bdb61a5({ appId: appId, extensionId: extensionId, accountType: accountType, environment: environment, cloudId: cloudId, workspaceId: workspaceId, renderThreeLOPrompt: renderThreeLOPrompt, options: options, contextIds: contextIds = [] }) {
    const { captureEvent: captureEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    const [userAuthTokenForExtensionMutationFunction] = (0, $1KmJq.useMutation)($d04645d643f36821$export$ed8186c9e5e5ba23, options);
    const authTokenRef = (0, $42omo.useRef)(undefined);
    const tenantRegionRef = (0, $42omo.useRef)(undefined);
    const tracing = (0, $kaOT1.useTracingContext)();
    /**
   * Workspace based products like Trello and Bitbucket will not pass in cloudId,
   * they will pass in workspaceId instead.
   */ if (!cloudId && !workspaceId) return async ()=>{
        throw new Error('Product APIs are not available in this module. Remove requestConfluence, requestJira or requestBitbucket from your code.');
    };
    const fetchOAuthToken = async (extensionId, contextIds)=>{
        tracing?.recordGqlCall('userAuthTokenForExtension - start');
        const { data: data } = await userAuthTokenForExtensionMutationFunction({
            variables: {
                input: {
                    extensionId: extensionId,
                    contextIds: contextIds
                }
            },
            context: {
                headers: {
                    'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
                }
            }
        });
        if (data?.userAuthTokenForExtension) {
            const { success: success, authToken: authToken, errors: errors } = data.userAuthTokenForExtension;
            tracing?.recordGqlCall('userAuthTokenForExtension - end');
            if (!success && errors && errors[0].message.includes('No Atlassian OAuth token found for this user and extension')) return new Promise((resolve)=>{
                renderThreeLOPrompt(async ()=>{
                    const token = await fetchOAuthToken(extensionId, contextIds);
                    resolve(token);
                });
            });
            if (success && authToken) {
                const { token: token, ttl: ttl } = authToken;
                return {
                    token: token,
                    expiry: Date.now() + ttl * $d04645d643f36821$export$5d72c9fa1086d504
                };
            }
        }
        throw new Error('An unexpected error occurred when fetching an auth token');
    };
    const cdnEnvironment = (0, $b7qxC.getCDNEnvironment)(environment);
    return async (restPath, product, init, isMultipartFormData)=>{
        if (!$d04645d643f36821$var$isProduct(product)) throw new Error(`Invalid product: ${product}`);
        const requestAuthStartMark = (0, $1uzCd.getPerformanceMark)();
        if ((0, $dh538.fg)('forge-ui-performance-analytics-provider')) captureEvent?.({
            type: 'product-api-request-initiated',
            elapsed: requestAuthStartMark
        });
        const atlassianAccount = !accountType || accountType === 'atlassian';
        if (!$d04645d643f36821$export$d1a8c8b605234fe8(authTokenRef.current) && atlassianAccount) {
            if ((0, $dh538.fg)('forge-ui-enable-region-steering')) {
                const fetchAuthTokenPromise = fetchOAuthToken(extensionId, contextIds);
                let getTenantRegionPromise;
                // We need to fetch the tenant region to know which region to steer the request to.
                if (cloudId && options?.client) getTenantRegionPromise = $d04645d643f36821$var$getTenantRegion(product, [
                    cloudId
                ], options.client);
                const [authToken, tenantRegion] = await Promise.all([
                    fetchAuthTokenPromise,
                    getTenantRegionPromise ? getTenantRegionPromise : Promise.resolve(undefined)
                ]);
                authTokenRef.current = authToken;
                tenantRegionRef.current = tenantRegion;
            } else authTokenRef.current = await fetchOAuthToken(extensionId, contextIds);
        }
        const headers = new Headers(init.headers);
        headers.set('Authorization', `Bearer ${authTokenRef?.current?.token}`);
        // Set the region hit for the request if it's available
        if (tenantRegionRef.current) headers.set('atl-edge-region-hint', tenantRegionRef.current);
        // this header is used to identify requests made by Forge, based on:
        // https://hello.atlassian.net/wiki/x/O5jUIwE?atlOrigin=eyJpIjoiM2NhNjU1MDUxOWJkNDcxNThiNzJjNWU1NzE5Y2FmZTMiLCJwIjoiYyJ9
        const appAri = (0, $7MEO5.createAppAri)({
            appId: appId
        }).toString();
        headers.set('x-ecosystem-user-agent', `forge ${appAri}`);
        const body = isMultipartFormData ? $d04645d643f36821$var$parseFormData(JSON.parse(init.body)) : init.body;
        if (isMultipartFormData) // let the fetch api correctly set the multipart/form-data content-type
        // https://github.com/github/fetch/issues/505#issuecomment-293064470
        headers.delete('content-type');
        const requestAuthEndMark = (0, $1uzCd.getPerformanceMark)();
        const request = $d04645d643f36821$var$requestProduct($d04645d643f36821$var$createProductUrl(cdnEnvironment, product, restPath, cloudId), {
            ...init,
            body: body,
            headers: headers
        });
        if ((0, $dh538.fg)('forge-ui-performance-analytics-provider')) request.then(()=>{
            const requestEndMark = (0, $1uzCd.getPerformanceMark)();
            captureEvent?.({
                type: 'product-api-requested',
                duration: requestEndMark - requestAuthStartMark,
                authDuration: requestAuthEndMark - requestAuthStartMark,
                elapsed: requestEndMark
            });
        });
        return request;
    };
}
module.exports["authTokenForExtensionMutation"] = $d04645d643f36821$export$ed8186c9e5e5ba23;
module.exports["isTokenValid"] = $d04645d643f36821$export$d1a8c8b605234fe8;
module.exports["isBinaryContentType"] = $d04645d643f36821$export$da8d8c42bfb20907;
module.exports["MILLIS_IN_SECOND"] = $d04645d643f36821$export$5d72c9fa1086d504;
module.exports["useProductFetchClient"] = $d04645d643f36821$export$2f041121bdb61a5;

});

parcelRegister("hvvoj", function(module, exports) {

var $kxKUs = parcelRequire("kxKUs");

const $2a01424001f37a1e$export$21f63b78155c2049 = (extensionBasePath)=>{
    return {
        extensionRouteToFullPath: (extensionRoute)=>`${extensionBasePath}${extensionRoute ?? ''}`,
        fullPathToExtensionRoute: (fullLocation)=>{
            const extensionRoute = fullLocation.split(extensionBasePath).pop();
            return extensionRoute ? extensionRoute : '/';
        }
    };
};
const $2a01424001f37a1e$export$4178d7ac16e6cf7c = ({ history: history, extensionBasePath: extensionBasePath })=>{
    if (!history || !extensionBasePath) throw new (0, $kxKUs.BridgeClientError)('History API is not available within this module.');
    const { extensionRouteToFullPath: extensionRouteToFullPath, fullPathToExtensionRoute: fullPathToExtensionRoute } = $2a01424001f37a1e$export$21f63b78155c2049(extensionBasePath);
    const parseLocation = (location, parser)=>({
            ...location,
            pathname: parser(location.pathname)
        });
    const setNewHistoryLocation = (type, pathOrLocation, state)=>{
        const setHistory = type === 'push' ? history.push : history.replace;
        if (typeof pathOrLocation === 'string') return setHistory(extensionRouteToFullPath(pathOrLocation), state);
        return setHistory(parseLocation({
            state: state,
            ...pathOrLocation
        }, extensionRouteToFullPath));
    };
    return {
        ...history,
        location: parseLocation(history.location, fullPathToExtensionRoute),
        push (pathOrLocation, state) {
            setNewHistoryLocation('push', pathOrLocation, state);
        },
        replace (pathOrLocation, state) {
            setNewHistoryLocation('replace', pathOrLocation, state);
        },
        listen (listener) {
            const unlisten = history.listen((location, action)=>{
                listener(parseLocation(location, fullPathToExtensionRoute), action);
            });
            return unlisten;
        }
    };
};
module.exports["createHistory"] = $2a01424001f37a1e$export$4178d7ac16e6cf7c;

});

parcelRegister("JsJ4Y", function(module, exports) {
const $d09011ff2196b597$export$b3fb17ae4345ac8f = (b64string, mimeType)=>{
    const base64Data = b64string.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for(let i = 0; i < byteCharacters.length; i++)byteNumbers[i] = byteCharacters.charCodeAt(i);
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([
        byteArray
    ], {
        type: mimeType
    });
};
const $d09011ff2196b597$export$47a328b4cabd57cc = (blob)=>{
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};
module.exports["base64ToBlob"] = $d09011ff2196b597$export$b3fb17ae4345ac8f;
module.exports["blobToBase64"] = $d09011ff2196b597$export$47a328b4cabd57cc;

});


$parcel$global.rlb("fRvqe")
//# sourceMappingURL=FullPageEditorComponent.6c4b4c68.js.map
